import {
  __require,
  __toESM
} from "./chunk-cf4g1482.js";

// src/Studio.tsx
import { useLayoutEffect as useLayoutEffect2 } from "react";
import { createPortal } from "react-dom";
import { Internals as Internals66 } from "remotion";

// src/components/Editor.tsx
import { PlayerInternals as PlayerInternals19 } from "@remotion/player";
import React173, { useCallback as useCallback130, useEffect as useEffect77, useMemo as useMemo129 } from "react";
import { Internals as Internals62 } from "remotion";

// src/helpers/colors.ts
var BACKGROUND = "rgb(31,36,40)";
var BACKGROUND__TRANSPARENT = "rgba(31,36,40, 0)";
var INPUT_BACKGROUND = "#2f363d";
var BORDER_COLOR = "#000";
var LIGHT_COLOR = "#ddd";
var SELECTED_BACKGROUND = "hsla(0, 0%, 100%, 0.15)";
var LIGHT_TEXT = "#A6A7A9";
var RULER_COLOR = "#808080";
var VERY_LIGHT_TEXT = "rgba(255, 255, 255, 0.3)";
var SELECTED_HOVER_BACKGROUND = "hsla(0, 0%, 100%, 0.25)";
var CLEAR_HOVER = "rgba(255, 255, 255, 0.06)";
var INPUT_BORDER_COLOR_UNHOVERED = "rgba(0, 0, 0, 0.6)";
var INPUT_BORDER_COLOR_HOVERED = "rgba(255, 255, 255, 0.05)";
var TIMELINE_BACKGROUND = "#111";
var FAIL_COLOR = "#ff3232";
var TEXT_COLOR = "#fff";
var WARNING_COLOR = "#f1c40f";
var BLUE = "#0b84f3";
var BLUE_DISABLED = "#284f73";
var LIGHT_TRANSPARENT = "rgba(255, 255, 255, 0.7)";
var UNSELECTED_GUIDE = "#7e1219";
var SELECTED_GUIDE = "#d22d3a";
var LINE_COLOR = "#363A3E";
var TIMELINE_TRACK_SEPARATOR = "rgba(0, 0, 0, 0.3)";
var getBackgroundFromHoverState = ({
  selected,
  hovered
}) => {
  if (selected) {
    if (hovered) {
      return SELECTED_HOVER_BACKGROUND;
    }
    return SELECTED_BACKGROUND;
  }
  if (hovered) {
    return CLEAR_HOVER;
  }
  return "transparent";
};

// src/helpers/noop.ts
var noop = () => {
  return;
};

// src/state/canvas-ref.ts
import { createRef } from "react";
var canvasRef = createRef();
var drawRef = createRef();

// src/state/timeline-zoom.tsx
import { createContext as createContext2, useMemo as useMemo2, useState } from "react";

// src/components/Timeline/imperative-state.ts
var currentFrame = 0;
var currentZoom = 1;
var currentDuration = 1;
var currentFps = 1;
var getCurrentZoom = () => {
  return currentZoom;
};
var setCurrentZoom = (z) => {
  currentZoom = z;
};
var getCurrentFrame = () => {
  return currentFrame;
};
var setCurrentFrame = (f) => {
  currentFrame = f;
};
var getCurrentDuration = () => {
  return currentDuration;
};
var setCurrentDuration = (d) => {
  currentDuration = d;
};
var getCurrentFps = () => {
  return currentFps;
};
var setCurrentFps = (d) => {
  currentFps = d;
};

// src/components/Timeline/timeline-scroll-logic.ts
import { interpolate } from "remotion";

// src/helpers/timeline-layout.ts
var TIMELINE_PADDING = 16;
var TIMELINE_BORDER = 1;
var TIMELINE_ITEM_BORDER_BOTTOM = 1;
var getTimelineLayerHeight = (type) => {
  if (type === "video") {
    return 50;
  }
  return 25;
};

// src/components/Timeline/TimelineSlider.tsx
import {
  createRef as createRef2,
  useContext,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef
} from "react";
import { Internals, useVideoConfig } from "remotion";

// src/helpers/get-left-of-timeline-slider.ts
var getXPositionOfItemInTimelineImperatively = (frame, duration, width) => {
  const proportion = frame / (duration - 1);
  return proportion * (width - TIMELINE_PADDING * 2) + TIMELINE_PADDING;
};

// src/components/Timeline/TimelineSliderHandle.tsx
import { jsx } from "react/jsx-runtime";
var container = {
  width: 20,
  height: 20,
  position: "fixed",
  marginLeft: -8
};
var TimelineSliderHandle = () => {
  return /* @__PURE__ */ jsx("div", {
    style: container,
    children: /* @__PURE__ */ jsx("svg", {
      width: 17,
      viewBox: "0 0 159 212",
      children: /* @__PURE__ */ jsx("path", {
        d: "M17.0234375,1.07763419 L143.355469,1.07763419 C151.63974,1.07763419 158.355469,7.79336295 158.355469,16.0776342 L158.355469,69.390507 C158.355469,73.7938677 156.420655,77.9748242 153.064021,80.8248415 L89.3980057,134.881757 C83.7986799,139.635978 75.5802263,139.635978 69.9809005,134.881757 L6.66764807,81.1243622 C3.0872392,78.0843437 1.0234375,73.6246568 1.0234375,68.9277387 L1.0234375,17.0776342 C1.0234375,8.2410782 8.1868815,1.07763419 17.0234375,1.07763419 Z",
        fill: "#f02c00"
      })
    })
  });
};

// src/components/Timeline/TimelineWidthProvider.tsx
import { PlayerInternals } from "@remotion/player";
import { createContext } from "react";

// src/components/Timeline/timeline-refs.ts
import React from "react";
var sliderAreaRef = React.createRef();
var scrollableRef = React.createRef();
var timelineVerticalScroll = React.createRef();

// src/components/Timeline/TimelineWidthProvider.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var TimelineWidthContext = createContext(null);
var TimelineWidthProvider = ({ children }) => {
  const size = PlayerInternals.useElementSize(sliderAreaRef, {
    triggerOnWindowResize: false,
    shouldApplyCssTransforms: true
  });
  return /* @__PURE__ */ jsx2(TimelineWidthContext.Provider, {
    value: size?.width ?? null,
    children
  });
};

// src/components/Timeline/TimelineSlider.tsx
import { jsx as jsx3, jsxs } from "react/jsx-runtime";
var container2 = {
  position: "absolute",
  bottom: 0,
  top: 0,
  pointerEvents: "none"
};
var line = {
  height: "100vh",
  width: 1,
  position: "fixed",
  backgroundColor: "#f02c00"
};
var redrawTimelineSliderFast = createRef2();
var TimelineSlider = () => {
  const videoConfig = Internals.useUnsafeVideoConfig();
  const timelineWidth = useContext(TimelineWidthContext);
  if (videoConfig === null || timelineWidth === null) {
    return null;
  }
  return /* @__PURE__ */ jsx3(Inner, {});
};
var Inner = () => {
  const videoConfig = useVideoConfig();
  const timelinePosition = Internals.Timeline.useTimelinePosition();
  const ref = useRef(null);
  const timelineWidth = useContext(TimelineWidthContext);
  if (timelineWidth === null) {
    throw new Error("Unexpectedly did not have timeline width");
  }
  const style = useMemo(() => {
    const left = getXPositionOfItemInTimelineImperatively(timelinePosition, videoConfig.durationInFrames, timelineWidth);
    return {
      ...container2,
      transform: `translateX(${left}px)`
    };
  }, [timelinePosition, videoConfig.durationInFrames, timelineWidth]);
  useImperativeHandle(redrawTimelineSliderFast, () => {
    return {
      draw: (frame, width) => {
        const { current } = ref;
        if (!current) {
          throw new Error("unexpectedly did not have ref to timelineslider");
        }
        current.style.transform = `translateX(${getXPositionOfItemInTimelineImperatively(frame, getCurrentDuration(), width ?? sliderAreaRef.current?.clientWidth ?? 0)}px)`;
      }
    };
  }, []);
  useEffect(() => {
    const currentRef = ref.current;
    if (!currentRef) {
      return;
    }
    const { current } = timelineVerticalScroll;
    if (!current) {
      return;
    }
    const onScroll = () => {
      currentRef.style.top = current.scrollTop + "px";
    };
    current.addEventListener("scroll", onScroll);
    return () => {
      current.removeEventListener("scroll", onScroll);
    };
  }, []);
  return /* @__PURE__ */ jsxs("div", {
    ref,
    style,
    children: [
      /* @__PURE__ */ jsx3("div", {
        style: line
      }),
      /* @__PURE__ */ jsx3(TimelineSliderHandle, {})
    ]
  });
};

// src/components/Timeline/timeline-scroll-logic.ts
var canScrollTimelineIntoDirection = () => {
  const current = scrollableRef.current;
  const { scrollWidth, scrollLeft, clientWidth } = current;
  const canScrollRight = scrollWidth - scrollLeft - clientWidth > TIMELINE_PADDING;
  const canScrollLeft = scrollLeft > TIMELINE_PADDING;
  return { canScrollRight, canScrollLeft };
};
var SCROLL_INCREMENT = 200;
var calculateFrameWhileScrollingRight = ({
  durationInFrames,
  width,
  scrollLeft
}) => {
  return getFrameFromX({
    clientX: scrollLeft,
    durationInFrames,
    width,
    extrapolate: "clamp"
  }) + Math.ceil((scrollableRef.current?.clientWidth - TIMELINE_PADDING) / getFrameIncrement(durationInFrames));
};
var getFrameWhileScrollingLeft = ({
  durationInFrames,
  width
}) => {
  const nextFrame = getFrameFromX({
    clientX: scrollableRef.current?.scrollLeft - SCROLL_INCREMENT,
    durationInFrames,
    width,
    extrapolate: "clamp"
  });
  const currentFrame2 = getFrameFromX({
    clientX: scrollableRef.current?.scrollLeft,
    durationInFrames,
    width,
    extrapolate: "clamp"
  });
  return Math.max(0, Math.min(currentFrame2 - 1, nextFrame));
};
var isCursorInViewport = ({
  frame,
  durationInFrames
}) => {
  const width = scrollableRef.current?.scrollWidth ?? 0;
  const scrollLeft = scrollableRef.current?.scrollLeft ?? 0;
  const scrollPosOnRightEdge = getScrollPositionForCursorOnRightEdge({
    nextFrame: frame,
    durationInFrames
  });
  const scrollPosOnLeftEdge = getScrollPositionForCursorOnLeftEdge({
    nextFrame: frame,
    durationInFrames
  });
  const currentFrameRight = calculateFrameWhileScrollingRight({
    durationInFrames,
    scrollLeft,
    width
  });
  return !(scrollPosOnRightEdge >= getScrollPositionForCursorOnRightEdge({
    nextFrame: currentFrameRight,
    durationInFrames
  }) || scrollPosOnLeftEdge < scrollLeft);
};
var ensureFrameIsInViewport = ({
  direction,
  durationInFrames,
  frame
}) => {
  redrawTimelineSliderFast.current?.draw(frame);
  const width = scrollableRef.current?.scrollWidth ?? 0;
  const scrollLeft = scrollableRef.current?.scrollLeft ?? 0;
  if (direction === "fit-left") {
    const currentFrameLeft = getFrameFromX({
      clientX: scrollLeft,
      durationInFrames,
      width,
      extrapolate: "clamp"
    });
    const scrollPos = getScrollPositionForCursorOnLeftEdge({
      nextFrame: frame,
      durationInFrames
    });
    const needsToScrollLeft = scrollPos <= getScrollPositionForCursorOnLeftEdge({
      nextFrame: currentFrameLeft,
      durationInFrames
    });
    if (needsToScrollLeft) {
      scrollToTimelineXOffset(scrollPos);
    }
  }
  if (direction === "fit-right") {
    const currentFrameRight = calculateFrameWhileScrollingRight({
      durationInFrames,
      scrollLeft,
      width
    });
    const scrollPos = getScrollPositionForCursorOnRightEdge({
      nextFrame: frame,
      durationInFrames
    });
    const needsToScrollRight = scrollPos >= getScrollPositionForCursorOnRightEdge({
      nextFrame: currentFrameRight,
      durationInFrames
    });
    if (needsToScrollRight) {
      scrollToTimelineXOffset(scrollPos);
    }
  }
  if (direction === "page-right" || direction === "page-left") {
    if (!isCursorInViewport({ frame, durationInFrames })) {
      scrollToTimelineXOffset(direction === "page-left" ? getScrollPositionForCursorOnRightEdge({
        nextFrame: frame,
        durationInFrames
      }) : getScrollPositionForCursorOnLeftEdge({
        nextFrame: frame,
        durationInFrames
      }));
    }
  }
  if (direction === "center") {
    const scrollPosOnRightEdge = getScrollPositionForCursorOnRightEdge({
      nextFrame: frame,
      durationInFrames
    });
    const scrollPosOnLeftEdge = getScrollPositionForCursorOnLeftEdge({
      nextFrame: frame,
      durationInFrames
    });
    scrollToTimelineXOffset((scrollPosOnLeftEdge + scrollPosOnRightEdge) / 2);
  }
};
var scrollToTimelineXOffset = (scrollPos) => {
  scrollableRef.current?.scroll({
    left: scrollPos
  });
};
var getScrollPositionForCursorOnLeftEdge = ({
  nextFrame,
  durationInFrames
}) => {
  const frameIncrement = getFrameIncrement(durationInFrames);
  const scrollPos = frameIncrement * nextFrame;
  return scrollPos;
};
var getScrollPositionForCursorOnRightEdge = ({
  nextFrame,
  durationInFrames
}) => {
  const frameIncrement = getFrameIncrement(durationInFrames);
  const framesRemaining = durationInFrames - 1 - nextFrame;
  const fromRight = framesRemaining * frameIncrement + TIMELINE_PADDING;
  const scrollPos = scrollableRef.current?.scrollWidth - fromRight - scrollableRef.current?.clientWidth + TIMELINE_PADDING + 4;
  return scrollPos;
};
var getFrameIncrement = (durationInFrames) => {
  const width = scrollableRef.current?.scrollWidth ?? 0;
  return getFrameIncrementFromWidth(durationInFrames, width);
};
var getFrameIncrementFromWidth = (durationInFrames, width) => {
  return (width - TIMELINE_PADDING * 2) / (durationInFrames - 1);
};
var getFrameWhileScrollingRight = ({
  durationInFrames,
  width
}) => {
  const nextFrame = calculateFrameWhileScrollingRight({
    durationInFrames,
    width,
    scrollLeft: scrollableRef.current?.scrollLeft + SCROLL_INCREMENT
  });
  const currentFrame2 = calculateFrameWhileScrollingRight({
    durationInFrames,
    width,
    scrollLeft: scrollableRef.current?.scrollLeft
  });
  return Math.min(durationInFrames - 1, Math.max(nextFrame, currentFrame2 + 1));
};
var getFrameFromX = ({
  clientX,
  durationInFrames,
  width,
  extrapolate
}) => {
  const pos = clientX - TIMELINE_PADDING;
  const frame = Math.round(interpolate(pos, [0, width - TIMELINE_PADDING * 2], [0, durationInFrames - 1], {
    extrapolateLeft: extrapolate,
    extrapolateRight: extrapolate
  }));
  return frame;
};
var zoomAndPreserveCursor = ({
  oldZoom,
  newZoom,
  currentFrame: currentFrame2,
  currentDurationInFrames
}) => {
  const ratio = newZoom / oldZoom;
  if (ratio === 1) {
    return;
  }
  const { current } = scrollableRef;
  if (!current) {
    return;
  }
  const frameIncrement = getFrameIncrement(currentDurationInFrames);
  const prevCursorPosition = frameIncrement * currentFrame2 + TIMELINE_PADDING;
  const newCursorPosition = ratio * (prevCursorPosition - TIMELINE_PADDING) + TIMELINE_PADDING;
  current.scrollLeft += newCursorPosition - prevCursorPosition;
  redrawTimelineSliderFast.current?.draw(currentFrame2, (scrollableRef.current?.clientWidth ?? 0) * ratio);
};

// src/components/ZoomPersistor.tsx
import { useContext as useContext2, useEffect as useEffect2 } from "react";
import { Internals as Internals2 } from "remotion";

// src/helpers/url-state.ts
var getUrlHandlingType = () => {
  if (window.remotion_isReadOnlyStudio) {
    return "query-string";
  }
  return "spa";
};
var pushUrl = (url) => {
  if (getUrlHandlingType() === "query-string") {
    window.history.pushState({}, "Studio", `${window.location.pathname}?${url}`);
  } else {
    window.history.pushState({}, "Studio", url);
  }
};
var clearUrl = () => {
  window.location.href = window.location.pathname;
};
var reloadUrl = () => {
  window.location.reload();
};
var getRoute = () => {
  if (getUrlHandlingType() === "query-string") {
    return window.location.search.substring(1);
  }
  return window.location.pathname;
};

// src/components/load-canvas-content-from-url.ts
var deriveCanvasContentFromUrl = () => {
  const route = getRoute();
  const substrings = route.split("/").filter(Boolean);
  const lastPart = substrings[substrings.length - 1];
  if (substrings[0] === "assets") {
    return {
      type: "asset",
      asset: decodeURIComponent(route.substring("/assets/".length))
    };
  }
  if (substrings[0] === "outputs") {
    return {
      type: "output",
      path: decodeURIComponent(route.substring("/outputs/".length))
    };
  }
  if (lastPart) {
    return {
      type: "composition",
      compositionId: decodeURIComponent(lastPart)
    };
  }
  return null;
};

// src/components/ZoomPersistor.tsx
var makeKey = () => {
  return `remotion.zoom-map`;
};
var persistCurrentZoom = (zoom) => {
  localStorage.setItem(makeKey(), JSON.stringify(zoom));
};
var getZoomFromLocalStorage = () => {
  const zoom = localStorage.getItem(makeKey());
  return zoom ? JSON.parse(zoom) : {};
};
var ZoomPersistor = () => {
  const [playing] = Internals2.Timeline.usePlayingState();
  const { zoom } = useContext2(TimelineZoomCtx);
  const { canvasContent } = useContext2(Internals2.CompositionManager);
  const urlState = deriveCanvasContentFromUrl();
  const isActive = urlState && urlState.type === "composition" && canvasContent && canvasContent.type === "composition" && urlState.compositionId === canvasContent.compositionId;
  useEffect2(() => {
    if (!isActive) {
      return;
    }
    persistCurrentZoom(zoom);
  }, [zoom, isActive, playing, urlState]);
  return null;
};

// src/state/timeline-zoom.tsx
import { jsx as jsx4 } from "react/jsx-runtime";
var TIMELINE_MIN_ZOOM = 1;
var TIMELINE_MAX_ZOOM = 5;
var TimelineZoomCtx = createContext2({
  zoom: {},
  setZoom: () => {
    throw new Error("has no context");
  }
});
var TimelineZoomContext = ({ children }) => {
  const [zoom, setZoom] = useState(() => getZoomFromLocalStorage());
  const value = useMemo2(() => {
    return {
      zoom,
      setZoom: (compositionId, callback) => {
        setZoom((prevZoomMap) => {
          const newZoomWithFloatingPointErrors = Math.min(TIMELINE_MAX_ZOOM, Math.max(TIMELINE_MIN_ZOOM, callback(prevZoomMap[compositionId] ?? TIMELINE_MIN_ZOOM)));
          const newZoom = Math.round(newZoomWithFloatingPointErrors * 10) / 10;
          zoomAndPreserveCursor({
            oldZoom: prevZoomMap[compositionId] ?? TIMELINE_MIN_ZOOM,
            newZoom,
            currentDurationInFrames: getCurrentDuration(),
            currentFrame: getCurrentFrame()
          });
          return { ...prevZoomMap, [compositionId]: newZoom };
        });
      }
    };
  }, [zoom]);
  return /* @__PURE__ */ jsx4(TimelineZoomCtx.Provider, {
    value,
    children
  });
};

// src/state/z-index.tsx
import {
  createContext as createContext5,
  useContext as useContext4,
  useEffect as useEffect4,
  useMemo as useMemo6,
  useRef as useRef3
} from "react";

// src/helpers/use-keybinding.ts
import { useCallback as useCallback2, useContext as useContext3, useEffect as useEffect3, useMemo as useMemo4, useState as useState2 } from "react";

// src/state/keybindings.tsx
import { createContext as createContext3, useCallback, useMemo as useMemo3, useRef as useRef2 } from "react";
import { jsx as jsx5 } from "react/jsx-runtime";
var KeybindingContext = createContext3({
  registerKeybinding: () => {
    throw new Error("Has no keybinding context");
  },
  unregisterKeybinding: () => {
    return;
  },
  unregisterPane: () => {
    return;
  }
});
var KeybindingContextProvider = ({ children }) => {
  const registered = useRef2([]);
  const registerKeybinding = useCallback((binding) => {
    registered.current = [...registered.current, binding];
    window.addEventListener(binding.event, binding.callback);
  }, []);
  const unregisterKeybinding = useCallback((binding) => {
    registered.current = registered.current.filter((r) => {
      if (r.id === binding.id) {
        window.removeEventListener(binding.event, binding.callback);
        return false;
      }
      return true;
    });
  }, []);
  const unregisterPane = useCallback((paneId) => {
    const matchedKeybindings = registered.current.filter((r) => r.registeredFromPane === paneId);
    for (const matched of matchedKeybindings) {
      unregisterKeybinding(matched);
    }
  }, [unregisterKeybinding]);
  const value = useMemo3(() => {
    return {
      registerKeybinding,
      unregisterKeybinding,
      unregisterPane
    };
  }, [registerKeybinding, unregisterKeybinding, unregisterPane]);
  return /* @__PURE__ */ jsx5(KeybindingContext.Provider, {
    value,
    children
  });
};

// src/helpers/use-keybinding.ts
if (!process.env.KEYBOARD_SHORTCUTS_ENABLED) {
  console.warn("Keyboard shortcuts disabled either due to: a) --disable-keyboard-shortcuts being passed b) Config.setKeyboardShortcutsEnabled(false) being set or c) a Remotion version mismatch.");
}
var areKeyboardShortcutsDisabled = () => {
  return !process.env.KEYBOARD_SHORTCUTS_ENABLED;
};
var useKeybinding = () => {
  const [paneId] = useState2(() => String(Math.random()));
  const context = useContext3(KeybindingContext);
  const { isHighestContext } = useZIndex();
  const registerKeybinding = useCallback2((options) => {
    if (!process.env.KEYBOARD_SHORTCUTS_ENABLED) {
      return {
        unregister: () => {
          return;
        }
      };
    }
    if (!isHighestContext && !options.keepRegisteredWhenNotHighestContext) {
      return {
        unregister: () => {
          return;
        }
      };
    }
    const listener = (e) => {
      const commandKey = window.navigator.platform.startsWith("Mac") ? e.metaKey : e.ctrlKey;
      if (!e.key) {
        return;
      }
      if (e.key.toLowerCase() === options.key.toLowerCase() && options.commandCtrlKey === commandKey) {
        if (!options.triggerIfInputFieldFocused) {
          const { activeElement } = document;
          if (activeElement instanceof HTMLInputElement) {
            return;
          }
          if (activeElement instanceof HTMLTextAreaElement) {
            return;
          }
        }
        options.callback(e);
        if (options.preventDefault) {
          e.preventDefault();
        }
      }
    };
    const toRegister = {
      registeredFromPane: paneId,
      event: options.event,
      key: options.key,
      callback: listener,
      id: String(Math.random())
    };
    context.registerKeybinding(toRegister);
    return {
      unregister: () => context.unregisterKeybinding(toRegister)
    };
  }, [context, isHighestContext, paneId]);
  useEffect3(() => {
    return () => {
      context.unregisterPane(paneId);
    };
  }, [context, paneId]);
  return useMemo4(() => ({ registerKeybinding, isHighestContext }), [registerKeybinding, isHighestContext]);
};

// src/state/highest-z-index.tsx
import { createContext as createContext4, useCallback as useCallback3, useMemo as useMemo5, useState as useState3 } from "react";
import { jsx as jsx6 } from "react/jsx-runtime";
var HighestZIndexContext = createContext4({
  highestIndex: 0,
  registerZIndex: () => {
    return;
  },
  unregisterZIndex: () => {
    return;
  }
});
var HighestZIndexProvider = ({ children }) => {
  const [zIndexes, setZIndexes] = useState3([]);
  const registerZIndex = useCallback3((newIndex) => {
    setZIndexes((prev) => [...prev, newIndex]);
  }, []);
  const unregisterZIndex = useCallback3((newIndex) => {
    setZIndexes((prev) => {
      const index = prev.indexOf(newIndex);
      if (index === -1) {
        throw new Error("did not find z-index " + newIndex);
      }
      return prev.filter((_n, i) => i !== index);
    });
  }, []);
  const highestIndex = Math.max(...zIndexes);
  const value = useMemo5(() => {
    return {
      highestIndex,
      registerZIndex,
      unregisterZIndex
    };
  }, [registerZIndex, unregisterZIndex, highestIndex]);
  return /* @__PURE__ */ jsx6(HighestZIndexContext.Provider, {
    value,
    children
  });
};

// src/state/input-dragger-click-lock.ts
var clickLock = false;
var getClickLock = () => clickLock;
var setClickLock = (lock) => {
  clickLock = lock;
};

// src/state/z-index.tsx
import { jsx as jsx7, jsxs as jsxs2 } from "react/jsx-runtime";
var ZIndexContext = createContext5({
  currentIndex: 0
});
var margin = {
  margin: "auto"
};
var EscapeHook = ({ onEscape }) => {
  const keybindings = useKeybinding();
  useEffect4(() => {
    const escape = keybindings.registerKeybinding({
      event: "keydown",
      key: "Escape",
      callback: onEscape,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: true,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      escape.unregister();
    };
  }, [keybindings, onEscape]);
  return null;
};
var HigherZIndex = ({ children, onEscape, onOutsideClick, disabled }) => {
  const context = useContext4(ZIndexContext);
  const highestContext = useContext4(HighestZIndexContext);
  const containerRef = useRef3(null);
  const currentIndex = disabled ? context.currentIndex : context.currentIndex + 1;
  useEffect4(() => {
    if (disabled) {
      return;
    }
    highestContext.registerZIndex(currentIndex);
    return () => highestContext.unregisterZIndex(currentIndex);
  }, [currentIndex, highestContext, disabled]);
  useEffect4(() => {
    if (disabled) {
      return;
    }
    let onUp = null;
    const listener = (downEvent) => {
      const outsideClick = !containerRef.current?.contains(downEvent.target);
      if (!outsideClick) {
        return;
      }
      onUp = (upEvent) => {
        if (highestContext.highestIndex === currentIndex && !getClickLock() && document.contains(upEvent.target)) {
          upEvent.stopPropagation();
          onOutsideClick(upEvent.target);
        }
      };
      window.addEventListener("pointerup", onUp, { once: true });
    };
    requestAnimationFrame(() => {
      window.addEventListener("pointerdown", listener);
    });
    return () => {
      if (onUp) {
        window.removeEventListener("pointerup", onUp, { once: true });
      }
      onUp = null;
      return window.removeEventListener("pointerdown", listener);
    };
  }, [currentIndex, disabled, highestContext.highestIndex, onOutsideClick]);
  const value = useMemo6(() => {
    return {
      currentIndex
    };
  }, [currentIndex]);
  return /* @__PURE__ */ jsxs2(ZIndexContext.Provider, {
    value,
    children: [
      disabled ? null : /* @__PURE__ */ jsx7(EscapeHook, {
        onEscape
      }),
      /* @__PURE__ */ jsx7("div", {
        ref: containerRef,
        style: margin,
        children
      })
    ]
  });
};
var useZIndex = () => {
  const context = useContext4(ZIndexContext);
  const highestContext = useContext4(HighestZIndexContext);
  const isHighestContext = highestContext.highestIndex === context.currentIndex;
  return useMemo6(() => ({
    currentZIndex: context.currentIndex,
    highestZIndex: highestContext.highestIndex,
    isHighestContext,
    tabIndex: isHighestContext ? 0 : -1
  }), [context.currentIndex, highestContext.highestIndex, isHighestContext]);
};

// src/components/EditorContent.tsx
import { useContext as useContext68 } from "react";
import { Internals as Internals56 } from "remotion";

// src/helpers/is-current-selected-still.ts
import { useContext as useContext5 } from "react";
import { Internals as Internals3 } from "remotion";

// src/helpers/is-composition-still.ts
var isCompositionStill = (comp) => {
  if (!comp) {
    return false;
  }
  return comp.durationInFrames === 1;
};

// src/helpers/is-current-selected-still.ts
var useIsStill = () => {
  const resolved = Internals3.useResolvedVideoConfig(null);
  if (!resolved || resolved.type !== "success") {
    return false;
  }
  return isCompositionStill(resolved.result);
};
var useIsVideoComposition = () => {
  const isStill = useIsStill();
  const { canvasContent } = useContext5(Internals3.CompositionManager);
  if (canvasContent === null) {
    return false;
  }
  if (isStill) {
    return false;
  }
  return canvasContent.type === "composition";
};

// src/components/InitialCompositionLoader.tsx
import { useCallback as useCallback22, useContext as useContext13, useEffect as useEffect13 } from "react";
import { Internals as Internals10 } from "remotion";

// src/api/get-static-files.ts
var warnedServer = false;
var warnedPlayer = false;
var warnServerOnce = () => {
  if (warnedServer) {
    return;
  }
  warnedServer = true;
  console.warn("Called getStaticFiles() on the server. The API is only available in the browser. An empty array was returned.");
};
var warnPlayerOnce = () => {
  if (warnedPlayer) {
    return;
  }
  warnedPlayer = true;
  console.warn("Called getStaticFiles() while using the Remotion Player. The API is only available while using the Remotion Studio. An empty array was returned.");
};
var getStaticFiles = () => {
  if (typeof document === "undefined") {
    warnServerOnce();
    return [];
  }
  if (window.remotion_isPlayer) {
    warnPlayerOnce();
    return [];
  }
  return window.remotion_staticFiles;
};

// src/helpers/mobile-layout.ts
import { useEffect as useEffect5, useRef as useRef4, useState as useState4 } from "react";
var breakpoint = 900;
function getIsMobile() {
  return window.innerWidth < breakpoint;
}
var useMobileLayout = () => {
  const [isMobile, setIsMobile] = useState4(getIsMobile());
  const isMobileRef = useRef4(isMobile);
  useEffect5(() => {
    function handleResize() {
      if (getIsMobile() !== isMobileRef.current) {
        setIsMobile(getIsMobile());
      }
      isMobileRef.current = getIsMobile();
    }
    window.addEventListener("resize", handleResize);
    return () => {
      return window.removeEventListener("resize", handleResize);
    };
  }, []);
  return isMobile;
};

// src/state/folders.tsx
import { createContext as createContext7, useMemo as useMemo7, useState as useState5 } from "react";

// src/helpers/persist-open-folders.tsx
import { createContext as createContext6 } from "react";
var openFolderKey = ({
  folderName,
  parentName
}) => {
  return [parentName ?? "no-parent", folderName].join("/");
};
var localStorageKey = (type) => type === "compositions" ? "remotion.expandedFolders" : "remotion.expandedAssetFolders";
var persistExpandedFolders = (type, state) => {
  window.localStorage.setItem(localStorageKey(type), JSON.stringify(state));
};
var loadExpandedFolders = (type) => {
  const item = window.localStorage.getItem(localStorageKey(type));
  if (item === null) {
    return {};
  }
  return JSON.parse(item);
};
var ExpandedFoldersContext = createContext6({
  toggleFolder: () => {},
  foldersExpanded: {},
  setFoldersExpanded: () => {}
});

// src/state/folders.tsx
import { jsx as jsx8 } from "react/jsx-runtime";
var FolderContext = createContext7({
  compositionFoldersExpanded: {},
  setCompositionFoldersExpanded: () => {
    throw new Error("default state");
  },
  assetFoldersExpanded: {},
  setAssetFoldersExpanded: () => {
    throw new Error("default state");
  }
});
var FolderContextProvider = ({ children }) => {
  const [compositionFoldersExpanded, setCompositionFoldersExpanded] = useState5(() => loadExpandedFolders("compositions"));
  const [assetFoldersExpanded, setAssetFoldersExpanded] = useState5(() => loadExpandedFolders("assets"));
  const value = useMemo7(() => {
    return {
      compositionFoldersExpanded,
      setCompositionFoldersExpanded,
      assetFoldersExpanded,
      setAssetFoldersExpanded
    };
  }, [assetFoldersExpanded, compositionFoldersExpanded]);
  return /* @__PURE__ */ jsx8(FolderContext.Provider, {
    value,
    children
  });
};

// src/state/sidebar.tsx
import { createContext as createContext8, useMemo as useMemo8, useState as useState6 } from "react";
import { jsx as jsx9 } from "react/jsx-runtime";
var storageKey = (sidebar) => {
  if (sidebar === "right") {
    return "remotion.sidebarRightCollapsing";
  }
  return "remotion.sidebarCollapsing";
};
var getSavedCollapsedStateLeft = (isMobileLayout = false) => {
  const state = window.localStorage.getItem(storageKey("left"));
  if (isMobileLayout) {
    return "collapsed";
  }
  if (state === "collapsed") {
    return "collapsed";
  }
  if (state === "expanded") {
    return "expanded";
  }
  return "responsive";
};
var getSavedCollapsedStateRight = (isMobileLayout = false) => {
  const state = window.localStorage.getItem(storageKey("right"));
  if (isMobileLayout) {
    return "collapsed";
  }
  if (state === "expanded") {
    return "expanded";
  }
  return "collapsed";
};
var saveCollapsedState = (type, sidebar) => {
  window.localStorage.setItem(storageKey(sidebar), type);
};
var SidebarContext = createContext8({
  sidebarCollapsedStateLeft: "collapsed",
  setSidebarCollapsedState: () => {
    throw new Error("sidebar collapsed state");
  },
  sidebarCollapsedStateRight: "collapsed"
});
var SidebarContextProvider = ({ children }) => {
  const isMobileLayout = useMobileLayout();
  const [sidebarCollapsedState, setSidebarCollapsedState] = useState6(() => ({
    left: getSavedCollapsedStateLeft(isMobileLayout),
    right: getSavedCollapsedStateRight(isMobileLayout)
  }));
  const value = useMemo8(() => {
    return {
      sidebarCollapsedStateLeft: sidebarCollapsedState.left,
      sidebarCollapsedStateRight: sidebarCollapsedState.right,
      setSidebarCollapsedState: (options) => {
        const { left, right } = options;
        setSidebarCollapsedState((f) => {
          const copied = { ...f };
          if (left) {
            const updatedLeft = typeof left === "function" ? left(f.left) : left;
            saveCollapsedState(updatedLeft, "left");
            copied.left = updatedLeft;
          }
          if (right) {
            const updatedRight = typeof right === "function" ? right(f.right) : right;
            saveCollapsedState(updatedRight, "right");
            copied.right = updatedRight;
          }
          return copied;
        });
      }
    };
  }, [sidebarCollapsedState]);
  return /* @__PURE__ */ jsx9(SidebarContext.Provider, {
    value,
    children
  });
};

// src/components/CompositionSelector.tsx
import { useCallback as useCallback15, useContext as useContext9, useMemo as useMemo21 } from "react";
import { Internals as Internals7 } from "remotion";

// src/helpers/create-folder-tree.ts
var buildAssetFolderStructure = (files, parentFolderName, foldersExpanded) => {
  const notInFolder = files.filter((f) => !f.name.includes("/"));
  const inFolder = files.filter((f) => f.name.includes("/"));
  const groupedByFolder = {};
  for (const item of inFolder) {
    const folderName = item.name.split("/")[0];
    if (!groupedByFolder[folderName]) {
      groupedByFolder[folderName] = [];
    }
    groupedByFolder[folderName].push(item);
  }
  return {
    files: notInFolder,
    folders: Object.keys(groupedByFolder).map((folderName) => {
      const filesInFolder = groupedByFolder[folderName];
      const filesWithoutFolderName = filesInFolder.map((f) => {
        return {
          ...f,
          name: f.name.substring(folderName.length + 1)
        };
      });
      const key = [parentFolderName, folderName].filter(Boolean).join("/");
      const isExpanded = foldersExpanded[key] ?? false;
      return {
        name: folderName,
        items: buildAssetFolderStructure(filesWithoutFolderName, [parentFolderName, folderName].filter(Boolean).join("/"), foldersExpanded),
        expanded: isExpanded
      };
    })
  };
};
var splitParentIntoNameAndParent = (name) => {
  if (name === null) {
    return {
      name: null,
      parent: null
    };
  }
  const splitted = name.split("/");
  const lastName = splitted[splitted.length - 1];
  const parentParentArray = splitted.slice(0, splitted.length - 1);
  const parentParent = parentParentArray.length === 0 ? null : parentParentArray.join("/");
  return {
    name: lastName,
    parent: parentParent
  };
};
var doesFolderExist = (items, folderName, parentName) => {
  for (const item of items) {
    if (item.type === "folder") {
      if (item.folderName === folderName && item.parentName === parentName) {
        return item.items;
      }
      const found = doesFolderExist(item.items, folderName, parentName);
      if (found !== false) {
        return found;
      }
    }
  }
  return false;
};
var findItemListToPush = (items, folderName, parentName) => {
  if (folderName === null) {
    return items;
  }
  const folder = doesFolderExist(items, folderName, parentName);
  if (!folder) {
    console.log({ items, folderName, parentName });
    throw new Error("did not find folder " + folderName);
  }
  return folder;
};
var createFolderIfDoesNotExist = (items, availableFolders, folderItem, foldersExpanded) => {
  if (doesFolderExist(items, folderItem.name, folderItem.parent)) {
    return;
  }
  const splitted = splitParentIntoNameAndParent(folderItem.parent);
  if (folderItem.parent) {
    const parent = availableFolders.find((f) => f.name === splitted.name && f.parent === splitted.parent);
    if (!parent) {
      throw new Error("unexpectedly did not have parent");
    }
    createFolderIfDoesNotExist(items, availableFolders, parent, foldersExpanded);
  }
  const itemList = findItemListToPush(items, splitted.name, splitted.parent);
  if (!itemList) {
    throw new Error("why did folder not exist? " + folderItem.name);
  }
  itemList.push({
    type: "folder",
    folderName: folderItem.name,
    items: [],
    key: folderItem.name,
    expanded: foldersExpanded[openFolderKey({
      folderName: folderItem.name,
      parentName: folderItem.parent
    })] ?? false,
    parentName: folderItem.parent
  });
};
var createFolderTree = (comps, folders, foldersExpanded) => {
  const items = [];
  const uniqueFolderKeys = [];
  for (const folder of folders) {
    const folderKey = openFolderKey({
      folderName: folder.name,
      parentName: folder.parent
    });
    if (uniqueFolderKeys.includes(folderKey)) {
      if (folder.parent) {
        throw new Error(`Multiple folders with the name ${folder.name} inside the folder ${folder.parent} exist. Folder names must be unique.`);
      }
      throw new Error("Multiple folders with the name " + folder.name + " exist. Folder names must be unique.");
    }
    uniqueFolderKeys.push(folderKey);
    createFolderIfDoesNotExist(items, folders, folder, foldersExpanded);
  }
  for (const item of comps) {
    const toPush = {
      type: "composition",
      composition: item,
      key: item.id
    };
    const list = findItemListToPush(items, item.folderName, item.parentFolderName);
    list.push(toPush);
  }
  return items;
};

// src/components/CompositionSelectorItem.tsx
import { useCallback as useCallback14, useContext as useContext8, useMemo as useMemo20, useState as useState14 } from "react";

// src/icons/folder.tsx
import { jsx as jsx10 } from "react/jsx-runtime";
var CollapsedFolderIcon = ({ color, ...props }) => {
  return /* @__PURE__ */ jsx10("svg", {
    viewBox: "0 0 512 512",
    ...props,
    children: /* @__PURE__ */ jsx10("path", {
      fill: color,
      d: "M447.1 96H272L226.7 50.75C214.7 38.74 198.5 32 181.5 32H63.1c-35.35 0-64 28.65-64 64v320c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64V160C511.1 124.7 483.3 96 447.1 96zM480 416c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V96c0-17.64 14.36-32 32-32h117.5c8.549 0 16.58 3.328 22.63 9.375L258.7 128H448c17.64 0 32 14.36 32 32V416z"
    })
  });
};
var ExpandedFolderIcon = ({ color, ...props }) => {
  return /* @__PURE__ */ jsx10("svg", {
    viewBox: "0 0 576 512",
    ...props,
    children: /* @__PURE__ */ jsx10("path", {
      fill: color,
      d: "M566.6 211.6C557.5 199.1 543.4 192 527.1 192H134.2C114.3 192 96.2 204.5 89.23 223.1L32 375.8V96c0-17.64 14.36-32 32-32h117.5c8.549 0 16.58 3.328 22.63 9.375L258.7 128H448c17.64 0 32 14.36 32 32h32c0-35.35-28.65-64-64-64H272L226.7 50.75C214.7 38.74 198.5 32 181.5 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h403.1c21.11 0 39.53-13.53 45.81-33.69l60-192C578.4 239.6 575.8 224 566.6 211.6zM543.2 244.8l-60 192C481.1 443.5 475 448 467.1 448H64c-3.322 0-6.357-.9551-9.373-1.898c-2.184-1.17-4.109-2.832-5.596-4.977c-3.031-4.375-3.703-9.75-1.828-14.73l72-192C121.5 228.2 127.5 224 134.2 224h393.8c5.141 0 9.844 2.375 12.89 6.516C543.9 234.7 544.8 239.9 543.2 244.8z"
    })
  });
};
var ExpandedFolderIconSolid = ({ color, ...props }) => {
  return /* @__PURE__ */ jsx10("svg", {
    viewBox: "0 0 576 512",
    ...props,
    children: /* @__PURE__ */ jsx10("path", {
      fill: color,
      d: "M384 480h48c11.4 0 21.9-6 27.6-15.9l112-192c5.8-9.9 5.8-22.1 .1-32.1S555.5 224 544 224H144c-11.4 0-21.9 6-27.6 15.9L48 357.1V96c0-8.8 7.2-16 16-16H181.5c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c21 21 49.5 32.8 79.2 32.8H416c8.8 0 16 7.2 16 16v32h48V160c0-35.3-28.7-64-64-64H298.5c-17 0-33.3-6.7-45.3-18.7L226.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H87.7 384z"
    })
  });
};

// src/icons/still.tsx
import { jsx as jsx11 } from "react/jsx-runtime";
var StillIcon = ({ color, ...props }) => {
  return /* @__PURE__ */ jsx11("svg", {
    ...props,
    viewBox: "0 0 512 512",
    children: /* @__PURE__ */ jsx11("path", {
      fill: color,
      d: "M144 288C144 226.1 194.1 176 256 176C317.9 176 368 226.1 368 288C368 349.9 317.9 400 256 400C194.1 400 144 349.9 144 288zM256 208C211.8 208 176 243.8 176 288C176 332.2 211.8 368 256 368C300.2 368 336 332.2 336 288C336 243.8 300.2 208 256 208zM362.9 64.82L373.3 96H448C483.3 96 512 124.7 512 160V416C512 451.3 483.3 480 448 480H64C28.65 480 0 451.3 0 416V160C0 124.7 28.65 96 64 96H138.7L149.1 64.82C155.6 45.22 173.9 32 194.6 32H317.4C338.1 32 356.4 45.22 362.9 64.82H362.9zM64 128C46.33 128 32 142.3 32 160V416C32 433.7 46.33 448 64 448H448C465.7 448 480 433.7 480 416V160C480 142.3 465.7 128 448 128H350.3L332.6 74.94C330.4 68.41 324.3 64 317.4 64H194.6C187.7 64 181.6 68.41 179.4 74.94L161.7 128H64z"
    })
  });
};

// src/icons/video.tsx
import { jsx as jsx12 } from "react/jsx-runtime";
var FilmIcon = ({ color, ...props }) => {
  return /* @__PURE__ */ jsx12("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    children: /* @__PURE__ */ jsx12("path", {
      fill: color,
      d: "M448 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64V96C512 60.65 483.3 32 448 32zM384 64v176H128V64H384zM32 96c0-17.64 14.36-32 32-32h32v80H32V96zM32 176h64v64H32V176zM32 272h64v64H32V272zM64 448c-17.64 0-32-14.36-32-32v-48h64V448H64zM128 448V272h256V448H128zM480 416c0 17.64-14.36 32-32 32h-32v-80h64V416zM480 336h-64v-64h64V336zM480 240h-64v-64h64V240zM480 144h-64V64h32c17.64 0 32 14.36 32 32V144z"
    })
  });
};

// src/state/modals.ts
import { createContext as createContext9 } from "react";
var ModalsContext = createContext9({
  selectedModal: null,
  setSelectedModal: () => {
    return;
  }
});

// src/components/CompositionContextButton.tsx
import { useCallback as useCallback11, useContext as useContext6, useMemo as useMemo17 } from "react";

// src/helpers/client-id.tsx
import React12, { useCallback as useCallback5, useEffect as useEffect7, useMemo as useMemo10, useRef as useRef5 } from "react";
import { Internals as Internals4 } from "remotion";

// src/components/Notifications/NotificationCenter.tsx
import {
  createRef as createRef3,
  useCallback as useCallback4,
  useImperativeHandle as useImperativeHandle2,
  useState as useState7
} from "react";

// src/components/Notifications/Notification.tsx
import { useEffect as useEffect6 } from "react";
import { jsx as jsx13 } from "react/jsx-runtime";
var notification = {
  backgroundColor: "#111111",
  color: "white",
  fontFamily: "Arial, Helvetica, sans-serif",
  display: "inline-flex",
  padding: "8px 14px",
  borderRadius: 4,
  fontSize: 15,
  border: "0.25px solid rgba(255, 255, 255, 0.1)",
  boxShadow: "0 2px 3px rgba(0, 0, 0, 1)",
  marginTop: 3,
  marginBottom: 3,
  alignItems: "center"
};
var Notification = ({ children, id, duration, created, onRemove }) => {
  useEffect6(() => {
    if (duration === null) {
      return;
    }
    const timeout = setTimeout(() => {
      onRemove(id);
    }, duration - (Date.now() - created));
    return () => {
      clearTimeout(timeout);
    };
  }, [created, duration, id, onRemove]);
  return /* @__PURE__ */ jsx13("div", {
    className: "css-reset",
    style: notification,
    children
  });
};

// src/components/Notifications/NotificationCenter.tsx
import { jsx as jsx14 } from "react/jsx-runtime";
var container3 = {
  position: "absolute",
  justifyContent: "center",
  alignItems: "center",
  display: "flex",
  width: "100%",
  flexDirection: "column",
  paddingTop: 20,
  pointerEvents: "none",
  backgroundColor: "transparent"
};
var notificationCenter = createRef3();
var showNotification = (content, durationInMs) => {
  return notificationCenter.current.addNotification({
    content,
    duration: durationInMs,
    created: Date.now(),
    id: String(Math.random()).replace("0.", "")
  });
};
var NotificationCenter = () => {
  const [notifications, setNotifications] = useState7([]);
  const onRemove = useCallback4((id) => {
    setNotifications((not) => {
      return not.filter((n) => n.id !== id);
    });
  }, []);
  const addNotification = useCallback4((notification2) => {
    setNotifications((previousNotifications) => {
      return [...previousNotifications, notification2];
    });
    return {
      replaceContent: (newContent, durationInMs) => {
        setNotifications((oldNotifications) => {
          return oldNotifications.map((notificationToMap) => {
            if (notificationToMap.id === notification2.id) {
              return {
                ...notificationToMap,
                duration: durationInMs,
                content: newContent,
                created: Date.now()
              };
            }
            return notificationToMap;
          });
        });
      }
    };
  }, []);
  useImperativeHandle2(notificationCenter, () => {
    return {
      addNotification
    };
  }, [addNotification]);
  return /* @__PURE__ */ jsx14("div", {
    style: container3,
    children: notifications.map((n) => {
      return /* @__PURE__ */ jsx14(Notification, {
        created: n.created,
        duration: n.duration,
        id: n.id,
        onRemove,
        children: n.content
      }, n.id);
    })
  });
};

// src/components/PlayBeepSound.tsx
var beeped = {};
var playBeepSound = async (renderId) => {
  if (beeped[renderId]) {
    return;
  }
  beeped[renderId] = true;
  const beepAudio = new Audio("/beep.wav");
  try {
    await beepAudio.play();
  } catch (error) {
    console.error("Error playing beep sound:", error);
    throw error;
  }
};
var PlayBeepSound_default = playBeepSound;

// src/components/RenderQueue/context.tsx
import React11, { createRef as createRef4, useImperativeHandle as useImperativeHandle3, useMemo as useMemo9, useState as useState8 } from "react";
import { jsx as jsx15 } from "react/jsx-runtime";
var RenderQueueContext = React11.createContext({
  jobs: []
});
var renderJobsRef = createRef4();
var RenderQueueContextProvider = ({ children }) => {
  const [jobs, setJobs] = useState8(window.remotion_initialRenderQueue ?? []);
  const value = useMemo9(() => {
    return {
      jobs
    };
  }, [jobs]);
  useImperativeHandle3(renderJobsRef, () => {
    return {
      updateRenderJobs: (newJobs) => {
        setJobs(newJobs);
      }
    };
  }, []);
  return /* @__PURE__ */ jsx15(RenderQueueContext.Provider, {
    value,
    children
  });
};

// src/helpers/client-id.tsx
import { jsx as jsx16 } from "react/jsx-runtime";
var StudioServerConnectionCtx = React12.createContext({
  previewServerState: {
    type: "init"
  },
  subscribeToEvent: () => {
    throw new Error("Context not initalized");
  }
});
var PreviewServerConnection = ({ children, readOnlyStudio }) => {
  const listeners = useRef5([]);
  const subscribeToEvent = useCallback5((type, listener) => {
    listeners.current.push({ type, listener });
    return () => {
      listeners.current = listeners.current.filter((l) => l.type !== type || l.listener !== listener);
    };
  }, []);
  const openEventSource = useCallback5(() => {
    const source = new EventSource("/events");
    source.addEventListener("message", (event) => {
      const newEvent = JSON.parse(event.data);
      if (newEvent.type === "new-input-props" || newEvent.type === "new-env-variables") {
        reloadUrl();
      }
      if (newEvent.type === "init") {
        setState({
          type: "connected",
          clientId: newEvent.clientId
        });
      }
      if (newEvent.type === "render-queue-updated") {
        renderJobsRef.current?.updateRenderJobs(newEvent.queue);
        for (const job of newEvent.queue) {
          if (job.status === "done" && job.beepOnFinish) {
            PlayBeepSound_default(job.id);
          }
        }
      }
      if (newEvent.type === "render-job-failed") {
        showNotification(`Rendering "${newEvent.compositionId}" failed`, 2000);
      }
      if (newEvent.type === "new-public-folder") {
        const payload = {
          files: newEvent.files
        };
        window.remotion_staticFiles = newEvent.files;
        window.remotion_publicFolderExists = newEvent.folderExists;
        window.dispatchEvent(new CustomEvent(Internals4.WATCH_REMOTION_STATIC_FILES, {
          detail: payload
        }));
      }
      listeners.current.forEach((l) => {
        if (l.type === newEvent.type) {
          l.listener(newEvent);
        }
      });
    });
    source.addEventListener("open", () => {
      source.addEventListener("error", () => {
        setState({ type: "disconnected" });
        source?.close();
        setTimeout(() => {
          openEventSource();
        }, 1000);
      }, { once: true });
    });
    const close = () => {
      source.close();
    };
    return {
      close
    };
  }, []);
  useEffect7(() => {
    if (readOnlyStudio) {
      return;
    }
    const { close } = openEventSource();
    return () => {
      close();
    };
  }, [openEventSource, readOnlyStudio]);
  const [state, setState] = React12.useState({
    type: "init"
  });
  const context = useMemo10(() => {
    return {
      previewServerState: state,
      subscribeToEvent
    };
  }, [state, subscribeToEvent]);
  return /* @__PURE__ */ jsx16(StudioServerConnectionCtx.Provider, {
    value: context,
    children
  });
};

// src/icons/ellipsis.tsx
import { jsx as jsx17 } from "react/jsx-runtime";
var EllipsisIcon = (props) => {
  return /* @__PURE__ */ jsx17("svg", {
    ...props.svgProps,
    viewBox: "0 0 448 512",
    children: /* @__PURE__ */ jsx17("path", {
      fill: props.fill,
      d: "M8 256a56 56 0 1 1 112 0A56 56 0 1 1 8 256zm160 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm216-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"
    })
  });
};

// src/components/InlineDropdown.tsx
import { PlayerInternals as PlayerInternals3 } from "@remotion/player";
import { useCallback as useCallback10, useMemo as useMemo16, useRef as useRef8, useState as useState12 } from "react";
import ReactDOM2 from "react-dom";

// src/components/InlineAction.tsx
import { useCallback as useCallback6, useMemo as useMemo11, useState as useState9 } from "react";
import { jsx as jsx18 } from "react/jsx-runtime";
var InlineAction = ({
  renderAction,
  onClick,
  disabled,
  title
}) => {
  const { tabIndex } = useZIndex();
  const [hovered, setHovered] = useState9(false);
  const onPointerEnter = useCallback6(() => {
    setHovered(true);
  }, []);
  const onPointerLeave = useCallback6(() => {
    setHovered(false);
  }, []);
  const style = useMemo11(() => {
    return {
      border: "none",
      background: disabled ? "transparent" : getBackgroundFromHoverState({ hovered, selected: false }),
      height: 24,
      width: 24,
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: 3,
      pointerEvents: disabled ? "none" : "auto"
    };
  }, [disabled, hovered]);
  return /* @__PURE__ */ jsx18("button", {
    type: "button",
    onPointerEnter,
    onPointerLeave,
    onClick,
    style,
    tabIndex,
    title,
    children: renderAction(hovered ? "white" : LIGHT_TEXT)
  });
};

// src/components/Menu/portals.ts
var portals = [
  document.getElementById("menuportal-0"),
  document.getElementById("menuportal-1"),
  document.getElementById("menuportal-2"),
  document.getElementById("menuportal-3"),
  document.getElementById("menuportal-4"),
  document.getElementById("menuportal-5")
];
var getPortal = (i) => {
  return portals[i];
};

// src/components/Menu/styles.ts
var MENU_VERTICAL_PADDING = 4;
var SUBMENU_LEFT_INSET = -8;
var MAX_MENU_WIDTH = 400;
var MAX_MOBILE_MENU_WIDTH = 300;
var menuContainer = {
  backgroundColor: BACKGROUND,
  position: "fixed",
  color: "white",
  userSelect: "none",
  WebkitUserSelect: "none"
};
var SHADOW_TOWARDS_BOTTOM = "0 2px 8px rgba(0, 0, 0, 0.5)";
var SHADOW_TOWARDS_TOP = "0 -2px 8px rgba(0, 0, 0, 0.5)";
var menuContainerTowardsBottom = {
  ...menuContainer,
  boxShadow: SHADOW_TOWARDS_BOTTOM
};
var menuContainerTowardsTop = {
  ...menuContainer,
  boxShadow: SHADOW_TOWARDS_TOP
};
var fullScreenOverlay = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0
};
var outerPortal = {
  position: "fixed"
};
var inlineCodeSnippet = {
  fontSize: 14,
  color: BLUE,
  fontFamily: "monospace"
};

// src/components/NewComposition/MenuContent.tsx
import { useCallback as useCallback9, useEffect as useEffect9, useMemo as useMemo15, useRef as useRef7, useState as useState11 } from "react";

// src/components/Menu/MenuDivider.tsx
import { jsx as jsx19 } from "react/jsx-runtime";
var menuDivider = {
  marginTop: 4,
  marginBottom: 4,
  height: 1,
  backgroundColor: INPUT_BORDER_COLOR_HOVERED
};
var MenuDivider = () => {
  return /* @__PURE__ */ jsx19("div", {
    style: menuDivider
  });
};

// src/components/Menu/MenuSubItem.tsx
import { PlayerInternals as PlayerInternals2 } from "@remotion/player";
import { useCallback as useCallback8, useEffect as useEffect8, useMemo as useMemo14, useRef as useRef6, useState as useState10 } from "react";
import ReactDOM from "react-dom";

// src/icons/caret.tsx
import { useMemo as useMemo12 } from "react";
import { jsx as jsx20 } from "react/jsx-runtime";
var caret = {
  height: 12
};
var caretDown = {
  width: 10
};
var angleDown = {
  width: 10
};
var CaretRight = () => /* @__PURE__ */ jsx20("svg", {
  viewBox: "0 0 192 512",
  style: caret,
  children: /* @__PURE__ */ jsx20("path", {
    fill: "currentColor",
    d: "M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z"
  })
});
var CaretDown = () => {
  return /* @__PURE__ */ jsx20("svg", {
    viewBox: "0 0 320 512",
    style: caretDown,
    children: /* @__PURE__ */ jsx20("path", {
      fill: "currentColor",
      d: "M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
    })
  });
};
var AngleDown = ({ down }) => {
  const style = useMemo12(() => {
    return {
      ...angleDown,
      transform: down ? "rotate(180deg)" : "rotate(0deg)",
      marginTop: 1
    };
  }, [down]);
  return /* @__PURE__ */ jsx20("svg", {
    style,
    viewBox: "0 0 448 512",
    children: /* @__PURE__ */ jsx20("path", {
      fill: LIGHT_TEXT,
      d: "M201.4 342.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 274.7 86.6 137.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
    })
  });
};

// src/components/layout.tsx
import { useMemo as useMemo13 } from "react";
import { jsx as jsx21 } from "react/jsx-runtime";
var SPACING_UNIT = 8;
var Spacing = ({ x = 0, y = 0, block = false }) => {
  const style = useMemo13(() => {
    return {
      display: block ? "block" : "inline-block",
      width: x * SPACING_UNIT,
      height: y * SPACING_UNIT,
      flexShrink: 0
    };
  }, [block, x, y]);
  return /* @__PURE__ */ jsx21("div", {
    style
  });
};
var flexCss = { flex: 1 };
var Flex = ({ children }) => /* @__PURE__ */ jsx21("div", {
  style: flexCss,
  children
});
var Row = ({ children, justify, className, align, flex, style = {}, ...other }) => {
  const finalStyle = useMemo13(() => {
    return {
      ...style,
      display: "flex",
      flexDirection: "row",
      justifyContent: justify ?? "flex-start",
      alignItems: align ?? "flex-start",
      flex: flex ?? undefined
    };
  }, [align, flex, justify, style]);
  return /* @__PURE__ */ jsx21("div", {
    className,
    style: finalStyle,
    ...other,
    children
  });
};
var Column = ({ children, justify, className, align, style = {} }) => {
  const finalStyle = useMemo13(() => {
    return {
      ...style,
      display: "flex",
      flexDirection: "column",
      justifyContent: justify ?? "flex-start",
      alignItems: align ?? "flex-start"
    };
  }, [align, justify, style]);
  return /* @__PURE__ */ jsx21("div", {
    className,
    style: finalStyle,
    children
  });
};

// src/components/Menu/SubMenu.tsx
import { useCallback as useCallback7 } from "react";
import { jsx as jsx22 } from "react/jsx-runtime";
var SubMenuComponent = ({
  portalStyle,
  subMenuActivated,
  subMenu,
  onQuitFullMenu,
  onQuitSubMenu
}) => {
  const mobileLayout = useMobileLayout();
  const onOutsideClick = useCallback7((e) => {
    if (portals.find((p) => p.contains(e)) || mobileLayout) {
      onQuitSubMenu();
    } else {
      onQuitFullMenu();
    }
  }, [mobileLayout, onQuitFullMenu, onQuitSubMenu]);
  return /* @__PURE__ */ jsx22(HigherZIndex, {
    onEscape: onQuitFullMenu,
    onOutsideClick,
    children: /* @__PURE__ */ jsx22("div", {
      style: portalStyle,
      className: "css-reset",
      children: /* @__PURE__ */ jsx22(MenuContent, {
        onNextMenu: noop,
        onPreviousMenu: onQuitSubMenu,
        values: subMenu.items,
        onHide: onQuitFullMenu,
        leaveLeftSpace: subMenu.leaveLeftSpace,
        preselectIndex: subMenuActivated === "without-mouse" && typeof subMenu.preselectIndex === "number" ? subMenu.preselectIndex : false,
        topItemCanBeUnselected: false,
        fixedHeight: null
      })
    })
  });
};

// src/components/Menu/is-menu-item.tsx
var MENU_INITIATOR_CLASSNAME = "__remotion-studio-menu-initiator";
var MENU_ITEM_CLASSNAME = "__remotion-studio-menu-item";
var HORIZONTAL_SCROLLBAR_CLASSNAME = "__remotion-horizontal-scrollbar";
var VERTICAL_SCROLLBAR_CLASSNAME = "__remotion-vertical-scrollbar";
var isMenuItem = (el) => {
  return Boolean(el.classList.contains(MENU_ITEM_CLASSNAME) || el.closest(`.${MENU_ITEM_CLASSNAME}`) || el.classList.contains(MENU_INITIATOR_CLASSNAME) || el.closest(`.${MENU_INITIATOR_CLASSNAME}`));
};

// src/components/Menu/MenuSubItem.tsx
import { jsx as jsx23, jsxs as jsxs3, Fragment } from "react/jsx-runtime";
var container4 = {
  paddingTop: 8,
  paddingBottom: 8,
  paddingLeft: 12,
  paddingRight: 8,
  cursor: "default"
};
var labelStyle = {
  fontSize: 13,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  flex: 1
};
var keyHintCss = {
  flexDirection: "row",
  color: LIGHT_TEXT,
  fontSize: 13
};
var leftSpace = {
  width: 24,
  marginLeft: -6,
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center"
};
var MenuSubItem = ({
  label,
  leaveLeftSpace,
  leftItem,
  onActionChosen,
  id,
  selected,
  onItemSelected,
  keyHint,
  subMenu,
  onQuitMenu,
  subMenuActivated,
  setSubMenuActivated
}) => {
  const [hovered, setHovered] = useState10(false);
  const ref = useRef6(null);
  const size = PlayerInternals2.useElementSize(ref, {
    triggerOnWindowResize: true,
    shouldApplyCssTransforms: true
  });
  const mobileLayout = useMobileLayout();
  const { currentZIndex } = useZIndex();
  const style = useMemo14(() => {
    return {
      ...container4,
      backgroundColor: selected ? CLEAR_HOVER : "transparent"
    };
  }, [selected]);
  const onPointerUp = useCallback8((e) => {
    if (subMenu) {
      setSubMenuActivated("with-mouse");
      setHovered(true);
      return;
    }
    onActionChosen(id, e);
  }, [id, onActionChosen, setSubMenuActivated, subMenu]);
  const onPointerEnter = useCallback8(() => {
    onItemSelected(id);
    setHovered(true);
  }, [id, onItemSelected]);
  const onPointerLeave = useCallback8(() => {
    setHovered(false);
  }, []);
  const onQuitSubmenu = useCallback8(() => {
    setSubMenuActivated(false);
  }, [setSubMenuActivated]);
  const portalStyle = useMemo14(() => {
    if (!selected || !size || !subMenu || !subMenuActivated) {
      return null;
    }
    const left = size.left + size.width + SUBMENU_LEFT_INSET;
    return {
      ...menuContainerTowardsBottom,
      left: mobileLayout ? left * 0.7 : left,
      top: size.top - MENU_VERTICAL_PADDING
    };
  }, [mobileLayout, selected, size, subMenu, subMenuActivated]);
  useEffect8(() => {
    if (!hovered || !subMenu) {
      return;
    }
    const hi = setTimeout(() => {
      setSubMenuActivated("with-mouse");
    }, 100);
    return () => clearTimeout(hi);
  }, [hovered, selected, setSubMenuActivated, subMenu]);
  useEffect8(() => {
    if (selected) {
      ref.current?.scrollIntoView({
        block: "nearest"
      });
    }
  }, [selected]);
  return /* @__PURE__ */ jsx23("div", {
    ref,
    onPointerEnter,
    onPointerLeave,
    style,
    onPointerUp,
    role: "button",
    className: MENU_ITEM_CLASSNAME,
    children: /* @__PURE__ */ jsxs3(Row, {
      align: "center",
      children: [
        leaveLeftSpace ? /* @__PURE__ */ jsxs3(Fragment, {
          children: [
            /* @__PURE__ */ jsx23("div", {
              style: leftSpace,
              children: leftItem
            }),
            /* @__PURE__ */ jsx23(Spacing, {
              x: 1
            })
          ]
        }) : null,
        /* @__PURE__ */ jsx23("div", {
          style: labelStyle,
          ...{ title: typeof label === "string" ? label : undefined },
          children: label
        }),
        " ",
        /* @__PURE__ */ jsx23(Spacing, {
          x: 2
        }),
        subMenu ? /* @__PURE__ */ jsx23(CaretRight, {}) : null,
        keyHint && !areKeyboardShortcutsDisabled() ? /* @__PURE__ */ jsx23("span", {
          style: keyHintCss,
          children: keyHint
        }) : null,
        portalStyle && subMenu ? ReactDOM.createPortal(/* @__PURE__ */ jsx23(SubMenuComponent, {
          onQuitFullMenu: onQuitMenu,
          subMenu,
          onQuitSubMenu: onQuitSubmenu,
          portalStyle,
          subMenuActivated
        }), getPortal(currentZIndex)) : null
      ]
    })
  });
};

// src/components/NewComposition/MenuContent.tsx
import { jsx as jsx24 } from "react/jsx-runtime";
var BORDER_SIZE = 1;
var container5 = {
  paddingTop: MENU_VERTICAL_PADDING,
  paddingBottom: MENU_VERTICAL_PADDING,
  border: `${BORDER_SIZE}px solid ${INPUT_BORDER_COLOR_UNHOVERED}`,
  marginLeft: 0 - BORDER_SIZE,
  overflowY: "auto",
  overflowX: "hidden",
  minWidth: 200,
  maxWidth: MAX_MENU_WIDTH
};
var MenuContent = ({
  onHide,
  values,
  preselectIndex,
  onNextMenu,
  onPreviousMenu,
  leaveLeftSpace,
  topItemCanBeUnselected,
  fixedHeight
}) => {
  const keybindings = useKeybinding();
  const containerRef = useRef7(null);
  const isMobileLayout = useMobileLayout();
  const [subMenuActivated, setSubMenuActivated] = useState11(false);
  if (values[0].type === "divider") {
    throw new Error("first value cant be divide");
  }
  const [selectedItem, setSelectedItem] = useState11(typeof preselectIndex === "number" && preselectIndex >= 0 ? values[preselectIndex].id : null);
  const onEscape = useCallback9(() => {
    onHide();
  }, [onHide]);
  const onItemSelected = useCallback9((id) => {
    setSelectedItem(id);
  }, []);
  const onArrowUp = useCallback9(() => {
    setSelectedItem((prevItem) => {
      if (prevItem === null) {
        return null;
      }
      const index = values.findIndex((val) => val.id === prevItem);
      if (topItemCanBeUnselected && index === 0 || prevItem === null) {
        return null;
      }
      const previousItems = values.filter((v, i) => i < index && v.type !== "divider");
      if (previousItems.length > 0) {
        return previousItems[previousItems.length - 1].id;
      }
      const firstNonDivider = values.find((v) => v.type !== "divider");
      if (firstNonDivider) {
        return firstNonDivider.id;
      }
      throw new Error("could not find previous item");
    });
  }, [topItemCanBeUnselected, values]);
  const onArrowDown = useCallback9(() => {
    setSelectedItem((prevItem) => {
      const index = values.findIndex((val) => val.id === prevItem);
      const nextItem = values.find((v, i) => i > index && v.type !== "divider");
      if (nextItem) {
        return nextItem.id;
      }
      const lastNonDivider = values.slice().reverse().find((v) => v.type !== "divider");
      if (lastNonDivider) {
        return lastNonDivider.id;
      }
      throw new Error("could not find next item");
    });
  }, [values]);
  const onEnter = useCallback9(() => {
    if (selectedItem === null) {
      return onHide();
    }
    const item = values.find((i) => i.id === selectedItem);
    if (!item) {
      throw new Error("cannot find item");
    }
    if (item.type === "divider") {
      throw new Error("cannot find divider");
    }
    if (item.subMenu) {
      return setSubMenuActivated("without-mouse");
    }
    onHide();
    item.onClick(item.id, null);
  }, [onHide, selectedItem, values]);
  const onArrowRight = useCallback9(() => {
    if (selectedItem === null) {
      return onNextMenu();
    }
    const item = values.find((i) => i.id === selectedItem);
    if (!item) {
      throw new Error("cannot find item");
    }
    if (item.type === "divider") {
      throw new Error("cannot find divider");
    }
    if (!item.subMenu) {
      return onNextMenu();
    }
    setSubMenuActivated("without-mouse");
  }, [onNextMenu, selectedItem, values]);
  const containerWithHeight = useMemo15(() => {
    const containerStyles = { ...container5 };
    if (fixedHeight === null) {
      containerStyles.maxHeight = 600;
    } else {
      containerStyles.maxHeight = fixedHeight;
    }
    if (isMobileLayout) {
      containerStyles.maxWidth = MAX_MOBILE_MENU_WIDTH;
    }
    return containerStyles;
  }, [fixedHeight, isMobileLayout]);
  useEffect9(() => {
    const escapeBinding = keybindings.registerKeybinding({
      event: "keydown",
      key: "Escape",
      callback: onEscape,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const rightBinding = keybindings.registerKeybinding({
      event: "keydown",
      key: "ArrowRight",
      commandCtrlKey: false,
      callback: onArrowRight,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const leftBinding = keybindings.registerKeybinding({
      event: "keydown",
      commandCtrlKey: false,
      key: "ArrowLeft",
      callback: onPreviousMenu,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const downBinding = keybindings.registerKeybinding({
      event: "keydown",
      key: "ArrowDown",
      commandCtrlKey: false,
      callback: onArrowDown,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const upBinding = keybindings.registerKeybinding({
      event: "keydown",
      key: "ArrowUp",
      callback: onArrowUp,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const enterBinding = keybindings.registerKeybinding({
      event: "keydown",
      key: "Enter",
      callback: onEnter,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const spaceBinding = keybindings.registerKeybinding({
      event: "keyup",
      key: " ",
      callback: onEnter,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      escapeBinding.unregister();
      leftBinding.unregister();
      rightBinding.unregister();
      downBinding.unregister();
      upBinding.unregister();
      enterBinding.unregister();
      spaceBinding.unregister();
    };
  }, [
    keybindings,
    onEscape,
    onNextMenu,
    onPreviousMenu,
    onArrowDown,
    onArrowUp,
    onEnter,
    onArrowRight
  ]);
  useEffect9(() => {
    if (!subMenuActivated) {
      return;
    }
    if (selectedItem === null) {
      return setSubMenuActivated(false);
    }
    const item = values.find((i) => i.id === selectedItem);
    if (!item) {
      return;
    }
    if (item.type === "divider") {
      throw new Error("should not select divider");
    }
    if (!item.subMenu && subMenuActivated) {
      setSubMenuActivated(false);
    }
  }, [selectedItem, subMenuActivated, values]);
  useEffect9(() => {
    const { current } = containerRef;
    if (!current) {
      return;
    }
    const onPointerLeave = () => {
      if (subMenuActivated) {
        return;
      }
      setSelectedItem(null);
    };
    current.addEventListener("pointerleave", onPointerLeave);
    return () => current.removeEventListener("pointerleave", onPointerLeave);
  }, [onHide, subMenuActivated]);
  return /* @__PURE__ */ jsx24("div", {
    ref: containerRef,
    style: containerWithHeight,
    className: VERTICAL_SCROLLBAR_CLASSNAME,
    children: values.map((item) => {
      if (item.type === "divider") {
        return /* @__PURE__ */ jsx24(MenuDivider, {}, item.id);
      }
      const onClick = (id, e) => {
        item.onClick(id, e);
        if (item.subMenu) {
          return null;
        }
        onHide();
      };
      return /* @__PURE__ */ jsx24(MenuSubItem, {
        selected: item.id === selectedItem,
        onActionChosen: onClick,
        onItemSelected,
        label: item.label,
        id: item.id,
        keyHint: item.keyHint,
        leaveLeftSpace,
        leftItem: item.leftItem,
        subMenu: item.subMenu,
        onQuitMenu: onHide,
        onNextMenu,
        subMenuActivated,
        setSubMenuActivated
      }, item.id);
    })
  });
};

// src/components/InlineDropdown.tsx
import { jsx as jsx25, jsxs as jsxs4, Fragment as Fragment2 } from "react/jsx-runtime";
var InlineDropdown = ({
  values,
  ...props
}) => {
  const ref = useRef8(null);
  const [opened, setOpened] = useState12({ type: "not-open" });
  const { currentZIndex } = useZIndex();
  const size = PlayerInternals3.useElementSize(ref, {
    triggerOnWindowResize: true,
    shouldApplyCssTransforms: true
  });
  const isMobileLayout = useMobileLayout();
  const onClick = useCallback10((e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpened({ type: "open", left: e.clientX, top: e.clientY });
  }, []);
  const spaceToBottom = useMemo16(() => {
    if (size && opened.type === "open") {
      return size.windowSize.height - opened.top;
    }
    return 0;
  }, [opened, size]);
  const spaceToTop = useMemo16(() => {
    if (size && opened.type === "open") {
      return opened.top;
    }
    return 0;
  }, [opened, size]);
  const portalStyle = useMemo16(() => {
    if (opened.type === "not-open") {
      return;
    }
    if (!size) {
      return;
    }
    const spaceToRight = size.windowSize.width - size.left;
    const spaceToLeft = size.left + size.width;
    const minSpaceRequired = isMobileLayout ? MAX_MOBILE_MENU_WIDTH : MAX_MENU_WIDTH;
    const verticalLayout = spaceToTop > spaceToBottom ? "bottom" : "top";
    const canOpenOnLeft = spaceToLeft >= minSpaceRequired;
    const canOpenOnRight = spaceToRight >= minSpaceRequired;
    const horizontalLayout = canOpenOnRight ? "left" : "right";
    return {
      ...menuContainerTowardsTop,
      ...verticalLayout === "top" ? {
        top: opened.top
      } : {
        bottom: size.windowSize.height - opened.top
      },
      ...horizontalLayout === "left" ? {
        left: opened.left
      } : {
        right: canOpenOnLeft ? size.windowSize.width - opened.left : 0
      }
    };
  }, [opened, size, isMobileLayout, spaceToTop, spaceToBottom]);
  const onHide = useCallback10(() => {
    setOpened({ type: "not-open" });
  }, []);
  return /* @__PURE__ */ jsxs4(Fragment2, {
    children: [
      /* @__PURE__ */ jsx25("div", {
        ref,
        children: /* @__PURE__ */ jsx25(InlineAction, {
          onClick,
          ...props
        })
      }),
      portalStyle ? ReactDOM2.createPortal(/* @__PURE__ */ jsx25("div", {
        style: fullScreenOverlay,
        children: /* @__PURE__ */ jsx25("div", {
          style: outerPortal,
          className: "css-reset",
          children: /* @__PURE__ */ jsx25(HigherZIndex, {
            onOutsideClick: onHide,
            onEscape: onHide,
            children: /* @__PURE__ */ jsx25("div", {
              style: portalStyle,
              children: /* @__PURE__ */ jsx25(MenuContent, {
                onNextMenu: noop,
                onPreviousMenu: noop,
                values,
                onHide,
                leaveLeftSpace: true,
                preselectIndex: false,
                topItemCanBeUnselected: false,
                fixedHeight: null
              })
            })
          })
        })
      }), getPortal(currentZIndex)) : null
    ]
  });
};

// src/components/CompositionContextButton.tsx
import { jsx as jsx26 } from "react/jsx-runtime";
var CompositionContextButton = ({ visible, values }) => {
  const iconStyle = useMemo17(() => {
    return {
      style: {
        height: 12
      }
    };
  }, []);
  const connectionStatus = useContext6(StudioServerConnectionCtx).previewServerState.type;
  const renderAction = useCallback11((color) => {
    return /* @__PURE__ */ jsx26(EllipsisIcon, {
      fill: color,
      svgProps: iconStyle
    });
  }, [iconStyle]);
  if (!visible || connectionStatus !== "connected") {
    return null;
  }
  return /* @__PURE__ */ jsx26(InlineDropdown, {
    renderAction,
    values
  });
};

// src/components/ContextMenu.tsx
import { PlayerInternals as PlayerInternals4 } from "@remotion/player";
import { useCallback as useCallback12, useEffect as useEffect10, useMemo as useMemo18, useRef as useRef9, useState as useState13 } from "react";
import ReactDOM3 from "react-dom";
import { jsx as jsx27, jsxs as jsxs5, Fragment as Fragment3 } from "react/jsx-runtime";
var ContextMenu = ({ children, values }) => {
  const ref = useRef9(null);
  const [opened, setOpened] = useState13({ type: "not-open" });
  const { currentZIndex } = useZIndex();
  const style = useMemo18(() => {
    return {};
  }, []);
  const size = PlayerInternals4.useElementSize(ref, {
    triggerOnWindowResize: true,
    shouldApplyCssTransforms: true
  });
  const isMobileLayout = useMobileLayout();
  useEffect10(() => {
    const { current } = ref;
    if (!current) {
      return;
    }
    const onClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      setOpened({ type: "open", left: e.clientX, top: e.clientY });
      return false;
    };
    current.addEventListener("contextmenu", onClick);
    return () => {
      current.removeEventListener("contextmenu", onClick);
    };
  }, [size]);
  const spaceToBottom = useMemo18(() => {
    if (size && opened.type === "open") {
      return size.windowSize.height - opened.top;
    }
    return 0;
  }, [opened, size]);
  const spaceToTop = useMemo18(() => {
    if (size && opened.type === "open") {
      return opened.top;
    }
    return 0;
  }, [opened, size]);
  const portalStyle = useMemo18(() => {
    if (opened.type === "not-open") {
      return;
    }
    if (!size) {
      return;
    }
    const spaceToRight = size.windowSize.width - size.left;
    const spaceToLeft = size.left + size.width;
    const minSpaceRequired = isMobileLayout ? MAX_MOBILE_MENU_WIDTH : MAX_MENU_WIDTH;
    const verticalLayout = spaceToTop > spaceToBottom ? "bottom" : "top";
    const canOpenOnLeft = spaceToLeft >= minSpaceRequired;
    const canOpenOnRight = spaceToRight >= minSpaceRequired;
    const horizontalLayout = canOpenOnRight ? "left" : "right";
    return {
      ...menuContainerTowardsTop,
      ...verticalLayout === "top" ? {
        top: opened.top
      } : {
        bottom: size.windowSize.height - opened.top
      },
      ...horizontalLayout === "left" ? {
        left: opened.left
      } : {
        right: canOpenOnLeft ? size.windowSize.width - opened.left : 0
      }
    };
  }, [opened, size, isMobileLayout, spaceToTop, spaceToBottom]);
  const onHide = useCallback12(() => {
    setOpened({ type: "not-open" });
  }, []);
  return /* @__PURE__ */ jsxs5(Fragment3, {
    children: [
      /* @__PURE__ */ jsx27("div", {
        ref,
        onContextMenu: () => false,
        style,
        children
      }),
      portalStyle ? ReactDOM3.createPortal(/* @__PURE__ */ jsx27("div", {
        style: fullScreenOverlay,
        children: /* @__PURE__ */ jsx27("div", {
          style: outerPortal,
          className: "css-reset",
          children: /* @__PURE__ */ jsx27(HigherZIndex, {
            onOutsideClick: onHide,
            onEscape: onHide,
            children: /* @__PURE__ */ jsx27("div", {
              style: portalStyle,
              children: /* @__PURE__ */ jsx27(MenuContent, {
                onNextMenu: noop,
                onPreviousMenu: noop,
                values,
                onHide,
                leaveLeftSpace: true,
                preselectIndex: false,
                topItemCanBeUnselected: false,
                fixedHeight: null
              })
            })
          })
        })
      }), getPortal(currentZIndex)) : null
    ]
  });
};

// src/components/SidebarRenderButton.tsx
import { useCallback as useCallback13, useContext as useContext7, useMemo as useMemo19 } from "react";
import { Internals as Internals5 } from "remotion";

// src/icons/render.tsx
import { jsx as jsx28 } from "react/jsx-runtime";
var RenderIcon = (props) => {
  return /* @__PURE__ */ jsx28("svg", {
    ...props.svgProps,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    children: /* @__PURE__ */ jsx28("path", {
      fill: "currentColor",
      d: "M156.6 384.9L125.7 354c-8.5-8.5-11.5-20.8-7.7-32.2c3-8.9 7-20.5 11.8-33.8L24 288c-8.6 0-16.6-4.6-20.9-12.1s-4.2-16.7 .2-24.1l52.5-88.5c13-21.9 36.5-35.3 61.9-35.3l82.3 0c2.4-4 4.8-7.7 7.2-11.3C289.1-4.1 411.1-8.1 483.9 5.3c11.6 2.1 20.6 11.2 22.8 22.8c13.4 72.9 9.3 194.8-111.4 276.7c-3.5 2.4-7.3 4.8-11.3 7.2v82.3c0 25.4-13.4 49-35.3 61.9l-88.5 52.5c-7.4 4.4-16.6 4.5-24.1 .2s-12.1-12.2-12.1-20.9V380.8c-14.1 4.9-26.4 8.9-35.7 11.9c-11.2 3.6-23.4 .5-31.8-7.8zM384 168a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
    })
  });
};
var ThinRenderIcon = (props) => {
  return /* @__PURE__ */ jsx28("svg", {
    ...props.svgProps,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    children: /* @__PURE__ */ jsx28("path", {
      fill: props.fill,
      d: "M188.9 372l-50.4-50.4c18.6-42.6 61.7-137.7 95.1-187C304.6 30.1 409 24.6 475.7 36.3c11.7 66.7 6.2 171.1-98.4 242c-49.4 33.5-145.5 75.6-188.4 93.7zm-79.9-62.8c-5.2 11.9-2.5 25.7 6.7 34.9l50.7 50.7c9.1 9.1 22.7 11.9 34.5 6.9c6.5-2.7 14.3-6 23-9.8L224 496c0 5.5 2.9 10.7 7.6 13.6s10.6 3.2 15.6 .7l101.5-50.7c21.7-10.8 35.4-33 35.4-57.2V312.1c4-2.5 7.7-4.9 11.3-7.3C516.1 222.9 520.1 100.9 506.7 28.1c-2.1-11.6-11.2-20.6-22.8-22.8C411.1-8.1 289.1-4.1 207.2 116.7c-2.4 3.6-4.9 7.3-7.3 11.3l-90.2 0c-24.2 0-46.4 13.7-57.2 35.4L1.7 264.8c-2.5 5-2.2 10.8 .7 15.6s8.1 7.6 13.6 7.6H118.5c-3.6 8-6.8 15.2-9.4 21.2zM256 470.1l0-92.5c30.3-13.7 65.4-30.3 96-47v71.7c0 12.1-6.8 23.2-17.7 28.6L256 470.1zM109.7 160h71.5c-16.9 30.7-34 65.8-48.1 96H41.9L81 177.7c5.4-10.8 16.5-17.7 28.6-17.7zM392 144a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM368 88a56 56 0 1 0 0 112 56 56 0 1 0 0-112z"
    })
  });
};

// src/components/SidebarRenderButton.tsx
import { jsx as jsx29 } from "react/jsx-runtime";
var SidebarRenderButton = ({ composition, visible }) => {
  const { setSelectedModal } = useContext7(ModalsContext);
  const { setSidebarCollapsedState } = useContext7(SidebarContext);
  const isMobileLayout = useMobileLayout();
  const iconStyle = useMemo19(() => {
    return {
      style: {
        height: 12
      }
    };
  }, []);
  const connectionStatus = useContext7(StudioServerConnectionCtx).previewServerState.type;
  const { props } = useContext7(Internals5.EditorPropsContext);
  const onClick = useCallback13((e) => {
    const defaults = window.remotion_renderDefaults;
    if (!defaults) {
      throw new Error("expected defaults");
    }
    e.stopPropagation();
    setSelectedModal({
      type: "render",
      compositionId: composition.id,
      initialFrame: 0,
      initialVideoImageFormat: defaults.videoImageFormat,
      initialStillImageFormat: defaults.stillImageFormat,
      initialJpegQuality: defaults.jpegQuality,
      initialScale: defaults.scale,
      initialLogLevel: defaults.logLevel,
      initialConcurrency: defaults.concurrency,
      maxConcurrency: defaults.maxConcurrency,
      minConcurrency: defaults.minConcurrency,
      initialMuted: defaults.muted,
      initialEnforceAudioTrack: defaults.enforceAudioTrack,
      initialProResProfile: defaults.proResProfile,
      initialx264Preset: defaults.x264Preset,
      initialPixelFormat: defaults.pixelFormat,
      initialAudioBitrate: defaults.audioBitrate,
      initialVideoBitrate: defaults.videoBitrate,
      initialEveryNthFrame: defaults.everyNthFrame,
      initialNumberOfGifLoops: defaults.numberOfGifLoops,
      initialDelayRenderTimeout: defaults.delayRenderTimeout,
      defaultConfigurationAudioCodec: defaults.audioCodec,
      initialEnvVariables: window.process.env,
      initialDisableWebSecurity: defaults.disableWebSecurity,
      initialOpenGlRenderer: defaults.openGlRenderer,
      initialHeadless: defaults.headless,
      initialOffthreadVideoCacheSizeInBytes: defaults.offthreadVideoCacheSizeInBytes,
      initialOffthreadVideoThreads: defaults.offthreadVideoThreads,
      initialIgnoreCertificateErrors: defaults.ignoreCertificateErrors,
      defaultProps: props[composition.id] ?? composition.defaultProps,
      inFrameMark: null,
      outFrameMark: null,
      initialColorSpace: defaults.colorSpace,
      initialMultiProcessOnLinux: defaults.multiProcessOnLinux,
      defaultConfigurationVideoCodec: defaults.codec,
      initialEncodingBufferSize: defaults.encodingBufferSize,
      initialEncodingMaxRate: defaults.encodingMaxRate,
      initialUserAgent: defaults.userAgent,
      initialBeep: defaults.beepOnFinish,
      initialRepro: defaults.repro,
      initialForSeamlessAacConcatenation: defaults.forSeamlessAacConcatenation,
      renderTypeOfLastRender: null,
      defaulMetadata: defaults.metadata,
      initialHardwareAcceleration: defaults.hardwareAcceleration,
      initialChromeMode: defaults.chromeMode
    });
    if (isMobileLayout) {
      setSidebarCollapsedState({ left: "collapsed", right: "collapsed" });
    }
  }, [
    composition.defaultProps,
    composition.id,
    isMobileLayout,
    props,
    setSelectedModal,
    setSidebarCollapsedState
  ]);
  const renderAction = useCallback13((color) => {
    return /* @__PURE__ */ jsx29(ThinRenderIcon, {
      fill: color,
      svgProps: iconStyle
    });
  }, [iconStyle]);
  if (!visible || connectionStatus !== "connected") {
    return null;
  }
  return /* @__PURE__ */ jsx29(InlineAction, {
    renderAction,
    onClick
  });
};

// src/components/CompositionSelectorItem.tsx
import { jsx as jsx30, jsxs as jsxs6, Fragment as Fragment4 } from "react/jsx-runtime";
var COMPOSITION_ITEM_HEIGHT = 32;
var itemStyle = {
  paddingRight: 10,
  paddingTop: 6,
  paddingBottom: 6,
  fontSize: 13,
  display: "flex",
  textDecoration: "none",
  cursor: "default",
  alignItems: "center",
  marginBottom: 1,
  appearance: "none",
  border: "none",
  width: "100%",
  textAlign: "left",
  backgroundColor: BACKGROUND,
  height: COMPOSITION_ITEM_HEIGHT
};
var labelStyle2 = {
  textAlign: "left",
  textDecoration: "none",
  fontSize: 13,
  flex: 1,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis"
};
var iconStyle = {
  width: 18,
  height: 18,
  flexShrink: 0
};
var CompositionSelectorItem = ({
  item,
  level,
  currentComposition,
  tabIndex,
  selectComposition,
  toggleFolder
}) => {
  const selected = useMemo20(() => {
    if (item.type === "composition") {
      return currentComposition === item.composition.id;
    }
    return false;
  }, [item, currentComposition]);
  const [hovered, setHovered] = useState14(false);
  const onPointerEnter = useCallback14(() => {
    setHovered(true);
  }, []);
  const onPointerLeave = useCallback14(() => {
    setHovered(false);
  }, []);
  const style = useMemo20(() => {
    return {
      ...itemStyle,
      backgroundColor: getBackgroundFromHoverState({ hovered, selected }),
      paddingLeft: 12 + level * 8
    };
  }, [hovered, level, selected]);
  const label = useMemo20(() => {
    return {
      ...labelStyle2,
      color: selected || hovered ? "white" : LIGHT_TEXT
    };
  }, [hovered, selected]);
  const onClick = useCallback14((evt) => {
    evt.preventDefault();
    if (item.type === "composition") {
      selectComposition(item.composition, true);
    } else {
      toggleFolder(item.folderName, item.parentName);
    }
  }, [item, selectComposition, toggleFolder]);
  const onKeyPress = useCallback14((evt) => {
    if (evt.key === "Enter") {
      onClick(evt);
    }
  }, [onClick]);
  const { setSelectedModal } = useContext8(ModalsContext);
  const contextMenu = useMemo20(() => {
    if (item.type === "composition") {
      return [
        {
          id: "duplicate",
          keyHint: null,
          label: `Duplicate...`,
          leftItem: null,
          onClick: () => {
            setSelectedModal({
              type: "duplicate-comp",
              compositionId: item.composition.id,
              compositionType: item.composition.durationInFrames === 1 ? "still" : "composition"
            });
          },
          quickSwitcherLabel: null,
          subMenu: null,
          type: "item",
          value: "duplicate"
        },
        {
          id: "rename",
          keyHint: null,
          label: `Rename...`,
          leftItem: null,
          onClick: () => {
            setSelectedModal({
              type: "rename-comp",
              compositionId: item.composition.id
            });
          },
          quickSwitcherLabel: null,
          subMenu: null,
          type: "item",
          value: "rename"
        },
        {
          id: "delete",
          keyHint: null,
          label: `Delete...`,
          leftItem: null,
          onClick: () => {
            setSelectedModal({
              type: "delete-comp",
              compositionId: item.composition.id
            });
          },
          quickSwitcherLabel: null,
          subMenu: null,
          type: "item",
          value: "delete"
        },
        {
          type: "divider",
          id: "copy-id-divider"
        },
        {
          id: "copy-id",
          keyHint: null,
          label: `Copy ID`,
          leftItem: null,
          onClick: () => {
            navigator.clipboard.writeText(item.composition.id).catch((err) => {
              showNotification(`Could not copy to clipboard: ${err.message}`, 1000);
            }).then(() => {
              showNotification("Copied to clipboard", 1000);
            });
          },
          quickSwitcherLabel: null,
          subMenu: null,
          type: "item",
          value: "remove"
        }
      ];
    }
    return [];
  }, [item, setSelectedModal]);
  if (item.type === "folder") {
    return /* @__PURE__ */ jsxs6(Fragment4, {
      children: [
        /* @__PURE__ */ jsxs6("button", {
          style,
          onPointerEnter,
          onPointerLeave,
          tabIndex,
          onClick,
          type: "button",
          title: item.folderName,
          children: [
            item.expanded ? /* @__PURE__ */ jsx30(ExpandedFolderIcon, {
              style: iconStyle,
              color: hovered || selected ? "white" : LIGHT_TEXT
            }) : /* @__PURE__ */ jsx30(CollapsedFolderIcon, {
              color: hovered || selected ? "white" : LIGHT_TEXT,
              style: iconStyle
            }),
            /* @__PURE__ */ jsx30(Spacing, {
              x: 1
            }),
            /* @__PURE__ */ jsx30("div", {
              style: label,
              children: item.folderName
            })
          ]
        }),
        item.expanded ? item.items.map((childItem) => {
          return /* @__PURE__ */ jsx30(CompositionSelectorItem, {
            currentComposition,
            selectComposition,
            item: childItem,
            tabIndex,
            level: level + 1,
            toggleFolder
          }, childItem.key + childItem.type);
        }) : null
      ]
    });
  }
  return /* @__PURE__ */ jsx30(ContextMenu, {
    values: contextMenu,
    children: /* @__PURE__ */ jsx30(Row, {
      align: "center",
      children: /* @__PURE__ */ jsxs6("a", {
        style,
        onPointerEnter,
        onPointerLeave,
        tabIndex,
        onClick,
        onKeyPress,
        type: "button",
        title: item.composition.id,
        className: "__remotion-composition",
        "data-compname": item.composition.id,
        children: [
          isCompositionStill(item.composition) ? /* @__PURE__ */ jsx30(StillIcon, {
            color: hovered || selected ? "white" : LIGHT_TEXT,
            style: iconStyle
          }) : /* @__PURE__ */ jsx30(FilmIcon, {
            color: hovered || selected ? "white" : LIGHT_TEXT,
            style: iconStyle
          }),
          /* @__PURE__ */ jsx30(Spacing, {
            x: 1
          }),
          /* @__PURE__ */ jsx30("div", {
            style: label,
            children: item.composition.id
          }),
          /* @__PURE__ */ jsx30(Spacing, {
            x: 0.5
          }),
          /* @__PURE__ */ jsx30(CompositionContextButton, {
            values: contextMenu,
            visible: hovered
          }),
          /* @__PURE__ */ jsx30(SidebarRenderButton, {
            visible: hovered,
            composition: item.composition
          })
        ]
      })
    })
  });
};

// src/components/CurrentComposition.tsx
import { Internals as Internals6 } from "remotion";

// src/state/render-frame.ts
var renderFrame = (frame, fps) => {
  const hours = Math.floor(frame / fps / 3600);
  const remainingMinutes = frame - hours * fps * 3600;
  const minutes = Math.floor(remainingMinutes / 60 / fps);
  const remainingSec = frame - hours * fps * 3600 - minutes * fps * 60;
  const seconds = Math.floor(remainingSec / fps);
  const frameAfterSec = Math.round(frame % fps);
  const hoursStr = String(hours);
  const minutesStr = String(minutes).padStart(2, "0");
  const secondsStr = String(seconds).padStart(2, "0");
  const frameStr = String(frameAfterSec).padStart(2, "0");
  if (hours > 0) {
    return `${hoursStr}:${minutesStr}:${secondsStr}.${frameStr}`;
  }
  return `${minutesStr}:${secondsStr}.${frameStr}`;
};

// src/components/CurrentComposition.tsx
import { jsx as jsx31, jsxs as jsxs7 } from "react/jsx-runtime";
var CURRENT_COMPOSITION_HEIGHT = 80;
var container6 = {
  height: CURRENT_COMPOSITION_HEIGHT,
  display: "block",
  borderBottom: `1px solid ${BORDER_COLOR}`,
  padding: 12,
  color: "white",
  backgroundColor: BACKGROUND
};
var title = {
  fontWeight: "bold",
  fontSize: 12,
  whiteSpace: "nowrap",
  lineHeight: "18px",
  backgroundColor: BACKGROUND
};
var subtitle = {
  fontSize: 12,
  opacity: 0.8,
  whiteSpace: "nowrap",
  lineHeight: "18px",
  backgroundColor: BACKGROUND
};
var row = {
  display: "flex",
  flexDirection: "row",
  lineHeight: "18px",
  backgroundColor: BACKGROUND
};
var CurrentComposition = () => {
  const video = Internals6.useVideo();
  if (!video) {
    return /* @__PURE__ */ jsx31("div", {
      style: container6
    });
  }
  return /* @__PURE__ */ jsx31("div", {
    style: container6,
    children: /* @__PURE__ */ jsx31("div", {
      style: row,
      children: /* @__PURE__ */ jsxs7("div", {
        children: [
          /* @__PURE__ */ jsx31("div", {
            style: title,
            children: video.id
          }),
          /* @__PURE__ */ jsxs7("div", {
            style: subtitle,
            children: [
              video.width,
              "x",
              video.height,
              isCompositionStill(video) ? null : `, ${video.fps} FPS`
            ]
          }),
          isCompositionStill(video) ? /* @__PURE__ */ jsx31("div", {
            style: subtitle,
            children: "Still"
          }) : /* @__PURE__ */ jsxs7("div", {
            style: subtitle,
            children: [
              "Duration ",
              renderFrame(video.durationInFrames, video.fps)
            ]
          })
        ]
      })
    })
  });
};

// src/components/CompositionSelector.tsx
import { jsx as jsx32, jsxs as jsxs8 } from "react/jsx-runtime";
var useCompositionNavigation = () => {
  const { compositions, canvasContent } = useContext9(Internals7.CompositionManager);
  const selectComposition = useSelectComposition();
  const navigateToNextComposition = useCallback15(() => {
    if (!canvasContent || canvasContent.type !== "composition" || compositions.length <= 1) {
      return;
    }
    const currentIndex = compositions.findIndex((c) => c.id === canvasContent.compositionId);
    if (currentIndex === -1) {
      return;
    }
    const nextIndex = (currentIndex + 1) % compositions.length;
    const nextComposition = compositions[nextIndex];
    selectComposition(nextComposition, true);
  }, [canvasContent, compositions, selectComposition]);
  const navigateToPreviousComposition = useCallback15(() => {
    if (!canvasContent || canvasContent.type !== "composition" || compositions.length <= 1) {
      return;
    }
    const currentIndex = compositions.findIndex((c) => c.id === canvasContent.compositionId);
    if (currentIndex === -1) {
      return;
    }
    const previousIndex = (currentIndex - 1 + compositions.length) % compositions.length;
    const previousComposition = compositions[previousIndex];
    selectComposition(previousComposition, true);
  }, [canvasContent, compositions, selectComposition]);
  return useMemo21(() => ({
    navigateToNextComposition,
    navigateToPreviousComposition
  }), [navigateToNextComposition, navigateToPreviousComposition]);
};
var container7 = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  overflow: "hidden",
  backgroundColor: BACKGROUND
};
var getKeysToExpand = (initialFolderName, parentFolderName, initial = []) => {
  initial.push(openFolderKey({
    folderName: initialFolderName,
    parentName: parentFolderName
  }));
  const { name, parent } = splitParentIntoNameAndParent(parentFolderName);
  if (!name) {
    return initial;
  }
  return getKeysToExpand(name, parent, initial);
};
var CompositionSelector = () => {
  const { compositions, canvasContent, folders } = useContext9(Internals7.CompositionManager);
  const { foldersExpanded } = useContext9(ExpandedFoldersContext);
  const { tabIndex } = useZIndex();
  const selectComposition = useSelectComposition();
  const items = useMemo21(() => {
    return createFolderTree(compositions, folders, foldersExpanded);
  }, [compositions, folders, foldersExpanded]);
  const showCurrentComposition = canvasContent && canvasContent.type === "composition";
  const list = useMemo21(() => {
    return {
      height: showCurrentComposition ? `calc(100% - ${CURRENT_COMPOSITION_HEIGHT}px)` : "100%",
      overflowY: "auto"
    };
  }, [showCurrentComposition]);
  const toggleFolder = useCallback15((folderName, parentName) => {
    Internals7.compositionSelectorRef.current?.toggleFolder(folderName, parentName);
  }, []);
  return /* @__PURE__ */ jsxs8("div", {
    style: container7,
    children: [
      showCurrentComposition ? /* @__PURE__ */ jsx32(CurrentComposition, {}) : null,
      /* @__PURE__ */ jsx32("div", {
        className: "__remotion-vertical-scrollbar",
        style: list,
        children: items.map((c) => {
          return /* @__PURE__ */ jsx32(CompositionSelectorItem, {
            level: 0,
            currentComposition: showCurrentComposition ? canvasContent.compositionId : null,
            selectComposition,
            toggleFolder,
            tabIndex,
            item: c
          }, c.key + c.type);
        })
      })
    ]
  });
};

// src/components/ExplorerPanel.tsx
import { createRef as createRef5, useCallback as useCallback21, useImperativeHandle as useImperativeHandle5, useState as useState19 } from "react";

// src/components/AssetSelector.tsx
import React25, {
  useCallback as useCallback18,
  useContext as useContext11,
  useEffect as useEffect12,
  useMemo as useMemo24,
  useState as useState16
} from "react";

// src/api/write-static-file.ts
var writeStaticFile = async ({
  contents,
  filePath
}) => {
  if (window.remotion_isReadOnlyStudio) {
    throw new Error("writeStaticFile() is not available in read-only Studio");
  }
  const url = new URL("/api/add-asset", window.location.origin);
  if (filePath.includes("\\")) {
    return Promise.reject(new Error("File path cannot contain backslashes"));
  }
  url.search = new URLSearchParams({
    filePath
  }).toString();
  const response = await fetch(url, {
    method: "POST",
    body: contents
  });
  if (!response.ok) {
    const jsonResponse = await response.json();
    throw new Error(jsonResponse.error);
  }
};

// src/helpers/use-asset-drag-events.ts
import { useCallback as useCallback16, useEffect as useEffect11, useMemo as useMemo22, useRef as useRef10 } from "react";
import { NoReactInternals } from "remotion/no-react";
function useAssetDragEvents({
  name,
  parentFolder,
  dropLocation,
  setDropLocation
}) {
  const dragDepthRef = useRef10(0);
  const combinedParents = useMemo22(() => {
    return [parentFolder, name].filter(NoReactInternals.truthy).join("/");
  }, [name, parentFolder]);
  const isDropDiv = useMemo22(() => {
    return dropLocation === combinedParents;
  }, [combinedParents, dropLocation]);
  const onDragEnter = useCallback16(() => {
    if (dragDepthRef.current === 0) {
      setDropLocation((currentDropLocation) => currentDropLocation?.includes(combinedParents) ? currentDropLocation : combinedParents);
    }
    dragDepthRef.current++;
  }, [combinedParents, dragDepthRef, setDropLocation]);
  const onDragLeave = useCallback16(() => {
    dragDepthRef.current--;
    if (dragDepthRef.current === 0) {
      setDropLocation((currentPath) => currentPath === combinedParents ? parentFolder : currentPath);
    }
  }, [combinedParents, dragDepthRef, parentFolder, setDropLocation]);
  useEffect11(() => {
    if (dropLocation === null) {
      dragDepthRef.current = 0;
    }
  }, [dropLocation]);
  return {
    isDropDiv,
    onDragEnter,
    onDragLeave
  };
}
var use_asset_drag_events_default = useAssetDragEvents;

// src/components/AssetSelectorItem.tsx
import React24, { useCallback as useCallback17, useContext as useContext10, useMemo as useMemo23, useRef as useRef11, useState as useState15 } from "react";
import { Internals as Internals8 } from "remotion";
import { NoReactInternals as NoReactInternals3 } from "remotion/no-react";

// src/helpers/copy-text.ts
var copyText = (cmd) => {
  const permissionName = "clipboard-write";
  return new Promise((resolve, reject) => {
    navigator.permissions.query({ name: permissionName }).then((result) => {
      if (result.state === "granted" || result.state === "prompt") {
        navigator.clipboard.writeText(cmd);
        resolve();
      } else {
        reject(new Error("Permission to copy not granted"));
      }
    }).catch((err) => {
      reject(err);
    });
  });
};

// src/icons/clipboard.tsx
import { jsx as jsx33 } from "react/jsx-runtime";
var ClipboardIcon = ({ color, ...props }) => /* @__PURE__ */ jsx33("svg", {
  viewBox: "0 0 384 512",
  ...props,
  children: /* @__PURE__ */ jsx33("path", {
    fill: color,
    d: "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm144 418c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V118c0-3.3 2.7-6 6-6h42v36c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-36h42c3.3 0 6 2.7 6 6z"
  })
});

// src/icons/file.tsx
import { jsx as jsx34 } from "react/jsx-runtime";
var FileIcon = ({
  color,
  ...props
}) => /* @__PURE__ */ jsx34("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 384 512",
  ...props,
  children: /* @__PURE__ */ jsx34("path", {
    fill: color ?? "currentColor",
    d: "M0 64C0 28.65 28.65 0 64 0h156.1c12.7 0 25 5.057 34 14.06L369.9 129.9c9 9 14.1 21.3 14.1 34V448c0 35.3-28.7 64-64 64H64c-35.35 0-64-28.7-64-64V64zm352 128H240c-26.5 0-48-21.5-48-48V32H64c-17.67 0-32 14.33-32 32v384c0 17.7 14.33 32 32 32h256c17.7 0 32-14.3 32-32V192zm-4.7-39.4L231.4 36.69c-2-2.07-4.6-3.51-7.4-4.21V144c0 8.8 7.2 16 16 16h111.5c-.7-2.8-2.1-5.4-4.2-7.4z"
  })
});

// src/components/RenderQueue/actions.ts
import { NoReactInternals as NoReactInternals2 } from "remotion/no-react";

// src/components/call-api.ts
var callApi = (endpoint, body, signal) => {
  return new Promise((resolve, reject) => {
    fetch(endpoint, {
      method: "post",
      headers: {
        "content-type": "application/json"
      },
      signal,
      body: JSON.stringify(body)
    }).then((res) => res.json()).then((data) => {
      if (data.success) {
        resolve(data.data);
      } else {
        reject(new Error(data.error));
      }
    }).catch((err) => {
      reject(err);
    });
  });
};

// src/components/RenderQueue/actions.ts
var addStillRenderJob = ({
  compositionId,
  outName,
  imageFormat,
  jpegQuality,
  frame,
  scale,
  logLevel,
  chromiumOptions,
  delayRenderTimeout,
  envVariables,
  inputProps,
  offthreadVideoCacheSizeInBytes,
  offthreadVideoThreads,
  multiProcessOnLinux,
  beepOnFinish,
  metadata,
  chromeMode
}) => {
  return callApi("/api/render", {
    compositionId,
    type: "still",
    outName,
    imageFormat,
    jpegQuality,
    frame,
    scale,
    logLevel,
    chromiumOptions,
    delayRenderTimeout,
    envVariables,
    serializedInputPropsWithCustomSchema: NoReactInternals2.serializeJSONWithSpecialTypes({
      data: inputProps,
      staticBase: window.remotion_staticBase,
      indent: undefined
    }).serializedString,
    offthreadVideoCacheSizeInBytes,
    offthreadVideoThreads,
    multiProcessOnLinux,
    beepOnFinish,
    metadata,
    chromeMode
  });
};
var addSequenceRenderJob = ({
  compositionId,
  outName,
  imageFormat,
  startFrame,
  endFrame,
  scale,
  logLevel,
  chromiumOptions,
  delayRenderTimeout,
  envVariables,
  inputProps,
  concurrency,
  offthreadVideoCacheSizeInBytes,
  offthreadVideoThreads,
  jpegQuality,
  disallowParallelEncoding,
  multiProcessOnLinux,
  beepOnFinish,
  repro,
  metadata,
  chromeMode
}) => {
  return callApi("/api/render", {
    compositionId,
    type: "sequence",
    outName,
    imageFormat,
    jpegQuality,
    scale,
    startFrame,
    endFrame,
    logLevel,
    chromiumOptions,
    delayRenderTimeout,
    envVariables,
    concurrency,
    serializedInputPropsWithCustomSchema: NoReactInternals2.serializeJSONWithSpecialTypes({
      data: inputProps,
      staticBase: window.remotion_staticBase,
      indent: undefined
    }).serializedString,
    offthreadVideoCacheSizeInBytes,
    offthreadVideoThreads,
    disallowParallelEncoding,
    multiProcessOnLinux,
    beepOnFinish,
    repro,
    metadata,
    chromeMode
  });
};
var addVideoRenderJob = ({
  compositionId,
  outName,
  imageFormat,
  jpegQuality,
  scale,
  logLevel,
  codec,
  concurrency,
  crf,
  startFrame,
  endFrame,
  muted,
  enforceAudioTrack,
  proResProfile,
  x264Preset,
  pixelFormat,
  audioBitrate,
  videoBitrate,
  everyNthFrame,
  numberOfGifLoops,
  delayRenderTimeout,
  audioCodec,
  disallowParallelEncoding,
  chromiumOptions,
  envVariables,
  inputProps,
  offthreadVideoCacheSizeInBytes,
  offthreadVideoThreads,
  colorSpace,
  multiProcessOnLinux,
  encodingMaxRate,
  encodingBufferSize,
  beepOnFinish,
  repro,
  forSeamlessAacConcatenation,
  separateAudioTo,
  metadata,
  hardwareAcceleration,
  chromeMode
}) => {
  return callApi("/api/render", {
    compositionId,
    type: "video",
    outName,
    imageFormat,
    jpegQuality,
    scale,
    logLevel,
    codec,
    concurrency,
    crf,
    endFrame,
    startFrame,
    muted,
    enforceAudioTrack,
    proResProfile,
    x264Preset,
    pixelFormat,
    audioBitrate,
    videoBitrate,
    everyNthFrame,
    numberOfGifLoops,
    delayRenderTimeout,
    audioCodec,
    disallowParallelEncoding,
    chromiumOptions,
    envVariables,
    serializedInputPropsWithCustomSchema: NoReactInternals2.serializeJSONWithSpecialTypes({
      data: inputProps,
      staticBase: window.remotion_staticBase,
      indent: undefined
    }).serializedString,
    offthreadVideoCacheSizeInBytes,
    offthreadVideoThreads,
    colorSpace,
    multiProcessOnLinux,
    encodingBufferSize,
    encodingMaxRate,
    beepOnFinish,
    repro,
    forSeamlessAacConcatenation,
    separateAudioTo,
    metadata,
    hardwareAcceleration,
    chromeMode
  });
};
var unsubscribeFromFileExistenceWatcher = ({
  file,
  clientId
}) => {
  return callApi("/api/unsubscribe-from-file-existence", { file, clientId });
};
var subscribeToFileExistenceWatcher = async ({
  file,
  clientId
}) => {
  const { exists } = await callApi("/api/subscribe-to-file-existence", {
    file,
    clientId
  });
  return exists;
};
var openInFileExplorer = ({ directory }) => {
  const body = {
    directory
  };
  return callApi("/api/open-in-file-explorer", body);
};
var applyCodemod = ({
  codemod,
  dryRun,
  signal
}) => {
  const body = {
    codemod,
    dryRun
  };
  return callApi("/api/apply-codemod", body, signal);
};
var removeRenderJob = (job) => {
  return callApi("/api/remove-render", {
    jobId: job.id
  });
};
var cancelRenderJob = (job) => {
  return callApi("/api/cancel", {
    jobId: job.id
  });
};
var updateAvailable = (signal) => {
  return callApi("/api/update-available", {}, signal);
};
var getProjectInfo = (signal) => {
  return callApi("/api/project-info", {}, signal);
};
var callUpdateDefaultPropsApi = (compositionId, defaultProps, enumPaths) => {
  return callApi("/api/update-default-props", {
    compositionId,
    defaultProps: NoReactInternals2.serializeJSONWithSpecialTypes({
      data: defaultProps,
      indent: undefined,
      staticBase: window.remotion_staticBase
    }).serializedString,
    enumPaths
  });
};
var canUpdateDefaultProps = (compositionId, readOnlyStudio) => {
  if (readOnlyStudio) {
    return Promise.resolve({
      canUpdate: false,
      reason: "Read-only studio"
    });
  }
  return callApi("/api/can-update-default-props", {
    compositionId
  });
};
var applyVisualControlChange = ({
  fileName,
  changes
}) => {
  return callApi("/api/apply-visual-control-change", {
    fileName,
    changes
  });
};

// src/components/AssetSelectorItem.tsx
import { jsx as jsx35, jsxs as jsxs9, Fragment as Fragment5 } from "react/jsx-runtime";
var ASSET_ITEM_HEIGHT = 32;
var iconStyle2 = {
  width: 18,
  height: 18,
  flexShrink: 0
};
var itemStyle2 = {
  paddingRight: 10,
  paddingTop: 6,
  paddingBottom: 6,
  fontSize: 13,
  display: "flex",
  textDecoration: "none",
  cursor: "default",
  alignItems: "center",
  marginBottom: 1,
  appearance: "none",
  border: "none",
  width: "100%",
  textAlign: "left",
  backgroundColor: BACKGROUND,
  height: ASSET_ITEM_HEIGHT,
  userSelect: "none",
  WebkitUserSelect: "none"
};
var labelStyle3 = {
  textAlign: "left",
  textDecoration: "none",
  fontSize: 13,
  flex: "1 1 0%",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis"
};
var revealIconStyle = {
  height: 12,
  color: "currentColor"
};
var AssetFolderItem = ({
  tabIndex,
  item,
  level,
  parentFolder,
  toggleFolder,
  dropLocation,
  setDropLocation
}) => {
  const [hovered, setHovered] = useState15(false);
  const openFolderTimerRef = useRef11(null);
  const { isDropDiv, onDragEnter, onDragLeave } = use_asset_drag_events_default({
    name: item.name,
    parentFolder,
    dropLocation,
    setDropLocation
  });
  const onPointerEnter = useCallback17(() => {
    setHovered(true);
  }, []);
  const onPointerLeave = useCallback17(() => {
    setHovered(false);
  }, []);
  const folderStyle = useMemo23(() => {
    return {
      ...itemStyle2,
      paddingLeft: 4 + level * 8,
      backgroundColor: hovered ? CLEAR_HOVER : "transparent"
    };
  }, [hovered, level]);
  const label = useMemo23(() => {
    return {
      ...labelStyle3,
      color: hovered ? "white" : LIGHT_TEXT
    };
  }, [hovered]);
  const onClick = useCallback17(() => {
    toggleFolder(item.name, parentFolder);
  }, [item.name, parentFolder, toggleFolder]);
  const Icon = item.expanded ? ExpandedFolderIcon : CollapsedFolderIcon;
  return /* @__PURE__ */ jsxs9("div", {
    onDragEnter,
    onDragLeave,
    style: {
      backgroundColor: isDropDiv ? CLEAR_HOVER : BACKGROUND
    },
    children: [
      /* @__PURE__ */ jsx35("div", {
        style: folderStyle,
        onPointerEnter,
        onPointerLeave,
        tabIndex,
        title: item.name,
        onClick,
        onDragEnter: () => {
          if (!item.expanded) {
            openFolderTimerRef.current = window.setTimeout(() => {
              toggleFolder(item.name, parentFolder);
            }, 1000);
          }
        },
        onDragLeave: () => {
          if (openFolderTimerRef.current) {
            clearTimeout(openFolderTimerRef.current);
          }
        },
        children: /* @__PURE__ */ jsxs9(Row, {
          children: [
            /* @__PURE__ */ jsx35(Icon, {
              style: iconStyle2,
              color: hovered ? "white" : LIGHT_TEXT
            }),
            /* @__PURE__ */ jsx35(Spacing, {
              x: 1
            }),
            /* @__PURE__ */ jsx35("div", {
              style: label,
              children: item.name
            })
          ]
        })
      }),
      item.expanded ? /* @__PURE__ */ jsx35(AssetFolderTree, {
        item: item.items,
        name: item.name,
        level,
        parentFolder,
        tabIndex,
        toggleFolder,
        dropLocation,
        setDropLocation
      }, item.name) : null
    ]
  });
};
var AssetFolderTree = ({
  item,
  level,
  name,
  parentFolder,
  toggleFolder,
  tabIndex,
  dropLocation,
  setDropLocation
}) => {
  const combinedParents = useMemo23(() => {
    return [parentFolder, name].filter(NoReactInternals3.truthy).join("/");
  }, [name, parentFolder]);
  return /* @__PURE__ */ jsxs9("div", {
    children: [
      item.folders.map((folder) => {
        return /* @__PURE__ */ jsx35(AssetFolderItem, {
          item: folder,
          tabIndex,
          level: level + 1,
          parentFolder: combinedParents,
          toggleFolder,
          dropLocation,
          setDropLocation
        }, folder.name);
      }),
      item.files.map((file) => {
        return /* @__PURE__ */ jsx35(AssetSelectorItem, {
          item: file,
          tabIndex,
          level,
          parentFolder: combinedParents
        }, file.src);
      })
    ]
  });
};
var AssetSelectorItem = ({ item, tabIndex, level, parentFolder }) => {
  const isMobileLayout = useMobileLayout();
  const [hovered, setHovered] = useState15(false);
  const { setSidebarCollapsedState } = useContext10(SidebarContext);
  const onPointerEnter = useCallback17(() => {
    setHovered(true);
  }, []);
  const { setCanvasContent } = useContext10(Internals8.CompositionSetters);
  const { canvasContent } = useContext10(Internals8.CompositionManager);
  const selected = useMemo23(() => {
    if (canvasContent && canvasContent.type === "asset") {
      const nameWOParent = canvasContent.asset.split("/").pop();
      return nameWOParent === item.name;
    }
    return false;
  }, [canvasContent, item.name]);
  const onPointerLeave = useCallback17(() => {
    setHovered(false);
  }, []);
  const onClick = useCallback17(() => {
    const relativePath = parentFolder ? parentFolder + "/" + item.name : item.name;
    setCanvasContent({ type: "asset", asset: relativePath });
    pushUrl(`/assets/${relativePath}`);
    if (isMobileLayout) {
      setSidebarCollapsedState({ left: "collapsed", right: "collapsed" });
    }
  }, [
    isMobileLayout,
    item.name,
    parentFolder,
    setCanvasContent,
    setSidebarCollapsedState
  ]);
  const style = useMemo23(() => {
    return {
      ...itemStyle2,
      color: hovered || selected ? "white" : LIGHT_TEXT,
      backgroundColor: hovered ? selected ? SELECTED_BACKGROUND : CLEAR_HOVER : selected ? SELECTED_BACKGROUND : "transparent",
      paddingLeft: 12 + level * 8
    };
  }, [hovered, level, selected]);
  const label = useMemo23(() => {
    return {
      ...labelStyle3,
      color: hovered || selected ? "white" : LIGHT_TEXT
    };
  }, [hovered, selected]);
  const renderFileExplorerAction = useCallback17((color) => {
    return /* @__PURE__ */ jsx35(ExpandedFolderIcon, {
      style: revealIconStyle,
      color
    });
  }, []);
  const renderCopyAction = useCallback17((color) => {
    return /* @__PURE__ */ jsx35(ClipboardIcon, {
      style: revealIconStyle,
      color
    });
  }, []);
  const revealInExplorer = React24.useCallback((e) => {
    e.stopPropagation();
    openInFileExplorer({
      directory: window.remotion_publicFolderExists + "/" + parentFolder + "/" + item.name
    }).catch((err) => {
      showNotification(`Could not open file: ${err.message}`, 2000);
    });
  }, [item.name, parentFolder]);
  const copyToClipboard = useCallback17((e) => {
    e.stopPropagation();
    const content = `staticFile("${[parentFolder, item.name].join("/")}")`;
    copyText(content).then(() => {
      showNotification(`Copied '${content}' to clipboard`, 1000);
    }).catch((err) => {
      showNotification(`Could not copy: ${err.message}`, 2000);
    });
  }, [item.name, parentFolder]);
  return /* @__PURE__ */ jsx35(Row, {
    align: "center",
    children: /* @__PURE__ */ jsxs9("div", {
      style,
      onPointerEnter,
      onPointerLeave,
      onClick,
      tabIndex,
      title: item.name,
      children: [
        /* @__PURE__ */ jsx35(FileIcon, {
          style: iconStyle2,
          color: LIGHT_TEXT
        }),
        /* @__PURE__ */ jsx35(Spacing, {
          x: 1
        }),
        /* @__PURE__ */ jsx35("div", {
          style: label,
          children: item.name
        }),
        hovered ? /* @__PURE__ */ jsxs9(Fragment5, {
          children: [
            /* @__PURE__ */ jsx35(Spacing, {
              x: 0.5
            }),
            /* @__PURE__ */ jsx35(InlineAction, {
              title: "Copy staticFile() name",
              renderAction: renderCopyAction,
              onClick: copyToClipboard
            }),
            /* @__PURE__ */ jsx35(Spacing, {
              x: 0.5
            }),
            /* @__PURE__ */ jsx35(InlineAction, {
              title: "Open in Explorer",
              renderAction: renderFileExplorerAction,
              onClick: revealInExplorer
            })
          ]
        }) : null
      ]
    })
  });
};

// src/components/AssetSelector.tsx
import { jsx as jsx36, jsxs as jsxs10 } from "react/jsx-runtime";
var container8 = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  overflow: "hidden",
  backgroundColor: BACKGROUND
};
var emptyState = {
  display: "flex",
  flex: 1,
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  padding: "0 12px"
};
var label = {
  color: LIGHT_TEXT,
  lineHeight: 1.5,
  fontSize: 14
};
var list = {
  height: "100%",
  overflowY: "auto"
};
var AssetSelector = ({ readOnlyStudio }) => {
  const { tabIndex } = useZIndex();
  const { assetFoldersExpanded, setAssetFoldersExpanded } = useContext11(FolderContext);
  const [dropLocation, setDropLocation] = useState16(null);
  const { subscribeToEvent } = useContext11(StudioServerConnectionCtx);
  const connectionStatus = useContext11(StudioServerConnectionCtx).previewServerState.type;
  const shouldAllowUpload = connectionStatus === "connected" && !readOnlyStudio;
  const [{ publicFolderExists, staticFiles }, setState] = React25.useState(() => {
    return {
      staticFiles: getStaticFiles(),
      publicFolderExists: window.remotion_publicFolderExists
    };
  });
  const assetTree = useMemo24(() => {
    return buildAssetFolderStructure(staticFiles, null, assetFoldersExpanded);
  }, [assetFoldersExpanded, staticFiles]);
  useEffect12(() => {
    const onUpdate = () => {
      setState({
        staticFiles: getStaticFiles(),
        publicFolderExists: window.remotion_publicFolderExists
      });
    };
    const unsub = subscribeToEvent("new-public-folder", onUpdate);
    return () => {
      unsub();
    };
  }, [subscribeToEvent]);
  const toggleFolder = useCallback18((folderName, parentName) => {
    setAssetFoldersExpanded((p) => {
      const key = [parentName, folderName].filter(Boolean).join("/");
      const prev = p[key] ?? false;
      const foldersExpandedState = {
        ...p,
        [key]: !prev
      };
      persistExpandedFolders("assets", foldersExpandedState);
      return foldersExpandedState;
    });
  }, [setAssetFoldersExpanded]);
  const { isDropDiv, onDragEnter, onDragLeave } = use_asset_drag_events_default({
    name: null,
    parentFolder: null,
    dropLocation,
    setDropLocation
  });
  const onDragOver = useCallback18((e) => {
    e.preventDefault();
  }, []);
  const onDrop = useCallback18(async (e) => {
    try {
      e.preventDefault();
      e.stopPropagation();
      const { files } = e.dataTransfer;
      const assetPath = dropLocation ?? null;
      const makePath = (file) => {
        return [assetPath, file.name].filter(Boolean).join("/");
      };
      for (const file of files) {
        const body = await file.arrayBuffer();
        await writeStaticFile({
          contents: body,
          filePath: makePath(file)
        });
      }
      if (files.length === 1) {
        showNotification(`Created ${makePath(files[0])}`, 3000);
      } else {
        showNotification(`Added ${files.length} files to ${assetPath}`, 3000);
      }
    } catch (error) {
      showNotification(`Error during upload: ${error}`, 3000);
    } finally {
      setDropLocation(null);
    }
  }, [dropLocation]);
  return /* @__PURE__ */ jsx36("div", {
    style: container8,
    onDragOver: shouldAllowUpload ? onDragOver : undefined,
    onDrop: shouldAllowUpload ? onDrop : undefined,
    children: staticFiles.length === 0 ? publicFolderExists ? /* @__PURE__ */ jsx36("div", {
      style: emptyState,
      children: /* @__PURE__ */ jsxs10("div", {
        style: label,
        children: [
          "To add assets, place a file in the",
          " ",
          /* @__PURE__ */ jsx36("code", {
            style: inlineCodeSnippet,
            children: "public"
          }),
          " folder of your project or drag and drop a file here."
        ]
      })
    }) : /* @__PURE__ */ jsx36("div", {
      style: emptyState,
      children: /* @__PURE__ */ jsxs10("div", {
        style: label,
        children: [
          "To add assets, create a folder called",
          " ",
          /* @__PURE__ */ jsx36("code", {
            style: inlineCodeSnippet,
            children: "public"
          }),
          " in the root of your project and place a file in it."
        ]
      })
    }) : /* @__PURE__ */ jsx36("div", {
      className: "__remotion-vertical-scrollbar",
      style: {
        ...list,
        backgroundColor: isDropDiv ? CLEAR_HOVER : BACKGROUND
      },
      onDragEnter,
      onDragLeave,
      children: /* @__PURE__ */ jsx36(AssetFolderTree, {
        item: assetTree,
        level: 0,
        parentFolder: null,
        name: null,
        tabIndex,
        toggleFolder,
        dropLocation,
        setDropLocation
      })
    })
  });
};

// src/components/CompSelectorRef.tsx
import {
  useCallback as useCallback19,
  useContext as useContext12,
  useImperativeHandle as useImperativeHandle4,
  useMemo as useMemo25,
  useState as useState17
} from "react";
import { Internals as Internals9 } from "remotion";
import { jsx as jsx37 } from "react/jsx-runtime";
var CompSelectorRef = ({ children }) => {
  const { compositions } = useContext12(Internals9.CompositionManager);
  const [foldersExpanded, setFoldersExpanded] = useState17(loadExpandedFolders("compositions"));
  const selectComposition = useSelectComposition();
  const toggleFolder = useCallback19((folderName, parentName) => {
    setFoldersExpanded((p) => {
      const key = openFolderKey({ folderName, parentName });
      const prev = p[key] ?? false;
      const foldersExpandedState = {
        ...p,
        [key]: !prev
      };
      persistExpandedFolders("compositions", foldersExpandedState);
      return foldersExpandedState;
    });
  }, []);
  useImperativeHandle4(Internals9.compositionSelectorRef, () => {
    return {
      expandComposition: (compName) => {
        const compositionToExpand = compositions.find((c) => c.id === compName);
        if (!compositionToExpand) {
          return;
        }
        const { folderName, parentFolderName } = compositionToExpand;
        if (folderName === null) {
          return;
        }
        setFoldersExpanded((previousState) => {
          const foldersExpandedState = {
            ...previousState
          };
          const currentFolder = folderName;
          const currentParentName = parentFolderName;
          const key = openFolderKey({
            folderName: currentFolder,
            parentName: currentParentName
          });
          const splitted = key.split("/");
          for (let i = 0;i < splitted.length - 1; i++) {
            const allExceptLast = i === 0 ? openFolderKey({
              folderName: splitted.filter((s) => s !== "no-parent")[0],
              parentName: null
            }) : splitted.slice(0, i + 1).join("/");
            foldersExpandedState[allExceptLast] = true;
          }
          persistExpandedFolders("compositions", foldersExpandedState);
          return foldersExpandedState;
        });
      },
      selectComposition: (compName) => {
        const comp = compositions.find((c) => c.id === compName);
        if (!comp) {
          throw new Error(`Composition ${compName} not found`);
        }
        selectComposition(comp, true);
      },
      toggleFolder: (folderName, parentName) => {
        toggleFolder(folderName, parentName);
      }
    };
  }, [compositions, selectComposition, toggleFolder]);
  const contextValue = useMemo25(() => {
    return {
      foldersExpanded,
      setFoldersExpanded,
      toggleFolder
    };
  }, [foldersExpanded, setFoldersExpanded, toggleFolder]);
  return /* @__PURE__ */ jsx37(ExpandedFoldersContext.Provider, {
    value: contextValue,
    children
  });
};

// src/components/Tabs/index.tsx
import { useCallback as useCallback20, useMemo as useMemo26, useState as useState18 } from "react";
import { jsx as jsx38 } from "react/jsx-runtime";
var tabsContainer = {
  display: "flex",
  flexDirection: "row"
};
var Tabs = ({ children, style }) => {
  const definiteStyle = useMemo26(() => {
    return {
      ...tabsContainer,
      ...style
    };
  }, [style]);
  return /* @__PURE__ */ jsx38("div", {
    style: definiteStyle,
    children
  });
};
var selectorButton = {
  border: "none",
  flex: 1,
  padding: 4,
  height: 40,
  paddingLeft: 16,
  display: "flex",
  flexDirection: "row",
  fontSize: 14,
  color: "inherit",
  alignItems: "center",
  cursor: "default"
};
var Tab = ({ children, onClick, style, selected }) => {
  const [hovered, setHovered] = useState18(false);
  const { tabIndex } = useZIndex();
  const onPointerEnter = useCallback20(() => {
    setHovered(true);
  }, []);
  const onPointerLeave = useCallback20(() => {
    setHovered(false);
  }, []);
  const definiteStyle = useMemo26(() => ({
    ...selectorButton,
    backgroundColor: selected ? BACKGROUND : hovered ? CLEAR_HOVER : INPUT_BACKGROUND,
    color: selected ? "white" : LIGHT_TEXT,
    borderTop: selected ? "2px solid " + BLUE : "2px solid transparent",
    boxShadow: selected ? "none" : undefined,
    ...style
  }), [hovered, selected, style]);
  return /* @__PURE__ */ jsx38("div", {
    style: definiteStyle,
    role: "button",
    onClick,
    tabIndex,
    onPointerLeave,
    onPointerEnter,
    children
  });
};

// src/components/ExplorerPanel.tsx
import { jsx as jsx39, jsxs as jsxs11 } from "react/jsx-runtime";
var container9 = {
  height: "100%",
  width: "100%",
  maxWidth: "100%",
  display: "flex",
  flexDirection: "column",
  flex: 1
};
var localStorageKey2 = "remotion.sidebarPanel";
var getSelectedPanel = () => {
  const panel = localStorage.getItem(localStorageKey2);
  if (panel === "assets") {
    return "assets";
  }
  return "compositions";
};
var tabsContainer2 = {
  backgroundColor: BACKGROUND
};
var persistSelectedOptionsSidebarPanel = (panel) => {
  localStorage.setItem(localStorageKey2, panel);
};
var explorerSidebarTabs = createRef5();
var ExplorerPanel = ({ readOnlyStudio }) => {
  const [panel, setPanel] = useState19(() => getSelectedPanel());
  const onCompositionsSelected = useCallback21(() => {
    setPanel("compositions");
    persistSelectedOptionsSidebarPanel("compositions");
  }, []);
  const onAssetsSelected = useCallback21(() => {
    setPanel("assets");
    persistSelectedOptionsSidebarPanel("assets");
  }, []);
  useImperativeHandle5(explorerSidebarTabs, () => {
    return {
      selectAssetsPanel: () => {
        setPanel("assets");
        persistSelectedOptionsSidebarPanel("assets");
      },
      selectCompositionPanel: () => {
        setPanel("compositions");
        persistSelectedOptionsSidebarPanel("compositions");
      }
    };
  }, []);
  return /* @__PURE__ */ jsx39(CompSelectorRef, {
    children: /* @__PURE__ */ jsxs11("div", {
      style: container9,
      className: "css-reset",
      children: [
        /* @__PURE__ */ jsx39("div", {
          style: tabsContainer2,
          children: /* @__PURE__ */ jsxs11(Tabs, {
            children: [
              /* @__PURE__ */ jsx39(Tab, {
                selected: panel === "compositions",
                onClick: onCompositionsSelected,
                children: "Compositions"
              }),
              /* @__PURE__ */ jsx39(Tab, {
                selected: panel === "assets",
                onClick: onAssetsSelected,
                children: "Assets"
              })
            ]
          })
        }),
        panel === "compositions" ? /* @__PURE__ */ jsx39(CompositionSelector, {}) : /* @__PURE__ */ jsx39(AssetSelector, {
          readOnlyStudio
        })
      ]
    })
  });
};

// src/components/InitialCompositionLoader.tsx
var useSelectAsset = () => {
  const { setCanvasContent } = useContext13(Internals10.CompositionSetters);
  const { setAssetFoldersExpanded } = useContext13(FolderContext);
  return (asset) => {
    setCanvasContent({ type: "asset", asset });
    explorerSidebarTabs.current?.selectAssetsPanel();
    setAssetFoldersExpanded((ex) => {
      const split = asset.split("/");
      const keysToExpand = split.map((_, i) => {
        return split.slice(0, i).join("/");
      });
      const newState = {
        ...ex
      };
      for (const key of keysToExpand) {
        newState[key] = true;
      }
      return newState;
    });
  };
};
var useSelectComposition = () => {
  const { setCompositionFoldersExpanded } = useContext13(FolderContext);
  const { setCanvasContent } = useContext13(Internals10.CompositionSetters);
  const isMobileLayout = useMobileLayout();
  const { setSidebarCollapsedState } = useContext13(SidebarContext);
  return useCallback22((c, push) => {
    if (push) {
      pushUrl(`/${c.id}`);
    }
    explorerSidebarTabs.current?.selectCompositionPanel();
    setCanvasContent({ type: "composition", compositionId: c.id });
    const { folderName, parentFolderName } = c;
    if (folderName !== null) {
      setCompositionFoldersExpanded((ex) => {
        const keysToExpand = getKeysToExpand(folderName, parentFolderName);
        const newState = {
          ...ex
        };
        for (const key of keysToExpand) {
          newState[key] = true;
        }
        return newState;
      });
      if (isMobileLayout) {
        setSidebarCollapsedState({ left: "collapsed", right: "collapsed" });
      }
    }
  }, [
    isMobileLayout,
    setCanvasContent,
    setCompositionFoldersExpanded,
    setSidebarCollapsedState
  ]);
};
var InitialCompositionLoader = () => {
  const { compositions, canvasContent } = useContext13(Internals10.CompositionManager);
  const { setCanvasContent } = useContext13(Internals10.CompositionSetters);
  const selectComposition = useSelectComposition();
  const selectAsset = useSelectAsset();
  useEffect13(() => {
    if (canvasContent) {
      return;
    }
    const canvasContentFromUrl = deriveCanvasContentFromUrl();
    if (canvasContentFromUrl && canvasContentFromUrl.type === "composition") {
      const exists = compositions.find((c) => c.id === canvasContentFromUrl.compositionId);
      if (exists) {
        selectComposition(exists, false);
      }
      return;
    }
    if (canvasContentFromUrl && canvasContentFromUrl.type === "asset") {
      selectAsset(canvasContentFromUrl.asset);
      return;
    }
    if (canvasContentFromUrl && canvasContentFromUrl.type === "output") {
      setCanvasContent(canvasContentFromUrl);
      return;
    }
    if (compositions.length > 0) {
      selectComposition(compositions[0], true);
    }
  }, [
    compositions,
    canvasContent,
    selectComposition,
    setCanvasContent,
    selectAsset
  ]);
  useEffect13(() => {
    const onchange = () => {
      const newCanvas = deriveCanvasContentFromUrl();
      if (newCanvas && newCanvas.type === "composition") {
        const newComp = getRoute().substring(1);
        const exists = compositions.find((c) => c.id === newComp);
        if (exists) {
          selectComposition(exists, false);
        }
        return;
      }
      if (newCanvas && newCanvas.type === "asset") {
        const staticFiles = getStaticFiles();
        const exists = staticFiles.find((file) => {
          return file.name === newCanvas.asset;
        });
        if (exists) {
          setCanvasContent(newCanvas);
        }
        return;
      }
      setCanvasContent(newCanvas);
    };
    window.addEventListener("popstate", onchange);
    return () => window.removeEventListener("popstate", onchange);
  }, [compositions, selectComposition, setCanvasContent]);
  return null;
};

// src/components/MenuToolbar.tsx
import { useCallback as useCallback93, useMemo as useMemo97, useState as useState61 } from "react";

// src/helpers/use-menu-structure.tsx
import { useContext as useContext20, useMemo as useMemo37 } from "react";
import { Internals as Internals15 } from "remotion";
import { NoReactInternals as NoReactInternals5 } from "remotion/no-react";

// src/api/restart-studio.ts
import { getRemotionEnvironment } from "remotion";
var restartStudio = () => {
  if (!getRemotionEnvironment().isStudio) {
    throw new Error("restartStudio() is only available in the Studio");
  }
  if (window.remotion_isReadOnlyStudio) {
    throw new Error("restartStudio() is not available in read-only Studio");
  }
  return callApi("/api/restart-studio", {});
};

// src/components/AskAiModal.tsx
import {
  createRef as createRef6,
  useCallback as useCallback24,
  useEffect as useEffect14,
  useImperativeHandle as useImperativeHandle6,
  useRef as useRef12,
  useState as useState20
} from "react";
import { AbsoluteFill } from "remotion";

// src/components/ModalContainer.tsx
import { jsx as jsx40 } from "react/jsx-runtime";
var padding = 20;
var getMaxModalWidth = (width) => {
  return `min(calc(100vw - ${padding * 2}px), calc(${width}px - ${padding * 2}px))`;
};
var getMaxModalHeight = (height) => {
  return `min(calc(100vh - ${padding * 2}px), calc(${height}px - ${padding * 2}px))`;
};
var backgroundOverlay = {
  backgroundColor: "rgba(255, 255, 255, 0.2)",
  backdropFilter: `blur(1px)`,
  position: "fixed",
  height: "100%",
  width: "100%",
  display: "flex",
  padding
};
var panel = {
  backgroundColor: BACKGROUND,
  boxShadow: "0 0 4px black",
  color: "white",
  margin: "auto"
};
var ModalContainer = ({ children, onEscape, onOutsideClick, noZIndex }) => {
  return /* @__PURE__ */ jsx40("div", {
    className: "css-reset",
    style: backgroundOverlay,
    role: "dialog",
    "aria-modal": "true",
    children: /* @__PURE__ */ jsx40(HigherZIndex, {
      disabled: noZIndex,
      onOutsideClick,
      onEscape,
      children: /* @__PURE__ */ jsx40("div", {
        style: panel,
        children
      })
    })
  });
};

// src/components/ModalHeader.tsx
import { useCallback as useCallback23, useContext as useContext14 } from "react";

// src/components/NewComposition/CancelButton.tsx
import { jsx as jsx41 } from "react/jsx-runtime";
var style = {
  appearance: "none",
  border: "none",
  backgroundColor: "transparent",
  color: "white",
  cursor: "pointer",
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center"
};
var CancelButton = ({ onPress, ...props }) => {
  const { tabIndex } = useZIndex();
  return /* @__PURE__ */ jsx41("button", {
    tabIndex,
    style,
    type: "button",
    onClick: onPress,
    children: /* @__PURE__ */ jsx41("svg", {
      viewBox: "0 0 320 512",
      ...props,
      children: /* @__PURE__ */ jsx41("path", {
        fill: "currentColor",
        d: "M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z"
      })
    })
  });
};

// src/components/ModalHeader.tsx
import { jsx as jsx42, jsxs as jsxs12 } from "react/jsx-runtime";
var container10 = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  padding: "12px 16px",
  width: "100%",
  borderBottom: "1px solid black"
};
var titleStyle = {
  fontSize: 14,
  color: "white"
};
var icon = {
  height: 20,
  width: 20
};
var ModalHeader = ({ title: title2, onClose }) => {
  const { setSelectedModal } = useContext14(ModalsContext);
  const onPress = useCallback23(() => {
    setSelectedModal(null);
  }, [setSelectedModal]);
  return /* @__PURE__ */ jsxs12("div", {
    style: container10,
    children: [
      /* @__PURE__ */ jsx42("div", {
        style: titleStyle,
        children: title2
      }),
      /* @__PURE__ */ jsx42(Flex, {}),
      /* @__PURE__ */ jsx42(CancelButton, {
        style: icon,
        onPress: onClose ?? onPress
      })
    ]
  });
};

// src/components/AskAiModal.tsx
import { jsx as jsx43, jsxs as jsxs13 } from "react/jsx-runtime";
var container11 = {
  height: "calc(100vh - 100px)",
  width: "calc(100vw - 160px)",
  maxWidth: 800,
  maxHeight: 900,
  display: "block"
};
var askAiModalRef = createRef6();
var AskAiModal = () => {
  const [state, setState] = useState20("never-opened");
  const iframe = useRef12(null);
  useImperativeHandle6(askAiModalRef, () => ({
    toggle: () => {
      setState((s) => {
        if (s === "visible") {
          iframe.current?.blur();
          iframe.current?.contentWindow?.blur();
        }
        return s === "visible" ? "hidden" : "visible";
      });
    }
  }), []);
  useEffect14(() => {
    const onMessage = (event) => {
      try {
        const json = typeof event.data === "string" ? JSON.parse(event.data) : event.data;
        if (json.type === "cmd-i") {
          askAiModalRef.current?.toggle();
        }
      } catch {}
    };
    window.addEventListener("message", onMessage);
    return () => {
      window.removeEventListener("message", onMessage);
    };
  }, []);
  const onQuit = useCallback24(() => {
    setState("hidden");
  }, [setState]);
  useEffect14(() => {
    if (!iframe.current) {
      return;
    }
    if (state === "visible") {
      iframe.current.contentWindow?.postMessage({
        type: "focus"
      }, "*");
    }
  }, [state]);
  if (state === "never-opened") {
    return null;
  }
  return /* @__PURE__ */ jsx43(AbsoluteFill, {
    style: { display: state === "visible" ? "block" : "none" },
    children: /* @__PURE__ */ jsxs13(ModalContainer, {
      noZIndex: state === "hidden",
      onOutsideClick: onQuit,
      onEscape: onQuit,
      children: [
        /* @__PURE__ */ jsx43(ModalHeader, {
          title: "Ask AI",
          onClose: onQuit
        }),
        /* @__PURE__ */ jsx43("iframe", {
          ref: iframe,
          frameBorder: 0,
          style: container11,
          src: "https://www.remotion.dev/ai-embed",
          allow: "clipboard-read; clipboard-write"
        })
      ]
    })
  });
};

// src/components/SizeSelector.tsx
import { useContext as useContext18, useMemo as useMemo33 } from "react";
import { Internals as Internals12 } from "remotion";

// src/icons/Checkmark.tsx
import { jsx as jsx44 } from "react/jsx-runtime";
var style2 = {
  width: 14,
  height: 14
};
var Checkmark = () => /* @__PURE__ */ jsx44("svg", {
  focusable: "false",
  role: "img",
  viewBox: "0 0 512 512",
  style: style2,
  children: /* @__PURE__ */ jsx44("path", {
    fill: "currentColor",
    d: "M435.848 83.466L172.804 346.51l-96.652-96.652c-4.686-4.686-12.284-4.686-16.971 0l-28.284 28.284c-4.686 4.686-4.686 12.284 0 16.971l133.421 133.421c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-28.284-28.284c-4.686-4.686-12.284-4.686-16.97 0z"
  })
});

// src/components/ControlButton.tsx
import { useMemo as useMemo27 } from "react";
import { jsx as jsx45 } from "react/jsx-runtime";
var CONTROL_BUTTON_PADDING = 6;
var ControlButton = (props) => {
  const style3 = useMemo27(() => {
    return {
      opacity: props.disabled ? 0.5 : 1,
      display: "inline-flex",
      background: "none",
      border: "none",
      padding: CONTROL_BUTTON_PADDING
    };
  }, [props.disabled]);
  const { tabIndex } = useZIndex();
  return /* @__PURE__ */ jsx45("button", {
    type: "button",
    tabIndex,
    ...props,
    style: style3
  });
};

// src/components/NewComposition/ComboBox.tsx
import { PlayerInternals as PlayerInternals5 } from "@remotion/player";
import { useCallback as useCallback25, useEffect as useEffect15, useMemo as useMemo28, useRef as useRef13, useState as useState21 } from "react";
import ReactDOM4 from "react-dom";
import { jsx as jsx46, jsxs as jsxs14, Fragment as Fragment6 } from "react/jsx-runtime";
var container12 = {
  padding: "8px 10px",
  display: "inline-block",
  backgroundColor: INPUT_BACKGROUND,
  borderWidth: 1,
  borderStyle: "solid",
  maxWidth: "100%"
};
var label2 = {
  flex: 1,
  overflow: "hidden",
  textOverflow: "ellipsis",
  fontSize: 14,
  textAlign: "left"
};
var Combobox = ({ values, selectedId, style: customStyle, title: title2 }) => {
  const [hovered, setIsHovered] = useState21(false);
  const [opened, setOpened] = useState21(false);
  const ref = useRef13(null);
  const { tabIndex, currentZIndex } = useZIndex();
  const size = PlayerInternals5.useElementSize(ref, {
    triggerOnWindowResize: true,
    shouldApplyCssTransforms: true
  });
  const refresh = size?.refresh;
  const onHide = useCallback25(() => {
    setOpened(false);
  }, []);
  useEffect15(() => {
    const { current } = ref;
    if (!current) {
      return;
    }
    const onMouseEnter = () => setIsHovered(true);
    const onMouseLeave = () => setIsHovered(false);
    const onPointerDown = () => {
      return setOpened((o) => {
        if (!o) {
          refresh?.();
        }
        return !o;
      });
    };
    const onClick = (e) => {
      e.stopPropagation();
      const isKeyboardInitiated = e.detail === 0;
      if (!isKeyboardInitiated) {
        return;
      }
      return setOpened((o) => {
        if (!o) {
          refresh?.();
          window.addEventListener("pointerup", (evt) => {
            if (!isMenuItem(evt.target)) {
              setOpened(false);
            }
          }, {
            once: true
          });
        }
        return !o;
      });
    };
    current.addEventListener("mouseenter", onMouseEnter);
    current.addEventListener("mouseleave", onMouseLeave);
    current.addEventListener("pointerdown", onPointerDown);
    current.addEventListener("click", onClick);
    return () => {
      current.removeEventListener("mouseenter", onMouseEnter);
      current.removeEventListener("mouseleave", onMouseLeave);
      current.removeEventListener("pointerdown", onPointerDown);
      current.removeEventListener("click", onClick);
    };
  }, [refresh]);
  const spaceToBottom = useMemo28(() => {
    const margin2 = 10;
    if (size && opened) {
      return size.windowSize.height - (size.top + size.height) - margin2;
    }
    return 0;
  }, [opened, size]);
  const spaceToTop = useMemo28(() => {
    const margin2 = 10;
    if (size && opened) {
      return size.top - margin2;
    }
    return 0;
  }, [opened, size]);
  const derivedMaxHeight = useMemo28(() => {
    return spaceToTop > spaceToBottom ? spaceToTop : spaceToBottom;
  }, [spaceToBottom, spaceToTop]);
  const isMobileLayout = useMobileLayout();
  const portalStyle = useMemo28(() => {
    if (!opened || !size) {
      return null;
    }
    const spaceToRight = size.windowSize.width - size.left;
    const spaceToLeft = size.left + size.width;
    const minSpaceRequired = isMobileLayout ? MAX_MOBILE_MENU_WIDTH : MAX_MENU_WIDTH;
    const verticalLayout = spaceToTop > spaceToBottom ? "bottom" : "top";
    const canOpenOnLeft = spaceToLeft >= minSpaceRequired;
    const canOpenOnRight = spaceToRight >= minSpaceRequired;
    const horizontalLayout = canOpenOnRight ? "left" : "right";
    return {
      ...verticalLayout === "top" ? {
        ...menuContainerTowardsBottom,
        top: size.top + size.height
      } : {
        ...menuContainerTowardsTop,
        bottom: size.windowSize.height - size.top
      },
      ...horizontalLayout === "left" ? {
        left: size.left
      } : canOpenOnLeft ? {
        right: size.windowSize.width - size.left - size.width
      } : { left: 0 }
    };
  }, [isMobileLayout, opened, size, spaceToBottom, spaceToTop]);
  const selected = values.find((v) => v.id === selectedId);
  const style3 = useMemo28(() => {
    return {
      ...container12,
      ...customStyle ?? {},
      userSelect: "none",
      WebkitUserSelect: "none",
      color: "white",
      display: "inline-flex",
      flexDirection: "row",
      alignItems: "center",
      borderColor: opened ? SELECTED_BACKGROUND : hovered ? INPUT_BORDER_COLOR_HOVERED : INPUT_BORDER_COLOR_UNHOVERED
    };
  }, [customStyle, hovered, opened]);
  return /* @__PURE__ */ jsxs14(Fragment6, {
    children: [
      /* @__PURE__ */ jsxs14("button", {
        ref,
        title: title2,
        tabIndex,
        type: "button",
        style: style3,
        className: MENU_INITIATOR_CLASSNAME,
        children: [
          selected ? /* @__PURE__ */ jsx46("div", {
            title: typeof selected.label === "string" ? selected.label : undefined,
            style: label2,
            children: selected?.label
          }) : null,
          /* @__PURE__ */ jsx46(Spacing, {
            x: 1
          }),
          " ",
          /* @__PURE__ */ jsx46(CaretDown, {})
        ]
      }),
      portalStyle ? ReactDOM4.createPortal(/* @__PURE__ */ jsx46("div", {
        style: fullScreenOverlay,
        children: /* @__PURE__ */ jsx46("div", {
          style: outerPortal,
          className: "css-reset",
          children: /* @__PURE__ */ jsx46(HigherZIndex, {
            onOutsideClick: onHide,
            onEscape: onHide,
            children: /* @__PURE__ */ jsx46("div", {
              style: portalStyle,
              children: /* @__PURE__ */ jsx46(MenuContent, {
                onNextMenu: noop,
                onPreviousMenu: noop,
                values,
                onHide,
                leaveLeftSpace: true,
                preselectIndex: values.findIndex((v) => selected && v.id === selected.id),
                topItemCanBeUnselected: false,
                fixedHeight: derivedMaxHeight
              })
            })
          })
        })
      }), getPortal(currentZIndex)) : null
    ]
  });
};

// src/components/Preview.tsx
import { PlayerInternals as PlayerInternals6 } from "@remotion/player";
import { useContext as useContext17, useEffect as useEffect20, useMemo as useMemo32, useRef as useRef16 } from "react";
import { Internals as Internals11 } from "remotion";

// src/helpers/checkerboard-background.ts
var getCheckerboardBackgroundSize = (size) => `${size}px ${size}px`;
var getCheckerboardBackgroundPos = (size) => `0 0, ${size / 2}px 0, ${size / 2}px -${size / 2}px, 0px ${size / 2}px`;
var checkerboardBackgroundColor = (checkerboard) => {
  if (checkerboard) {
    return "white";
  }
  return "black";
};
var checkerboardBackgroundImage = (checkerboard) => {
  if (checkerboard) {
    return `
     linear-gradient(
        45deg,
        rgba(0, 0, 0, 0.1) 25%,
        transparent 25%
      ),
      linear-gradient(135deg, rgba(0, 0, 0, 0.1) 25%, transparent 25%),
      linear-gradient(45deg, transparent 75%, rgba(0, 0, 0, 0.1) 75%),
      linear-gradient(135deg, transparent 75%, rgba(0, 0, 0, 0.1) 75%)
    `;
  }
  return;
};

// src/state/checkerboard.ts
import { createContext as createContext10 } from "react";
var persistCheckerboardOption = (option) => {
  localStorage.setItem("option", String(option));
};
var loadCheckerboardOption = () => {
  const item = localStorage.getItem("option");
  return item !== "false";
};
var CheckerboardContext = createContext10({
  checkerboard: loadCheckerboardOption(),
  setCheckerboard: () => {
    return;
  }
});

// src/components/RenderPreview.tsx
import { useContext as useContext15 } from "react";

// src/helpers/get-asset-metadata.ts
import { getVideoMetadata } from "@remotion/media-utils";
import { staticFile } from "remotion";
var remotion_outputsBase = window.remotion_staticBase.replace("static", "outputs");
var getSrcFromCanvasContent = (canvasContent) => {
  if (canvasContent.type === "asset") {
    return staticFile(canvasContent.asset);
  }
  if (canvasContent.type === "composition") {
    throw new Error("cannot get dimensions for composition");
  }
  return remotion_outputsBase + canvasContent.path;
};
var getAssetMetadata = async (canvasContent, addTime) => {
  const src = getSrcFromCanvasContent(canvasContent);
  const file = await fetch(src, {
    method: "HEAD"
  });
  if (file.status === 404) {
    return { type: "not-found" };
  }
  if (file.status !== 200) {
    throw new Error(`Expected status code 200 or 404 for file, got ${file.status}`);
  }
  const size = file.headers.get("content-length");
  if (!size) {
    throw new Error("Unexpected error: content-length is null");
  }
  const fetchedAt = Date.now();
  const srcWithTime = addTime ? `${src}?date=${fetchedAt}` : src;
  const fileType = getPreviewFileType(src);
  if (fileType === "video") {
    const resolution = await getVideoMetadata(srcWithTime);
    return {
      type: "found",
      size: Number(size),
      dimensions: { width: resolution.width, height: resolution.height },
      fetchedAt
    };
  }
  if (fileType === "image") {
    const resolution = await new Promise((resolve, reject) => {
      const img = new Image;
      img.onload = () => {
        resolve({
          type: "found",
          size: Number(size),
          dimensions: { width: img.width, height: img.height },
          fetchedAt
        });
      };
      img.onerror = () => {
        reject(new Error("Failed to load image"));
      };
      img.src = srcWithTime;
    });
    return resolution;
  }
  return {
    type: "found",
    dimensions: "none",
    size: Number(size),
    fetchedAt
  };
};

// src/components/FilePreview.tsx
import { formatBytes } from "@remotion/studio-shared";

// src/components/JSONViewer.tsx
import { useEffect as useEffect18, useState as useState24 } from "react";

// src/components/NewComposition/RemTextarea.tsx
import {
  forwardRef as forwardRef2,
  useEffect as useEffect17,
  useImperativeHandle as useImperativeHandle8,
  useMemo as useMemo30,
  useRef as useRef15,
  useState as useState23
} from "react";

// src/components/NewComposition/RemInput.tsx
import {
  forwardRef,
  useEffect as useEffect16,
  useImperativeHandle as useImperativeHandle7,
  useMemo as useMemo29,
  useRef as useRef14,
  useState as useState22
} from "react";
import { jsx as jsx47 } from "react/jsx-runtime";
var INPUT_HORIZONTAL_PADDING = 8;
var aligner = {
  marginRight: -INPUT_HORIZONTAL_PADDING
};
var RightAlignInput = ({ children }) => {
  return /* @__PURE__ */ jsx47("div", {
    style: aligner,
    children
  });
};
var inputBaseStyle = {
  padding: `${INPUT_HORIZONTAL_PADDING}px 10px`,
  color: "white",
  borderStyle: "solid",
  borderWidth: 1,
  fontSize: 14
};
var getInputBorderColor = ({
  status,
  isFocused,
  isHovered
}) => status === "warning" ? WARNING_COLOR : status === "error" ? FAIL_COLOR : isFocused ? SELECTED_BACKGROUND : isHovered ? INPUT_BORDER_COLOR_HOVERED : INPUT_BORDER_COLOR_UNHOVERED;
var RemInputForwardRef = ({ status, rightAlign, ...props }, ref) => {
  const [isFocused, setIsFocused] = useState22(false);
  const [isHovered, setIsHovered] = useState22(false);
  const inputRef = useRef14(null);
  const { tabIndex } = useZIndex();
  const style3 = useMemo29(() => {
    return {
      backgroundColor: INPUT_BACKGROUND,
      ...inputBaseStyle,
      width: "100%",
      borderColor: getInputBorderColor({ isFocused, isHovered, status }),
      textAlign: rightAlign ? "right" : "left",
      ...props.style ?? {}
    };
  }, [isFocused, isHovered, rightAlign, props.style, status]);
  useImperativeHandle7(ref, () => {
    return inputRef.current;
  }, []);
  useEffect16(() => {
    if (!inputRef.current) {
      return;
    }
    const { current } = inputRef;
    const onFocus = () => setIsFocused(true);
    const onBlur = () => setIsFocused(false);
    const onMouseEnter = () => setIsHovered(true);
    const onMouseLeave = () => setIsHovered(false);
    current.addEventListener("focus", onFocus);
    current.addEventListener("blur", onBlur);
    current.addEventListener("mouseenter", onMouseEnter);
    current.addEventListener("mouseleave", onMouseLeave);
    return () => {
      current.removeEventListener("focus", onFocus);
      current.removeEventListener("blur", onBlur);
      current.removeEventListener("mouseenter", onMouseEnter);
      current.removeEventListener("mouseleave", onMouseLeave);
    };
  }, [inputRef]);
  return /* @__PURE__ */ jsx47("input", {
    ref: inputRef,
    tabIndex,
    ...props,
    style: style3
  });
};
var RemotionInput = forwardRef(RemInputForwardRef);

// src/components/NewComposition/RemTextarea.tsx
import { jsx as jsx48 } from "react/jsx-runtime";
var inputBaseStyle2 = {
  padding: `${INPUT_HORIZONTAL_PADDING}px 10px`,
  color: "white",
  borderStyle: "solid",
  borderWidth: 1,
  fontSize: 14,
  resize: "none",
  overflowX: "hidden"
};
var RemTextareaFRFunction = ({ status, ...props }, ref) => {
  const [isFocused, setIsFocused] = useState23(false);
  const [isHovered, setIsHovered] = useState23(false);
  const inputRef = useRef15(null);
  const { tabIndex } = useZIndex();
  useImperativeHandle8(ref, () => {
    return inputRef.current;
  }, []);
  const style3 = useMemo30(() => {
    return {
      backgroundColor: INPUT_BACKGROUND,
      ...inputBaseStyle2,
      width: "100%",
      borderColor: getInputBorderColor({ isFocused, isHovered, status }),
      ...props.style ?? {}
    };
  }, [isFocused, isHovered, props.style, status]);
  useEffect17(() => {
    if (!inputRef.current) {
      return;
    }
    const { current } = inputRef;
    const onFocus = () => setIsFocused(true);
    const onBlur = () => setIsFocused(false);
    const onMouseEnter = () => setIsHovered(true);
    const onMouseLeave = () => setIsHovered(false);
    const onKeyDown = (e) => {
      if (!inputRef.current) {
        return;
      }
      if (inputRef.current !== document.activeElement) {
        return;
      }
      if (e.code === "Tab") {
        e.preventDefault();
        document.execCommand("insertText", false, " ".repeat(2));
      }
      if (e.code === "Enter") {
        e.preventDefault();
        const { selectionStart, selectionEnd, value } = inputRef.current;
        if (selectionStart !== selectionEnd) {
          return;
        }
        let prevNewline = selectionStart;
        for (let i = selectionStart - 1;i >= 0; i--) {
          if (value[i] === `
`) {
            break;
          }
          prevNewline = i;
        }
        const currentLine = value.substring(prevNewline, selectionStart);
        const trimmed = currentLine.trim();
        const difference = currentLine.length - trimmed.length;
        document.execCommand("insertText", false, `
` + " ".repeat(difference));
      }
    };
    current.addEventListener("focus", onFocus);
    current.addEventListener("blur", onBlur);
    current.addEventListener("mouseenter", onMouseEnter);
    current.addEventListener("mouseleave", onMouseLeave);
    current.addEventListener("keydown", onKeyDown);
    return () => {
      current.removeEventListener("focus", onFocus);
      current.removeEventListener("blur", onBlur);
      current.removeEventListener("mouseenter", onMouseEnter);
      current.removeEventListener("mouseleave", onMouseLeave);
      current.removeEventListener("keydown", onKeyDown);
    };
  }, [inputRef]);
  return /* @__PURE__ */ jsx48("textarea", {
    ref: inputRef,
    tabIndex,
    ...props,
    className: VERTICAL_SCROLLBAR_CLASSNAME,
    style: style3
  });
};
var RemTextarea = forwardRef2(RemTextareaFRFunction);

// src/components/JSONViewer.tsx
import { jsx as jsx49 } from "react/jsx-runtime";
var jsonStyle = {
  marginTop: 14,
  marginBottom: 14,
  fontFamily: "monospace",
  flex: 1
};
var JSONViewer = ({ src }) => {
  const [json, setJson] = useState24(null);
  useEffect18(() => {
    fetch(src).then((res) => res.json()).then((jsonRes) => {
      setJson(JSON.stringify(jsonRes, null, 2));
    });
  }, [src]);
  return /* @__PURE__ */ jsx49(RemTextarea, {
    value: json ?? undefined,
    status: "ok",
    onChange: () => {
      return null;
    },
    style: jsonStyle
  });
};

// src/components/TextViewer.tsx
import { useEffect as useEffect19, useState as useState25 } from "react";
import { jsxs as jsxs15 } from "react/jsx-runtime";
var textStyle = {
  margin: 14,
  fontFamily: "monospace",
  flex: 1,
  color: "white",
  whiteSpace: "pre-wrap"
};
var TextViewer = ({ src }) => {
  const [txt, setTxt] = useState25("");
  useEffect19(() => {
    fetch(src).then(async (res) => {
      if (!res.ok || !res.body) {
        return;
      }
      const text = await res.text();
      setTxt(text);
    });
  }, [src]);
  return /* @__PURE__ */ jsxs15("div", {
    style: textStyle,
    children: [
      txt,
      " "
    ]
  });
};

// src/components/FilePreview.tsx
import { jsx as jsx50, jsxs as jsxs16, Fragment as Fragment7 } from "react/jsx-runtime";
var msgStyle = {
  fontSize: 13,
  color: "white",
  fontFamily: "sans-serif",
  display: "flex",
  justifyContent: "center"
};
var FilePreview = ({ fileType, src, currentAsset, assetMetadata }) => {
  if (!assetMetadata) {
    throw new Error("expected to have assetMetadata");
  }
  if (assetMetadata.type === "not-found") {
    throw new Error('expected to have assetMetadata, got "not-found"');
  }
  if (fileType === "audio") {
    return /* @__PURE__ */ jsx50("audio", {
      src,
      controls: true
    });
  }
  if (fileType === "video") {
    return /* @__PURE__ */ jsx50("video", {
      src,
      controls: true
    });
  }
  if (fileType === "image") {
    return /* @__PURE__ */ jsx50("img", {
      src
    });
  }
  if (fileType === "json") {
    return /* @__PURE__ */ jsx50(JSONViewer, {
      src
    });
  }
  if (fileType === "txt") {
    return /* @__PURE__ */ jsx50(TextViewer, {
      src
    });
  }
  return /* @__PURE__ */ jsxs16(Fragment7, {
    children: [
      /* @__PURE__ */ jsx50("div", {
        style: msgStyle,
        children: currentAsset
      }),
      /* @__PURE__ */ jsx50(Spacing, {
        y: 0.5
      }),
      /* @__PURE__ */ jsxs16("div", {
        style: msgStyle,
        children: [
          "Size: ",
          formatBytes(assetMetadata.size),
          " "
        ]
      })
    ]
  });
};

// src/components/RenderPreview.tsx
import { jsx as jsx51 } from "react/jsx-runtime";
var msgStyle2 = {
  fontSize: 13,
  color: "white",
  fontFamily: "sans-serif",
  display: "flex",
  justifyContent: "center"
};
var errMsgStyle = {
  ...msgStyle2,
  color: LIGHT_TEXT
};
var RenderPreview = ({ path, assetMetadata }) => {
  const fileType = getPreviewFileType(path);
  const src = remotion_outputsBase + path;
  const connectionStatus = useContext15(StudioServerConnectionCtx).previewServerState.type;
  if (connectionStatus === "disconnected") {
    return /* @__PURE__ */ jsx51("div", {
      style: errMsgStyle,
      children: "Studio server disconnected"
    });
  }
  return /* @__PURE__ */ jsx51(FilePreview, {
    assetMetadata,
    currentAsset: path,
    fileType,
    src
  });
};

// src/components/Spinner.tsx
import { useMemo as useMemo31 } from "react";
import { jsx as jsx52, jsxs as jsxs17, Fragment as Fragment8 } from "react/jsx-runtime";
var viewBox = 100;
var lines = 8;
var className = "__remotion_spinner_line";
var remotionSpinnerAnimation = "__remotion_spinner_animation";
var translated = "M 44 0 L 50 0 a 6 6 0 0 1 6 6 L 56 26 a 6 6 0 0 1 -6 6 L 50 32 a 6 6 0 0 1 -6 -6 L 44 6 a 6 6 0 0 1 6 -6 Z";
var Spinner = ({ size, duration }) => {
  const style3 = useMemo31(() => {
    return {
      width: size,
      height: size
    };
  }, [size]);
  return /* @__PURE__ */ jsxs17(Fragment8, {
    children: [
      /* @__PURE__ */ jsx52("style", {
        type: "text/css",
        children: `
				@keyframes ${remotionSpinnerAnimation} {
          0% {
            opacity: 1;
          }
          100% {
            opacity: 0.15;
          }
        }
        
        .${className} {
            animation: ${remotionSpinnerAnimation} ${duration}s linear infinite;
        }        
			`
      }),
      /* @__PURE__ */ jsx52("svg", {
        style: style3,
        viewBox: `0 0 ${viewBox} ${viewBox}`,
        children: new Array(lines).fill(true).map((_, index) => {
          return /* @__PURE__ */ jsx52("path", {
            className,
            style: {
              rotate: `${index * Math.PI * 2 / lines}rad`,
              transformOrigin: "center center",
              animationDelay: `${index * (duration / lines) - duration}s`
            },
            d: translated,
            fill: LIGHT_TEXT
          }, index);
        })
      })
    ]
  });
};

// src/components/StaticFilePreview.tsx
import { useContext as useContext16 } from "react";
import { staticFile as staticFile2 } from "remotion";
import { jsx as jsx53, jsxs as jsxs18 } from "react/jsx-runtime";
var msgStyle3 = {
  fontSize: 13,
  color: "white",
  fontFamily: "sans-serif",
  display: "flex",
  justifyContent: "center"
};
var errMsgStyle2 = {
  ...msgStyle3,
  color: LIGHT_TEXT
};
var StaticFilePreview = ({ currentAsset, assetMetadata }) => {
  const fileType = getPreviewFileType(currentAsset);
  const staticFileSrc = staticFile2(currentAsset);
  const staticFiles = getStaticFiles();
  const connectionStatus = useContext16(StudioServerConnectionCtx).previewServerState.type;
  const exists = staticFiles.find((file) => file.name === currentAsset);
  if (connectionStatus === "disconnected") {
    return /* @__PURE__ */ jsx53("div", {
      style: errMsgStyle2,
      children: "Studio server disconnected"
    });
  }
  if (!exists) {
    return /* @__PURE__ */ jsxs18("div", {
      style: errMsgStyle2,
      children: [
        currentAsset,
        " does not exist in your public folder."
      ]
    });
  }
  if (!currentAsset) {
    return null;
  }
  return /* @__PURE__ */ jsx53(FilePreview, {
    currentAsset,
    fileType,
    src: `${staticFileSrc}?date=${assetMetadata && assetMetadata.type === "found" ? assetMetadata.fetchedAt : 0}`,
    assetMetadata
  });
};

// src/components/Preview.tsx
import { jsx as jsx54 } from "react/jsx-runtime";
var centeredContainer = {
  display: "flex",
  flex: 1,
  justifyContent: "center",
  alignItems: "center"
};
var label3 = {
  fontFamily: "sans-serif",
  fontSize: 14,
  color: LIGHT_TEXT
};
var getPreviewFileType = (fileName) => {
  if (!fileName) {
    return "other";
  }
  const audioExtensions = ["mp3", "wav", "ogg", "aac"];
  const videoExtensions = ["mp4", "avi", "mkv", "mov", "webm"];
  const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp"];
  const fileExtension = fileName.split(".").pop()?.toLowerCase();
  if (fileExtension === undefined) {
    throw new Error("File extension is undefined");
  }
  if (audioExtensions.includes(fileExtension)) {
    return "audio";
  }
  if (videoExtensions.includes(fileExtension)) {
    return "video";
  }
  if (imageExtensions.includes(fileExtension)) {
    return "image";
  }
  if (fileExtension === "json") {
    return "json";
  }
  if (fileExtension === "txt") {
    return "txt";
  }
  return "other";
};
var checkerboardSize = 49;
var containerStyle = (options) => {
  return {
    transform: `scale(${options.scale})`,
    marginLeft: options.xCorrection,
    marginTop: options.yCorrection,
    width: options.width,
    height: options.height,
    display: "flex",
    position: "absolute",
    backgroundColor: checkerboardBackgroundColor(options.checkerboard),
    backgroundImage: checkerboardBackgroundImage(options.checkerboard),
    backgroundSize: getCheckerboardBackgroundSize(checkerboardSize),
    backgroundPosition: getCheckerboardBackgroundPos(checkerboardSize)
  };
};
var VideoPreview = ({ canvasSize, contentDimensions, canvasContent, assetMetadata }) => {
  if (assetMetadata && assetMetadata.type === "not-found") {
    return /* @__PURE__ */ jsx54("div", {
      style: centeredContainer,
      children: /* @__PURE__ */ jsx54("div", {
        style: label3,
        children: "File does not exist"
      })
    });
  }
  if (contentDimensions === null) {
    return /* @__PURE__ */ jsx54("div", {
      style: centeredContainer,
      children: /* @__PURE__ */ jsx54(Spinner, {
        duration: 0.5,
        size: 24
      })
    });
  }
  return /* @__PURE__ */ jsx54(CompWhenItHasDimensions, {
    contentDimensions,
    canvasSize,
    canvasContent,
    assetMetadata
  });
};
var CompWhenItHasDimensions = ({ contentDimensions, canvasSize, canvasContent, assetMetadata }) => {
  const { size: previewSize } = useContext17(Internals11.PreviewSizeContext);
  const { centerX, centerY, yCorrection, xCorrection, scale } = useMemo32(() => {
    if (contentDimensions === "none") {
      return {
        centerX: 0,
        centerY: 0,
        yCorrection: 0,
        xCorrection: 0,
        scale: 1
      };
    }
    return PlayerInternals6.calculateCanvasTransformation({
      canvasSize,
      compositionHeight: contentDimensions.height,
      compositionWidth: contentDimensions.width,
      previewSize: previewSize.size
    });
  }, [canvasSize, contentDimensions, previewSize.size]);
  const outer = useMemo32(() => {
    return {
      width: contentDimensions === "none" ? "100%" : contentDimensions.width * scale,
      height: contentDimensions === "none" ? "100%" : contentDimensions.height * scale,
      display: "flex",
      flexDirection: "column",
      position: "absolute",
      left: centerX - previewSize.translation.x,
      top: centerY - previewSize.translation.y,
      overflow: "hidden",
      justifyContent: canvasContent.type === "asset" ? "center" : "flex-start",
      alignItems: canvasContent.type === "asset" && getPreviewFileType(canvasContent.asset) === "audio" ? "center" : "normal"
    };
  }, [
    contentDimensions,
    scale,
    centerX,
    previewSize.translation.x,
    previewSize.translation.y,
    centerY,
    canvasContent
  ]);
  return /* @__PURE__ */ jsx54("div", {
    style: outer,
    children: canvasContent.type === "asset" ? /* @__PURE__ */ jsx54(StaticFilePreview, {
      assetMetadata,
      currentAsset: canvasContent.asset
    }) : canvasContent.type === "output" ? /* @__PURE__ */ jsx54(RenderPreview, {
      path: canvasContent.path,
      assetMetadata
    }) : /* @__PURE__ */ jsx54(PortalContainer, {
      contentDimensions,
      scale,
      xCorrection,
      yCorrection
    })
  });
};
var PortalContainer = ({ scale, xCorrection, yCorrection, contentDimensions }) => {
  const { checkerboard } = useContext17(CheckerboardContext);
  const style3 = useMemo32(() => {
    return containerStyle({
      checkerboard,
      scale,
      xCorrection,
      yCorrection,
      width: contentDimensions.width,
      height: contentDimensions.height
    });
  }, [
    checkerboard,
    contentDimensions.height,
    contentDimensions.width,
    scale,
    xCorrection,
    yCorrection
  ]);
  useEffect20(() => {
    const { current } = portalContainer;
    current?.appendChild(Internals11.portalNode());
    return () => {
      current?.removeChild(Internals11.portalNode());
    };
  }, []);
  const portalContainer = useRef16(null);
  return /* @__PURE__ */ jsx54("div", {
    ref: portalContainer,
    style: style3
  });
};

// src/components/SizeSelector.tsx
import { jsx as jsx55 } from "react/jsx-runtime";
var commonPreviewSizes = [
  {
    size: "auto",
    translation: {
      x: 0,
      y: 0
    }
  },
  {
    size: 0.25,
    translation: {
      x: 0,
      y: 0
    }
  },
  {
    size: 0.5,
    translation: {
      x: 0,
      y: 0
    }
  },
  {
    size: 1,
    translation: {
      x: 0,
      y: 0
    }
  }
];
var getPreviewSizeLabel = (previewSize) => {
  if (previewSize.size === "auto") {
    return "Fit";
  }
  return `${(previewSize.size * 100).toFixed(0)}%`;
};
var accessibilityLabel = "Preview Size";
var comboStyle = { width: 80 };
var getUniqueSizes = (size) => {
  const customPreviewSizes = [size, ...commonPreviewSizes];
  const uniqueSizes = [];
  customPreviewSizes.forEach((p) => {
    if (!uniqueSizes.find((s) => s.size === p.size)) {
      uniqueSizes.push(p);
    }
  });
  return uniqueSizes.sort((a, b) => {
    if (a.size === "auto") {
      return -1;
    }
    if (b.size === "auto") {
      return 1;
    }
    return a.size - b.size;
  });
};
var zoomableFileTypes = ["video", "image"];
var SizeSelector = () => {
  const { size, setSize } = useContext18(Internals12.PreviewSizeContext);
  const { canvasContent } = useContext18(Internals12.CompositionManager);
  const style3 = useMemo33(() => {
    return {
      padding: CONTROL_BUTTON_PADDING
    };
  }, []);
  const zoomable = useMemo33(() => {
    if (!canvasContent) {
      return null;
    }
    if (canvasContent.type === "composition") {
      return true;
    }
    if (canvasContent.type === "asset" && zoomableFileTypes.includes(getPreviewFileType(canvasContent.asset))) {
      return true;
    }
    if (canvasContent.type === "output" && zoomableFileTypes.includes(getPreviewFileType(canvasContent.path))) {
      return true;
    }
    return false;
  }, [canvasContent]);
  const items = useMemo33(() => {
    return getUniqueSizes(size).map((newSize) => {
      return {
        id: String(newSize.size),
        label: getPreviewSizeLabel(newSize),
        onClick: () => {
          return setSize(() => {
            return newSize;
          });
        },
        type: "item",
        value: newSize.size,
        keyHint: newSize.size === "auto" ? "0" : null,
        leftItem: String(size.size) === String(newSize.size) ? /* @__PURE__ */ jsx55(Checkmark, {}) : null,
        subMenu: null,
        quickSwitcherLabel: null
      };
    });
  }, [setSize, size]);
  if (!zoomable) {
    return null;
  }
  return /* @__PURE__ */ jsx55("div", {
    style: style3,
    "aria-label": accessibilityLabel,
    children: /* @__PURE__ */ jsx55(Combobox, {
      title: accessibilityLabel,
      style: comboStyle,
      selectedId: String(size.size),
      values: items
    })
  });
};

// src/components/TimelineInOutToggle.tsx
import { PlayerInternals as PlayerInternals7 } from "@remotion/player";
import {
  createRef as createRef7,
  useCallback as useCallback26,
  useEffect as useEffect21,
  useImperativeHandle as useImperativeHandle9
} from "react";
import { Internals as Internals14 } from "remotion";
import { NoReactInternals as NoReactInternals4 } from "remotion/no-react";

// src/icons/timelineInOutPointer.tsx
import { jsx as jsx56 } from "react/jsx-runtime";
var TimelineInPointer = (props) => {
  return /* @__PURE__ */ jsx56("svg", {
    viewBox: "0 0 256 256",
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx56("path", {
      d: "M158 25H99V230.5H158",
      stroke: props.color,
      strokeWidth: "42",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};
var TimelineOutPointer = (props) => {
  return /* @__PURE__ */ jsx56("svg", {
    viewBox: "0 0 256 256",
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx56("path", {
      d: "M98 25H157V230.5H98",
      stroke: props.color,
      strokeWidth: "42",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};

// src/state/in-out.ts
import { createContext as createContext11, useContext as useContext19, useMemo as useMemo34 } from "react";
import { Internals as Internals13 } from "remotion";
var TimelineInOutContext = createContext11({});
var SetTimelineInOutContext = createContext11({
  setInAndOutFrames: () => {
    throw new Error("default");
  }
});
var useTimelineInOutFramePosition = () => {
  const videoConfig = Internals13.useUnsafeVideoConfig();
  const state = useContext19(TimelineInOutContext);
  const id = videoConfig?.id;
  const durationInFrames = videoConfig?.durationInFrames;
  return useMemo34(() => {
    if (!id || !durationInFrames) {
      return { inFrame: null, outFrame: null };
    }
    const maxFrame = durationInFrames - 1;
    const actualInFrame = state[id]?.inFrame ?? null;
    const actualOutFrame = state[id]?.outFrame ?? null;
    return {
      inFrame: actualInFrame === null ? null : actualInFrame >= maxFrame ? null : actualInFrame,
      outFrame: actualOutFrame === null ? null : actualOutFrame >= maxFrame ? null : actualOutFrame
    };
  }, [durationInFrames, id, state]);
};
var useTimelineSetInOutFramePosition = () => {
  const { setInAndOutFrames } = useContext19(SetTimelineInOutContext);
  return { setInAndOutFrames };
};

// src/components/TimelineInOutToggle.tsx
import { jsx as jsx57, jsxs as jsxs19, Fragment as Fragment9 } from "react/jsx-runtime";
var getTooltipText = (pointType, key) => [
  `Mark ${pointType}`,
  areKeyboardShortcutsDisabled() ? null : `(${key})`,
  "- right click to clear"
].filter(NoReactInternals4.truthy).join(" ");
var style3 = {
  width: 16,
  height: 16
};
var inOutHandles = createRef7();
var defaultInOutValue = { inFrame: null, outFrame: null };
var TimelineInOutPointToggle = () => {
  const { inFrame, outFrame } = useTimelineInOutFramePosition();
  const { setInAndOutFrames } = useTimelineSetInOutFramePosition();
  const videoConfig = Internals14.useUnsafeVideoConfig();
  const keybindings = useKeybinding();
  const { getCurrentFrame: getCurrentFrame2, isFirstFrame, isLastFrame } = PlayerInternals7.usePlayer();
  const onInOutClear = useCallback26((composition) => {
    setInAndOutFrames((prev) => {
      return {
        ...prev,
        [composition]: {
          inFrame: null,
          outFrame: null
        }
      };
    });
  }, [setInAndOutFrames]);
  const onInMark = useCallback26((e) => {
    if (!videoConfig) {
      return null;
    }
    if (e?.shiftKey) {
      setInAndOutFrames((prev) => {
        return {
          ...prev,
          [videoConfig.id]: {
            ...prev[videoConfig.id] ?? defaultInOutValue,
            inFrame: null
          }
        };
      });
      return null;
    }
    setInAndOutFrames((prev) => {
      const prevOut = prev[videoConfig.id]?.outFrame;
      const biggestPossible = prevOut === undefined || prevOut === null ? Infinity : prevOut - 1;
      const selected = Math.min(getCurrentFrame2(), biggestPossible);
      if (selected === 0) {
        return {
          ...prev,
          [videoConfig.id]: {
            ...prev[videoConfig.id] ?? defaultInOutValue,
            inFrame: null
          }
        };
      }
      const prevIn = prev[videoConfig.id]?.inFrame;
      if (prevIn !== null && prevIn !== undefined) {
        if (prevIn === selected) {
          return {
            ...prev,
            [videoConfig.id]: {
              ...prev[videoConfig.id] ?? defaultInOutValue,
              inFrame: null
            }
          };
        }
      }
      return {
        ...prev,
        [videoConfig.id]: {
          ...prev[videoConfig.id] ?? defaultInOutValue,
          inFrame: selected
        }
      };
    });
  }, [getCurrentFrame2, setInAndOutFrames, videoConfig]);
  const clearInMark = useCallback26((e) => {
    if (!videoConfig) {
      return null;
    }
    e.preventDefault();
    setInAndOutFrames((f) => {
      return {
        ...f,
        [videoConfig.id]: {
          ...f[videoConfig.id] ?? defaultInOutValue,
          inFrame: null
        }
      };
    });
  }, [setInAndOutFrames, videoConfig]);
  const clearOutMark = useCallback26((e) => {
    if (!videoConfig) {
      return null;
    }
    e?.preventDefault();
    setInAndOutFrames((f) => {
      return {
        ...f,
        [videoConfig.id]: {
          ...f[videoConfig.id] ?? defaultInOutValue,
          outFrame: null
        }
      };
    });
  }, [setInAndOutFrames, videoConfig]);
  const onOutMark = useCallback26((e) => {
    if (!videoConfig) {
      return null;
    }
    if (e?.shiftKey) {
      setInAndOutFrames((f) => {
        return {
          ...f,
          [videoConfig.id]: {
            ...f[videoConfig.id] ?? defaultInOutValue,
            outFrame: null
          }
        };
      });
      return;
    }
    setInAndOutFrames((prev) => {
      const prevInFrame = prev[videoConfig.id]?.inFrame;
      const smallestPossible = prevInFrame === null || prevInFrame === undefined ? -Infinity : prevInFrame + 1;
      const selected = Math.max(getCurrentFrame2(), smallestPossible);
      if (selected === videoConfig.durationInFrames - 1) {
        return {
          ...prev,
          [videoConfig.id]: {
            ...prev[videoConfig.id] ?? defaultInOutValue,
            outFrame: null
          }
        };
      }
      const prevOut = prev[videoConfig.id]?.outFrame;
      if (prevOut !== null && prevOut !== undefined) {
        if (prevOut === selected) {
          return {
            ...prev,
            [videoConfig.id]: {
              ...prev[videoConfig.id] ?? defaultInOutValue,
              outFrame: null
            }
          };
        }
      }
      return {
        ...prev,
        [videoConfig.id]: {
          ...prev[videoConfig.id] ?? defaultInOutValue,
          outFrame: selected
        }
      };
    });
  }, [getCurrentFrame2, setInAndOutFrames, videoConfig]);
  const confId = videoConfig?.id;
  useEffect21(() => {
    if (!confId) {
      return;
    }
    const iKey = keybindings.registerKeybinding({
      event: "keypress",
      key: "i",
      callback: (e) => {
        onInMark(e);
      },
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const oKey = keybindings.registerKeybinding({
      event: "keypress",
      key: "o",
      callback: (e) => {
        onOutMark(e);
      },
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const xKey = keybindings.registerKeybinding({
      event: "keypress",
      key: "x",
      callback: () => {
        onInOutClear(confId);
      },
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      oKey.unregister();
      iKey.unregister();
      xKey.unregister();
    };
  }, [confId, keybindings, onInMark, onInOutClear, onOutMark]);
  useImperativeHandle9(inOutHandles, () => {
    return {
      clearMarks: () => {
        if (!confId) {
          return;
        }
        onInOutClear(confId);
      },
      inMarkClick: onInMark,
      outMarkClick: onOutMark
    };
  }, [confId, onInMark, onInOutClear, onOutMark]);
  return /* @__PURE__ */ jsxs19(Fragment9, {
    children: [
      /* @__PURE__ */ jsx57(ControlButton, {
        title: getTooltipText("In", "I"),
        "aria-label": getTooltipText("In", "I"),
        onClick: onInMark,
        onContextMenu: clearInMark,
        disabled: !videoConfig || isFirstFrame,
        children: /* @__PURE__ */ jsx57(TimelineInPointer, {
          color: inFrame === null ? "white" : BLUE,
          style: style3
        })
      }),
      /* @__PURE__ */ jsx57(ControlButton, {
        title: getTooltipText("Out", "O"),
        "aria-label": getTooltipText("Out", "O"),
        onClick: onOutMark,
        onContextMenu: clearOutMark,
        disabled: !videoConfig || isLastFrame,
        children: /* @__PURE__ */ jsx57(TimelineOutPointer, {
          color: outFrame === null ? "white" : BLUE,
          style: style3
        })
      })
    ]
  });
};

// src/error-overlay/remotion-overlay/ShortcutHint.tsx
import { useMemo as useMemo35 } from "react";
import { jsx as jsx58, jsxs as jsxs20 } from "react/jsx-runtime";
var cmdOrCtrlCharacter = window.navigator.platform.startsWith("Mac") ? "⌘" : "Ctrl";
var container13 = {
  display: "inline-block",
  marginLeft: 6,
  opacity: 0.6,
  verticalAlign: "middle",
  fontSize: 14
};
var ShortcutHint = ({ keyToPress, cmdOrCtrl }) => {
  const style4 = useMemo35(() => {
    if (keyToPress === "↵") {
      return {
        display: "inline-block",
        transform: `translateY(2px)`,
        fontSize: 14
      };
    }
    return {};
  }, [keyToPress]);
  if (areKeyboardShortcutsDisabled()) {
    return null;
  }
  return /* @__PURE__ */ jsxs20("span", {
    style: container13,
    children: [
      cmdOrCtrl ? `${cmdOrCtrlCharacter}` : "",
      /* @__PURE__ */ jsx58("span", {
        style: style4,
        children: keyToPress.toUpperCase()
      })
    ]
  });
};

// src/state/editor-guides.ts
import { createContext as createContext12 } from "react";
var persistEditorShowGuidesOption = (option) => {
  localStorage.setItem("remotion.editorShowGuides", String(option));
};
var loadEditorShowGuidesOption = () => {
  const item = localStorage.getItem("remotion.editorShowGuides");
  return item === "true";
};
var persistGuidesList = (guides) => {
  localStorage.setItem("remotion.guidesList", JSON.stringify(guides));
};
var loadGuidesList = () => {
  const item = localStorage.getItem("remotion.guidesList");
  return item ? JSON.parse(item) : [];
};
var EditorShowGuidesContext = createContext12({
  editorShowGuides: false,
  setEditorShowGuides: () => {
    return;
  },
  guidesList: [],
  setGuidesList: () => {
    return;
  },
  selectedGuideId: null,
  setSelectedGuideId: () => {
    return;
  },
  shouldCreateGuideRef: { current: false },
  shouldDeleteGuideRef: { current: false },
  hoveredGuideId: null,
  setHoveredGuideId: () => {
    return;
  }
});

// src/state/editor-rulers.ts
import { createContext as createContext13 } from "react";
var persistEditorShowRulersOption = (option) => {
  localStorage.setItem("remotion.editorShowRulers", String(option));
};
var loadEditorShowRulersOption = () => {
  const item = localStorage.getItem("remotion.editorShowRulers");
  return item === "true";
};
var EditorShowRulersContext = createContext13({
  editorShowRulers: loadEditorShowRulersOption(),
  setEditorShowRulers: () => {
    return;
  }
});
var RULER_WIDTH = 20;
var MINIMUM_VISIBLE_CANVAS_SIZE = 50;
var PREDEFINED_RULER_SCALE_GAPS = [
  1,
  2,
  5,
  10,
  20,
  50,
  100,
  250,
  500,
  1000,
  2000,
  5000
];
var MAXIMUM_PREDEFINED_RULER_SCALE_GAP = 5000;
var MINIMUM_RULER_MARKING_GAP_PX = 50;

// src/state/editor-zoom-gestures.ts
import { createContext as createContext14 } from "react";
var persistEditorZoomGesturesOption = (option) => {
  localStorage.setItem("remotion.editorZoomGestures", String(option));
};
var loadEditorZoomGesturesOption = () => {
  const item = localStorage.getItem("remotion.editorZoomGestures");
  return item !== "false";
};
var EditorZoomGesturesContext = createContext14({
  editorZoomGestures: loadEditorZoomGesturesOption(),
  setEditorZoomGestures: () => {
    return;
  }
});

// src/helpers/check-fullscreen-support.ts
var checkFullscreenSupport = () => {
  return document.fullscreenEnabled || document.webkitFullscreenEnabled;
};

// src/helpers/get-git-menu-item.ts
var getGitSourceName = (gitSource) => {
  if (gitSource.type === "github") {
    return "GitHub";
  }
  throw new Error("Unknown git source type");
};
var getGitSourceBranchUrl = (gitSource) => {
  if (gitSource.type === "github") {
    return `https://github.com/${gitSource.org}/${gitSource.name}/tree/${gitSource.ref}${gitSource.relativeFromGitRoot ? `/${gitSource.relativeFromGitRoot}` : ""}`;
  }
  throw new Error("Unknown git source type");
};
var getGitRefUrl = (gitSource, originalLocation) => {
  if (gitSource.type === "github") {
    return `https://github.com/${gitSource.org}/${gitSource.name}/tree/${gitSource.ref}/${gitSource.relativeFromGitRoot ? `${gitSource.relativeFromGitRoot}/` : ""}${originalLocation.source}#L${originalLocation.line}`;
  }
  throw new Error("Unknown git source type");
};
var getGitMenuItem = () => {
  if (!window.remotion_gitSource) {
    return null;
  }
  return {
    id: "open-git-source",
    value: "open-git-source",
    label: `Open ${getGitSourceName(window.remotion_gitSource)} Repo`,
    onClick: () => {
      window.open(getGitSourceBranchUrl(window.remotion_gitSource), "_blank");
    },
    type: "item",
    keyHint: null,
    leftItem: null,
    subMenu: null,
    quickSwitcherLabel: `Open ${getGitSourceName(window.remotion_gitSource)} repo`
  };
};

// src/helpers/open-in-editor.ts
var openInEditor = (stack) => {
  const {
    originalFileName,
    originalLineNumber,
    originalColumnNumber,
    originalFunctionName,
    originalScriptCode
  } = stack;
  return fetch(`/api/open-in-editor`, {
    method: "post",
    headers: {
      "content-type": "application/json"
    },
    body: JSON.stringify({
      stack: {
        originalFileName,
        originalLineNumber,
        originalColumnNumber,
        originalFunctionName,
        originalScriptCode
      }
    })
  });
};
var openOriginalPositionInEditor = async (originalPosition) => {
  await openInEditor({
    originalColumnNumber: originalPosition.column,
    originalFileName: originalPosition.source,
    originalFunctionName: null,
    originalLineNumber: originalPosition.line,
    originalScriptCode: null
  });
};

// src/components/Notifications/ColorDot.tsx
import { useMemo as useMemo36 } from "react";
import { jsx as jsx59 } from "react/jsx-runtime";
var container14 = {
  height: 16,
  width: 16,
  backgroundColor: "red",
  border: "1px solid rgba(255, 255, 255, 0.2)",
  borderRadius: 8
};
var ColorDot = ({ color }) => {
  const style4 = useMemo36(() => {
    return {
      ...container14,
      backgroundColor: color
    };
  }, [color]);
  return /* @__PURE__ */ jsx59("div", {
    style: style4
  });
};

// src/helpers/pick-color.tsx
import { jsx as jsx60, jsxs as jsxs21, Fragment as Fragment10 } from "react/jsx-runtime";
var pickColor = () => {
  const open = new EyeDropper().open();
  open.then((color) => {
    copyText(color.sRGBHex).then(() => {
      showNotification(/* @__PURE__ */ jsxs21(Fragment10, {
        children: [
          /* @__PURE__ */ jsx60(ColorDot, {
            color: color.sRGBHex
          }),
          " ",
          /* @__PURE__ */ jsx60(Spacing, {
            x: 1
          }),
          " Copied",
          " ",
          color.sRGBHex
        ]
      }), 2000);
    }).catch((err) => {
      showNotification(`Could not copy: ${err.message}`, 2000);
    });
  }).catch((err) => {
    if (err.message.includes("canceled")) {
      return;
    }
    showNotification(`Could not pick color.`, 2000);
  });
};

// src/helpers/use-menu-structure.tsx
import { jsx as jsx61 } from "react/jsx-runtime";
var openExternal = (link) => {
  window.open(link, "_blank");
};
var rotate = {
  transform: `rotate(90deg)`
};
var ICON_SIZE = 16;
var getFileMenu = ({
  readOnlyStudio,
  closeMenu,
  previewServerState
}) => {
  const items = [
    readOnlyStudio ? null : {
      id: "render",
      value: "render",
      label: "Render...",
      onClick: () => {
        closeMenu();
        if (previewServerState !== "connected") {
          showNotification("Restart the studio to render", 2000);
          return;
        }
        const renderButton = document.getElementById("render-modal-button");
        renderButton.click();
      },
      type: "item",
      keyHint: "R",
      leftItem: null,
      subMenu: null,
      quickSwitcherLabel: "Render..."
    },
    window.remotion_editorName && !readOnlyStudio ? {
      type: "divider",
      id: "open-in-editor-divider"
    } : null,
    window.remotion_editorName && !readOnlyStudio ? {
      id: "open-in-editor",
      value: "open-in-editor",
      label: `Open in ${window.remotion_editorName}`,
      onClick: async () => {
        await openInEditor({
          originalFileName: `${window.remotion_cwd}`,
          originalLineNumber: 1,
          originalColumnNumber: 1,
          originalFunctionName: null,
          originalScriptCode: null
        }).then((res) => res.json()).then(({ success }) => {
          if (!success) {
            showNotification(`Could not open ${window.remotion_editorName}`, 2000);
          }
        }).catch((err) => {
          console.error(err);
          showNotification(`Could not open ${window.remotion_editorName}`, 2000);
        });
      },
      type: "item",
      keyHint: null,
      leftItem: null,
      subMenu: null,
      quickSwitcherLabel: "Open in editor..."
    } : null,
    getGitMenuItem()
  ].filter(NoReactInternals5.truthy);
  if (items.length === 0) {
    return null;
  }
  return {
    id: "file",
    label: "File",
    leaveLeftPadding: false,
    items,
    quickSwitcherLabel: null
  };
};
var useMenuStructure = (closeMenu, readOnlyStudio) => {
  const { setSelectedModal } = useContext20(ModalsContext);
  const { checkerboard, setCheckerboard } = useContext20(CheckerboardContext);
  const { editorZoomGestures, setEditorZoomGestures } = useContext20(EditorZoomGesturesContext);
  const { editorShowRulers, setEditorShowRulers } = useContext20(EditorShowRulersContext);
  const { editorShowGuides, setEditorShowGuides } = useContext20(EditorShowGuidesContext);
  const { size, setSize } = useContext20(Internals15.PreviewSizeContext);
  const { type } = useContext20(StudioServerConnectionCtx).previewServerState;
  const {
    setSidebarCollapsedState,
    sidebarCollapsedStateLeft,
    sidebarCollapsedStateRight
  } = useContext20(SidebarContext);
  const sizes = useMemo37(() => getUniqueSizes(size), [size]);
  const isFullscreenSupported = checkFullscreenSupport();
  const { remotion_packageManager } = window;
  const sizePreselectIndex = sizes.findIndex((s) => String(size.size) === String(s.size));
  const mobileLayout = useMobileLayout();
  const structure = useMemo37(() => {
    let struct = [
      {
        id: "remotion",
        label: /* @__PURE__ */ jsx61(Row, {
          align: "center",
          justify: "center",
          children: /* @__PURE__ */ jsx61("svg", {
            width: ICON_SIZE,
            height: ICON_SIZE,
            viewBox: "-100 -100 400 400",
            style: rotate,
            children: /* @__PURE__ */ jsx61("path", {
              fill: "#fff",
              stroke: "#fff",
              strokeWidth: "100",
              strokeLinejoin: "round",
              d: "M 2 172 a 196 100 0 0 0 195 5 A 196 240 0 0 0 100 2.259 A 196 240 0 0 0 2 172 z"
            })
          })
        }),
        leaveLeftPadding: false,
        items: [
          {
            id: "about",
            value: "about",
            label: "About Remotion",
            onClick: () => {
              closeMenu();
              openExternal("https://remotion.dev");
            },
            type: "item",
            keyHint: null,
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: "Help: About Remotion"
          },
          {
            id: "changelog",
            value: "changelog",
            label: "Changelog",
            onClick: () => {
              closeMenu();
              openExternal("https://github.com/remotion-dev/remotion/releases");
            },
            type: "item",
            keyHint: null,
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: "Help: Changelog"
          },
          {
            id: "license",
            value: "license",
            label: "License",
            onClick: () => {
              closeMenu();
              openExternal("https://github.com/remotion-dev/remotion/blob/main/LICENSE.md");
            },
            type: "item",
            keyHint: null,
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: "Help: License"
          },
          {
            id: "acknowledgements",
            value: "acknowledgements",
            label: "Acknowledgements",
            onClick: () => {
              closeMenu();
              openExternal("https://remotion.dev/acknowledgements");
            },
            type: "item",
            keyHint: null,
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: "Help: Acknowledgements"
          },
          {
            type: "divider",
            id: "timeline-divider-1"
          },
          {
            id: "restart-studio",
            value: "restart-studio",
            label: "Restart Studio Server",
            onClick: () => {
              closeMenu();
              restartStudio();
            },
            type: "item",
            keyHint: null,
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: "Restart Studio Server"
          }
        ],
        quickSwitcherLabel: null
      },
      getFileMenu({
        readOnlyStudio,
        closeMenu,
        previewServerState: type
      }),
      {
        id: "view",
        label: "View",
        leaveLeftPadding: true,
        items: [
          {
            id: "preview-size",
            keyHint: null,
            label: "Preview size",
            onClick: () => {
              return;
            },
            type: "item",
            value: "preview-size",
            leftItem: null,
            subMenu: {
              leaveLeftSpace: true,
              preselectIndex: sizePreselectIndex,
              items: sizes.map((newSize) => ({
                id: String(newSize.size),
                keyHint: newSize.size === 1 ? "0" : null,
                label: getPreviewSizeLabel(newSize),
                leftItem: String(newSize.size) === String(size.size) ? /* @__PURE__ */ jsx61(Checkmark, {}) : null,
                onClick: () => {
                  closeMenu();
                  setSize(() => newSize);
                },
                subMenu: null,
                type: "item",
                value: newSize.size,
                quickSwitcherLabel: null
              })),
              quickSwitcherLabel: null
            },
            quickSwitcherLabel: null
          },
          {
            id: "editor-zoom-gestures",
            keyHint: null,
            label: "Zoom and Pan Gestures",
            onClick: () => {
              closeMenu();
              setEditorZoomGestures((c) => !c);
            },
            type: "item",
            value: "editor-zoom-gestures",
            leftItem: editorZoomGestures ? /* @__PURE__ */ jsx61(Checkmark, {}) : null,
            subMenu: null,
            quickSwitcherLabel: editorZoomGestures ? "Disable Zoom and Pan Gestures" : "Enable Zoom and Pan Gestures"
          },
          {
            id: "show-rulers",
            keyHint: null,
            label: "Show Rulers",
            onClick: () => {
              closeMenu();
              setEditorShowRulers((c) => !c);
            },
            type: "item",
            value: "show-ruler",
            leftItem: editorShowRulers ? /* @__PURE__ */ jsx61(Checkmark, {}) : null,
            subMenu: null,
            quickSwitcherLabel: editorShowRulers ? "Hide Rulers" : "Show Rulers"
          },
          {
            id: "show-guides",
            keyHint: null,
            label: "Show Guides",
            onClick: () => {
              closeMenu();
              setEditorShowGuides((c) => !c);
            },
            type: "item",
            value: "show-guides",
            leftItem: editorShowGuides ? /* @__PURE__ */ jsx61(Checkmark, {}) : null,
            subMenu: null,
            quickSwitcherLabel: editorShowGuides ? "Hide Guides" : "Show Guides"
          },
          {
            id: "timeline-divider-1",
            type: "divider"
          },
          {
            id: "left-sidebar",
            label: "Left Sidebar",
            keyHint: null,
            type: "item",
            value: "preview-size",
            leftItem: null,
            quickSwitcherLabel: null,
            subMenu: {
              leaveLeftSpace: true,
              preselectIndex: 0,
              items: [
                {
                  id: "left-sidebar-responsive",
                  keyHint: null,
                  label: "Responsive",
                  leftItem: sidebarCollapsedStateLeft === "responsive" ? /* @__PURE__ */ jsx61(Checkmark, {}) : null,
                  onClick: () => {
                    closeMenu();
                    setSidebarCollapsedState({
                      left: "responsive",
                      right: null
                    });
                  },
                  subMenu: null,
                  type: "item",
                  value: "responsive",
                  quickSwitcherLabel: null
                },
                {
                  id: "left-sidebar-expanded",
                  keyHint: null,
                  label: "Expanded",
                  leftItem: sidebarCollapsedStateLeft === "expanded" ? /* @__PURE__ */ jsx61(Checkmark, {}) : null,
                  onClick: () => {
                    closeMenu();
                    setSidebarCollapsedState({ left: "expanded", right: null });
                  },
                  subMenu: null,
                  type: "item",
                  value: "expanded",
                  quickSwitcherLabel: "Expand"
                },
                {
                  id: "left-sidebar-collapsed",
                  keyHint: null,
                  label: "Collapsed",
                  leftItem: sidebarCollapsedStateLeft === "collapsed" ? /* @__PURE__ */ jsx61(Checkmark, {}) : null,
                  onClick: () => {
                    closeMenu();
                    setSidebarCollapsedState({
                      left: "collapsed",
                      right: null
                    });
                  },
                  subMenu: null,
                  type: "item",
                  value: "collapsed",
                  quickSwitcherLabel: "Collapse"
                }
              ]
            },
            onClick: () => {
              return;
            }
          },
          {
            id: "right-sidebar",
            label: "Right Sidebar",
            keyHint: null,
            type: "item",
            value: "preview-size",
            leftItem: null,
            quickSwitcherLabel: null,
            subMenu: {
              leaveLeftSpace: true,
              preselectIndex: 0,
              items: [
                {
                  id: "sidebar-expanded",
                  keyHint: null,
                  label: "Expanded",
                  leftItem: sidebarCollapsedStateRight === "expanded" ? /* @__PURE__ */ jsx61(Checkmark, {}) : null,
                  onClick: () => {
                    closeMenu();
                    setSidebarCollapsedState({ left: null, right: "expanded" });
                  },
                  subMenu: null,
                  type: "item",
                  value: "expanded",
                  quickSwitcherLabel: "Expand"
                },
                {
                  id: "right-sidebar-collapsed",
                  keyHint: null,
                  label: "Collapsed",
                  leftItem: sidebarCollapsedStateRight === "collapsed" ? /* @__PURE__ */ jsx61(Checkmark, {}) : null,
                  onClick: () => {
                    closeMenu();
                    setSidebarCollapsedState({
                      left: null,
                      right: "collapsed"
                    });
                  },
                  subMenu: null,
                  type: "item",
                  value: "collapsed",
                  quickSwitcherLabel: "Collapse"
                }
              ]
            },
            onClick: () => {
              return;
            }
          },
          {
            id: "timeline-divider-2",
            type: "divider"
          },
          {
            id: "checkerboard",
            keyHint: "T",
            label: "Transparency as checkerboard",
            onClick: () => {
              closeMenu();
              setCheckerboard((c) => !c);
            },
            type: "item",
            value: "checkerboard",
            leftItem: checkerboard ? /* @__PURE__ */ jsx61(Checkmark, {}) : null,
            subMenu: null,
            quickSwitcherLabel: checkerboard ? "Disable Checkerboard Transparency" : "Enable Checkerboard Transparency"
          },
          {
            id: "timeline-divider-3",
            type: "divider"
          },
          {
            id: "quick-switcher",
            keyHint: `${cmdOrCtrlCharacter}+K`,
            label: "Quick Switcher",
            onClick: () => {
              closeMenu();
              setSelectedModal({
                type: "quick-switcher",
                mode: "compositions",
                invocationTimestamp: Date.now()
              });
            },
            type: "item",
            value: "quick-switcher",
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: "Switch composition"
          },
          {
            id: "in-out-divider-5",
            type: "divider"
          },
          {
            id: "in-mark",
            keyHint: "I",
            label: "In Mark",
            leftItem: null,
            onClick: () => {
              closeMenu();
              inOutHandles.current?.inMarkClick(null);
            },
            subMenu: null,
            type: "item",
            value: "in-mark",
            quickSwitcherLabel: "Timeline: Set In Mark"
          },
          {
            id: "out-mark",
            keyHint: "O",
            label: "Out Mark",
            leftItem: null,
            onClick: () => {
              closeMenu();
              inOutHandles.current?.outMarkClick(null);
            },
            subMenu: null,
            type: "item",
            value: "out-mark",
            quickSwitcherLabel: "Timeline: Set Out Mark"
          },
          {
            id: "x-mark",
            keyHint: "X",
            label: "Clear In/Out Marks",
            leftItem: null,
            onClick: () => {
              closeMenu();
              inOutHandles.current?.clearMarks();
            },
            subMenu: null,
            type: "item",
            value: "clear-marks",
            quickSwitcherLabel: "Timeline: Clear In and Out Mark"
          },
          {
            id: "goto-time",
            keyHint: "G",
            label: "Go to frame",
            leftItem: null,
            onClick: () => {
              closeMenu();
              Internals15.timeValueRef.current?.goToFrame();
            },
            subMenu: null,
            type: "item",
            value: "clear-marks",
            quickSwitcherLabel: "Timeline: Go to frame"
          },
          {
            id: "fullscreen-divider",
            type: "divider"
          },
          isFullscreenSupported ? {
            id: "fullscreen",
            keyHint: null,
            label: "Fullscreen",
            leftItem: null,
            onClick: () => {
              closeMenu();
              drawRef.current?.requestFullscreen();
            },
            subMenu: null,
            type: "item",
            value: "fullscreen",
            quickSwitcherLabel: "Go Fullscreen"
          } : null
        ].filter(Internals15.truthy)
      },
      {
        id: "tools",
        label: "Tools",
        leaveLeftPadding: false,
        items: [
          {
            id: "ask-ai",
            value: "ask-ai",
            label: "Ask AI",
            onClick: () => {
              closeMenu();
              askAiModalRef.current?.toggle();
            },
            leftItem: null,
            keyHint: `${cmdOrCtrlCharacter}+I`,
            subMenu: null,
            type: "item",
            quickSwitcherLabel: "Ask AI"
          },
          "EyeDropper" in window ? {
            id: "color-picker",
            value: "color-picker",
            label: "Color Picker",
            onClick: () => {
              closeMenu();
              pickColor();
            },
            leftItem: null,
            keyHint: null,
            subMenu: null,
            type: "item",
            quickSwitcherLabel: "Show Color Picker"
          } : null,
          {
            id: "spring-editor",
            value: "spring-editor",
            label: "spring() Editor",
            onClick: () => {
              closeMenu();
              window.open("https://springs.remotion.dev", "_blank");
            },
            leftItem: null,
            keyHint: null,
            subMenu: null,
            type: "item",
            quickSwitcherLabel: "Open spring() Editor"
          }
        ].filter(Internals15.truthy),
        quickSwitcherLabel: null
      },
      readOnlyStudio || remotion_packageManager === "unknown" ? null : {
        id: "install",
        label: "Packages",
        leaveLeftPadding: false,
        items: [
          {
            id: "install-packages",
            value: "install-packages",
            label: "Install...",
            onClick: () => {
              closeMenu();
              setSelectedModal({
                type: "install-packages",
                packageManager: remotion_packageManager
              });
            },
            type: "item",
            keyHint: null,
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: `Install packages`
          }
        ]
      },
      {
        id: "help",
        label: "Help",
        leaveLeftPadding: false,
        items: [
          {
            id: "shortcuts",
            value: "shortcuts",
            label: areKeyboardShortcutsDisabled() ? "Shortcuts (disabled)" : "Shortcuts",
            onClick: () => {
              closeMenu();
              setSelectedModal({
                type: "quick-switcher",
                mode: "docs",
                invocationTimestamp: Date.now()
              });
            },
            keyHint: "?",
            leftItem: null,
            subMenu: null,
            type: "item",
            quickSwitcherLabel: areKeyboardShortcutsDisabled() ? "Show all Keyboard Shortcuts (disabled)" : "Show all Keyboard Shortcuts"
          },
          {
            id: "docs",
            value: "docs",
            label: "Docs",
            onClick: () => {
              closeMenu();
              openExternal("https://remotion.dev/docs");
            },
            type: "item",
            keyHint: null,
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: "Visit Documentation"
          },
          {
            id: "file-issue",
            value: "file-issue",
            label: "File an issue",
            onClick: () => {
              closeMenu();
              openExternal("https://github.com/remotion-dev/remotion/issues/new/choose");
            },
            type: "item",
            keyHint: null,
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: "File GitHub issue"
          },
          {
            id: "discord",
            value: "discord",
            label: "Join Discord community",
            onClick: () => {
              closeMenu();
              openExternal("https://discord.com/invite/6VzzNDwUwV");
            },
            type: "item",
            keyHint: null,
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: null
          },
          {
            id: "help-divider-6",
            type: "divider"
          },
          {
            id: "insta",
            value: "insta",
            label: "Instagram",
            onClick: () => {
              closeMenu();
              openExternal("https://instagram.com/remotion");
            },
            type: "item",
            keyHint: null,
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: "Follow Remotion on Instagram"
          },
          {
            id: "x",
            value: "x",
            label: "X",
            onClick: () => {
              closeMenu();
              openExternal("https://x.com/remotion");
            },
            type: "item",
            keyHint: null,
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: "Follow Remotion on X"
          },
          {
            id: "youtube",
            value: "youtube",
            label: "YouTube",
            onClick: () => {
              closeMenu();
              openExternal("https://www.youtube.com/@remotion_dev");
            },
            type: "item",
            keyHint: null,
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: "Watch Remotion on YouTube"
          },
          {
            id: "linkedin",
            value: "linkedin",
            label: "LinkedIn",
            onClick: () => {
              closeMenu();
              openExternal("https://www.linkedin.com/company/remotion-dev/");
            },
            type: "item",
            keyHint: null,
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: "Follow Remotion on LinkedIn"
          },
          {
            id: "tiktok",
            value: "tiktok",
            label: "TikTok",
            onClick: () => {
              closeMenu();
              openExternal("https://www.tiktok.com/@remotion");
            },
            type: "item",
            keyHint: null,
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: "Follow Remotion on TikTok"
          }
        ]
      }
    ].filter(Internals15.truthy);
    if (mobileLayout) {
      struct = [
        {
          ...struct[0],
          items: [
            ...struct.slice(1).map((s) => {
              return {
                ...s,
                keyHint: null,
                onClick: () => {
                  return;
                },
                type: "item",
                value: s.id,
                leftItem: null,
                subMenu: {
                  items: s.items,
                  leaveLeftSpace: true,
                  preselectIndex: 0
                },
                quickSwitcherLabel: null
              };
            }),
            ...struct[0].items
          ]
        }
      ];
    }
    return struct;
  }, [
    readOnlyStudio,
    closeMenu,
    type,
    sizePreselectIndex,
    sizes,
    editorZoomGestures,
    editorShowRulers,
    editorShowGuides,
    sidebarCollapsedStateLeft,
    sidebarCollapsedStateRight,
    checkerboard,
    isFullscreenSupported,
    remotion_packageManager,
    mobileLayout,
    size.size,
    setSize,
    setEditorZoomGestures,
    setEditorShowRulers,
    setEditorShowGuides,
    setSidebarCollapsedState,
    setCheckerboard,
    setSelectedModal
  ]);
  return structure;
};
var getItemLabel = (item) => {
  if (item.quickSwitcherLabel !== null) {
    return item.quickSwitcherLabel;
  }
  if (typeof item.label === "string") {
    return item.label;
  }
  return item.label?.toString();
};
var itemToSearchResult = (item, setSelectedModal, prefixes) => {
  if (item.subMenu) {
    return item.subMenu.items.map((subItem) => {
      if (subItem.type === "divider") {
        return null;
      }
      return itemToSearchResult(subItem, setSelectedModal, [
        ...prefixes,
        getItemLabel(item)
      ]);
    }).flat(1).filter(NoReactInternals5.truthy);
  }
  return [
    {
      type: "menu-item",
      id: item.id,
      onSelected: () => {
        setSelectedModal(null);
        item.onClick(item.id, null);
      },
      title: [...prefixes, getItemLabel(item)].join(": ")
    }
  ];
};
var makeSearchResults = (actions, setSelectedModal) => {
  const items = actions.map((menu) => {
    return menu.items.map((item) => {
      if (item.type === "divider") {
        return null;
      }
      return itemToSearchResult(item, setSelectedModal, []);
    });
  }).flat(Infinity).filter(NoReactInternals5.truthy);
  return items;
};

// src/components/Menu/MenuItem.tsx
import { PlayerInternals as PlayerInternals8 } from "@remotion/player";
import { useCallback as useCallback27, useMemo as useMemo38, useRef as useRef17, useState as useState26 } from "react";
import ReactDOM5 from "react-dom";
import { jsx as jsx62, jsxs as jsxs22, Fragment as Fragment11 } from "react/jsx-runtime";
var container15 = {
  fontSize: 13,
  color: "white",
  paddingLeft: 10,
  paddingRight: 10,
  cursor: "default",
  paddingTop: 8,
  paddingBottom: 8,
  userSelect: "none",
  WebkitUserSelect: "none",
  border: "none"
};
var MenuItem = ({
  label: itemName,
  selected,
  id,
  onItemSelected,
  onItemHovered,
  onItemQuit,
  onPreviousMenu,
  onNextMenu,
  menu
}) => {
  const [hovered, setHovered] = useState26(false);
  const ref = useRef17(null);
  const size = PlayerInternals8.useElementSize(ref, {
    triggerOnWindowResize: true,
    shouldApplyCssTransforms: true
  });
  const { tabIndex, currentZIndex } = useZIndex();
  const containerStyle2 = useMemo38(() => {
    return {
      ...container15,
      backgroundColor: getBackgroundFromHoverState({
        hovered,
        selected
      })
    };
  }, [hovered, selected]);
  const portalStyle = useMemo38(() => {
    if (!selected || !size) {
      return null;
    }
    return {
      ...menuContainerTowardsBottom,
      left: size.left,
      top: size.top + size.height
    };
  }, [selected, size]);
  const onPointerEnter = useCallback27(() => {
    onItemHovered(id);
    setHovered(true);
  }, [id, onItemHovered]);
  const onPointerLeave = useCallback27(() => {
    setHovered(false);
  }, []);
  const onPointerDown = useCallback27((e) => {
    if (e.button !== 0) {
      return;
    }
    onItemSelected(id);
    window.addEventListener("pointerup", (evt) => {
      if (!isMenuItem(evt.target)) {
        onItemQuit();
      }
    }, {
      once: true
    });
  }, [id, onItemQuit, onItemSelected]);
  const onClick = useCallback27((e) => {
    e.stopPropagation();
    const isKeyboardInitiated = e.detail === 0;
    if (!isKeyboardInitiated) {
      return;
    }
    onItemSelected((p) => {
      return p === null ? id : null;
    });
  }, [id, onItemSelected]);
  const outerStyle = useMemo38(() => {
    return {
      ...outerPortal,
      top: (size?.top ?? 0) + (size?.height ?? 0)
    };
  }, [size]);
  return /* @__PURE__ */ jsxs22(Fragment11, {
    children: [
      /* @__PURE__ */ jsx62("button", {
        ref,
        role: "button",
        tabIndex,
        onPointerEnter,
        onPointerLeave,
        onPointerDown,
        onClick,
        style: containerStyle2,
        type: "button",
        className: MENU_INITIATOR_CLASSNAME,
        children: itemName
      }),
      portalStyle ? ReactDOM5.createPortal(/* @__PURE__ */ jsx62("div", {
        className: "css-reset",
        style: outerStyle,
        children: /* @__PURE__ */ jsx62(HigherZIndex, {
          onEscape: onItemQuit,
          onOutsideClick: onItemQuit,
          children: /* @__PURE__ */ jsx62("div", {
            style: portalStyle,
            children: /* @__PURE__ */ jsx62(MenuContent, {
              onNextMenu: onPreviousMenu,
              onPreviousMenu: onNextMenu,
              values: menu.items,
              onHide: onItemQuit,
              leaveLeftSpace: menu.leaveLeftPadding,
              preselectIndex: false,
              topItemCanBeUnselected: true,
              fixedHeight: null
            })
          })
        })
      }), getPortal(currentZIndex)) : null
    ]
  });
};

// src/components/MenuBuildIndicator.tsx
import { useContext as useContext21, useEffect as useEffect22, useState as useState28 } from "react";

// src/components/OpenEditorButton.tsx
import { useCallback as useCallback28, useMemo as useMemo39, useState as useState27 } from "react";
import { jsx as jsx63 } from "react/jsx-runtime";
var svgStyle = {
  width: 11,
  height: 11
};
var buttonStyle = {
  border: "none",
  height: "20px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
};
var OpenEditorButton = ({ type }) => {
  const [hovered, setHovered] = useState27(false);
  const svgFillColor = useMemo39(() => {
    return hovered ? "white" : LIGHT_TEXT;
  }, [hovered]);
  const handleClick = useCallback28(async () => {
    if (type === "editor") {
      await openInEditor({
        originalFileName: `${window.remotion_cwd}`,
        originalLineNumber: 1,
        originalColumnNumber: 1,
        originalFunctionName: null,
        originalScriptCode: null
      }).then((res) => res.json()).then(({ success }) => {
        if (!success) {
          showNotification(`Could not open ${window.remotion_editorName}`, 2000);
        }
      }).catch((err) => {
        console.error(err);
        showNotification(`Could not open ${window.remotion_editorName}`, 2000);
      });
    }
    if (type === "git") {
      if (!window.remotion_gitSource) {
        throw new Error("No git source");
      }
      window.open(getGitSourceBranchUrl(window.remotion_gitSource), "_blank");
    }
  }, [type]);
  const buttonTooltip = type === "git" ? `Open ${getGitSourceName(window.remotion_gitSource)} Repo` : `Open in ${window.remotion_editorName}`;
  const openInEditorSvg = /* @__PURE__ */ jsx63("svg", {
    viewBox: "0 0 512 512",
    style: svgStyle,
    children: /* @__PURE__ */ jsx63("path", {
      fill: svgFillColor,
      d: "M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"
    })
  });
  const onPointerEnter = useCallback28(() => {
    setHovered(true);
  }, []);
  const onPointerLeave = useCallback28(() => {
    setHovered(false);
  }, []);
  return /* @__PURE__ */ jsx63("button", {
    title: buttonTooltip,
    type: "button",
    onPointerEnter,
    onPointerLeave,
    style: buttonStyle,
    onClick: handleClick,
    children: openInEditorSvg
  });
};

// src/components/MenuBuildIndicator.tsx
import { jsx as jsx64, jsxs as jsxs23 } from "react/jsx-runtime";
var cwd = {
  fontSize: 13,
  opacity: 0.8,
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
};
var spinnerSize = 14;
var spinner = {
  position: "relative",
  width: spinnerSize,
  marginTop: 4
};
var noSpinner = {
  position: "relative",
  width: spinnerSize
};
var MenuBuildIndicator = () => {
  const [isBuilding, setIsBuilding] = useState28(false);
  const ctx = useContext21(StudioServerConnectionCtx).previewServerState;
  const showButton = window.remotion_editorName && ctx.type === "connected";
  useEffect22(() => {
    window.remotion_isBuilding = () => {
      setIsBuilding(true);
    };
    window.remotion_finishedBuilding = () => {
      setIsBuilding(false);
    };
    return () => {
      window.remotion_isBuilding = undefined;
      window.remotion_finishedBuilding = undefined;
    };
  }, []);
  return /* @__PURE__ */ jsxs23("div", {
    style: cwd,
    title: window.remotion_cwd,
    children: [
      showButton ? /* @__PURE__ */ jsx64(Spacing, {
        x: 2
      }) : null,
      isBuilding ? /* @__PURE__ */ jsx64("div", {
        style: spinner,
        children: /* @__PURE__ */ jsx64(Spinner, {
          duration: 0.5,
          size: spinnerSize
        })
      }) : /* @__PURE__ */ jsx64("div", {
        style: noSpinner
      }),
      showButton ? /* @__PURE__ */ jsx64(Spacing, {
        x: 0.5
      }) : null,
      window.remotion_projectName,
      showButton ? /* @__PURE__ */ jsx64(Spacing, {
        x: 0.25
      }) : null,
      showButton ? /* @__PURE__ */ jsx64(OpenEditorButton, {
        type: "editor"
      }) : window.remotion_gitSource ? /* @__PURE__ */ jsx64(OpenEditorButton, {
        type: "git"
      }) : null
    ]
  });
};

// src/components/SidebarCollapserControls.tsx
import { useCallback as useCallback91, useContext as useContext57, useEffect as useEffect57 } from "react";

// src/components/TopPanel.tsx
import { useCallback as useCallback90, useContext as useContext56, useEffect as useEffect56, useMemo as useMemo95 } from "react";

// src/helpers/use-breakpoint.ts
import { useEffect as useEffect23, useState as useState29 } from "react";
function useBreakpoint(breakpoint2) {
  const [compactUI, setCompactUI] = useState29(window.innerWidth < breakpoint2);
  useEffect23(() => {
    function handleResize() {
      setCompactUI(window.innerWidth < breakpoint2);
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, [breakpoint2]);
  return compactUI;
}

// src/components/CanvasIfSizeIsAvailable.tsx
import { useContext as useContext30, useMemo as useMemo50 } from "react";
import { Internals as Internals25 } from "remotion";

// src/components/CanvasOrLoading.tsx
import { useContext as useContext29, useEffect as useEffect33 } from "react";
import { Internals as Internals24 } from "remotion";

// src/error-overlay/remotion-overlay/ErrorLoader.tsx
import { useEffect as useEffect28, useState as useState32 } from "react";

// src/error-overlay/react-overlay/utils/parser.ts
import { getLocationFromBuildError } from "@remotion/studio-shared";

// src/error-overlay/react-overlay/effects/resolve-file-source.ts
var resolveFileSource = async (location, contextLines) => {
  const res = await fetch(`/api/file-source?f=${encodeURIComponent(location.fileName)}`);
  const text = await res.text();
  const lines2 = text.split(`
`).map((l, i) => {
    const oneIndexedLineNumber = i + 1;
    return [oneIndexedLineNumber, l];
  }).filter(([oneIndexedLineNumber]) => {
    return Math.abs(oneIndexedLineNumber - location.lineNumber) <= contextLines;
  });
  const scriptCode = lines2.map(([num, line2]) => {
    return {
      content: line2,
      highlight: location.lineNumber === num,
      lineNumber: num
    };
  });
  return {
    originalColumnNumber: location.columnNumber,
    originalFunctionName: null,
    originalFileName: location.fileName,
    originalLineNumber: location.lineNumber,
    originalScriptCode: scriptCode
  };
};

// src/error-overlay/react-overlay/utils/make-stack-frame.ts
var makeStackFrame = ({
  functionName,
  fileName,
  lineNumber,
  columnNumber
}) => {
  if (functionName && functionName.indexOf("Object.") === 0) {
    functionName = functionName.slice("Object.".length);
  }
  if (functionName === "friendlySyntaxErrorLabel" || functionName === "exports.__esModule" || functionName === "<anonymous>" || !functionName) {
    functionName = null;
  }
  return {
    columnNumber,
    fileName,
    functionName,
    lineNumber
  };
};

// src/error-overlay/react-overlay/utils/parser.ts
var regexExtractLocation = /\(?(.+?)(?::(\d+))?(?::(\d+))?\)?$/;
function extractLocation(token) {
  const execed = regexExtractLocation.exec(token);
  if (!execed) {
    throw new Error("Could not match in extractLocation");
  }
  return execed.slice(1).map((v) => {
    const p = Number(v);
    if (!isNaN(p)) {
      return p;
    }
    return v;
  });
}
var regexValidFrame_Chrome = /^\s*(at|in)\s.+(:\d+)/;
var regexValidFrame_FireFox = /(^|@)\S+:\d+|.+line\s+\d+\s+>\s+(eval|Function).+/;
function parseStack(stack) {
  const frames = stack.filter((e) => regexValidFrame_Chrome.test(e) || regexValidFrame_FireFox.test(e)).map((e) => {
    if (regexValidFrame_FireFox.test(e)) {
      let isEval = false;
      if (/ > (eval|Function)/.test(e)) {
        e = e.replace(/ line (\d+)(?: > eval line \d+)* > (eval|Function):\d+:\d+/g, ":$1");
        isEval = true;
      }
      const _data = e.split(/[@]/g);
      const _last = _data.pop();
      if (!_last) {
        throw new Error("could not get last");
      }
      const [_fileName, _lineNumber, _columnNumber] = extractLocation(_last);
      return makeStackFrame({
        functionName: _data.join("@") || (isEval ? "eval" : null),
        fileName: _fileName,
        lineNumber: _lineNumber,
        columnNumber: _columnNumber
      });
    }
    if (e.indexOf("(eval ") !== -1) {
      e = e.replace(/(\(eval at [^()]*)|(\),.*$)/g, "");
    }
    if (e.indexOf("(at ") !== -1) {
      e = e.replace(/\(at /, "(");
    }
    const data = e.trim().split(/\s+/g).slice(1);
    const last = data.pop();
    if (!last) {
      throw new Error("could not get last");
    }
    const [fileName, lineNumber, columnNumber] = extractLocation(last);
    return makeStackFrame({
      functionName: data.join(" ") || null,
      fileName,
      lineNumber,
      columnNumber
    });
  });
  return frames;
}
var parseError = async (error, contextLines) => {
  if (error === null) {
    throw new Error("You cannot pass a null object.");
  }
  if (typeof error === "string") {
    return parseStack(error.split(`
`)).map((frame) => {
      return {
        type: "transpiled",
        frame
      };
    });
  }
  if (Array.isArray(error)) {
    return parseStack(error).map((frame) => {
      return {
        type: "transpiled",
        frame
      };
    });
  }
  const errorLocation = getLocationFromBuildError(error);
  if (errorLocation) {
    return [
      {
        type: "symbolicated",
        frame: await resolveFileSource(errorLocation, contextLines)
      }
    ];
  }
  if (typeof error.stack === "string") {
    return parseStack(error.stack.split(`
`)).map((frame) => {
      return {
        type: "transpiled",
        frame
      };
    });
  }
  return [];
};

// src/error-overlay/react-overlay/utils/unmapper.ts
import { Internals as Internals16 } from "remotion";

// src/error-overlay/react-overlay/utils/get-lines-around.ts
function getLinesAround(line2, count, lines2) {
  const result = [];
  for (let index = Math.max(0, line2 - 1 - count);index <= Math.min(lines2.length - 1, line2 - 1 + count); ++index) {
    result.push({
      lineNumber: index + 1,
      content: lines2[index],
      highlight: index === line2 - 1
    });
  }
  return result;
}

// src/error-overlay/react-overlay/utils/get-source-map.ts
import { SourceMapConsumer } from "source-map";
var getOriginalPosition = (source_map, line2, column) => {
  const result = source_map.originalPositionFor({
    line: line2,
    column
  });
  return { line: result.line, column: result.column, source: result.source };
};
function extractSourceMapUrl(fileContents) {
  const regex = /\/\/[#@] ?sourceMappingURL=([^\s'"]+)\s*$/gm;
  let match = null;
  for (;; ) {
    const next = regex.exec(fileContents);
    if (next == null) {
      break;
    }
    match = next;
  }
  if (!match?.[1]) {
    return null;
  }
  return match[1].toString();
}
async function getSourceMap(fileUri, fileContents) {
  const sm = extractSourceMapUrl(fileContents);
  if (sm === null) {
    return null;
  }
  if (sm.indexOf("data:") === 0) {
    const base64 = /^data:application\/json;([\w=:"-]+;)*base64,/;
    const match2 = sm.match(base64);
    if (!match2) {
      throw new Error("Sorry, non-base64 inline source-map encoding is not supported.");
    }
    const converted = window.atob(sm.substring(match2[0].length));
    return new SourceMapConsumer(JSON.parse(converted));
  }
  const index = fileUri.lastIndexOf("/");
  const url = fileUri.substring(0, index + 1) + sm;
  const obj = await fetch(url).then((res) => res.json());
  return new SourceMapConsumer(obj);
}

// src/error-overlay/react-overlay/utils/unmapper.ts
var getFileContents = async (fileName) => {
  const res = await fetch(fileName);
  const fileContents = await res.text();
  return fileContents;
};
var unmap = async (frames, contextLines) => {
  const transpiled = frames.filter((s) => s.type === "transpiled").map((s) => s.frame);
  const uniqueFileNames = [
    ...new Set(transpiled.map((f) => f.fileName).filter(Internals16.truthy))
  ];
  const maps = await Promise.all(uniqueFileNames.map(async (fileName) => {
    const fileContents = await getFileContents(fileName);
    return getSourceMap(fileName, fileContents);
  }));
  const mapValues = {};
  for (let i = 0;i < uniqueFileNames.length; i++) {
    mapValues[uniqueFileNames[i]] = maps[i];
  }
  return frames.map((frame) => {
    if (frame.type === "symbolicated") {
      return frame.frame;
    }
    const map = mapValues[frame.frame.fileName];
    if (!map) {
      return null;
    }
    const pos = getOriginalPosition(map, frame.frame.lineNumber, frame.frame.columnNumber);
    const { functionName } = frame.frame;
    let hasSource = null;
    hasSource = pos.source ? map.sourceContentFor(pos.source, false) : null;
    const scriptCode = hasSource && pos.line ? getLinesAround(pos.line, contextLines, hasSource.split(`
`)) : null;
    return {
      originalColumnNumber: pos.column,
      originalFileName: pos.source,
      originalFunctionName: functionName,
      originalLineNumber: pos.line,
      originalScriptCode: scriptCode
    };
  }).filter(Internals16.truthy);
};

// src/error-overlay/react-overlay/utils/get-stack-frames.ts
var getStackFrames = async (error, contextSize) => {
  const parsedFrames = await parseError(error, contextSize);
  const enhancedFrames = await unmap(parsedFrames, contextSize);
  if (enhancedFrames.map((f) => f.originalFileName).filter((f_1) => f_1 !== null && f_1 !== undefined).length === 0) {
    return null;
  }
  return enhancedFrames;
};

// src/error-overlay/react-overlay/listen-to-runtime-errors.ts
var CONTEXT_SIZE = 3;
var getErrorRecord = async (error) => {
  const stackFrames = await getStackFrames(error, CONTEXT_SIZE);
  if (stackFrames === null || stackFrames === undefined) {
    return null;
  }
  return {
    error,
    contextSize: CONTEXT_SIZE,
    stackFrames
  };
};

// src/error-overlay/remotion-overlay/ErrorDisplay.tsx
import { getLocationFromBuildError as getLocationFromBuildError2 } from "@remotion/studio-shared";
import { useMemo as useMemo43 } from "react";

// src/error-overlay/remotion-overlay/AskOnDiscord.tsx
import { useCallback as useCallback29, useEffect as useEffect24 } from "react";

// src/components/Button.tsx
import { forwardRef as forwardRef3, useMemo as useMemo40 } from "react";
import { jsx as jsx65 } from "react/jsx-runtime";
var button = {
  border: `1px solid ${INPUT_BORDER_COLOR_UNHOVERED}`,
  borderRadius: 4,
  backgroundColor: INPUT_BACKGROUND,
  appearance: "none",
  fontFamily: "inherit",
  fontSize: 14,
  color: "white",
  flexDirection: "row"
};
var ButtonRefForwardFunction = ({
  children,
  onClick,
  title: title2,
  disabled,
  style: style4,
  id,
  autoFocus,
  buttonContainerStyle
}, ref) => {
  const combined = useMemo40(() => {
    return {
      ...button,
      ...style4 ?? {}
    };
  }, [style4]);
  const buttonContainer = useMemo40(() => {
    return {
      padding: 10,
      cursor: disabled ? "inherit" : "pointer",
      fontSize: 14,
      opacity: disabled ? 0.7 : 1,
      ...buttonContainerStyle ?? {}
    };
  }, [buttonContainerStyle, disabled]);
  return /* @__PURE__ */ jsx65("button", {
    ref,
    id,
    style: combined,
    type: "button",
    disabled,
    onClick,
    autoFocus,
    title: title2,
    children: /* @__PURE__ */ jsx65("div", {
      className: "css-reset",
      style: buttonContainer,
      children
    })
  });
};
var Button = forwardRef3(ButtonRefForwardFunction);

// src/error-overlay/remotion-overlay/AskOnDiscord.tsx
import { jsx as jsx66, jsxs as jsxs24 } from "react/jsx-runtime";
var DISCORD_LINK = "https://remotion.dev/discord";
var AskOnDiscord = ({ canHaveKeyboardShortcuts }) => {
  const openInBrowser = useCallback29(() => {
    window.open(DISCORD_LINK, "_blank");
  }, []);
  const { registerKeybinding } = useKeybinding();
  useEffect24(() => {
    if (!canHaveKeyboardShortcuts) {
      return;
    }
    const onEditor = () => {
      openInBrowser();
    };
    const { unregister } = registerKeybinding({
      event: "keydown",
      key: "d",
      callback: onEditor,
      commandCtrlKey: true,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => unregister();
  }, [canHaveKeyboardShortcuts, openInBrowser, registerKeybinding]);
  return /* @__PURE__ */ jsxs24(Button, {
    onClick: openInBrowser,
    children: [
      "Ask on Discord",
      " ",
      canHaveKeyboardShortcuts ? /* @__PURE__ */ jsx66(ShortcutHint, {
        keyToPress: "d",
        cmdOrCtrl: true
      }) : null
    ]
  });
};

// src/error-overlay/remotion-overlay/CalculateMetadataErrorExplainer.tsx
import { jsx as jsx67, jsxs as jsxs25 } from "react/jsx-runtime";
var CalculateMetadataErrorExplainer = () => {
  return /* @__PURE__ */ jsxs25("div", {
    style: style4,
    children: [
      "This error occured while calling",
      " ",
      /* @__PURE__ */ jsx67("code", {
        style: inlineCodeSnippet,
        children: "calculateMetadata()"
      }),
      "."
    ]
  });
};
var style4 = {
  borderRadius: 3,
  color: "white",
  padding: 12,
  backgroundColor: BORDER_COLOR,
  fontSize: 14,
  fontFamily: "sans-serif"
};

// src/error-overlay/react-overlay/index.ts
import { Internals as Internals17 } from "remotion";
var didUnmountReactApp = () => {
  return !Internals17.getPreviewDomElement()?.hasChildNodes();
};

// src/error-overlay/remotion-overlay/DismissButton.tsx
import { useCallback as useCallback30 } from "react";
import { jsx as jsx68 } from "react/jsx-runtime";
var size = {
  height: 20,
  width: 20
};
var style5 = {
  appearance: "none",
  WebkitAppearance: "none",
  backgroundColor: "transparent",
  border: "none",
  cursor: "pointer"
};
var DismissButton = () => {
  const dismiss = useCallback30(() => {
    clearUrl();
  }, []);
  return /* @__PURE__ */ jsx68("button", {
    type: "button",
    style: style5,
    onClick: dismiss,
    children: /* @__PURE__ */ jsx68("svg", {
      focusable: "false",
      role: "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 352 512",
      style: size,
      children: /* @__PURE__ */ jsx68("path", {
        fill: "white",
        d: "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
      })
    })
  });
};

// src/error-overlay/remotion-overlay/ErrorMessage.tsx
import { PlayerInternals as PlayerInternals9 } from "@remotion/player";
import { useCallback as useCallback31, useMemo as useMemo41, useRef as useRef18, useState as useState30 } from "react";

// src/error-overlay/remotion-overlay/carets.tsx
import { jsx as jsx69 } from "react/jsx-runtime";
var CaretRight2 = () => {
  return /* @__PURE__ */ jsx69("svg", {
    style: { height: 20 },
    "aria-hidden": "true",
    focusable: "false",
    role: "img",
    viewBox: "0 0 192 512",
    children: /* @__PURE__ */ jsx69("path", {
      fill: "currentColor",
      d: "M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z"
    })
  });
};
var CaretDown2 = ({ invert }) => {
  return /* @__PURE__ */ jsx69("svg", {
    "aria-hidden": "true",
    focusable: "false",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    style: { height: 20, transform: invert ? `rotate(180deg)` : "" },
    children: /* @__PURE__ */ jsx69("path", {
      fill: "currentColor",
      d: "M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
    })
  });
};

// src/error-overlay/remotion-overlay/ErrorMessage.tsx
import { jsx as jsx70, jsxs as jsxs26 } from "react/jsx-runtime";
var fontSize = 24;
var lineHeight = 1.5;
var maxLines = 2;
var buttonSize = 32;
var maskImage = "linear-gradient(to bottom, white 60%, transparent)";
var container16 = {
  position: "relative",
  marginBottom: 15
};
var messageContainer = {
  overflow: "hidden"
};
var textContainer = {
  fontSize,
  lineHeight
};
var moreLine = {
  width: "100%",
  display: "flex",
  justifyContent: "center",
  position: "absolute",
  border: `1px solid ${INPUT_BORDER_COLOR_HOVERED}`,
  height: 0,
  marginTop: 4
};
var moreButton = {
  height: buttonSize,
  width: buttonSize,
  borderRadius: buttonSize / 2,
  backgroundColor: INPUT_BACKGROUND,
  border: `1px solid ${INPUT_BORDER_COLOR_UNHOVERED}`,
  marginTop: -buttonSize / 2,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  cursor: "pointer",
  color: "white"
};
var ErrorMessage = ({ message }) => {
  const [expanded, setExpanded] = useState30(false);
  const ref = useRef18(null);
  const size2 = PlayerInternals9.useElementSize(ref, {
    shouldApplyCssTransforms: false,
    triggerOnWindowResize: true
  });
  const errorLines = size2 ? size2.height / (lineHeight * fontSize) : null;
  const style6 = useMemo41(() => {
    const isExpanded = expanded || errorLines !== null && errorLines <= maxLines;
    return {
      ...messageContainer,
      maxHeight: isExpanded ? undefined : fontSize * lineHeight * maxLines,
      maskImage: isExpanded ? undefined : maskImage,
      WebkitMaskImage: isExpanded ? undefined : maskImage
    };
  }, [errorLines, expanded]);
  const toggle = useCallback31(() => {
    setExpanded((e) => !e);
  }, []);
  return /* @__PURE__ */ jsxs26("div", {
    style: container16,
    children: [
      /* @__PURE__ */ jsx70("div", {
        style: style6,
        children: /* @__PURE__ */ jsx70("div", {
          ref,
          style: textContainer,
          children: message
        })
      }),
      errorLines !== null && errorLines > maxLines ? /* @__PURE__ */ jsx70("div", {
        style: moreLine,
        children: /* @__PURE__ */ jsx70("button", {
          type: "button",
          onClick: toggle,
          style: moreButton,
          children: /* @__PURE__ */ jsx70(CaretDown2, {
            invert: expanded
          })
        })
      }) : null
    ]
  });
};

// src/error-overlay/remotion-overlay/Symbolicating.tsx
import { jsx as jsx71, jsxs as jsxs27 } from "react/jsx-runtime";
var Symbolicating = (props) => {
  return /* @__PURE__ */ jsxs27("svg", {
    id: "loading",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: "16",
    height: "16",
    fill: "white",
    ...props,
    children: [
      /* @__PURE__ */ jsx71("path", {
        opacity: ".1",
        d: "M14 0 H18 V8 H14 z",
        transform: "rotate(0 16 16)",
        children: /* @__PURE__ */ jsx71("animate", {
          attributeName: "opacity",
          from: "1",
          to: ".1",
          dur: "1s",
          repeatCount: "indefinite",
          begin: "0"
        })
      }),
      /* @__PURE__ */ jsx71("path", {
        opacity: ".1",
        d: "M14 0 H18 V8 H14 z",
        transform: "rotate(45 16 16)",
        children: /* @__PURE__ */ jsx71("animate", {
          attributeName: "opacity",
          from: "1",
          to: ".1",
          dur: "1s",
          repeatCount: "indefinite",
          begin: "0.125s"
        })
      }),
      /* @__PURE__ */ jsx71("path", {
        opacity: ".1",
        d: "M14 0 H18 V8 H14 z",
        transform: "rotate(90 16 16)",
        children: /* @__PURE__ */ jsx71("animate", {
          attributeName: "opacity",
          from: "1",
          to: ".1",
          dur: "1s",
          repeatCount: "indefinite",
          begin: "0.25s"
        })
      }),
      /* @__PURE__ */ jsx71("path", {
        opacity: ".1",
        d: "M14 0 H18 V8 H14 z",
        transform: "rotate(135 16 16)",
        children: /* @__PURE__ */ jsx71("animate", {
          attributeName: "opacity",
          from: "1",
          to: ".1",
          dur: "1s",
          repeatCount: "indefinite",
          begin: "0.375s"
        })
      }),
      /* @__PURE__ */ jsx71("path", {
        opacity: ".1",
        d: "M14 0 H18 V8 H14 z",
        transform: "rotate(180 16 16)",
        children: /* @__PURE__ */ jsx71("animate", {
          attributeName: "opacity",
          from: "1",
          to: ".1",
          dur: "1s",
          repeatCount: "indefinite",
          begin: "0.5s"
        })
      }),
      /* @__PURE__ */ jsx71("path", {
        opacity: ".1",
        d: "M14 0 H18 V8 H14 z",
        transform: "rotate(225 16 16)",
        children: /* @__PURE__ */ jsx71("animate", {
          attributeName: "opacity",
          from: "1",
          to: ".1",
          dur: "1s",
          repeatCount: "indefinite",
          begin: "0.675s"
        })
      }),
      /* @__PURE__ */ jsx71("path", {
        opacity: ".1",
        d: "M14 0 H18 V8 H14 z",
        transform: "rotate(270 16 16)",
        children: /* @__PURE__ */ jsx71("animate", {
          attributeName: "opacity",
          from: "1",
          to: ".1",
          dur: "1s",
          repeatCount: "indefinite",
          begin: "0.75s"
        })
      }),
      /* @__PURE__ */ jsx71("path", {
        opacity: ".1",
        d: "M14 0 H18 V8 H14 z",
        transform: "rotate(315 16 16)",
        children: /* @__PURE__ */ jsx71("animate", {
          attributeName: "opacity",
          from: "1",
          to: ".1",
          dur: "1s",
          repeatCount: "indefinite",
          begin: "0.875s"
        })
      })
    ]
  });
};

// src/error-overlay/remotion-overlay/ErrorTitle.tsx
import { jsx as jsx72, jsxs as jsxs28, Fragment as Fragment12 } from "react/jsx-runtime";
var title2 = {
  marginBottom: 8,
  display: "flex",
  flexDirection: "row",
  justifyContent: "center"
};
var left = {
  flex: 1,
  paddingRight: 14,
  fontWeight: "bold",
  maxWidth: "100%"
};
var errName = {
  fontSize: 18,
  color: BLUE,
  display: "inline-block"
};
var row2 = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center"
};
var spacer = {
  width: 5
};
var ErrorTitle = ({ name, message, symbolicating, canHaveDismissButton }) => {
  return /* @__PURE__ */ jsxs28("div", {
    style: title2,
    className: "css-reset",
    children: [
      /* @__PURE__ */ jsxs28("div", {
        style: left,
        children: [
          /* @__PURE__ */ jsx72("span", {
            style: errName,
            children: name
          }),
          /* @__PURE__ */ jsx72("br", {}),
          /* @__PURE__ */ jsxs28("div", {
            style: row2,
            children: [
              symbolicating ? /* @__PURE__ */ jsxs28(Fragment12, {
                children: [
                  /* @__PURE__ */ jsx72(Symbolicating, {}),
                  /* @__PURE__ */ jsx72("div", {
                    style: spacer
                  })
                ]
              }) : null,
              /* @__PURE__ */ jsx72(ErrorMessage, {
                message
              })
            ]
          })
        ]
      }),
      didUnmountReactApp() ? null : canHaveDismissButton ? /* @__PURE__ */ jsx72(DismissButton, {}) : null
    ]
  });
};

// src/error-overlay/remotion-overlay/HelpLink.tsx
import { useCallback as useCallback32, useEffect as useEffect25 } from "react";
import { jsx as jsx73, jsxs as jsxs29 } from "react/jsx-runtime";
var buttonStyle2 = {
  backgroundColor: BLUE,
  color: "white"
};
var HelpLink = ({ canHaveKeyboardShortcuts, link }) => {
  const openLink = useCallback32(() => {
    window.open(link.url, "_blank");
  }, [link]);
  const { registerKeybinding } = useKeybinding();
  useEffect25(() => {
    if (!canHaveKeyboardShortcuts) {
      return;
    }
    const onEditor = () => {
      openLink();
    };
    const { unregister } = registerKeybinding({
      event: "keydown",
      key: "h",
      callback: onEditor,
      commandCtrlKey: true,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => unregister();
  }, [canHaveKeyboardShortcuts, openLink, registerKeybinding]);
  return /* @__PURE__ */ jsxs29(Button, {
    style: buttonStyle2,
    onClick: openLink,
    children: [
      "Help: ",
      '"',
      link.title,
      '"',
      canHaveKeyboardShortcuts ? /* @__PURE__ */ jsx73(ShortcutHint, {
        keyToPress: "h",
        cmdOrCtrl: true
      }) : null
    ]
  });
};

// src/error-overlay/remotion-overlay/OpenInEditor.tsx
import {
  useCallback as useCallback33,
  useEffect as useEffect26,
  useMemo as useMemo42,
  useReducer,
  useRef as useRef19
} from "react";
import { jsx as jsx74, jsxs as jsxs30 } from "react/jsx-runtime";
var initialState = { type: "idle" };
var reducer = (state, action) => {
  if (action.type === "start") {
    return {
      type: "load"
    };
  }
  if (action.type === "fail") {
    return {
      type: "error"
    };
  }
  if (action.type === "reset") {
    return {
      type: "idle"
    };
  }
  if (action.type === "succeed") {
    return {
      type: "success"
    };
  }
  return state;
};
var OpenInEditor = ({ stack, canHaveKeyboardShortcuts }) => {
  const isMounted = useRef19(true);
  const [state, dispatch] = useReducer(reducer, initialState);
  const { registerKeybinding } = useKeybinding();
  const dispatchIfMounted = useCallback33((payload) => {
    if (isMounted.current === false)
      return;
    dispatch(payload);
  }, []);
  const openInBrowser = useCallback33(() => {
    dispatch({ type: "start" });
    openInEditor(stack).then((res) => res.json()).then((data) => {
      if (data.success) {
        dispatchIfMounted({ type: "succeed" });
      } else {
        dispatchIfMounted({ type: "fail" });
      }
    }).catch((err) => {
      dispatchIfMounted({ type: "fail" });
      console.log("Could not open browser", err);
    }).finally(() => {
      setTimeout(() => {
        dispatchIfMounted({ type: "reset" });
      }, 2000);
    });
  }, [dispatchIfMounted, stack]);
  useEffect26(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);
  useEffect26(() => {
    if (!canHaveKeyboardShortcuts) {
      return;
    }
    const onEditor = () => {
      openInBrowser();
    };
    const { unregister } = registerKeybinding({
      event: "keydown",
      key: "o",
      callback: onEditor,
      commandCtrlKey: true,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => unregister();
  }, [canHaveKeyboardShortcuts, openInBrowser, registerKeybinding]);
  const label4 = useMemo42(() => {
    switch (state.type) {
      case "error":
        return "Failed to open";
      case "idle":
        return `Open in ${window.remotion_editorName}`;
      case "success":
        return `Opened in ${window.remotion_editorName}`;
      case "load":
        return `Opening...`;
      default:
        throw new Error("invalid state");
    }
  }, [state.type]);
  return /* @__PURE__ */ jsxs30(Button, {
    onClick: openInBrowser,
    disabled: state.type !== "idle",
    children: [
      label4,
      canHaveKeyboardShortcuts ? /* @__PURE__ */ jsx74(ShortcutHint, {
        keyToPress: "o",
        cmdOrCtrl: true
      }) : null
    ]
  });
};

// src/error-overlay/remotion-overlay/Retry.tsx
import { jsx as jsx75 } from "react/jsx-runtime";
var RetryButton = ({ onClick }) => {
  return /* @__PURE__ */ jsx75(Button, {
    onClick,
    children: "Retry calculateMetadata()"
  });
};

// src/error-overlay/remotion-overlay/SearchGitHubIssues.tsx
import { useCallback as useCallback34, useEffect as useEffect27 } from "react";
import { jsx as jsx76, jsxs as jsxs31 } from "react/jsx-runtime";
var SearchGithubIssues = ({ message, canHaveKeyboardShortcuts }) => {
  const openInBrowser = useCallback34(() => {
    window.open(`https://github.com/remotion-dev/remotion/issues?q=${encodeURIComponent(message)}`, "_blank");
  }, [message]);
  const { registerKeybinding } = useKeybinding();
  useEffect27(() => {
    if (!canHaveKeyboardShortcuts) {
      return;
    }
    const onEditor = () => {
      openInBrowser();
    };
    const { unregister } = registerKeybinding({
      event: "keydown",
      key: "g",
      callback: onEditor,
      commandCtrlKey: true,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => unregister();
  }, [canHaveKeyboardShortcuts, openInBrowser, registerKeybinding]);
  return /* @__PURE__ */ jsxs31(Button, {
    onClick: openInBrowser,
    children: [
      "Search GitHub Issues",
      " ",
      canHaveKeyboardShortcuts ? /* @__PURE__ */ jsx76(ShortcutHint, {
        keyToPress: "g",
        cmdOrCtrl: true
      }) : null
    ]
  });
};

// src/error-overlay/remotion-overlay/StackFrame.tsx
import { useCallback as useCallback35, useState as useState31 } from "react";

// src/error-overlay/remotion-overlay/CodeFrame.tsx
import { jsx as jsx77, jsxs as jsxs32 } from "react/jsx-runtime";
var container17 = {
  display: "flex",
  flexDirection: "row",
  width: "100%"
};
var frame = {
  backgroundColor: "#070707",
  marginBottom: 20,
  overflowY: "auto"
};
var lineNumber = {
  whiteSpace: "pre",
  paddingRight: 12,
  color: "inherit",
  fontSize: 14,
  lineHeight: 1.7,
  width: 60,
  flexShrink: 0,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "flex-end",
  fontFamily: "monospace"
};
var CodeFrame = ({ source, lineNumberWidth }) => {
  return /* @__PURE__ */ jsx77("div", {
    style: frame,
    className: HORIZONTAL_SCROLLBAR_CLASSNAME,
    children: source.map((s, j) => {
      return /* @__PURE__ */ jsxs32("div", {
        style: container17,
        children: [
          /* @__PURE__ */ jsx77("div", {
            style: {
              ...lineNumber,
              backgroundColor: s.highlight ? "white" : "#121212",
              color: s.highlight ? "black" : "rgba(255, 255, 255, 0.6)"
            },
            children: String(s.lineNumber).padStart(lineNumberWidth, " ")
          }),
          /* @__PURE__ */ jsx77("div", {
            style: {
              fontFamily: "monospace",
              whiteSpace: "pre",
              tabSize: 2,
              color: s.highlight ? "white" : "rgba(255, 255, 255, 0.6)",
              backgroundColor: s.highlight ? BLUE : "transparent",
              lineHeight: 1.7,
              paddingRight: 12,
              paddingLeft: 12
            },
            children: s.content
          })
        ]
      }, j);
    })
  });
};

// src/error-overlay/remotion-overlay/format-location.ts
var formatLocation = (location) => {
  if (location.startsWith("webpack://")) {
    return location.replace("webpack://", "");
  }
  return location;
};

// src/error-overlay/remotion-overlay/StackFrame.tsx
import { jsx as jsx78, jsxs as jsxs33 } from "react/jsx-runtime";
var location = {
  color: "rgba(255, 255, 255, 0.6)",
  fontFamily: "monospace",
  fontSize: 14
};
var header = {
  paddingLeft: 14,
  paddingTop: 10,
  paddingBottom: 10,
  paddingRight: 14,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  borderBottom: "1px solid rgb(66, 144, 245)",
  backgroundColor: "black"
};
var left2 = {
  paddingRight: 14,
  flex: 1
};
var fnName = {
  fontSize: 14,
  lineHeight: 1.5,
  marginBottom: 3
};
var StackElement = ({ s, lineNumberWidth, isFirst, defaultFunctionName }) => {
  const [showCodeFrame, setShowCodeFrame] = useState31(() => !s.originalFileName?.includes("node_modules") && !s.originalFileName?.startsWith("webpack/") || isFirst);
  const toggleCodeFrame = useCallback35(() => {
    setShowCodeFrame((f) => !f);
  }, []);
  return /* @__PURE__ */ jsxs33("div", {
    className: "css-reset",
    children: [
      /* @__PURE__ */ jsxs33("div", {
        style: header,
        children: [
          /* @__PURE__ */ jsxs33("div", {
            style: left2,
            children: [
              /* @__PURE__ */ jsx78("div", {
                style: fnName,
                children: s.originalFunctionName ?? defaultFunctionName
              }),
              s.originalFileName ? /* @__PURE__ */ jsxs33("div", {
                style: location,
                children: [
                  formatLocation(s.originalFileName),
                  ":",
                  s.originalLineNumber
                ]
              }) : null
            ]
          }),
          s.originalScriptCode && s.originalScriptCode.length > 0 ? /* @__PURE__ */ jsx78(Button, {
            onClick: toggleCodeFrame,
            children: showCodeFrame ? /* @__PURE__ */ jsx78(CaretDown2, {
              invert: false
            }) : /* @__PURE__ */ jsx78(CaretRight2, {})
          }) : null
        ]
      }),
      /* @__PURE__ */ jsx78("div", {
        children: s.originalScriptCode && s.originalScriptCode.length > 0 && showCodeFrame ? /* @__PURE__ */ jsx78(CodeFrame, {
          lineNumberWidth,
          source: s.originalScriptCode
        }) : null
      })
    ]
  });
};

// src/error-overlay/remotion-overlay/get-help-link.ts
var getHelpLink = (message) => {
  if (message.includes("See https://www.remotion.dev/docs/the-fundamentals#defining-compositions")) {
    return {
      title: "Defining compositions",
      url: "See https://www.remotion.dev/docs/the-fundamentals#defining-compositions"
    };
  }
  if (message.includes("https://remotion.dev/docs/wrong-composition-mount")) {
    return {
      title: "Wrongly mounted <Composition>",
      url: "https://remotion.dev/docs/wrong-composition-mount"
    };
  }
  if (message.includes("https://remotion.dev/docs/staticfile-relative-paths")) {
    return {
      title: "staticFile() relative paths",
      url: "https://remotion.dev/docs/staticfile-relative-paths"
    };
  }
  if (message.includes("https://remotion.dev/docs/staticfile-remote-urls")) {
    return {
      title: "staticFile() remote URLs",
      url: "https://remotion.dev/docs/staticfile-remote-urls"
    };
  }
  if (message.includes("https://remotion.dev/docs/non-seekable-media")) {
    return {
      title: "Non-seekable media",
      url: "https://remotion.dev/docs/non-seekable-media"
    };
  }
  if (message.includes("https://remotion.dev/docs/media-playback-error")) {
    return {
      title: "Media playback error",
      url: "https://remotion.dev/docs/media-playback-error"
    };
  }
  if (message.includes("Div is not part of the THREE")) {
    return {
      title: "<Sequence> inside <ThreeCanvas>",
      url: "https://remotion.dev/docs/sequence#note-for-remotionthree"
    };
  }
  return null;
};

// src/error-overlay/remotion-overlay/ErrorDisplay.tsx
import { jsx as jsx79, jsxs as jsxs34, Fragment as Fragment13 } from "react/jsx-runtime";
var stack = {
  marginTop: 17,
  overflowX: "scroll",
  marginBottom: "10vh"
};
var spacer2 = {
  width: 5,
  display: "inline-block"
};
var ErrorDisplay = ({
  display,
  keyboardShortcuts,
  onRetry,
  canHaveDismissButton,
  calculateMetadata
}) => {
  const highestLineNumber = Math.max(...display.stackFrames.map((s) => s.originalScriptCode).flat(1).map((s) => s?.lineNumber ?? 0));
  const message = useMemo43(() => {
    const location2 = getLocationFromBuildError2(display.error);
    if (!location2) {
      return display.error.message;
    }
    return location2.message.replace(/\\n/g, `
`).replace(/\\t/g, "  ").replace(/^error:/, "").trim();
  }, [display.error]);
  const lineNumberWidth = String(highestLineNumber).length;
  const helpLink = getHelpLink(message);
  return /* @__PURE__ */ jsxs34("div", {
    children: [
      /* @__PURE__ */ jsx79(ErrorTitle, {
        symbolicating: false,
        name: display.error.name,
        message,
        canHaveDismissButton
      }),
      helpLink ? /* @__PURE__ */ jsxs34(Fragment13, {
        children: [
          /* @__PURE__ */ jsx79(HelpLink, {
            link: helpLink,
            canHaveKeyboardShortcuts: keyboardShortcuts
          }),
          /* @__PURE__ */ jsx79("div", {
            style: spacer2
          })
        ]
      }) : null,
      display.stackFrames.length > 0 && window.remotion_editorName ? /* @__PURE__ */ jsxs34(Fragment13, {
        children: [
          /* @__PURE__ */ jsx79(OpenInEditor, {
            canHaveKeyboardShortcuts: keyboardShortcuts,
            stack: display.stackFrames[0]
          }),
          /* @__PURE__ */ jsx79("div", {
            style: spacer2
          })
        ]
      }) : null,
      /* @__PURE__ */ jsx79(SearchGithubIssues, {
        canHaveKeyboardShortcuts: keyboardShortcuts,
        message: display.error.message
      }),
      /* @__PURE__ */ jsx79("div", {
        style: spacer2
      }),
      /* @__PURE__ */ jsx79(AskOnDiscord, {
        canHaveKeyboardShortcuts: keyboardShortcuts
      }),
      onRetry ? /* @__PURE__ */ jsxs34(Fragment13, {
        children: [
          /* @__PURE__ */ jsx79("div", {
            style: spacer2
          }),
          /* @__PURE__ */ jsx79(RetryButton, {
            onClick: onRetry
          })
        ]
      }) : null,
      calculateMetadata ? /* @__PURE__ */ jsxs34(Fragment13, {
        children: [
          /* @__PURE__ */ jsx79("br", {}),
          /* @__PURE__ */ jsx79(Spacing, {
            y: 0.5
          }),
          /* @__PURE__ */ jsx79(CalculateMetadataErrorExplainer, {})
        ]
      }) : null,
      /* @__PURE__ */ jsx79("div", {
        style: stack,
        className: HORIZONTAL_SCROLLBAR_CLASSNAME,
        children: display.stackFrames.map((s, i) => {
          return /* @__PURE__ */ jsx79(StackElement, {
            isFirst: i === 0,
            s,
            lineNumberWidth,
            defaultFunctionName: "(anonymous function)"
          }, i);
        })
      })
    ]
  });
};

// src/error-overlay/remotion-overlay/ErrorLoader.tsx
import { jsx as jsx80, jsxs as jsxs35 } from "react/jsx-runtime";
var container18 = {
  width: "100%",
  maxWidth: 1000,
  paddingLeft: 14,
  paddingRight: 14,
  marginLeft: "auto",
  marginRight: "auto",
  fontFamily: "SF Pro Text, sans-serif",
  paddingTop: "5vh"
};
var errorWhileErrorStyle = {
  color: "white",
  lineHeight: 1.5,
  whiteSpace: "pre"
};
var ErrorLoader = ({
  error,
  keyboardShortcuts,
  onRetry,
  canHaveDismissButton,
  calculateMetadata
}) => {
  const [state, setState] = useState32({
    type: "loading"
  });
  useEffect28(() => {
    getErrorRecord(error).then((record) => {
      if (record) {
        setState({
          type: "symbolicated",
          record
        });
      } else {
        setState({
          type: "no-record"
        });
      }
    }).catch((err) => {
      setState({
        err,
        type: "error"
      });
    });
  }, [error]);
  if (state.type === "loading") {
    return /* @__PURE__ */ jsx80("div", {
      style: container18,
      children: /* @__PURE__ */ jsx80(ErrorTitle, {
        symbolicating: true,
        name: error.name,
        message: error.message,
        canHaveDismissButton
      })
    });
  }
  if (state.type === "error") {
    return /* @__PURE__ */ jsxs35("div", {
      style: container18,
      children: [
        /* @__PURE__ */ jsx80(ErrorTitle, {
          symbolicating: false,
          name: error.name,
          message: error.message,
          canHaveDismissButton
        }),
        /* @__PURE__ */ jsx80("div", {
          style: errorWhileErrorStyle,
          children: "Error while getting stack trace:"
        }),
        /* @__PURE__ */ jsx80("div", {
          style: errorWhileErrorStyle,
          children: state.err.stack
        }),
        /* @__PURE__ */ jsx80("div", {
          style: errorWhileErrorStyle,
          children: "Report this in the Remotion repo."
        })
      ]
    });
  }
  if (state.type === "no-record") {
    return /* @__PURE__ */ jsxs35("div", {
      style: container18,
      children: [
        /* @__PURE__ */ jsx80(ErrorTitle, {
          symbolicating: false,
          name: error.name,
          message: error.message,
          canHaveDismissButton
        }),
        /* @__PURE__ */ jsx80("div", {
          style: errorWhileErrorStyle,
          children: "Check the Terminal and browser console for error messages."
        })
      ]
    });
  }
  return /* @__PURE__ */ jsx80("div", {
    style: container18,
    children: /* @__PURE__ */ jsx80(ErrorDisplay, {
      keyboardShortcuts,
      display: state.record,
      onRetry,
      canHaveDismissButton,
      calculateMetadata
    })
  });
};

// src/components/Canvas.tsx
import {
  useCallback as useCallback39,
  useContext as useContext28,
  useEffect as useEffect31,
  useMemo as useMemo49,
  useState as useState34
} from "react";
import { Internals as Internals22, watchStaticFile } from "remotion";

// src/helpers/get-effective-translation.ts
var getEffectiveXTranslation = ({
  canvasSize,
  scale,
  compositionWidth,
  translation
}) => {
  const maxTranslation = Math.abs(canvasSize.width / 2 + scale * compositionWidth / 2 - MUST_BE_INSIDE_CANVAS);
  return Math.max(-maxTranslation, Math.min(translation.x, maxTranslation));
};
var MUST_BE_INSIDE_CANVAS = 50;
var getEffectiveYTranslation = ({
  canvasSize,
  scale,
  compositionHeight,
  translation
}) => {
  const maxTranslation = Math.abs(canvasSize.height / 2 + scale * compositionHeight / 2) - MUST_BE_INSIDE_CANVAS;
  return Math.max(-maxTranslation, Math.min(translation.y, maxTranslation));
};
var getEffectiveTranslation = ({
  canvasSize,
  scale,
  compositionHeight,
  compositionWidth,
  translation
}) => {
  return {
    x: getEffectiveXTranslation({
      canvasSize,
      compositionWidth,
      scale,
      translation
    }),
    y: getEffectiveYTranslation({
      canvasSize,
      compositionHeight,
      scale,
      translation
    })
  };
};
var getCenterPointWhileScrolling = ({
  size: size2,
  clientX,
  clientY,
  compositionWidth,
  compositionHeight,
  scale,
  translation
}) => {
  const mouseLeft = clientX - size2.left;
  const mouseTop = clientY - size2.top;
  const contentLeftPoint = size2.width / 2 - compositionWidth * scale / 2 - translation.x;
  const contentTopPoint = size2.height / 2 - compositionHeight * scale / 2 - translation.y;
  const offsetFromVideoLeft = Math.min(compositionWidth, Math.max(0, (mouseLeft - contentLeftPoint) / scale));
  const offsetFromVideoTop = Math.min(compositionHeight, Math.max(0, (mouseTop - contentTopPoint) / scale));
  return {
    centerX: offsetFromVideoLeft,
    centerY: offsetFromVideoTop
  };
};

// src/helpers/smooth-zoom.ts
var BASE = Math.E / 4;
var MIN_ZOOM = 0.05;
var MAX_ZOOM = 10;
function logN(val) {
  return Math.log(val) / Math.log(BASE);
}
var smoothenZoom = (input) => {
  return BASE ** (input - 1);
};
var unsmoothenZoom = (input) => {
  if (input < 0) {
    return MAX_ZOOM;
  }
  return Math.min(MAX_ZOOM, Math.max(MIN_ZOOM, logN(input) + 1));
};

// src/components/EditorGuides/index.tsx
import { useContext as useContext24, useMemo as useMemo46 } from "react";
import { Internals as Internals19 } from "remotion";

// src/helpers/use-studio-canvas-dimensions.ts
import { PlayerInternals as PlayerInternals10 } from "@remotion/player";
import { useContext as useContext22, useMemo as useMemo44 } from "react";
import { Internals as Internals18 } from "remotion";
var useStudioCanvasDimensions = ({
  canvasSize,
  contentDimensions,
  assetMetadata
}) => {
  const { size: previewSize } = useContext22(Internals18.PreviewSizeContext);
  const { centerX, centerY, scale } = useMemo44(() => {
    if (contentDimensions === "none" || contentDimensions === null || assetMetadata && assetMetadata.type === "not-found" || !canvasSize) {
      return {
        centerX: previewSize.translation.x,
        centerY: previewSize.translation.y,
        scale: 1
      };
    }
    return PlayerInternals10.calculateCanvasTransformation({
      canvasSize,
      compositionHeight: contentDimensions.height,
      compositionWidth: contentDimensions.width,
      previewSize: previewSize.size
    });
  }, [
    canvasSize,
    contentDimensions,
    previewSize.size,
    previewSize.translation.y,
    previewSize.translation.x,
    assetMetadata
  ]);
  const canvasPosition = useMemo44(() => {
    return {
      left: centerX - previewSize.translation.x,
      top: centerY - previewSize.translation.y,
      width: contentDimensions === "none" || !contentDimensions ? canvasSize?.width || 0 : contentDimensions.width * scale,
      height: contentDimensions === "none" || !contentDimensions ? canvasSize?.height || 0 : contentDimensions.height * scale
    };
  }, [
    scale,
    centerX,
    previewSize.translation.x,
    previewSize.translation.y,
    centerY,
    canvasSize,
    contentDimensions
  ]);
  return {
    canvasPosition,
    scale
  };
};

// src/components/EditorGuides/Guide.tsx
import { memo, useCallback as useCallback36, useContext as useContext23, useMemo as useMemo45 } from "react";
import { NoReactInternals as NoReactInternals6 } from "remotion/no-react";
import { jsx as jsx81 } from "react/jsx-runtime";
var PADDING_FOR_EASY_DRAG = 4;
var GuideComp = ({ guide, canvasDimensions, scale }) => {
  const {
    shouldCreateGuideRef,
    setGuidesList,
    setSelectedGuideId,
    selectedGuideId,
    setHoveredGuideId,
    hoveredGuideId
  } = useContext23(EditorShowGuidesContext);
  const onPointerEnter = useCallback36(() => {
    setHoveredGuideId(() => guide.id);
  }, [guide.id, setHoveredGuideId]);
  const onPointerLeave = useCallback36(() => {
    setHoveredGuideId(() => null);
  }, [setHoveredGuideId]);
  const isVerticalGuide = guide.orientation === "vertical";
  const guideStyle = useMemo45(() => {
    const canvasPosition = isVerticalGuide ? canvasDimensions.left : canvasDimensions.top;
    const guidePosition = guide.position * scale + canvasPosition;
    return {
      position: "absolute",
      width: `${isVerticalGuide ? "1px" : "100%"}`,
      height: `${isVerticalGuide ? "100%" : "1px"}`,
      left: `${isVerticalGuide ? guidePosition - PADDING_FOR_EASY_DRAG : 0}px`,
      top: `${isVerticalGuide ? 0 : guidePosition - PADDING_FOR_EASY_DRAG}px`,
      cursor: `${isVerticalGuide ? "ew-resize" : "ns-resize"}`,
      padding: isVerticalGuide ? `0 ${PADDING_FOR_EASY_DRAG}px` : `${PADDING_FOR_EASY_DRAG}px 0`
    };
  }, [guide, scale, canvasDimensions, isVerticalGuide]);
  const guideContentStyle = useMemo45(() => {
    return {
      position: "relative",
      minWidth: `${isVerticalGuide ? "1px" : `calc(100% + ${RULER_WIDTH}px`}`,
      minHeight: `${isVerticalGuide ? `calc(100% + ${RULER_WIDTH}px` : "1px"}`,
      top: `${isVerticalGuide ? `-${RULER_WIDTH}px` : "0px"}`,
      left: `${isVerticalGuide ? "0px" : `-${RULER_WIDTH}px`}`,
      display: guide.show ? "block" : "none",
      backgroundColor: selectedGuideId === guide.id || hoveredGuideId === guide.id ? SELECTED_GUIDE : UNSELECTED_GUIDE
    };
  }, [isVerticalGuide, guide.show, guide.id, selectedGuideId, hoveredGuideId]);
  const onMouseDown = useCallback36((e) => {
    e.preventDefault();
    if (e.button !== 0) {
      return;
    }
    shouldCreateGuideRef.current = true;
    document.body.style.cursor = "no-drop";
    setSelectedGuideId(() => guide.id);
  }, [shouldCreateGuideRef, setSelectedGuideId, guide.id]);
  const values = useMemo45(() => {
    return [
      {
        id: "1",
        keyHint: null,
        label: "Remove guide",
        leftItem: null,
        onClick: () => {
          setGuidesList((prevState) => {
            const newGuides = prevState.filter((selected) => {
              return selected.id !== guide.id;
            });
            persistGuidesList(newGuides);
            return newGuides;
          });
        },
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item",
        value: "remove"
      }
    ];
  }, [guide.id, setGuidesList]);
  return /* @__PURE__ */ jsx81(ContextMenu, {
    values,
    children: /* @__PURE__ */ jsx81("div", {
      style: guideStyle,
      onMouseDown,
      className: "__remotion_editor_guide",
      onPointerEnter,
      onPointerLeave,
      children: /* @__PURE__ */ jsx81("div", {
        style: guideContentStyle,
        className: [
          "__remotion_editor_guide_content",
          selectedGuideId === guide.id || hoveredGuideId === guide.id ? "__remotion_editor_guide_selected" : null
        ].filter(NoReactInternals6.truthy).join(" ")
      })
    })
  });
};
var Guide_default = memo(GuideComp);

// src/components/EditorGuides/index.tsx
import { jsx as jsx82, Fragment as Fragment14 } from "react/jsx-runtime";
var EditorGuides = ({ canvasSize, contentDimensions, assetMetadata }) => {
  const { canvasPosition: canvasDimensions, scale } = useStudioCanvasDimensions({
    canvasSize,
    contentDimensions,
    assetMetadata
  });
  const { canvasContent } = useContext24(Internals19.CompositionManager);
  if (canvasContent === null || canvasContent.type !== "composition") {
    throw new Error("Expected to be in a composition");
  }
  const { guidesList } = useContext24(EditorShowGuidesContext);
  const guidesForThisComposition = useMemo46(() => {
    return guidesList.filter((guide) => {
      return guide.compositionId === canvasContent.compositionId;
    });
  }, [canvasContent.compositionId, guidesList]);
  return /* @__PURE__ */ jsx82(Fragment14, {
    children: guidesForThisComposition.map((guide) => {
      return /* @__PURE__ */ jsx82(Guide_default, {
        guide,
        canvasDimensions,
        scale
      }, guide.id);
    })
  });
};
var EditorGuides_default = EditorGuides;

// src/components/EditorRuler/index.tsx
import {
  useCallback as useCallback38,
  useContext as useContext26,
  useEffect as useEffect30,
  useMemo as useMemo48,
  useRef as useRef21
} from "react";

// src/helpers/editor-ruler.ts
var drawLabel = ({
  orientation,
  context,
  label: label4,
  originDistance,
  color
}) => {
  context.fillStyle = color;
  if (orientation === "horizontal") {
    context.fillText(label4, originDistance + 4, 16);
  } else {
    context.rotate(-Math.PI / 2);
    context.fillText(label4, -originDistance + 4, 16);
    context.rotate(Math.PI / 2);
  }
};
var drawGradient = ({
  orientation,
  context,
  originDistance,
  canvasHeight,
  canvasWidth
}) => {
  const size2 = 250;
  const startX = orientation === "horizontal" ? originDistance - size2 / 2 : 0;
  const startY = orientation === "horizontal" ? 0 : originDistance - size2 / 2;
  const endX = orientation === "horizontal" ? originDistance + size2 / 2 : canvasWidth;
  const endY = orientation === "horizontal" ? canvasHeight : originDistance + size2 / 2;
  const grd = context.createLinearGradient(startX, startY, endX, endY);
  grd.addColorStop(0, BACKGROUND__TRANSPARENT);
  grd.addColorStop(0.25, BACKGROUND);
  grd.addColorStop(0.75, BACKGROUND);
  grd.addColorStop(1, BACKGROUND__TRANSPARENT);
  context.fillStyle = grd;
  context.fillRect(startX, startY, endX - startX, endY - startY);
};
var drawGuide = ({
  selectedGuide,
  scale,
  startMarking,
  context,
  canvasHeight,
  canvasWidth,
  orientation,
  originOffset
}) => {
  const originDistance = rulerValueToPosition({
    value: selectedGuide.position,
    startMarking,
    scale
  }) + originOffset - startMarking * scale;
  drawGradient({
    canvasHeight,
    context,
    orientation,
    originDistance,
    canvasWidth
  });
  context.strokeStyle = SELECTED_GUIDE;
  context.lineWidth = 1;
  context.beginPath();
  if (orientation === "horizontal" && selectedGuide.orientation === "horizontal") {
    return;
  }
  if (orientation === "vertical" && selectedGuide.orientation === "vertical") {
    return;
  }
  if (orientation === "vertical" && selectedGuide.orientation === "horizontal") {
    context.moveTo(0, originDistance);
    context.lineTo(canvasWidth, originDistance);
    drawLabel({
      context,
      label: selectedGuide.position.toString(),
      originDistance,
      orientation,
      color: SELECTED_GUIDE
    });
  } else if (orientation === "horizontal" && selectedGuide.orientation === "vertical") {
    context.moveTo(originDistance, 0);
    context.lineTo(originDistance, canvasHeight);
    drawLabel({
      context,
      label: selectedGuide.position.toString(),
      originDistance,
      orientation,
      color: SELECTED_GUIDE
    });
  }
  context.stroke();
};
var drawMarkingOnRulerCanvas = ({
  scale,
  points,
  startMarking,
  originOffset,
  markingGaps,
  orientation,
  rulerCanvasRef,
  selectedGuide,
  canvasHeight,
  canvasWidth
}) => {
  const canvas = rulerCanvasRef.current;
  if (!canvas)
    return;
  const context = canvas.getContext("2d");
  if (!context)
    return;
  canvas.width = canvasWidth;
  canvas.height = canvasHeight;
  context.scale(window.devicePixelRatio, window.devicePixelRatio);
  context.clearRect(0, 0, canvasWidth, canvasHeight);
  context.strokeStyle = RULER_COLOR;
  context.lineWidth = 1;
  context.beginPath();
  points.forEach((point) => {
    context.strokeStyle = RULER_COLOR;
    context.lineWidth = 1;
    const originDistance = point.position + originOffset - startMarking * scale;
    context.beginPath();
    if (orientation === "horizontal") {
      context.moveTo(originDistance, 0);
      context.lineTo(originDistance, canvasHeight);
    } else {
      context.moveTo(0, originDistance);
      context.lineTo(canvasWidth, originDistance);
    }
    for (let i = 1;i < 5; i++) {
      const markingOffsetXY = i * markingGaps * scale;
      if (orientation === "horizontal") {
        context.moveTo(originDistance + markingOffsetXY / 5, 0);
        context.lineTo(originDistance + markingOffsetXY / 5, 4);
      } else {
        context.moveTo(0, originDistance + markingOffsetXY / 5);
        context.lineTo(4, originDistance + markingOffsetXY / 5);
      }
    }
    context.stroke();
    context.font = "10px Arial, Helvetica, sans-serif";
    context.textAlign = "left";
    context.fillStyle = RULER_COLOR;
    drawLabel({
      orientation,
      context,
      label: point.value.toString(),
      originDistance,
      color: RULER_COLOR
    });
  });
  if (selectedGuide && orientation !== selectedGuide.orientation) {
    drawGuide({
      canvasHeight,
      canvasWidth,
      context,
      orientation,
      originOffset,
      scale,
      selectedGuide,
      startMarking
    });
  }
};
var getRulerPoints = ({
  rulerScaleRange,
  rulerMarkingGaps,
  scale
}) => {
  const points = [];
  const startPoint = Math.ceil(rulerScaleRange.start / rulerMarkingGaps);
  const endPoint = Math.floor(rulerScaleRange.end / rulerMarkingGaps);
  const startMarking = startPoint * rulerMarkingGaps;
  for (let i = startPoint;i <= endPoint; i++) {
    points.push({
      value: i * rulerMarkingGaps,
      position: rulerValueToPosition({
        scale,
        startMarking,
        value: i * rulerMarkingGaps
      })
    });
  }
  return {
    points,
    startMarking
  };
};
var rulerValueToPosition = ({
  value,
  startMarking,
  scale
}) => {
  return (value + startMarking) * scale;
};
var getRulerScaleRange = ({
  canvasLength,
  scale,
  canvasSize
}) => {
  const scaleRangeBeyondCanvas = (canvasSize.width || MINIMUM_VISIBLE_CANVAS_SIZE - MINIMUM_VISIBLE_CANVAS_SIZE) / scale;
  return {
    start: -scaleRangeBeyondCanvas,
    end: scaleRangeBeyondCanvas + canvasLength
  };
};

// src/components/EditorRuler/Ruler.tsx
import {
  useCallback as useCallback37,
  useContext as useContext25,
  useEffect as useEffect29,
  useMemo as useMemo47,
  useRef as useRef20,
  useState as useState33
} from "react";
import { Internals as Internals20 } from "remotion";
import { jsx as jsx83 } from "react/jsx-runtime";
var makeGuideId = () => {
  return Math.random().toString(36).substring(7);
};
var Ruler = ({
  scale,
  points,
  originOffset,
  startMarking,
  size: size2,
  markingGaps,
  orientation
}) => {
  const rulerCanvasRef = useRef20(null);
  const isVerticalRuler = orientation === "vertical";
  const {
    shouldCreateGuideRef,
    setGuidesList,
    selectedGuideId,
    hoveredGuideId,
    setSelectedGuideId,
    guidesList,
    setEditorShowGuides
  } = useContext25(EditorShowGuidesContext);
  const unsafeVideoConfig = Internals20.useUnsafeVideoConfig();
  if (!unsafeVideoConfig) {
    throw new Error("Video config not set");
  }
  const [cursor, setCursor] = useState33(isVerticalRuler ? "ew-resize" : "ns-resize");
  const selectedOrHoveredGuide = useMemo47(() => {
    return guidesList.find((guide) => guide.id === selectedGuideId) ?? guidesList.find((guide) => guide.id === hoveredGuideId) ?? null;
  }, [guidesList, hoveredGuideId, selectedGuideId]);
  const rulerWidth = isVerticalRuler ? RULER_WIDTH : size2.width - RULER_WIDTH;
  const rulerHeight = isVerticalRuler ? size2.height - RULER_WIDTH : RULER_WIDTH;
  useEffect29(() => {
    drawMarkingOnRulerCanvas({
      scale,
      points,
      startMarking,
      originOffset,
      markingGaps,
      orientation,
      rulerCanvasRef,
      selectedGuide: selectedOrHoveredGuide,
      canvasHeight: rulerHeight * window.devicePixelRatio,
      canvasWidth: rulerWidth * window.devicePixelRatio
    });
  }, [
    scale,
    points,
    startMarking,
    originOffset,
    markingGaps,
    orientation,
    selectedOrHoveredGuide,
    size2,
    rulerHeight,
    rulerWidth
  ]);
  const rulerStyle = useMemo47(() => ({
    position: "absolute",
    background: BACKGROUND,
    width: rulerWidth,
    height: rulerHeight,
    left: isVerticalRuler ? 0 : "unset",
    top: isVerticalRuler ? "unset" : 0,
    borderBottom: isVerticalRuler ? undefined : "1px solid " + RULER_COLOR,
    borderRight: isVerticalRuler ? "1px solid " + RULER_COLOR : undefined,
    cursor
  }), [rulerWidth, rulerHeight, cursor, isVerticalRuler]);
  const onMouseDown = useCallback37((e) => {
    if (e.button !== 0) {
      return;
    }
    e.preventDefault();
    shouldCreateGuideRef.current = true;
    document.body.style.cursor = "no-drop";
    const guideId = makeGuideId();
    setEditorShowGuides(() => true);
    setSelectedGuideId(() => guideId);
    setGuidesList((prevState) => {
      return [
        ...prevState,
        {
          orientation,
          position: -originOffset,
          show: false,
          id: guideId,
          compositionId: unsafeVideoConfig.id
        }
      ];
    });
  }, [
    shouldCreateGuideRef,
    setEditorShowGuides,
    setSelectedGuideId,
    setGuidesList,
    orientation,
    originOffset,
    unsafeVideoConfig.id
  ]);
  const changeCursor = useCallback37((e) => {
    e.preventDefault();
    if (selectedGuideId !== null) {
      setCursor("no-drop");
    }
  }, [setCursor, selectedGuideId]);
  useEffect29(() => {
    if (selectedGuideId === null) {
      setCursor(isVerticalRuler ? "ew-resize" : "ns-resize");
    }
  }, [selectedGuideId, isVerticalRuler]);
  return /* @__PURE__ */ jsx83("canvas", {
    ref: rulerCanvasRef,
    width: rulerWidth * window.devicePixelRatio,
    height: rulerHeight * window.devicePixelRatio,
    style: rulerStyle,
    onPointerDown: onMouseDown,
    onPointerEnter: changeCursor,
    onPointerLeave: changeCursor
  });
};
var Ruler_default = Ruler;

// src/components/EditorRuler/index.tsx
import { jsx as jsx84, jsxs as jsxs36, Fragment as Fragment15 } from "react/jsx-runtime";
var originBlockStyles = {
  position: "absolute",
  top: 0,
  left: 0,
  borderBottom: "1px solid " + RULER_COLOR,
  borderRight: "1px solid " + RULER_COLOR,
  width: `${RULER_WIDTH}px`,
  height: `${RULER_WIDTH}px`,
  background: BACKGROUND
};
var EditorRulers = ({ contentDimensions, canvasSize, assetMetadata, containerRef }) => {
  const { scale, canvasPosition } = useStudioCanvasDimensions({
    canvasSize,
    contentDimensions,
    assetMetadata
  });
  const {
    shouldCreateGuideRef,
    shouldDeleteGuideRef,
    setGuidesList,
    selectedGuideId,
    setSelectedGuideId
  } = useContext26(EditorShowGuidesContext);
  const rulerMarkingGaps = useMemo48(() => {
    const minimumGap = MINIMUM_RULER_MARKING_GAP_PX;
    const predefinedGap = PREDEFINED_RULER_SCALE_GAPS.find((gap) => gap * scale > minimumGap);
    return predefinedGap || MAXIMUM_PREDEFINED_RULER_SCALE_GAP;
  }, [scale]);
  const horizontalRulerScaleRange = useMemo48(() => getRulerScaleRange({
    canvasLength: canvasPosition.width,
    scale,
    canvasSize
  }), [canvasPosition.width, canvasSize, scale]);
  const verticalRulerScaleRange = useMemo48(() => getRulerScaleRange({
    canvasLength: canvasPosition.height,
    scale,
    canvasSize
  }), [canvasPosition.height, canvasSize, scale]);
  const {
    points: horizontalRulerPoints,
    startMarking: horizontalRulerStartMarking
  } = useMemo48(() => getRulerPoints({
    rulerScaleRange: horizontalRulerScaleRange,
    rulerMarkingGaps,
    scale
  }), [horizontalRulerScaleRange, rulerMarkingGaps, scale]);
  const { points: verticalRulerPoints, startMarking: verticalRulerStartMarking } = useMemo48(() => getRulerPoints({
    rulerScaleRange: verticalRulerScaleRange,
    rulerMarkingGaps,
    scale
  }), [verticalRulerScaleRange, rulerMarkingGaps, scale]);
  const requestAnimationFrameRef = useRef21(null);
  const onMouseMove = useCallback38((e) => {
    if (requestAnimationFrameRef.current) {
      cancelAnimationFrame(requestAnimationFrameRef.current);
    }
    requestAnimationFrameRef.current = requestAnimationFrame(() => {
      const { clientX: mouseX, clientY: mouseY } = e;
      const {
        left: containerLeft = 0,
        top: containerTop = 0,
        right: containerRight = 0,
        bottom: containerBottom = 0
      } = containerRef.current?.getBoundingClientRect() || {};
      if (mouseX < containerLeft || mouseX > containerRight || mouseY < containerTop || mouseY > containerBottom) {
        if (!shouldDeleteGuideRef.current) {
          shouldDeleteGuideRef.current = true;
        }
        if (document.body.style.cursor !== "no-drop") {
          document.body.style.cursor = "no-drop";
        }
        setGuidesList((prevState) => {
          const newGuides = prevState.map((guide) => {
            if (guide.id !== selectedGuideId) {
              return guide;
            }
            return {
              ...guide,
              show: false
            };
          });
          persistGuidesList(newGuides);
          return newGuides;
        });
      } else {
        if (shouldDeleteGuideRef.current) {
          shouldDeleteGuideRef.current = false;
        }
        setGuidesList((prevState) => {
          return prevState.map((guide) => {
            if (guide.id !== selectedGuideId) {
              return guide;
            }
            const position = guide.orientation === "vertical" ? (mouseX - containerLeft) / scale - canvasPosition.left / scale : (mouseY - containerTop) / scale - canvasPosition.top / scale;
            const desiredCursor = guide.orientation === "vertical" ? "ew-resize" : "ns-resize";
            if (document.body.style.cursor !== desiredCursor) {
              document.body.style.cursor = desiredCursor;
            }
            return {
              ...guide,
              position: Math.floor(position / 1),
              show: true
            };
          });
        });
      }
    });
  }, [
    containerRef,
    shouldDeleteGuideRef,
    setGuidesList,
    selectedGuideId,
    scale,
    canvasPosition.left,
    canvasPosition.top
  ]);
  const onMouseUp = useCallback38(() => {
    setGuidesList((prevState) => {
      const newGuides = prevState.filter((selected) => {
        if (!shouldDeleteGuideRef.current) {
          return true;
        }
        return selected.id !== selectedGuideId;
      });
      persistGuidesList(newGuides);
      return newGuides;
    });
    shouldDeleteGuideRef.current = false;
    document.body.style.cursor = "auto";
    shouldCreateGuideRef.current = false;
    setSelectedGuideId(() => null);
    document.removeEventListener("pointerup", onMouseUp);
    document.removeEventListener("pointermove", onMouseMove);
  }, [
    selectedGuideId,
    shouldCreateGuideRef,
    shouldDeleteGuideRef,
    setSelectedGuideId,
    setGuidesList,
    onMouseMove
  ]);
  useEffect30(() => {
    if (selectedGuideId !== null) {
      document.addEventListener("pointermove", onMouseMove);
      document.addEventListener("pointerup", onMouseUp);
    }
    return () => {
      document.removeEventListener("pointermove", onMouseMove);
      document.removeEventListener("pointerup", onMouseUp);
      if (requestAnimationFrameRef.current) {
        cancelAnimationFrame(requestAnimationFrameRef.current);
      }
    };
  }, [selectedGuideId, onMouseMove, onMouseUp]);
  return /* @__PURE__ */ jsxs36(Fragment15, {
    children: [
      /* @__PURE__ */ jsx84("div", {
        style: originBlockStyles
      }),
      /* @__PURE__ */ jsx84(Ruler_default, {
        orientation: "horizontal",
        scale,
        points: horizontalRulerPoints,
        startMarking: horizontalRulerStartMarking,
        markingGaps: rulerMarkingGaps,
        originOffset: canvasPosition.left,
        size: canvasSize
      }),
      /* @__PURE__ */ jsx84(Ruler_default, {
        orientation: "vertical",
        scale,
        points: verticalRulerPoints,
        startMarking: verticalRulerStartMarking,
        markingGaps: rulerMarkingGaps,
        originOffset: canvasPosition.top,
        size: canvasSize
      })
    ]
  });
};

// src/components/EditorRuler/use-is-ruler-visible.ts
import { useContext as useContext27 } from "react";
import { Internals as Internals21 } from "remotion";
var useIsRulerVisible = () => {
  const { canvasContent } = useContext27(Internals21.CompositionManager);
  const { editorShowRulers } = useContext27(EditorShowRulersContext);
  return editorShowRulers && canvasContent && canvasContent.type === "composition";
};

// src/components/ResetZoomButton.tsx
import { jsx as jsx85 } from "react/jsx-runtime";
var ResetZoomButton = ({ onClick }) => {
  return /* @__PURE__ */ jsx85(Button, {
    onClick,
    children: "Reset zoom"
  });
};

// src/components/Canvas.tsx
import { jsx as jsx86, jsxs as jsxs37, Fragment as Fragment16 } from "react/jsx-runtime";
var container19 = {
  flex: 1,
  display: "flex",
  overflow: "hidden",
  position: "relative",
  backgroundColor: BACKGROUND
};
var resetZoom = {
  position: "absolute",
  top: SPACING_UNIT * 2,
  right: SPACING_UNIT * 2
};
var ZOOM_PX_FACTOR = 0.003;
var Canvas = ({ canvasContent, size: size2 }) => {
  const { setSize, size: previewSize } = useContext28(Internals22.PreviewSizeContext);
  const { editorZoomGestures } = useContext28(EditorZoomGesturesContext);
  const keybindings = useKeybinding();
  const config = Internals22.useUnsafeVideoConfig();
  const areRulersVisible = useIsRulerVisible();
  const { editorShowGuides } = useContext28(EditorShowGuidesContext);
  const [assetResolution, setAssetResolution] = useState34(null);
  const contentDimensions = useMemo49(() => {
    if ((canvasContent.type === "asset" || canvasContent.type === "output") && assetResolution && assetResolution.type === "found") {
      return assetResolution.dimensions;
    }
    if (config) {
      return { width: config.width, height: config.height };
    }
    return null;
  }, [assetResolution, config, canvasContent]);
  const isFit = previewSize.size === "auto";
  const onWheel = useCallback39((e) => {
    if (!editorZoomGestures) {
      return;
    }
    if (!size2) {
      return;
    }
    if (!contentDimensions || contentDimensions === "none") {
      return;
    }
    const wantsToZoom = e.ctrlKey || e.metaKey;
    if (!wantsToZoom && isFit) {
      return;
    }
    e.preventDefault();
    setSize((prevSize) => {
      const scale = Internals22.calculateScale({
        canvasSize: size2,
        compositionHeight: contentDimensions.height,
        compositionWidth: contentDimensions.width,
        previewSize: prevSize.size
      });
      if (wantsToZoom) {
        const oldSize = prevSize.size === "auto" ? scale : prevSize.size;
        const smoothened = smoothenZoom(oldSize);
        const added = smoothened + e.deltaY * ZOOM_PX_FACTOR;
        const unsmoothened = unsmoothenZoom(added);
        const { centerX, centerY } = getCenterPointWhileScrolling({
          size: size2,
          clientX: e.clientX,
          clientY: e.clientY,
          compositionWidth: contentDimensions.width,
          compositionHeight: contentDimensions.height,
          scale,
          translation: prevSize.translation
        });
        const zoomDifference = unsmoothened - oldSize;
        const uvCoordinatesX = centerX / contentDimensions.width;
        const uvCoordinatesY = centerY / contentDimensions.height;
        const correctionLeft = -uvCoordinatesX * (zoomDifference * contentDimensions.width) + (1 - uvCoordinatesX) * zoomDifference * contentDimensions.width;
        const correctionTop = -uvCoordinatesY * (zoomDifference * contentDimensions.height) + (1 - uvCoordinatesY) * zoomDifference * contentDimensions.height;
        return {
          translation: getEffectiveTranslation({
            translation: {
              x: prevSize.translation.x - correctionLeft / 2,
              y: prevSize.translation.y - correctionTop / 2
            },
            canvasSize: size2,
            compositionHeight: contentDimensions.height,
            compositionWidth: contentDimensions.width,
            scale
          }),
          size: unsmoothened
        };
      }
      const effectiveTranslation = getEffectiveTranslation({
        translation: prevSize.translation,
        canvasSize: size2,
        compositionHeight: contentDimensions.height,
        compositionWidth: contentDimensions.width,
        scale
      });
      return {
        ...prevSize,
        translation: getEffectiveTranslation({
          translation: {
            x: effectiveTranslation.x + e.deltaX,
            y: effectiveTranslation.y + e.deltaY
          },
          canvasSize: size2,
          compositionHeight: contentDimensions.height,
          compositionWidth: contentDimensions.width,
          scale
        })
      };
    });
  }, [editorZoomGestures, contentDimensions, isFit, setSize, size2]);
  useEffect31(() => {
    const { current } = canvasRef;
    if (!current) {
      return;
    }
    current.addEventListener("wheel", onWheel, { passive: false });
    return () => current.removeEventListener("wheel", onWheel, {
      passive: false
    });
  }, [onWheel]);
  const onReset = useCallback39(() => {
    setSize(() => {
      return {
        translation: {
          x: 0,
          y: 0
        },
        size: "auto"
      };
    });
  }, [setSize]);
  const onZoomIn = useCallback39(() => {
    if (!contentDimensions || contentDimensions === "none") {
      return;
    }
    if (!size2) {
      return;
    }
    setSize((prevSize) => {
      const scale = Internals22.calculateScale({
        canvasSize: size2,
        compositionHeight: contentDimensions.height,
        compositionWidth: contentDimensions.width,
        previewSize: prevSize.size
      });
      return {
        translation: {
          x: 0,
          y: 0
        },
        size: Math.min(MAX_ZOOM, scale * 2)
      };
    });
  }, [contentDimensions, setSize, size2]);
  const onZoomOut = useCallback39(() => {
    if (!contentDimensions || contentDimensions === "none") {
      return;
    }
    if (!size2) {
      return;
    }
    setSize((prevSize) => {
      const scale = Internals22.calculateScale({
        canvasSize: size2,
        compositionHeight: contentDimensions.height,
        compositionWidth: contentDimensions.width,
        previewSize: prevSize.size
      });
      return {
        translation: {
          x: 0,
          y: 0
        },
        size: Math.max(MIN_ZOOM, scale / 2)
      };
    });
  }, [contentDimensions, setSize, size2]);
  useEffect31(() => {
    const resetBinding = keybindings.registerKeybinding({
      event: "keydown",
      key: "0",
      commandCtrlKey: false,
      callback: onReset,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const zoomIn = keybindings.registerKeybinding({
      event: "keydown",
      key: "+",
      commandCtrlKey: false,
      callback: onZoomIn,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const zoomOut = keybindings.registerKeybinding({
      event: "keydown",
      key: "-",
      commandCtrlKey: false,
      callback: onZoomOut,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      resetBinding.unregister();
      zoomIn.unregister();
      zoomOut.unregister();
    };
  }, [keybindings, onReset, onZoomIn, onZoomOut]);
  const fetchMetadata = useCallback39(async () => {
    setAssetResolution(null);
    if (canvasContent.type === "composition") {
      return;
    }
    const metadata = await getAssetMetadata(canvasContent, canvasContent.type === "asset");
    setAssetResolution(metadata);
  }, [canvasContent]);
  useEffect31(() => {
    if (canvasContent.type !== "asset") {
      return;
    }
    const file = watchStaticFile(canvasContent.asset, () => {
      fetchMetadata();
    });
    return () => {
      file.cancel();
    };
  }, [canvasContent, fetchMetadata]);
  useEffect31(() => {
    fetchMetadata();
  }, [fetchMetadata]);
  return /* @__PURE__ */ jsxs37(Fragment16, {
    children: [
      /* @__PURE__ */ jsxs37("div", {
        ref: canvasRef,
        style: container19,
        children: [
          size2 ? /* @__PURE__ */ jsx86(VideoPreview, {
            canvasContent,
            contentDimensions,
            canvasSize: size2,
            assetMetadata: assetResolution
          }) : null,
          isFit ? null : /* @__PURE__ */ jsx86("div", {
            style: resetZoom,
            className: "css-reset",
            children: /* @__PURE__ */ jsx86(ResetZoomButton, {
              onClick: onReset
            })
          }),
          editorShowGuides && canvasContent.type === "composition" && /* @__PURE__ */ jsx86(EditorGuides_default, {
            canvasSize: size2,
            contentDimensions,
            assetMetadata: assetResolution
          })
        ]
      }),
      areRulersVisible && /* @__PURE__ */ jsx86(EditorRulers, {
        contentDimensions,
        canvasSize: size2,
        assetMetadata: assetResolution,
        containerRef: canvasRef
      })
    ]
  });
};

// src/components/FramePersistor.tsx
import { useEffect as useEffect32 } from "react";
import { Internals as Internals23, useVideoConfig as useVideoConfig2 } from "remotion";
var FramePersistor = () => {
  const [playing] = Internals23.Timeline.usePlayingState();
  const config = useVideoConfig2();
  const frame2 = Internals23.Timeline.useTimelinePosition();
  const setFrame = Internals23.useTimelineSetFrame();
  useEffect32(() => {
    if (!playing) {
      setFrame((f) => {
        const newObj = { ...f, [config.id]: frame2 };
        Internals23.persistCurrentFrame(newObj);
        return newObj;
      });
    }
  }, [config.id, frame2, playing, setFrame]);
  return null;
};

// src/components/RefreshCompositionOverlay.tsx
import { AbsoluteFill as AbsoluteFill2 } from "remotion";

// src/components/RunningCalculateMetadata.tsx
import { jsx as jsx87, jsxs as jsxs38 } from "react/jsx-runtime";
var loaderLabel = {
  fontSize: 14,
  color: LIGHT_TEXT,
  fontFamily: "sans-serif",
  lineHeight: 1.5
};
var container20 = {
  backgroundColor: BACKGROUND,
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "row",
  padding: 20
};
var RunningCalculateMetadata = () => {
  return /* @__PURE__ */ jsxs38("div", {
    style: container20,
    children: [
      /* @__PURE__ */ jsx87(Spinner, {
        size: 24,
        duration: 1
      }),
      /* @__PURE__ */ jsx87(Spacing, {
        x: 2
      }),
      /* @__PURE__ */ jsxs38("div", {
        style: loaderLabel,
        children: [
          "Running ",
          /* @__PURE__ */ jsx87("code", {
            style: inlineCodeSnippet,
            children: "calculateMetadata()"
          }),
          "..."
        ]
      })
    ]
  });
};

// src/components/RefreshCompositionOverlay.tsx
import { jsx as jsx88 } from "react/jsx-runtime";
var container21 = {
  justifyContent: "flex-end",
  alignItems: "flex-start",
  padding: 20,
  pointerEvents: "none"
};
var shadow = {
  boxShadow: "0 0 4px black"
};
var RefreshCompositionOverlay = () => {
  return /* @__PURE__ */ jsx88(AbsoluteFill2, {
    style: container21,
    children: /* @__PURE__ */ jsx88("div", {
      style: shadow,
      children: /* @__PURE__ */ jsx88(RunningCalculateMetadata, {})
    })
  });
};

// src/components/CanvasOrLoading.tsx
import { jsx as jsx89, jsxs as jsxs39, Fragment as Fragment17 } from "react/jsx-runtime";
var container22 = {
  color: "white",
  flex: 1,
  justifyContent: "center",
  alignItems: "center",
  display: "flex",
  backgroundColor: BACKGROUND,
  flexDirection: "column"
};
var CanvasOrLoading = ({ size: size2 }) => {
  const resolved = Internals24.useResolvedVideoConfig(null);
  const { setZoom } = useContext29(TimelineZoomCtx);
  const { canvasContent } = useContext29(Internals24.CompositionManager);
  useEffect33(() => {
    if (resolved?.type !== "success" && resolved?.type !== "success-and-refreshing") {
      return;
    }
    const c = resolved.result;
    setTimeout(() => {
      ensureFrameIsInViewport({
        direction: "center",
        frame: getCurrentFrame(),
        durationInFrames: c.durationInFrames
      });
    });
  }, [resolved, setZoom]);
  if (!canvasContent) {
    const compname = window.location.pathname.replace("/", "");
    return /* @__PURE__ */ jsx89("div", {
      style: container22,
      className: "css-reset",
      children: /* @__PURE__ */ jsxs39("div", {
        style: loaderLabel,
        children: [
          "Composition with ID ",
          compname,
          " not found."
        ]
      })
    });
  }
  const content = /* @__PURE__ */ jsxs39(Fragment17, {
    children: [
      /* @__PURE__ */ jsx89(ZoomPersistor, {}),
      /* @__PURE__ */ jsx89(Canvas, {
        size: size2,
        canvasContent
      }),
      resolved?.type === "success-and-refreshing" ? /* @__PURE__ */ jsx89(RefreshCompositionOverlay, {}) : null
    ]
  });
  if (canvasContent.type === "asset" || canvasContent.type === "output") {
    return content;
  }
  if (!resolved) {
    return null;
  }
  if (resolved.type === "loading") {
    return /* @__PURE__ */ jsx89("div", {
      style: container22,
      className: "css-reset",
      children: /* @__PURE__ */ jsx89(RunningCalculateMetadata, {})
    });
  }
  if (resolved.type === "error") {
    return /* @__PURE__ */ jsx89(ErrorLoading, {
      error: resolved.error
    });
  }
  return /* @__PURE__ */ jsxs39(Fragment17, {
    children: [
      /* @__PURE__ */ jsx89(FramePersistor, {}),
      " ",
      content
    ]
  });
};
var loaderContainer = {
  marginLeft: "auto",
  marginRight: "auto",
  width: "100%",
  position: "absolute",
  height: "100%",
  overflowY: "auto"
};
var ErrorLoading = ({ error }) => {
  return /* @__PURE__ */ jsx89("div", {
    style: loaderContainer,
    className: VERTICAL_SCROLLBAR_CLASSNAME,
    children: /* @__PURE__ */ jsx89(ErrorLoader, {
      canHaveDismissButton: false,
      keyboardShortcuts: false,
      error,
      onRetry: () => Internals24.resolveCompositionsRef.current?.reloadCurrentlySelectedComposition(),
      calculateMetadata: true
    }, error.stack)
  });
};

// src/components/CanvasIfSizeIsAvailable.tsx
import { jsx as jsx90 } from "react/jsx-runtime";
var CanvasIfSizeIsAvailable = () => {
  const rulersAreVisible = useIsRulerVisible();
  const context = useContext30(Internals25.CurrentScaleContext);
  const sizeWithRulersApplied = useMemo50(() => {
    const size2 = context && context.type === "canvas-size" ? context.canvasSize : null;
    if (!rulersAreVisible) {
      return size2;
    }
    if (!size2) {
      return null;
    }
    return {
      ...size2,
      width: size2.width - RULER_WIDTH,
      height: size2.height - RULER_WIDTH
    };
  }, [context, rulersAreVisible]);
  if (!sizeWithRulersApplied) {
    return null;
  }
  return /* @__PURE__ */ jsx90(CanvasOrLoading, {
    size: sizeWithRulersApplied
  });
};

// src/components/CurrentCompositionSideEffects.tsx
import { useCallback as useCallback40, useContext as useContext31, useEffect as useEffect34 } from "react";
import { Internals as Internals26 } from "remotion";

// src/helpers/document-title.ts
import { NoReactInternals as NoReactInternals7 } from "remotion/no-react";
var currentItemName = null;
var unsavedProps = false;
var tabInactive = false;
var renderJobs = [];
var setCurrentCanvasContentId = (id) => {
  if (!id) {
    currentItemName = id;
    updateTitle();
    return;
  }
  const idWithoutFolder = id.split("/").pop();
  currentItemName = idWithoutFolder;
  updateTitle();
};
var setUnsavedProps = (unsaved) => {
  window.remotion_unsavedProps = unsaved;
  unsavedProps = unsaved;
};
var setRenderJobs = (jobs) => {
  renderJobs = jobs;
  updateTitle();
};
document.addEventListener("visibilitychange", () => {
  tabInactive = document.visibilityState === "hidden";
  updateTitle();
});
var productName = "Remotion Studio";
var suffix = `- ${productName}`;
var updateTitle = () => {
  if (!currentItemName) {
    document.title = productName;
    return;
  }
  const currentCompTitle = `${currentItemName} / ${window.remotion_projectName}`;
  document.title = [
    getProgressInBrackets(currentItemName, renderJobs),
    unsavedProps && tabInactive ? "✏️" : null,
    `${currentCompTitle} ${suffix}`
  ].filter(NoReactInternals7.truthy).join(" ");
};
var getProgressInBrackets = (selectedCompositionId, jobs) => {
  const currentRender = jobs.find((job) => job.status === "running");
  if (!currentRender) {
    return null;
  }
  if (currentRender.status !== "running") {
    throw new Error("expected running job");
  }
  const progInPercent = Math.ceil(currentRender.progress.value * 100);
  const progressInBrackets = currentRender.compositionId === selectedCompositionId ? `[${progInPercent}%]` : `[${progInPercent}% ${currentRender.compositionId}]`;
  return progressInBrackets;
};
document.addEventListener("visibilitychange", () => {
  tabInactive = document.visibilityState === "hidden";
  updateTitle();
});

// src/components/CurrentCompositionSideEffects.tsx
var TitleUpdater = () => {
  const renderQueue = useContext31(RenderQueueContext);
  const { canvasContent } = useContext31(Internals26.CompositionManager);
  const { jobs } = renderQueue;
  useEffect34(() => {
    if (!canvasContent) {
      setCurrentCanvasContentId(null);
      return;
    }
    if (canvasContent.type === "composition") {
      setCurrentCanvasContentId(canvasContent.compositionId);
      return;
    }
    if (canvasContent.type === "output") {
      setCurrentCanvasContentId(canvasContent.path);
      return;
    }
    setCurrentCanvasContentId(canvasContent.asset);
  }, [canvasContent]);
  useEffect34(() => {
    setRenderJobs(jobs);
  }, [jobs]);
  return null;
};
var CurrentCompositionKeybindings = ({ readOnlyStudio }) => {
  const keybindings = useKeybinding();
  const video = Internals26.useVideo();
  const { type } = useContext31(StudioServerConnectionCtx).previewServerState;
  const openRenderModal = useCallback40(() => {
    if (!video) {
      return;
    }
    if (readOnlyStudio) {
      return showNotification("Studio is read-only", 2000);
    }
    if (type !== "connected") {
      showNotification("Studio server is offline", 2000);
      return;
    }
    const renderButton = document.getElementById("render-modal-button");
    renderButton.click();
  }, [readOnlyStudio, type, video]);
  useEffect34(() => {
    const binding = keybindings.registerKeybinding({
      event: "keydown",
      key: "r",
      commandCtrlKey: false,
      callback: openRenderModal,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      binding.unregister();
    };
  }, [keybindings, openRenderModal]);
  return null;
};

// src/components/MobilePanel.tsx
import ReactDOM6 from "react-dom";
import { jsx as jsx91, jsxs as jsxs40 } from "react/jsx-runtime";
var container23 = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  padding: "0 0px 50px 0px",
  background: BACKGROUND
};
var buttonContainer = {
  height: "40px",
  width: "100%",
  alignItems: "center",
  display: "flex",
  justifyContent: "flex-end"
};
var button2 = {
  height: 20,
  width: 20
};
function MobilePanel({
  children,
  onClose
}) {
  const { currentZIndex } = useZIndex();
  return ReactDOM6.createPortal(/* @__PURE__ */ jsxs40("div", {
    style: container23,
    children: [
      /* @__PURE__ */ jsx91("div", {
        style: buttonContainer,
        children: /* @__PURE__ */ jsx91(CancelButton, {
          style: button2,
          onPress: onClose
        })
      }),
      children
    ]
  }), getPortal(currentZIndex));
}

// src/components/OptionsPanel.tsx
import {
  createRef as createRef9,
  useCallback as useCallback80,
  useContext as useContext46,
  useEffect as useEffect48,
  useImperativeHandle as useImperativeHandle12,
  useMemo as useMemo89,
  useState as useState54
} from "react";
import { Internals as Internals36 } from "remotion";

// src/visual-controls/VisualControls.tsx
import {
  createContext as createContext16,
  createRef as createRef8,
  useCallback as useCallback41,
  useEffect as useEffect36,
  useImperativeHandle as useImperativeHandle10,
  useMemo as useMemo52,
  useRef as useRef22,
  useState as useState36
} from "react";
import { useRemotionEnvironment } from "remotion";

// src/api/get-zod-schema-from-primitive.ts
var getZodSchemaFromPrimitive = (value, z) => {
  if (typeof value === "string") {
    return z.string();
  }
  if (typeof value === "number") {
    return z.number();
  }
  let stringified;
  try {
    stringified = JSON.stringify(value);
  } catch {}
  throw new Error(`visualControl(): Specify a schema for this value: ${stringified ?? "[non-serializable value]"}. See https://remotion.dev/docs/studio/visual-control`);
};

// src/components/get-zod-if-possible.tsx
import {
  createContext as createContext15,
  useContext as useContext32,
  useEffect as useEffect35,
  useMemo as useMemo51,
  useState as useState35
} from "react";
import { jsx as jsx92 } from "react/jsx-runtime";
var getZodIfPossible = async () => {
  try {
    const { z } = await import("zod");
    return z;
  } catch {
    return null;
  }
};
var getZTypesIfPossible = async () => {
  try {
    const mod = await import("@remotion/zod-types");
    return mod;
  } catch {
    return null;
  }
};
var useZodIfPossible = () => {
  const context = useContext32(ZodContext);
  return context?.zod ?? null;
};
var useZodTypesIfPossible = () => {
  const context = useContext32(ZodContext);
  return context?.zodTypes ?? null;
};
var ZodContext = createContext15(null);
var ZodProvider = ({ children }) => {
  const [zod, setZod] = useState35(null);
  const [zodTypes, setZodTypes] = useState35(null);
  useEffect35(() => {
    getZodIfPossible().then((z) => setZod(z));
  }, []);
  useEffect35(() => {
    getZTypesIfPossible().then((z) => setZodTypes(z));
  }, []);
  const contextValue = useMemo51(() => {
    return {
      zod,
      zodTypes
    };
  }, [zod, zodTypes]);
  return /* @__PURE__ */ jsx92(ZodContext.Provider, {
    value: contextValue,
    children
  });
};

// src/visual-controls/get-current-edited-value.ts
var getVisualControlEditedValue = ({
  handles,
  key
}) => {
  return handles?.[key]?.unsavedValue ?? null;
};

// src/visual-controls/VisualControls.tsx
import { jsx as jsx93 } from "react/jsx-runtime";
var VisualControlsTabActivatedContext = createContext16(false);
var VisualControlsContext = createContext16({
  handles: {}
});
var visualControlRef = createRef8();
var SetVisualControlsContext = createContext16({
  updateHandles: () => {
    throw new Error("updateHandles is not implemented");
  },
  updateValue: () => {
    throw new Error("updateValue is not implemented");
  },
  visualControl: () => {
    throw new Error("visualControl is not implemented");
  }
});
var VisualControlsProvider = ({ children }) => {
  const imperativeHandles = useRef22({});
  const [handles, setHandles] = useState36({});
  const state = useMemo52(() => {
    return {
      handles
    };
  }, [handles]);
  const setControl = useCallback41((key, value) => {
    const currentUnsaved = imperativeHandles.current?.[key]?.unsavedValue;
    const currentSavedState = imperativeHandles.current?.[key]?.valueInCode;
    const changedSavedValue = value.valueInCode !== currentSavedState;
    const changedUnsavedValue = currentUnsaved === undefined && value.valueInCode !== undefined;
    imperativeHandles.current = {
      ...imperativeHandles.current,
      [key]: {
        ...value,
        unsavedValue: currentUnsaved ?? value.valueInCode,
        valueInCode: value.valueInCode
      }
    };
    return {
      changed: changedSavedValue || changedUnsavedValue,
      currentValue: getVisualControlEditedValue({
        key,
        handles: imperativeHandles.current
      })
    };
  }, []);
  const z = useZodIfPossible();
  const changedRef = useRef22(false);
  const env = useRemotionEnvironment();
  const visualControl = useCallback41(function(key, value, schema) {
    if (handles && false) {}
    if (!env.isStudio) {
      return value;
    }
    if (!z) {
      return value;
    }
    const { changed, currentValue } = setControl(key, {
      valueInCode: value,
      schema: schema ?? getZodSchemaFromPrimitive(value, z),
      stack: new Error().stack
    });
    if (changed) {
      changedRef.current = true;
    }
    return currentValue;
  }, [setControl, handles, z, env.isStudio]);
  const updateHandles = useCallback41(() => {
    setHandles(() => {
      return imperativeHandles.current;
    });
  }, []);
  const updateValue = useCallback41((key, value) => {
    imperativeHandles.current = {
      ...imperativeHandles.current,
      [key]: {
        ...imperativeHandles.current[key],
        unsavedValue: value
      }
    };
    updateHandles();
  }, [updateHandles]);
  useImperativeHandle10(visualControlRef, () => {
    return {
      globalVisualControl: visualControl
    };
  }, [visualControl]);
  useEffect36(() => {
    const callback = () => {
      if (imperativeHandles.current) {
        updateHandles();
        changedRef.current = false;
      }
    };
    const interval = setInterval(callback, 100);
    return () => {
      clearInterval(interval);
    };
  }, [updateHandles]);
  const setState = useMemo52(() => {
    return {
      setControl,
      updateHandles,
      updateValue,
      visualControl
    };
  }, [setControl, updateHandles, updateValue, visualControl]);
  return /* @__PURE__ */ jsx93(VisualControlsTabActivatedContext.Provider, {
    value: Object.keys(state.handles).length > 0,
    children: /* @__PURE__ */ jsx93(VisualControlsContext.Provider, {
      value: state,
      children: /* @__PURE__ */ jsx93(SetVisualControlsContext.Provider, {
        value: setState,
        children
      })
    })
  });
};

// src/components/GlobalPropsEditorUpdateButton.tsx
import React61, { useCallback as useCallback44, useContext as useContext33 } from "react";
import { Internals as Internals28 } from "remotion";

// src/api/save-default-props.ts
import { getRemotionEnvironment as getRemotionEnvironment3 } from "remotion";

// src/components/RenderModal/SchemaEditor/extract-enum-json-paths.ts
var extractEnumJsonPaths = ({
  schema,
  zodRuntime,
  currentPath,
  zodTypes
}) => {
  const def = schema._def;
  const typeName = def.typeName;
  switch (typeName) {
    case zodRuntime.ZodFirstPartyTypeKind.ZodObject: {
      const shape = def.shape();
      const keys = Object.keys(shape);
      return keys.map((key) => {
        return extractEnumJsonPaths({
          schema: shape[key],
          zodRuntime,
          currentPath: [...currentPath, key],
          zodTypes
        });
      }).flat(1);
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodArray: {
      return extractEnumJsonPaths({
        schema: def.type,
        zodRuntime,
        currentPath: [...currentPath, "[]"],
        zodTypes
      });
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodUnion: {
      return def.options.map((option) => {
        return extractEnumJsonPaths({
          schema: option,
          zodRuntime,
          currentPath,
          zodTypes
        });
      }).flat(1);
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodDiscriminatedUnion: {
      return def.options.map((op) => {
        return extractEnumJsonPaths({
          schema: op,
          zodRuntime,
          currentPath,
          zodTypes
        });
      }).flat(1);
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodLiteral: {
      return [currentPath];
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodEffects: {
      if (zodTypes && schema._def.description === zodTypes.ZodZypesInternals.REMOTION_MATRIX_BRAND) {
        return [currentPath];
      }
      return extractEnumJsonPaths({
        schema: def.schema,
        zodRuntime,
        currentPath,
        zodTypes
      });
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodIntersection: {
      const { left: left3, right } = def;
      const leftValue = extractEnumJsonPaths({
        schema: left3,
        zodRuntime,
        currentPath,
        zodTypes
      });
      const rightValue = extractEnumJsonPaths({
        schema: right,
        zodRuntime,
        currentPath,
        zodTypes
      });
      return [...leftValue, ...rightValue];
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodTuple: {
      return def.items.map((item, i) => extractEnumJsonPaths({
        schema: item,
        zodRuntime,
        currentPath: [...currentPath, i],
        zodTypes
      })).flat(1);
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodRecord: {
      const values = extractEnumJsonPaths({
        schema: def.valueType,
        zodRuntime,
        currentPath: [...currentPath, "{}"],
        zodTypes
      });
      return values;
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodFunction: {
      throw new Error("Cannot create a value for type function");
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodEnum: {
      return [currentPath];
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodNativeEnum: {
      return [];
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodOptional: {
      const defType = def;
      const value = extractEnumJsonPaths({
        schema: defType.innerType,
        zodRuntime,
        currentPath,
        zodTypes
      });
      return value;
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodNullable: {
      const defType = def;
      const value = extractEnumJsonPaths({
        schema: defType.innerType,
        zodRuntime,
        currentPath,
        zodTypes
      });
      return value;
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodDefault: {
      const defType = def;
      return extractEnumJsonPaths({
        schema: defType.innerType,
        zodRuntime,
        currentPath,
        zodTypes
      });
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodCatch: {
      const defType = def;
      return extractEnumJsonPaths({
        schema: defType.innerType,
        zodRuntime,
        currentPath,
        zodTypes
      });
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodPromise: {
      return [];
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodBranded: {
      const defType = def;
      const value = extractEnumJsonPaths({
        schema: defType.type,
        zodRuntime,
        currentPath,
        zodTypes
      });
      return value;
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodPipeline: {
      const defType = def;
      const value = extractEnumJsonPaths({
        schema: defType.out,
        zodRuntime,
        currentPath,
        zodTypes
      });
      return value;
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodString:
    case zodRuntime.ZodFirstPartyTypeKind.ZodNumber:
    case zodRuntime.ZodFirstPartyTypeKind.ZodBigInt:
    case zodRuntime.ZodFirstPartyTypeKind.ZodBoolean:
    case zodRuntime.ZodFirstPartyTypeKind.ZodNaN:
    case zodRuntime.ZodFirstPartyTypeKind.ZodDate:
    case zodRuntime.ZodFirstPartyTypeKind.ZodSymbol:
    case zodRuntime.ZodFirstPartyTypeKind.ZodUndefined:
    case zodRuntime.ZodFirstPartyTypeKind.ZodNull:
    case zodRuntime.ZodFirstPartyTypeKind.ZodAny:
    case zodRuntime.ZodFirstPartyTypeKind.ZodUnknown:
    case zodRuntime.ZodFirstPartyTypeKind.ZodNever:
    case zodRuntime.ZodFirstPartyTypeKind.ZodVoid:
    case zodRuntime.ZodFirstPartyTypeKind.ZodMap:
    case zodRuntime.ZodFirstPartyTypeKind.ZodLazy:
    case zodRuntime.ZodFirstPartyTypeKind.ZodSet: {
      return [];
    }
    default:
      throw new Error("Not implemented: " + typeName);
  }
};

// src/api/helpers/calc-new-props.ts
import { Internals as Internals27, getRemotionEnvironment as getRemotionEnvironment2 } from "remotion";
var calcNewProps = (compositionId, defaultProps) => {
  if (!getRemotionEnvironment2().isStudio) {
    throw new Error("saveDefaultProps can only be called in the Remotion Studio.");
  }
  const { compositionsRef, editorPropsProviderRef } = Internals27;
  const compositionsStore = compositionsRef.current;
  if (!compositionsStore) {
    throw new Error("No compositions ref found. Are you in the Remotion Studio and are the Remotion versions aligned?");
  }
  const compositions = compositionsStore.getCompositions();
  const composition = compositions.find((c) => c.id === compositionId);
  if (!composition) {
    throw new Error(`No composition with the ID ${compositionId} found. Available compositions: ${compositions.map((c) => c.id).join(", ")}`);
  }
  const propsStore = editorPropsProviderRef.current;
  if (!propsStore) {
    throw new Error("No props store found. Are you in the Remotion Studio and are the Remotion versions aligned?");
  }
  const savedDefaultProps = composition.defaultProps ?? {};
  const unsavedDefaultProps = propsStore.getProps()[compositionId] ?? savedDefaultProps;
  const generatedDefaultProps = defaultProps({
    schema: composition.schema,
    savedDefaultProps,
    unsavedDefaultProps
  });
  return {
    composition,
    generatedDefaultProps
  };
};

// src/api/save-default-props.ts
var saveDefaultProps = async ({
  compositionId,
  defaultProps
}) => {
  if (!getRemotionEnvironment3().isStudio) {
    throw new Error("saveDefaultProps() is only available in the Studio");
  }
  if (window.remotion_isReadOnlyStudio) {
    throw new Error("saveDefaultProps() is not available in read-only Studio");
  }
  try {
    await import("zod");
  } catch {
    throw new Error('"zod" is required to use saveDefaultProps(), but is not installed.');
  }
  const z = await import("zod");
  let zodTypes = null;
  try {
    zodTypes = await import("@remotion/zod-types");
  } catch {}
  const { generatedDefaultProps, composition } = calcNewProps(compositionId, defaultProps);
  const res = await callUpdateDefaultPropsApi(compositionId, generatedDefaultProps, composition.schema ? extractEnumJsonPaths({
    schema: composition.schema,
    zodRuntime: z,
    currentPath: [],
    zodTypes
  }) : []);
  if (res.success) {
    return Promise.resolve();
  }
  const err = new Error(res.reason);
  err.stack = res.stack;
  return Promise.reject(err);
};

// src/components/RenderModal/SchemaEditor/SchemaResetButton.tsx
import { useCallback as useCallback42 } from "react";
import { jsx as jsx94 } from "react/jsx-runtime";
var icon2 = {
  height: 14,
  color: "currentColor"
};
var SchemaResetButton = ({ onClick }) => {
  const renderAction = useCallback42((color) => {
    return /* @__PURE__ */ jsx94("svg", {
      style: icon2,
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ jsx94("path", {
        fill: color,
        d: "M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"
      })
    });
  }, []);
  return /* @__PURE__ */ jsx94(InlineAction, {
    renderAction,
    onClick
  });
};

// src/components/RenderModal/SchemaEditor/SchemaSaveButton.tsx
import { useCallback as useCallback43 } from "react";
import { jsx as jsx95 } from "react/jsx-runtime";
var icon3 = {
  height: 14,
  color: "currentColor"
};
var SchemaSaveButton = ({ onClick, disabled }) => {
  const renderAction = useCallback43((color) => {
    return /* @__PURE__ */ jsx95("svg", {
      style: icon3,
      viewBox: "0 0 448 512",
      children: /* @__PURE__ */ jsx95("path", {
        fill: disabled ? LIGHT_TEXT : color,
        d: "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
      })
    });
  }, [disabled]);
  return /* @__PURE__ */ jsx95(InlineAction, {
    renderAction,
    onClick,
    disabled
  });
};

// src/components/GlobalPropsEditorUpdateButton.tsx
import { jsx as jsx96, jsxs as jsxs41 } from "react/jsx-runtime";
var container24 = {
  display: "inline-block",
  flexDirection: "row"
};
var GlobalPropsEditorUpdateButton = ({ compositionId, currentDefaultProps }) => {
  const { fastRefreshes } = useContext33(Internals28.NonceContext);
  const [disabled, setDisabled] = React61.useState(false);
  const onClicked = useCallback44(() => {
    setDisabled(true);
    window.remotion_ignoreFastRefreshUpdate = fastRefreshes + 1;
    saveDefaultProps({
      compositionId,
      defaultProps: () => currentDefaultProps
    }).catch((err) => {
      showNotification(`Cannot update default props: ${err.stack}`, 2000);
    }).finally(() => {
      setDisabled(true);
    });
  }, [compositionId, currentDefaultProps, fastRefreshes]);
  const onReset = useCallback44(() => {
    window.remotion_ignoreFastRefreshUpdate = null;
    window.dispatchEvent(new CustomEvent(Internals28.PROPS_UPDATED_EXTERNALLY, {
      detail: {
        resetUnsaved: compositionId
      }
    }));
  }, [compositionId]);
  return /* @__PURE__ */ jsxs41("div", {
    style: container24,
    children: [
      /* @__PURE__ */ jsx96(SchemaResetButton, {
        onClick: onReset
      }),
      /* @__PURE__ */ jsx96(SchemaSaveButton, {
        disabled,
        onClick: onClicked
      })
    ]
  });
};

// src/components/RenderModal/DataEditor.tsx
import React92, {
  useCallback as useCallback68,
  useContext as useContext36,
  useEffect as useEffect43,
  useMemo as useMemo79,
  useState as useState49
} from "react";
import { getInputProps, Internals as Internals31 } from "remotion";
import { NoReactInternals as NoReactInternals10 } from "remotion/no-react";

// src/components/NewComposition/ValidationMessage.tsx
import { useMemo as useMemo53 } from "react";
import { jsx as jsx97, jsxs as jsxs42 } from "react/jsx-runtime";
var WarningTriangle = (props) => {
  return /* @__PURE__ */ jsx97("svg", {
    viewBox: "0 0 576 512",
    ...props,
    children: /* @__PURE__ */ jsx97("path", {
      d: "M248.747 204.705l6.588 112c.373 6.343 5.626 11.295 11.979 11.295h41.37a12 12 0 0 0 11.979-11.295l6.588-112c.405-6.893-5.075-12.705-11.979-12.705h-54.547c-6.903 0-12.383 5.812-11.978 12.705zM330 384c0 23.196-18.804 42-42 42s-42-18.804-42-42 18.804-42 42-42 42 18.804 42 42zm-.423-360.015c-18.433-31.951-64.687-32.009-83.154 0L6.477 440.013C-11.945 471.946 11.118 512 48.054 512H527.94c36.865 0 60.035-39.993 41.577-71.987L329.577 23.985zM53.191 455.002L282.803 57.008c2.309-4.002 8.085-4.002 10.394 0l229.612 397.993c2.308 4-.579 8.998-5.197 8.998H58.388c-4.617.001-7.504-4.997-5.197-8.997z"
    })
  });
};
var style6 = {
  width: 12,
  height: 12,
  flexShrink: 0
};
var container25 = {
  maxWidth: 500
};
var label4 = {
  fontSize: 13,
  color: "white",
  fontFamily: "sans-serif"
};
var ValidationMessage = ({ message, align, type }) => {
  const finalStyle = useMemo53(() => {
    return {
      ...style6,
      fill: type === "warning" ? WARNING_COLOR : FAIL_COLOR
    };
  }, [type]);
  return /* @__PURE__ */ jsx97("div", {
    style: container25,
    children: /* @__PURE__ */ jsxs42(Row, {
      align: "center",
      justify: align,
      children: [
        /* @__PURE__ */ jsx97(WarningTriangle, {
          style: finalStyle
        }),
        /* @__PURE__ */ jsx97(Spacing, {
          x: 1
        }),
        /* @__PURE__ */ jsx97("div", {
          style: label4,
          children: message
        })
      ]
    })
  });
};

// src/components/SegmentedControl.tsx
import { useCallback as useCallback45, useMemo as useMemo54, useState as useState37 } from "react";
import { jsx as jsx98 } from "react/jsx-runtime";
var container26 = {
  display: "flex",
  flexDirection: "row",
  overflow: "hidden",
  border: "1px solid " + INPUT_BORDER_COLOR_UNHOVERED,
  flexWrap: "wrap",
  maxWidth: 350,
  justifyContent: "flex-end"
};
var item = {
  display: "flex",
  fontSize: 15,
  padding: "4px 12px",
  cursor: "pointer",
  appearance: "none",
  border: "none",
  flex: 1,
  justifyContent: "center",
  whiteSpace: "nowrap"
};
var SegmentedControl = ({ items, needsWrapping }) => {
  const controlStyle = useMemo54(() => {
    if (needsWrapping) {
      return {
        ...container26,
        flexWrap: "wrap",
        maxWidth: "248px",
        justifyContent: "flex-end",
        marginBottom: "8px"
      };
    }
    return {
      ...container26
    };
  }, [needsWrapping]);
  return /* @__PURE__ */ jsx98("div", {
    style: controlStyle,
    children: items.map((i) => {
      return /* @__PURE__ */ jsx98(Item, {
        onClick: i.onClick,
        selected: i.selected,
        children: i.label
      }, i.key);
    })
  });
};
var Item = ({ selected, onClick, children }) => {
  const [hovered, setHovered] = useState37(false);
  const { tabIndex } = useZIndex();
  const onPointerEnter = useCallback45(() => {
    setHovered(true);
  }, []);
  const onPointerLeave = useCallback45(() => {
    setHovered(false);
  }, []);
  const itemStyle3 = useMemo54(() => {
    return {
      ...item,
      backgroundColor: selected ? INPUT_BACKGROUND : "transparent",
      color: selected ? "white" : hovered ? "white" : LIGHT_TEXT
    };
  }, [hovered, selected]);
  return /* @__PURE__ */ jsx98("button", {
    type: "button",
    onPointerEnter,
    onPointerLeave,
    style: itemStyle3,
    tabIndex,
    onClick,
    children
  });
};

// src/components/RenderModal/RenderModalJSONPropsEditor.tsx
import React65, { useCallback as useCallback46, useEffect as useEffect37, useMemo as useMemo56 } from "react";
import { NoReactInternals as NoReactInternals8 } from "remotion/no-react";

// src/components/RenderModal/SchemaEditor/ZodErrorMessages.tsx
import { useMemo as useMemo55 } from "react";
import { jsx as jsx99, jsxs as jsxs43 } from "react/jsx-runtime";
var schemaLabel = {
  fontSize: 14,
  color: LIGHT_TEXT
};
var jsonLabel = {
  color: "white",
  fontSize: 13,
  fontFamily: "sans-serif",
  display: "flex",
  alignItems: "center"
};
var triangleStyle = {
  width: 12,
  height: 12,
  flexShrink: 0,
  fill: FAIL_COLOR
};
var ZodErrorMessages = ({ zodValidationResult, viewTab }) => {
  if (zodValidationResult.success) {
    throw new Error("Expected error");
  }
  const style7 = useMemo55(() => {
    return viewTab === "json" ? jsonLabel : schemaLabel;
  }, [viewTab]);
  const code = useMemo55(() => {
    return {
      ...schemaLabel,
      fontFamily: "monospace"
    };
  }, []);
  if (viewTab === "json") {
    return /* @__PURE__ */ jsx99("div", {
      children: zodValidationResult.error.errors.map((error) => {
        return /* @__PURE__ */ jsxs43("div", {
          style: style7,
          children: [
            /* @__PURE__ */ jsx99(WarningTriangle, {
              style: triangleStyle
            }),
            /* @__PURE__ */ jsx99(Spacing, {
              x: 1
            }),
            error.path.length === 0 ? "Root" : error.path.join("."),
            ":",
            " ",
            error.message
          ]
        }, error.path.join("."));
      })
    });
  }
  return /* @__PURE__ */ jsx99("div", {
    children: zodValidationResult.error.errors.map((error) => {
      return /* @__PURE__ */ jsxs43("div", {
        style: style7,
        children: [
          "-",
          " ",
          /* @__PURE__ */ jsx99("code", {
            style: code,
            children: error.path.length === 0 ? "Root" : error.path.join(".")
          }),
          ": ",
          error.message
        ]
      }, error.path.join("."));
    })
  });
};

// src/components/RenderModal/SchemaEditor/deep-equal.ts
function deepEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (a instanceof Date && b instanceof Date) {
    return a.getTime() === b.getTime();
  }
  if (typeof a !== "object" || a === null || typeof b !== "object" || b === null) {
    return false;
  }
  const keysA = Object.keys(a);
  const keysB = Object.keys(b);
  if (keysA.length !== keysB.length) {
    return false;
  }
  for (const key of keysA) {
    if (!keysB.includes(key) || !deepEqual(a[key], b[key])) {
      return false;
    }
  }
  return true;
}

// src/components/RenderModal/RenderModalJSONPropsEditor.tsx
import { jsx as jsx100, jsxs as jsxs44 } from "react/jsx-runtime";
var style7 = {
  fontFamily: "monospace",
  flex: 1
};
var scrollable = {
  padding: "8px 12px",
  display: "flex",
  flexDirection: "column",
  flex: 1
};
var parseJSON = (str, schema) => {
  try {
    const value = NoReactInternals8.deserializeJSONWithSpecialTypes(str);
    const zodValidation = schema.safeParse(value);
    return { str, value, validJSON: true, zodValidation };
  } catch (e) {
    return { str, validJSON: false, error: e.message };
  }
};
var RenderModalJSONPropsEditor = ({
  setValue,
  value,
  defaultProps,
  onSave,
  showSaveButton,
  serializedJSON,
  schema
}) => {
  if (serializedJSON === null) {
    throw new Error("expecting serializedJSON to be defined");
  }
  const keybindings = useKeybinding();
  const [localValue, setLocalValue] = React65.useState(() => {
    return parseJSON(serializedJSON.serializedString, schema);
  });
  const onPretty = useCallback46(() => {
    if (!localValue.validJSON) {
      return;
    }
    const parsed = JSON.parse(localValue.str);
    setLocalValue({ ...localValue, str: JSON.stringify(parsed, null, 2) });
  }, [localValue, setLocalValue]);
  const onChange = useCallback46((e) => {
    const parsed = parseJSON(e.target.value, schema);
    if (parsed.validJSON) {
      const validationResult = schema.safeParse(parsed.value);
      setLocalValue({
        str: e.target.value,
        value: parsed.value,
        validJSON: parsed.validJSON,
        zodValidation: validationResult
      });
      if (validationResult.success) {
        setValue(parsed.value);
      }
    } else {
      setLocalValue({
        str: e.target.value,
        validJSON: parsed.validJSON,
        error: parsed.error
      });
    }
  }, [schema, setValue]);
  const hasChanged = useMemo56(() => {
    return !deepEqual(value, defaultProps);
  }, [defaultProps, value]);
  useEffect37(() => {
    setUnsavedProps(hasChanged);
  }, [hasChanged]);
  const onQuickSave = useCallback46(() => {
    if (hasChanged) {
      onSave();
    }
  }, [hasChanged, onSave]);
  useEffect37(() => {
    setLocalValue(parseJSON(localValue.str, schema));
  }, [localValue.str, schema]);
  useEffect37(() => {
    const save = keybindings.registerKeybinding({
      event: "keydown",
      key: "s",
      commandCtrlKey: true,
      callback: onQuickSave,
      preventDefault: true,
      triggerIfInputFieldFocused: true,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      save.unregister();
    };
  }, [keybindings, onQuickSave, onSave]);
  const reset = useCallback46(() => {
    setValue(defaultProps);
    setLocalValue(parseJSON(JSON.stringify(defaultProps, null, 2), schema));
  }, [defaultProps, schema, setValue]);
  const textAreaStyle = useMemo56(() => {
    const fail = !localValue.validJSON || !localValue.zodValidation.success;
    if (!fail) {
      return style7;
    }
    return {
      ...style7,
      borderColor: FAIL_COLOR
    };
  }, [localValue]);
  return /* @__PURE__ */ jsxs44("div", {
    style: scrollable,
    children: [
      /* @__PURE__ */ jsx100(RemTextarea, {
        onChange,
        value: localValue.str,
        status: localValue.validJSON ? "ok" : "error",
        style: textAreaStyle
      }),
      /* @__PURE__ */ jsx100(Spacing, {
        y: 1
      }),
      localValue.validJSON === false ? /* @__PURE__ */ jsx100(ValidationMessage, {
        align: "flex-start",
        message: localValue.error,
        type: "error"
      }) : localValue.zodValidation.success === false ? /* @__PURE__ */ jsx100(ZodErrorMessages, {
        zodValidationResult: localValue.zodValidation,
        viewTab: "json"
      }) : null,
      /* @__PURE__ */ jsx100(Spacing, {
        y: 1
      }),
      /* @__PURE__ */ jsxs44(Row, {
        children: [
          /* @__PURE__ */ jsx100(Button, {
            disabled: !(hasChanged || !localValue.validJSON),
            onClick: reset,
            children: "Reset"
          }),
          /* @__PURE__ */ jsx100(Flex, {}),
          /* @__PURE__ */ jsx100(Button, {
            disabled: !localValue.validJSON,
            onClick: onPretty,
            children: "Format"
          }),
          /* @__PURE__ */ jsx100(Spacing, {
            x: 1
          }),
          showSaveButton ? /* @__PURE__ */ jsx100(Button, {
            onClick: onSave,
            disabled: !(localValue.validJSON && localValue.zodValidation.success) || !localValue.validJSON || !hasChanged,
            children: "Save"
          }) : null
        ]
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/SchemaEditor.tsx
import { useCallback as useCallback66, useEffect as useEffect42, useMemo as useMemo77, useState as useState48 } from "react";
import { Internals as Internals30 } from "remotion";

// src/components/RenderModal/SchemaEditor/SchemaErrorMessages.tsx
import { jsx as jsx101, jsxs as jsxs45 } from "react/jsx-runtime";
var explainer = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  padding: "0 12px",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  background: BACKGROUND
};
var errorExplanation = {
  fontSize: 14,
  color: LIGHT_TEXT,
  fontFamily: "sans-serif",
  lineHeight: 1.5
};
var codeSnippet = {
  fontSize: 14,
  color: BLUE,
  fontFamily: "monospace"
};
var errorContainer = {
  padding: "8px 12px",
  overflowY: "auto"
};
var openDocs = () => {
  window.open("https://www.remotion.dev/docs/schemas");
};
var ZodNotInstalled = () => {
  return /* @__PURE__ */ jsxs45("div", {
    style: explainer,
    children: [
      /* @__PURE__ */ jsxs45("div", {
        style: errorExplanation,
        children: [
          "Install ",
          /* @__PURE__ */ jsx101("code", {
            style: inlineCodeSnippet,
            children: "zod"
          }),
          " as a dependency to interactively control the props of the composition."
        ]
      }),
      /* @__PURE__ */ jsx101(Spacing, {
        y: 2,
        block: true
      }),
      /* @__PURE__ */ jsx101(Button, {
        onClick: openDocs,
        children: "Learn how"
      })
    ]
  });
};
var NoSchemaDefined = () => {
  return /* @__PURE__ */ jsxs45("div", {
    style: explainer,
    children: [
      /* @__PURE__ */ jsxs45("div", {
        style: errorExplanation,
        children: [
          "Make the props of this composition interactively editable by adding a",
          " ",
          /* @__PURE__ */ jsx101("code", {
            style: inlineCodeSnippet,
            children: "schema"
          }),
          " prop to the",
          " ",
          /* @__PURE__ */ jsx101("code", {
            style: inlineCodeSnippet,
            children: "<Composition>"
          }),
          " component."
        ]
      }),
      /* @__PURE__ */ jsx101(Spacing, {
        y: 2,
        block: true
      }),
      /* @__PURE__ */ jsx101(Button, {
        onClick: openDocs,
        children: "Learn how"
      })
    ]
  });
};
var NoDefaultProps = () => {
  return /* @__PURE__ */ jsxs45("div", {
    style: explainer,
    children: [
      /* @__PURE__ */ jsxs45("div", {
        style: errorExplanation,
        children: [
          "The schema can not be edited because the",
          " ",
          /* @__PURE__ */ jsx101("code", {
            style: inlineCodeSnippet,
            children: "defaultProps"
          }),
          " prop in the",
          " ",
          /* @__PURE__ */ jsx101("code", {
            style: inlineCodeSnippet,
            children: "<Composition>"
          }),
          " does not exist."
        ]
      }),
      /* @__PURE__ */ jsx101(Spacing, {
        y: 1
      }),
      /* @__PURE__ */ jsxs45("div", {
        style: errorExplanation,
        children: [
          "Fix the schema by adding a",
          " ",
          /* @__PURE__ */ jsx101("code", {
            style: inlineCodeSnippet,
            children: "defaultProps"
          }),
          " prop to your composition."
        ]
      }),
      /* @__PURE__ */ jsx101(Spacing, {
        y: 2,
        block: true
      }),
      /* @__PURE__ */ jsx101(Button, {
        onClick: openDocs,
        children: "Learn more"
      })
    ]
  });
};
var InvalidDefaultProps = ({ zodValidationResult }) => {
  return /* @__PURE__ */ jsxs45("div", {
    style: errorContainer,
    children: [
      /* @__PURE__ */ jsxs45("div", {
        style: errorExplanation,
        children: [
          "The schema can not be edited because the",
          " ",
          /* @__PURE__ */ jsx101("code", {
            style: inlineCodeSnippet,
            children: "defaultProps"
          }),
          " prop in the",
          " ",
          /* @__PURE__ */ jsx101("code", {
            style: inlineCodeSnippet,
            children: "<Composition>"
          }),
          " is not valid:"
        ]
      }),
      /* @__PURE__ */ jsx101(Spacing, {
        y: 1,
        block: true
      }),
      /* @__PURE__ */ jsx101(ZodErrorMessages, {
        zodValidationResult,
        viewTab: "schema"
      }),
      /* @__PURE__ */ jsx101(Spacing, {
        y: 1,
        block: true
      }),
      /* @__PURE__ */ jsxs45("div", {
        style: errorExplanation,
        children: [
          "Fix the schema by changing the",
          " ",
          /* @__PURE__ */ jsx101("code", {
            style: inlineCodeSnippet,
            children: "defaultProps"
          }),
          " prop in your composition so it does not give a type error."
        ]
      })
    ]
  });
};
var InvalidSchema = ({ zodValidationResult, reset }) => {
  return /* @__PURE__ */ jsxs45("div", {
    style: errorContainer,
    children: [
      /* @__PURE__ */ jsx101("div", {
        style: errorExplanation,
        children: "The data does not satisfy the schema:"
      }),
      /* @__PURE__ */ jsx101(Spacing, {
        y: 1,
        block: true
      }),
      /* @__PURE__ */ jsx101(ZodErrorMessages, {
        zodValidationResult,
        viewTab: "schema"
      }),
      /* @__PURE__ */ jsx101(Spacing, {
        y: 1,
        block: true
      }),
      /* @__PURE__ */ jsx101("div", {
        style: errorExplanation,
        children: "Fix the schema using the JSON editor."
      }),
      /* @__PURE__ */ jsx101(Spacing, {
        y: 1,
        block: true
      }),
      /* @__PURE__ */ jsxs45("div", {
        style: errorExplanation,
        children: [
          "Alternatively, reset the data to the",
          " ",
          /* @__PURE__ */ jsx101("code", {
            style: inlineCodeSnippet,
            children: "defaultProps"
          }),
          " that you have defined."
        ]
      }),
      /* @__PURE__ */ jsx101(Spacing, {
        y: 1,
        block: true
      }),
      /* @__PURE__ */ jsx101(Button, {
        onClick: reset,
        children: "Reset props"
      })
    ]
  });
};
var TopLevelZodValue = ({ typeReceived }) => {
  return /* @__PURE__ */ jsxs45("div", {
    style: explainer,
    children: [
      /* @__PURE__ */ jsxs45("div", {
        style: errorExplanation,
        children: [
          "The top-level type of the schema must be a pure",
          " ",
          /* @__PURE__ */ jsx101("code", {
            style: codeSnippet,
            children: "z.object"
          }),
          ". Instead got a schema of type",
          " ",
          /* @__PURE__ */ jsx101("code", {
            style: codeSnippet,
            children: typeReceived
          })
        ]
      }),
      /* @__PURE__ */ jsx101(Spacing, {
        y: 1
      }),
      /* @__PURE__ */ jsx101("div", {
        style: errorExplanation,
        children: "Fix the schema by changing the top-level Zod type to an object."
      }),
      /* @__PURE__ */ jsx101(Spacing, {
        y: 2,
        block: true
      }),
      /* @__PURE__ */ jsx101(Button, {
        onClick: openDocs,
        children: "Learn more"
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodObjectEditor.tsx
import React89, { useMemo as useMemo76, useState as useState47 } from "react";

// src/components/RenderModal/layout.ts
var optionRow = {
  display: "flex",
  flexDirection: "row",
  minHeight: 40,
  paddingLeft: 16,
  paddingRight: 16,
  paddingTop: 8,
  paddingBottom: 8
};
var label5 = {
  width: 220,
  fontSize: 15,
  lineHeight: "40px",
  color: LIGHT_TEXT,
  fontFamily: "sans-serif",
  display: "flex",
  flexDirection: "row",
  alignItems: "center"
};
var rightRow = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end",
  alignSelf: "center",
  flex: 1
};
var input = {
  minWidth: 250
};
var fieldSetText = {
  color: LIGHT_TEXT,
  fontSize: 14,
  fontFamily: "monospace"
};
var fieldsetLabel = {
  ...fieldSetText,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  width: "100%"
};

// src/components/RenderModal/SchemaEditor/Fieldset.tsx
import { createContext as createContext17, useContext as useContext34, useMemo as useMemo57 } from "react";
import { jsx as jsx102 } from "react/jsx-runtime";
var SCHEMA_EDITOR_FIELDSET_PADDING = 10;
var AlreadyPaddedRightContext = createContext17(false);
var Fieldset = ({ children, shouldPad }) => {
  const alreadyPadded = useContext34(AlreadyPaddedRightContext);
  const style8 = useMemo57(() => {
    if (shouldPad) {
      return {
        padding: SCHEMA_EDITOR_FIELDSET_PADDING,
        paddingTop: SCHEMA_EDITOR_FIELDSET_PADDING / 2,
        paddingRight: alreadyPadded ? 0 : SCHEMA_EDITOR_FIELDSET_PADDING
      };
    }
    return {};
  }, [alreadyPadded, shouldPad]);
  const content = /* @__PURE__ */ jsx102("div", {
    style: style8,
    children
  });
  if (shouldPad) {
    return /* @__PURE__ */ jsx102(AlreadyPaddedRightContext.Provider, {
      value: true,
      children: content
    });
  }
  return content;
};

// src/components/RenderModal/SchemaEditor/SchemaLabel.tsx
import { useCallback as useCallback48, useMemo as useMemo58, useState as useState38 } from "react";

// src/components/RenderModal/InlineRemoveButton.tsx
import { useCallback as useCallback47 } from "react";
import { jsx as jsx103 } from "react/jsx-runtime";
var clearIcon = {
  height: 14,
  color: "currentColor"
};
var InlineRemoveButton = ({ onClick }) => {
  const renderAction = useCallback47((color) => {
    return /* @__PURE__ */ jsx103("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 320 512",
      style: clearIcon,
      children: /* @__PURE__ */ jsx103("path", {
        d: "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z",
        fill: color
      })
    });
  }, []);
  return /* @__PURE__ */ jsx103(InlineAction, {
    renderAction,
    onClick
  });
};

// src/components/RenderModal/SchemaEditor/get-schema-label.ts
var getSchemaLabel = (jsonPath) => {
  const lastKey = jsonPath[jsonPath.length - 1];
  if (typeof lastKey === "number") {
    const secondLastKey = jsonPath[jsonPath.length - 2];
    if (typeof secondLastKey === "undefined") {
      return `[${lastKey}]:`;
    }
    return `${lastKey}:`;
  }
  return `${lastKey}:`;
};

// src/components/RenderModal/SchemaEditor/scroll-to-default-props-path.ts
import React67 from "react";
var DEFAULT_PROPS_PATH_CLASSNAME = "__remotion-default-props-editor-label";
var DEFAULT_PROPS_PATH_ACTIVE_CLASSNAME = "__remotion-default-props-editor-label-active";
var defaultPropsEditorScrollableAreaRef = React67.createRef();

// src/components/RenderModal/SchemaEditor/SchemaLabel.tsx
import { jsx as jsx104, jsxs as jsxs46 } from "react/jsx-runtime";
var compactStyles = {
  fontSize: 15,
  color: LIGHT_TEXT,
  fontFamily: "sans-serif",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  flex: 1
};
var SchemaLabel = ({
  jsonPath,
  isDefaultValue,
  onReset,
  onSave,
  showSaveButton,
  onRemove,
  saving,
  valid,
  saveDisabledByParent,
  suffix: suffix2,
  handleClick
}) => {
  const [clickableButtonHovered, setClickableButtonHovered] = useState38(false);
  const disableSave = saving || !valid || saveDisabledByParent;
  const labelStyle4 = useMemo58(() => {
    return {
      fontFamily: "monospace",
      fontSize: 14,
      color: valid ? clickableButtonHovered ? "white" : LIGHT_TEXT : FAIL_COLOR,
      lineHeight: "24px"
    };
  }, [clickableButtonHovered, valid]);
  const onClickablePointerEnter = useCallback48(() => {
    setClickableButtonHovered(true);
  }, []);
  const onClickablePointerLeave = useCallback48(() => {
    setClickableButtonHovered(false);
  }, []);
  const labelContent = /* @__PURE__ */ jsxs46("span", {
    style: labelStyle4,
    children: [
      getSchemaLabel(jsonPath),
      " ",
      suffix2 ? suffix2 : null
    ]
  });
  return /* @__PURE__ */ jsxs46("div", {
    style: compactStyles,
    className: DEFAULT_PROPS_PATH_CLASSNAME,
    "data-json-path": jsonPath.join("."),
    children: [
      handleClick ? /* @__PURE__ */ jsx104("button", {
        onPointerEnter: onClickablePointerEnter,
        onPointerLeave: onClickablePointerLeave,
        type: "button",
        onClick: handleClick,
        style: { border: "none", padding: 0 },
        children: labelContent
      }) : labelContent,
      /* @__PURE__ */ jsx104(Flex, {}),
      isDefaultValue ? null : /* @__PURE__ */ jsx104(SchemaResetButton, {
        onClick: onReset
      }),
      isDefaultValue ? null : showSaveButton ? /* @__PURE__ */ jsx104(SchemaSaveButton, {
        onClick: onSave,
        disabled: disableSave
      }) : null,
      onRemove ? /* @__PURE__ */ jsx104(InlineRemoveButton, {
        onClick: onRemove
      }) : null
    ]
  });
};

// src/components/RenderModal/SchemaEditor/SchemaSeparationLine.tsx
import { useCallback as useCallback49, useMemo as useMemo59, useState as useState39 } from "react";

// src/icons/plus.tsx
import { jsx as jsx105 } from "react/jsx-runtime";
var Plus = ({ color, ...props }) => {
  return /* @__PURE__ */ jsx105("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    children: /* @__PURE__ */ jsx105("path", {
      fill: color,
      d: "M432 256c0 17.69-14.33 32.01-32 32.01H256v144c0 17.69-14.33 31.99-32 31.99s-32-14.3-32-31.99v-144H48c-17.67 0-32-14.32-32-32.01s14.33-31.99 32-31.99H192v-144c0-17.69 14.33-32.01 32-32.01s32 14.32 32 32.01v144h144C417.7 224 432 238.3 432 256z"
    })
  });
};

// src/components/RenderModal/SchemaEditor/create-zod-values.ts
var createZodValues = (schema, zodRuntime, zodTypes) => {
  if (!schema) {
    throw new Error("Invalid zod schema");
  }
  const def = schema._def;
  const typeName = def.typeName;
  switch (typeName) {
    case zodRuntime.ZodFirstPartyTypeKind.ZodString:
      return "";
    case zodRuntime.ZodFirstPartyTypeKind.ZodNumber: {
      for (const check of def.checks) {
        if (check.kind === "min") {
          return check.value;
        }
        if (check.kind === "max" && check.value < 0) {
          return check.value;
        }
      }
      return 0;
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodBigInt:
      return BigInt(0);
    case zodRuntime.ZodFirstPartyTypeKind.ZodBoolean:
      return false;
    case zodRuntime.ZodFirstPartyTypeKind.ZodNaN:
      return NaN;
    case zodRuntime.ZodFirstPartyTypeKind.ZodDate:
      return new Date;
    case zodRuntime.ZodFirstPartyTypeKind.ZodSymbol:
      return Symbol("remotion");
    case zodRuntime.ZodFirstPartyTypeKind.ZodUndefined:
      return;
    case zodRuntime.ZodFirstPartyTypeKind.ZodNull:
      return null;
    case zodRuntime.ZodFirstPartyTypeKind.ZodAny:
      throw new Error("Cannot create a value for type z.any()");
    case zodRuntime.ZodFirstPartyTypeKind.ZodUnknown:
      throw new Error("Cannot create a value for type z.unknown()");
    case zodRuntime.ZodFirstPartyTypeKind.ZodNever:
      throw new Error("Cannot create a value for type z.never()");
    case zodRuntime.ZodFirstPartyTypeKind.ZodVoid:
      return;
    case zodRuntime.ZodFirstPartyTypeKind.ZodObject: {
      const shape = def.shape();
      const keys = Object.keys(shape);
      const returnValue = keys.reduce((existing, key) => {
        existing[key] = createZodValues(shape[key], zodRuntime, zodTypes);
        return existing;
      }, {});
      return returnValue;
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodArray: {
      return [
        createZodValues(def.type, zodRuntime, zodTypes)
      ];
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodUnion: {
      const firstOptions = def.options[0];
      return firstOptions ? createZodValues(firstOptions, zodRuntime, zodTypes) : undefined;
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodDiscriminatedUnion: {
      const options = def.options[0];
      return createZodValues(options, zodRuntime, zodTypes);
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodLiteral: {
      return def.value;
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodEffects: {
      if (zodTypes && schema._def.description === zodTypes.ZodZypesInternals.REMOTION_COLOR_BRAND) {
        return "#ffffff";
      }
      if (zodTypes && schema._def.description === zodTypes.ZodZypesInternals.REMOTION_TEXTAREA_BRAND) {
        return "";
      }
      if (zodTypes && schema._def.description === zodTypes.ZodZypesInternals.REMOTION_MATRIX_BRAND) {
        return [
          [1, 0, 0],
          [0, 1, 0],
          [0, 0, 1]
        ];
      }
      return createZodValues(def.schema, zodRuntime, zodTypes);
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodIntersection: {
      const { left: left3, right } = def;
      const leftValue = createZodValues(left3, zodRuntime, zodTypes);
      if (typeof leftValue !== "object") {
        throw new Error("Cannot create value for type z.intersection: Left side is not an object");
      }
      const rightValue = createZodValues(right, zodRuntime, zodTypes);
      if (typeof rightValue !== "object") {
        throw new Error("Cannot create value for type z.intersection: Right side is not an object");
      }
      return { ...leftValue, ...rightValue };
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodTuple: {
      const items = def.items.map((item2) => createZodValues(item2, zodRuntime, zodTypes));
      return items;
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodRecord: {
      const values = createZodValues(def.valueType, zodRuntime, zodTypes);
      return { key: values };
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodMap: {
      const defType = def;
      const values = createZodValues(defType.valueType, zodRuntime, zodTypes);
      const key = createZodValues(defType.keyType, zodRuntime, zodTypes);
      return new Map([[key, values]]);
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodLazy: {
      const defType = def;
      const type = defType.getter();
      return createZodValues(type, zodRuntime, zodTypes);
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodSet: {
      const defType = def;
      const values = createZodValues(defType.valueType, zodRuntime, zodTypes);
      return new Set([values]);
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodFunction: {
      throw new Error("Cannot create a value for type function");
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodEnum: {
      const { values } = def;
      return values[0];
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodNativeEnum: {
      return 0;
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodOptional: {
      const defType = def;
      const value = createZodValues(defType.innerType, zodRuntime, zodTypes);
      return value;
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodNullable: {
      const defType = def;
      const value = createZodValues(defType.innerType, zodRuntime, zodTypes);
      return value;
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodDefault: {
      const defType = def;
      return defType.defaultValue();
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodCatch: {
      const defType = def;
      const value = createZodValues(defType.innerType, zodRuntime, zodTypes);
      return value;
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodPromise: {
      const defType = def;
      const value = createZodValues(defType.type, zodRuntime, zodTypes);
      return Promise.resolve(value);
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodBranded: {
      const defType = def;
      const value = createZodValues(defType.type, zodRuntime, zodTypes);
      return value;
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodPipeline: {
      const defType = def;
      const value = createZodValues(defType.out, zodRuntime, zodTypes);
      return value;
    }
    default:
      throw new Error("Not implemented: " + typeName);
  }
};

// src/components/RenderModal/SchemaEditor/SchemaSeparationLine.tsx
import { jsx as jsx106, jsxs as jsxs47, Fragment as Fragment18 } from "react/jsx-runtime";
var VERTICAL_GUIDE_HEIGHT = 24;
var line2 = {
  borderBottom: "1px solid " + LINE_COLOR
};
var SchemaSeparationLine = () => {
  return /* @__PURE__ */ jsx106("div", {
    style: line2
  });
};
var arraySeparationLine = {
  borderBottom: "1px solid " + LINE_COLOR,
  marginTop: -VERTICAL_GUIDE_HEIGHT / 2,
  pointerEvents: "none",
  width: "100%",
  flexBasis: "100%"
};
var SchemaArrayItemSeparationLine = ({ onChange, index, schema, isLast, showAddButton }) => {
  const [outerHovered, setOuterHovered] = useState39(false);
  const [innerHovered, setInnerHovered] = useState39(false);
  const zodTypes = useZodTypesIfPossible();
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const def = schema._def;
  const onAdd = useCallback49(() => {
    onChange((oldV) => {
      return [
        ...oldV.slice(0, index + 1),
        createZodValues(def.type, z, zodTypes),
        ...oldV.slice(index + 1)
      ];
    }, false, true);
  }, [def.type, index, onChange, z, zodTypes]);
  const dynamicAddButtonStyle = useMemo59(() => {
    return {
      display: "flex",
      justifyContent: "center",
      height: VERTICAL_GUIDE_HEIGHT,
      opacity: outerHovered || isLast ? 1 : 0,
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)"
    };
  }, [isLast, outerHovered]);
  const inner = useMemo59(() => {
    return {
      background: BACKGROUND,
      paddingLeft: 10,
      paddingRight: 10
    };
  }, []);
  const onOuterMouseEnter = useCallback49(() => {
    setOuterHovered(true);
  }, []);
  const onOuterMouseLeave = useCallback49(() => {
    setOuterHovered(false);
  }, []);
  const onInnerMouseEnter = useCallback49(() => {
    setInnerHovered(true);
  }, []);
  const onInnerMouseLeave = useCallback49(() => {
    setInnerHovered(false);
  }, []);
  return /* @__PURE__ */ jsxs47("div", {
    style: {
      display: "flex",
      flexDirection: "row",
      height: VERTICAL_GUIDE_HEIGHT
    },
    children: [
      /* @__PURE__ */ jsxs47("div", {
        style: {
          flex: 1,
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end"
        },
        children: [
          showAddButton && /* @__PURE__ */ jsx106("div", {
            style: dynamicAddButtonStyle,
            onMouseEnter: onOuterMouseEnter,
            onMouseLeave: onOuterMouseLeave,
            children: /* @__PURE__ */ jsx106("div", {
              onClick: onAdd,
              style: inner,
              onMouseEnter: onInnerMouseEnter,
              onMouseLeave: onInnerMouseLeave,
              children: /* @__PURE__ */ jsx106(Plus, {
                color: innerHovered ? "white" : LIGHT_TEXT,
                style: { height: VERTICAL_GUIDE_HEIGHT / 2 }
              })
            })
          }),
          /* @__PURE__ */ jsx106("div", {
            style: arraySeparationLine
          })
        ]
      }),
      isLast ? /* @__PURE__ */ jsxs47(Fragment18, {
        children: [
          /* @__PURE__ */ jsx106(Spacing, {
            x: 1
          }),
          /* @__PURE__ */ jsx106("div", {
            style: {
              ...fieldSetText,
              alignItems: "center",
              display: "flex"
            },
            children: "]"
          })
        ]
      }) : null
    ]
  });
};

// src/components/RenderModal/SchemaEditor/SchemaVerticalGuide.tsx
import { useMemo as useMemo60 } from "react";
import { jsx as jsx107, jsxs as jsxs48 } from "react/jsx-runtime";
var flex = {
  flex: 1
};
var SchemaVerticalGuide = ({ isRoot, children }) => {
  const outer = useMemo60(() => {
    return {
      display: "flex",
      flexDirection: "row",
      position: "relative",
      marginLeft: isRoot ? 0 : 4
    };
  }, [isRoot]);
  const inner = useMemo60(() => {
    return isRoot ? {} : {
      height: `calc(100% - ${VERTICAL_GUIDE_HEIGHT / 2}px)`,
      width: 1,
      background: "#363A3E",
      position: "absolute"
    };
  }, [isRoot]);
  return /* @__PURE__ */ jsxs48("div", {
    style: outer,
    children: [
      /* @__PURE__ */ jsx107("div", {
        style: inner
      }),
      /* @__PURE__ */ jsx107("div", {
        style: flex,
        children
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodArrayEditor.tsx
import React74, { useMemo as useMemo65, useState as useState42 } from "react";

// src/components/RenderModal/SchemaEditor/ZodArrayItemEditor.tsx
import { useCallback as useCallback50, useMemo as useMemo61 } from "react";
import { jsx as jsx108 } from "react/jsx-runtime";
var ZodArrayItemEditor = ({
  def,
  onChange,
  jsonPath,
  index,
  value,
  defaultValue,
  onSave: onSaveObject,
  showSaveButton,
  saving,
  saveDisabledByParent,
  mayPad,
  mayRemove
}) => {
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const onRemove = useCallback50(() => {
    onChange((oldV) => [...oldV.slice(0, index), ...oldV.slice(index + 1)], false, true);
  }, [index, onChange]);
  const setValue = useCallback50((val) => {
    onChange((oldV) => [
      ...oldV.slice(0, index),
      typeof val === "function" ? val(oldV[index]) : val,
      ...oldV.slice(index + 1)
    ], false, false);
  }, [index, onChange]);
  const newJsonPath = useMemo61(() => [...jsonPath, index], [index, jsonPath]);
  const onSave = useCallback50((updater) => {
    onSaveObject((oldV) => [
      ...oldV.slice(0, index),
      updater(oldV[index]),
      ...oldV.slice(index + 1)
    ], false, false);
  }, [index, onSaveObject]);
  return /* @__PURE__ */ jsx108("div", {
    children: /* @__PURE__ */ jsx108(ZodSwitch, {
      jsonPath: newJsonPath,
      schema: def.type,
      value,
      setValue,
      defaultValue,
      onSave,
      showSaveButton,
      onRemove: mayRemove ? onRemove : null,
      saving,
      saveDisabledByParent,
      mayPad
    })
  });
};

// src/components/RenderModal/InfoBubble.tsx
import { PlayerInternals as PlayerInternals11 } from "@remotion/player";
import { useCallback as useCallback51, useEffect as useEffect38, useMemo as useMemo63, useRef as useRef23, useState as useState40 } from "react";
import ReactDOM7 from "react-dom";

// src/components/RenderModal/InfoTooltip.tsx
import { useMemo as useMemo62 } from "react";
import { jsx as jsx109, jsxs as jsxs49 } from "react/jsx-runtime";
var arrow = {
  height: 7,
  display: "block",
  overflow: "visible",
  marginLeft: 7
};
var arrowUp = {
  ...arrow,
  transform: `translateY(1px)`
};
var arrowDown = {
  ...arrow,
  marginTop: -1
};
var InfoTooltip = ({ children, arrowDirection, backgroundColor }) => {
  const container27 = useMemo62(() => {
    return {
      boxShadow: arrowDirection === "down" ? SHADOW_TOWARDS_TOP : SHADOW_TOWARDS_BOTTOM,
      background: backgroundColor,
      color: "white",
      border: "0.5px solid " + BORDER_COLOR,
      maxHeight: 200,
      overflow: "auto",
      borderRadius: "4px"
    };
  }, [arrowDirection, backgroundColor]);
  return /* @__PURE__ */ jsxs49("div", {
    style: {
      display: "flex",
      flexDirection: arrowDirection === "up" ? "column-reverse" : "column",
      alignItems: "flex-start"
    },
    children: [
      /* @__PURE__ */ jsx109("div", {
        style: container27,
        className: VERTICAL_SCROLLBAR_CLASSNAME,
        children
      }),
      arrowDirection === "down" ? /* @__PURE__ */ jsx109("svg", {
        viewBox: "0 0 14 7",
        style: arrowDown,
        children: /* @__PURE__ */ jsx109("path", {
          d: `M 14 0 L 7 7 L 0 0`,
          fill: backgroundColor,
          strokeLinecap: "butt",
          stroke: BORDER_COLOR,
          strokeWidth: 0.5
        })
      }) : null,
      arrowDirection === "up" ? /* @__PURE__ */ jsx109("svg", {
        viewBox: "0 0 14 7",
        style: arrowUp,
        children: /* @__PURE__ */ jsx109("path", {
          d: `M 0 7 L 7 0 L 14 7`,
          fill: backgroundColor,
          strokeLinecap: "butt",
          stroke: BORDER_COLOR,
          strokeWidth: 0.5
        })
      }) : null
    ]
  });
};

// src/components/RenderModal/InfoBubble.tsx
import { jsx as jsx110, jsxs as jsxs50, Fragment as Fragment19 } from "react/jsx-runtime";
var icon4 = {
  color: LIGHT_TEXT,
  height: 15
};
var container27 = {
  display: "inline-block",
  border: "none",
  fontSize: 14,
  verticalAlign: "text-bottom"
};
var InfoBubble = ({ title: title3, children }) => {
  const [hovered, setIsHovered] = useState40(false);
  const [opened, setOpened] = useState40(false);
  const ref = useRef23(null);
  const { tabIndex, currentZIndex } = useZIndex();
  const size2 = PlayerInternals11.useElementSize(ref, {
    triggerOnWindowResize: true,
    shouldApplyCssTransforms: true
  });
  const refresh = size2?.refresh;
  const onHide = useCallback51(() => {
    setOpened(false);
  }, []);
  useEffect38(() => {
    const { current } = ref;
    if (!current) {
      return;
    }
    const onMouseEnter = () => setIsHovered(true);
    const onMouseLeave = () => setIsHovered(false);
    const onPointerUp = () => {
      return setOpened((o) => {
        if (!o) {
          refresh?.();
        }
        return !o;
      });
    };
    const onClick = (e) => {
      e.stopPropagation();
      const isKeyboardInitiated = e.detail === 0;
      if (!isKeyboardInitiated) {
        return;
      }
      return setOpened((o) => {
        return !o;
      });
    };
    current.addEventListener("mouseenter", onMouseEnter);
    current.addEventListener("mouseleave", onMouseLeave);
    current.addEventListener("pointerup", onPointerUp);
    current.addEventListener("click", onClick);
    return () => {
      current.removeEventListener("mouseenter", onMouseEnter);
      current.removeEventListener("mouseleave", onMouseLeave);
      current.removeEventListener("pointerup", onPointerUp);
      current.removeEventListener("click", onClick);
    };
  }, [refresh]);
  const layout = useMemo63(() => {
    if (!size2) {
      return "down";
    }
    const spaceToBottom = size2.windowSize.height - (size2.top + size2.height);
    const spaceToTop = size2.top;
    const l = spaceToTop > spaceToBottom ? "down" : "up";
    return l;
  }, [size2]);
  const portalStyle = useMemo63(() => {
    if (!size2 || !opened) {
      return null;
    }
    return {
      ...layout === "up" ? {
        position: "fixed",
        top: size2.top + size2.height
      } : {
        position: "fixed",
        bottom: size2.windowSize.height - size2.top
      },
      left: size2.left
    };
  }, [layout, opened, size2]);
  const style8 = useMemo63(() => {
    return {
      ...container27,
      userSelect: "none",
      WebkitUserSelect: "none",
      color: "white",
      display: "inline-flex",
      flexDirection: "row",
      alignItems: "center",
      padding: 6
    };
  }, []);
  return /* @__PURE__ */ jsxs50(Fragment19, {
    children: [
      /* @__PURE__ */ jsx110("button", {
        ref,
        tabIndex,
        style: style8,
        title: title3,
        type: "button",
        children: /* @__PURE__ */ jsx110("svg", {
          style: icon4,
          viewBox: "0 0 512 512",
          children: /* @__PURE__ */ jsx110("path", {
            fill: hovered ? "white" : LIGHT_TEXT,
            d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V248c0-13.3-10.7-24-24-24H216c-13.3 0-24 10.7-24 24s10.7 24 24 24h24v64H216zm40-144a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
          })
        })
      }),
      portalStyle ? ReactDOM7.createPortal(/* @__PURE__ */ jsx110("div", {
        style: outerPortal,
        className: "css-reset",
        children: /* @__PURE__ */ jsx110(HigherZIndex, {
          onOutsideClick: onHide,
          onEscape: onHide,
          children: /* @__PURE__ */ jsx110("div", {
            style: portalStyle,
            children: /* @__PURE__ */ jsx110(InfoTooltip, {
              backgroundColor: INPUT_BACKGROUND,
              arrowDirection: layout,
              children
            })
          })
        })
      }), getPortal(currentZIndex)) : null
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodFieldValidation.tsx
import { jsx as jsx111, jsxs as jsxs51 } from "react/jsx-runtime";
var legend = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center"
};
var stackTrace = {
  padding: 10
};
var stackTraceLabel = {
  fontSize: 14
};
var ZodFieldValidation = ({ localValue, path }) => {
  if (localValue.zodValidation.success) {
    return null;
  }
  return /* @__PURE__ */ jsxs51("div", {
    style: legend,
    children: [
      /* @__PURE__ */ jsx111(ValidationMessage, {
        align: "flex-start",
        message: localValue.zodValidation.error.format()._errors[0],
        type: "error"
      }),
      /* @__PURE__ */ jsx111(Spacing, {
        x: 0.5
      }),
      /* @__PURE__ */ jsx111(InfoBubble, {
        title: "Zod validation failure",
        children: /* @__PURE__ */ jsxs51("div", {
          style: stackTrace,
          children: [
            /* @__PURE__ */ jsx111("div", {
              style: stackTraceLabel,
              children: "Zod Validation has failed:"
            }),
            localValue.zodValidation.error.errors.map((error, index) => /* @__PURE__ */ jsxs51("div", {
              style: stackTraceLabel,
              children: [
                "Type: ",
                error.code,
                " ",
                /* @__PURE__ */ jsx111("br", {}),
                "Message: ",
                error.message,
                /* @__PURE__ */ jsx111("br", {}),
                "Path: ",
                path.join(".")
              ]
            }, index))
          ]
        })
      }),
      /* @__PURE__ */ jsx111(Spacing, {
        x: 0.5
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/local-state.tsx
import {
  createContext as createContext18,
  useCallback as useCallback52,
  useContext as useContext35,
  useEffect as useEffect39,
  useMemo as useMemo64,
  useRef as useRef24,
  useState as useState41
} from "react";
import { Internals as Internals29 } from "remotion";
import { jsx as jsx112 } from "react/jsx-runtime";
var RevisionContext = createContext18({
  childResetRevision: 0
});
var useLocalState = ({
  unsavedValue,
  schema,
  setValue,
  savedValue
}) => {
  const parentRevision = useContext35(RevisionContext).childResetRevision;
  const [resetRevision, setResetRevision] = useState41(0);
  const [localValueOrNull, setLocalValue] = useState41(() => {
    return {
      [parentRevision]: {
        value: unsavedValue,
        keyStabilityRevision: 0,
        zodValidation: schema.safeParse(unsavedValue)
      }
    };
  });
  const localUnsavedValue = useMemo64(() => {
    if ((localValueOrNull[parentRevision] ?? null) === null) {
      return {
        value: unsavedValue,
        keyStabilityRevision: 0,
        zodValidation: schema.safeParse(unsavedValue)
      };
    }
    return localValueOrNull[parentRevision];
  }, [localValueOrNull, parentRevision, schema, unsavedValue]);
  useEffect39(() => {
    const checkFile = () => {
      setResetRevision((old) => old + 1);
      setLocalValue({});
    };
    window.addEventListener(Internals29.PROPS_UPDATED_EXTERNALLY, checkFile);
    return () => {
      window.removeEventListener(Internals29.PROPS_UPDATED_EXTERNALLY, checkFile);
    };
  }, []);
  const currentLocalValue = useMemo64(() => {
    return localUnsavedValue ?? {
      value: savedValue,
      keyStabilityRevision: 0,
      zodValidation: schema.safeParse(savedValue)
    };
  }, [localUnsavedValue, savedValue, schema]);
  const stateRef = useRef24(currentLocalValue);
  stateRef.current = currentLocalValue;
  const onChange = useCallback52((updater, forceApply, increment) => {
    const newValue = updater(stateRef.current.value);
    const isSame = deepEqual(newValue, stateRef.current.value);
    if (isSame) {
      return;
    }
    const safeParse = schema.safeParse(newValue);
    if (safeParse.success || forceApply) {
      setValue(updater, forceApply, increment);
    }
    setLocalValue(() => {
      const newState = {
        keyStabilityRevision: currentLocalValue.keyStabilityRevision + (increment ? 1 : 0),
        value: newValue,
        zodValidation: safeParse
      };
      stateRef.current = newState;
      return {
        ...localUnsavedValue,
        [parentRevision]: newState
      };
    });
  }, [
    currentLocalValue.keyStabilityRevision,
    localUnsavedValue,
    parentRevision,
    schema,
    setValue
  ]);
  const contextValue = useMemo64(() => {
    return {
      childResetRevision: resetRevision
    };
  }, [resetRevision]);
  const reset = useCallback52(() => {
    onChange(() => savedValue, true, true);
    setResetRevision((old) => old + 1);
  }, [savedValue, onChange]);
  const RevisionContextProvider = useCallback52(({ children }) => {
    return /* @__PURE__ */ jsx112(RevisionContext.Provider, {
      value: contextValue,
      children
    });
  }, [contextValue]);
  return useMemo64(() => ({
    localValue: currentLocalValue,
    onChange,
    reset,
    RevisionContextProvider
  }), [RevisionContextProvider, currentLocalValue, onChange, reset]);
};

// src/components/RenderModal/SchemaEditor/ZodArrayEditor.tsx
import { jsx as jsx113, jsxs as jsxs52 } from "react/jsx-runtime";
var ZodArrayEditor = ({
  schema,
  jsonPath,
  setValue,
  defaultValue,
  value,
  onSave,
  showSaveButton,
  onRemove,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const { localValue, onChange, RevisionContextProvider, reset } = useLocalState({
    unsavedValue: value,
    schema,
    setValue,
    savedValue: defaultValue
  });
  const [expanded, setExpanded] = useState42(true);
  const def = schema._def;
  const suffix2 = useMemo65(() => {
    return expanded ? " [" : " [...] ";
  }, [expanded]);
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const zodTypes = useZodTypesIfPossible();
  const typeName = def.typeName;
  if (typeName !== z.ZodFirstPartyTypeKind.ZodArray) {
    throw new Error("expected object");
  }
  const isDefaultValue = useMemo65(() => {
    return deepEqual(localValue.value, defaultValue);
  }, [defaultValue, localValue]);
  return /* @__PURE__ */ jsxs52(Fieldset, {
    shouldPad: mayPad,
    success: localValue.zodValidation.success,
    children: [
      /* @__PURE__ */ jsx113("div", {
        style: {
          display: "flex",
          flexDirection: "row"
        },
        children: /* @__PURE__ */ jsx113(SchemaLabel, {
          onReset: reset,
          isDefaultValue,
          jsonPath,
          onRemove,
          suffix: suffix2,
          onSave: () => {
            onSave(() => localValue.value, false, false);
          },
          saveDisabledByParent,
          saving,
          showSaveButton,
          valid: localValue.zodValidation.success,
          handleClick: () => setExpanded(!expanded)
        })
      }),
      expanded ? /* @__PURE__ */ jsx113(RevisionContextProvider, {
        children: /* @__PURE__ */ jsxs52(SchemaVerticalGuide, {
          isRoot: false,
          children: [
            localValue.value.map((child, i) => {
              return /* @__PURE__ */ jsxs52(React74.Fragment, {
                children: [
                  /* @__PURE__ */ jsx113(ZodArrayItemEditor, {
                    onChange,
                    value: child,
                    def,
                    index: i,
                    jsonPath,
                    defaultValue: defaultValue?.[i] ?? createZodValues(def.type, z, zodTypes),
                    onSave,
                    showSaveButton,
                    saving,
                    saveDisabledByParent,
                    mayPad,
                    mayRemove: true
                  }),
                  /* @__PURE__ */ jsx113(SchemaArrayItemSeparationLine, {
                    schema,
                    index: i,
                    onChange,
                    isLast: i === localValue.value.length - 1,
                    showAddButton: true
                  })
                ]
              }, `${i}${localValue.keyStabilityRevision}`);
            }),
            value.length === 0 ? /* @__PURE__ */ jsx113(SchemaArrayItemSeparationLine, {
              schema,
              index: 0,
              onChange,
              isLast: true,
              showAddButton: true
            }) : null
          ]
        })
      }) : null,
      /* @__PURE__ */ jsx113(ZodFieldValidation, {
        path: jsonPath,
        localValue
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodBooleanEditor.tsx
import { useCallback as useCallback53 } from "react";

// src/components/Checkbox.tsx
import { useMemo as useMemo66 } from "react";
import { jsx as jsx114, jsxs as jsxs53 } from "react/jsx-runtime";
var size2 = 20;
var background = {
  height: size2,
  width: size2,
  position: "relative"
};
var box = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "absolute",
  height: size2,
  width: size2,
  top: 0,
  left: 0,
  pointerEvents: "none",
  color: "white"
};
var Checkbox = ({ checked, onChange, disabled, name }) => {
  const input2 = useMemo66(() => {
    return {
      appearance: "none",
      background: disabled ? "transparent" : INPUT_BACKGROUND,
      border: "1px solid " + INPUT_BORDER_COLOR_UNHOVERED,
      height: size2,
      width: size2,
      top: 0,
      left: 0,
      position: "absolute",
      margin: 0
    };
  }, [disabled]);
  return /* @__PURE__ */ jsxs53("div", {
    style: background,
    children: [
      /* @__PURE__ */ jsx114("input", {
        style: input2,
        type: "checkbox",
        checked,
        onChange,
        disabled,
        name
      }),
      /* @__PURE__ */ jsx114("div", {
        style: box,
        children: checked ? /* @__PURE__ */ jsx114(Checkmark, {}) : null
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodBooleanEditor.tsx
import { jsx as jsx115, jsxs as jsxs54 } from "react/jsx-runtime";
var fullWidth = {
  width: "100%"
};
var ZodBooleanEditor = ({
  schema,
  jsonPath,
  value,
  setValue,
  onSave,
  defaultValue,
  onRemove,
  showSaveButton,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const { localValue, onChange, reset } = useLocalState({
    schema,
    setValue,
    unsavedValue: value,
    savedValue: defaultValue
  });
  const onToggle = useCallback53((e) => {
    onChange(() => e.target.checked, false, false);
  }, [onChange]);
  const save = useCallback53(() => {
    onSave(() => value, false, false);
  }, [onSave, value]);
  return /* @__PURE__ */ jsxs54(Fieldset, {
    shouldPad: mayPad,
    success: localValue.zodValidation.success,
    children: [
      /* @__PURE__ */ jsx115(SchemaLabel, {
        handleClick: null,
        isDefaultValue: localValue.value === defaultValue,
        jsonPath,
        onReset: reset,
        onSave: save,
        showSaveButton,
        onRemove,
        saving,
        valid: true,
        saveDisabledByParent,
        suffix: null
      }),
      /* @__PURE__ */ jsx115("div", {
        style: fullWidth,
        children: /* @__PURE__ */ jsx115(Checkbox, {
          name: jsonPath.join("."),
          checked: localValue.value,
          onChange: onToggle,
          disabled: false
        })
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodColorEditor.tsx
import { useCallback as useCallback55, useMemo as useMemo69 } from "react";

// src/helpers/color-math.ts
var colorWithNewOpacity = (color, opacity, zodTypes) => {
  const { r, g, b } = zodTypes.ZodZypesInternals.parseColor(color);
  if (opacity >= 255) {
    return `#${r.toString(16).padStart(2, "0")}${g.toString(16).padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
  }
  return `rgba(${r}, ${g}, ${b}, ${(opacity / 255).toFixed(2)})`;
};

// src/components/NewComposition/InputDragger.tsx
import React77, { useCallback as useCallback54, useEffect as useEffect40, useMemo as useMemo67, useRef as useRef25, useState as useState43 } from "react";
import { interpolate as interpolate2 } from "remotion";
import { jsx as jsx116 } from "react/jsx-runtime";
var isInt = (num) => {
  return num % 1 === 0;
};
var InputDraggerForwardRefFn = ({
  onValueChange,
  min: _min,
  max: _max,
  step: _step,
  value,
  onTextChange,
  formatter = (q) => String(q),
  status,
  rightAlign,
  ...props
}, ref) => {
  const [inputFallback, setInputFallback] = useState43(false);
  const fallbackRef = useRef25(null);
  const style8 = useMemo67(() => {
    return {
      ...inputBaseStyle,
      backgroundColor: "transparent",
      borderColor: "transparent"
    };
  }, []);
  const span = useMemo67(() => ({
    borderBottom: "1px dotted " + BLUE,
    paddingBottom: 1,
    color: BLUE,
    cursor: "ew-resize",
    userSelect: "none",
    WebkitUserSelect: "none",
    fontSize: 13,
    fontVariantNumeric: "tabular-nums"
  }), []);
  const onClick = useCallback54((e) => {
    if (!getClickLock()) {
      e.stopPropagation();
    }
    if (getClickLock()) {
      return;
    }
    setInputFallback(true);
  }, []);
  const onEscape = useCallback54(() => {
    setInputFallback(false);
  }, []);
  const onBlur = useCallback54(() => {
    if (!fallbackRef.current) {
      return;
    }
    const newValue = fallbackRef.current.value;
    if (newValue.trim() === "") {
      onEscape();
      return;
    }
    if (fallbackRef.current.checkValidity()) {
      onTextChange?.(newValue);
      setInputFallback(false);
    } else {
      fallbackRef.current.reportValidity();
    }
  }, [onEscape, onTextChange]);
  const onKeyPress = useCallback54((e) => {
    if (e.key === "Enter") {
      fallbackRef.current?.blur();
    }
  }, []);
  const roundToStep = (val, stepSize) => {
    const factor = 1 / stepSize;
    return Math.ceil(val * factor) / factor;
  };
  const onPointerDown = useCallback54((e) => {
    const { pageX, pageY, button: button3 } = e;
    if (button3 !== 0) {
      return;
    }
    const moveListener = (ev) => {
      const xDistance = ev.pageX - pageX;
      const distanceFromStart = Math.sqrt(xDistance ** 2 + (ev.pageY - pageY) ** 2);
      const step = Number(_step ?? 1);
      const min = Number(_min ?? 0);
      const max = Number(_max ?? Infinity);
      if (distanceFromStart > 4) {
        setClickLock(true);
      }
      const diff = interpolate2(xDistance, [-5, -4, 0, 4, 5], [-step, 0, 0, 0, step]);
      const newValue = Math.min(max, Math.max(min, Number(value) + diff));
      const roundedToStep = roundToStep(newValue, step);
      onValueChange(roundedToStep);
    };
    window.addEventListener("mousemove", moveListener);
    window.addEventListener("pointerup", () => {
      window.removeEventListener("mousemove", moveListener);
      setTimeout(() => {
        setClickLock(false);
      }, 2);
    }, {
      once: true
    });
  }, [_step, _min, _max, value, onValueChange]);
  useEffect40(() => {
    if (inputFallback) {
      fallbackRef.current?.select();
    }
  }, [inputFallback]);
  const deriveStep = useMemo67(() => {
    if (_step !== undefined) {
      return _step;
    }
    if (typeof _min === "number" && isInt(_min)) {
      return 1;
    }
    return 0.0001;
  }, [_min, _step]);
  if (inputFallback) {
    return /* @__PURE__ */ jsx116(HigherZIndex, {
      onEscape,
      onOutsideClick: noop,
      children: /* @__PURE__ */ jsx116(RemotionInput, {
        ref: fallbackRef,
        autoFocus: true,
        onKeyPress,
        onBlur,
        min: _min,
        max: _max,
        step: deriveStep,
        defaultValue: value,
        status,
        pattern: "[0-9]*[.]?[0-9]*",
        rightAlign,
        ...props
      })
    });
  }
  return /* @__PURE__ */ jsx116("button", {
    ref,
    type: "button",
    style: style8,
    onClick,
    onPointerDown,
    children: /* @__PURE__ */ jsx116("span", {
      style: span,
      children: formatter(value)
    })
  });
};
var InputDragger = React77.forwardRef(InputDraggerForwardRefFn);

// src/components/NewComposition/RemInputTypeColor.tsx
import {
  forwardRef as forwardRef4,
  useEffect as useEffect41,
  useImperativeHandle as useImperativeHandle11,
  useMemo as useMemo68,
  useRef as useRef26,
  useState as useState44
} from "react";
import { jsx as jsx117 } from "react/jsx-runtime";
var inputBaseStyle3 = {
  padding: 0,
  borderStyle: "solid",
  borderWidth: 1
};
var RemInputTypeColorForwardRef = ({ status, ...props }, ref) => {
  const [isFocused, setIsFocused] = useState44(false);
  const [isHovered, setIsHovered] = useState44(false);
  const inputRef = useRef26(null);
  const { tabIndex } = useZIndex();
  const style8 = useMemo68(() => {
    return {
      backgroundColor: INPUT_BACKGROUND,
      ...inputBaseStyle3,
      borderColor: getInputBorderColor({ isFocused, isHovered, status }),
      ...props.style ?? {}
    };
  }, [isFocused, isHovered, props.style, status]);
  useImperativeHandle11(ref, () => {
    return inputRef.current;
  }, []);
  useEffect41(() => {
    if (!inputRef.current) {
      return;
    }
    const { current } = inputRef;
    const onFocus = () => setIsFocused(true);
    const onBlur = () => setIsFocused(false);
    const onMouseEnter = () => setIsHovered(true);
    const onMouseLeave = () => setIsHovered(false);
    current.addEventListener("focus", onFocus);
    current.addEventListener("blur", onBlur);
    current.addEventListener("mouseenter", onMouseEnter);
    current.addEventListener("mouseleave", onMouseLeave);
    return () => {
      current.removeEventListener("focus", onFocus);
      current.removeEventListener("blur", onBlur);
      current.removeEventListener("mouseenter", onMouseEnter);
      current.removeEventListener("mouseleave", onMouseLeave);
    };
  }, [inputRef]);
  return /* @__PURE__ */ jsx117("input", {
    ref: inputRef,
    type: "color",
    tabIndex,
    ...props,
    name: props.name,
    style: style8
  });
};
var RemInputTypeColor = forwardRef4(RemInputTypeColorForwardRef);

// src/components/RenderModal/SchemaEditor/ZodColorEditor.tsx
import { jsx as jsx118, jsxs as jsxs55 } from "react/jsx-runtime";
var fullWidth2 = {
  width: "100%"
};
var ZodColorEditor = ({
  jsonPath,
  value,
  setValue,
  showSaveButton,
  defaultValue,
  schema,
  onSave,
  onRemove,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const zodTypes = useZodTypesIfPossible();
  if (!zodTypes) {
    throw new Error("expected zod color");
  }
  const {
    localValue,
    onChange: onValueChange,
    reset
  } = useLocalState({
    schema,
    setValue,
    unsavedValue: value,
    savedValue: defaultValue
  });
  const { a, b, g, r } = localValue.zodValidation.success ? zodTypes.ZodZypesInternals.parseColor(localValue.value) : { a: 1, b: 0, g: 0, r: 0 };
  const onChange = useCallback55((e) => {
    const newColor = colorWithNewOpacity(e.target.value, Math.round(a), zodTypes);
    onValueChange(() => newColor, false, false);
  }, [a, onValueChange, zodTypes]);
  const onTextChange = useCallback55((e) => {
    const newValue = e.target.value;
    onValueChange(() => newValue, false, false);
  }, [onValueChange]);
  const save = useCallback55(() => {
    onSave(() => value, false, false);
  }, [onSave, value]);
  const rgb = `#${r.toString(16).padStart(2, "0")}${g.toString(16).padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
  const status = localValue.zodValidation.success ? "ok" : "error";
  const colorPicker = useMemo69(() => {
    return {
      height: 39,
      width: 45,
      display: "inline-block"
    };
  }, []);
  const onOpacityChange = useCallback55((newValue) => {
    const newColor = colorWithNewOpacity(localValue.value, Math.round(Number(newValue) / 100 * 255), zodTypes);
    onValueChange(() => newColor, false, false);
  }, [localValue.value, onValueChange, zodTypes]);
  const onOpacityValueChange = useCallback55((newValue) => {
    const newColor = colorWithNewOpacity(localValue.value, Math.round(Number(newValue) / 100 * 255), zodTypes);
    onValueChange(() => newColor, false, false);
  }, [localValue.value, onValueChange, zodTypes]);
  return /* @__PURE__ */ jsxs55(Fieldset, {
    shouldPad: mayPad,
    success: localValue.zodValidation.success,
    children: [
      /* @__PURE__ */ jsx118(SchemaLabel, {
        handleClick: null,
        isDefaultValue: localValue.value === defaultValue,
        jsonPath,
        onReset: reset,
        onSave: save,
        showSaveButton,
        onRemove,
        saving,
        valid: localValue.zodValidation.success,
        saveDisabledByParent,
        suffix: null
      }),
      /* @__PURE__ */ jsxs55("div", {
        style: fullWidth2,
        children: [
          /* @__PURE__ */ jsxs55(Row, {
            align: "center",
            children: [
              /* @__PURE__ */ jsx118("div", {
                style: colorPicker,
                children: /* @__PURE__ */ jsx118(RemInputTypeColor, {
                  type: "color",
                  style: {
                    height: 39
                  },
                  value: rgb,
                  onChange,
                  className: "__remotion_color_picker",
                  status,
                  name: jsonPath.join(".")
                })
              }),
              /* @__PURE__ */ jsx118(Spacing, {
                x: 1,
                block: true
              }),
              /* @__PURE__ */ jsx118(RemotionInput, {
                value: localValue.value,
                status,
                placeholder: jsonPath.join("."),
                onChange: onTextChange,
                rightAlign: false
              }),
              /* @__PURE__ */ jsx118(Spacing, {
                x: 1
              }),
              /* @__PURE__ */ jsx118(InputDragger, {
                onTextChange: onOpacityChange,
                onValueChange: onOpacityValueChange,
                status,
                value: a / 255 * 100,
                min: 0,
                max: 100,
                step: 1,
                formatter: (v) => `${Math.round(Number(v))}%`,
                rightAlign: false
              })
            ]
          }),
          /* @__PURE__ */ jsx118(ZodFieldValidation, {
            path: jsonPath,
            localValue
          })
        ]
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodDateEditor.tsx
import { useCallback as useCallback56 } from "react";
import { jsx as jsx119, jsxs as jsxs56 } from "react/jsx-runtime";
var fullWidth3 = {
  width: "100%"
};
var explainer2 = {
  fontFamily: "sans-serif",
  fontSize: 12,
  color: VERY_LIGHT_TEXT
};
var inputStyle = {
  colorScheme: "dark"
};
var formatDate = (date) => {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();
  const milliseconds = date.getMilliseconds();
  const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${day.toString().padStart(2, "0")}T${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}.${milliseconds.toString().padStart(3, "0")}`;
  return formattedDate;
};
var ZodDateEditor = ({
  jsonPath,
  value,
  setValue,
  showSaveButton,
  defaultValue,
  schema,
  onSave,
  onRemove,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const {
    localValue,
    onChange: setLocalValue,
    reset
  } = useLocalState({
    schema,
    setValue,
    unsavedValue: value,
    savedValue: defaultValue
  });
  const onChange = useCallback56((e) => {
    setLocalValue(() => new Date(e.target.value), false, false);
  }, [setLocalValue]);
  const save = useCallback56(() => {
    onSave(() => value, false, false);
  }, [onSave, value]);
  return /* @__PURE__ */ jsxs56(Fieldset, {
    shouldPad: mayPad,
    success: localValue.zodValidation.success,
    children: [
      /* @__PURE__ */ jsx119(SchemaLabel, {
        handleClick: null,
        isDefaultValue: localValue.value.getTime() === defaultValue.getTime(),
        jsonPath,
        onReset: reset,
        onSave: save,
        showSaveButton,
        onRemove,
        saving,
        valid: localValue.zodValidation.success,
        saveDisabledByParent,
        suffix: null
      }),
      /* @__PURE__ */ jsxs56("div", {
        style: fullWidth3,
        children: [
          /* @__PURE__ */ jsx119(RemotionInput, {
            value: formatDate(localValue.value),
            type: "datetime-local",
            status: localValue.zodValidation.success ? "ok" : "error",
            placeholder: jsonPath.join("."),
            onChange,
            style: inputStyle,
            rightAlign: false
          }),
          /* @__PURE__ */ jsx119(Spacing, {
            y: 1,
            block: true
          }),
          /* @__PURE__ */ jsx119("div", {
            style: explainer2,
            children: "Date is in local format"
          }),
          /* @__PURE__ */ jsx119(ZodFieldValidation, {
            path: jsonPath,
            localValue
          })
        ]
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodDefaultEditor.tsx
import { jsx as jsx120 } from "react/jsx-runtime";
var ZodDefaultEditor = ({
  jsonPath,
  schema,
  setValue,
  onSave,
  defaultValue,
  value,
  showSaveButton,
  onRemove,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const { innerType } = schema._def;
  return /* @__PURE__ */ jsx120(ZodSwitch, {
    defaultValue,
    jsonPath,
    onRemove,
    onSave,
    schema: innerType,
    setValue,
    showSaveButton,
    value,
    saving,
    saveDisabledByParent,
    mayPad
  });
};

// src/components/RenderModal/SchemaEditor/ZodDiscriminatedUnionEditor.tsx
import { useCallback as useCallback57, useMemo as useMemo70 } from "react";
import { jsx as jsx121, jsxs as jsxs57 } from "react/jsx-runtime";
var ZodDiscriminatedUnionEditor = ({
  schema,
  setValue,
  showSaveButton,
  saving,
  value,
  defaultValue,
  saveDisabledByParent,
  onSave,
  mayPad,
  jsonPath,
  onRemove
}) => {
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const zodTypes = useZodTypesIfPossible();
  const typedSchema = schema._def;
  const options = useMemo70(() => [...typedSchema.optionsMap.keys()], [typedSchema.optionsMap]);
  const {
    localValue,
    onChange: setLocalValue,
    reset
  } = useLocalState({
    schema,
    setValue,
    unsavedValue: value,
    savedValue: defaultValue
  });
  const comboBoxValues = useMemo70(() => {
    return options.map((option) => {
      return {
        value: option,
        label: option,
        id: option,
        keyHint: null,
        leftItem: option === value[typedSchema.discriminator] ? /* @__PURE__ */ jsx121(Checkmark, {}) : null,
        onClick: () => {
          const val = createZodValues(typedSchema.optionsMap.get(option), z, zodTypes);
          setLocalValue(() => val, false, false);
        },
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item"
      };
    });
  }, [
    options,
    setLocalValue,
    typedSchema.discriminator,
    typedSchema.optionsMap,
    value,
    z,
    zodTypes
  ]);
  const save = useCallback57(() => {
    onSave(() => value, false, false);
  }, [onSave, value]);
  const discriminatedUnionReplacement = useMemo70(() => {
    return {
      discriminator: typedSchema.discriminator,
      markup: /* @__PURE__ */ jsxs57(Fieldset, {
        shouldPad: mayPad,
        success: true,
        children: [
          /* @__PURE__ */ jsx121(SchemaLabel, {
            handleClick: null,
            isDefaultValue: localValue.value[typedSchema.discriminator] === defaultValue[typedSchema.discriminator],
            jsonPath: [...jsonPath, typedSchema.discriminator],
            onRemove,
            onReset: reset,
            onSave: save,
            saveDisabledByParent,
            saving,
            showSaveButton,
            suffix: null,
            valid: localValue.zodValidation.success
          }),
          /* @__PURE__ */ jsx121(Combobox, {
            title: "Select type",
            values: comboBoxValues,
            selectedId: value[typedSchema.discriminator]
          })
        ]
      }, "replacement")
    };
  }, [
    comboBoxValues,
    defaultValue,
    jsonPath,
    localValue.value,
    localValue.zodValidation.success,
    mayPad,
    onRemove,
    reset,
    save,
    saveDisabledByParent,
    saving,
    showSaveButton,
    typedSchema.discriminator,
    value
  ]);
  return /* @__PURE__ */ jsx121(ZodObjectEditor, {
    jsonPath,
    mayPad,
    savedValue: defaultValue,
    onRemove,
    onSave,
    saveDisabledByParent,
    saving,
    schema: typedSchema.optionsMap.get(value[typedSchema.discriminator]),
    setValue: setLocalValue,
    showSaveButton,
    unsavedValue: value,
    discriminatedUnionReplacement
  }, value[typedSchema.discriminator]);
};

// src/components/RenderModal/SchemaEditor/ZodEffectEditor.tsx
import { jsx as jsx122, jsxs as jsxs58 } from "react/jsx-runtime";
var fullWidth4 = {
  width: "100%"
};
var ZodEffectEditor = ({
  schema,
  jsonPath,
  value,
  setValue: updateValue,
  defaultValue,
  onSave,
  onRemove,
  showSaveButton,
  saving,
  mayPad
}) => {
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const { localValue, onChange } = useLocalState({
    unsavedValue: value,
    schema,
    setValue: updateValue,
    savedValue: defaultValue
  });
  const def = schema._def;
  const typeName = def.typeName;
  if (typeName !== z.ZodFirstPartyTypeKind.ZodEffects) {
    throw new Error("expected effect");
  }
  return /* @__PURE__ */ jsxs58(Fieldset, {
    shouldPad: mayPad,
    success: localValue.zodValidation.success,
    children: [
      /* @__PURE__ */ jsx122("div", {
        style: fullWidth4,
        children: /* @__PURE__ */ jsx122(ZodSwitch, {
          value,
          setValue: onChange,
          jsonPath,
          schema: def.schema,
          defaultValue,
          onSave,
          showSaveButton,
          onRemove,
          saving,
          saveDisabledByParent: !localValue.zodValidation.success,
          mayPad: false
        })
      }),
      /* @__PURE__ */ jsx122(ZodFieldValidation, {
        path: jsonPath,
        localValue
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodEnumEditor.tsx
import { useCallback as useCallback58, useMemo as useMemo71 } from "react";
import { jsx as jsx123, jsxs as jsxs59 } from "react/jsx-runtime";
var container28 = {
  width: "100%"
};
var ZodEnumEditor = ({
  schema,
  jsonPath,
  setValue,
  defaultValue,
  value,
  onSave,
  showSaveButton,
  onRemove,
  saving
}) => {
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const {
    localValue,
    onChange: setLocalValue,
    reset
  } = useLocalState({
    schema,
    setValue,
    unsavedValue: value,
    savedValue: defaultValue
  });
  const def = schema._def;
  const typeName = def.typeName;
  if (typeName !== z.ZodFirstPartyTypeKind.ZodEnum) {
    throw new Error("expected enum");
  }
  const isRoot = jsonPath.length === 0;
  const comboBoxValues = useMemo71(() => {
    return def.values.map((option) => {
      return {
        value: option,
        label: option,
        id: option,
        keyHint: null,
        leftItem: option === value ? /* @__PURE__ */ jsx123(Checkmark, {}) : null,
        onClick: (id) => {
          setLocalValue(() => id, false, false);
        },
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item"
      };
    });
  }, [def.values, setLocalValue, value]);
  const save = useCallback58(() => {
    onSave(() => value, false, false);
  }, [onSave, value]);
  return /* @__PURE__ */ jsxs59(Fieldset, {
    shouldPad: true,
    success: localValue.zodValidation.success,
    children: [
      /* @__PURE__ */ jsx123(SchemaLabel, {
        handleClick: null,
        onSave: save,
        showSaveButton,
        isDefaultValue: localValue.value === defaultValue,
        onReset: reset,
        jsonPath,
        onRemove,
        saving,
        valid: localValue.zodValidation.success,
        saveDisabledByParent: !localValue.zodValidation.success,
        suffix: null
      }),
      /* @__PURE__ */ jsx123("div", {
        style: isRoot ? undefined : container28,
        children: /* @__PURE__ */ jsx123(Combobox, {
          values: comboBoxValues,
          selectedId: value,
          title: value
        })
      }),
      /* @__PURE__ */ jsx123(ZodFieldValidation, {
        path: jsonPath,
        localValue
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodMatrixEditor.tsx
import React82, { useMemo as useMemo72, useState as useState45 } from "react";
import { jsx as jsx124, jsxs as jsxs60 } from "react/jsx-runtime";
var rowStyle = {
  display: "flex",
  flexDirection: "row",
  width: "100%"
};
var ZodMatrixEditor = ({
  schema,
  jsonPath,
  setValue,
  defaultValue,
  value,
  onSave,
  showSaveButton,
  onRemove,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const { localValue, onChange, RevisionContextProvider, reset } = useLocalState({
    unsavedValue: value,
    schema,
    setValue,
    savedValue: defaultValue
  });
  const [expanded, setExpanded] = useState45(true);
  const def = schema._def;
  const suffix2 = useMemo72(() => {
    return expanded ? " [" : " [...] ";
  }, [expanded]);
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const zodTypes = useZodTypesIfPossible();
  const isDefaultValue = useMemo72(() => {
    return deepEqual(localValue.value, defaultValue);
  }, [defaultValue, localValue]);
  const dimensions = Math.sqrt(localValue.value.length);
  if (!Number.isInteger(dimensions)) {
    throw new Error("Invalid matrix");
  }
  const chunkedItems = useMemo72(() => {
    return localValue.value.reduce((acc, item2, index) => {
      const chunkIndex = Math.floor(index / dimensions);
      acc[chunkIndex] = acc[chunkIndex] || [];
      acc[chunkIndex].push(item2);
      return acc;
    }, []);
  }, [localValue.value, dimensions]);
  return /* @__PURE__ */ jsxs60(Fieldset, {
    shouldPad: mayPad,
    success: localValue.zodValidation.success,
    children: [
      /* @__PURE__ */ jsx124(SchemaLabel, {
        onReset: reset,
        isDefaultValue,
        jsonPath,
        onRemove,
        suffix: suffix2,
        onSave: () => {
          onSave(() => localValue.value, false, false);
        },
        saveDisabledByParent,
        saving,
        showSaveButton,
        valid: localValue.zodValidation.success,
        handleClick: () => setExpanded(!expanded)
      }),
      expanded ? /* @__PURE__ */ jsx124(RevisionContextProvider, {
        children: /* @__PURE__ */ jsxs60(SchemaVerticalGuide, {
          isRoot: false,
          children: [
            chunkedItems.map((row3, rowIndex) => {
              return /* @__PURE__ */ jsx124(React82.Fragment, {
                children: /* @__PURE__ */ jsx124("div", {
                  style: rowStyle,
                  children: row3.map((item2, _index) => {
                    const actualIndex = rowIndex * dimensions + _index;
                    return /* @__PURE__ */ jsx124("div", {
                      style: { flex: 1 },
                      children: /* @__PURE__ */ jsx124(ZodArrayItemEditor, {
                        onChange,
                        value: item2,
                        def,
                        index: actualIndex,
                        jsonPath,
                        defaultValue: defaultValue?.[actualIndex] ?? createZodValues(def.type, z, zodTypes),
                        onSave,
                        showSaveButton,
                        saving,
                        saveDisabledByParent,
                        mayPad,
                        mayRemove: false
                      })
                    }, `${_index}${localValue.keyStabilityRevision}`);
                  })
                })
              }, `${rowIndex}${localValue.keyStabilityRevision}`);
            }),
            value.length === 0 ? /* @__PURE__ */ jsx124(SchemaArrayItemSeparationLine, {
              schema,
              index: 0,
              onChange,
              isLast: true,
              showAddButton: true
            }) : null
          ]
        })
      }) : null,
      /* @__PURE__ */ jsx124(ZodFieldValidation, {
        path: jsonPath,
        localValue
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodNonEditableValue.tsx
import { useCallback as useCallback59 } from "react";
import { jsx as jsx125, jsxs as jsxs61 } from "react/jsx-runtime";
var fullWidth5 = {
  width: "100%"
};
var emptyLabel = {
  width: "100%",
  color: VERY_LIGHT_TEXT,
  fontFamily: "sans-serif",
  fontSize: 14
};
var wideEmptyLabel = {
  ...emptyLabel,
  lineHeight: "37px"
};
var ZonNonEditableValue = ({ jsonPath, label: label6, showSaveButton, saving, mayPad }) => {
  const save = useCallback59(() => {
    return;
  }, []);
  const reset = useCallback59(() => {
    return;
  }, []);
  return /* @__PURE__ */ jsxs61(Fieldset, {
    shouldPad: mayPad,
    success: true,
    children: [
      /* @__PURE__ */ jsx125(SchemaLabel, {
        handleClick: null,
        isDefaultValue: true,
        jsonPath,
        onReset: reset,
        onSave: save,
        showSaveButton,
        onRemove: null,
        saving,
        valid: true,
        saveDisabledByParent: true,
        suffix: null
      }),
      /* @__PURE__ */ jsx125("div", {
        style: fullWidth5,
        children: /* @__PURE__ */ jsx125("em", {
          style: wideEmptyLabel,
          children: label6
        })
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodOrNullishEditor.tsx
import { useCallback as useCallback60 } from "react";
import { jsx as jsx126, jsxs as jsxs62 } from "react/jsx-runtime";
var labelStyle4 = {
  fontFamily: "sans-serif",
  fontSize: 14,
  color: LIGHT_TEXT
};
var checkBoxWrapper = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  marginTop: "5px"
};
var ZodOrNullishEditor = ({
  jsonPath,
  schema,
  setValue,
  onSave,
  defaultValue,
  value,
  showSaveButton,
  onRemove,
  nullishValue,
  saving,
  saveDisabledByParent,
  mayPad,
  innerSchema
}) => {
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const zodTypes = useZodTypesIfPossible();
  const isChecked = value === nullishValue;
  const {
    localValue,
    onChange: setLocalValue,
    reset
  } = useLocalState({
    schema,
    setValue,
    unsavedValue: value,
    savedValue: defaultValue
  });
  const onCheckBoxChange = useCallback60((e) => {
    const val = e.target.checked ? nullishValue : createZodValues(innerSchema, z, zodTypes);
    setLocalValue(() => val, false, false);
  }, [innerSchema, nullishValue, setLocalValue, z, zodTypes]);
  const save = useCallback60(() => {
    onSave(() => value, false, false);
  }, [onSave, value]);
  return /* @__PURE__ */ jsxs62(Fieldset, {
    shouldPad: mayPad,
    success: localValue.zodValidation.success,
    children: [
      localValue.value === nullishValue ? /* @__PURE__ */ jsx126(SchemaLabel, {
        handleClick: null,
        isDefaultValue: localValue.value === defaultValue,
        jsonPath,
        onReset: reset,
        onSave: save,
        showSaveButton,
        onRemove,
        saving,
        valid: localValue.zodValidation.success,
        saveDisabledByParent,
        suffix: null
      }) : /* @__PURE__ */ jsx126(ZodSwitch, {
        value: localValue.value,
        setValue: setLocalValue,
        jsonPath,
        schema: innerSchema,
        defaultValue,
        onSave,
        showSaveButton,
        onRemove,
        saving,
        saveDisabledByParent,
        mayPad: false
      }),
      /* @__PURE__ */ jsxs62("div", {
        style: checkBoxWrapper,
        children: [
          /* @__PURE__ */ jsx126(Checkbox, {
            checked: isChecked,
            onChange: onCheckBoxChange,
            disabled: false,
            name: jsonPath.join(".")
          }),
          /* @__PURE__ */ jsx126(Spacing, {
            x: 1
          }),
          /* @__PURE__ */ jsx126("div", {
            style: labelStyle4,
            children: String(nullishValue)
          })
        ]
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodNullableEditor.tsx
import { jsx as jsx127 } from "react/jsx-runtime";
var ZodNullableEditor = ({
  jsonPath,
  schema,
  setValue,
  onSave,
  defaultValue,
  value,
  showSaveButton,
  onRemove,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const { innerType } = schema._def;
  return /* @__PURE__ */ jsx127(ZodOrNullishEditor, {
    defaultValue,
    jsonPath,
    onRemove,
    onSave,
    schema,
    innerSchema: innerType,
    setValue,
    showSaveButton,
    value,
    nullishValue: null,
    saving,
    saveDisabledByParent,
    mayPad
  });
};

// src/components/RenderModal/SchemaEditor/ZodNumberEditor.tsx
import { useCallback as useCallback61 } from "react";
import { jsx as jsx128, jsxs as jsxs63 } from "react/jsx-runtime";
var fullWidth6 = {
  width: "100%"
};
var getMinValue = (schema) => {
  const minCheck = schema._def.checks.find((c) => c.kind === "min");
  if (!minCheck) {
    return -Infinity;
  }
  if (minCheck.kind !== "min") {
    throw new Error("Expected min check");
  }
  if (!minCheck.inclusive) {
    return -Infinity;
  }
  return minCheck.value;
};
var getMaxValue = (schema) => {
  const maxCheck = schema._def.checks.find((c) => c.kind === "max");
  if (!maxCheck) {
    return Infinity;
  }
  if (maxCheck.kind !== "max") {
    throw new Error("Expected max check");
  }
  if (!maxCheck.inclusive) {
    return Infinity;
  }
  return maxCheck.value;
};
var getStep = (schema) => {
  const multipleStep = schema._def.checks.find((c) => c.kind === "multipleOf");
  if (!multipleStep) {
    return;
  }
  if (multipleStep.kind !== "multipleOf") {
    throw new Error("Expected multipleOf check");
  }
  return multipleStep.value;
};
var ZodNumberEditor = ({
  jsonPath,
  value,
  schema,
  setValue,
  onSave,
  defaultValue,
  onRemove,
  showSaveButton,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const {
    localValue,
    onChange: setLocalValue,
    reset
  } = useLocalState({
    unsavedValue: value,
    schema,
    setValue,
    savedValue: defaultValue
  });
  const onNumberChange = useCallback61((newValue) => {
    setLocalValue(() => newValue, false, false);
  }, [setLocalValue]);
  const isDefault = localValue.value === defaultValue;
  const onTextChange = useCallback61((newValue) => {
    setLocalValue(() => Number(newValue), false, false);
  }, [setLocalValue]);
  const save = useCallback61(() => {
    onSave(() => value, false, false);
  }, [onSave, value]);
  return /* @__PURE__ */ jsxs63(Fieldset, {
    shouldPad: mayPad,
    success: localValue.zodValidation.success,
    children: [
      /* @__PURE__ */ jsx128(SchemaLabel, {
        handleClick: null,
        isDefaultValue: isDefault,
        jsonPath,
        onReset: reset,
        onSave: save,
        showSaveButton,
        onRemove,
        saving,
        valid: localValue.zodValidation.success,
        saveDisabledByParent,
        suffix: null
      }),
      /* @__PURE__ */ jsxs63("div", {
        style: fullWidth6,
        children: [
          /* @__PURE__ */ jsx128(InputDragger, {
            type: "number",
            value: localValue.value,
            style: fullWidth6,
            status: localValue.zodValidation.success ? "ok" : "error",
            placeholder: jsonPath.join("."),
            onTextChange,
            onValueChange: onNumberChange,
            min: getMinValue(schema),
            max: getMaxValue(schema),
            step: getStep(schema),
            rightAlign: false
          }),
          /* @__PURE__ */ jsx128(ZodFieldValidation, {
            path: jsonPath,
            localValue
          })
        ]
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodOptionalEditor.tsx
import { jsx as jsx129 } from "react/jsx-runtime";
var ZodOptionalEditor = ({
  jsonPath,
  schema,
  setValue,
  onSave,
  defaultValue,
  value,
  showSaveButton,
  onRemove,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const { innerType } = schema._def;
  return /* @__PURE__ */ jsx129(ZodOrNullishEditor, {
    defaultValue,
    jsonPath,
    onRemove,
    onSave,
    schema,
    setValue,
    showSaveButton,
    value,
    nullishValue: undefined,
    saving,
    saveDisabledByParent,
    mayPad,
    innerSchema: innerType
  });
};

// src/components/RenderModal/SchemaEditor/ZodStaticFileEditor.tsx
import { useCallback as useCallback62, useMemo as useMemo73 } from "react";
import { jsx as jsx130, jsxs as jsxs64 } from "react/jsx-runtime";
var container29 = {
  width: "100%"
};
var ZodStaticFileEditor = ({
  schema,
  jsonPath,
  setValue,
  defaultValue,
  value,
  onSave,
  showSaveButton,
  onRemove,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const {
    localValue,
    onChange: setLocalValue,
    reset
  } = useLocalState({
    schema,
    setValue,
    unsavedValue: value,
    savedValue: defaultValue
  });
  const def = schema._def;
  const typeName = def.typeName;
  if (typeName !== z.ZodFirstPartyTypeKind.ZodString) {
    throw new Error("expected enum");
  }
  const isRoot = jsonPath.length === 0;
  const comboBoxValues = useMemo73(() => {
    return getStaticFiles().map((option) => {
      return {
        value: option.src,
        label: option.name,
        id: option.src,
        keyHint: null,
        leftItem: option.src === value ? /* @__PURE__ */ jsx130(Checkmark, {}) : null,
        onClick: (id) => {
          setLocalValue(() => id, false, false);
        },
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item"
      };
    });
  }, [setLocalValue, value]);
  const save = useCallback62(() => {
    onSave(() => value);
  }, [onSave, value]);
  return /* @__PURE__ */ jsxs64(Fieldset, {
    shouldPad: mayPad,
    success: localValue.zodValidation.success,
    children: [
      /* @__PURE__ */ jsx130(SchemaLabel, {
        handleClick: null,
        onSave: save,
        showSaveButton,
        isDefaultValue: localValue.value === defaultValue,
        onReset: reset,
        jsonPath,
        onRemove,
        saving,
        valid: localValue.zodValidation.success,
        saveDisabledByParent,
        suffix: null
      }),
      /* @__PURE__ */ jsx130("div", {
        style: isRoot ? undefined : container29,
        children: /* @__PURE__ */ jsx130(Combobox, {
          values: comboBoxValues,
          selectedId: localValue.value,
          title: value
        })
      }),
      /* @__PURE__ */ jsx130(ZodFieldValidation, {
        path: jsonPath,
        localValue
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodStringEditor.tsx
import { useCallback as useCallback63 } from "react";
import { jsx as jsx131, jsxs as jsxs65 } from "react/jsx-runtime";
var fullWidth7 = {
  width: "100%"
};
var ZodStringEditor = ({
  jsonPath,
  value,
  setValue,
  showSaveButton,
  defaultValue,
  schema,
  onSave,
  onRemove,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const {
    localValue,
    onChange: setLocalValue,
    reset
  } = useLocalState({
    schema,
    setValue,
    unsavedValue: value,
    savedValue: defaultValue
  });
  const onChange = useCallback63((e) => {
    setLocalValue(() => e.target.value, false, false);
  }, [setLocalValue]);
  const save = useCallback63(() => {
    onSave(() => value, false, false);
  }, [onSave, value]);
  return /* @__PURE__ */ jsxs65(Fieldset, {
    shouldPad: mayPad,
    success: false,
    children: [
      /* @__PURE__ */ jsx131(SchemaLabel, {
        handleClick: null,
        isDefaultValue: localValue.value === defaultValue,
        jsonPath,
        onReset: reset,
        onSave: save,
        showSaveButton,
        onRemove,
        saving,
        valid: localValue.zodValidation.success,
        saveDisabledByParent,
        suffix: null
      }),
      /* @__PURE__ */ jsxs65("div", {
        style: fullWidth7,
        children: [
          /* @__PURE__ */ jsx131(RemotionInput, {
            value: localValue.value,
            status: localValue.zodValidation ? "ok" : "error",
            placeholder: jsonPath.join("."),
            onChange,
            rightAlign: false,
            name: jsonPath.join(".")
          }),
          /* @__PURE__ */ jsx131(ZodFieldValidation, {
            path: jsonPath,
            localValue
          })
        ]
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodTextareaEditor.tsx
import { useCallback as useCallback64 } from "react";
import { jsx as jsx132, jsxs as jsxs66 } from "react/jsx-runtime";
var fullWidth8 = {
  width: "100%"
};
var textareaStyle = {
  resize: "vertical",
  minHeight: 100
};
var ZodTextareaEditor = ({
  jsonPath,
  value,
  setValue,
  showSaveButton,
  defaultValue,
  schema,
  onSave,
  onRemove,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const zodTypes = useZodTypesIfPossible();
  if (!zodTypes) {
    throw new Error("expected zod textarea");
  }
  const {
    localValue,
    onChange: setLocalValue,
    reset
  } = useLocalState({
    schema,
    setValue,
    unsavedValue: value,
    savedValue: defaultValue
  });
  const onChange = useCallback64((e) => {
    setLocalValue(() => e.target.value, false, false);
  }, [setLocalValue]);
  const save = useCallback64(() => {
    onSave(() => value, false, false);
  }, [onSave, value]);
  return /* @__PURE__ */ jsxs66(Fieldset, {
    shouldPad: mayPad,
    success: localValue.zodValidation.success,
    children: [
      /* @__PURE__ */ jsx132(SchemaLabel, {
        handleClick: null,
        isDefaultValue: localValue.value === defaultValue,
        jsonPath,
        onReset: reset,
        onSave: save,
        showSaveButton,
        onRemove,
        saving,
        valid: localValue.zodValidation.success,
        saveDisabledByParent,
        suffix: null
      }),
      /* @__PURE__ */ jsxs66("div", {
        style: fullWidth8,
        children: [
          /* @__PURE__ */ jsx132(RemTextarea, {
            onChange,
            value: localValue.value,
            status: localValue.zodValidation ? "ok" : "error",
            placeholder: jsonPath.join("."),
            name: jsonPath.join("."),
            style: textareaStyle
          }),
          /* @__PURE__ */ jsx132(ZodFieldValidation, {
            path: jsonPath,
            localValue
          })
        ]
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodTupleEditor.tsx
import React88, { useMemo as useMemo75, useState as useState46 } from "react";

// src/components/RenderModal/SchemaEditor/ZodTupleItemEditor.tsx
import { useCallback as useCallback65, useMemo as useMemo74 } from "react";
import { jsx as jsx133 } from "react/jsx-runtime";
var ZodTupleItemEditor = ({
  def,
  onChange,
  jsonPath,
  index,
  value,
  defaultValue,
  onSave: onSaveObject,
  showSaveButton,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const setValue = useCallback65((val) => {
    onChange((oldV) => [
      ...oldV.slice(0, index),
      typeof val === "function" ? val(oldV[index]) : val,
      ...oldV.slice(index + 1)
    ], false, false);
  }, [index, onChange]);
  const newJsonPath = useMemo74(() => [...jsonPath, index], [index, jsonPath]);
  const onSave = useCallback65((updater) => {
    onSaveObject((oldV) => [
      ...oldV.slice(0, index),
      updater(oldV[index]),
      ...oldV.slice(index + 1)
    ], false, false);
  }, [index, onSaveObject]);
  return /* @__PURE__ */ jsx133("div", {
    children: /* @__PURE__ */ jsx133(ZodSwitch, {
      jsonPath: newJsonPath,
      schema: def.items[index],
      value,
      setValue,
      defaultValue,
      onSave,
      showSaveButton,
      onRemove: null,
      saving,
      saveDisabledByParent,
      mayPad
    })
  });
};

// src/components/RenderModal/SchemaEditor/ZodTupleEditor.tsx
import { jsx as jsx134, jsxs as jsxs67 } from "react/jsx-runtime";
var ZodTupleEditor = ({
  schema,
  jsonPath,
  setValue,
  defaultValue,
  value,
  onSave,
  showSaveButton,
  onRemove,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const { localValue, onChange, RevisionContextProvider, reset } = useLocalState({
    unsavedValue: value,
    schema,
    setValue,
    savedValue: defaultValue
  });
  const [expanded, setExpanded] = useState46(true);
  const def = schema._def;
  const suffix2 = useMemo75(() => {
    return expanded ? " [" : " [...] ";
  }, [expanded]);
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const zodTypes = useZodTypesIfPossible();
  const typeName = def.typeName;
  if (typeName !== z.ZodFirstPartyTypeKind.ZodTuple) {
    throw new Error("expected object");
  }
  const isDefaultValue = useMemo75(() => {
    return deepEqual(localValue.value, defaultValue);
  }, [defaultValue, localValue]);
  return /* @__PURE__ */ jsxs67(Fieldset, {
    shouldPad: mayPad,
    success: localValue.zodValidation.success,
    children: [
      /* @__PURE__ */ jsx134("div", {
        style: {
          display: "flex",
          flexDirection: "row"
        },
        children: /* @__PURE__ */ jsx134(SchemaLabel, {
          onReset: reset,
          isDefaultValue,
          jsonPath,
          onRemove,
          suffix: suffix2,
          onSave: () => {
            onSave(() => localValue.value, false, false);
          },
          saveDisabledByParent,
          saving,
          showSaveButton,
          valid: localValue.zodValidation.success,
          handleClick: () => setExpanded(!expanded)
        })
      }),
      expanded ? /* @__PURE__ */ jsx134(RevisionContextProvider, {
        children: /* @__PURE__ */ jsxs67(SchemaVerticalGuide, {
          isRoot: false,
          children: [
            localValue.value.map((child, i) => {
              return /* @__PURE__ */ jsxs67(React88.Fragment, {
                children: [
                  /* @__PURE__ */ jsx134(ZodTupleItemEditor, {
                    onChange,
                    value: child,
                    def,
                    index: i,
                    jsonPath,
                    defaultValue: defaultValue?.[i] ?? createZodValues(def.items[i], z, zodTypes),
                    onSave,
                    showSaveButton,
                    saving,
                    saveDisabledByParent,
                    mayPad
                  }),
                  /* @__PURE__ */ jsx134(SchemaArrayItemSeparationLine, {
                    schema,
                    index: i,
                    onChange,
                    isLast: i === localValue.value.length - 1,
                    showAddButton: false
                  })
                ]
              }, `${i}${localValue.keyStabilityRevision}`);
            }),
            value.length === 0 ? /* @__PURE__ */ jsx134(SchemaArrayItemSeparationLine, {
              schema,
              index: 0,
              onChange,
              isLast: true,
              showAddButton: false
            }) : null
          ]
        })
      }) : null,
      /* @__PURE__ */ jsx134(ZodFieldValidation, {
        path: jsonPath,
        localValue
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodUnionEditor.tsx
import { jsx as jsx135 } from "react/jsx-runtime";
var findNull = (value, zodType) => {
  const nullIndex = value.findIndex((v) => v._def.typeName === zodType.ZodFirstPartyTypeKind.ZodNull || v._def.typeName === zodType.ZodFirstPartyTypeKind.ZodUndefined);
  if (nullIndex === -1) {
    return null;
  }
  const nullishValue = value[nullIndex]._def.typeName === zodType.ZodFirstPartyTypeKind.ZodNull ? null : undefined;
  const otherSchema = value[nullIndex === 0 ? 1 : 0];
  const otherSchemaIsAlsoNullish = otherSchema._def.typeName === zodType.ZodFirstPartyTypeKind.ZodNull || otherSchema._def.typeName === zodType.ZodFirstPartyTypeKind.ZodUndefined;
  return {
    nullIndex,
    nullishValue,
    otherSchema,
    otherSchemaIsAlsoNullish
  };
};
var ZodUnionEditor = ({
  jsonPath,
  schema,
  setValue,
  onSave,
  defaultValue,
  value,
  showSaveButton,
  onRemove,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const { options } = schema._def;
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  if (options.length > 2) {
    return /* @__PURE__ */ jsx135(ZonNonEditableValue, {
      jsonPath,
      label: "Union with more than 2 options not editable",
      showSaveButton,
      saving,
      mayPad
    });
  }
  if (options.length < 2) {
    return /* @__PURE__ */ jsx135(ZonNonEditableValue, {
      jsonPath,
      label: "Union with less than 2 options not editable",
      showSaveButton,
      saving,
      mayPad
    });
  }
  const nullResult = findNull(options, z);
  if (!nullResult) {
    return /* @__PURE__ */ jsx135(ZonNonEditableValue, {
      jsonPath,
      label: "Union only editable with 1 value being null",
      showSaveButton,
      saving,
      mayPad
    });
  }
  const { otherSchema, nullishValue, otherSchemaIsAlsoNullish } = nullResult;
  if (otherSchemaIsAlsoNullish) {
    return /* @__PURE__ */ jsx135(ZonNonEditableValue, {
      jsonPath,
      label: "Not editable - both union values are nullish",
      showSaveButton,
      saving,
      mayPad
    });
  }
  return /* @__PURE__ */ jsx135(ZodOrNullishEditor, {
    defaultValue,
    jsonPath,
    onRemove,
    onSave,
    schema,
    innerSchema: otherSchema,
    setValue,
    showSaveButton,
    value,
    nullishValue,
    saving,
    saveDisabledByParent,
    mayPad
  });
};

// src/components/RenderModal/SchemaEditor/ZodSwitch.tsx
import { jsx as jsx136 } from "react/jsx-runtime";
var ZodSwitch = ({
  schema,
  jsonPath,
  value,
  setValue,
  defaultValue,
  onSave,
  showSaveButton,
  onRemove,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const def = schema._def;
  const typeName = def.typeName;
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const zodTypes = useZodTypesIfPossible();
  if (typeName === z.ZodFirstPartyTypeKind.ZodObject) {
    return /* @__PURE__ */ jsx136(ZodObjectEditor, {
      setValue,
      unsavedValue: value,
      savedValue: defaultValue,
      jsonPath,
      schema,
      onSave,
      showSaveButton,
      onRemove,
      saving,
      saveDisabledByParent,
      mayPad,
      discriminatedUnionReplacement: null
    });
  }
  if (typeName === z.ZodFirstPartyTypeKind.ZodString) {
    if (value.startsWith(window.remotion_staticBase)) {
      return /* @__PURE__ */ jsx136(ZodStaticFileEditor, {
        setValue,
        value,
        jsonPath,
        schema,
        defaultValue,
        onSave,
        showSaveButton,
        onRemove,
        saving,
        saveDisabledByParent,
        mayPad
      });
    }
    if (zodTypes && schema._def.description === zodTypes.ZodZypesInternals.REMOTION_TEXTAREA_BRAND) {
      return /* @__PURE__ */ jsx136(ZodTextareaEditor, {
        value,
        setValue,
        jsonPath,
        schema,
        onSave,
        defaultValue,
        showSaveButton,
        onRemove,
        saving,
        saveDisabledByParent,
        mayPad
      });
    }
    return /* @__PURE__ */ jsx136(ZodStringEditor, {
      value,
      setValue,
      jsonPath,
      schema,
      onSave,
      defaultValue,
      showSaveButton,
      onRemove,
      saving,
      saveDisabledByParent,
      mayPad
    });
  }
  if (typeName === z.ZodFirstPartyTypeKind.ZodDate) {
    return /* @__PURE__ */ jsx136(ZodDateEditor, {
      value,
      setValue,
      jsonPath,
      schema,
      onSave,
      defaultValue,
      showSaveButton,
      onRemove,
      saving,
      saveDisabledByParent,
      mayPad
    });
  }
  if (typeName === z.ZodFirstPartyTypeKind.ZodNumber) {
    return /* @__PURE__ */ jsx136(ZodNumberEditor, {
      value,
      setValue,
      jsonPath,
      schema,
      defaultValue,
      onSave,
      showSaveButton,
      onRemove,
      saving,
      saveDisabledByParent,
      mayPad
    });
  }
  if (typeName === z.ZodFirstPartyTypeKind.ZodBoolean) {
    return /* @__PURE__ */ jsx136(ZodBooleanEditor, {
      value,
      setValue,
      jsonPath,
      defaultValue,
      onSave,
      showSaveButton,
      onRemove,
      saving,
      saveDisabledByParent,
      mayPad,
      schema
    });
  }
  if (typeName === z.ZodFirstPartyTypeKind.ZodUndefined) {
    return /* @__PURE__ */ jsx136(ZonNonEditableValue, {
      jsonPath,
      showSaveButton,
      label: "undefined",
      saving,
      mayPad
    });
  }
  if (typeName === z.ZodFirstPartyTypeKind.ZodNull) {
    return /* @__PURE__ */ jsx136(ZonNonEditableValue, {
      jsonPath,
      showSaveButton,
      label: "null",
      saving,
      mayPad
    });
  }
  if (typeName === z.ZodFirstPartyTypeKind.ZodAny) {
    return /* @__PURE__ */ jsx136(ZonNonEditableValue, {
      jsonPath,
      showSaveButton,
      label: "any (not editable)",
      saving,
      mayPad
    });
  }
  if (typeName === z.ZodFirstPartyTypeKind.ZodBigInt) {
    return /* @__PURE__ */ jsx136(ZonNonEditableValue, {
      jsonPath,
      showSaveButton,
      label: "BigInt (not editable)",
      saving,
      mayPad
    });
  }
  if (typeName === z.ZodFirstPartyTypeKind.ZodUnknown) {
    return /* @__PURE__ */ jsx136(ZonNonEditableValue, {
      jsonPath,
      showSaveButton,
      label: "unknown (not editable)",
      saving,
      mayPad
    });
  }
  if (typeName === z.ZodFirstPartyTypeKind.ZodArray) {
    return /* @__PURE__ */ jsx136(ZodArrayEditor, {
      setValue,
      value,
      jsonPath,
      schema,
      defaultValue,
      onSave,
      showSaveButton,
      onRemove,
      saving,
      saveDisabledByParent,
      mayPad
    });
  }
  if (typeName === z.ZodFirstPartyTypeKind.ZodEnum) {
    return /* @__PURE__ */ jsx136(ZodEnumEditor, {
      setValue,
      value,
      jsonPath,
      schema,
      defaultValue,
      onSave,
      showSaveButton,
      onRemove,
      saving
    });
  }
  if (typeName === z.ZodFirstPartyTypeKind.ZodEffects) {
    if (zodTypes && schema._def.description === zodTypes.ZodZypesInternals.REMOTION_COLOR_BRAND) {
      return /* @__PURE__ */ jsx136(ZodColorEditor, {
        value,
        setValue,
        jsonPath,
        schema,
        onSave,
        defaultValue,
        showSaveButton,
        onRemove,
        saving,
        saveDisabledByParent,
        mayPad
      });
    }
    if (zodTypes && schema._def.description === zodTypes.ZodZypesInternals.REMOTION_MATRIX_BRAND) {
      return /* @__PURE__ */ jsx136(ZodMatrixEditor, {
        setValue,
        value,
        jsonPath,
        schema: schema._def.schema,
        defaultValue,
        onSave,
        showSaveButton,
        onRemove,
        saving,
        saveDisabledByParent,
        mayPad
      });
    }
    return /* @__PURE__ */ jsx136(ZodEffectEditor, {
      value,
      setValue,
      jsonPath,
      schema,
      defaultValue,
      onSave,
      showSaveButton,
      onRemove,
      saving,
      mayPad
    });
  }
  if (typeName === z.ZodFirstPartyTypeKind.ZodUnion) {
    return /* @__PURE__ */ jsx136(ZodUnionEditor, {
      schema,
      showSaveButton,
      jsonPath,
      value,
      defaultValue,
      setValue,
      onSave,
      onRemove,
      saving,
      saveDisabledByParent,
      mayPad
    });
  }
  if (typeName === z.ZodFirstPartyTypeKind.ZodOptional) {
    return /* @__PURE__ */ jsx136(ZodOptionalEditor, {
      jsonPath,
      showSaveButton,
      defaultValue,
      value,
      setValue,
      onSave,
      onRemove,
      schema,
      saving,
      saveDisabledByParent,
      mayPad
    });
  }
  if (typeName === z.ZodFirstPartyTypeKind.ZodNullable) {
    return /* @__PURE__ */ jsx136(ZodNullableEditor, {
      jsonPath,
      showSaveButton,
      defaultValue,
      value,
      setValue,
      onSave,
      onRemove,
      schema,
      saving,
      saveDisabledByParent,
      mayPad
    });
  }
  if (typeName === z.ZodFirstPartyTypeKind.ZodDefault) {
    return /* @__PURE__ */ jsx136(ZodDefaultEditor, {
      jsonPath,
      showSaveButton,
      defaultValue,
      value,
      setValue,
      onSave,
      onRemove,
      schema,
      saving,
      saveDisabledByParent,
      mayPad
    });
  }
  if (typeName === z.ZodFirstPartyTypeKind.ZodDiscriminatedUnion) {
    return /* @__PURE__ */ jsx136(ZodDiscriminatedUnionEditor, {
      defaultValue,
      mayPad,
      schema,
      setValue,
      value,
      jsonPath,
      onRemove,
      onSave,
      saving,
      saveDisabledByParent,
      showSaveButton
    });
  }
  if (typeName === z.ZodFirstPartyTypeKind.ZodTuple) {
    return /* @__PURE__ */ jsx136(ZodTupleEditor, {
      setValue,
      value,
      jsonPath,
      schema,
      defaultValue,
      onSave,
      showSaveButton,
      onRemove,
      saving,
      saveDisabledByParent,
      mayPad
    });
  }
  return /* @__PURE__ */ jsx136(ZonNonEditableValue, {
    jsonPath,
    showSaveButton,
    label: `${typeName} (not editable)`,
    saving,
    mayPad
  });
};

// src/components/RenderModal/SchemaEditor/ZodObjectEditor.tsx
import { jsx as jsx137, jsxs as jsxs68 } from "react/jsx-runtime";
var ZodObjectEditor = ({
  schema,
  jsonPath,
  setValue,
  unsavedValue,
  savedValue,
  onSave,
  showSaveButton,
  onRemove,
  saving,
  saveDisabledByParent,
  mayPad,
  discriminatedUnionReplacement
}) => {
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const [expanded, setExpanded] = useState47(true);
  const { localValue, onChange, RevisionContextProvider, reset } = useLocalState({
    schema,
    setValue,
    unsavedValue,
    savedValue
  });
  const def = schema._def;
  const typeName = def.typeName;
  if (typeName !== z.ZodFirstPartyTypeKind.ZodObject) {
    throw new Error("expected object");
  }
  const shape = def.shape();
  const keys = Object.keys(shape);
  const isRoot = jsonPath.length === 0;
  const isDefaultValue = useMemo76(() => {
    return deepEqual(localValue.value, savedValue);
  }, [savedValue, localValue]);
  const suffix2 = useMemo76(() => {
    return expanded ? " {" : " {...}";
  }, [expanded]);
  return /* @__PURE__ */ jsxs68(Fieldset, {
    shouldPad: !isRoot && mayPad,
    success: localValue.zodValidation.success,
    children: [
      isRoot ? null : /* @__PURE__ */ jsx137(SchemaLabel, {
        isDefaultValue,
        onReset: reset,
        jsonPath,
        onRemove,
        suffix: suffix2,
        onSave: () => {
          onSave(() => {
            return localValue.value;
          }, false, false);
        },
        saveDisabledByParent,
        saving,
        showSaveButton,
        valid: localValue.zodValidation.success,
        handleClick: () => setExpanded(!expanded)
      }),
      expanded ? /* @__PURE__ */ jsx137(RevisionContextProvider, {
        children: /* @__PURE__ */ jsx137(SchemaVerticalGuide, {
          isRoot,
          children: keys.map((key, i) => {
            if (discriminatedUnionReplacement && key === discriminatedUnionReplacement.discriminator) {
              return discriminatedUnionReplacement.markup;
            }
            return /* @__PURE__ */ jsxs68(React89.Fragment, {
              children: [
                /* @__PURE__ */ jsx137(ZodSwitch, {
                  mayPad: true,
                  jsonPath: [...jsonPath, key],
                  schema: shape[key],
                  value: localValue.value[key],
                  defaultValue: (savedValue ?? unsavedValue)[key],
                  setValue: (val, forceApply) => {
                    onChange((oldVal) => {
                      return {
                        ...oldVal,
                        [key]: typeof val === "function" ? val(oldVal[key]) : val
                      };
                    }, forceApply, false);
                  },
                  onSave: (val, forceApply) => {
                    onSave((oldVal) => {
                      return {
                        ...oldVal,
                        [key]: typeof val === "function" ? val(oldVal[key]) : val
                      };
                    }, forceApply, false);
                  },
                  onRemove: null,
                  showSaveButton,
                  saving,
                  saveDisabledByParent
                }),
                i === keys.length - 1 ? null : /* @__PURE__ */ jsx137(SchemaSeparationLine, {})
              ]
            }, key);
          })
        })
      }) : null,
      isRoot || !expanded ? null : /* @__PURE__ */ jsx137("div", {
        style: fieldsetLabel,
        children: "}"
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/SchemaEditor.tsx
import { jsx as jsx138 } from "react/jsx-runtime";
var scrollable2 = {
  display: "flex",
  flexDirection: "column",
  overflowY: "auto"
};
var SchemaEditor = ({
  schema,
  unsavedDefaultProps,
  setValue,
  zodValidationResult,
  savedDefaultProps,
  onSave,
  showSaveButton,
  saving,
  saveDisabledByParent
}) => {
  const keybindings = useKeybinding();
  const [revision, setRevision] = useState48(0);
  const revisionState = useMemo77(() => {
    return {
      childResetRevision: revision
    };
  }, [revision]);
  useEffect42(() => {
    const bumpRevision = () => {
      setRevision((old) => old + 1);
    };
    window.addEventListener(Internals30.PROPS_UPDATED_EXTERNALLY, bumpRevision);
    return () => {
      window.removeEventListener(Internals30.PROPS_UPDATED_EXTERNALLY, bumpRevision);
    };
  }, []);
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const hasChanged = useMemo77(() => {
    return !deepEqual(savedDefaultProps, unsavedDefaultProps);
  }, [savedDefaultProps, unsavedDefaultProps]);
  useEffect42(() => {
    setUnsavedProps(hasChanged);
  }, [hasChanged]);
  const onQuickSave = useCallback66(() => {
    if (hasChanged && showSaveButton) {
      onSave(() => {
        return unsavedDefaultProps;
      });
    }
  }, [hasChanged, onSave, showSaveButton, unsavedDefaultProps]);
  useEffect42(() => {
    const save = keybindings.registerKeybinding({
      event: "keydown",
      key: "s",
      commandCtrlKey: true,
      callback: onQuickSave,
      preventDefault: true,
      triggerIfInputFieldFocused: true,
      keepRegisteredWhenNotHighestContext: true
    });
    return () => {
      save.unregister();
    };
  }, [keybindings, onQuickSave, onSave]);
  const def = schema._def;
  const typeName = def.typeName;
  const reset = useCallback66(() => {
    setValue(savedDefaultProps);
  }, [savedDefaultProps, setValue]);
  if (!zodValidationResult.success) {
    const defaultPropsValid = schema.safeParse(savedDefaultProps);
    if (!defaultPropsValid.success) {
      return /* @__PURE__ */ jsx138(InvalidDefaultProps, {
        zodValidationResult
      });
    }
    return /* @__PURE__ */ jsx138(InvalidSchema, {
      reset,
      zodValidationResult
    });
  }
  if (typeName !== z.ZodFirstPartyTypeKind.ZodObject) {
    return /* @__PURE__ */ jsx138(TopLevelZodValue, {
      typeReceived: typeName
    });
  }
  return /* @__PURE__ */ jsx138("div", {
    ref: defaultPropsEditorScrollableAreaRef,
    style: scrollable2,
    className: VERTICAL_SCROLLBAR_CLASSNAME,
    children: /* @__PURE__ */ jsx138(RevisionContext.Provider, {
      value: revisionState,
      children: /* @__PURE__ */ jsx138(ZodObjectEditor, {
        discriminatedUnionReplacement: null,
        unsavedValue: unsavedDefaultProps,
        setValue,
        jsonPath: [],
        schema,
        savedValue: savedDefaultProps,
        onSave,
        showSaveButton,
        onRemove: null,
        saving,
        saveDisabledByParent,
        mayPad: true
      })
    })
  });
};

// src/components/RenderModal/WarningIndicatorButton.tsx
import { useCallback as useCallback67, useMemo as useMemo78 } from "react";
import { jsx as jsx139, jsxs as jsxs69 } from "react/jsx-runtime";
var style8 = {
  fontSize: 12,
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "transparent",
  color: LIGHT_TEXT,
  borderStyle: "solid",
  borderWidth: 1,
  cursor: "pointer",
  paddingLeft: 8,
  paddingRight: 8,
  paddingTop: 4,
  paddingBottom: 4
};
var triangleStyle2 = {
  width: 12,
  height: 12,
  flexShrink: 0,
  fill: WARNING_COLOR
};
var WarningTriangle2 = (props) => {
  return /* @__PURE__ */ jsx139("svg", {
    viewBox: "0 0 576 512",
    ...props,
    children: /* @__PURE__ */ jsx139("path", {
      d: "M248.747 204.705l6.588 112c.373 6.343 5.626 11.295 11.979 11.295h41.37a12 12 0 0 0 11.979-11.295l6.588-112c.405-6.893-5.075-12.705-11.979-12.705h-54.547c-6.903 0-12.383 5.812-11.978 12.705zM330 384c0 23.196-18.804 42-42 42s-42-18.804-42-42 18.804-42 42-42 42 18.804 42 42zm-.423-360.015c-18.433-31.951-64.687-32.009-83.154 0L6.477 440.013C-11.945 471.946 11.118 512 48.054 512H527.94c36.865 0 60.035-39.993 41.577-71.987L329.577 23.985zM53.191 455.002L282.803 57.008c2.309-4.002 8.085-4.002 10.394 0l229.612 397.993c2.308 4-.579 8.998-5.197 8.998H58.388c-4.617.001-7.504-4.997-5.197-8.997z"
    })
  });
};
var WarningIndicatorButton = ({ setShowWarning, showWarning, warningCount }) => {
  const onClick = useCallback67(() => {
    setShowWarning((s) => !s);
  }, [setShowWarning]);
  const buttonStyle3 = useMemo78(() => {
    return {
      ...style8,
      backgroundColor: showWarning ? INPUT_BACKGROUND : "transparent",
      borderColor: showWarning ? INPUT_BORDER_COLOR_HOVERED : INPUT_BORDER_COLOR_UNHOVERED,
      color: showWarning ? "white" : LIGHT_TEXT
    };
  }, [showWarning]);
  return /* @__PURE__ */ jsxs69("button", {
    type: "button",
    style: buttonStyle3,
    onClick,
    children: [
      /* @__PURE__ */ jsx139(WarningTriangle2, {
        style: triangleStyle2
      }),
      /* @__PURE__ */ jsx139(Spacing, {
        x: 0.5
      }),
      warningCount,
      /* @__PURE__ */ jsx139(Spacing, {
        x: 1
      }),
      /* @__PURE__ */ jsx139(AngleDown, {
        down: showWarning
      })
    ]
  });
};

// src/components/RenderModal/get-render-modal-warnings.ts
import { NoReactInternals as NoReactInternals9 } from "remotion/no-react";
var defaultTypeCanSaveState = {
  canUpdate: false,
  reason: "Loading...",
  determined: false
};
var getInputPropsWarning = ({
  cliProps,
  propsEditType
}) => {
  if (Object.keys(cliProps).length > 0 && propsEditType === "default-props") {
    return "The data that was passed using --props takes priority over the data you enter here.";
  }
  return null;
};
var getCannotSaveDefaultProps = (canSaveDefaultProps) => {
  if (canSaveDefaultProps.canUpdate) {
    return null;
  }
  if (!canSaveDefaultProps.determined) {
    return null;
  }
  return `Can't save default props: ${canSaveDefaultProps.reason}.`;
};
var customDateUsed = (used, inJSONEditor) => {
  if (used && inJSONEditor) {
    return "There is a Date in the schema which was serialized. Note the custom syntax.";
  }
  return null;
};
var staticFileUsed = (used, inJSONEditor) => {
  if (used && inJSONEditor) {
    return "There is a staticFile() in the schema which was serialized. Note the custom syntax.";
  }
  return null;
};
var mapUsed = (used, inJSONEditor) => {
  if (used && inJSONEditor) {
    return "A `Map` was used in the schema which can not be serialized to JSON.";
  }
  return null;
};
var setUsed = (used, inJSONEditor) => {
  if (used && inJSONEditor) {
    return "A `Set` was used in the schema which can not be serialized to JSON.";
  }
  return null;
};
var getRenderModalWarnings = ({
  cliProps,
  canSaveDefaultProps,
  isCustomDateUsed,
  customFileUsed,
  jsMapUsed,
  jsSetUsed,
  inJSONEditor,
  propsEditType
}) => {
  return [
    getInputPropsWarning({ cliProps, propsEditType }),
    getCannotSaveDefaultProps(canSaveDefaultProps),
    customDateUsed(isCustomDateUsed, inJSONEditor),
    staticFileUsed(customFileUsed, inJSONEditor),
    mapUsed(jsMapUsed, inJSONEditor),
    setUsed(jsSetUsed, inJSONEditor)
  ].filter(NoReactInternals9.truthy);
};

// src/components/RenderModal/DataEditor.tsx
import { jsx as jsx140, jsxs as jsxs70 } from "react/jsx-runtime";
var errorExplanation2 = {
  fontSize: 14,
  color: LIGHT_TEXT,
  fontFamily: "sans-serif",
  lineHeight: 1.5
};
var explainer3 = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  padding: "0 12px",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center"
};
var outer = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  overflow: "hidden",
  backgroundColor: BACKGROUND
};
var controlContainer = {
  flexDirection: "column",
  display: "flex",
  padding: 12,
  borderBottom: `1px solid ${BORDER_COLOR}`
};
var tabWrapper = {
  display: "flex",
  marginBottom: "4px",
  flexDirection: "row",
  alignItems: "center"
};
var persistanceKey = "remotion.show-render-modalwarning";
var getPersistedShowWarningState = () => {
  const val = localStorage.getItem(persistanceKey);
  if (!val) {
    return true;
  }
  return val === "true";
};
var setPersistedShowWarningState = (val) => {
  localStorage.setItem(persistanceKey, String(Boolean(val)));
};
var DataEditor = ({
  unresolvedComposition,
  defaultProps,
  setDefaultProps,
  mayShowSaveButton,
  propsEditType,
  saving,
  setSaving,
  readOnlyStudio
}) => {
  const [mode, setMode] = useState49("schema");
  const [showWarning, setShowWarningWithoutPersistance] = useState49(() => getPersistedShowWarningState());
  const { updateCompositionDefaultProps } = useContext36(Internals31.CompositionSetters);
  const inJSONEditor = mode === "json";
  const serializedJSON = useMemo79(() => {
    if (!inJSONEditor) {
      return null;
    }
    const value = defaultProps;
    return NoReactInternals10.serializeJSONWithSpecialTypes({
      data: value,
      indent: 2,
      staticBase: window.remotion_staticBase
    });
  }, [inJSONEditor, defaultProps]);
  const cliProps = getInputProps();
  const [canSaveDefaultPropsObjectState, setCanSaveDefaultProps] = useState49({
    [unresolvedComposition.id]: defaultTypeCanSaveState
  });
  const z = useZodIfPossible();
  const zodTypes = useZodTypesIfPossible();
  const schema = useMemo79(() => {
    if (!z) {
      return "no-zod";
    }
    if (!unresolvedComposition.schema) {
      return "no-schema";
    }
    if (!(typeof unresolvedComposition.schema.safeParse === "function")) {
      throw new Error("A value which is not a Zod schema was passed to `schema`");
    }
    return unresolvedComposition.schema;
  }, [unresolvedComposition.schema, z]);
  const zodValidationResult = useMemo79(() => {
    if (schema === "no-zod") {
      return "no-zod";
    }
    if (schema === "no-schema") {
      return "no-schema";
    }
    return schema.safeParse(defaultProps);
  }, [defaultProps, schema]);
  const setShowWarning = useCallback68((val) => {
    setShowWarningWithoutPersistance((prevVal) => {
      if (typeof val === "boolean") {
        setPersistedShowWarningState(val);
        return val;
      }
      setPersistedShowWarningState(val(prevVal));
      return val(prevVal);
    });
  }, []);
  const canSaveDefaultProps = useMemo79(() => {
    return canSaveDefaultPropsObjectState[unresolvedComposition.id] ? canSaveDefaultPropsObjectState[unresolvedComposition.id] : defaultTypeCanSaveState;
  }, [canSaveDefaultPropsObjectState, unresolvedComposition.id]);
  const showSaveButton = mayShowSaveButton && canSaveDefaultProps.canUpdate;
  const { fastRefreshes } = useContext36(Internals31.NonceContext);
  const checkIfCanSaveDefaultProps = useCallback68(async () => {
    try {
      const can = await canUpdateDefaultProps(unresolvedComposition.id, readOnlyStudio);
      if (can.canUpdate) {
        setCanSaveDefaultProps((prevState) => ({
          ...prevState,
          [unresolvedComposition.id]: {
            canUpdate: true
          }
        }));
      } else {
        setCanSaveDefaultProps((prevState) => ({
          ...prevState,
          [unresolvedComposition.id]: {
            canUpdate: false,
            reason: can.reason,
            determined: true
          }
        }));
      }
    } catch (err) {
      setCanSaveDefaultProps((prevState) => ({
        ...prevState,
        [unresolvedComposition.id]: {
          canUpdate: false,
          reason: err.message,
          determined: true
        }
      }));
    }
  }, [readOnlyStudio, unresolvedComposition.id]);
  useEffect43(() => {
    checkIfCanSaveDefaultProps();
  }, [checkIfCanSaveDefaultProps]);
  const { previewServerState, subscribeToEvent } = useContext36(StudioServerConnectionCtx);
  useEffect43(() => {
    const unsub = subscribeToEvent("root-file-changed", checkIfCanSaveDefaultProps);
    return () => {
      unsub();
    };
  }, [checkIfCanSaveDefaultProps, subscribeToEvent]);
  const modeItems = useMemo79(() => {
    return [
      {
        key: "schema",
        label: "Schema",
        onClick: () => {
          setMode("schema");
        },
        selected: mode === "schema"
      },
      {
        key: "json",
        label: "JSON",
        onClick: () => {
          setMode("json");
        },
        selected: mode === "json"
      }
    ];
  }, [mode]);
  const onUpdate = useCallback68(() => {
    if (schema === "no-zod" || schema === "no-schema" || z === null) {
      showNotification("Cannot update default props: No Zod schema", 2000);
      return;
    }
    callUpdateDefaultPropsApi(unresolvedComposition.id, defaultProps, extractEnumJsonPaths({ schema, zodRuntime: z, currentPath: [], zodTypes })).then((response) => {
      if (!response.success) {
        showNotification(`Cannot update default props: ${response.reason}`, 2000);
      }
    });
  }, [schema, z, unresolvedComposition.id, defaultProps, zodTypes]);
  const onSave = useCallback68((updater) => {
    if (schema === "no-zod" || schema === "no-schema" || z === null) {
      showNotification("Cannot update default props: No Zod schema", 2000);
      return;
    }
    window.remotion_ignoreFastRefreshUpdate = fastRefreshes + 1;
    setSaving(true);
    const newDefaultProps = updater(unresolvedComposition.defaultProps ?? {});
    callUpdateDefaultPropsApi(unresolvedComposition.id, newDefaultProps, extractEnumJsonPaths({
      schema,
      zodRuntime: z,
      currentPath: [],
      zodTypes
    })).then((response) => {
      if (!response.success) {
        console.log(response.stack);
        showNotification(`Cannot update default props: ${response.reason}. See console for more information.`, 2000);
      }
      updateCompositionDefaultProps(unresolvedComposition.id, newDefaultProps);
    }).catch((err) => {
      showNotification(`Cannot update default props: ${err.message}`, 2000);
    }).finally(() => {
      setSaving(false);
    });
  }, [
    schema,
    z,
    zodTypes,
    fastRefreshes,
    setSaving,
    unresolvedComposition.defaultProps,
    unresolvedComposition.id,
    updateCompositionDefaultProps
  ]);
  const connectionStatus = previewServerState.type;
  const warnings = useMemo79(() => {
    return getRenderModalWarnings({
      canSaveDefaultProps,
      cliProps,
      isCustomDateUsed: serializedJSON ? serializedJSON.customDateUsed : false,
      customFileUsed: serializedJSON ? serializedJSON.customFileUsed : false,
      inJSONEditor,
      propsEditType,
      jsMapUsed: serializedJSON ? serializedJSON.mapUsed : false,
      jsSetUsed: serializedJSON ? serializedJSON.setUsed : false
    });
  }, [
    cliProps,
    canSaveDefaultProps,
    inJSONEditor,
    propsEditType,
    serializedJSON
  ]);
  if (connectionStatus === "disconnected") {
    return /* @__PURE__ */ jsxs70("div", {
      style: explainer3,
      children: [
        /* @__PURE__ */ jsx140(Spacing, {
          y: 5
        }),
        /* @__PURE__ */ jsx140("div", {
          style: errorExplanation2,
          children: "The studio server has disconnected. Reconnect to edit the schema."
        }),
        /* @__PURE__ */ jsx140(Spacing, {
          y: 2,
          block: true
        })
      ]
    });
  }
  if (schema === "no-zod") {
    return /* @__PURE__ */ jsx140(ZodNotInstalled, {});
  }
  if (schema === "no-schema") {
    return /* @__PURE__ */ jsx140(NoSchemaDefined, {});
  }
  if (!z) {
    throw new Error("expected zod");
  }
  if (zodValidationResult === "no-zod") {
    throw new Error("expected zod");
  }
  if (zodValidationResult === "no-schema") {
    throw new Error("expected schema");
  }
  const def = schema._def;
  const typeName = def.typeName;
  if (typeName === z.ZodFirstPartyTypeKind.ZodAny) {
    return /* @__PURE__ */ jsx140(NoSchemaDefined, {});
  }
  if (!unresolvedComposition.defaultProps) {
    return /* @__PURE__ */ jsx140(NoDefaultProps, {});
  }
  return /* @__PURE__ */ jsxs70("div", {
    style: outer,
    children: [
      /* @__PURE__ */ jsxs70("div", {
        style: controlContainer,
        children: [
          /* @__PURE__ */ jsxs70("div", {
            style: tabWrapper,
            children: [
              /* @__PURE__ */ jsx140(SegmentedControl, {
                items: modeItems,
                needsWrapping: false
              }),
              /* @__PURE__ */ jsx140(Flex, {}),
              warnings.length > 0 ? /* @__PURE__ */ jsx140(WarningIndicatorButton, {
                setShowWarning,
                showWarning,
                warningCount: warnings.length
              }) : null
            ]
          }),
          showWarning && warnings.length > 0 ? warnings.map((warning) => /* @__PURE__ */ jsxs70(React92.Fragment, {
            children: [
              /* @__PURE__ */ jsx140(Spacing, {
                y: 1
              }),
              /* @__PURE__ */ jsx140(ValidationMessage, {
                message: warning,
                align: "flex-start",
                type: "warning"
              })
            ]
          }, warning)) : null
        ]
      }),
      mode === "schema" ? /* @__PURE__ */ jsx140(SchemaEditor, {
        unsavedDefaultProps: defaultProps,
        setValue: setDefaultProps,
        schema,
        zodValidationResult,
        savedDefaultProps: unresolvedComposition.defaultProps,
        onSave,
        showSaveButton,
        saving,
        saveDisabledByParent: !zodValidationResult.success
      }) : /* @__PURE__ */ jsx140(RenderModalJSONPropsEditor, {
        value: defaultProps ?? {},
        setValue: setDefaultProps,
        onSave: onUpdate,
        showSaveButton,
        serializedJSON,
        defaultProps: unresolvedComposition.defaultProps,
        schema
      })
    ]
  });
};

// src/components/RenderQueue/index.tsx
import React102, { useContext as useContext42, useEffect as useEffect45, useMemo as useMemo86 } from "react";
import { Internals as Internals33 } from "remotion";

// src/components/RenderQueue/RenderQueueItem.tsx
import {
  useCallback as useCallback77,
  useContext as useContext41,
  useEffect as useEffect44,
  useMemo as useMemo85,
  useState as useState50
} from "react";
import { Internals as Internals32 } from "remotion";

// src/components/RenderQueue/RenderQueueCopyToClipboard.tsx
import { useCallback as useCallback69 } from "react";
import { jsx as jsx141 } from "react/jsx-runtime";
var revealIconStyle2 = {
  height: 12,
  color: "currentColor"
};
var supportsCopyingToClipboard = (job) => {
  if (job.status !== "done") {
    return false;
  }
  if (job.type !== "still") {
    return false;
  }
  if (job.imageFormat === "png") {
    return true;
  }
  if (job.imageFormat === "jpeg") {
    return true;
  }
  return false;
};
var RenderQueueCopyToClipboard = ({ job }) => {
  const renderCopyAction = useCallback69((color) => {
    return /* @__PURE__ */ jsx141(ClipboardIcon, {
      style: revealIconStyle2,
      color
    });
  }, []);
  const onClick = useCallback69(async (e) => {
    e.stopPropagation();
    try {
      const src = `${remotion_outputsBase}/${job.outName}`;
      const content = await fetch(src);
      const contentType = content.headers.get("content-type");
      if (!contentType) {
        throw new Error("Expected content-type header");
      }
      const blob = await content.blob();
      await navigator.clipboard.write([
        new ClipboardItem({
          [contentType]: blob
        })
      ]);
      showNotification("Copied to clipboard!", 1000);
    } catch (err) {
      showNotification(`Could not copy to clipboard: ${err.message}`, 2000);
    }
  }, [job.outName]);
  return /* @__PURE__ */ jsx141(InlineAction, {
    title: "Copy to clipboard",
    renderAction: renderCopyAction,
    onClick
  });
};

// src/components/RenderQueue/RenderQueueError.tsx
import { useCallback as useCallback70, useContext as useContext37 } from "react";

// src/components/RenderQueue/item-style.ts
var renderQueueItemSubtitleStyle = {
  fontSize: 13,
  color: LIGHT_TEXT,
  appearance: "none",
  border: "none",
  padding: 0,
  cursor: "pointer",
  lineHeight: 1.2,
  textAlign: "left",
  whiteSpace: "nowrap",
  marginRight: SPACING_UNIT,
  overflowX: "hidden",
  maxWidth: 500,
  textOverflow: "ellipsis"
};

// src/components/RenderQueue/RenderQueueError.tsx
import { jsx as jsx142 } from "react/jsx-runtime";
var outputLocation = {
  ...renderQueueItemSubtitleStyle
};
var RenderQueueError = ({ job }) => {
  const { setSelectedModal } = useContext37(ModalsContext);
  const { tabIndex } = useZIndex();
  const onClick = useCallback70(() => {
    setSelectedModal({
      type: "render-progress",
      jobId: job.id
    });
  }, [job.id, setSelectedModal]);
  if (job.status !== "failed") {
    throw new Error("should not have rendered this component");
  }
  return /* @__PURE__ */ jsx142("button", {
    onClick,
    type: "button",
    style: outputLocation,
    tabIndex,
    title: job.error.message,
    children: job.error.message
  });
};

// src/components/RenderQueue/RenderQueueItemCancelButton.tsx
import { useCallback as useCallback71, useMemo as useMemo80 } from "react";
import { jsx as jsx143 } from "react/jsx-runtime";
var RenderQueueCancelButton = ({ job }) => {
  const onClick = useCallback71((e) => {
    e.stopPropagation();
    cancelRenderJob(job).catch((err) => {
      showNotification(`Could not cancel job: ${err.message}`, 2000);
    });
  }, [job]);
  const icon5 = useMemo80(() => {
    return {
      height: 14,
      color: "currentColor"
    };
  }, []);
  const renderAction = useCallback71((color) => {
    return /* @__PURE__ */ jsx143("svg", {
      style: icon5,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ jsx143("path", {
        fill: color,
        d: "M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256z"
      })
    });
  }, [icon5]);
  return /* @__PURE__ */ jsx143(InlineAction, {
    renderAction,
    onClick
  });
};

// src/components/RenderQueue/RenderQueueItemStatus.tsx
import React95, { useCallback as useCallback72, useContext as useContext38 } from "react";

// src/components/RenderQueue/CircularProgress.tsx
import { jsx as jsx144 } from "react/jsx-runtime";
var RENDER_STATUS_INDICATOR_SIZE = 16;
var STROKE_WIDTH = 3;
var container30 = {
  height: RENDER_STATUS_INDICATOR_SIZE,
  width: RENDER_STATUS_INDICATOR_SIZE,
  transform: `rotate(-90deg)`
};
var CircularProgress = ({ progress }) => {
  const r = RENDER_STATUS_INDICATOR_SIZE / 2 - STROKE_WIDTH;
  const circumference = r * Math.PI * 2;
  return /* @__PURE__ */ jsx144("svg", {
    style: container30,
    viewBox: `0 0 ${RENDER_STATUS_INDICATOR_SIZE} ${RENDER_STATUS_INDICATOR_SIZE}`,
    children: /* @__PURE__ */ jsx144("circle", {
      r: RENDER_STATUS_INDICATOR_SIZE / 2 - STROKE_WIDTH,
      stroke: LIGHT_TEXT,
      fill: "none",
      strokeWidth: STROKE_WIDTH,
      cx: RENDER_STATUS_INDICATOR_SIZE / 2,
      cy: RENDER_STATUS_INDICATOR_SIZE / 2,
      strokeDasharray: `${circumference} ${circumference}`,
      strokeMiterlimit: 0,
      strokeDashoffset: (1 - progress) * circumference
    })
  });
};

// src/components/RenderQueue/RenderQueueItemStatus.tsx
import { jsx as jsx145 } from "react/jsx-runtime";
var iconStyle3 = {
  height: RENDER_STATUS_INDICATOR_SIZE,
  width: RENDER_STATUS_INDICATOR_SIZE
};
var invisibleStyle = {
  appearance: "none",
  border: "none",
  padding: 0,
  cursor: "pointer",
  display: "flex"
};
var RenderQueueItemStatus = ({ job }) => {
  const { setSelectedModal } = useContext38(ModalsContext);
  const [hovered, setHovered] = React95.useState(false);
  const onPointerEnter = useCallback72(() => {
    setHovered(true);
  }, []);
  const onPointerLeave = useCallback72(() => {
    setHovered(false);
  }, []);
  const onClick = useCallback72((e) => {
    e.stopPropagation();
    setSelectedModal({
      type: "render-progress",
      jobId: job.id
    });
  }, [job.id, setSelectedModal]);
  if (job.status === "failed") {
    return /* @__PURE__ */ jsx145("div", {
      children: /* @__PURE__ */ jsx145("svg", {
        style: iconStyle3,
        viewBox: "0 0 512 512",
        children: /* @__PURE__ */ jsx145("path", {
          fill: FAIL_COLOR,
          d: "M0 160V352L160 512H352L512 352V160L352 0H160L0 160zm353.9 32l-17 17-47 47 47 47 17 17L320 353.9l-17-17-47-47-47 47-17 17L158.1 320l17-17 47-47-47-47-17-17L192 158.1l17 17 47 47 47-47 17-17L353.9 192z"
        })
      })
    });
  }
  if (job.status === "idle") {
    return /* @__PURE__ */ jsx145("svg", {
      style: iconStyle3,
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ jsx145("path", {
        fill: LIGHT_TEXT,
        d: "M256 512C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
      })
    });
  }
  if (job.status === "done") {
    return /* @__PURE__ */ jsx145("button", {
      type: "button",
      style: invisibleStyle,
      onPointerEnter,
      onPointerLeave,
      onClick,
      children: /* @__PURE__ */ jsx145("svg", {
        style: iconStyle3,
        viewBox: "0 0 512 512",
        children: /* @__PURE__ */ jsx145("path", {
          fill: hovered ? "white" : LIGHT_TEXT,
          d: "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM369 209L241 337l-17 17-17-17-64-64-17-17L160 222.1l17 17 47 47L335 175l17-17L385.9 192l-17 17z"
        })
      })
    });
  }
  if (job.status === "running") {
    return /* @__PURE__ */ jsx145("button", {
      type: "button",
      style: invisibleStyle,
      onClick,
      children: /* @__PURE__ */ jsx145(CircularProgress, {
        progress: Math.max(0.07, job.progress.value)
      })
    });
  }
  throw new Error("Unknown job status");
};

// src/components/RenderQueue/RenderQueueOpenInFolder.tsx
import { useCallback as useCallback73, useMemo as useMemo81 } from "react";
import { jsx as jsx146 } from "react/jsx-runtime";
var RenderQueueOpenInFinderItem = ({ job }) => {
  const onClick = useCallback73((e) => {
    e.stopPropagation();
    openInFileExplorer({ directory: job.outName }).catch((err) => {
      showNotification(`Could not open file: ${err.message}`, 2000);
    });
  }, [job.outName]);
  const icon5 = useMemo81(() => {
    return {
      height: 12,
      color: "currentColor"
    };
  }, []);
  const renderAction = useCallback73((color) => {
    return /* @__PURE__ */ jsx146(ExpandedFolderIconSolid, {
      style: icon5,
      color
    });
  }, [icon5]);
  return /* @__PURE__ */ jsx146(InlineAction, {
    renderAction,
    onClick
  });
};

// src/components/RenderQueue/RenderQueueOutputName.tsx
import { useMemo as useMemo82 } from "react";
import { jsx as jsx147 } from "react/jsx-runtime";
var RenderQueueOutputName = ({ job }) => {
  const style9 = useMemo82(() => {
    return {
      ...renderQueueItemSubtitleStyle,
      textDecoration: job.deletedOutputLocation ? "line-through" : "none",
      color: renderQueueItemSubtitleStyle.color,
      cursor: "inherit"
    };
  }, [job.deletedOutputLocation]);
  return /* @__PURE__ */ jsx147("span", {
    style: style9,
    title: job.deletedOutputLocation ? "File was deleted" : job.outName,
    children: job.outName
  });
};

// src/components/RenderQueue/RenderQueueProgressMessage.tsx
import { useCallback as useCallback74, useContext as useContext39 } from "react";
import { jsx as jsx148 } from "react/jsx-runtime";
var outputLocation2 = {
  ...renderQueueItemSubtitleStyle
};
var RenderQueueProgressMessage = ({ job }) => {
  if (job.status !== "running") {
    throw new Error("should not have rendered this component");
  }
  const { setSelectedModal } = useContext39(ModalsContext);
  const { tabIndex } = useZIndex();
  const onClick = useCallback74(() => {
    setSelectedModal({
      type: "render-progress",
      jobId: job.id
    });
  }, [job, setSelectedModal]);
  return /* @__PURE__ */ jsx148("button", {
    onClick,
    type: "button",
    style: outputLocation2,
    tabIndex,
    title: job.progress.message,
    children: job.progress.message
  });
};

// src/components/RenderQueue/RenderQueueRemoveItem.tsx
import { useCallback as useCallback75, useMemo as useMemo83 } from "react";
import { jsx as jsx149 } from "react/jsx-runtime";
var RenderQueueRemoveItem = ({ job }) => {
  const onClick = useCallback75((e) => {
    e.stopPropagation();
    removeRenderJob(job).then(() => {
      showNotification("Removed job", 2000);
    }).catch((err) => {
      showNotification(`Could not remove item: ${err.message}`, 2000);
    });
  }, [job]);
  const icon5 = useMemo83(() => {
    return {
      height: 16,
      color: "currentColor"
    };
  }, []);
  const renderAction = useCallback75((color) => {
    return /* @__PURE__ */ jsx149("svg", {
      style: icon5,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 320 512",
      children: /* @__PURE__ */ jsx149("path", {
        fill: color,
        d: "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z"
      })
    });
  }, [icon5]);
  return /* @__PURE__ */ jsx149(InlineAction, {
    renderAction,
    onClick
  });
};

// src/components/RenderQueue/RenderQueueRepeat.tsx
import { useCallback as useCallback76, useContext as useContext40, useMemo as useMemo84 } from "react";

// src/helpers/retry-payload.ts
import { NoReactInternals as NoReactInternals11 } from "remotion/no-react";
var makeRetryPayload = (job) => {
  const defaults = window.remotion_renderDefaults;
  if (!defaults) {
    throw new Error("defaults not set");
  }
  if (job.type === "still") {
    return {
      type: "render",
      compositionId: job.compositionId,
      initialFrame: job.frame,
      initialStillImageFormat: job.imageFormat,
      initialVideoImageFormat: defaults.videoImageFormat,
      initialJpegQuality: job.jpegQuality ?? defaults.jpegQuality,
      initialScale: job.scale,
      initialLogLevel: job.logLevel,
      initialConcurrency: defaults.concurrency,
      maxConcurrency: defaults.maxConcurrency,
      minConcurrency: defaults.minConcurrency,
      initialMuted: defaults.muted,
      initialEnforceAudioTrack: defaults.enforceAudioTrack,
      initialProResProfile: defaults.proResProfile,
      initialx264Preset: defaults.x264Preset,
      initialPixelFormat: defaults.pixelFormat,
      initialAudioBitrate: defaults.audioBitrate,
      initialVideoBitrate: defaults.videoBitrate,
      initialEveryNthFrame: defaults.everyNthFrame,
      initialNumberOfGifLoops: defaults.numberOfGifLoops,
      initialDelayRenderTimeout: job.delayRenderTimeout,
      defaultConfigurationAudioCodec: defaults.audioCodec,
      initialEnvVariables: job.envVariables,
      initialDisableWebSecurity: job.chromiumOptions.disableWebSecurity,
      initialOpenGlRenderer: job.chromiumOptions.gl,
      initialHeadless: job.chromiumOptions.headless,
      initialIgnoreCertificateErrors: job.chromiumOptions.ignoreCertificateErrors,
      defaultProps: NoReactInternals11.deserializeJSONWithSpecialTypes(job.serializedInputPropsWithCustomSchema),
      inFrameMark: null,
      outFrameMark: null,
      initialOffthreadVideoCacheSizeInBytes: job.offthreadVideoCacheSizeInBytes,
      initialOffthreadVideoThreads: job.offthreadVideoThreads,
      initialColorSpace: defaults.colorSpace,
      initialMultiProcessOnLinux: job.multiProcessOnLinux,
      defaultConfigurationVideoCodec: defaults.codec,
      initialEncodingBufferSize: defaults.encodingBufferSize,
      initialEncodingMaxRate: defaults.encodingMaxRate,
      initialUserAgent: job.chromiumOptions.userAgent,
      initialBeep: job.beepOnFinish,
      initialRepro: job.repro,
      initialForSeamlessAacConcatenation: defaults.forSeamlessAacConcatenation,
      defaulMetadata: job.metadata,
      renderTypeOfLastRender: "still",
      initialHardwareAcceleration: defaults.hardwareAcceleration,
      initialChromeMode: job.chromeMode
    };
  }
  if (job.type === "sequence") {
    return {
      type: "render",
      initialFrame: 0,
      compositionId: job.compositionId,
      initialVideoImageFormat: defaults.videoImageFormat,
      initialJpegQuality: job.jpegQuality ?? defaults.jpegQuality,
      initialScale: job.scale,
      initialLogLevel: job.logLevel,
      initialConcurrency: defaults.concurrency,
      maxConcurrency: defaults.maxConcurrency,
      minConcurrency: defaults.minConcurrency,
      initialMuted: defaults.muted,
      initialEnforceAudioTrack: defaults.enforceAudioTrack,
      initialProResProfile: defaults.proResProfile,
      initialx264Preset: defaults.x264Preset,
      initialPixelFormat: defaults.pixelFormat,
      initialAudioBitrate: defaults.audioBitrate,
      initialVideoBitrate: defaults.videoBitrate,
      initialEveryNthFrame: defaults.everyNthFrame,
      initialNumberOfGifLoops: defaults.numberOfGifLoops,
      initialDelayRenderTimeout: job.delayRenderTimeout,
      initialEnvVariables: job.envVariables,
      initialDisableWebSecurity: job.chromiumOptions.disableWebSecurity,
      initialOpenGlRenderer: job.chromiumOptions.gl,
      initialHeadless: job.chromiumOptions.headless,
      initialIgnoreCertificateErrors: job.chromiumOptions.ignoreCertificateErrors,
      defaultProps: NoReactInternals11.deserializeJSONWithSpecialTypes(job.serializedInputPropsWithCustomSchema),
      initialStillImageFormat: defaults.stillImageFormat,
      inFrameMark: job.startFrame,
      outFrameMark: job.endFrame,
      initialOffthreadVideoCacheSizeInBytes: job.offthreadVideoCacheSizeInBytes,
      initialOffthreadVideoThreads: job.offthreadVideoThreads,
      initialColorSpace: defaults.colorSpace,
      initialMultiProcessOnLinux: job.multiProcessOnLinux,
      defaultConfigurationVideoCodec: defaults.codec,
      defaultConfigurationAudioCodec: defaults.audioCodec,
      initialEncodingBufferSize: defaults.encodingBufferSize,
      initialEncodingMaxRate: defaults.encodingMaxRate,
      initialUserAgent: job.chromiumOptions.userAgent,
      initialBeep: job.beepOnFinish,
      initialRepro: job.repro,
      initialForSeamlessAacConcatenation: defaults.forSeamlessAacConcatenation,
      defaulMetadata: job.metadata,
      renderTypeOfLastRender: "sequence",
      initialHardwareAcceleration: defaults.hardwareAcceleration,
      initialChromeMode: job.chromeMode
    };
  }
  if (job.type === "video") {
    return {
      type: "render",
      compositionId: job.compositionId,
      initialStillImageFormat: defaults.stillImageFormat,
      initialVideoImageFormat: job.imageFormat,
      initialJpegQuality: job.jpegQuality ?? defaults.jpegQuality,
      initialScale: job.scale,
      initialLogLevel: job.logLevel,
      initialFrame: 0,
      initialConcurrency: job.concurrency,
      maxConcurrency: defaults.maxConcurrency,
      minConcurrency: defaults.minConcurrency,
      initialMuted: job.muted,
      initialEnforceAudioTrack: job.enforceAudioTrack,
      initialProResProfile: job.proResProfile ?? defaults.proResProfile,
      initialx264Preset: job.x264Preset ?? defaults.x264Preset,
      initialPixelFormat: job.pixelFormat,
      initialAudioBitrate: job.audioBitrate,
      initialVideoBitrate: job.videoBitrate,
      initialEveryNthFrame: job.everyNthFrame,
      initialNumberOfGifLoops: job.numberOfGifLoops,
      initialDelayRenderTimeout: job.delayRenderTimeout,
      initialEnvVariables: job.envVariables,
      initialDisableWebSecurity: job.chromiumOptions.disableWebSecurity,
      initialOpenGlRenderer: job.chromiumOptions.gl,
      initialHeadless: job.chromiumOptions.headless,
      initialIgnoreCertificateErrors: job.chromiumOptions.ignoreCertificateErrors,
      defaultProps: NoReactInternals11.deserializeJSONWithSpecialTypes(job.serializedInputPropsWithCustomSchema),
      inFrameMark: job.startFrame,
      outFrameMark: job.endFrame,
      initialOffthreadVideoCacheSizeInBytes: job.offthreadVideoCacheSizeInBytes,
      initialOffthreadVideoThreads: job.offthreadVideoThreads,
      initialColorSpace: job.colorSpace,
      initialMultiProcessOnLinux: job.multiProcessOnLinux,
      defaultConfigurationVideoCodec: job.codec,
      defaultConfigurationAudioCodec: job.audioCodec,
      initialEncodingBufferSize: job.encodingBufferSize,
      initialEncodingMaxRate: job.encodingMaxRate,
      initialUserAgent: job.chromiumOptions.userAgent,
      initialBeep: job.beepOnFinish,
      initialRepro: job.repro,
      initialForSeamlessAacConcatenation: job.forSeamlessAacConcatenation,
      defaulMetadata: job.metadata,
      renderTypeOfLastRender: "video",
      initialHardwareAcceleration: job.hardwareAcceleration,
      initialChromeMode: job.chromeMode
    };
  }
  throw new Error(`Job ${JSON.stringify(job)} Not implemented`);
};

// src/components/RenderQueue/RenderQueueRepeat.tsx
import { jsx as jsx150 } from "react/jsx-runtime";
var RenderQueueRepeatItem = ({ job }) => {
  const { setSelectedModal } = useContext40(ModalsContext);
  const isMobileLayout = useMobileLayout();
  const { setSidebarCollapsedState } = useContext40(SidebarContext);
  const onClick = useCallback76((e) => {
    e.stopPropagation();
    const retryPayload = makeRetryPayload(job);
    setSelectedModal(retryPayload);
    if (isMobileLayout) {
      setSidebarCollapsedState({ left: "collapsed", right: "collapsed" });
    }
  }, [isMobileLayout, job, setSelectedModal, setSidebarCollapsedState]);
  const icon5 = useMemo84(() => {
    return {
      height: 12,
      color: "currentColor"
    };
  }, []);
  const renderAction = useCallback76((color) => {
    return /* @__PURE__ */ jsx150("svg", {
      style: icon5,
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ jsx150("path", {
        fill: color,
        d: "M386.3 160H336c-17.7 0-32 14.3-32 32s14.3 32 32 32H464c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0s-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3s163.8-62.5 226.3 0L386.3 160z"
      })
    });
  }, [icon5]);
  return /* @__PURE__ */ jsx150(InlineAction, {
    onClick,
    renderAction
  });
};

// src/components/RenderQueue/RenderQueueItem.tsx
import { jsx as jsx151, jsxs as jsxs71 } from "react/jsx-runtime";
var container31 = {
  padding: 12,
  display: "flex",
  flexDirection: "row",
  paddingBottom: 10,
  paddingRight: 4
};
var title3 = {
  fontSize: 13,
  lineHeight: 1
};
var right = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  overflow: "hidden"
};
var subtitle2 = {
  maxWidth: "100%",
  flex: 1,
  display: "flex",
  overflow: "hidden"
};
var SELECTED_CLASSNAME = "__remotion_selected_classname";
var RenderQueueItem = ({ job, selected }) => {
  const [hovered, setHovered] = useState50(false);
  const { setCanvasContent } = useContext41(Internals32.CompositionSetters);
  const onPointerEnter = useCallback77(() => {
    setHovered(true);
  }, []);
  const onPointerLeave = useCallback77(() => {
    setHovered(false);
  }, []);
  const isHoverable = job.status === "done";
  const containerStyle2 = useMemo85(() => {
    return {
      ...container31,
      backgroundColor: getBackgroundFromHoverState({
        hovered: isHoverable && hovered && job.type !== "sequence",
        selected
      }),
      userSelect: "none",
      WebkitUserSelect: "none"
    };
  }, [hovered, isHoverable, job.type, selected]);
  const scrollCurrentIntoView = useCallback77(() => {
    document.querySelector(`.${SELECTED_CLASSNAME}`)?.scrollIntoView({ behavior: "smooth" });
  }, []);
  const onClick = useCallback77(() => {
    if (job.status !== "done") {
      return;
    }
    if (job.type === "sequence") {
      return;
    }
    setCanvasContent((c) => {
      const isAlreadySelected = c && c.type === "output" && c.path === `/${job.outName}`;
      if (isAlreadySelected && !selected) {
        scrollCurrentIntoView();
        return c;
      }
      return { type: "output", path: `/${job.outName}` };
    });
    pushUrl(`/outputs/${job.outName}`);
  }, [job, scrollCurrentIntoView, selected, setCanvasContent]);
  useEffect44(() => {
    if (selected) {
      scrollCurrentIntoView();
    }
  }, [scrollCurrentIntoView, selected]);
  return /* @__PURE__ */ jsxs71(Row, {
    onPointerEnter,
    onPointerLeave,
    style: containerStyle2,
    align: "center",
    onClick,
    className: selected ? SELECTED_CLASSNAME : undefined,
    children: [
      /* @__PURE__ */ jsx151(RenderQueueItemStatus, {
        job
      }),
      /* @__PURE__ */ jsx151(Spacing, {
        x: 1
      }),
      /* @__PURE__ */ jsxs71("div", {
        style: right,
        children: [
          /* @__PURE__ */ jsx151("div", {
            style: title3,
            children: job.compositionId
          }),
          /* @__PURE__ */ jsx151("div", {
            style: subtitle2,
            children: job.status === "done" ? /* @__PURE__ */ jsx151(RenderQueueOutputName, {
              job
            }) : job.status === "failed" ? /* @__PURE__ */ jsx151(RenderQueueError, {
              job
            }) : job.status === "running" ? /* @__PURE__ */ jsx151(RenderQueueProgressMessage, {
              job
            }) : null
          })
        ]
      }),
      /* @__PURE__ */ jsx151(Spacing, {
        x: 1
      }),
      supportsCopyingToClipboard(job) ? /* @__PURE__ */ jsx151(RenderQueueCopyToClipboard, {
        job
      }) : null,
      job.status === "done" || job.status === "failed" ? /* @__PURE__ */ jsx151(RenderQueueRepeatItem, {
        job
      }) : null,
      job.status === "running" ? /* @__PURE__ */ jsx151(RenderQueueCancelButton, {
        job
      }) : /* @__PURE__ */ jsx151(RenderQueueRemoveItem, {
        job
      }),
      job.status === "done" ? /* @__PURE__ */ jsx151(RenderQueueOpenInFinderItem, {
        job
      }) : null
    ]
  });
};

// src/components/RenderQueue/index.tsx
import { jsx as jsx152, jsxs as jsxs72 } from "react/jsx-runtime";
var separatorStyle = {
  borderBottom: `1px solid ${BORDER_COLOR}`
};
var errorExplanation3 = {
  fontSize: 14,
  color: LIGHT_TEXT,
  fontFamily: "sans-serif",
  lineHeight: 1.5
};
var explainer4 = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  padding: "0 12px",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  background: BACKGROUND
};
var renderQueue = {
  background: BACKGROUND,
  flex: 1,
  overflowY: "auto"
};
var RenderQueue = () => {
  const connectionStatus = useContext42(StudioServerConnectionCtx).previewServerState.type;
  const { jobs } = useContext42(RenderQueueContext);
  const { canvasContent } = useContext42(Internals33.CompositionManager);
  const previousJobCount = React102.useRef(jobs.length);
  const jobCount = jobs.length;
  const divRef = React102.useRef(null);
  useEffect45(() => {
    if (!divRef.current) {
      return;
    }
    if (jobCount > previousJobCount.current) {
      divRef.current.scrollTo({
        top: divRef.current.scrollHeight,
        behavior: "smooth"
      });
    }
    previousJobCount.current = jobCount;
  }, [jobCount]);
  const selectedJob = useMemo86(() => {
    let selectedIndex = -1;
    for (let i = 0;i < jobs.length; i++) {
      const job = jobs[i];
      if (canvasContent && canvasContent.type === "output" && canvasContent.path === `/${job.outName}` && job.status === "done") {
        selectedIndex = i;
      }
    }
    return selectedIndex;
  }, [canvasContent, jobs]);
  if (connectionStatus === "disconnected") {
    return /* @__PURE__ */ jsxs72("div", {
      style: explainer4,
      children: [
        /* @__PURE__ */ jsx152(Spacing, {
          y: 5
        }),
        /* @__PURE__ */ jsx152("div", {
          style: errorExplanation3,
          children: "The studio server has disconnected."
        }),
        /* @__PURE__ */ jsx152(Spacing, {
          y: 2,
          block: true
        })
      ]
    });
  }
  if (jobCount === 0) {
    return /* @__PURE__ */ jsxs72("div", {
      style: explainer4,
      children: [
        /* @__PURE__ */ jsx152(Spacing, {
          y: 5
        }),
        /* @__PURE__ */ jsx152("div", {
          style: errorExplanation3,
          children: "No renders in the queue."
        }),
        /* @__PURE__ */ jsx152(Spacing, {
          y: 2,
          block: true
        })
      ]
    });
  }
  return /* @__PURE__ */ jsx152("div", {
    ref: divRef,
    style: renderQueue,
    className: ["css-reset", VERTICAL_SCROLLBAR_CLASSNAME].join(" "),
    children: jobs.map((j, index) => {
      return /* @__PURE__ */ jsx152("div", {
        style: index === jobs.length - 1 ? undefined : separatorStyle,
        children: /* @__PURE__ */ jsx152(RenderQueueItem, {
          selected: selectedJob === index,
          job: j
        })
      }, j.id);
    })
  });
};

// src/components/RendersTab.tsx
import { useContext as useContext43, useMemo as useMemo87 } from "react";
import { Internals as Internals34 } from "remotion";
import { jsx as jsx153, jsxs as jsxs73, Fragment as Fragment20 } from "react/jsx-runtime";
var row3 = {
  display: "flex",
  flexDirection: "row",
  fontSize: 14,
  color: "inherit",
  alignItems: "center",
  flex: 1
};
var badge = {
  height: 16,
  width: 16,
  borderRadius: 3,
  fontSize: 10,
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center"
};
var RendersTab = ({ selected, onClick }) => {
  const { jobs } = useContext43(RenderQueueContext);
  const { canvasContent } = useContext43(Internals34.CompositionManager);
  const failedJobs = jobs.filter((j) => j.status === "failed").length;
  const jobCount = jobs.length;
  const isActuallySelected = useMemo87(() => {
    if (!canvasContent || canvasContent.type !== "composition") {
      return true;
    }
    return selected;
  }, [canvasContent, selected]);
  const badgeStyle = useMemo87(() => {
    return {
      ...badge,
      backgroundColor: failedJobs > 0 ? FAIL_COLOR : "transparent",
      color: failedJobs > 0 ? "white" : LIGHT_TEXT,
      borderWidth: failedJobs > 0 ? 0 : 1,
      borderStyle: "solid",
      borderColor: LIGHT_TEXT
    };
  }, [failedJobs]);
  return /* @__PURE__ */ jsx153(Tab, {
    selected: isActuallySelected,
    onClick,
    children: /* @__PURE__ */ jsxs73("div", {
      style: row3,
      children: [
        "Renders",
        jobCount > 0 ? /* @__PURE__ */ jsxs73(Fragment20, {
          children: [
            /* @__PURE__ */ jsx153(Flex, {}),
            /* @__PURE__ */ jsx153("div", {
              style: badgeStyle,
              children: jobCount
            })
          ]
        }) : null
      ]
    })
  });
};

// src/components/VisualControls/VisualControlsContent.tsx
import React105, { useContext as useContext45 } from "react";

// src/components/VisualControls/VisualControlHandle.tsx
import { useCallback as useCallback79, useContext as useContext44, useEffect as useEffect47, useState as useState53 } from "react";
import { Internals as Internals35 } from "remotion";
import { NoReactInternals as NoReactInternals12 } from "remotion/no-react";

// src/components/VisualControls/ClickableFileName.tsx
import { useCallback as useCallback78, useMemo as useMemo88, useState as useState51 } from "react";

// src/components/Timeline/TimelineStack/source-attribution.ts
var getOriginalSourceAttribution = (originalLocation) => {
  if (!originalLocation.source) {
    return "";
  }
  const split = originalLocation.source.split("/");
  const last = split[split.length - 1];
  if (last.startsWith("index")) {
    const lastTwo = split[split.length - 2];
    return `${lastTwo}/${last}:${originalLocation.line}`;
  }
  return `${last}:${originalLocation.line}`;
};

// src/components/VisualControls/ClickableFileName.tsx
import { jsx as jsx154 } from "react/jsx-runtime";
var container32 = {
  paddingLeft: SCHEMA_EDITOR_FIELDSET_PADDING,
  paddingTop: SCHEMA_EDITOR_FIELDSET_PADDING / 2
};
var ClickableFileName = ({
  originalFileName
}) => {
  const [titleHovered, setTitleHovered] = useState51(false);
  const hoverEffect = titleHovered && originalFileName.type === "loaded";
  const onTitlePointerEnter = useCallback78(() => {
    setTitleHovered(true);
  }, []);
  const onTitlePointerLeave = useCallback78(() => {
    setTitleHovered(false);
  }, []);
  const style9 = useMemo88(() => {
    return {
      fontSize: 12,
      cursor: originalFileName.type === "loaded" ? "pointer" : undefined,
      borderBottom: hoverEffect ? "1px solid #fff" : "none",
      color: hoverEffect ? "#fff" : LIGHT_COLOR
    };
  }, [originalFileName, hoverEffect]);
  const onClick = useCallback78(async () => {
    if (originalFileName.type !== "loaded") {
      return;
    }
    await openOriginalPositionInEditor(originalFileName.originalFileName);
  }, [originalFileName]);
  return /* @__PURE__ */ jsx154("div", {
    style: container32,
    children: /* @__PURE__ */ jsx154("span", {
      style: style9,
      onClick,
      onPointerEnter: onTitlePointerEnter,
      onPointerLeave: onTitlePointerLeave,
      children: originalFileName.type === "loaded" ? getOriginalSourceAttribution(originalFileName.originalFileName) : originalFileName.type === "loading" ? "Loading..." : "Error loading"
    })
  });
};

// src/components/VisualControls/VisualControlHandleHeader.tsx
import { jsx as jsx155 } from "react/jsx-runtime";
var VisualControlHandleHeader = ({ originalFileName }) => {
  return /* @__PURE__ */ jsx155(ClickableFileName, {
    originalFileName
  });
};

// src/components/VisualControls/get-original-stack-trace.ts
import { useEffect as useEffect46, useState as useState52 } from "react";

// src/components/Timeline/TimelineStack/get-stack.ts
import { SourceMapConsumer as SourceMapConsumer2 } from "source-map";

// src/helpers/get-location-of-sequence.ts
var getLocationOfSequence = (stack2) => {
  if (!stack2) {
    return null;
  }
  const parsed = parseStack(stack2.split(`
`));
  let i = 0;
  while (i < parsed.length) {
    const frame2 = parsed[i];
    if (frame2.functionName === "apply") {
      i++;
      continue;
    }
    return frame2;
  }
  return null;
};
var getLocationOfFunctionCall = (stack2, functionName) => {
  if (!stack2) {
    return null;
  }
  const parsed = parseStack(stack2.split(`
`));
  let i = 0;
  while (i < parsed.length) {
    const frame2 = parsed[i];
    if (frame2.functionName !== functionName) {
      i++;
      continue;
    }
    return parsed[i + 1];
  }
  return null;
};

// src/components/Timeline/TimelineStack/get-stack.ts
var waiters = [];
var sourceMapConsumerCache = {};
var isCreating = {};
var getSourceMapCache = async (fileName) => {
  if (sourceMapConsumerCache[fileName]) {
    return sourceMapConsumerCache[fileName];
  }
  if (isCreating[fileName]) {
    return new Promise((resolve) => {
      waiters.push({
        id: String(Math.random()),
        forFileName: fileName,
        resolve
      });
    });
  }
  isCreating[fileName] = true;
  const res = await fetch(`${fileName}.map`);
  const json = await res.json();
  const map = await new Promise((resolve) => {
    SourceMapConsumer2.with(json, null, (consumer) => {
      resolve(consumer);
    });
  });
  waiters.filter((w) => {
    if (w.forFileName === fileName) {
      w.resolve(map);
      return false;
    }
    return true;
  });
  sourceMapConsumerCache[fileName] = map;
  isCreating[fileName] = false;
  return map;
};
var getOriginalLocationFromStack = async (stack2, type) => {
  const location2 = type === "sequence" ? getLocationOfSequence(stack2) : getLocationOfFunctionCall(stack2, "visualControl");
  if (!location2) {
    return null;
  }
  const map = await getSourceMapCache(location2.fileName);
  const originalPosition = getOriginalPosition(map, location2.lineNumber, location2.columnNumber);
  return originalPosition;
};

// src/components/VisualControls/get-original-stack-trace.ts
var useOriginalFileName = (stack2) => {
  const [originalFileName, setOriginalFileName] = useState52({ type: "loading" });
  useEffect46(() => {
    if (!stack2) {
      return;
    }
    getOriginalLocationFromStack(stack2, "visual-control").then((frame2) => {
      if (frame2 === null) {
        setOriginalFileName({
          type: "error",
          error: new Error("No frame found")
        });
      } else {
        setOriginalFileName({ type: "loaded", originalFileName: frame2 });
      }
    }).catch((err) => {
      console.error("Could not get original location of Sequence", err);
    });
  }, [stack2]);
  return originalFileName;
};

// src/components/VisualControls/VisualControlHandle.tsx
import { jsx as jsx156, jsxs as jsxs74, Fragment as Fragment21 } from "react/jsx-runtime";
var VisualControlHandle = ({ value, keyName }) => {
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const zodTypes = useZodTypesIfPossible();
  const state = useContext44(VisualControlsContext);
  const { updateValue } = useContext44(SetVisualControlsContext);
  const { fastRefreshes } = useContext44(Internals35.NonceContext);
  const { increaseManualRefreshes } = useContext44(Internals35.SetNonceContext);
  const [saving, setSaving] = useState53(false);
  const currentValue = getVisualControlEditedValue({
    handles: state.handles,
    key: keyName
  });
  const originalFileName = useOriginalFileName(value.stack);
  const { localValue, RevisionContextProvider, onChange } = useLocalState({
    schema: value.schema,
    setValue: (updater) => {
      updateValue(keyName, updater(currentValue));
      increaseManualRefreshes();
    },
    unsavedValue: currentValue,
    savedValue: value.valueInCode
  });
  const disableSave = window.remotion_isReadOnlyStudio || originalFileName.type !== "loaded";
  const onSave = useCallback79((updater) => {
    if (disableSave) {
      return;
    }
    if (originalFileName.type !== "loaded") {
      throw new Error("Original file name is not loaded");
    }
    const val = updater(value.valueInCode);
    window.remotion_ignoreFastRefreshUpdate = fastRefreshes + 1;
    const enumPaths = extractEnumJsonPaths({
      schema: value.schema,
      zodRuntime: z,
      currentPath: [],
      zodTypes
    });
    setSaving(true);
    Promise.resolve().then(() => {
      return applyVisualControlChange({
        fileName: originalFileName.originalFileName.source,
        changes: [
          {
            id: keyName,
            newValueSerialized: NoReactInternals12.serializeJSONWithSpecialTypes({
              data: val,
              indent: 2,
              staticBase: window.remotion_staticBase
            }).serializedString,
            enumPaths
          }
        ]
      });
    }).catch((e) => {
      showNotification(`Could not save visual control: ${e.message}`, 3000);
    });
  }, [
    disableSave,
    value.valueInCode,
    value.schema,
    fastRefreshes,
    z,
    originalFileName,
    keyName,
    zodTypes
  ]);
  useEffect47(() => {
    setSaving(false);
  }, [fastRefreshes]);
  return /* @__PURE__ */ jsxs74(Fragment21, {
    children: [
      /* @__PURE__ */ jsx156(VisualControlHandleHeader, {
        originalFileName
      }),
      /* @__PURE__ */ jsx156(Spacing, {
        block: true,
        y: 0.5
      }),
      /* @__PURE__ */ jsx156(RevisionContextProvider, {
        children: /* @__PURE__ */ jsx156(ZodSwitch, {
          mayPad: true,
          schema: value.schema,
          showSaveButton: !disableSave,
          saving,
          saveDisabledByParent: false,
          onSave,
          jsonPath: [keyName],
          value: localValue.value,
          defaultValue: value.valueInCode,
          setValue: onChange,
          onRemove: null
        })
      })
    ]
  });
};

// src/components/VisualControls/VisualControlsContent.tsx
import { jsx as jsx157, jsxs as jsxs75 } from "react/jsx-runtime";
var container33 = {
  overflowY: "auto"
};
var VisualControlsContent = () => {
  const { handles } = useContext45(VisualControlsContext);
  const entries = Object.entries(handles);
  return /* @__PURE__ */ jsx157("div", {
    style: container33,
    className: VERTICAL_SCROLLBAR_CLASSNAME,
    children: entries.map(([key, value], i) => {
      return /* @__PURE__ */ jsxs75(React105.Fragment, {
        children: [
          /* @__PURE__ */ jsx157(VisualControlHandle, {
            keyName: key,
            value
          }),
          i === entries.length - 1 ? null : /* @__PURE__ */ jsx157(SchemaSeparationLine, {})
        ]
      }, key);
    })
  });
};

// src/components/OptionsPanel.tsx
import { jsx as jsx158, jsxs as jsxs76 } from "react/jsx-runtime";
var localStorageKey3 = "remotion.sidebarPanel";
var getSelectedPanel2 = (readOnlyStudio) => {
  if (readOnlyStudio) {
    return "input-props";
  }
  const panel2 = localStorage.getItem(localStorageKey3);
  if (panel2 === "renders") {
    return "renders";
  }
  if (panel2 === "visual-controls") {
    return "visual-controls";
  }
  return "input-props";
};
var tabsContainer3 = {
  backgroundColor: BACKGROUND
};
var persistSelectedOptionsSidebarPanel2 = (panel2) => {
  localStorage.setItem(localStorageKey3, panel2);
};
var optionsSidebarTabs = createRef9();
var OptionsPanel = ({ readOnlyStudio }) => {
  const { props, updateProps, resetUnsaved } = useContext46(Internals36.EditorPropsContext);
  const [saving, setSaving] = useState54(false);
  const isMobileLayout = useMobileLayout();
  const visualControlsTabActivated = useContext46(VisualControlsTabActivatedContext);
  const container34 = useMemo89(() => ({
    height: "100%",
    width: "100%",
    display: "flex",
    position: isMobileLayout ? "relative" : "absolute",
    flexDirection: "column",
    flex: 1
  }), [isMobileLayout]);
  const [panel2, setPanel] = useState54(() => getSelectedPanel2(readOnlyStudio));
  const onPropsSelected = useCallback80(() => {
    setPanel("input-props");
    persistSelectedOptionsSidebarPanel2("input-props");
  }, []);
  const onRendersSelected = useCallback80(() => {
    setPanel("renders");
    persistSelectedOptionsSidebarPanel2("renders");
  }, []);
  const onVisualControlsSelected = useCallback80(() => {
    setPanel("visual-controls");
    persistSelectedOptionsSidebarPanel2("visual-controls");
  }, []);
  useImperativeHandle12(optionsSidebarTabs, () => {
    return {
      selectRendersPanel: () => {
        setPanel("renders");
        persistSelectedOptionsSidebarPanel2("renders");
      }
    };
  }, []);
  const { compositions, canvasContent } = useContext46(Internals36.CompositionManager);
  const composition = useMemo89(() => {
    if (canvasContent === null || canvasContent.type !== "composition") {
      return null;
    }
    for (const comp of compositions) {
      if (comp.id === canvasContent.compositionId) {
        return comp;
      }
    }
    return null;
  }, [canvasContent, compositions]);
  const setDefaultProps = useCallback80((newProps) => {
    if (composition === null) {
      return;
    }
    window.remotion_ignoreFastRefreshUpdate = null;
    updateProps({
      id: composition.id,
      defaultProps: composition.defaultProps,
      newProps
    });
  }, [composition, updateProps]);
  const currentDefaultProps = useMemo89(() => {
    if (composition === null) {
      return {};
    }
    return props[composition.id] ?? composition.defaultProps ?? {};
  }, [composition, props]);
  const unsavedChangesExist = useMemo89(() => {
    if (composition === null || composition.defaultProps === undefined) {
      return false;
    }
    return !deepEqual(composition.defaultProps, currentDefaultProps);
  }, [currentDefaultProps, composition]);
  const reset = useCallback80((e) => {
    if (e.detail.resetUnsaved) {
      resetUnsaved(e.detail.resetUnsaved);
    }
  }, [resetUnsaved]);
  useEffect48(() => {
    window.addEventListener(Internals36.PROPS_UPDATED_EXTERNALLY, reset);
    return () => {
      window.removeEventListener(Internals36.PROPS_UPDATED_EXTERNALLY, reset);
    };
  }, [reset]);
  return /* @__PURE__ */ jsxs76("div", {
    style: container34,
    className: "css-reset",
    children: [
      /* @__PURE__ */ jsx158("div", {
        style: tabsContainer3,
        children: /* @__PURE__ */ jsxs76(Tabs, {
          children: [
            visualControlsTabActivated ? /* @__PURE__ */ jsx158(Tab, {
              selected: panel2 === "visual-controls",
              onClick: onVisualControlsSelected,
              children: "Controls"
            }) : null,
            composition ? /* @__PURE__ */ jsxs76(Tab, {
              selected: panel2 === "input-props",
              onClick: onPropsSelected,
              style: { justifyContent: "space-between" },
              children: [
                "Props",
                unsavedChangesExist ? /* @__PURE__ */ jsx158(GlobalPropsEditorUpdateButton, {
                  compositionId: composition.id,
                  currentDefaultProps
                }) : null
              ]
            }) : null,
            readOnlyStudio ? null : /* @__PURE__ */ jsx158(RendersTab, {
              onClick: onRendersSelected,
              selected: panel2 === "renders"
            })
          ]
        })
      }),
      panel2 === `input-props` && composition ? /* @__PURE__ */ jsx158(DataEditor, {
        unresolvedComposition: composition,
        defaultProps: currentDefaultProps,
        setDefaultProps,
        mayShowSaveButton: true,
        propsEditType: "default-props",
        saving,
        setSaving,
        readOnlyStudio
      }, composition.id) : panel2 === "visual-controls" && visualControlsTabActivated ? /* @__PURE__ */ jsx158(VisualControlsContent, {}) : readOnlyStudio ? null : /* @__PURE__ */ jsx158(RenderQueue, {})
    ]
  });
};

// src/components/PreviewToolbar.tsx
import { useContext as useContext53, useEffect as useEffect54, useRef as useRef28, useState as useState57 } from "react";
import { Internals as Internals46 } from "remotion";

// src/helpers/show-browser-rendering.ts
var SHOW_BROWSER_RENDERING = false;

// src/state/loop.ts
var key = "remotion.loop";
var persistLoopOption = (option) => {
  localStorage.setItem(key, String(option));
};
var loadLoopOption = () => {
  const item2 = localStorage.getItem(key);
  return item2 !== "false";
};

// src/components/CheckboardToggle.tsx
import { useCallback as useCallback81, useContext as useContext47 } from "react";
import { NoReactInternals as NoReactInternals13 } from "remotion/no-react";
import { jsx as jsx159 } from "react/jsx-runtime";
var accessibilityLabel2 = [
  "Show transparency as checkerboard",
  areKeyboardShortcutsDisabled() ? null : "(T)"
].filter(NoReactInternals13.truthy).join(" ");
var CheckboardToggle = () => {
  const { checkerboard, setCheckerboard } = useContext47(CheckerboardContext);
  const onClick = useCallback81(() => {
    setCheckerboard((c) => {
      return !c;
    });
  }, [setCheckerboard]);
  return /* @__PURE__ */ jsx159(ControlButton, {
    title: accessibilityLabel2,
    "aria-label": accessibilityLabel2,
    onClick,
    children: /* @__PURE__ */ jsx159("svg", {
      "aria-hidden": "true",
      focusable: "false",
      "data-prefix": "fas",
      "data-icon": "game-board-alt",
      className: "svg-inline--fa fa-game-board-alt fa-w-16",
      role: "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      style: { width: 16, height: 16 },
      children: /* @__PURE__ */ jsx159("path", {
        fill: checkerboard ? BLUE : "white",
        d: "M480 0H32A32 32 0 0 0 0 32v448a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zm-32 256H256v192H64V256h192V64h192z"
      })
    })
  });
};

// src/components/FpsCounter.tsx
import {
  useEffect as useEffect49,
  useLayoutEffect,
  useMemo as useMemo90,
  useRef as useRef27,
  useState as useState55
} from "react";
import { Internals as Internals37 } from "remotion";
import { jsxs as jsxs77 } from "react/jsx-runtime";
var label6 = {
  color: "white",
  fontSize: 15,
  fontFamily: "Arial, Helvetica, sans-serif",
  whiteSpace: "nowrap"
};
var pushWithMaxSize = (arr, value, maxSize) => {
  arr.push(value);
  return arr.slice(-maxSize);
};
var FpsCounter = ({ playbackSpeed }) => {
  const videoConfig = Internals37.useUnsafeVideoConfig();
  const [playing] = Internals37.Timeline.usePlayingState();
  const frame2 = Internals37.Timeline.useTimelinePosition();
  const [marker, rerender] = useState55({});
  const [fps, setFps] = useState55(0);
  const previousUpdates = useRef27([]);
  const fpsRef = useRef27(0);
  const playingRef = useRef27(playing);
  useLayoutEffect(() => {
    fpsRef.current = 0;
    previousUpdates.current = [];
    playingRef.current = playing;
  }, [playing]);
  useLayoutEffect(() => {
    if (playingRef.current === false)
      return;
    previousUpdates.current = pushWithMaxSize(previousUpdates.current, performance.now(), 15);
    if (previousUpdates.current.length < 2)
      return;
    const diff = Math.max(...previousUpdates.current) - Math.min(...previousUpdates.current);
    const averageDistanceBetween = diff / (previousUpdates.current.length - 1);
    fpsRef.current = 1000 / averageDistanceBetween;
    if (previousUpdates.current.length === 2)
      setFps(fpsRef.current);
  }, [frame2]);
  useEffect49(() => {
    if (playing) {
      const t = setTimeout(() => {
        rerender({});
        setFps(fpsRef.current);
      }, 1000);
      return () => clearTimeout(t);
    }
  }, [marker, playing]);
  const style9 = useMemo90(() => {
    if (!videoConfig) {
      return {};
    }
    const expectedFps = Math.abs(playbackSpeed) * videoConfig.fps;
    return {
      ...label6,
      color: fps < expectedFps * 0.9 ? "red" : "white"
    };
  }, [fps, playbackSpeed, videoConfig]);
  if (fps === 0) {
    return null;
  }
  if (playing === false) {
    return null;
  }
  if (videoConfig === null) {
    return null;
  }
  return /* @__PURE__ */ jsxs77("div", {
    style: style9,
    children: [
      fps.toFixed(1),
      " FPS"
    ]
  });
};

// src/components/FullscreenToggle.tsx
import { useCallback as useCallback82, useContext as useContext48, useEffect as useEffect50 } from "react";
import { Internals as Internals38 } from "remotion";
import { NoReactInternals as NoReactInternals14 } from "remotion/no-react";
import { jsx as jsx160 } from "react/jsx-runtime";
var accessibilityLabel3 = [
  "Enter fullscreen preview",
  areKeyboardShortcutsDisabled() ? null : "(F)"
].filter(NoReactInternals14.truthy).join(" ");
var FullScreenToggle = () => {
  const keybindings = useKeybinding();
  const { setSize } = useContext48(Internals38.PreviewSizeContext);
  const onClick = useCallback82(() => {
    drawRef.current?.requestFullscreen();
    if (document.fullscreenElement)
      setSize(() => ({
        size: "auto",
        translation: {
          x: 0,
          y: 0
        }
      }));
  }, [setSize]);
  useEffect50(() => {
    const f = keybindings.registerKeybinding({
      event: "keydown",
      key: "f",
      callback: onClick,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      f.unregister();
    };
  }, [keybindings, onClick]);
  return /* @__PURE__ */ jsx160(ControlButton, {
    title: accessibilityLabel3,
    "aria-label": accessibilityLabel3,
    onClick,
    children: /* @__PURE__ */ jsx160("svg", {
      style: { width: 18, height: 18 },
      viewBox: "0 0 448 512",
      fill: "#fff",
      children: /* @__PURE__ */ jsx160("path", {
        d: "M0 180V56c0-13.3 10.7-24 24-24h124c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H64v84c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12zM288 44v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V56c0-13.3-10.7-24-24-24H300c-6.6 0-12 5.4-12 12zm148 276h-40c-6.6 0-12 5.4-12 12v84h-84c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24V332c0-6.6-5.4-12-12-12zM160 468v-40c0-6.6-5.4-12-12-12H64v-84c0-6.6-5.4-12-12-12H12c-6.6 0-12 5.4-12 12v124c0 13.3 10.7 24 24 24h124c6.6 0 12-5.4 12-12z"
      })
    })
  });
};

// src/components/LoopToggle.tsx
import { useCallback as useCallback83 } from "react";
import { jsx as jsx161 } from "react/jsx-runtime";
var accessibilityLabel4 = "Loop video";
var LoopToggle = ({ loop, setLoop }) => {
  const onClick = useCallback83(() => {
    setLoop((c) => {
      persistLoopOption(!c);
      return !c;
    });
  }, [setLoop]);
  return /* @__PURE__ */ jsx161(ControlButton, {
    title: accessibilityLabel4,
    "aria-label": accessibilityLabel4,
    onClick,
    children: /* @__PURE__ */ jsx161("svg", {
      viewBox: "0 0 512 512",
      style: { width: 18, height: 18 },
      children: /* @__PURE__ */ jsx161("path", {
        fill: loop ? BLUE : "white",
        d: "M493.544 181.463c11.956 22.605 18.655 48.4 18.452 75.75C511.339 345.365 438.56 416 350.404 416H192v47.495c0 22.475-26.177 32.268-40.971 17.475l-80-80c-9.372-9.373-9.372-24.569 0-33.941l80-80C166.138 271.92 192 282.686 192 304v48h158.875c52.812 0 96.575-42.182 97.12-94.992.155-15.045-3.17-29.312-9.218-42.046-4.362-9.185-2.421-20.124 4.8-27.284 4.745-4.706 8.641-8.555 11.876-11.786 11.368-11.352 30.579-8.631 38.091 5.571zM64.005 254.992c.545-52.81 44.308-94.992 97.12-94.992H320v47.505c0 22.374 26.121 32.312 40.971 17.465l80-80c9.372-9.373 9.372-24.569 0-33.941l-80-80C346.014 16.077 320 26.256 320 48.545V96H161.596C73.44 96 .661 166.635.005 254.788c-.204 27.35 6.495 53.145 18.452 75.75 7.512 14.202 26.723 16.923 38.091 5.57 3.235-3.231 7.13-7.08 11.876-11.786 7.22-7.16 9.162-18.098 4.8-27.284-6.049-12.735-9.374-27.001-9.219-42.046z"
      })
    })
  });
};

// src/components/MuteToggle.tsx
import { useCallback as useCallback84 } from "react";

// src/icons/media-volume.tsx
import { jsx as jsx162 } from "react/jsx-runtime";
var size3 = 22;
var VolumeOffIcon = () => {
  return /* @__PURE__ */ jsx162("svg", {
    width: size3,
    height: size3,
    viewBox: "0 0 24 24",
    children: /* @__PURE__ */ jsx162("path", {
      d: "M3.63 3.63a.996.996 0 000 1.41L7.29 8.7 7 9H4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h3l3.29 3.29c.63.63 1.71.18 1.71-.71v-4.17l4.18 4.18c-.49.37-1.02.68-1.6.91-.36.15-.58.53-.58.92 0 .72.73 1.18 1.39.91.8-.33 1.55-.77 2.22-1.31l1.34 1.34a.996.996 0 101.41-1.41L5.05 3.63c-.39-.39-1.02-.39-1.42 0zM19 12c0 .82-.15 1.61-.41 2.34l1.53 1.53c.56-1.17.88-2.48.88-3.87 0-3.83-2.4-7.11-5.78-8.4-.59-.23-1.22.23-1.22.86v.19c0 .38.25.71.61.85C17.18 6.54 19 9.06 19 12zm-8.71-6.29l-.17.17L12 7.76V6.41c0-.89-1.08-1.33-1.71-.7zM16.5 12A4.5 4.5 0 0014 7.97v1.79l2.48 2.48c.01-.08.02-.16.02-.24z",
      fill: BLUE
    })
  });
};
var VolumeOnIcon = () => {
  return /* @__PURE__ */ jsx162("svg", {
    width: size3,
    height: size3,
    viewBox: "0 0 24 24",
    children: /* @__PURE__ */ jsx162("path", {
      d: "M3 10v4c0 .55.45 1 1 1h3l3.29 3.29c.63.63 1.71.18 1.71-.71V6.41c0-.89-1.08-1.34-1.71-.71L7 9H4c-.55 0-1 .45-1 1zm13.5 2A4.5 4.5 0 0014 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 4.45v.2c0 .38.25.71.6.85C17.18 6.53 19 9.06 19 12s-1.82 5.47-4.4 6.5c-.36.14-.6.47-.6.85v.2c0 .63.63 1.07 1.21.85C18.6 19.11 21 15.84 21 12s-2.4-7.11-5.79-8.4c-.58-.23-1.21.22-1.21.85z",
      fill: "#fff"
    })
  });
};

// src/state/mute.ts
var key2 = "remotion.mute";
var persistMuteOption = (option) => {
  localStorage.setItem(key2, String(option));
};
var loadMuteOption = () => {
  const item2 = localStorage.getItem(key2);
  return item2 === "true";
};

// src/components/MuteToggle.tsx
import { jsx as jsx163 } from "react/jsx-runtime";
var MuteToggle = ({ muted, setMuted }) => {
  const onClick = useCallback84(() => {
    setMuted((m) => {
      persistMuteOption(!m);
      return !m;
    });
  }, [setMuted]);
  const accessibilityLabel5 = muted ? "Unmute video" : "Mute video";
  return /* @__PURE__ */ jsx163(ControlButton, {
    title: accessibilityLabel5,
    "aria-label": accessibilityLabel5,
    onClick,
    children: muted ? /* @__PURE__ */ jsx163(VolumeOffIcon, {}) : /* @__PURE__ */ jsx163(VolumeOnIcon, {})
  });
};

// src/components/PlayPause.tsx
import { PlayerInternals as PlayerInternals12 } from "@remotion/player";
import { useCallback as useCallback85, useEffect as useEffect51, useState as useState56 } from "react";
import { Internals as Internals39 } from "remotion";

// src/icons/jump-to-start.tsx
import { jsx as jsx164 } from "react/jsx-runtime";
var JumpToStart = (props) => {
  return /* @__PURE__ */ jsx164("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ...props,
    children: /* @__PURE__ */ jsx164("path", {
      fill: "currentColor",
      d: "M0 415.1V96.03c0-17.67 14.33-31.1 31.1-31.1C49.67 64.03 64 78.36 64 96.03v131.8l171.5-156.5C256.1 54.28 288 68.66 288 96.03v131.9l171.5-156.5C480.1 54.28 512 68.66 512 96.03v319.9c0 27.37-31.88 41.74-52.5 24.62L288 285.2v130.7c0 27.37-31.88 41.74-52.5 24.62L64 285.2v130.7c0 17.67-14.33 31.1-31.1 31.1C14.33 447.1 0 433.6 0 415.1z"
    })
  });
};

// src/icons/pause.tsx
import { jsx as jsx165 } from "react/jsx-runtime";
var Pause = (props) => /* @__PURE__ */ jsx165("svg", {
  ...props,
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "pause",
  className: "svg-inline--fa fa-pause fa-w-14",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512",
  children: /* @__PURE__ */ jsx165("path", {
    fill: "currentColor",
    d: "M144 479H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zm304-48V79c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48z"
  })
});

// src/icons/play.tsx
import { jsx as jsx166 } from "react/jsx-runtime";
var Play = (props) => /* @__PURE__ */ jsx166("svg", {
  ...props,
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "play",
  className: "svg-inline--fa fa-play fa-w-14",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512",
  children: /* @__PURE__ */ jsx166("path", {
    fill: "currentColor",
    d: "M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"
  })
});

// src/icons/step-back.tsx
import { jsx as jsx167 } from "react/jsx-runtime";
var StepBack = (props) => {
  return /* @__PURE__ */ jsx167("svg", {
    viewBox: "0 0 448 512",
    ...props,
    children: /* @__PURE__ */ jsx167("path", {
      fill: "currentColor",
      d: "M64 468V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12v176.4l195.5-181C352.1 22.3 384 36.6 384 64v384c0 27.4-31.9 41.7-52.5 24.6L136 292.7V468c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12z"
    })
  });
};

// src/icons/step-forward.tsx
import { jsx as jsx168 } from "react/jsx-runtime";
var StepForward = (props) => {
  return /* @__PURE__ */ jsx168("svg", {
    viewBox: "0 0 448 512",
    ...props,
    children: /* @__PURE__ */ jsx168("path", {
      fill: "currentColor",
      d: "M384 44v424c0 6.6-5.4 12-12 12h-48c-6.6 0-12-5.4-12-12V291.6l-195.5 181C95.9 489.7 64 475.4 64 448V64c0-27.4 31.9-41.7 52.5-24.6L312 219.3V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12z"
    })
  });
};

// src/components/PlayPause.tsx
import { jsx as jsx169, jsxs as jsxs78, Fragment as Fragment22 } from "react/jsx-runtime";
var backStyle = {
  height: 18,
  color: "white"
};
var forwardBackStyle = {
  height: 16,
  color: "white"
};
var iconButton = {
  height: 14,
  width: 14,
  color: "white"
};
var PlayPause = ({ playbackRate, loop, bufferStateDelayInMilliseconds }) => {
  const { inFrame, outFrame } = useTimelineInOutFramePosition();
  const videoConfig = Internals39.useUnsafeVideoConfig();
  const [showBufferIndicator, setShowBufferState] = useState56(false);
  const {
    playing,
    play,
    pause,
    pauseAndReturnToPlayStart,
    frameBack,
    seek,
    frameForward,
    isLastFrame,
    isFirstFrame,
    emitter,
    getCurrentFrame: getCurrentFrame2
  } = PlayerInternals12.usePlayer();
  PlayerInternals12.usePlayback({
    loop,
    playbackRate,
    moveToBeginningWhenEnded: true,
    inFrame,
    outFrame,
    getCurrentFrame: getCurrentFrame2,
    browserMediaControlsBehavior: {
      mode: "register-media-session"
    }
  });
  const isStill = useIsStill();
  useEffect51(() => {
    if (isStill) {
      pause();
    }
  }, [isStill, pause]);
  const onSpace = useCallback85((e) => {
    if (playing) {
      pause();
    } else {
      play();
    }
    e.preventDefault();
  }, [pause, play, playing]);
  const onEnter = useCallback85((e) => {
    if (playing) {
      e.preventDefault();
      pauseAndReturnToPlayStart();
    }
  }, [pauseAndReturnToPlayStart, playing]);
  const onArrowLeft = useCallback85((e) => {
    e.preventDefault();
    if (e.altKey) {
      seek(0);
      ensureFrameIsInViewport({
        direction: "fit-left",
        durationInFrames: getCurrentDuration(),
        frame: 0
      });
    } else if (e.shiftKey) {
      frameBack(getCurrentFps());
      ensureFrameIsInViewport({
        direction: "fit-left",
        durationInFrames: getCurrentDuration(),
        frame: Math.max(0, getCurrentFrame2() - getCurrentFps())
      });
    } else {
      frameBack(1);
      ensureFrameIsInViewport({
        direction: "fit-left",
        durationInFrames: getCurrentDuration(),
        frame: Math.max(0, getCurrentFrame2() - 1)
      });
    }
  }, [frameBack, seek, getCurrentFrame2]);
  const onArrowRight = useCallback85((e) => {
    if (e.altKey) {
      seek(getCurrentDuration() - 1);
      ensureFrameIsInViewport({
        direction: "fit-right",
        durationInFrames: getCurrentDuration() - 1,
        frame: getCurrentDuration() - 1
      });
    } else if (e.shiftKey) {
      frameForward(getCurrentFps());
      ensureFrameIsInViewport({
        direction: "fit-right",
        durationInFrames: getCurrentDuration(),
        frame: Math.min(getCurrentDuration() - 1, getCurrentFrame2() + getCurrentFps())
      });
    } else {
      frameForward(1);
      ensureFrameIsInViewport({
        direction: "fit-right",
        durationInFrames: getCurrentDuration(),
        frame: Math.min(getCurrentDuration() - 1, getCurrentFrame2() + 1)
      });
    }
    e.preventDefault();
  }, [frameForward, seek, getCurrentFrame2]);
  const oneFrameBack = useCallback85(() => {
    frameBack(1);
  }, [frameBack]);
  const oneFrameForward = useCallback85(() => {
    frameForward(1);
  }, [frameForward]);
  const jumpToStart = useCallback85(() => {
    seek(inFrame ?? 0);
  }, [seek, inFrame]);
  const jumpToEnd = useCallback85(() => {
    seek(outFrame ?? getCurrentDuration() - 1);
  }, [seek, outFrame]);
  const keybindings = useKeybinding();
  useEffect51(() => {
    const arrowLeft = keybindings.registerKeybinding({
      event: "keydown",
      key: "ArrowLeft",
      callback: onArrowLeft,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const arrowRight = keybindings.registerKeybinding({
      event: "keydown",
      key: "ArrowRight",
      callback: onArrowRight,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const space = keybindings.registerKeybinding({
      event: "keydown",
      key: " ",
      callback: onSpace,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const enter = keybindings.registerKeybinding({
      event: "keydown",
      key: "enter",
      callback: onEnter,
      commandCtrlKey: false,
      preventDefault: false,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const a = keybindings.registerKeybinding({
      event: "keydown",
      key: "a",
      callback: jumpToStart,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const e = keybindings.registerKeybinding({
      event: "keydown",
      key: "e",
      callback: jumpToEnd,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      arrowLeft.unregister();
      arrowRight.unregister();
      space.unregister();
      enter.unregister();
      a.unregister();
      e.unregister();
    };
  }, [
    jumpToEnd,
    jumpToStart,
    keybindings,
    onArrowLeft,
    onArrowRight,
    onEnter,
    onSpace
  ]);
  useEffect51(() => {
    let timeout = null;
    let stopped = false;
    const onBuffer = () => {
      requestAnimationFrame(() => {
        stopped = false;
        timeout = setTimeout(() => {
          if (!stopped) {
            setShowBufferState(true);
          }
        }, bufferStateDelayInMilliseconds);
      });
    };
    const onResume = () => {
      requestAnimationFrame(() => {
        setShowBufferState(false);
        stopped = true;
        if (timeout) {
          clearTimeout(timeout);
        }
      });
    };
    emitter.addEventListener("waiting", onBuffer);
    emitter.addEventListener("resume", onResume);
    return () => {
      emitter.removeEventListener("waiting", onBuffer);
      emitter.removeEventListener("resume", onResume);
      setShowBufferState(false);
      if (timeout) {
        clearTimeout(timeout);
      }
      stopped = true;
    };
  }, [bufferStateDelayInMilliseconds, emitter]);
  return /* @__PURE__ */ jsxs78(Fragment22, {
    children: [
      /* @__PURE__ */ jsx169(ControlButton, {
        "aria-label": "Jump to beginning",
        title: "Jump to beginning",
        disabled: !videoConfig || isFirstFrame,
        onClick: jumpToStart,
        children: /* @__PURE__ */ jsx169(JumpToStart, {
          style: backStyle
        })
      }),
      /* @__PURE__ */ jsx169(ControlButton, {
        "aria-label": "Step back one frame",
        title: "Step back one frame",
        disabled: !videoConfig || isFirstFrame,
        onClick: oneFrameBack,
        children: /* @__PURE__ */ jsx169(StepBack, {
          style: forwardBackStyle
        })
      }),
      /* @__PURE__ */ jsx169(ControlButton, {
        "aria-label": playing ? "Pause" : "Play",
        title: playing ? "Pause" : "Play",
        onClick: playing ? pause : play,
        disabled: !videoConfig,
        children: playing ? showBufferIndicator ? /* @__PURE__ */ jsx169(PlayerInternals12.BufferingIndicator, {
          type: "studio"
        }) : /* @__PURE__ */ jsx169(Pause, {
          style: iconButton
        }) : /* @__PURE__ */ jsx169(Play, {
          style: iconButton
        })
      }),
      /* @__PURE__ */ jsx169(ControlButton, {
        "aria-label": "Step forward one frame",
        title: "Step forward one frame",
        disabled: !videoConfig || isLastFrame,
        onClick: oneFrameForward,
        children: /* @__PURE__ */ jsx169(StepForward, {
          style: forwardBackStyle
        })
      })
    ]
  });
};

// src/components/PlaybackKeyboardShortcutsManager.tsx
import { PlayerInternals as PlayerInternals13 } from "@remotion/player";
import { useCallback as useCallback86, useEffect as useEffect52 } from "react";
var PlaybackKeyboardShortcutsManager = ({ setPlaybackRate }) => {
  const keybindings = useKeybinding();
  const { play, pause, playing } = PlayerInternals13.usePlayer();
  const onJKey = useCallback86(() => {
    setPlaybackRate((prevPlaybackRate) => {
      if (!playing) {
        return -1;
      }
      if (prevPlaybackRate > -1) {
        return -1;
      }
      if (prevPlaybackRate > -2) {
        return -2;
      }
      return -4;
    });
    play();
  }, [play, playing, setPlaybackRate]);
  const onKKey = useCallback86(() => {
    setPlaybackRate(1);
    pause();
  }, [pause, setPlaybackRate]);
  const onLKey = useCallback86(() => {
    setPlaybackRate((prevPlaybackRate) => {
      if (!playing) {
        return 1;
      }
      if (prevPlaybackRate < 1) {
        return 1;
      }
      if (prevPlaybackRate < 2) {
        return 2;
      }
      return 4;
    });
    play();
  }, [play, playing, setPlaybackRate]);
  useEffect52(() => {
    const jKey = keybindings.registerKeybinding({
      event: "keydown",
      key: "j",
      callback: onJKey,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const kKey = keybindings.registerKeybinding({
      event: "keydown",
      key: "k",
      callback: onKKey,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const lKey = keybindings.registerKeybinding({
      event: "keydown",
      key: "l",
      callback: onLKey,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      jKey.unregister();
      kKey.unregister();
      lKey.unregister();
    };
  }, [keybindings, onJKey, onKKey, onLKey]);
  return null;
};

// src/components/PlaybackRatePersistor.tsx
import { useContext as useContext49, useEffect as useEffect53 } from "react";
import { Internals as Internals40 } from "remotion";

// src/state/playbackrate.ts
var key3 = "remotion.playbackrate";
var persistPlaybackRate = (option) => {
  localStorage.setItem(key3, String(option));
};
var loadPlaybackRate = () => {
  if (typeof window !== "undefined") {
    return 1;
  }
  const item2 = localStorage.getItem(key3);
  if (item2 === null) {
    return 1;
  }
  return Number(item2);
};

// src/components/PlaybackRatePersistor.tsx
var PlaybackRatePersistor = () => {
  const { setPlaybackRate, playbackRate } = useContext49(Internals40.Timeline.TimelineContext);
  useEffect53(() => {
    setPlaybackRate(loadPlaybackRate());
  }, [setPlaybackRate]);
  useEffect53(() => {
    persistPlaybackRate(playbackRate);
  }, [playbackRate]);
  return null;
};

// src/components/PlaybackRateSelector.tsx
import { useContext as useContext50, useMemo as useMemo91 } from "react";
import { Internals as Internals41 } from "remotion";
import { jsx as jsx170 } from "react/jsx-runtime";
var commonPlaybackRates = [
  -4,
  -2,
  -1,
  -0.5,
  -0.25,
  0.25,
  0.5,
  1,
  1.5,
  2,
  4
];
var getPlaybackRateLabel = (playbackRate) => {
  return `${playbackRate}x`;
};
var accessibilityLabel5 = "Change the playback rate";
var comboStyle2 = { width: 80 };
var PlaybackRateSelector = ({ playbackRate, setPlaybackRate }) => {
  const { canvasContent } = useContext50(Internals41.CompositionManager);
  const isStill = useIsStill();
  const style9 = useMemo91(() => {
    return {
      padding: CONTROL_BUTTON_PADDING
    };
  }, []);
  const items = useMemo91(() => {
    const divider = {
      type: "divider",
      id: "divider"
    };
    const values = commonPlaybackRates.map((newPlaybackRate) => {
      return {
        id: String(newPlaybackRate),
        label: getPlaybackRateLabel(newPlaybackRate),
        onClick: () => {
          return setPlaybackRate(() => {
            persistPlaybackRate(newPlaybackRate);
            return newPlaybackRate;
          });
        },
        type: "item",
        value: newPlaybackRate,
        keyHint: null,
        leftItem: String(playbackRate) === String(newPlaybackRate) ? /* @__PURE__ */ jsx170(Checkmark, {}) : null,
        subMenu: null,
        quickSwitcherLabel: null
      };
    });
    const middle = Math.floor(commonPlaybackRates.length / 2);
    return [...values.slice(0, middle), divider, ...values.slice(middle)];
  }, [playbackRate, setPlaybackRate]);
  if (isStill || canvasContent === null || canvasContent.type === "asset") {
    return null;
  }
  return /* @__PURE__ */ jsx170("div", {
    style: style9,
    "aria-label": accessibilityLabel5,
    children: /* @__PURE__ */ jsx170(Combobox, {
      title: accessibilityLabel5,
      style: comboStyle2,
      selectedId: String(playbackRate),
      values: items
    })
  });
};

// src/components/RenderButton.tsx
import { PlayerInternals as PlayerInternals14 } from "@remotion/player";
import { useCallback as useCallback87, useContext as useContext51, useMemo as useMemo92 } from "react";
import { Internals as Internals42 } from "remotion";
import { jsx as jsx171, jsxs as jsxs79 } from "react/jsx-runtime";
var button3 = {
  paddingLeft: 7,
  paddingRight: 7,
  paddingTop: 7,
  paddingBottom: 7
};
var label7 = {
  fontSize: 14
};
var RenderButton = () => {
  const { inFrame, outFrame } = useTimelineInOutFramePosition();
  const { setSelectedModal } = useContext51(ModalsContext);
  const connectionStatus = useContext51(StudioServerConnectionCtx).previewServerState.type;
  const shortcut = areKeyboardShortcutsDisabled() ? "" : "(R)";
  const tooltip = connectionStatus === "connected" ? "Export the current composition " + shortcut : "Connect to the Studio server to render";
  const iconStyle4 = useMemo92(() => {
    return {
      style: {
        height: 16,
        color: "currentColor"
      }
    };
  }, []);
  const video = Internals42.useVideo();
  const getCurrentFrame2 = PlayerInternals14.useFrameImperative();
  const { props } = useContext51(Internals42.EditorPropsContext);
  const onClick = useCallback87(() => {
    if (!video) {
      return null;
    }
    const defaults = window.remotion_renderDefaults;
    if (!defaults) {
      throw new TypeError("Expected defaults");
    }
    setSelectedModal({
      type: "render",
      compositionId: video.id,
      initialFrame: getCurrentFrame2(),
      initialStillImageFormat: defaults.stillImageFormat,
      initialVideoImageFormat: defaults.videoImageFormat,
      initialJpegQuality: defaults.jpegQuality,
      initialScale: window.remotion_renderDefaults?.scale ?? 1,
      initialLogLevel: defaults.logLevel,
      initialConcurrency: defaults.concurrency,
      maxConcurrency: defaults.maxConcurrency,
      minConcurrency: defaults.minConcurrency,
      initialMuted: defaults.muted,
      initialEnforceAudioTrack: defaults.enforceAudioTrack,
      initialProResProfile: defaults.proResProfile,
      initialx264Preset: defaults.x264Preset,
      initialPixelFormat: defaults.pixelFormat,
      initialAudioBitrate: defaults.audioBitrate,
      initialVideoBitrate: defaults.videoBitrate,
      initialEveryNthFrame: defaults.everyNthFrame,
      initialNumberOfGifLoops: defaults.numberOfGifLoops,
      initialDelayRenderTimeout: defaults.delayRenderTimeout,
      defaultConfigurationAudioCodec: defaults.audioCodec,
      initialEnvVariables: window.process.env,
      initialDisableWebSecurity: defaults.disableWebSecurity,
      initialOpenGlRenderer: defaults.openGlRenderer,
      initialHeadless: defaults.headless,
      initialIgnoreCertificateErrors: defaults.ignoreCertificateErrors,
      initialOffthreadVideoCacheSizeInBytes: defaults.offthreadVideoCacheSizeInBytes,
      initialOffthreadVideoThreads: defaults.offthreadVideoThreads,
      defaultProps: props[video.id] ?? video.defaultProps,
      inFrameMark: inFrame,
      outFrameMark: outFrame,
      initialColorSpace: defaults.colorSpace,
      initialMultiProcessOnLinux: defaults.multiProcessOnLinux,
      defaultConfigurationVideoCodec: defaults.codec,
      initialEncodingBufferSize: defaults.encodingBufferSize,
      initialEncodingMaxRate: defaults.encodingMaxRate,
      initialUserAgent: defaults.userAgent,
      initialBeep: defaults.beepOnFinish,
      initialRepro: defaults.repro,
      initialForSeamlessAacConcatenation: defaults.forSeamlessAacConcatenation,
      renderTypeOfLastRender: null,
      defaulMetadata: defaults.metadata,
      initialHardwareAcceleration: defaults.hardwareAcceleration,
      initialChromeMode: defaults.chromeMode
    });
  }, [video, setSelectedModal, getCurrentFrame2, props, inFrame, outFrame]);
  if (!video) {
    return null;
  }
  return /* @__PURE__ */ jsx171(Button, {
    id: "render-modal-button",
    title: tooltip,
    onClick,
    buttonContainerStyle: button3,
    disabled: connectionStatus !== "connected",
    children: /* @__PURE__ */ jsxs79(Row, {
      align: "center",
      children: [
        /* @__PURE__ */ jsx171(RenderIcon, {
          svgProps: iconStyle4
        }),
        /* @__PURE__ */ jsx171(Spacing, {
          x: 1
        }),
        /* @__PURE__ */ jsx171("span", {
          style: label7,
          children: "Render"
        })
      ]
    })
  });
};

// src/components/Timeline/TimelineZoomControls.tsx
import { useCallback as useCallback88, useContext as useContext52 } from "react";
import { Internals as Internals43 } from "remotion";

// src/icons/minus.tsx
import { jsx as jsx172 } from "react/jsx-runtime";
var Minus = (props) => {
  return /* @__PURE__ */ jsx172("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    children: /* @__PURE__ */ jsx172("path", {
      fill: "currentColor",
      d: "M400 288h-352c-17.69 0-32-14.32-32-32.01s14.31-31.99 32-31.99h352c17.69 0 32 14.3 32 31.99S417.7 288 400 288z"
    })
  });
};

// src/components/Timeline/TimelineZoomControls.tsx
import { jsx as jsx173, jsxs as jsxs80 } from "react/jsx-runtime";
var container34 = {
  color: "black",
  flexDirection: "row",
  display: "flex",
  alignItems: "center"
};
var buttonStyle3 = {
  fontSize: 24
};
var iconStyle4 = {
  color: "white",
  width: 14
};
var TimelineZoomControls = () => {
  const { canvasContent } = useContext52(Internals43.CompositionManager);
  const { setZoom, zoom: zoomMap } = useContext52(TimelineZoomCtx);
  const { tabIndex } = useZIndex();
  const onMinusClicked = useCallback88(() => {
    if (canvasContent === null || canvasContent.type !== "composition") {
      return;
    }
    setZoom(canvasContent.compositionId, (z) => Math.max(TIMELINE_MIN_ZOOM, z - 0.2));
  }, [canvasContent, setZoom]);
  const onPlusClicked = useCallback88(() => {
    if (canvasContent === null || canvasContent.type !== "composition") {
      return;
    }
    setZoom(canvasContent.compositionId, (z) => Math.min(TIMELINE_MAX_ZOOM, z + 0.2));
  }, [canvasContent, setZoom]);
  const onChange = useCallback88((e) => {
    if (canvasContent === null || canvasContent.type !== "composition") {
      return;
    }
    setZoom(canvasContent.compositionId, () => Number(e.target.value));
  }, [canvasContent, setZoom]);
  const isStill = useIsStill();
  if (isStill || canvasContent === null || canvasContent.type !== "composition") {
    return null;
  }
  const zoom = zoomMap[canvasContent.compositionId] ?? TIMELINE_MIN_ZOOM;
  return /* @__PURE__ */ jsxs80("div", {
    style: container34,
    children: [
      /* @__PURE__ */ jsx173(ControlButton, {
        onClick: onMinusClicked,
        style: buttonStyle3,
        title: "Zoom out timeline",
        role: "ControlButton",
        type: "button",
        disabled: TIMELINE_MIN_ZOOM === zoom,
        children: /* @__PURE__ */ jsx173(Minus, {
          style: iconStyle4
        })
      }),
      /* @__PURE__ */ jsx173(Spacing, {
        x: 0.5
      }),
      /* @__PURE__ */ jsx173("input", {
        title: `Timeline zoom (${zoom}x)`,
        alt: `Timeline zoom (${zoom}x)`,
        type: "range",
        min: TIMELINE_MIN_ZOOM,
        step: 0.1,
        value: zoom,
        max: TIMELINE_MAX_ZOOM,
        onChange,
        className: "__remotion-timeline-slider",
        tabIndex
      }),
      /* @__PURE__ */ jsx173(Spacing, {
        x: 0.5
      }),
      /* @__PURE__ */ jsx173(ControlButton, {
        onClick: onPlusClicked,
        style: buttonStyle3,
        title: "Zoom in timeline",
        role: "button",
        type: "button",
        disabled: TIMELINE_MAX_ZOOM === zoom,
        children: /* @__PURE__ */ jsx173(Plus, {
          color: "currentcolor",
          style: iconStyle4
        })
      })
    ]
  });
};

// ../web-renderer/dist/esm/index.mjs
import ReactDOM8 from "react-dom/client";
import { Internals as Internals44 } from "remotion";
import { jsx as jsx174 } from "react/jsx-runtime";
var compose = ({
  composables,
  width,
  height
}) => {
  const canvas = new OffscreenCanvas(width, height);
  const context = canvas.getContext("2d");
  if (!context) {
    throw new Error("Could not get context");
  }
  for (const composable of composables) {
    context.drawImage(composable, 0, 0);
  }
  return canvas;
};
var findCanvasElements = (element) => {
  const canvasElements = element.querySelectorAll("canvas");
  const composables = [];
  Array.from(canvasElements).forEach((canvasElement) => {
    const canvas = canvasElement;
    composables.push(canvas);
  });
  return composables;
};
var waitForReady = (timeoutInMilliseconds) => {
  const { promise, resolve, reject } = Promise.withResolvers();
  const start = Date.now();
  const interval = setInterval(() => {
    if (window.remotion_renderReady === true) {
      resolve(true);
      clearInterval(interval);
      return;
    }
    if (window.remotion_cancelledError !== undefined) {
      reject(window.remotion_cancelledError);
      clearInterval(interval);
      return;
    }
    if (Date.now() - start > timeoutInMilliseconds + 3000) {
      reject(new Error(Object.values(window.remotion_delayRenderTimeouts).map((d) => d.label).join(", ")));
      clearInterval(interval);
    }
  }, 50);
  return promise;
};
var renderMediaOnWeb = async ({
  Component,
  width,
  height,
  fps,
  durationInFrames
}) => {
  const div = document.createElement("div");
  div.style.display = "flex";
  div.style.backgroundColor = "transparent";
  div.style.position = "absolute";
  div.style.width = `${width}px`;
  div.style.height = `${height}px`;
  document.body.appendChild(div);
  const delayRenderTimeoutInMilliseconds = 1e4;
  if (!ReactDOM8.createRoot) {
    throw new Error("@remotion/web-renderer requires React 18 or higher");
  }
  const compositionManagerContext = {
    currentCompositionMetadata: {
      durationInFrames,
      fps,
      height,
      width,
      props: {},
      defaultCodec: null,
      defaultOutName: null,
      defaultVideoImageFormat: null,
      defaultPixelFormat: null
    },
    folders: [],
    compositions: [
      {
        id: "markup",
        component: Component,
        nonce: 0,
        defaultProps: undefined,
        folderName: null,
        parentFolderName: null,
        schema: null,
        calculateMetadata: null,
        durationInFrames,
        fps,
        height,
        width
      }
    ],
    canvasContent: {
      type: "composition",
      compositionId: "markup"
    }
  };
  const root = ReactDOM8.createRoot(div);
  root.render(/* @__PURE__ */ jsx174(Internals44.RemotionEnvironmentContext, {
    value: {
      isStudio: false,
      isRendering: true,
      isPlayer: false,
      isReadOnlyStudio: false,
      isClientSideRendering: true
    },
    children: /* @__PURE__ */ jsx174(Internals44.RemotionRoot, {
      logLevel: "info",
      numberOfAudioTags: 0,
      onlyRenderComposition: null,
      currentCompositionMetadata: {
        props: {},
        durationInFrames,
        fps,
        height,
        width,
        defaultCodec: null,
        defaultOutName: null,
        defaultVideoImageFormat: null,
        defaultPixelFormat: null
      },
      audioLatencyHint: "interactive",
      children: /* @__PURE__ */ jsx174(Internals44.CanUseRemotionHooks, {
        value: true,
        children: /* @__PURE__ */ jsx174(Internals44.CompositionManager.Provider, {
          value: compositionManagerContext,
          children: /* @__PURE__ */ jsx174(Component, {})
        })
      })
    })
  }));
  await waitForReady(delayRenderTimeoutInMilliseconds);
  const canvasElements = findCanvasElements(div);
  const composed = compose({
    composables: canvasElements,
    width,
    height
  });
  const imageData = await composed.convertToBlob({
    type: "image/png"
  });
  const blob = new Blob([imageData], { type: "image/png" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "composed.png";
  a.click();
  URL.revokeObjectURL(url);
  root.unmount();
  div.remove();
};

// src/components/WebRender/TriggerWebRender.tsx
import { useCallback as useCallback89 } from "react";
import { Internals as Internals45 } from "remotion";
import { jsx as jsx175 } from "react/jsx-runtime";
var button4 = {
  paddingLeft: 7,
  paddingRight: 7,
  paddingTop: 7,
  paddingBottom: 7
};
var TriggerWebRender = () => {
  const video = Internals45.useVideo();
  const onClick = useCallback89(() => {
    if (!video) {
      throw new Error("No video found");
    }
    renderMediaOnWeb({
      Component: video.component,
      width: video.width,
      height: video.height,
      fps: video.fps,
      durationInFrames: video.durationInFrames
    });
  }, [video]);
  return /* @__PURE__ */ jsx175(Button, {
    id: "render-modal-button",
    onClick,
    buttonContainerStyle: button4,
    disabled: false,
    children: /* @__PURE__ */ jsx175("span", {
      children: "Render"
    })
  });
};

// src/components/PreviewToolbar.tsx
import { jsx as jsx176, jsxs as jsxs81, Fragment as Fragment23 } from "react/jsx-runtime";
var container35 = {
  display: "flex",
  justifyContent: "center",
  borderTop: "1px solid rgba(0, 0, 0, 0.5)",
  paddingTop: 2,
  paddingBottom: 2,
  alignItems: "center",
  flexDirection: "row",
  background: BACKGROUND
};
var mobileContainer = {
  ...container35,
  position: "relative",
  overflowY: "auto",
  justifyContent: "flex-start"
};
var scrollIndicatorLeft = {
  position: "fixed",
  display: "none",
  top: 0,
  left: 0,
  width: 40,
  height: "100%",
  pointerEvents: "none",
  background: `linear-gradient(to right, ${BACKGROUND}, ${BACKGROUND__TRANSPARENT})`
};
var scrollIndicatorRight = {
  position: "fixed",
  display: "none",
  top: 0,
  right: 0,
  width: 40,
  height: "100%",
  pointerEvents: "none",
  background: `linear-gradient(to left, ${BACKGROUND}, ${BACKGROUND__TRANSPARENT})`
};
var sideContainer = {
  width: 300,
  height: 38,
  display: "flex",
  flexDirection: "row",
  alignItems: "center"
};
var padding2 = {
  width: TIMELINE_PADDING
};
var PreviewToolbar = ({ readOnlyStudio, bufferStateDelayInMilliseconds }) => {
  const { playbackRate, setPlaybackRate } = useContext53(Internals46.Timeline.TimelineContext);
  const { mediaMuted } = useContext53(Internals46.MediaVolumeContext);
  const { setMediaMuted } = useContext53(Internals46.SetMediaVolumeContext);
  const isVideoComposition = useIsVideoComposition();
  const previewToolbarRef = useRef28(null);
  const leftScrollIndicatorRef = useRef28(null);
  const rightScrollIndicatorRef = useRef28(null);
  const isStill = useIsStill();
  const [loop, setLoop] = useState57(loadLoopOption());
  const isFullscreenSupported = checkFullscreenSupport();
  const isMobileLayout = useMobileLayout();
  useEffect54(() => {
    if (isMobileLayout && previewToolbarRef.current) {
      const updateScrollableIndicatorProps = (target) => {
        const boundingBox = target.getBoundingClientRect();
        const { scrollLeft, scrollWidth, clientWidth } = target;
        const scrollRight = scrollWidth - clientWidth - scrollLeft;
        if (!leftScrollIndicatorRef.current || !rightScrollIndicatorRef.current) {
          return;
        }
        if (scrollLeft !== 0) {
          Object.assign(leftScrollIndicatorRef.current.style, {
            display: "block",
            height: `${boundingBox.height}px`,
            top: `${boundingBox.top}px`,
            left: `${boundingBox.left}px`
          });
        } else {
          Object.assign(leftScrollIndicatorRef.current.style, {
            display: "none"
          });
        }
        if (scrollRight !== 0) {
          const itemWidth = rightScrollIndicatorRef.current?.clientWidth || 0;
          Object.assign(rightScrollIndicatorRef.current.style, {
            display: "block",
            height: `${boundingBox.height}px`,
            top: `${boundingBox.top}px`,
            left: `${boundingBox.left + boundingBox.width - itemWidth}px`
          });
        } else {
          Object.assign(rightScrollIndicatorRef.current.style, {
            display: "none"
          });
        }
      };
      const previewToolbar = previewToolbarRef.current;
      const scrollHandler = () => {
        updateScrollableIndicatorProps(previewToolbar);
      };
      previewToolbar.addEventListener("scroll", scrollHandler);
      scrollHandler();
      return () => {
        previewToolbar.removeEventListener("scroll", scrollHandler);
      };
    }
  });
  return /* @__PURE__ */ jsxs81("div", {
    ref: previewToolbarRef,
    style: isMobileLayout ? mobileContainer : container35,
    className: "css-reset",
    children: [
      /* @__PURE__ */ jsx176("div", {
        ref: leftScrollIndicatorRef,
        style: scrollIndicatorLeft
      }),
      isMobileLayout ? null : /* @__PURE__ */ jsxs81(Fragment23, {
        children: [
          /* @__PURE__ */ jsxs81("div", {
            style: sideContainer,
            children: [
              /* @__PURE__ */ jsx176("div", {
                style: padding2
              }),
              /* @__PURE__ */ jsx176(TimelineZoomControls, {})
            ]
          }),
          /* @__PURE__ */ jsx176(Flex, {}),
          /* @__PURE__ */ jsx176(SizeSelector, {}),
          isStill || isVideoComposition ? /* @__PURE__ */ jsx176(PlaybackRateSelector, {
            setPlaybackRate,
            playbackRate
          }) : null
        ]
      }),
      isVideoComposition ? /* @__PURE__ */ jsxs81(Fragment23, {
        children: [
          /* @__PURE__ */ jsx176(Spacing, {
            x: 2
          }),
          /* @__PURE__ */ jsx176(PlayPause, {
            bufferStateDelayInMilliseconds,
            loop,
            playbackRate
          }),
          /* @__PURE__ */ jsx176(Spacing, {
            x: 2
          }),
          /* @__PURE__ */ jsx176(LoopToggle, {
            loop,
            setLoop
          }),
          /* @__PURE__ */ jsx176(MuteToggle, {
            muted: mediaMuted,
            setMuted: setMediaMuted
          }),
          /* @__PURE__ */ jsx176(Spacing, {
            x: 2
          }),
          /* @__PURE__ */ jsx176(TimelineInOutPointToggle, {}),
          /* @__PURE__ */ jsx176(Spacing, {
            x: 2
          })
        ]
      }) : null,
      /* @__PURE__ */ jsx176(CheckboardToggle, {}),
      /* @__PURE__ */ jsx176(Spacing, {
        x: 1
      }),
      isFullscreenSupported && /* @__PURE__ */ jsx176(FullScreenToggle, {}),
      /* @__PURE__ */ jsx176(Flex, {}),
      isMobileLayout && /* @__PURE__ */ jsxs81(Fragment23, {
        children: [
          /* @__PURE__ */ jsx176(Flex, {}),
          /* @__PURE__ */ jsx176(SizeSelector, {}),
          isStill || isVideoComposition ? /* @__PURE__ */ jsx176(PlaybackRateSelector, {
            setPlaybackRate,
            playbackRate
          }) : null
        ]
      }),
      /* @__PURE__ */ jsxs81("div", {
        style: sideContainer,
        children: [
          /* @__PURE__ */ jsx176(Flex, {}),
          !isMobileLayout && /* @__PURE__ */ jsx176(FpsCounter, {
            playbackSpeed: playbackRate
          }),
          /* @__PURE__ */ jsx176(Spacing, {
            x: 2
          }),
          SHOW_BROWSER_RENDERING ? /* @__PURE__ */ jsx176(TriggerWebRender, {}) : null,
          readOnlyStudio ? null : /* @__PURE__ */ jsx176(RenderButton, {}),
          /* @__PURE__ */ jsx176(Spacing, {
            x: 1.5
          })
        ]
      }),
      /* @__PURE__ */ jsx176(PlaybackKeyboardShortcutsManager, {
        setPlaybackRate
      }),
      /* @__PURE__ */ jsx176(PlaybackRatePersistor, {}),
      /* @__PURE__ */ jsx176("div", {
        ref: rightScrollIndicatorRef,
        style: scrollIndicatorRight
      })
    ]
  });
};

// src/components/Splitter/SplitterContainer.tsx
import { useMemo as useMemo93, useRef as useRef29, useState as useState58 } from "react";

// src/state/timeline.ts
var localStorageKey4 = (id) => `remotion.editor.timelineFlex.${id}`;
var persistTimelineFlex = (value, id) => {
  localStorage.setItem(localStorageKey4(id), String(value));
};
var loadTimelineFlex = (id) => {
  const item2 = localStorage.getItem(localStorageKey4(id));
  return item2 ? parseFloat(item2) : null;
};
var useTimelineFlex = (id) => {
  return [
    loadTimelineFlex(id),
    (value) => persistTimelineFlex(value, id)
  ];
};

// src/components/Splitter/SplitterContext.tsx
import React115 from "react";
var SplitterContext = React115.createContext({
  flexValue: 1,
  ref: { current: null },
  setFlexValue: () => {
    return;
  },
  isDragging: { current: false },
  orientation: "horizontal",
  maxFlex: 1,
  minFlex: 1,
  defaultFlex: 1,
  id: "--",
  persistFlex: () => {
    return;
  }
});

// src/components/Splitter/SplitterContainer.tsx
import { jsx as jsx177 } from "react/jsx-runtime";
var containerRow = {
  display: "flex",
  flexDirection: "row",
  flex: 1,
  height: "100%",
  width: "100%"
};
var containerColumn = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  height: 0
};
var SplitterContainer = ({ orientation, children, defaultFlex, maxFlex, minFlex, id }) => {
  const [initialTimelineFlex, persistFlex] = useTimelineFlex(id);
  const [flexValue, setFlexValue] = useState58(initialTimelineFlex ?? defaultFlex);
  const ref = useRef29(null);
  const isDragging = useRef29(false);
  const value = useMemo93(() => {
    return {
      flexValue,
      ref,
      setFlexValue,
      isDragging,
      orientation,
      id,
      maxFlex,
      minFlex,
      defaultFlex,
      persistFlex
    };
  }, [
    defaultFlex,
    flexValue,
    id,
    maxFlex,
    minFlex,
    orientation,
    persistFlex,
    ref
  ]);
  return /* @__PURE__ */ jsx177(SplitterContext.Provider, {
    value,
    children: /* @__PURE__ */ jsx177("div", {
      ref,
      style: orientation === "horizontal" ? containerColumn : containerRow,
      children
    })
  });
};

// src/components/Splitter/SplitterElement.tsx
import { useContext as useContext54, useMemo as useMemo94 } from "react";
import { interpolateColors, random } from "remotion";
import { jsx as jsx178, jsxs as jsxs82, Fragment as Fragment24 } from "react/jsx-runtime";
var SplitterElement = ({ children, type, sticky }) => {
  const context = useContext54(SplitterContext);
  const style9 = useMemo94(() => {
    return {
      flex: (type === "flexer" ? context.flexValue : 1 - context.flexValue) * 1000,
      display: "flex",
      position: "relative",
      overflow: "hidden",
      flexDirection: "column"
    };
  }, [context.flexValue, type]);
  const stickStyle = useMemo94(() => {
    return {
      position: "absolute",
      left: (type === "flexer" ? 0 : context.flexValue) * 100 + "%",
      width: (type === "flexer" ? context.flexValue : 1 - context.flexValue) * 100 + "%",
      backgroundColor: interpolateColors(random(context.flexValue), [0, 1], ["red", "blue"])
    };
  }, [context.flexValue, type]);
  return /* @__PURE__ */ jsxs82(Fragment24, {
    children: [
      /* @__PURE__ */ jsx178("div", {
        style: style9,
        children
      }),
      /* @__PURE__ */ jsx178("div", {
        style: stickStyle,
        children: sticky ?? null
      })
    ]
  });
};

// src/components/Splitter/SplitterHandle.tsx
import { PlayerInternals as PlayerInternals15 } from "@remotion/player";
import { useContext as useContext55, useEffect as useEffect55, useRef as useRef30, useState as useState59 } from "react";
import { jsx as jsx179 } from "react/jsx-runtime";
var SPLITTER_HANDLE_SIZE = 3;
var containerRow2 = {
  height: SPLITTER_HANDLE_SIZE
};
var containerColumn2 = {
  width: SPLITTER_HANDLE_SIZE
};
var SplitterHandle = ({ allowToCollapse, onCollapse }) => {
  const context = useContext55(SplitterContext);
  if (!context) {
    throw new Error("Cannot find splitter context");
  }
  const [lastPointerUp, setLastPointerUp] = useState59(() => Date.now());
  const ref = useRef30(null);
  useEffect55(() => {
    if (context.isDragging.current) {
      return;
    }
    const { current } = ref;
    if (!current) {
      return;
    }
    const getNewValue = (e, clamp) => {
      if (!context.isDragging.current) {
        throw new Error("cannot get value if not dragging");
      }
      if (!context.ref.current) {
        throw new Error("domRect is not mounted");
      }
      const { width, height } = context.ref.current.getBoundingClientRect();
      const change = (() => {
        if (context.orientation === "vertical") {
          return (e.clientX - context.isDragging.current.x) / (width - SPLITTER_HANDLE_SIZE);
        }
        return (e.clientY - context.isDragging.current.y) / (height - SPLITTER_HANDLE_SIZE);
      })();
      const newFlex = context.flexValue + change;
      if (clamp) {
        return Math.min(context.maxFlex, Math.max(context.minFlex, newFlex));
      }
      return newFlex;
    };
    const onPointerDown = (e) => {
      if (e.button !== 0) {
        return;
      }
      context.isDragging.current = {
        x: e.clientX,
        y: e.clientY
      };
      ref.current?.classList.add("remotion-splitter-active");
      window.addEventListener("pointerup", (ev) => {
        if (!context.isDragging.current) {
          return;
        }
        context.persistFlex(getNewValue(ev, true));
        cleanup();
        setLastPointerUp(Date.now());
      }, { once: true });
      window.addEventListener("pointermove", onPointerMove);
    };
    const onPointerMove = (e) => {
      if (context.isDragging.current) {
        const val = getNewValue(e, true);
        context.setFlexValue(val);
        if (allowToCollapse === "left") {
          const unclamped = getNewValue(e, false);
          if (unclamped < context.minFlex / 2) {
            cleanup();
            onCollapse();
            setLastPointerUp(Date.now());
          }
        }
        if (allowToCollapse === "right") {
          const unclamped = 1 - getNewValue(e, false);
          if (unclamped < (1 - context.maxFlex) / 2) {
            cleanup();
            onCollapse();
            setLastPointerUp(Date.now());
          }
        }
      }
    };
    const cleanup = () => {
      context.isDragging.current = false;
      ref.current?.classList.remove("remotion-splitter-active");
      current.removeEventListener("pointerdown", onPointerDown);
      window.removeEventListener("pointermove", onPointerMove);
      PlayerInternals15.updateAllElementsSizes();
    };
    current.addEventListener("pointerdown", onPointerDown);
    return () => {
      if (!context.isDragging.current) {
        cleanup();
      }
    };
  }, [allowToCollapse, context, context.flexValue, lastPointerUp, onCollapse]);
  useEffect55(() => {
    const { current } = ref;
    if (!current) {
      return;
    }
    let isMouseDown = false;
    const onMouseDown = () => {
      isMouseDown = true;
    };
    const onMouseUp = () => {
      isMouseDown = false;
    };
    const onMouseEnter = (e) => {
      if (e.button !== 0) {
        return;
      }
      if (isMouseDown) {
        return;
      }
      current.classList.add("remotion-splitter-hover");
    };
    const onMouseLeave = (e) => {
      if (e.button !== 0) {
        return;
      }
      current.classList.remove("remotion-splitter-hover");
    };
    current.addEventListener("mouseenter", onMouseEnter);
    current.addEventListener("mouseleave", onMouseLeave);
    window.addEventListener("mousedown", onMouseDown);
    window.addEventListener("mouseup", onMouseUp);
    return () => {
      current.removeEventListener("mouseenter", onMouseEnter);
      current.removeEventListener("mouseleave", onMouseLeave);
      window.removeEventListener("mousedown", onMouseDown);
      window.removeEventListener("mouseup", onMouseUp);
    };
  }, []);
  return /* @__PURE__ */ jsx179("div", {
    ref,
    className: [
      "remotion-splitter",
      context.orientation === "horizontal" ? "remotion-splitter-horizontal" : "remotion-splitter-vertical"
    ].join(" "),
    style: context.orientation === "horizontal" ? containerRow2 : containerColumn2
  });
};

// src/components/TopPanel.tsx
import { jsx as jsx180, jsxs as jsxs83 } from "react/jsx-runtime";
var container36 = {
  height: "100%",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  flex: 1
};
var row4 = {
  display: "flex",
  flexDirection: "row",
  flex: 1,
  minHeight: 0
};
var useResponsiveSidebarStatus = () => {
  const { sidebarCollapsedStateLeft } = useContext56(SidebarContext);
  const responsiveLeftStatus = useBreakpoint(1200) ? "collapsed" : "expanded";
  const actualStateLeft = useMemo95(() => {
    if (sidebarCollapsedStateLeft === "collapsed") {
      return "collapsed";
    }
    if (sidebarCollapsedStateLeft === "expanded") {
      return "expanded";
    }
    return responsiveLeftStatus;
  }, [sidebarCollapsedStateLeft, responsiveLeftStatus]);
  return actualStateLeft;
};
var TopPanel = ({ readOnlyStudio, onMounted, drawRef: drawRef2, bufferStateDelayInMilliseconds }) => {
  const { setSidebarCollapsedState, sidebarCollapsedStateRight } = useContext56(SidebarContext);
  const rulersAreVisible = useIsRulerVisible();
  const actualStateLeft = useResponsiveSidebarStatus();
  const actualStateRight = useMemo95(() => {
    if (sidebarCollapsedStateRight === "collapsed") {
      return "collapsed";
    }
    return "expanded";
  }, [sidebarCollapsedStateRight]);
  useEffect56(() => {
    onMounted();
  }, [onMounted]);
  const canvasContainerStyle = useMemo95(() => ({
    flex: 1,
    display: "flex",
    paddingTop: rulersAreVisible ? RULER_WIDTH : 0,
    paddingLeft: rulersAreVisible ? RULER_WIDTH : 0
  }), [rulersAreVisible]);
  const onCollapseLeft = useCallback90(() => {
    setSidebarCollapsedState({ left: "collapsed", right: null });
  }, [setSidebarCollapsedState]);
  const onCollapseRight = useCallback90(() => {
    setSidebarCollapsedState({ left: null, right: "collapsed" });
  }, [setSidebarCollapsedState]);
  const isMobileLayout = useMobileLayout();
  return /* @__PURE__ */ jsxs83("div", {
    style: container36,
    children: [
      /* @__PURE__ */ jsx180("div", {
        style: row4,
        children: /* @__PURE__ */ jsxs83(SplitterContainer, {
          minFlex: 0.15,
          maxFlex: 0.4,
          defaultFlex: 0.2,
          id: "sidebar-to-preview",
          orientation: "vertical",
          children: [
            actualStateLeft === "expanded" ? isMobileLayout ? /* @__PURE__ */ jsx180(MobilePanel, {
              onClose: onCollapseLeft,
              children: /* @__PURE__ */ jsx180(ExplorerPanel, {
                readOnlyStudio
              })
            }) : /* @__PURE__ */ jsx180(SplitterElement, {
              sticky: null,
              type: "flexer",
              children: /* @__PURE__ */ jsx180(ExplorerPanel, {
                readOnlyStudio
              })
            }) : null,
            actualStateLeft === "expanded" ? /* @__PURE__ */ jsx180(SplitterHandle, {
              allowToCollapse: "left",
              onCollapse: onCollapseLeft
            }) : null,
            /* @__PURE__ */ jsx180(SplitterElement, {
              sticky: null,
              type: "anti-flexer",
              children: /* @__PURE__ */ jsxs83(SplitterContainer, {
                minFlex: 0.5,
                maxFlex: 0.8,
                defaultFlex: 0.7,
                id: "canvas-to-right-sidebar",
                orientation: "vertical",
                children: [
                  /* @__PURE__ */ jsx180(SplitterElement, {
                    sticky: null,
                    type: "flexer",
                    children: /* @__PURE__ */ jsx180("div", {
                      ref: drawRef2,
                      style: canvasContainerStyle,
                      children: /* @__PURE__ */ jsx180(CanvasIfSizeIsAvailable, {})
                    })
                  }),
                  actualStateRight === "expanded" ? /* @__PURE__ */ jsx180(SplitterHandle, {
                    allowToCollapse: "right",
                    onCollapse: onCollapseRight
                  }) : null,
                  actualStateRight === "expanded" ? isMobileLayout ? /* @__PURE__ */ jsx180(MobilePanel, {
                    onClose: onCollapseRight,
                    children: /* @__PURE__ */ jsx180(OptionsPanel, {
                      readOnlyStudio
                    })
                  }) : /* @__PURE__ */ jsx180(SplitterElement, {
                    sticky: null,
                    type: "anti-flexer",
                    children: /* @__PURE__ */ jsx180(OptionsPanel, {
                      readOnlyStudio
                    })
                  }) : null
                ]
              })
            })
          ]
        })
      }),
      /* @__PURE__ */ jsx180(PreviewToolbar, {
        bufferStateDelayInMilliseconds,
        readOnlyStudio
      }),
      /* @__PURE__ */ jsx180(CurrentCompositionKeybindings, {
        readOnlyStudio
      }),
      /* @__PURE__ */ jsx180(TitleUpdater, {})
    ]
  });
};

// src/components/SidebarCollapserControls.tsx
import { jsx as jsx181, jsxs as jsxs84, Fragment as Fragment25 } from "react/jsx-runtime";
var style9 = {
  width: 16,
  height: 16,
  minWidth: 16,
  border: "1px solid currentColor",
  borderRadius: 3,
  color: "currentColor",
  position: "relative"
};
var SidebarCollapserControls = () => {
  const { setSidebarCollapsedState, sidebarCollapsedStateRight } = useContext57(SidebarContext);
  const keybindings = useKeybinding();
  const leftSidebarStatus = useResponsiveSidebarStatus();
  const leftIcon = useCallback91((color) => {
    return {
      width: "35%",
      height: "100%",
      borderRight: "1px solid " + color,
      background: leftSidebarStatus === "expanded" ? color : "transparent"
    };
  }, [leftSidebarStatus]);
  const rightIcon = useCallback91((color) => {
    return {
      width: "35%",
      height: "100%",
      right: 0,
      position: "absolute",
      borderLeft: "1px solid " + color,
      background: sidebarCollapsedStateRight === "expanded" ? color : "transparent"
    };
  }, [sidebarCollapsedStateRight]);
  const toggleLeft = useCallback91(() => {
    setSidebarCollapsedState({
      left: (s) => {
        if (s === "responsive") {
          return leftSidebarStatus === "collapsed" ? "expanded" : "collapsed";
        }
        return s === "collapsed" ? "expanded" : "collapsed";
      },
      right: null
    });
  }, [leftSidebarStatus, setSidebarCollapsedState]);
  const toggleRight = useCallback91(() => {
    setSidebarCollapsedState({
      right: (s) => s === "collapsed" ? "expanded" : "collapsed",
      left: null
    });
  }, [setSidebarCollapsedState]);
  const toggleBoth = useCallback91(() => {
    if (sidebarCollapsedStateRight === leftSidebarStatus) {
      setSidebarCollapsedState({
        left: (s) => {
          if (s === "responsive") {
            return leftSidebarStatus === "collapsed" ? "expanded" : "collapsed";
          }
          return s === "collapsed" ? "expanded" : "collapsed";
        },
        right: (s) => s === "collapsed" ? "expanded" : "collapsed"
      });
    } else if (sidebarCollapsedStateRight === "expanded") {
      toggleRight();
    } else if (leftSidebarStatus === "expanded") {
      toggleLeft();
    }
  }, [
    leftSidebarStatus,
    setSidebarCollapsedState,
    sidebarCollapsedStateRight,
    toggleLeft,
    toggleRight
  ]);
  useEffect57(() => {
    const left3 = keybindings.registerKeybinding({
      event: "keydown",
      key: "b",
      commandCtrlKey: true,
      callback: toggleLeft,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const right2 = keybindings.registerKeybinding({
      event: "keydown",
      key: "j",
      commandCtrlKey: true,
      callback: toggleRight,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const zen = keybindings.registerKeybinding({
      event: "keydown",
      key: "g",
      commandCtrlKey: true,
      callback: toggleBoth,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      left3.unregister();
      right2.unregister();
      zen.unregister();
    };
  }, [keybindings, toggleBoth, toggleLeft, toggleRight]);
  const toggleLeftTooltip = areKeyboardShortcutsDisabled() ? "Toggle Left Sidebar" : `Toggle Left Sidebar (${cmdOrCtrlCharacter}+B)`;
  const toggleRightTooltip = areKeyboardShortcutsDisabled() ? "Toggle Right Sidebar" : `Toggle Right Sidebar (${cmdOrCtrlCharacter}+J)`;
  const colorStyle = useCallback91((color) => {
    return {
      ...style9,
      color
    };
  }, []);
  const toggleLeftAction = useCallback91((color) => {
    return /* @__PURE__ */ jsx181("div", {
      style: colorStyle(color),
      title: toggleLeftTooltip,
      children: /* @__PURE__ */ jsx181("div", {
        style: leftIcon(color)
      })
    });
  }, [colorStyle, leftIcon, toggleLeftTooltip]);
  const toggleRightAction = useCallback91((color) => {
    return /* @__PURE__ */ jsx181("div", {
      style: colorStyle(color),
      title: toggleRightTooltip,
      children: /* @__PURE__ */ jsx181("div", {
        style: rightIcon(color)
      })
    });
  }, [colorStyle, rightIcon, toggleRightTooltip]);
  return /* @__PURE__ */ jsxs84(Fragment25, {
    children: [
      /* @__PURE__ */ jsx181(InlineAction, {
        onClick: toggleLeft,
        renderAction: toggleLeftAction
      }),
      /* @__PURE__ */ jsx181(InlineAction, {
        onClick: toggleRight,
        renderAction: toggleRightAction
      })
    ]
  });
};

// src/components/UpdateCheck.tsx
import {
  useCallback as useCallback92,
  useContext as useContext58,
  useEffect as useEffect58,
  useMemo as useMemo96,
  useState as useState60
} from "react";
import { VERSION } from "remotion";
import { jsx as jsx182 } from "react/jsx-runtime";
var buttonStyle4 = {
  appearance: "none",
  color: BLUE,
  border: "none",
  fontWeight: "bold",
  backgroundColor: "transparent",
  cursor: "pointer",
  fontSize: 14,
  display: "inline-flex",
  justifyContent: "center"
};
var UpdateCheck = () => {
  const [info, setInfo] = useState60(null);
  const { setSelectedModal } = useContext58(ModalsContext);
  const { tabIndex } = useZIndex();
  const [knownBugs, setKnownBugs] = useState60(null);
  const hasKnownBugs = useMemo96(() => {
    return knownBugs && knownBugs.length > 0;
  }, [knownBugs]);
  const checkForUpdates = useCallback92(() => {
    const controller = new AbortController;
    updateAvailable(controller.signal).then((d) => {
      setInfo(d);
    }).catch((err) => {
      if (err.message.includes("aborted")) {
        return;
      }
      console.log("Could not check for updates", err);
    });
    return controller;
  }, []);
  const checkForBugs = useCallback92(() => {
    const controller = new AbortController;
    fetch(`https://bugs.remotion.dev/api/${VERSION}`, {
      signal: controller.signal
    }).then(async (res) => {
      const body = await res.json();
      setKnownBugs(body.bugs);
    }).catch((err) => {
      if (err.message.includes("aborted")) {
        return;
      }
      console.log("Could not check for bugs in this version", err);
    });
    return controller;
  }, []);
  useEffect58(() => {
    const abortUpdate = checkForUpdates();
    const abortBugs = checkForBugs();
    return () => {
      abortUpdate.abort();
      abortBugs.abort();
    };
  }, [checkForBugs, checkForUpdates]);
  const openModal = useCallback92(() => {
    setSelectedModal({
      type: "update",
      info,
      knownBugs
    });
  }, [info, knownBugs, setSelectedModal]);
  const dynButtonStyle = useMemo96(() => {
    return {
      ...buttonStyle4,
      color: hasKnownBugs ? WARNING_COLOR : LIGHT_TEXT
    };
  }, [hasKnownBugs]);
  if (!info) {
    return null;
  }
  if (!info.updateAvailable) {
    return null;
  }
  return /* @__PURE__ */ jsx182("button", {
    tabIndex,
    style: dynButtonStyle,
    onClick: openModal,
    type: "button",
    title: hasKnownBugs ? "Bugfixes available" : "Update available",
    children: hasKnownBugs ? "Bugfixes available" : /* @__PURE__ */ jsx182("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      style: {
        height: 16,
        width: 16
      },
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ jsx182("path", {
        fill: "currentcolor",
        d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM135.1 217.4c-4.5 4.2-7.1 10.1-7.1 16.3c0 12.3 10 22.3 22.3 22.3H208v96c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V256h57.7c12.3 0 22.3-10 22.3-22.3c0-6.2-2.6-12.1-7.1-16.3L269.8 117.5c-3.8-3.5-8.7-5.5-13.8-5.5s-10.1 2-13.8 5.5L135.1 217.4z"
      })
    })
  });
};

// src/components/MenuToolbar.tsx
import { jsx as jsx183, jsxs as jsxs85 } from "react/jsx-runtime";
var row5 = {
  alignItems: "center",
  flexDirection: "row",
  display: "flex",
  color: "white",
  borderBottom: "1px solid black",
  fontSize: 13,
  paddingLeft: 6,
  paddingRight: 10,
  backgroundColor: BACKGROUND
};
var flex2 = {
  flex: 1
};
var MenuToolbar = ({ readOnlyStudio }) => {
  const [selected, setSelected] = useState61(null);
  const mobileLayout = useMobileLayout();
  const fixedWidthRight = useMemo97(() => {
    return {
      ...mobileLayout ? { width: "fit-content" } : {
        width: "330px"
      },
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end"
    };
  }, [mobileLayout]);
  const fixedWidthLeft = useMemo97(() => {
    return {
      ...mobileLayout ? { minWidth: "0px" } : {
        minWidth: "330px"
      },
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start"
    };
  }, [mobileLayout]);
  const itemClicked = useCallback93((itemId) => {
    setSelected(itemId);
  }, [setSelected]);
  const itemHovered = useCallback93((itemId) => {
    if (selected) {
      setSelected(itemId);
    }
  }, [selected, setSelected]);
  const closeMenu = useCallback93(() => {
    setSelected(null);
  }, []);
  const structure = useMenuStructure(closeMenu, readOnlyStudio);
  const menus = useMemo97(() => {
    return structure.map((s) => s.id);
  }, [structure]);
  const onPreviousMenu = useCallback93(() => {
    setSelected((s) => {
      if (s === null) {
        return null;
      }
      return menus[(menus.indexOf(s) + 1) % menus.length];
    });
  }, [menus]);
  const onNextMenu = useCallback93(() => {
    setSelected((s) => {
      if (s === null) {
        return null;
      }
      if (menus.indexOf(s) === 0) {
        return menus[menus.length - 1];
      }
      return menus[(menus.indexOf(s) - 1) % menus.length];
    });
  }, [menus]);
  const onItemQuit = useCallback93(() => {
    setSelected(null);
  }, [setSelected]);
  return /* @__PURE__ */ jsxs85(Row, {
    align: "center",
    className: "css-reset",
    style: row5,
    children: [
      /* @__PURE__ */ jsxs85("div", {
        style: fixedWidthLeft,
        children: [
          structure.map((s) => {
            return /* @__PURE__ */ jsx183(MenuItem, {
              selected: selected === s.id,
              onItemSelected: itemClicked,
              onItemHovered: itemHovered,
              id: s.id,
              label: s.label,
              onItemQuit,
              menu: s,
              onPreviousMenu,
              onNextMenu,
              leaveLeftPadding: s.leaveLeftPadding
            }, s.id);
          }),
          readOnlyStudio ? null : /* @__PURE__ */ jsx183(UpdateCheck, {})
        ]
      }),
      /* @__PURE__ */ jsx183("div", {
        style: flex2
      }),
      /* @__PURE__ */ jsx183(MenuBuildIndicator, {}),
      /* @__PURE__ */ jsx183("div", {
        style: flex2
      }),
      /* @__PURE__ */ jsx183("div", {
        style: fixedWidthRight,
        children: /* @__PURE__ */ jsx183(SidebarCollapserControls, {})
      }),
      /* @__PURE__ */ jsx183(Spacing, {
        x: 1
      })
    ]
  });
};

// src/components/Timeline/Timeline.tsx
import { useContext as useContext67, useMemo as useMemo108 } from "react";
import { Internals as Internals55 } from "remotion";

// src/helpers/get-sequence-visible-range.ts
var getCascadedStart = (sequence, sequences) => {
  if (!sequence.parent) {
    return sequence.from;
  }
  const parent = sequences.find((s) => s.id === sequence.parent);
  if (!parent) {
    throw new TypeError("Parent not found for sequence " + sequence.id);
  }
  return getCascadedStart(parent, sequences) + sequence.from;
};
var getTimelineVisibleStart = (sequence, sequences) => {
  const cascadedStart = Math.max(0, getCascadedStart(sequence, sequences));
  if (!sequence.parent) {
    return cascadedStart;
  }
  const parent = sequences.find((s) => s.id === sequence.parent);
  if (!parent) {
    throw new TypeError("Parent not found for sequence " + sequence.id);
  }
  const timelineVisibleStart = getTimelineVisibleStart(parent, sequences);
  return Math.max(timelineVisibleStart, cascadedStart);
};
var getTimelineVisibleDuration = (sequence, sequences) => {
  const visibleDuration = sequence.duration + Math.min(sequence.from, 0);
  if (!sequence.parent) {
    return visibleDuration;
  }
  const parent = sequences.find((s) => s.id === sequence.parent);
  if (!parent) {
    throw new TypeError("Parent not found for sequence " + sequence.id);
  }
  return Math.min(visibleDuration, getTimelineVisibleDuration(parent, sequences));
};

// src/helpers/get-timeline-nestedness.ts
var getTimelineNestedLevel = (sequence, allSequences, depth) => {
  if (!sequence.parent) {
    return depth;
  }
  const parentSequence = allSequences.find((s) => s.id === sequence.parent);
  if (!parentSequence) {
    throw new Error("has parentId but no parent");
  }
  return getTimelineNestedLevel(parentSequence, allSequences, depth + 1);
};

// src/helpers/get-timeline-sequence-hash.ts
var getTimelineSequenceHash = (sequence, allSequences, hashesUsedInRoot, cache) => {
  if (cache[sequence.id]) {
    return cache[sequence.id];
  }
  const parent = allSequences.find((a) => a.id === sequence.parent);
  const baseHash = [
    parent ? getTimelineSequenceHash(parent, allSequences, hashesUsedInRoot, cache) : null,
    sequence.displayName,
    sequence.duration,
    sequence.from,
    sequence.type,
    sequence.type === "audio" ? sequence.src : null,
    sequence.type === "audio" ? sequence.volume : null,
    sequence.type === "video" ? sequence.src : null,
    sequence.type === "video" ? sequence.volume : null
  ].join("-");
  const actualHash = baseHash + hashesUsedInRoot[sequence.rootId].filter((h) => h === baseHash).length;
  hashesUsedInRoot[sequence.rootId].push(baseHash);
  cache[sequence.id] = actualHash;
  return actualHash;
};

// src/helpers/get-timeline-sequence-sort-key.ts
var getTimelineSequenceSequenceSortKey = (track, tracks, sameHashes = {}) => {
  const firstSequenceWithSameHash = tracks.find((t) => sameHashes[track.hash].includes(t.sequence.id));
  const id = String(firstSequenceWithSameHash.sequence.nonce).padStart(6, "0");
  if (!track.sequence.parent) {
    return id;
  }
  const parent = tracks.find((t) => t.sequence.id === track.sequence.parent);
  if (!parent) {
    return id;
  }
  const firstParentWithSameHash = tracks.find((a) => {
    return sameHashes[parent.hash].includes(a.sequence.id);
  });
  if (!firstParentWithSameHash) {
    throw new Error("could not find parent: " + track.sequence.parent);
  }
  return `${getTimelineSequenceSequenceSortKey(firstParentWithSameHash, tracks, sameHashes)}-${id}`;
};

// src/helpers/calculate-timeline.ts
var calculateTimeline = ({
  sequences,
  sequenceDuration
}) => {
  const tracks = [];
  if (sequences.length === 0) {
    return [
      {
        sequence: {
          displayName: "",
          duration: sequenceDuration,
          from: 0,
          id: "seq",
          parent: null,
          type: "sequence",
          rootId: "-",
          showInTimeline: true,
          nonce: 0,
          loopDisplay: undefined,
          stack: null,
          premountDisplay: null,
          postmountDisplay: null
        },
        depth: 0,
        hash: "-"
      }
    ];
  }
  const sameHashes = {};
  const hashesUsedInRoot = {};
  const cache = {};
  for (let i = 0;i < sequences.length; i++) {
    const sequence = sequences[i];
    if (!hashesUsedInRoot[sequence.rootId]) {
      hashesUsedInRoot[sequence.rootId] = [];
    }
    const actualHash = getTimelineSequenceHash(sequence, sequences, hashesUsedInRoot, cache);
    if (!sameHashes[actualHash]) {
      sameHashes[actualHash] = [];
    }
    sameHashes[actualHash].push(sequence.id);
    const cascadedStart = getCascadedStart(sequence, sequences);
    const visibleStart = getTimelineVisibleStart(sequence, sequences);
    const visibleDuration = getTimelineVisibleDuration(sequence, sequences);
    tracks.push({
      sequence: {
        ...sequence,
        from: visibleStart,
        duration: visibleDuration
      },
      depth: getTimelineNestedLevel(sequence, sequences, 0),
      hash: actualHash,
      cascadedStart,
      cascadedDuration: sequence.duration
    });
  }
  const uniqueTracks = [];
  for (const track of tracks) {
    if (!uniqueTracks.find((t) => t.hash === track.hash)) {
      const { cascadedDuration, cascadedStart, ...cleanTrack } = track;
      uniqueTracks.push(cleanTrack);
    }
  }
  return uniqueTracks.sort((a, b) => {
    const sortKeyA = getTimelineSequenceSequenceSortKey(a, tracks, sameHashes);
    const sortKeyB = getTimelineSequenceSequenceSortKey(b, tracks, sameHashes);
    return sortKeyA.localeCompare(sortKeyB);
  });
};

// src/components/Timeline/MaxTimelineTracks.tsx
import { DEFAULT_TIMELINE_TRACKS } from "@remotion/studio-shared";
import { jsxs as jsxs86 } from "react/jsx-runtime";
var MAX_TIMELINE_TRACKS = typeof process.env.MAX_TIMELINE_TRACKS === "undefined" || process.env.MAX_TIMELINE_TRACKS === null ? DEFAULT_TIMELINE_TRACKS : Number(process.env.MAX_TIMELINE_TRACKS);
var MAX_TIMELINE_TRACKS_NOTICE_HEIGHT = 24;
var container37 = {
  height: MAX_TIMELINE_TRACKS_NOTICE_HEIGHT,
  display: "flex",
  alignItems: "center",
  color: "rgba(255, 255, 255, 0.6)",
  fontFamily: "sans-serif",
  fontSize: 12,
  backgroundColor: "rgba(255, 255, 255, 0.1)",
  paddingLeft: TIMELINE_PADDING + 5
};
var MaxTimelineTracksReached = () => {
  return /* @__PURE__ */ jsxs86("div", {
    style: container37,
    children: [
      "Limited display to ",
      MAX_TIMELINE_TRACKS,
      " tracks to sustain performance.",
      "",
      "You can change this by setting Config.setMaxTimelineTracks() in your remotion.config.ts file."
    ]
  });
};

// src/components/Timeline/TimelineDragHandler.tsx
import { PlayerInternals as PlayerInternals16 } from "@remotion/player";
import {
  useCallback as useCallback94,
  useContext as useContext61,
  useEffect as useEffect59,
  useMemo as useMemo99,
  useRef as useRef31,
  useState as useState62
} from "react";
import { Internals as Internals48, useVideoConfig as useVideoConfig4 } from "remotion";

// src/components/Timeline/TimelineInOutPointer.tsx
import { createRef as createRef10, useContext as useContext59 } from "react";
import { Internals as Internals47 } from "remotion";
import { jsx as jsx184, jsxs as jsxs87, Fragment as Fragment26 } from "react/jsx-runtime";
var areaHighlight = {
  position: "absolute",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  height: "100%",
  bottom: 0,
  top: 0
};
var inMarkerAreaRef = createRef10();
var outMarkerAreaRef = createRef10();
var TimelineInOutPointer = () => {
  const { inFrame, outFrame } = useTimelineInOutFramePosition();
  const videoConfig = Internals47.useUnsafeVideoConfig();
  const timelineWidth = useContext59(TimelineWidthContext);
  if (!videoConfig || timelineWidth === null) {
    return null;
  }
  return /* @__PURE__ */ jsxs87(Fragment26, {
    children: [
      inFrame !== null && /* @__PURE__ */ jsx184("div", {
        ref: inMarkerAreaRef,
        style: {
          ...areaHighlight,
          left: 0,
          width: getXPositionOfItemInTimelineImperatively(inFrame, videoConfig.durationInFrames, timelineWidth)
        }
      }),
      outFrame !== null && /* @__PURE__ */ jsx184("div", {
        ref: outMarkerAreaRef,
        style: {
          ...areaHighlight,
          left: getXPositionOfItemInTimelineImperatively(outFrame, videoConfig.durationInFrames, timelineWidth),
          width: timelineWidth - getXPositionOfItemInTimelineImperatively(outFrame, videoConfig.durationInFrames, timelineWidth)
        }
      })
    ]
  });
};

// src/components/Timeline/TimelineInOutPointerHandle.tsx
import { createRef as createRef11, useContext as useContext60, useMemo as useMemo98 } from "react";
import { useVideoConfig as useVideoConfig3 } from "remotion";
import { jsx as jsx185 } from "react/jsx-runtime";
var line3 = {
  height: "100%",
  width: 1,
  position: "absolute",
  backgroundColor: "rgba(255, 255, 255, 0.1)",
  cursor: "ew-resize",
  paddingLeft: 1,
  paddingRight: 1
};
var inPointerHandle = createRef11();
var outPointerHandle = createRef11();
var InnerTimelineInOutPointerHandle = ({ atFrame, dragging, timelineWidth, type }) => {
  const videoConfig = useVideoConfig3();
  const style10 = useMemo98(() => {
    return {
      ...line3,
      backgroundColor: dragging ? LIGHT_TRANSPARENT : "rgba(255, 255, 255, 0.1)",
      transform: `translateX(${getXPositionOfItemInTimelineImperatively(atFrame, videoConfig.durationInFrames, timelineWidth)}px)`
    };
  }, [atFrame, dragging, timelineWidth, videoConfig.durationInFrames]);
  return /* @__PURE__ */ jsx185("div", {
    ref: type === "in" ? inPointerHandle : outPointerHandle,
    style: style10
  });
};
var TimelineInOutPointerHandle = ({
  dragging,
  type,
  atFrame
}) => {
  const timelineWidth = useContext60(TimelineWidthContext);
  if (timelineWidth === null) {
    return null;
  }
  return /* @__PURE__ */ jsx185(InnerTimelineInOutPointerHandle, {
    atFrame,
    dragging,
    timelineWidth,
    type
  });
};

// src/components/Timeline/TimelineDragHandler.tsx
import { jsx as jsx186, jsxs as jsxs88 } from "react/jsx-runtime";
var inner = {
  overflowY: "auto",
  overflowX: "hidden"
};
var container38 = {
  userSelect: "none",
  WebkitUserSelect: "none",
  position: "absolute",
  height: "100%",
  top: 0
};
var style10 = {
  width: "100%",
  height: "100%",
  userSelect: "none",
  WebkitUserSelect: "none"
};
var getClientXWithScroll = (x) => {
  return x + scrollableRef.current?.scrollLeft;
};
var TimelineDragHandler = () => {
  const video = Internals48.useUnsafeVideoConfig();
  const { zoom: zoomMap } = useContext61(TimelineZoomCtx);
  const { canvasContent } = useContext61(Internals48.CompositionManager);
  const containerStyle2 = useMemo99(() => {
    if (!canvasContent || canvasContent.type !== "composition") {
      return {};
    }
    const zoom = zoomMap[canvasContent.compositionId] ?? TIMELINE_MIN_ZOOM;
    return {
      ...container38,
      width: 100 * zoom + "%"
    };
  }, [canvasContent, zoomMap]);
  if (!canvasContent || canvasContent.type !== "composition") {
    return null;
  }
  return /* @__PURE__ */ jsx186("div", {
    ref: sliderAreaRef,
    style: containerStyle2,
    children: video ? /* @__PURE__ */ jsx186(Inner2, {}) : null
  });
};
var Inner2 = () => {
  const videoConfig = useVideoConfig4();
  const size4 = PlayerInternals16.useElementSize(scrollableRef, {
    triggerOnWindowResize: true,
    shouldApplyCssTransforms: true
  });
  const { isHighestContext } = useZIndex();
  const setFrame = Internals48.useTimelineSetFrame();
  const [inOutDragging, setInOutDragging] = useState62({
    dragging: false
  });
  const timelineWidth = useContext61(TimelineWidthContext);
  const get = useCallback94((frame2) => {
    if (timelineWidth === null) {
      throw new Error("timeline width is not yet determined");
    }
    return getXPositionOfItemInTimelineImperatively(frame2, videoConfig.durationInFrames, timelineWidth);
  }, [timelineWidth, videoConfig.durationInFrames]);
  const width = scrollableRef.current?.scrollWidth ?? 0;
  const left3 = size4?.left ?? 0;
  const { inFrame, outFrame } = useTimelineInOutFramePosition();
  const { setInAndOutFrames } = useTimelineSetInOutFramePosition();
  const [dragging, setDragging] = useState62({
    dragging: false
  });
  const { playing, play, pause, seek } = PlayerInternals16.usePlayer();
  const scroller = useRef31(null);
  const stopInterval = () => {
    if (scroller.current) {
      clearInterval(scroller.current);
      scroller.current = null;
    }
  };
  const onPointerDown = useCallback94((e) => {
    if (e.button !== 0) {
      return;
    }
    if (!isHighestContext) {
      return;
    }
    stopInterval();
    if (!videoConfig) {
      return;
    }
    if (e.target === inPointerHandle.current) {
      if (inFrame === null) {
        throw new Error("expected outframe");
      }
      const inMarker = get(inFrame);
      const outMarker = outFrame === null ? Infinity : get(outFrame - 1);
      setInOutDragging({
        dragging: "in",
        initialOffset: getClientXWithScroll(e.clientX),
        boundaries: [-Infinity, outMarker - inMarker]
      });
      return;
    }
    if (e.target === outPointerHandle.current) {
      if (outFrame === null) {
        throw new Error("expected outframe");
      }
      const outMarker = get(outFrame);
      const inMarker = inFrame === null ? -Infinity : get(inFrame + 1);
      setInOutDragging({
        dragging: "out",
        initialOffset: getClientXWithScroll(e.clientX),
        boundaries: [inMarker - outMarker, Infinity]
      });
      return;
    }
    if (e.button !== 0) {
      return;
    }
    const frame2 = getFrameFromX({
      clientX: getClientXWithScroll(e.clientX) - left3,
      durationInFrames: videoConfig.durationInFrames,
      width,
      extrapolate: "clamp"
    });
    seek(frame2);
    setDragging({
      dragging: true,
      wasPlaying: playing
    });
    pause();
  }, [
    isHighestContext,
    videoConfig,
    left3,
    width,
    seek,
    playing,
    pause,
    inFrame,
    get,
    outFrame
  ]);
  const onPointerMoveScrubbing = useCallback94((e) => {
    if (!videoConfig) {
      return;
    }
    if (!dragging.dragging) {
      return;
    }
    const isRightOfArea = e.clientX >= scrollableRef.current?.clientWidth + left3 - TIMELINE_PADDING;
    const isLeftOfArea = e.clientX <= left3;
    const frame2 = getFrameFromX({
      clientX: getClientXWithScroll(e.clientX) - left3,
      durationInFrames: videoConfig.durationInFrames,
      width,
      extrapolate: "clamp"
    });
    if (isLeftOfArea && canScrollTimelineIntoDirection().canScrollLeft) {
      if (scroller.current) {
        return;
      }
      const scrollEvery = () => {
        if (!canScrollTimelineIntoDirection().canScrollLeft) {
          stopInterval();
          return;
        }
        const nextFrame = getFrameWhileScrollingLeft({
          durationInFrames: videoConfig.durationInFrames,
          width
        });
        const scrollPos = getScrollPositionForCursorOnLeftEdge({
          nextFrame,
          durationInFrames: videoConfig.durationInFrames
        });
        redrawTimelineSliderFast.current?.draw(nextFrame);
        seek(nextFrame);
        scrollToTimelineXOffset(scrollPos);
      };
      scrollEvery();
      scroller.current = setInterval(() => {
        scrollEvery();
      }, 100);
    } else if (isRightOfArea && canScrollTimelineIntoDirection().canScrollRight) {
      if (scroller.current) {
        return;
      }
      const scrollEvery = () => {
        if (!canScrollTimelineIntoDirection().canScrollRight) {
          stopInterval();
          return;
        }
        const nextFrame = getFrameWhileScrollingRight({
          durationInFrames: videoConfig.durationInFrames,
          width
        });
        const scrollPos = getScrollPositionForCursorOnRightEdge({
          nextFrame,
          durationInFrames: videoConfig.durationInFrames
        });
        redrawTimelineSliderFast.current?.draw(nextFrame);
        seek(nextFrame);
        scrollToTimelineXOffset(scrollPos);
      };
      scrollEvery();
      scroller.current = setInterval(() => {
        scrollEvery();
      }, 100);
    } else {
      stopInterval();
      seek(frame2);
    }
  }, [videoConfig, dragging.dragging, left3, width, seek]);
  const onPointerMoveInOut = useCallback94((e) => {
    if (!videoConfig) {
      return;
    }
    if (!inOutDragging.dragging) {
      return;
    }
    const offset = Math.max(inOutDragging.boundaries[0], Math.min(inOutDragging.boundaries[1], getClientXWithScroll(e.clientX) - inOutDragging.initialOffset));
    if (inOutDragging.dragging === "in") {
      if (!inPointerHandle.current) {
        throw new Error("in pointer handle");
      }
      if (!inMarkerAreaRef.current) {
        throw new Error("expected inMarkerAreaRef");
      }
      if (!inFrame) {
        throw new Error("expected inframes");
      }
      inPointerHandle.current.style.transform = `translateX(${get(inFrame) + offset}px)`;
      inMarkerAreaRef.current.style.width = String(get(inFrame) + offset) + "px";
    }
    if (inOutDragging.dragging === "out") {
      if (!outPointerHandle.current) {
        throw new Error("in pointer handle");
      }
      if (!outMarkerAreaRef.current) {
        throw new Error("in outMarkerAreaRef");
      }
      if (!outFrame) {
        throw new Error("expected outframes");
      }
      outPointerHandle.current.style.transform = `translateX(${get(outFrame) + offset}px)`;
      outMarkerAreaRef.current.style.left = String(get(outFrame) + offset) + "px";
      outMarkerAreaRef.current.style.width = String(width - get(outFrame) - offset) + "px";
    }
  }, [get, inFrame, inOutDragging, outFrame, videoConfig, width]);
  const onPointerUpScrubbing = useCallback94((e) => {
    stopInterval();
    if (!videoConfig) {
      return;
    }
    if (!dragging.dragging) {
      return;
    }
    setDragging({
      dragging: false
    });
    const frame2 = getFrameFromX({
      clientX: getClientXWithScroll(e.clientX) - left3,
      durationInFrames: videoConfig.durationInFrames,
      width,
      extrapolate: "clamp"
    });
    setFrame((c) => {
      const newObj = { ...c, [videoConfig.id]: frame2 };
      Internals48.persistCurrentFrame(newObj);
      return newObj;
    });
    if (dragging.wasPlaying) {
      play();
    }
  }, [dragging, left3, play, videoConfig, setFrame, width]);
  const onPointerUpInOut = useCallback94((e) => {
    if (!videoConfig) {
      return;
    }
    if (!inOutDragging.dragging) {
      return;
    }
    setInOutDragging({
      dragging: false
    });
    const frame2 = getFrameFromX({
      clientX: getClientXWithScroll(e.clientX) - left3,
      durationInFrames: videoConfig.durationInFrames,
      width,
      extrapolate: "extend"
    });
    if (inOutDragging.dragging === "in") {
      if (frame2 < 1) {
        return setInAndOutFrames((prev) => ({
          ...prev,
          [videoConfig.id]: {
            ...prev[videoConfig.id] ?? defaultInOutValue,
            inFrame: null
          }
        }));
      }
      const maxFrame = outFrame === null ? Infinity : outFrame - 1;
      setInAndOutFrames((prev) => ({
        ...prev,
        [videoConfig.id]: {
          ...prev[videoConfig.id] ?? defaultInOutValue,
          inFrame: Math.min(maxFrame, frame2)
        }
      }));
    } else {
      if (frame2 > videoConfig.durationInFrames - 2) {
        return setInAndOutFrames((prev) => ({
          ...prev,
          [videoConfig.id]: {
            ...prev[videoConfig.id] ?? defaultInOutValue,
            outFrame: null
          }
        }));
      }
      const minFrame = inFrame === null ? -Infinity : inFrame + 1;
      setInAndOutFrames((prev) => ({
        ...prev,
        [videoConfig.id]: {
          ...prev[videoConfig.id] ?? defaultInOutValue,
          outFrame: Math.max(minFrame, frame2)
        }
      }));
    }
  }, [
    inFrame,
    inOutDragging.dragging,
    left3,
    outFrame,
    setInAndOutFrames,
    videoConfig,
    width
  ]);
  useEffect59(() => {
    if (!dragging.dragging) {
      return;
    }
    window.addEventListener("pointermove", onPointerMoveScrubbing);
    window.addEventListener("pointerup", onPointerUpScrubbing);
    return () => {
      window.removeEventListener("pointermove", onPointerMoveScrubbing);
      window.removeEventListener("pointerup", onPointerUpScrubbing);
    };
  }, [dragging.dragging, onPointerMoveScrubbing, onPointerUpScrubbing]);
  useEffect59(() => {
    if (inOutDragging.dragging === false) {
      return;
    }
    window.addEventListener("pointermove", onPointerMoveInOut);
    window.addEventListener("pointerup", onPointerUpInOut);
    return () => {
      window.removeEventListener("pointermove", onPointerMoveInOut);
      window.removeEventListener("pointerup", onPointerUpInOut);
    };
  }, [inOutDragging.dragging, onPointerMoveInOut, onPointerUpInOut]);
  const inContextMenu = useMemo99(() => {
    return [
      {
        id: "hide-in",
        keyHint: null,
        label: "Clear In marker",
        leftItem: null,
        onClick: (_, e) => {
          e?.stopPropagation();
          e?.preventDefault();
          setInAndOutFrames((prev) => ({
            ...prev,
            [videoConfig.id]: {
              ...prev[videoConfig.id] ?? defaultInOutValue,
              inFrame: null
            }
          }));
        },
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item",
        value: "hide-in"
      }
    ];
  }, [setInAndOutFrames, videoConfig.id]);
  const outContextMenu = useMemo99(() => {
    return [
      {
        id: "hide-out",
        keyHint: null,
        label: "Clear Out marker",
        leftItem: null,
        onClick: (_, e) => {
          e?.stopPropagation();
          e?.preventDefault();
          setInAndOutFrames((prev) => ({
            ...prev,
            [videoConfig.id]: {
              ...prev[videoConfig.id] ?? defaultInOutValue,
              outFrame: null
            }
          }));
        },
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item",
        value: "hide-out"
      }
    ];
  }, [setInAndOutFrames, videoConfig.id]);
  return /* @__PURE__ */ jsxs88("div", {
    style: style10,
    onPointerDown,
    children: [
      /* @__PURE__ */ jsx186("div", {
        style: inner,
        className: VERTICAL_SCROLLBAR_CLASSNAME
      }),
      inFrame !== null && /* @__PURE__ */ jsx186(ContextMenu, {
        values: inContextMenu,
        children: /* @__PURE__ */ jsx186(TimelineInOutPointerHandle, {
          type: "in",
          atFrame: inFrame,
          dragging: inOutDragging.dragging === "in"
        })
      }),
      outFrame !== null && /* @__PURE__ */ jsx186(ContextMenu, {
        values: outContextMenu,
        children: /* @__PURE__ */ jsx186(TimelineInOutPointerHandle, {
          type: "out",
          dragging: inOutDragging.dragging === "out",
          atFrame: outFrame
        })
      })
    ]
  });
};

// src/components/Timeline/TimelineList.tsx
import { PlayerInternals as PlayerInternals18 } from "@remotion/player";
import { useRef as useRef34 } from "react";

// src/components/Timeline/TimelineListItem.tsx
import { useCallback as useCallback97, useContext as useContext63, useMemo as useMemo101 } from "react";
import { Internals as Internals49 } from "remotion";

// src/components/Timeline/TimelineLayerEye.tsx
import { useCallback as useCallback95 } from "react";
import { jsx as jsx187 } from "react/jsx-runtime";
var eyeIcon = {
  width: 12,
  color: "currentColor",
  pointerEvents: "none"
};
var speakerIcon = {
  ...eyeIcon,
  height: 10,
  marginLeft: -1
};
var container39 = {
  height: 16,
  width: 16,
  borderRadius: 2,
  backgroundColor: "rgba(0, 0, 0, 0.4)",
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  marginRight: 6,
  flexShrink: 0
};
var layerPointedDown = null;
var TimelineLayerEye = ({ onInvoked, hidden, type }) => {
  const renderAction = useCallback95((color) => {
    if (hidden) {
      return null;
    }
    if (type === "speaker") {
      return /* @__PURE__ */ jsx187("svg", {
        viewBox: "0 0 10 14",
        fill: "none",
        style: speakerIcon,
        children: /* @__PURE__ */ jsx187("path", {
          d: "M9.40938 0.0869018C9.76875 0.249402 10 0.605652 10 0.999402V12.9994C10 13.3932 9.76875 13.7494 9.40938 13.9119C9.05 14.0744 8.62813 14.0088 8.33438 13.7463L4.11875 9.9994H2C0.896875 9.9994 0 9.10253 0 7.9994V5.9994C0 4.89628 0.896875 3.9994 2 3.9994H4.11875L8.33438 0.252527C8.62813 -0.0099732 9.05 -0.0724732 9.40938 0.0869018Z",
          fill: color
        })
      });
    }
    return /* @__PURE__ */ jsx187("svg", {
      style: eyeIcon,
      viewBox: "0 0 24 16",
      fill: "none",
      children: /* @__PURE__ */ jsx187("path", {
        d: "M24 7.551C24 7.551 19.748 16 12.015 16C4.835 16 0 7.551 0 7.551C0 7.551 4.446 0 12.015 0C19.709 0 24 7.551 24 7.551ZM17 8C17 5.243 14.757 3 12 3C9.243 3 7 5.243 7 8C7 10.757 9.243 13 12 13C14.757 13 17 10.757 17 8Z",
        fill: color
      })
    });
  }, [hidden, type]);
  const onPointerDown = useCallback95((e) => {
    if (e.button !== 0) {
      return;
    }
    layerPointedDown = hidden ? "enable" : "disable";
    onInvoked(layerPointedDown);
    window.addEventListener("pointerup", () => {
      layerPointedDown = null;
    }, { once: true });
  }, [hidden, onInvoked]);
  const onPointerEnter = useCallback95(() => {
    if (layerPointedDown) {
      onInvoked(layerPointedDown);
    }
  }, [onInvoked]);
  return /* @__PURE__ */ jsx187("div", {
    style: container39,
    onPointerEnter,
    onPointerDown,
    children: renderAction(LIGHT_COLOR)
  });
};

// src/components/Timeline/TimelineStack/index.tsx
import { SOURCE_MAP_ENDPOINT } from "@remotion/studio-shared";
import {
  useCallback as useCallback96,
  useContext as useContext62,
  useEffect as useEffect60,
  useMemo as useMemo100,
  useState as useState63
} from "react";
import { SourceMapConsumer as SourceMapConsumer3 } from "source-map";
import { jsx as jsx188, jsxs as jsxs89, Fragment as Fragment27 } from "react/jsx-runtime";
var publicPath = window.remotion_publicPath === "/" ? "" : window.remotion_publicPath;
var withoutSlashInTheEnd = publicPath.endsWith("/") ? publicPath.slice(0, -1) : publicPath;
SourceMapConsumer3.initialize({
  "lib/mappings.wasm": withoutSlashInTheEnd + SOURCE_MAP_ENDPOINT
});
var TimelineStack = ({ isCompact, sequence }) => {
  const [originalLocation, setOriginalLocation] = useState63(null);
  const [stackHovered, setStackHovered] = useState63(false);
  const [titleHovered, setTitleHovered] = useState63(false);
  const [opening, setOpening] = useState63(false);
  const selectAsset = useSelectAsset();
  const connectionStatus = useContext62(StudioServerConnectionCtx).previewServerState.type;
  const assetPath = useMemo100(() => {
    if (sequence.type !== "video" && sequence.type !== "audio") {
      return null;
    }
    const isStatic = sequence.src.startsWith(window.remotion_staticBase);
    if (!isStatic) {
      return null;
    }
    const relativePath = sequence.src.replace(window.remotion_staticBase + "/", "");
    return relativePath;
  }, [sequence]);
  const navigateToAsset = useCallback96((asset) => {
    selectAsset(asset);
    pushUrl(`/assets/${asset}`);
  }, [selectAsset]);
  const openEditor = useCallback96(async (location2) => {
    if (!window.remotion_editorName) {
      return;
    }
    setOpening(true);
    try {
      await openOriginalPositionInEditor(location2);
    } catch (err) {
      showNotification(err.message, 2000);
    } finally {
      setOpening(false);
    }
  }, []);
  const canOpenInEditor = window.remotion_editorName && connectionStatus === "connected" && originalLocation;
  const canOpenInGitHub = window.remotion_gitSource && originalLocation;
  const titleHoverable = isCompact && (canOpenInEditor || canOpenInGitHub) || assetPath;
  const stackHoverable = !isCompact && (canOpenInEditor || canOpenInGitHub);
  const onClickTitle = useCallback96(() => {
    if (!titleHoverable) {
      return null;
    }
    if (assetPath) {
      navigateToAsset(assetPath);
      return;
    }
    if (!originalLocation) {
      return;
    }
    if (canOpenInEditor) {
      openEditor(originalLocation);
      return;
    }
    if (canOpenInGitHub) {
      window.open(getGitRefUrl(window.remotion_gitSource, originalLocation), "_blank");
    }
  }, [
    assetPath,
    canOpenInEditor,
    canOpenInGitHub,
    navigateToAsset,
    openEditor,
    originalLocation,
    titleHoverable
  ]);
  const onClickStack = useCallback96(() => {
    if (!originalLocation) {
      return;
    }
    if (canOpenInEditor) {
      openEditor(originalLocation);
      return;
    }
    if (canOpenInGitHub) {
      window.open(getGitRefUrl(window.remotion_gitSource, originalLocation), "_blank");
    }
  }, [canOpenInEditor, canOpenInGitHub, openEditor, originalLocation]);
  useEffect60(() => {
    if (!sequence.stack) {
      return;
    }
    getOriginalLocationFromStack(sequence.stack, "sequence").then((frame2) => {
      setOriginalLocation(frame2);
    }).catch((err) => {
      console.error("Could not get original location of Sequence", err);
    });
  }, [sequence.stack]);
  const onStackPointerEnter = useCallback96(() => {
    setStackHovered(true);
  }, []);
  const onStackPointerLeave = useCallback96(() => {
    setStackHovered(false);
  }, []);
  const onTitlePointerEnter = useCallback96(() => {
    setTitleHovered(true);
  }, []);
  const onTitlePointerLeave = useCallback96(() => {
    setTitleHovered(false);
  }, []);
  const style11 = useMemo100(() => {
    return {
      fontSize: 12,
      color: opening ? VERY_LIGHT_TEXT : stackHovered && stackHoverable ? LIGHT_TEXT : VERY_LIGHT_TEXT,
      marginLeft: 10,
      cursor: stackHoverable ? "pointer" : undefined,
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden",
      flexShrink: 1e5
    };
  }, [opening, stackHovered, stackHoverable]);
  const titleStyle2 = useMemo100(() => {
    const hoverEffect = titleHovered && titleHoverable;
    return {
      fontSize: 12,
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden",
      lineHeight: 1,
      color: opening && isCompact ? VERY_LIGHT_TEXT : LIGHT_COLOR,
      userSelect: "none",
      WebkitUserSelect: "none",
      borderBottom: hoverEffect ? "1px solid #fff" : "none",
      cursor: hoverEffect ? "pointer" : undefined
    };
  }, [titleHoverable, isCompact, opening, titleHovered]);
  const text = sequence.displayName.length > 1000 ? sequence.displayName.slice(0, 1000) + "..." : sequence.displayName;
  return /* @__PURE__ */ jsxs89(Fragment27, {
    children: [
      /* @__PURE__ */ jsx188("div", {
        onPointerEnter: onTitlePointerEnter,
        onPointerLeave: onTitlePointerLeave,
        title: originalLocation ? getOriginalSourceAttribution(originalLocation) : text || "<Sequence>",
        style: titleStyle2,
        onClick: onClickTitle,
        children: text || "<Sequence>"
      }),
      isCompact || !originalLocation ? null : /* @__PURE__ */ jsx188("div", {
        onPointerEnter: onStackPointerEnter,
        onPointerLeave: onStackPointerLeave,
        onClick: onClickStack,
        style: style11,
        children: getOriginalSourceAttribution(originalLocation)
      }),
      opening ? /* @__PURE__ */ jsxs89(Fragment27, {
        children: [
          /* @__PURE__ */ jsx188(Spacing, {
            x: 0.5
          }),
          /* @__PURE__ */ jsx188(Spinner, {
            duration: 0.5,
            size: 12
          })
        ]
      }) : null
    ]
  });
};

// src/components/Timeline/TimelineListItem.tsx
import { jsx as jsx189, jsxs as jsxs90 } from "react/jsx-runtime";
var SPACING = 5;
var space = {
  width: SPACING,
  flexShrink: 0
};
var TimelineListItem = ({ nestedDepth, sequence, isCompact }) => {
  const { hidden, setHidden } = useContext63(Internals49.SequenceVisibilityToggleContext);
  const padder = useMemo101(() => {
    return {
      width: Number(SPACING * 1.5) * nestedDepth,
      flexShrink: 0
    };
  }, [nestedDepth]);
  const isItemHidden = useMemo101(() => {
    return hidden[sequence.id] ?? false;
  }, [hidden, sequence.id]);
  const onToggleVisibility = useCallback97((type) => {
    setHidden((prev) => {
      return {
        ...prev,
        [sequence.id]: type !== "enable"
      };
    });
  }, [sequence.id, setHidden]);
  const outer2 = useMemo101(() => {
    return {
      height: getTimelineLayerHeight(sequence.type === "video" ? "video" : "other") + TIMELINE_ITEM_BORDER_BOTTOM,
      color: "white",
      fontFamily: "Arial, Helvetica, sans-serif",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      wordBreak: "break-all",
      textAlign: "left",
      paddingLeft: SPACING,
      borderBottom: `1px solid ${TIMELINE_TRACK_SEPARATOR}`
    };
  }, [sequence.type]);
  return /* @__PURE__ */ jsxs90("div", {
    style: outer2,
    children: [
      /* @__PURE__ */ jsx189(TimelineLayerEye, {
        type: sequence.type === "audio" ? "speaker" : "eye",
        hidden: isItemHidden,
        onInvoked: onToggleVisibility
      }),
      /* @__PURE__ */ jsx189("div", {
        style: padder
      }),
      sequence.parent && nestedDepth > 0 ? /* @__PURE__ */ jsx189("div", {
        style: space
      }) : null,
      /* @__PURE__ */ jsx189(TimelineStack, {
        sequence,
        isCompact
      })
    ]
  });
};

// src/components/Timeline/TimelineTimeIndicators.tsx
import { useContext as useContext64, useEffect as useEffect62, useMemo as useMemo102, useRef as useRef33 } from "react";
import { Internals as Internals51 } from "remotion";

// src/components/TimeValue.tsx
import { PlayerInternals as PlayerInternals17 } from "@remotion/player";
import {
  useCallback as useCallback98,
  useEffect as useEffect61,
  useImperativeHandle as useImperativeHandle13,
  useRef as useRef32
} from "react";
import { Internals as Internals50, useCurrentFrame } from "remotion";
import { jsx as jsx190, jsxs as jsxs91 } from "react/jsx-runtime";
var text = {
  color: "white",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  fontVariantNumeric: "tabular-nums",
  lineHeight: 1,
  width: "100%",
  userSelect: "none",
  WebkitUserSelect: "none"
};
var time = {
  display: "inline-block",
  fontSize: 16,
  lineHeight: 1,
  fontFamily: "monospace"
};
var frameStyle = {
  color: LIGHT_TEXT,
  fontWeight: 500,
  lineHeight: 1,
  fontSize: 16,
  fontFamily: "monospace",
  paddingRight: 10
};
var TimeValue = () => {
  const frame2 = useCurrentFrame();
  const config = Internals50.useUnsafeVideoConfig();
  const isStill = useIsStill();
  const { seek, play, pause, toggle } = PlayerInternals17.usePlayer();
  const keybindings = useKeybinding();
  const ref = useRef32(null);
  const onTextChange = useCallback98((newVal) => {
    seek(parseInt(newVal, 10));
  }, [seek]);
  const onValueChange = useCallback98((val) => {
    seek(val);
  }, [seek]);
  useImperativeHandle13(Internals50.timeValueRef, () => ({
    goToFrame: () => {
      ref.current?.click();
    },
    seek,
    play,
    pause,
    toggle
  }), [seek, play, pause, toggle]);
  useEffect61(() => {
    const gKey = keybindings.registerKeybinding({
      event: "keypress",
      key: "g",
      callback: () => {
        ref.current?.click();
      },
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      gKey.unregister();
    };
  }, [keybindings]);
  if (!config) {
    return null;
  }
  if (isStill) {
    return null;
  }
  return /* @__PURE__ */ jsxs91("div", {
    style: text,
    children: [
      /* @__PURE__ */ jsx190("div", {
        style: time,
        children: renderFrame(frame2, config.fps)
      }),
      /* @__PURE__ */ jsx190(Spacing, {
        x: 2
      }),
      /* @__PURE__ */ jsx190(Flex, {}),
      /* @__PURE__ */ jsx190(InputDragger, {
        ref,
        value: frame2,
        onTextChange,
        onValueChange,
        rightAlign: true,
        status: "ok",
        style: frameStyle
      })
    ]
  });
};

// src/components/Timeline/TimelineTimeIndicators.tsx
import { jsx as jsx191 } from "react/jsx-runtime";
var TIMELINE_TIME_INDICATOR_HEIGHT = 39;
var container40 = {
  height: TIMELINE_TIME_INDICATOR_HEIGHT - 4,
  boxShadow: `0 0 4px ${TIMELINE_BACKGROUND}`,
  position: "absolute",
  backgroundColor: TIMELINE_BACKGROUND,
  top: 0
};
var tick = {
  width: 1,
  backgroundColor: "rgba(255, 255, 255, 0.15)",
  height: 20,
  position: "absolute"
};
var secondTick = {
  ...tick,
  height: 15
};
var tickLabel = {
  fontSize: 12,
  marginLeft: 8,
  marginTop: 7,
  color: LIGHT_TEXT
};
var timeValue = {
  height: TIMELINE_TIME_INDICATOR_HEIGHT,
  position: "absolute",
  top: 0,
  width: "100%",
  paddingLeft: 10,
  display: "flex",
  alignItems: "center",
  backgroundColor: BACKGROUND,
  borderBottom: `${TIMELINE_ITEM_BORDER_BOTTOM}px solid ${TIMELINE_TRACK_SEPARATOR}`
};
var TimelineTimePlaceholders = () => {
  return /* @__PURE__ */ jsx191("div", {
    style: timeValue,
    children: /* @__PURE__ */ jsx191(TimeValue, {})
  });
};
var TimelineTimePadding = () => {
  return /* @__PURE__ */ jsx191("div", {
    style: {
      height: TIMELINE_TIME_INDICATOR_HEIGHT
    }
  });
};
var TimelineTimeIndicators = () => {
  const sliderTrack = useContext64(TimelineWidthContext);
  const video = Internals51.useVideo();
  if (sliderTrack === null) {
    return null;
  }
  if (video === null) {
    return null;
  }
  return /* @__PURE__ */ jsx191(Inner3, {
    durationInFrames: video.durationInFrames,
    fps: video.fps,
    windowWidth: sliderTrack
  });
};
var Inner3 = ({ windowWidth, durationInFrames, fps }) => {
  const ref = useRef33(null);
  useEffect62(() => {
    const currentRef = ref.current;
    if (!currentRef) {
      return;
    }
    const { current } = timelineVerticalScroll;
    if (!current) {
      return;
    }
    const onScroll = () => {
      currentRef.style.top = current.scrollTop + "px";
    };
    current.addEventListener("scroll", onScroll);
    return () => {
      current.removeEventListener("scroll", onScroll);
    };
  }, []);
  const style11 = useMemo102(() => {
    return {
      ...container40,
      width: windowWidth - SPLITTER_HANDLE_SIZE / 2,
      overflow: "hidden",
      marginLeft: SPLITTER_HANDLE_SIZE / 2,
      pointerEvents: "none"
    };
  }, [windowWidth]);
  const ticks = useMemo102(() => {
    const frameInterval = getFrameIncrementFromWidth(durationInFrames, windowWidth);
    const MIN_SPACING_BETWEEN_TICKS_PX = 5;
    const seconds = Math.floor(durationInFrames / fps);
    const secondMarkerEveryNth = Math.ceil(MIN_SPACING_BETWEEN_TICKS_PX * fps / (frameInterval * fps));
    const frameMarkerEveryNth = Math.ceil(MIN_SPACING_BETWEEN_TICKS_PX / frameInterval);
    const secondTicks = new Array(seconds).fill(true).map((_, index) => {
      return {
        frame: index * fps,
        style: {
          ...secondTick,
          left: frameInterval * index * fps + TIMELINE_PADDING - SPLITTER_HANDLE_SIZE / 2
        },
        showTime: index > 0
      };
    }).filter((_, idx) => idx % secondMarkerEveryNth === 0);
    const frameTicks = new Array(durationInFrames).fill(true).map((_, index) => {
      return {
        frame: index,
        style: {
          ...tick,
          left: frameInterval * index + TIMELINE_PADDING - SPLITTER_HANDLE_SIZE / 2,
          height: index % fps === 0 ? 10 : index / frameMarkerEveryNth % 2 === 0 ? 5 : 2
        },
        showTime: false
      };
    }).filter((_, idx) => idx % frameMarkerEveryNth === 0);
    const hasTicks = [];
    return [...secondTicks, ...frameTicks].filter((t) => {
      const alreadyUsed = hasTicks.find((ht) => ht === t.frame) !== undefined;
      hasTicks.push(t.frame);
      return !alreadyUsed;
    });
  }, [durationInFrames, fps, windowWidth]);
  return /* @__PURE__ */ jsx191("div", {
    ref,
    style: style11,
    children: ticks.map((t) => {
      return /* @__PURE__ */ jsx191("div", {
        style: t.style,
        children: t.showTime ? /* @__PURE__ */ jsx191("div", {
          style: tickLabel,
          children: renderFrame(t.frame, fps)
        }) : null
      }, t.frame);
    })
  });
};

// src/components/Timeline/TimelineList.tsx
import { jsx as jsx192, jsxs as jsxs92 } from "react/jsx-runtime";
var container41 = {
  flex: 1,
  background: BACKGROUND
};
var TimelineList = ({ timeline }) => {
  const ref = useRef34(null);
  const size4 = PlayerInternals18.useElementSize(ref, {
    shouldApplyCssTransforms: false,
    triggerOnWindowResize: false
  });
  const isCompact = size4 ? size4.width < 250 : false;
  return /* @__PURE__ */ jsxs92("div", {
    ref,
    style: container41,
    children: [
      /* @__PURE__ */ jsx192(TimelineTimePadding, {}),
      timeline.map((track) => {
        return /* @__PURE__ */ jsx192("div", {
          children: /* @__PURE__ */ jsx192(TimelineListItem, {
            nestedDepth: track.depth,
            sequence: track.sequence,
            isCompact
          }, track.sequence.id)
        }, track.sequence.id);
      })
    ]
  });
};

// src/components/Timeline/TimelinePlayCursorSyncer.tsx
import { useContext as useContext65, useEffect as useEffect63 } from "react";
import { Internals as Internals52 } from "remotion";
var lastTimelinePositionWhileScrolling = null;
var TimelinePlayCursorSyncer = () => {
  const video = Internals52.useVideo();
  const timelineContext = useContext65(Internals52.Timeline.TimelineContext);
  const timelinePosition = Internals52.Timeline.useTimelinePosition();
  const { canvasContent } = useContext65(Internals52.CompositionManager);
  const { zoom: zoomMap } = useContext65(TimelineZoomCtx);
  const compositionId = canvasContent && canvasContent.type === "composition" ? canvasContent.compositionId : null;
  const zoom = compositionId ? zoomMap[compositionId] ?? TIMELINE_MIN_ZOOM : null;
  if (zoom && video) {
    setCurrentFrame(timelinePosition);
    setCurrentZoom(zoom);
    setCurrentDuration(video.durationInFrames);
    setCurrentFps(video.fps);
  }
  const playing = timelineContext.playing ?? false;
  useEffect63(() => {
    if (!video) {
      return;
    }
    if (!playing) {
      return;
    }
    ensureFrameIsInViewport({
      direction: timelineContext.playbackRate > 0 ? "page-right" : "page-left",
      durationInFrames: video.durationInFrames,
      frame: timelinePosition
    });
  }, [playing, timelineContext, timelinePosition, video]);
  useEffect63(() => {
    const { current } = scrollableRef;
    if (!current) {
      return;
    }
    if (playing) {
      lastTimelinePositionWhileScrolling = {
        scrollLeft: current.scrollLeft,
        frame: getCurrentFrame(),
        zoomLevel: getCurrentZoom(),
        durationInFrames: getCurrentDuration()
      };
    } else if (lastTimelinePositionWhileScrolling !== null) {
      if (isCursorInViewport({
        frame: getCurrentFrame(),
        durationInFrames: getCurrentDuration()
      })) {
        return;
      }
      if (lastTimelinePositionWhileScrolling.zoomLevel === getCurrentZoom() && lastTimelinePositionWhileScrolling.durationInFrames === getCurrentDuration()) {
        current.scrollLeft = lastTimelinePositionWhileScrolling.scrollLeft;
      } else {
        ensureFrameIsInViewport({
          direction: "center",
          durationInFrames: getCurrentDuration(),
          frame: lastTimelinePositionWhileScrolling.frame
        });
      }
    }
  }, [playing]);
  return null;
};

// src/components/Timeline/TimelineScrollable.tsx
import { useMemo as useMemo103 } from "react";
import { jsx as jsx193 } from "react/jsx-runtime";
var outer2 = {
  width: "100%",
  height: "100%",
  overflowX: "auto",
  overflowY: "hidden",
  position: "relative",
  backgroundColor: TIMELINE_BACKGROUND
};
var TimelineScrollable = ({ children }) => {
  const containerStyle2 = useMemo103(() => {
    return {
      width: "100%",
      minHeight: "100%"
    };
  }, []);
  return /* @__PURE__ */ jsx193("div", {
    ref: scrollableRef,
    style: outer2,
    className: HORIZONTAL_SCROLLBAR_CLASSNAME,
    children: /* @__PURE__ */ jsx193("div", {
      style: containerStyle2,
      children
    })
  });
};

// src/components/Timeline/TimelineTracks.tsx
import { useMemo as useMemo107 } from "react";

// src/components/Timeline/TimelineSequence.tsx
import { useContext as useContext66, useMemo as useMemo106 } from "react";
import { Internals as Internals54, useCurrentFrame as useCurrentFrame2 } from "remotion";

// src/helpers/get-timeline-sequence-layout.ts
var SEQUENCE_BORDER_WIDTH = 1;
var getWidthOfTrack = ({
  durationInFrames,
  lastFrame,
  windowWidth,
  spatialDuration,
  nonNegativeMarginLeft
}) => {
  const fullWidth9 = windowWidth - TIMELINE_PADDING * 2;
  const base = durationInFrames === Infinity || lastFrame === 0 ? fullWidth9 : spatialDuration / lastFrame * fullWidth9;
  return base - SEQUENCE_BORDER_WIDTH + nonNegativeMarginLeft;
};
var getTimelineSequenceLayout = ({
  durationInFrames,
  startFrom,
  maxMediaDuration,
  startFromMedia,
  video,
  windowWidth,
  premountDisplay,
  postmountDisplay
}) => {
  const maxMediaSequenceDuration = (maxMediaDuration ?? Infinity) - startFromMedia;
  const lastFrame = (video.durationInFrames ?? 1) - 1;
  let spatialDuration = Math.min(maxMediaSequenceDuration, durationInFrames - 1, lastFrame - startFrom);
  const shouldAddHalfAFrameAtEnd = startFrom + durationInFrames < lastFrame;
  const shouldAddHalfAFrameAtStart = startFrom > 0;
  if (shouldAddHalfAFrameAtEnd) {
    spatialDuration += 0.5;
  }
  if (shouldAddHalfAFrameAtStart) {
    spatialDuration += 0.5;
  }
  const startFromWithOffset = shouldAddHalfAFrameAtStart ? startFrom - 0.5 : startFrom;
  const marginLeft = lastFrame === 0 ? 0 : startFromWithOffset / lastFrame * (windowWidth - TIMELINE_PADDING * 2);
  const nonNegativeMarginLeft = Math.min(marginLeft, 0);
  const width = getWidthOfTrack({
    durationInFrames,
    lastFrame,
    nonNegativeMarginLeft,
    spatialDuration,
    windowWidth
  });
  const premountWidth = premountDisplay ? getWidthOfTrack({
    durationInFrames: premountDisplay,
    lastFrame,
    nonNegativeMarginLeft,
    spatialDuration: premountDisplay,
    windowWidth
  }) : null;
  const postmountWidth = postmountDisplay ? getWidthOfTrack({
    durationInFrames: postmountDisplay,
    lastFrame,
    nonNegativeMarginLeft,
    spatialDuration: postmountDisplay,
    windowWidth
  }) : null;
  return {
    marginLeft: Math.max(marginLeft, 0) - (premountWidth ?? 0),
    width: width + (premountWidth ?? 0) + (postmountWidth ?? 0),
    premountWidth,
    postmountWidth
  };
};

// ../media-parser/dist/esm/index.mjs
var getSampleRateFromSampleFrequencyIndex = (samplingFrequencyIndex) => {
  switch (samplingFrequencyIndex) {
    case 0:
      return 96000;
    case 1:
      return 88200;
    case 2:
      return 64000;
    case 3:
      return 48000;
    case 4:
      return 44100;
    case 5:
      return 32000;
    case 6:
      return 24000;
    case 7:
      return 22050;
    case 8:
      return 16000;
    case 9:
      return 12000;
    case 10:
      return 11025;
    case 11:
      return 8000;
    case 12:
      return 7350;
    default:
      throw new Error(`Unexpected sampling frequency index ${samplingFrequencyIndex}`);
  }
};
var getConfigForSampleRate = (sampleRate) => {
  if (sampleRate === 96000) {
    return 0;
  }
  if (sampleRate === 88200) {
    return 1;
  }
  if (sampleRate === 64000) {
    return 2;
  }
  if (sampleRate === 48000) {
    return 3;
  }
  if (sampleRate === 44100) {
    return 4;
  }
  if (sampleRate === 32000) {
    return 5;
  }
  if (sampleRate === 24000) {
    return 6;
  }
  if (sampleRate === 22050) {
    return 7;
  }
  if (sampleRate === 16000) {
    return 8;
  }
  if (sampleRate === 12000) {
    return 9;
  }
  if (sampleRate === 11025) {
    return 10;
  }
  if (sampleRate === 8000) {
    return 11;
  }
  if (sampleRate === 7350) {
    return 12;
  }
  throw new Error(`Unexpected sample rate ${sampleRate}`);
};
var createAacCodecPrivate = ({
  audioObjectType,
  sampleRate,
  channelConfiguration,
  codecPrivate
}) => {
  if (codecPrivate !== null && codecPrivate.length > 2) {
    return codecPrivate;
  }
  const bits = `${audioObjectType.toString(2).padStart(5, "0")}${getConfigForSampleRate(sampleRate).toString(2).padStart(4, "0")}${channelConfiguration.toString(2).padStart(4, "0")}000`;
  if (bits.length !== 16) {
    throw new Error("Invalid AAC codec private " + bits.length);
  }
  if (channelConfiguration === 0 || channelConfiguration > 7) {
    throw new Error("Invalid channel configuration " + channelConfiguration);
  }
  const firstByte = parseInt(bits.slice(0, 8), 2);
  const secondByte = parseInt(bits.slice(8, 16), 2);
  return new Uint8Array([firstByte, secondByte]);
};
var parseAacCodecPrivate = (bytes) => {
  if (bytes.length < 2) {
    throw new Error("Invalid AAC codec private length");
  }
  const bits = [...bytes].map((b) => b.toString(2).padStart(8, "0")).join("");
  let offset = 0;
  const audioObjectType = parseInt(bits.slice(offset, offset + 5), 2);
  offset += 5;
  const samplingFrequencyIndex = parseInt(bits.slice(offset, offset + 4), 2);
  offset += 4;
  if (samplingFrequencyIndex === 15) {
    offset += 24;
  }
  const channelConfiguration = parseInt(bits.slice(offset, offset + 4), 2);
  offset += 4;
  if (audioObjectType === 5) {
    const extensionSamplingFrequencyIndex = parseInt(bits.slice(offset, offset + 4), 2);
    offset += 4;
    const newAudioObjectType = parseInt(bits.slice(offset, offset + 5), 2);
    offset += 5;
    return {
      audioObjectType: newAudioObjectType,
      sampleRate: getSampleRateFromSampleFrequencyIndex(extensionSamplingFrequencyIndex),
      channelConfiguration
    };
  }
  const sampleRate = getSampleRateFromSampleFrequencyIndex(samplingFrequencyIndex);
  return {
    audioObjectType,
    sampleRate,
    channelConfiguration
  };
};
var mapAudioObjectTypeToCodecString = (audioObjectType) => {
  switch (audioObjectType) {
    case 1:
      return "mp4a.40.2";
    case 2:
      return "mp4a.40.5";
    case 3:
      return "mp4a.40.29";
    case 4:
      return "mp4a.40.1";
    case 5:
      return "mp4a.40.3";
    case 6:
      return "mp4a.40.4";
    case 17:
      return "mp4a.40.17";
    case 23:
      return "mp4a.40.23";
    default:
      throw new Error(`Unexpected audio object type ${audioObjectType}`);
  }
};
var parseFtyp = ({
  iterator,
  size: size4,
  offset
}) => {
  const majorBrand = iterator.getByteString(4, false);
  const minorVersion = iterator.getFourByteNumber();
  const types = (size4 - iterator.counter.getOffset()) / 4;
  const compatibleBrands = [];
  for (let i = 0;i < types; i++) {
    compatibleBrands.push(iterator.getByteString(4, false).trim());
  }
  const offsetAtEnd = iterator.counter.getOffset();
  return {
    type: "ftyp-box",
    majorBrand,
    minorVersion,
    compatibleBrands,
    offset,
    boxSize: offsetAtEnd - offset
  };
};
var matroskaElements = {
  Header: "0x1a45dfa3",
  EBMLMaxIDLength: "0x42f2",
  EBMLVersion: "0x4286",
  EBMLReadVersion: "0x42f7",
  EBMLMaxSizeLength: "0x42f3",
  DocType: "0x4282",
  DocTypeVersion: "0x4287",
  DocTypeReadVersion: "0x4285",
  Segment: "0x18538067",
  SeekHead: "0x114d9b74",
  Seek: "0x4dbb",
  SeekID: "0x53ab",
  SeekPosition: "0x53ac",
  Info: "0x1549a966",
  SegmentUUID: "0x73a4",
  SegmentFilename: "0x7384",
  PrevUUID: "0x3cb923",
  PrevFilename: "0x3c83ab",
  NextUUID: "0x3eb923",
  NextFilename: "0x3e83bb",
  SegmentFamily: "0x4444",
  ChapterTranslate: "0x6924",
  ChapterTranslateID: "0x69a5",
  ChapterTranslateCodec: "0x69bf",
  ChapterTranslateEditionUID: "0x69fc",
  TimestampScale: "0x2ad7b1",
  Duration: "0x4489",
  DateUTC: "0x4461",
  Title: "0x7ba9",
  MuxingApp: "0x4d80",
  WritingApp: "0x5741",
  Cluster: "0x1f43b675",
  Timestamp: "0xe7",
  SilentTracks: "0x5854",
  SilentTrackNumber: "0x58d7",
  Position: "0xa7",
  PrevSize: "0xab",
  SimpleBlock: "0xa3",
  BlockGroup: "0xa0",
  Block: "0xa1",
  BlockVirtual: "0xa2",
  BlockAdditions: "0x75a1",
  BlockMore: "0xa6",
  BlockAdditional: "0xa5",
  BlockAddID: "0xee",
  BlockDuration: "0x9b",
  ReferencePriority: "0xfa",
  ReferenceBlock: "0xfb",
  ReferenceVirtual: "0xfd",
  CodecState: "0xa4",
  DiscardPadding: "0x75a2",
  Slices: "0x8e",
  TimeSlice: "0xe8",
  LaceNumber: "0xcc",
  FrameNumber: "0xcd",
  BlockAdditionID: "0xcb",
  Delay: "0xce",
  SliceDuration: "0xcf",
  ReferenceFrame: "0xc8",
  ReferenceOffset: "0xc9",
  ReferenceTimestamp: "0xca",
  EncryptedBlock: "0xaf",
  Tracks: "0x1654ae6b",
  TrackEntry: "0xae",
  TrackNumber: "0xd7",
  TrackUID: "0x73c5",
  TrackType: "0x83",
  FlagEnabled: "0xb9",
  FlagDefault: "0x88",
  FlagForced: "0x55aa",
  FlagHearingImpaired: "0x55ab",
  FlagVisualImpaired: "0x55ac",
  FlagTextDescriptions: "0x55ad",
  FlagOriginal: "0x55ae",
  FlagCommentary: "0x55af",
  FlagLacing: "0x9c",
  MinCache: "0x6de7",
  MaxCache: "0x6df8",
  DefaultDuration: "0x23e383",
  DefaultDecodedFieldDuration: "0x234e7a",
  TrackTimestampScale: "0x23314f",
  TrackOffset: "0x537f",
  MaxBlockAdditionID: "0x55ee",
  BlockAdditionMapping: "0x41e4",
  BlockAddIDValue: "0x41f0",
  BlockAddIDName: "0x41a4",
  BlockAddIDType: "0x41e7",
  BlockAddIDExtraData: "0x41ed",
  Name: "0x536e",
  Language: "0x22b59c",
  LanguageBCP47: "0x22b59d",
  CodecID: "0x86",
  CodecPrivate: "0x63a2",
  CodecName: "0x258688",
  AttachmentLink: "0x7446",
  CodecSettings: "0x3a9697",
  CodecInfoURL: "0x3b4040",
  CodecDownloadURL: "0x26b240",
  CodecDecodeAll: "0xaa",
  TrackOverlay: "0x6fab",
  CodecDelay: "0x56aa",
  SeekPreRoll: "0x56bb",
  TrackTranslate: "0x6624",
  TrackTranslateTrackID: "0x66a5",
  TrackTranslateCodec: "0x66bf",
  TrackTranslateEditionUID: "0x66fc",
  Video: "0xe0",
  FlagInterlaced: "0x9a",
  FieldOrder: "0x9d",
  StereoMode: "0x53b8",
  AlphaMode: "0x53c0",
  OldStereoMode: "0x53b9",
  PixelWidth: "0xb0",
  PixelHeight: "0xba",
  PixelCropBottom: "0x54aa",
  PixelCropTop: "0x54bb",
  PixelCropLeft: "0x54cc",
  PixelCropRight: "0x54dd",
  DisplayWidth: "0x54b0",
  DisplayHeight: "0x54ba",
  DisplayUnit: "0x54b2",
  AspectRatioType: "0x54b3",
  UncompressedFourCC: "0x2eb524",
  GammaValue: "0x2fb523",
  FrameRate: "0x2383e3",
  Colour: "0x55b0",
  MatrixCoefficients: "0x55b1",
  BitsPerChannel: "0x55b2",
  ChromaSubsamplingHorz: "0x55b3",
  ChromaSubsamplingVert: "0x55b4",
  CbSubsamplingHorz: "0x55b5",
  CbSubsamplingVert: "0x55b6",
  ChromaSitingHorz: "0x55b7",
  ChromaSitingVert: "0x55b8",
  Range: "0x55b9",
  TransferCharacteristics: "0x55ba",
  Primaries: "0x55bb",
  MaxCLL: "0x55bc",
  MaxFALL: "0x55bd",
  MasteringMetadata: "0x55d0",
  PrimaryRChromaticityX: "0x55d1",
  PrimaryRChromaticityY: "0x55d2",
  PrimaryGChromaticityX: "0x55d3",
  PrimaryGChromaticityY: "0x55d4",
  PrimaryBChromaticityX: "0x55d5",
  PrimaryBChromaticityY: "0x55d6",
  WhitePointChromaticityX: "0x55d7",
  WhitePointChromaticityY: "0x55d8",
  LuminanceMax: "0x55d9",
  LuminanceMin: "0x55da",
  Projection: "0x7670",
  ProjectionType: "0x7671",
  ProjectionPrivate: "0x7672",
  ProjectionPoseYaw: "0x7673",
  ProjectionPosePitch: "0x7674",
  ProjectionPoseRoll: "0x7675",
  Audio: "0xe1",
  SamplingFrequency: "0xb5",
  OutputSamplingFrequency: "0x78b5",
  Channels: "0x9f",
  ChannelPositions: "0x7d7b",
  BitDepth: "0x6264",
  Emphasis: "0x52f1",
  TrackOperation: "0xe2",
  TrackCombinePlanes: "0xe3",
  TrackPlane: "0xe4",
  TrackPlaneUID: "0xe5",
  TrackPlaneType: "0xe6",
  TrackJoinBlocks: "0xe9",
  TrackJoinUID: "0xed",
  TrickTrackUID: "0xc0",
  TrickTrackSegmentUID: "0xc1",
  TrickTrackFlag: "0xc6",
  TrickMasterTrackUID: "0xc7",
  TrickMasterTrackSegmentUID: "0xc4",
  ContentEncodings: "0x6d80",
  ContentEncoding: "0x6240",
  ContentEncodingOrder: "0x5031",
  ContentEncodingScope: "0x5032",
  ContentEncodingType: "0x5033",
  ContentCompression: "0x5034",
  ContentCompAlgo: "0x4254",
  ContentCompSettings: "0x4255",
  ContentEncryption: "0x5035",
  ContentEncAlgo: "0x47e1",
  ContentEncKeyID: "0x47e2",
  ContentEncAESSettings: "0x47e7",
  AESSettingsCipherMode: "0x47e8",
  ContentSignature: "0x47e3",
  ContentSigKeyID: "0x47e4",
  ContentSigAlgo: "0x47e5",
  ContentSigHashAlgo: "0x47e6",
  Cues: "0x1c53bb6b",
  CuePoint: "0xbb",
  CueTime: "0xb3",
  CueTrackPositions: "0xb7",
  CueTrack: "0xf7",
  CueClusterPosition: "0xf1",
  CueRelativePosition: "0xf0",
  CueDuration: "0xb2",
  CueBlockNumber: "0x5378",
  CueCodecState: "0xea",
  CueReference: "0xdb",
  CueRefTime: "0x96",
  CueRefCluster: "0x97",
  CueRefNumber: "0x535f",
  CueRefCodecState: "0xeb",
  Attachments: "0x1941a469",
  AttachedFile: "0x61a7",
  FileDescription: "0x467e",
  FileName: "0x466e",
  FileMediaType: "0x4660",
  FileData: "0x465c",
  FileUID: "0x46ae",
  FileReferral: "0x4675",
  FileUsedStartTime: "0x4661",
  FileUsedEndTime: "0x4662",
  Chapters: "0x1043a770",
  EditionEntry: "0x45b9",
  EditionUID: "0x45bc",
  EditionFlagHidden: "0x45bd",
  EditionFlagDefault: "0x45db",
  EditionFlagOrdered: "0x45dd",
  EditionDisplay: "0x4520",
  EditionString: "0x4521",
  EditionLanguageIETF: "0x45e4",
  ChapterAtom: "0xb6",
  ChapterUID: "0x73c4",
  ChapterStringUID: "0x5654",
  ChapterTimeStart: "0x91",
  ChapterTimeEnd: "0x92",
  ChapterFlagHidden: "0x98",
  ChapterFlagEnabled: "0x4598",
  ChapterSegmentUUID: "0x6e67",
  ChapterSkipType: "0x4588",
  ChapterSegmentEditionUID: "0x6ebc",
  ChapterPhysicalEquiv: "0x63c3",
  ChapterTrack: "0x8f",
  ChapterTrackUID: "0x89",
  ChapterDisplay: "0x80",
  ChapString: "0x85",
  ChapLanguage: "0x437c",
  ChapLanguageBCP47: "0x437d",
  ChapCountry: "0x437e",
  ChapProcess: "0x6944",
  ChapProcessCodecID: "0x6955",
  ChapProcessPrivate: "0x450d",
  ChapProcessCommand: "0x6911",
  ChapProcessTime: "0x6922",
  ChapProcessData: "0x6933",
  Tags: "0x1254c367",
  Tag: "0x7373",
  Targets: "0x63c0",
  TargetTypeValue: "0x68ca",
  TargetType: "0x63ca",
  TagTrackUID: "0x63c5",
  TagEditionUID: "0x63c9",
  TagChapterUID: "0x63c4",
  TagAttachmentUID: "0x63c6",
  SimpleTag: "0x67c8",
  TagName: "0x45a3",
  TagLanguage: "0x447a",
  TagLanguageBCP47: "0x447b",
  TagDefault: "0x4484",
  TagDefaultBogus: "0x44b4",
  TagString: "0x4487",
  TagBinary: "0x4485",
  Void: "0xec",
  Crc32: "0xbf"
};
var matroskaIds = Object.values(matroskaElements);
var knownIdsWithOneLength = matroskaIds.filter((id) => id.length === 4);
var knownIdsWithTwoLength = matroskaIds.filter((id) => id.length === 6);
var knownIdsWithThreeLength = matroskaIds.filter((id) => id.length === 8);
var ebmlVersion = {
  name: "EBMLVersion",
  type: "uint"
};
var ebmlReadVersion = {
  name: "EBMLReadVersion",
  type: "uint"
};
var ebmlMaxIdLength = {
  name: "EBMLMaxIDLength",
  type: "uint"
};
var ebmlMaxSizeLength = {
  name: "EBMLMaxSizeLength",
  type: "uint"
};
var docType = {
  name: "DocType",
  type: "string"
};
var docTypeVersion = {
  name: "DocTypeVersion",
  type: "uint"
};
var docTypeReadVersion = {
  name: "DocTypeReadVersion",
  type: "uint"
};
var voidEbml = {
  name: "Void",
  type: "uint8array"
};
var matroskaHeader = {
  name: "Header",
  type: "children"
};
var seekId = {
  name: "SeekID",
  type: "hex-string"
};
var _name = {
  name: "Name",
  type: "string"
};
var minCache = {
  name: "MinCache",
  type: "uint"
};
var maxCache = {
  name: "MaxCache",
  type: "uint"
};
var seekPosition = {
  name: "SeekPosition",
  type: "uint"
};
var seek = {
  name: "Seek",
  type: "children"
};
var seekHead = {
  name: "SeekHead",
  type: "children"
};
var trackType = {
  name: "TrackType",
  type: "uint"
};
var widthType = {
  name: "PixelWidth",
  type: "uint"
};
var heightType = {
  name: "PixelHeight",
  type: "uint"
};
var muxingApp = {
  name: "MuxingApp",
  type: "string"
};
var duration = {
  name: "Duration",
  type: "float"
};
var timestampScale = {
  name: "TimestampScale",
  type: "uint"
};
var infoType = {
  name: "Info",
  type: "children"
};
var titleType = {
  name: "Title",
  type: "string"
};
var tagTrackUidType = {
  name: "TagTrackUID",
  type: "hex-string"
};
var samplingFrequency = {
  name: "SamplingFrequency",
  type: "float"
};
var channels = {
  name: "Channels",
  type: "uint"
};
var alphaMode = {
  name: "AlphaMode",
  type: "uint"
};
var interlaced = {
  name: "FlagInterlaced",
  type: "uint"
};
var bitDepth = {
  name: "BitDepth",
  type: "uint"
};
var displayWidth = {
  name: "DisplayWidth",
  type: "uint"
};
var displayHeight = {
  name: "DisplayHeight",
  type: "uint"
};
var displayUnit = {
  name: "DisplayUnit",
  type: "uint"
};
var flagLacing = {
  name: "FlagLacing",
  type: "uint"
};
var tagSegment = {
  name: "Tag",
  type: "children"
};
var tags = {
  name: "Tags",
  type: "children"
};
var trackNumber = {
  name: "TrackNumber",
  type: "uint"
};
var trackUID = {
  name: "TrackUID",
  type: "hex-string"
};
var color = {
  name: "Colour",
  type: "children"
};
var transferCharacteristics = {
  name: "TransferCharacteristics",
  type: "uint"
};
var matrixCoefficients = {
  name: "MatrixCoefficients",
  type: "uint"
};
var primaries = {
  name: "Primaries",
  type: "uint"
};
var range = {
  name: "Range",
  type: "uint"
};
var ChromaSitingHorz = {
  name: "ChromaSitingHorz",
  type: "uint"
};
var ChromaSitingVert = {
  name: "ChromaSitingVert",
  type: "uint"
};
var language = {
  name: "Language",
  type: "string"
};
var defaultDuration = {
  name: "DefaultDuration",
  type: "uint"
};
var codecPrivate = {
  name: "CodecPrivate",
  type: "uint8array"
};
var blockAdditionsSegment = {
  name: "BlockAdditions",
  type: "uint8array"
};
var maxBlockAdditionIdSegment = {
  name: "MaxBlockAdditionID",
  type: "uint"
};
var audioSegment = {
  name: "Audio",
  type: "children"
};
var videoSegment = {
  name: "Video",
  type: "children"
};
var flagDefault = {
  name: "FlagDefault",
  type: "uint"
};
var referenceBlock = {
  name: "ReferenceBlock",
  type: "uint"
};
var blockDurationSegment = {
  name: "BlockDuration",
  type: "uint"
};
var codecName = {
  name: "CodecName",
  type: "string"
};
var trackTimestampScale = {
  name: "TrackTimestampScale",
  type: "float"
};
var trackEntry = {
  name: "TrackEntry",
  type: "children"
};
var tracks = {
  name: "Tracks",
  type: "children"
};
var block = {
  name: "Block",
  type: "uint8array"
};
var simpleBlock = {
  name: "SimpleBlock",
  type: "uint8array"
};
var blockGroup = {
  name: "BlockGroup",
  type: "children"
};
var targetsType = {
  name: "Targets",
  type: "children"
};
var simpleTagType = {
  name: "SimpleTag",
  type: "children"
};
var tagNameType = {
  name: "TagName",
  type: "string"
};
var tagStringType = {
  name: "TagString",
  type: "string"
};
var ebmlMap = {
  [matroskaElements.Header]: matroskaHeader,
  [matroskaElements.DocType]: docType,
  [matroskaElements.Targets]: targetsType,
  [matroskaElements.SimpleTag]: simpleTagType,
  [matroskaElements.TagName]: tagNameType,
  [matroskaElements.TagString]: tagStringType,
  [matroskaElements.DocTypeVersion]: docTypeVersion,
  [matroskaElements.DocTypeReadVersion]: docTypeReadVersion,
  [matroskaElements.EBMLVersion]: ebmlVersion,
  [matroskaElements.EBMLReadVersion]: ebmlReadVersion,
  [matroskaElements.EBMLMaxIDLength]: ebmlMaxIdLength,
  [matroskaElements.EBMLMaxSizeLength]: ebmlMaxSizeLength,
  [matroskaElements.Void]: voidEbml,
  [matroskaElements.Cues]: {
    name: "Cues",
    type: "children"
  },
  [matroskaElements.CuePoint]: {
    name: "CuePoint",
    type: "children"
  },
  [matroskaElements.CueTime]: {
    name: "CueTime",
    type: "uint"
  },
  [matroskaElements.CueTrackPositions]: {
    name: "CueTrackPositions",
    type: "children"
  },
  [matroskaElements.CueClusterPosition]: {
    name: "CueClusterPosition",
    type: "uint"
  },
  [matroskaElements.CueRelativePosition]: {
    name: "CueRelativePosition",
    type: "uint"
  },
  [matroskaElements.CueBlockNumber]: {
    name: "CueBlockNumber",
    type: "uint"
  },
  [matroskaElements.CueTrack]: {
    name: "CueTrack",
    type: "uint"
  },
  [matroskaElements.DateUTC]: {
    name: "DateUTC",
    type: "uint8array"
  },
  [matroskaElements.TrackTimestampScale]: trackTimestampScale,
  [matroskaElements.CodecDelay]: {
    name: "CodecDelay",
    type: "uint8array"
  },
  [matroskaElements.SeekPreRoll]: {
    name: "SeekPreRoll",
    type: "uint8array"
  },
  [matroskaElements.DiscardPadding]: {
    name: "DiscardPadding",
    type: "uint8array"
  },
  [matroskaElements.OutputSamplingFrequency]: {
    name: "OutputSamplingFrequency",
    type: "uint8array"
  },
  [matroskaElements.CodecName]: codecName,
  [matroskaElements.Position]: {
    name: "Position",
    type: "uint8array"
  },
  [matroskaElements.SliceDuration]: {
    name: "SliceDuration",
    type: "uint8array"
  },
  [matroskaElements.TagTrackUID]: tagTrackUidType,
  [matroskaElements.SeekHead]: seekHead,
  [matroskaElements.Seek]: seek,
  [matroskaElements.SeekID]: seekId,
  [matroskaElements.Name]: _name,
  [matroskaElements.MinCache]: minCache,
  [matroskaElements.MaxCache]: maxCache,
  [matroskaElements.SeekPosition]: seekPosition,
  [matroskaElements.Crc32]: {
    name: "Crc32",
    type: "uint8array"
  },
  [matroskaElements.MuxingApp]: muxingApp,
  [matroskaElements.WritingApp]: {
    name: "WritingApp",
    type: "string"
  },
  [matroskaElements.SegmentUUID]: {
    name: "SegmentUUID",
    type: "string"
  },
  [matroskaElements.Duration]: duration,
  [matroskaElements.CodecID]: {
    name: "CodecID",
    type: "string"
  },
  [matroskaElements.TrackType]: trackType,
  [matroskaElements.PixelWidth]: widthType,
  [matroskaElements.PixelHeight]: heightType,
  [matroskaElements.TimestampScale]: timestampScale,
  [matroskaElements.Info]: infoType,
  [matroskaElements.Title]: titleType,
  [matroskaElements.SamplingFrequency]: samplingFrequency,
  [matroskaElements.Channels]: channels,
  [matroskaElements.AlphaMode]: alphaMode,
  [matroskaElements.FlagInterlaced]: interlaced,
  [matroskaElements.BitDepth]: bitDepth,
  [matroskaElements.DisplayHeight]: displayHeight,
  [matroskaElements.DisplayWidth]: displayWidth,
  [matroskaElements.DisplayUnit]: displayUnit,
  [matroskaElements.FlagLacing]: flagLacing,
  [matroskaElements.Tags]: tags,
  [matroskaElements.Tag]: tagSegment,
  [matroskaElements.TrackNumber]: trackNumber,
  [matroskaElements.TrackUID]: trackUID,
  [matroskaElements.Colour]: color,
  [matroskaElements.Language]: language,
  [matroskaElements.DefaultDuration]: defaultDuration,
  [matroskaElements.CodecPrivate]: codecPrivate,
  [matroskaElements.BlockDuration]: blockDurationSegment,
  [matroskaElements.BlockAdditions]: blockAdditionsSegment,
  [matroskaElements.MaxBlockAdditionID]: maxBlockAdditionIdSegment,
  [matroskaElements.Audio]: audioSegment,
  [matroskaElements.Video]: videoSegment,
  [matroskaElements.FlagDefault]: flagDefault,
  [matroskaElements.ReferenceBlock]: referenceBlock,
  [matroskaElements.TrackEntry]: trackEntry,
  [matroskaElements.Timestamp]: {
    name: "Timestamp",
    type: "uint"
  },
  [matroskaElements.Tracks]: tracks,
  [matroskaElements.Block]: block,
  [matroskaElements.SimpleBlock]: simpleBlock,
  [matroskaElements.BlockGroup]: blockGroup,
  [matroskaElements.Segment]: {
    name: "Segment",
    type: "children"
  },
  [matroskaElements.Cluster]: {
    name: "Cluster",
    type: "children"
  },
  [matroskaElements.TransferCharacteristics]: transferCharacteristics,
  [matroskaElements.MatrixCoefficients]: matrixCoefficients,
  [matroskaElements.Primaries]: primaries,
  [matroskaElements.Range]: range,
  [matroskaElements.ChromaSitingHorz]: ChromaSitingHorz,
  [matroskaElements.ChromaSitingVert]: ChromaSitingVert
};
var webmPattern = new Uint8Array([26, 69, 223, 163]);
var matchesPattern = (pattern) => {
  return (data) => {
    return pattern.every((value, index) => data[index] === value);
  };
};
var isRiffAvi = (data) => {
  const riffPattern = new Uint8Array([82, 73, 70, 70]);
  if (!matchesPattern(riffPattern)(data.subarray(0, 4))) {
    return false;
  }
  const fileType = data.subarray(8, 12);
  const aviPattern = new Uint8Array([65, 86, 73, 32]);
  return matchesPattern(aviPattern)(fileType);
};
var isRiffWave = (data) => {
  const riffPattern = new Uint8Array([82, 73, 70, 70]);
  if (!matchesPattern(riffPattern)(data.subarray(0, 4))) {
    return false;
  }
  const fileType = data.subarray(8, 12);
  const wavePattern = new Uint8Array([87, 65, 86, 69]);
  return matchesPattern(wavePattern)(fileType);
};
var isWebm = (data) => {
  return matchesPattern(webmPattern)(data.subarray(0, 4));
};
var isIsoBaseMedia = (data) => {
  const isoBaseMediaMp4Pattern = new TextEncoder().encode("ftyp");
  return matchesPattern(isoBaseMediaMp4Pattern)(data.subarray(4, 8));
};
var isTransportStream = (data) => {
  return data[0] === 71 && data[188] === 71;
};
var isMp3 = (data) => {
  const mpegPattern = new Uint8Array([255, 243]);
  const mpegPattern2 = new Uint8Array([255, 251]);
  const id3v4Pattern = new Uint8Array([73, 68, 51, 4]);
  const id3v3Pattern = new Uint8Array([73, 68, 51, 3]);
  const id3v2Pattern = new Uint8Array([73, 68, 51, 2]);
  const subarray = data.subarray(0, 4);
  return matchesPattern(mpegPattern)(subarray) || matchesPattern(mpegPattern2)(subarray) || matchesPattern(id3v4Pattern)(subarray) || matchesPattern(id3v3Pattern)(subarray) || matchesPattern(id3v2Pattern)(subarray);
};
var isAac = (data) => {
  const aacPattern = new Uint8Array([255, 241]);
  return matchesPattern(aacPattern)(data.subarray(0, 2));
};
var isFlac = (data) => {
  const flacPattern = new Uint8Array([102, 76, 97, 67]);
  return matchesPattern(flacPattern)(data.subarray(0, 4));
};
var isM3u = (data) => {
  return new TextDecoder("utf-8").decode(data.slice(0, 7)) === "#EXTM3U";
};
function getBmpDimensions(bmpData) {
  if (bmpData.length < 26) {
    return null;
  }
  const view = new DataView(bmpData.buffer, bmpData.byteOffset);
  return {
    width: view.getUint32(18, true),
    height: Math.abs(view.getInt32(22, true))
  };
}
var isBmp = (data) => {
  const bmpPattern = new Uint8Array([66, 77]);
  if (matchesPattern(bmpPattern)(data.subarray(0, 2))) {
    const bmp = getBmpDimensions(data);
    return { dimensions: bmp, type: "bmp" };
  }
  return null;
};
var getGifDimensions = (data) => {
  const view = new DataView(data.buffer, data.byteOffset);
  const width = view.getUint16(6, true);
  const height = view.getUint16(8, true);
  return { width, height };
};
var isGif = (data) => {
  const gifPattern = new Uint8Array([71, 73, 70, 56]);
  if (matchesPattern(gifPattern)(data.subarray(0, 4))) {
    return { type: "gif", dimensions: getGifDimensions(data) };
  }
  return null;
};
function getJpegDimensions(data) {
  let offset = 0;
  function readUint16BE(o) {
    return data[o] << 8 | data[o + 1];
  }
  if (readUint16BE(offset) !== 65496) {
    return null;
  }
  offset += 2;
  while (offset < data.length) {
    if (data[offset] === 255) {
      const marker = data[offset + 1];
      if (marker === 192 || marker === 194) {
        const height = readUint16BE(offset + 5);
        const width = readUint16BE(offset + 7);
        return { width, height };
      }
      const length = readUint16BE(offset + 2);
      offset += length + 2;
    } else {
      offset++;
    }
  }
  return null;
}
var isJpeg = (data) => {
  const jpegPattern = new Uint8Array([255, 216]);
  const jpeg = matchesPattern(jpegPattern)(data.subarray(0, 2));
  if (!jpeg) {
    return null;
  }
  const dim = getJpegDimensions(data);
  return { dimensions: dim, type: "jpeg" };
};
var isPdf = (data) => {
  if (data.length < 4) {
    return null;
  }
  const pdfPattern = new Uint8Array([37, 80, 68, 70]);
  return matchesPattern(pdfPattern)(data.subarray(0, 4)) ? { type: "pdf" } : null;
};
function getPngDimensions(pngData) {
  if (pngData.length < 24) {
    return null;
  }
  const view = new DataView(pngData.buffer, pngData.byteOffset);
  const pngSignature = [137, 80, 78, 71, 13, 10, 26, 10];
  for (let i = 0;i < 8; i++) {
    if (pngData[i] !== pngSignature[i]) {
      return null;
    }
  }
  return {
    width: view.getUint32(16, false),
    height: view.getUint32(20, false)
  };
}
var isPng = (data) => {
  const pngPattern = new Uint8Array([137, 80, 78, 71]);
  if (matchesPattern(pngPattern)(data.subarray(0, 4))) {
    const png = getPngDimensions(data);
    return { dimensions: png, type: "png" };
  }
  return null;
};
function getWebPDimensions(bytes) {
  if (bytes.length < 30) {
    return null;
  }
  if (bytes[0] !== 82 || bytes[1] !== 73 || bytes[2] !== 70 || bytes[3] !== 70 || bytes[8] !== 87 || bytes[9] !== 69 || bytes[10] !== 66 || bytes[11] !== 80) {
    return null;
  }
  if (bytes[12] === 86 && bytes[13] === 80 && bytes[14] === 56) {
    if (bytes[15] === 32) {
      return {
        width: bytes[26] | bytes[27] << 8 & 16383,
        height: bytes[28] | bytes[29] << 8 & 16383
      };
    }
  }
  if (bytes[12] === 86 && bytes[13] === 80 && bytes[14] === 56 && bytes[15] === 76) {
    return {
      width: 1 + (bytes[21] | (bytes[22] & 63) << 8),
      height: 1 + ((bytes[22] & 192) >> 6 | bytes[23] << 2 | (bytes[24] & 15) << 10)
    };
  }
  if (bytes[12] === 86 && bytes[13] === 80 && bytes[14] === 56 && bytes[15] === 88) {
    return {
      width: 1 + (bytes[24] | bytes[25] << 8 | bytes[26] << 16),
      height: 1 + (bytes[27] | bytes[28] << 8 | bytes[29] << 16)
    };
  }
  return null;
}
var isWebp = (data) => {
  const webpPattern = new Uint8Array([82, 73, 70, 70]);
  if (matchesPattern(webpPattern)(data.subarray(0, 4))) {
    return {
      type: "webp",
      dimensions: getWebPDimensions(data)
    };
  }
  return null;
};
var detectFileType = (data) => {
  if (isRiffWave(data)) {
    return { type: "wav" };
  }
  if (isRiffAvi(data)) {
    return { type: "riff" };
  }
  if (isAac(data)) {
    return { type: "aac" };
  }
  if (isFlac(data)) {
    return { type: "flac" };
  }
  if (isM3u(data)) {
    return { type: "m3u" };
  }
  const webp = isWebp(data);
  if (webp) {
    return webp;
  }
  if (isWebm(data)) {
    return { type: "webm" };
  }
  if (isIsoBaseMedia(data)) {
    return { type: "iso-base-media" };
  }
  if (isTransportStream(data)) {
    return { type: "transport-stream" };
  }
  if (isMp3(data)) {
    return { type: "mp3" };
  }
  const gif = isGif(data);
  if (gif) {
    return gif;
  }
  const png = isPng(data);
  if (png) {
    return png;
  }
  const pdf = isPdf(data);
  if (pdf) {
    return pdf;
  }
  const bmp = isBmp(data);
  if (bmp) {
    return bmp;
  }
  const jpeg = isJpeg(data);
  if (jpeg) {
    return jpeg;
  }
  return { type: "unknown" };
};
var logLevels = ["trace", "verbose", "info", "warn", "error"];
var getNumberForLogLevel = (level) => {
  return logLevels.indexOf(level);
};
var isEqualOrBelowLogLevel = (currentLevel, level) => {
  return getNumberForLogLevel(currentLevel) <= getNumberForLogLevel(level);
};
var Log = {
  trace: (logLevel, ...args) => {
    if (isEqualOrBelowLogLevel(logLevel, "trace")) {
      return console.log(...args);
    }
  },
  verbose: (logLevel, ...args) => {
    if (isEqualOrBelowLogLevel(logLevel, "verbose")) {
      return console.log(...args);
    }
  },
  info: (logLevel, ...args) => {
    if (isEqualOrBelowLogLevel(logLevel, "info")) {
      return console.log(...args);
    }
  },
  warn: (logLevel, ...args) => {
    if (isEqualOrBelowLogLevel(logLevel, "warn")) {
      return console.warn(...args);
    }
  },
  error: (...args) => {
    return console.error(...args);
  }
};

class ResizableBuffer {
  buffer;
  uintarray;
  constructor(buffer) {
    this.buffer = buffer;
    this.uintarray = new Uint8Array(buffer);
  }
  resize(newLength) {
    if (typeof this.buffer.resize === "function") {
      this.buffer.resize(newLength);
    } else {
      const newBuffer = new ArrayBuffer(newLength);
      new Uint8Array(newBuffer).set(new Uint8Array(this.buffer).subarray(0, Math.min(this.buffer.byteLength, newLength)));
      this.buffer = newBuffer;
      this.uintarray = new Uint8Array(newBuffer);
    }
  }
}
var makeBufferWithMaxBytes = (initialData, maxBytes) => {
  const maxByteLength = Math.min(maxBytes, 2 ** 31);
  try {
    const buf = new ArrayBuffer(initialData.byteLength, {
      maxByteLength
    });
    return new ResizableBuffer(buf);
  } catch (e) {
    if (e instanceof RangeError && maxBytes > 2 ** 27) {
      return new ResizableBuffer(new ArrayBuffer(initialData.byteLength, {
        maxByteLength: 2 ** 27
      }));
    }
    throw e;
  }
};
var bufferManager = ({
  initialData,
  maxBytes,
  counter,
  logLevel
}) => {
  const buf = makeBufferWithMaxBytes(initialData, maxBytes);
  if (!buf.buffer.resize) {
    Log.warn(logLevel, "`ArrayBuffer.resize` is not supported in this Runtime. Using slow polyfill.");
  }
  buf.uintarray.set(initialData);
  let view = new DataView(buf.uintarray.buffer);
  const destroy = () => {
    buf.uintarray = new Uint8Array(0);
    buf.resize(0);
  };
  const flushBytesRead = (force, mode) => {
    const bytesToRemove = counter.getDiscardedOffset();
    if (bytesToRemove < 3000000 && !force) {
      return { bytesRemoved: 0, removedData: null };
    }
    if (view.byteLength < bytesToRemove && !force) {
      return { bytesRemoved: 0, removedData: null };
    }
    counter.discardBytes(bytesToRemove);
    const removedData = mode === "download" ? buf.uintarray.slice(0, bytesToRemove) : null;
    const newData = buf.uintarray.slice(bytesToRemove);
    buf.uintarray.set(newData);
    buf.resize(newData.byteLength);
    view = new DataView(buf.uintarray.buffer);
    return { bytesRemoved: bytesToRemove, removedData };
  };
  const skipTo = (offset) => {
    const becomesSmaller = offset < counter.getOffset();
    if (becomesSmaller) {
      const toDecrement = counter.getOffset() - offset;
      if (toDecrement > counter.getDiscardedOffset()) {
        throw new Error("Cannot count backwards, data has already been flushed");
      }
      counter.decrement(toDecrement);
    }
    const currentOffset = counter.getOffset();
    counter.increment(offset - currentOffset);
  };
  const addData = (newData) => {
    const oldLength = buf.buffer.byteLength;
    const newLength = oldLength + newData.byteLength;
    if (newLength < oldLength) {
      throw new Error("Cannot decrement size");
    }
    if (newLength > (maxBytes ?? Infinity)) {
      throw new Error(`Exceeded maximum byte length ${maxBytes} with ${newLength}`);
    }
    buf.resize(newLength);
    buf.uintarray = new Uint8Array(buf.buffer);
    buf.uintarray.set(newData, oldLength);
    view = new DataView(buf.uintarray.buffer);
  };
  const replaceData = (newData, seekTo) => {
    buf.resize(newData.byteLength);
    buf.uintarray = new Uint8Array(buf.buffer);
    buf.uintarray.set(newData);
    view = new DataView(buf.uintarray.buffer);
    counter.setDiscardedOffset(seekTo);
    counter.decrement(counter.getOffset());
    counter.increment(seekTo);
  };
  return {
    getView: () => view,
    getUint8Array: () => buf.uintarray,
    destroy,
    addData,
    skipTo,
    removeBytesRead: flushBytesRead,
    replaceData
  };
};
var makeOffsetCounter = (initial) => {
  let offset = initial;
  let discardedBytes = 0;
  return {
    getOffset: () => offset,
    discardBytes: (bytes) => {
      discardedBytes += bytes;
    },
    increment: (bytes) => {
      if (bytes < 0) {
        throw new Error("Cannot increment by a negative amount: " + bytes);
      }
      offset += bytes;
    },
    getDiscardedBytes: () => discardedBytes,
    setDiscardedOffset: (bytes) => {
      discardedBytes = bytes;
    },
    getDiscardedOffset: () => offset - discardedBytes,
    decrement: (bytes) => {
      if (bytes < 0) {
        throw new Error("Cannot decrement by a negative amount: " + bytes);
      }
      offset -= bytes;
    }
  };
};
var getArrayBufferIterator = ({
  initialData,
  maxBytes,
  logLevel
}) => {
  const counter = makeOffsetCounter(0);
  const {
    getUint8Array,
    getView,
    addData,
    destroy,
    removeBytesRead,
    skipTo,
    replaceData
  } = bufferManager({ initialData, maxBytes, counter, logLevel });
  const startCheckpoint = () => {
    const checkpoint = counter.getOffset();
    return {
      returnToCheckpoint: () => {
        counter.decrement(counter.getOffset() - checkpoint);
      }
    };
  };
  const getSlice = (amount) => {
    const value = getUint8Array().slice(counter.getDiscardedOffset(), counter.getDiscardedOffset() + amount);
    counter.increment(value.length);
    return value;
  };
  const discard = (length) => {
    counter.increment(length);
  };
  const readUntilNullTerminator = () => {
    const bytes = [];
    let byte;
    while ((byte = getUint8()) !== 0) {
      bytes.push(byte);
    }
    counter.decrement(1);
    return new TextDecoder().decode(new Uint8Array(bytes));
  };
  const readUntilLineEnd = () => {
    const bytes = [];
    while (true) {
      if (bytesRemaining() === 0) {
        return null;
      }
      const byte = getUint8();
      bytes.push(byte);
      if (byte === 10) {
        break;
      }
    }
    const str = new TextDecoder().decode(new Uint8Array(bytes)).trim();
    return str;
  };
  const getUint8 = () => {
    const val = getView().getUint8(counter.getDiscardedOffset());
    counter.increment(1);
    return val;
  };
  const getEightByteNumber = (littleEndian = false) => {
    if (littleEndian) {
      const one = getUint8();
      const two = getUint8();
      const three = getUint8();
      const four = getUint8();
      const five = getUint8();
      const six = getUint8();
      const seven = getUint8();
      const eight = getUint8();
      return (eight << 56 | seven << 48 | six << 40 | five << 32 | four << 24 | three << 16 | two << 8 | one) >>> 0;
    }
    function byteArrayToBigInt(byteArray) {
      let result = BigInt(0);
      for (let i = 0;i < byteArray.length; i++) {
        result = (result << BigInt(8)) + BigInt(byteArray[i]);
      }
      return result;
    }
    const bigInt = byteArrayToBigInt([
      getUint8(),
      getUint8(),
      getUint8(),
      getUint8(),
      getUint8(),
      getUint8(),
      getUint8(),
      getUint8()
    ]);
    return Number(bigInt);
  };
  const getFourByteNumber = () => {
    const unsigned = getUint8() << 24 | getUint8() << 16 | getUint8() << 8 | getUint8();
    return unsigned >>> 0;
  };
  const getPaddedFourByteNumber = () => {
    let lastInt = 128;
    while (lastInt = getUint8(), lastInt === 128) {}
    return lastInt;
  };
  const getUint32 = () => {
    const val = getView().getUint32(counter.getDiscardedOffset());
    counter.increment(4);
    return val;
  };
  const getSyncSafeInt32 = () => {
    const val = getView().getUint32(counter.getDiscardedOffset());
    counter.increment(4);
    return (val & 2130706432) >> 3 | (val & 8323072) >> 2 | (val & 32512) >> 1 | val & 127;
  };
  const getUint64 = (littleEndian = false) => {
    const val = getView().getBigUint64(counter.getDiscardedOffset(), littleEndian);
    counter.increment(8);
    return val;
  };
  const getInt64 = (littleEndian = false) => {
    const val = getView().getBigInt64(counter.getDiscardedOffset(), littleEndian);
    counter.increment(8);
    return val;
  };
  const startBox = (size4) => {
    const startOffset = counter.getOffset();
    return {
      discardRest: () => discard(size4 - (counter.getOffset() - startOffset)),
      expectNoMoreBytes: () => {
        const remaining = size4 - (counter.getOffset() - startOffset);
        if (remaining !== 0) {
          throw new Error("expected 0 bytes, got " + remaining);
        }
      }
    };
  };
  const getUint32Le = () => {
    const val = getView().getUint32(counter.getDiscardedOffset(), true);
    counter.increment(4);
    return val;
  };
  const getInt32Le = () => {
    const val = getView().getInt32(counter.getDiscardedOffset(), true);
    counter.increment(4);
    return val;
  };
  const getInt32 = () => {
    const val = getView().getInt32(counter.getDiscardedOffset());
    counter.increment(4);
    return val;
  };
  const bytesRemaining = () => {
    return getUint8Array().byteLength - counter.getDiscardedOffset();
  };
  const readExpGolomb = () => {
    if (!bitReadingMode) {
      throw new Error("Not in bit reading mode");
    }
    let zerosCount = 0;
    while (getBits(1) === 0) {
      zerosCount++;
    }
    let suffix2 = 0;
    for (let i = 0;i < zerosCount; i++) {
      suffix2 = suffix2 << 1 | getBits(1);
    }
    return (1 << zerosCount) - 1 + suffix2;
  };
  const peekB = (length) => {
    Log.info("info", [...getSlice(length)].map((b) => b.toString(16).padStart(2, "0")));
    counter.decrement(length);
  };
  const peekD = (length) => {
    Log.info("info", [...getSlice(length)].map((b) => b.toString(16).padStart(2, "0")));
    counter.decrement(length);
  };
  const leb128 = () => {
    let result = 0;
    let shift = 0;
    let byte;
    do {
      byte = getBits(8);
      result |= (byte & 127) << shift;
      shift += 7;
    } while (byte >= 128);
    return result;
  };
  let bitIndex = 0;
  const stopReadingBits = () => {
    bitIndex = 0;
    bitReadingMode = false;
  };
  let byteToShift = 0;
  let bitReadingMode = false;
  const startReadingBits = () => {
    bitReadingMode = true;
    byteToShift = getUint8();
  };
  const getFlacCodecNumber = () => {
    let ones = 0;
    let bits = 0;
    while ((++bits || true) && getBits(1) === 1) {
      ones++;
    }
    if (ones === 0) {
      return getBits(7);
    }
    const bitArray = [];
    const firstByteBits = 8 - ones - 1;
    for (let i = 0;i < firstByteBits; i++) {
      bitArray.unshift(getBits(1));
    }
    const extraBytes = ones - 1;
    for (let i = 0;i < extraBytes; i++) {
      for (let j = 0;j < 8; j++) {
        const val = getBits(1);
        if (j < 2) {
          continue;
        }
        bitArray.unshift(val);
      }
    }
    const encoded = bitArray.reduce((acc, bit, index) => {
      return acc | bit << index;
    }, 0);
    return encoded;
  };
  const getBits = (bits) => {
    let result = 0;
    let bitsCollected = 0;
    while (bitsCollected < bits) {
      if (bitIndex >= 8) {
        bitIndex = 0;
        byteToShift = getUint8();
      }
      const remainingBitsInByte = 8 - bitIndex;
      const bitsToReadNow = Math.min(bits - bitsCollected, remainingBitsInByte);
      const mask = (1 << bitsToReadNow) - 1;
      const shift = remainingBitsInByte - bitsToReadNow;
      result <<= bitsToReadNow;
      result |= byteToShift >> shift & mask;
      bitsCollected += bitsToReadNow;
      bitIndex += bitsToReadNow;
    }
    return result;
  };
  return {
    startReadingBits,
    stopReadingBits,
    skipTo,
    addData,
    counter,
    peekB,
    peekD,
    getBits,
    bytesRemaining,
    leb128,
    removeBytesRead,
    discard,
    getEightByteNumber,
    getFourByteNumber,
    getSlice,
    getAtom: () => {
      const atom = getSlice(4);
      return new TextDecoder().decode(atom);
    },
    detectFileType: () => {
      return detectFileType(getUint8Array());
    },
    getPaddedFourByteNumber,
    getMatroskaSegmentId: () => {
      if (bytesRemaining() === 0) {
        return null;
      }
      const first = getSlice(1);
      const firstOneString = `0x${Array.from(new Uint8Array(first)).map((b) => {
        return b.toString(16).padStart(2, "0");
      }).join("")}`;
      if (knownIdsWithOneLength.includes(firstOneString)) {
        return firstOneString;
      }
      if (bytesRemaining() === 0) {
        return null;
      }
      const firstTwo = getSlice(1);
      const firstTwoString = `${firstOneString}${Array.from(new Uint8Array(firstTwo)).map((b) => {
        return b.toString(16).padStart(2, "0");
      }).join("")}`;
      if (knownIdsWithTwoLength.includes(firstTwoString)) {
        return firstTwoString;
      }
      if (bytesRemaining() === 0) {
        return null;
      }
      const firstThree = getSlice(1);
      const firstThreeString = `${firstTwoString}${Array.from(new Uint8Array(firstThree)).map((b) => {
        return b.toString(16).padStart(2, "0");
      }).join("")}`;
      if (knownIdsWithThreeLength.includes(firstThreeString)) {
        return firstThreeString;
      }
      if (bytesRemaining() === 0) {
        return null;
      }
      const segmentId = getSlice(1);
      return `${firstThreeString}${Array.from(new Uint8Array(segmentId)).map((b) => {
        return b.toString(16).padStart(2, "0");
      }).join("")}`;
    },
    getVint: () => {
      if (bytesRemaining() === 0) {
        return null;
      }
      const firstByte = getUint8();
      const totalLength = firstByte;
      if (totalLength === 0) {
        return 0;
      }
      let actualLength = 0;
      while ((totalLength >> 7 - actualLength & 1) === 0) {
        actualLength++;
      }
      if (bytesRemaining() < actualLength) {
        return null;
      }
      const slice = getSlice(actualLength);
      const d = [firstByte, ...Array.from(new Uint8Array(slice))];
      actualLength += 1;
      let value = 0;
      value = totalLength & 255 >> actualLength;
      for (let i = 1;i < actualLength; i++) {
        value = value << 8 | d[i];
      }
      if (value === -1) {
        return Infinity;
      }
      return value;
    },
    getUint8,
    getEBML: () => {
      const val = getUint8();
      const actualValue = val & 127;
      return actualValue;
    },
    getInt8: () => {
      const val = getView().getInt8(counter.getDiscardedOffset());
      counter.increment(1);
      return val;
    },
    getUint16: () => {
      const val = getView().getUint16(counter.getDiscardedOffset());
      counter.increment(2);
      return val;
    },
    getUint16Le: () => {
      const val = getView().getUint16(counter.getDiscardedOffset(), true);
      counter.increment(2);
      return val;
    },
    getUint24: () => {
      const val1 = getView().getUint8(counter.getDiscardedOffset());
      const val2 = getView().getUint8(counter.getDiscardedOffset() + 1);
      const val3 = getView().getUint8(counter.getDiscardedOffset() + 2);
      counter.increment(3);
      return val1 << 16 | val2 << 8 | val3;
    },
    getInt24: () => {
      const val1 = getView().getInt8(counter.getDiscardedOffset());
      const val2 = getView().getUint8(counter.getDiscardedOffset() + 1);
      const val3 = getView().getUint8(counter.getDiscardedOffset() + 2);
      counter.increment(3);
      return val1 << 16 | val2 << 8 | val3;
    },
    getInt16: () => {
      const val = getView().getInt16(counter.getDiscardedOffset());
      counter.increment(2);
      return val;
    },
    getUint32,
    getUint64,
    getInt64,
    getFixedPointUnsigned1616Number: () => {
      const val = getUint32();
      return val / 2 ** 16;
    },
    getFixedPointSigned1616Number: () => {
      const val = getInt32();
      return val / 2 ** 16;
    },
    getFixedPointSigned230Number: () => {
      const val = getInt32();
      return val / 2 ** 30;
    },
    getPascalString: () => {
      const val = getSlice(32);
      return [...Array.from(new Uint8Array(val))];
    },
    getUint(length) {
      const bytes = getSlice(length);
      const numbers = [...Array.from(new Uint8Array(bytes))];
      return numbers.reduce((acc, byte, index) => acc + (byte << 8 * (numbers.length - index - 1)), 0);
    },
    getByteString(length, trimTrailingZeroes) {
      let bytes = getSlice(length);
      while (trimTrailingZeroes && bytes[bytes.length - 1] === 0) {
        bytes = bytes.slice(0, -1);
      }
      return new TextDecoder().decode(bytes).trim();
    },
    planBytes: (size4) => {
      const currentOffset = counter.getOffset();
      return {
        discardRest: () => {
          const toDiscard = size4 - (counter.getOffset() - currentOffset);
          if (toDiscard < 0) {
            throw new Error("read too many bytes");
          }
          return getSlice(toDiscard);
        }
      };
    },
    getFloat64: () => {
      const val = getView().getFloat64(counter.getDiscardedOffset());
      counter.increment(8);
      return val;
    },
    readUntilNullTerminator,
    getFloat32: () => {
      const val = getView().getFloat32(counter.getDiscardedOffset());
      counter.increment(4);
      return val;
    },
    getUint32Le,
    getInt32Le,
    getInt32,
    destroy,
    startBox,
    readExpGolomb,
    startCheckpoint,
    getFlacCodecNumber,
    readUntilLineEnd,
    getSyncSafeInt32,
    replaceData
  };
};
var toUnixTimestamp = (value) => {
  if (value === 0) {
    return null;
  }
  const baseDate = new Date("1904-01-01T00:00:00Z");
  return Math.floor(value + baseDate.getTime() / 1000) * 1000;
};
var parseMvhd = ({
  iterator,
  offset,
  size: size4
}) => {
  const version = iterator.getUint8();
  iterator.discard(3);
  const creationTime = version === 1 ? iterator.getUint64() : iterator.getUint32();
  const modificationTime = version === 1 ? iterator.getUint64() : iterator.getUint32();
  const timeScale = iterator.getUint32();
  const durationInUnits = version === 1 ? iterator.getUint64() : iterator.getUint32();
  const durationInSeconds = Number(durationInUnits) / timeScale;
  const rateArray = iterator.getSlice(4);
  const rateView = getArrayBufferIterator({
    initialData: rateArray,
    maxBytes: rateArray.length,
    logLevel: "error"
  });
  const rate = rateView.getInt8() * 10 + rateView.getInt8() + rateView.getInt8() * 0.1 + rateView.getInt8() * 0.01;
  const volumeArray = iterator.getSlice(2);
  const volumeView = getArrayBufferIterator({
    initialData: volumeArray,
    maxBytes: volumeArray.length,
    logLevel: "error"
  });
  const volume = volumeView.getInt8() + volumeView.getInt8() * 0.1;
  iterator.discard(2);
  iterator.discard(4);
  iterator.discard(4);
  const matrix = [
    iterator.getFixedPointSigned1616Number(),
    iterator.getFixedPointSigned1616Number(),
    iterator.getFixedPointSigned230Number(),
    iterator.getFixedPointSigned1616Number(),
    iterator.getFixedPointSigned1616Number(),
    iterator.getFixedPointSigned230Number(),
    iterator.getFixedPointSigned1616Number(),
    iterator.getFixedPointSigned1616Number(),
    iterator.getFixedPointSigned230Number()
  ];
  iterator.discard(4 * 6);
  const nextTrackId = iterator.getUint32();
  volumeView.destroy();
  const bytesRemaining = size4 - (iterator.counter.getOffset() - offset);
  if (bytesRemaining !== 0) {
    throw new Error("expected 0 bytes " + bytesRemaining);
  }
  return {
    creationTime: toUnixTimestamp(Number(creationTime)),
    modificationTime: toUnixTimestamp(Number(modificationTime)),
    timeScale,
    durationInUnits: Number(durationInUnits),
    durationInSeconds,
    rate,
    volume,
    matrix,
    nextTrackId,
    type: "mvhd-box",
    boxSize: size4,
    offset
  };
};
var getCodecStringFromSpsAndPps = (sps) => {
  return `avc1.${sps.spsData.profile.toString(16).padStart(2, "0")}${sps.spsData.compatibility.toString(16).padStart(2, "0")}${sps.spsData.level.toString(16).padStart(2, "0")}`;
};
var combineUint8Arrays = (arrays) => {
  if (arrays.length === 0) {
    return new Uint8Array([]);
  }
  if (arrays.length === 1) {
    return arrays[0];
  }
  let totalLength = 0;
  for (const array of arrays) {
    totalLength += array.length;
  }
  const result = new Uint8Array(totalLength);
  let offset = 0;
  for (const array of arrays) {
    result.set(array, offset);
    offset += array.length;
  }
  return result;
};
function truthy(value) {
  return Boolean(value);
}
function serializeUint16(value) {
  const buffer = new ArrayBuffer(2);
  const view = new DataView(buffer);
  view.setUint16(0, value);
  return new Uint8Array(buffer);
}
var createSpsPpsData = (avc1Profile) => {
  return combineUint8Arrays([
    new Uint8Array([
      1,
      avc1Profile.sps.spsData.profile,
      avc1Profile.sps.spsData.compatibility,
      avc1Profile.sps.spsData.level,
      255,
      225
    ]),
    serializeUint16(avc1Profile.sps.sps.length),
    avc1Profile.sps.sps,
    new Uint8Array([1]),
    serializeUint16(avc1Profile.pps.pps.length),
    avc1Profile.pps.pps,
    [66, 77, 88].some((b) => avc1Profile.sps.spsData.profile === b) ? null : new Uint8Array([253, 248, 248, 0])
  ].filter(truthy));
};
var addAvcProfileToTrack = (track, avc1Profile) => {
  if (avc1Profile === null) {
    return track;
  }
  return {
    ...track,
    codec: getCodecStringFromSpsAndPps(avc1Profile.sps),
    codecData: { type: "avc-sps-pps", data: createSpsPpsData(avc1Profile) },
    description: undefined
  };
};
var registerVideoTrack = async ({
  track,
  container: container42,
  logLevel,
  onVideoTrack,
  registerVideoSampleCallback,
  tracks: tracks2
}) => {
  if (tracks2.getTracks().find((t) => t.trackId === track.trackId)) {
    Log.trace(logLevel, `Track ${track.trackId} already registered, skipping`);
    return null;
  }
  if (track.type !== "video") {
    throw new Error("Expected video track");
  }
  tracks2.addTrack(track);
  if (!onVideoTrack) {
    return null;
  }
  const callback = await onVideoTrack({
    track,
    container: container42
  });
  await registerVideoSampleCallback(track.trackId, callback ?? null);
  return callback;
};
var registerAudioTrack = async ({
  track,
  container: container42,
  tracks: tracks2,
  logLevel,
  onAudioTrack,
  registerAudioSampleCallback
}) => {
  if (tracks2.getTracks().find((t) => t.trackId === track.trackId)) {
    Log.trace(logLevel, `Track ${track.trackId} already registered, skipping`);
    return null;
  }
  if (track.type !== "audio") {
    throw new Error("Expected audio track");
  }
  tracks2.addTrack(track);
  if (!onAudioTrack) {
    return null;
  }
  const callback = await onAudioTrack({
    track,
    container: container42
  });
  await registerAudioSampleCallback(track.trackId, callback ?? null);
  return callback;
};
var registerVideoTrackWhenProfileIsAvailable = ({
  state,
  track,
  container: container42
}) => {
  state.riff.registerOnAvcProfileCallback(async (profile) => {
    await registerVideoTrack({
      track: addAvcProfileToTrack(track, profile),
      container: container42,
      logLevel: state.logLevel,
      onVideoTrack: state.onVideoTrack,
      registerVideoSampleCallback: state.callbacks.registerVideoSampleCallback,
      tracks: state.callbacks.tracks
    });
  });
};
var makeSkip = (skipTo) => ({
  action: "skip",
  skipTo
});
var makeFetchMoreData = (bytesNeeded) => ({
  action: "fetch-more-data",
  bytesNeeded
});
var parseElst = ({
  iterator,
  size: size4,
  offset
}) => {
  const { expectNoMoreBytes } = iterator.startBox(size4 - 8);
  const version = iterator.getUint8();
  const flags = iterator.getUint24();
  const entryCount = iterator.getUint32();
  const entries = [];
  for (let i = 0;i < entryCount; i++) {
    const editDuration = Number(version === 1 ? iterator.getUint64() : iterator.getUint32());
    const mediaTime = Number(version === 1 ? iterator.getUint64() : iterator.getInt32());
    const mediaRateInteger = iterator.getUint16();
    const mediaRateFraction = iterator.getUint16();
    entries.push({
      editDuration,
      mediaTime,
      mediaRateInteger,
      mediaRateFraction
    });
  }
  expectNoMoreBytes();
  const result = {
    type: "elst-box",
    version,
    flags,
    entries,
    boxSize: size4,
    offset
  };
  return result;
};
var parseDecoderSpecificConfig = (iterator) => {
  const layerTag = iterator.getUint8();
  const layerSize = iterator.getPaddedFourByteNumber();
  const start = iterator.counter.getOffset();
  if (layerTag !== 5) {
    iterator.discard(layerSize);
    return {
      type: "unknown-decoder-specific-config"
    };
  }
  const bytes = iterator.getSlice(layerSize);
  iterator.counter.decrement(layerSize);
  iterator.startReadingBits();
  const audioObjectType = iterator.getBits(5);
  const samplingFrequencyIndex = iterator.getBits(4);
  if (samplingFrequencyIndex === 15) {
    iterator.getBits(24);
  }
  const channelConfiguration = iterator.getBits(4);
  iterator.stopReadingBits();
  const read = iterator.counter.getOffset() - start;
  if (read < layerSize) {
    iterator.discard(layerSize - read);
  }
  return {
    type: "mp4a-specific-config",
    audioObjectType,
    samplingFrequencyIndex,
    channelConfiguration,
    asBytes: bytes
  };
};
var mapToObjectAudioIndicator = (num) => {
  if (num === 64) {
    return "aac";
  }
  if (num === 107) {
    return "mp3";
  }
  return "unknown";
};
var processDescriptor = ({
  iterator
}) => {
  const tag = iterator.getUint8();
  if (tag === 4) {
    const size4 = iterator.getPaddedFourByteNumber();
    const initialOffset = iterator.counter.getOffset();
    const objectTypeIndication = iterator.getUint8();
    iterator.startReadingBits();
    const streamType = iterator.getBits(6);
    const upStream = iterator.getBits(1);
    iterator.getBits(1);
    const bufferSizeDB = iterator.getBits(24);
    iterator.stopReadingBits();
    const maxBitrate = iterator.getUint32();
    const avgBitrate = iterator.getUint32();
    const decoderSpecificConfigs = [];
    while (size4 - (iterator.counter.getOffset() - initialOffset) > 0) {
      const decoderSpecificConfig = parseDecoderSpecificConfig(iterator);
      decoderSpecificConfigs.push(decoderSpecificConfig);
    }
    return {
      descriptor: {
        type: "decoder-config-descriptor",
        objectTypeIndication: mapToObjectAudioIndicator(objectTypeIndication),
        asNumber: objectTypeIndication,
        bufferSizeDB,
        streamType,
        upStream,
        avgBitrate,
        maxBitrate,
        decoderSpecificConfigs
      }
    };
  }
  if (tag === 6) {
    const size4 = iterator.getPaddedFourByteNumber();
    iterator.discard(size4);
    return {
      descriptor: {
        type: "sl-config-descriptor"
      }
    };
  }
  return {
    descriptor: null
  };
};
var parseDescriptors = (iterator, maxBytes) => {
  const descriptors = [];
  const initialOffset = iterator.counter.getOffset();
  while (iterator.bytesRemaining() > 0 && iterator.counter.getOffset() - initialOffset < maxBytes) {
    const { descriptor } = processDescriptor({
      iterator
    });
    if (descriptor) {
      descriptors.push(descriptor);
    } else {
      break;
    }
  }
  return descriptors;
};
var parseEsds = ({
  data,
  size: size4,
  fileOffset
}) => {
  const version = data.getUint8();
  data.discard(3);
  const tag = data.getUint8();
  const sizeOfInstance = data.getPaddedFourByteNumber();
  const esId = data.getUint16();
  data.discard(1);
  const remaining = size4 - (data.counter.getOffset() - fileOffset);
  const descriptors = parseDescriptors(data, remaining);
  const remainingNow = size4 - (data.counter.getOffset() - fileOffset);
  data.discard(remainingNow);
  return {
    type: "esds-box",
    version,
    tag,
    sizeOfInstance,
    esId,
    descriptors
  };
};
var precomputedMoofState = () => {
  let moofBoxes = [];
  return {
    getMoofBoxes: () => moofBoxes,
    setMoofBoxes: (boxes) => {
      moofBoxes = boxes;
    }
  };
};
var toMoofBox = (box2) => {
  if (box2.type !== "regular-box") {
    throw new Error("expected regular bpx");
  }
  return {
    offset: box2.offset,
    trafBoxes: box2.children.filter((c) => c.type === "regular-box" && c.boxType === "traf"),
    size: box2.boxSize
  };
};
var deduplicateMoofBoxesByOffset = (moofBoxes) => {
  return moofBoxes.filter((m, i, arr) => i === arr.findIndex((t) => t.offset === m.offset));
};
var getMoovFromFromIsoStructure = (structure) => {
  const moovBox = structure.boxes.find((s) => s.type === "moov-box");
  if (!moovBox || moovBox.type !== "moov-box") {
    return null;
  }
  return moovBox;
};
var getMoovBoxFromState = ({
  structureState,
  isoState,
  mp4HeaderSegment,
  mayUsePrecomputed
}) => {
  const got = isoState.moov.getMoovBoxAndPrecomputed();
  if (got && (mayUsePrecomputed || !got.precomputed)) {
    return got.moovBox;
  }
  if (mp4HeaderSegment) {
    return getMoovFromFromIsoStructure(mp4HeaderSegment);
  }
  const structure = structureState.getIsoStructure();
  return getMoovFromFromIsoStructure(structure);
};
var getMoofBoxes = (main) => {
  const moofBoxes = main.filter((s) => s.type === "regular-box" && s.boxType === "moof");
  return moofBoxes.map((m) => toMoofBox(m));
};
var getMvhdBox = (moovBox) => {
  const mvHdBox = moovBox.children.find((s) => s.type === "mvhd-box");
  if (!mvHdBox || mvHdBox.type !== "mvhd-box") {
    return null;
  }
  return mvHdBox;
};
var getTraks = (moovBox) => {
  return moovBox.children.filter((s) => s.type === "trak-box");
};
var getTkhdBox = (trakBox) => {
  const tkhdBox = trakBox.children.find((s) => s.type === "tkhd-box");
  return tkhdBox;
};
var getMdiaBox = (trakBox) => {
  const mdiaBox = trakBox.children.find((s) => s.type === "regular-box" && s.boxType === "mdia");
  if (!mdiaBox || mdiaBox.type !== "regular-box") {
    return null;
  }
  return mdiaBox;
};
var getMdhdBox = (trakBox) => {
  const mdiaBox = getMdiaBox(trakBox);
  if (!mdiaBox) {
    return null;
  }
  const mdhdBox = mdiaBox.children.find((c) => c.type === "mdhd-box");
  return mdhdBox;
};
var getStblBox = (trakBox) => {
  const mdiaBox = getMdiaBox(trakBox);
  if (!mdiaBox) {
    return null;
  }
  const minfBox = mdiaBox.children.find((s) => s.type === "regular-box" && s.boxType === "minf");
  if (!minfBox || minfBox.type !== "regular-box") {
    return null;
  }
  const stblBox = minfBox.children.find((s) => s.type === "regular-box" && s.boxType === "stbl");
  if (!stblBox || stblBox.type !== "regular-box") {
    return null;
  }
  return stblBox;
};
var getStsdBox = (trakBox) => {
  const stblBox = getStblBox(trakBox);
  if (!stblBox || stblBox.type !== "regular-box") {
    return null;
  }
  const stsdBox = stblBox.children.find((s) => s.type === "stsd-box");
  return stsdBox;
};
var getVideoDescriptors = (trakBox) => {
  const stsdBox = getStsdBox(trakBox);
  if (!stsdBox) {
    return null;
  }
  const descriptors = stsdBox.samples.map((s) => {
    return s.type === "video" ? s.descriptors.map((d) => {
      return d.type === "avcc-box" ? d.privateData : d.type === "hvcc-box" ? d.privateData : null;
    }) : [];
  });
  return descriptors.flat(1).filter(Boolean)[0] ?? null;
};
var getStcoBox = (trakBox) => {
  const stblBox = getStblBox(trakBox);
  if (!stblBox || stblBox.type !== "regular-box") {
    return null;
  }
  const stcoBox = stblBox.children.find((s) => s.type === "stco-box");
  return stcoBox;
};
var getSttsBox = (trakBox) => {
  const stblBox = getStblBox(trakBox);
  if (!stblBox || stblBox.type !== "regular-box") {
    return null;
  }
  const sttsBox = stblBox.children.find((s) => s.type === "stts-box");
  return sttsBox;
};
var getCttsBox = (trakBox) => {
  const stblBox = getStblBox(trakBox);
  if (!stblBox || stblBox.type !== "regular-box") {
    return null;
  }
  const cttsBox = stblBox.children.find((s) => s.type === "ctts-box");
  return cttsBox;
};
var getStszBox = (trakBox) => {
  const stblBox = getStblBox(trakBox);
  if (!stblBox || stblBox.type !== "regular-box") {
    return null;
  }
  const stszBox = stblBox.children.find((s) => s.type === "stsz-box");
  return stszBox;
};
var getStscBox = (trakBox) => {
  const stblBox = getStblBox(trakBox);
  if (!stblBox || stblBox.type !== "regular-box") {
    return null;
  }
  const stcoBox = stblBox.children.find((b) => b.type === "stsc-box");
  return stcoBox;
};
var getStssBox = (trakBox) => {
  const stblBox = getStblBox(trakBox);
  if (!stblBox || stblBox.type !== "regular-box") {
    return null;
  }
  const stssBox = stblBox.children.find((b) => b.type === "stss-box");
  return stssBox;
};
var getTfdtBox = (segment) => {
  if (segment.type !== "regular-box" || segment.boxType !== "traf") {
    throw new Error("Expected traf-box");
  }
  const tfhdBox = segment.children.find((c) => c.type === "tfdt-box");
  if (!tfhdBox || tfhdBox.type !== "tfdt-box") {
    throw new Error("Expected tfhd-box");
  }
  return tfhdBox;
};
var getTfhdBox = (segment) => {
  if (segment.type !== "regular-box" || segment.boxType !== "traf") {
    throw new Error("Expected traf-box");
  }
  const tfhdBox = segment.children.find((c) => c.type === "tfhd-box");
  if (!tfhdBox || tfhdBox.type !== "tfhd-box") {
    throw new Error("Expected tfhd-box");
  }
  return tfhdBox;
};
var getTrunBoxes = (segment) => {
  if (segment.type !== "regular-box" || segment.boxType !== "traf") {
    throw new Error("Expected traf-box");
  }
  const trunBoxes = segment.children.filter((c) => c.type === "trun-box");
  return trunBoxes;
};
var getMvexBox = (moovAtom) => {
  const mvexBox = moovAtom.children.find((s) => s.type === "regular-box" && s.boxType === "mvex");
  if (!mvexBox || mvexBox.type !== "regular-box") {
    return null;
  }
  return mvexBox;
};
var getTrexBoxes = (moovAtom) => {
  const mvexBox = getMvexBox(moovAtom);
  if (!mvexBox) {
    return [];
  }
  const trexBoxes = mvexBox.children.filter((c) => c.type === "trex-box");
  return trexBoxes;
};
var getTfraBoxesFromMfraBoxChildren = (mfraBoxChildren) => {
  const tfraBoxes = mfraBoxChildren.filter((b) => b.type === "tfra-box");
  return tfraBoxes;
};
var getTfraBoxes = (structure) => {
  const mfraBox = structure.find((b) => b.type === "regular-box" && b.boxType === "mfra");
  if (!mfraBox) {
    return [];
  }
  return getTfraBoxesFromMfraBoxChildren(mfraBox.children);
};
var getTrakBoxByTrackId = (moovBox, trackId) => {
  const trakBoxes = getTraks(moovBox);
  return trakBoxes.find((t) => {
    const tkhd = getTkhdBox(t);
    if (!tkhd) {
      return false;
    }
    return tkhd.trackId === trackId;
  }) ?? null;
};
var getElstBox = (trakBox) => {
  const edtsBox = trakBox.children.find((s) => s.type === "regular-box" && s.boxType === "edts");
  if (!edtsBox || edtsBox.type !== "regular-box") {
    return null;
  }
  const elstBox = edtsBox.children.find((s) => s.type === "elst-box");
  return elstBox;
};
var findTrackStartTimeInSeconds = ({
  movieTimeScale,
  trakBox
}) => {
  const elstBox = getElstBox(trakBox);
  if (!elstBox) {
    return 0;
  }
  const { entries } = elstBox;
  let dwellTime = 0;
  for (const entry of entries) {
    const { editDuration, mediaTime } = entry;
    if (mediaTime !== -1) {
      continue;
    }
    dwellTime += editDuration;
  }
  return dwellTime / movieTimeScale;
};
var findTrackMediaTimeOffsetInTrackTimescale = ({
  trakBox
}) => {
  const elstBox = getElstBox(trakBox);
  if (!elstBox) {
    return 0;
  }
  const { entries } = elstBox;
  let dwellTime = 0;
  for (const entry of entries) {
    const { mediaTime } = entry;
    if (mediaTime === -1) {
      continue;
    }
    dwellTime += mediaTime;
  }
  return dwellTime;
};
var WEBCODECS_TIMESCALE = 1e6;
var MEDIA_PARSER_RIFF_TIMESCALE = 1e6;
var isRiffAvi2 = (structure) => {
  return structure.boxes.some((box2) => box2.type === "riff-header" && box2.fileType === "AVI");
};
var getHdlrBox = (structure) => {
  return structure.boxes.find((box2) => box2.type === "list-box" && box2.listType === "hdrl");
};
var getAvihBox = (structure) => {
  const hdlrBox = getHdlrBox(structure);
  if (!hdlrBox) {
    return null;
  }
  return hdlrBox.children.find((box2) => box2.type === "avih-box");
};
var getStrlBoxes = (structure) => {
  const hdlrBox = getHdlrBox(structure);
  if (!hdlrBox) {
    return [];
  }
  return hdlrBox.children.filter((box2) => box2.type === "list-box" && box2.listType === "strl");
};
var getStrhBox = (strlBoxChildren) => {
  return strlBoxChildren.find((box2) => box2.type === "strh-box");
};
var TO_BE_OVERRIDDEN_LATER = "to-be-overriden-later";
var getNumberOfTracks = (structure) => {
  const avihBox = getAvihBox(structure);
  if (avihBox) {
    return avihBox.streams;
  }
  throw new Error("No avih box found");
};
var makeAviAudioTrack = ({
  strf,
  index
}) => {
  if (strf.formatTag !== 255) {
    throw new Error(`Unsupported audio format ${strf.formatTag}`);
  }
  return {
    type: "audio",
    codec: "mp4a.40.2",
    codecData: { type: "aac-config", data: new Uint8Array([18, 16]) },
    codecEnum: "aac",
    description: new Uint8Array([18, 16]),
    numberOfChannels: strf.numberOfChannels,
    sampleRate: strf.sampleRate,
    originalTimescale: MEDIA_PARSER_RIFF_TIMESCALE,
    trackId: index,
    startInSeconds: 0,
    timescale: WEBCODECS_TIMESCALE,
    trackMediaTimeOffsetInTrackTimescale: 0
  };
};
var makeAviVideoTrack = ({
  strh,
  strf,
  index
}) => {
  if (strh.handler !== "H264") {
    throw new Error(`Unsupported video codec ${strh.handler}`);
  }
  return {
    codecData: null,
    codec: TO_BE_OVERRIDDEN_LATER,
    codecEnum: "h264",
    codedHeight: strf.height,
    codedWidth: strf.width,
    width: strf.width,
    height: strf.height,
    type: "video",
    displayAspectHeight: strf.height,
    originalTimescale: MEDIA_PARSER_RIFF_TIMESCALE,
    description: undefined,
    m3uStreamFormat: null,
    trackId: index,
    colorSpace: {
      fullRange: null,
      matrix: null,
      primaries: null,
      transfer: null
    },
    advancedColor: {
      fullRange: null,
      matrix: null,
      primaries: null,
      transfer: null
    },
    displayAspectWidth: strf.width,
    rotation: 0,
    sampleAspectRatio: {
      numerator: 1,
      denominator: 1
    },
    fps: strh.rate / strh.scale,
    startInSeconds: 0,
    timescale: WEBCODECS_TIMESCALE,
    trackMediaTimeOffsetInTrackTimescale: 0
  };
};
var getTracksFromAvi = (structure, state) => {
  const tracks2 = [];
  const boxes = getStrlBoxes(structure);
  let i = 0;
  for (const box2 of boxes) {
    const strh = getStrhBox(box2.children);
    if (!strh) {
      continue;
    }
    const { strf } = strh;
    if (strf.type === "strf-box-video") {
      tracks2.push(addAvcProfileToTrack(makeAviVideoTrack({ strh, strf, index: i }), state.riff.getAvcProfile()));
    } else if (strh.fccType === "auds") {
      tracks2.push(makeAviAudioTrack({ strf, index: i }));
    } else {
      throw new Error(`Unsupported track type ${strh.fccType}`);
    }
    i++;
  }
  return tracks2;
};
var hasAllTracksFromAvi = (state) => {
  try {
    const structure = state.structure.getRiffStructure();
    const numberOfTracks = getNumberOfTracks(structure);
    const tracks2 = getTracksFromAvi(structure, state);
    return tracks2.length === numberOfTracks && !tracks2.find((t) => t.type === "video" && t.codec === TO_BE_OVERRIDDEN_LATER);
  } catch {
    return false;
  }
};
var findProgramAssociationTableOrThrow = (structure) => {
  const box2 = structure.boxes.find((b) => b.type === "transport-stream-pat-box");
  if (!box2) {
    throw new Error("No PAT box found");
  }
  return box2;
};
var findProgramMapOrNull = (structure) => {
  const box2 = structure.boxes.find((b) => b.type === "transport-stream-pmt-box");
  if (!box2) {
    return null;
  }
  return box2;
};
var findProgramMapTableOrThrow = (structure) => {
  const box2 = findProgramMapOrNull(structure);
  if (!box2) {
    throw new Error("No PMT box found");
  }
  return box2;
};
var getProgramForId = (structure, packetIdentifier) => {
  const box2 = findProgramAssociationTableOrThrow(structure);
  const entry = box2.pat.find((e) => e.programMapIdentifier === packetIdentifier);
  return entry ?? null;
};
var getStreamForId = (structure, packetIdentifier) => {
  const box2 = findProgramMapTableOrThrow(structure);
  const entry = box2.streams.find((e) => e.pid === packetIdentifier);
  return entry ?? null;
};
var filterStreamsBySupportedTypes = (streams) => {
  return streams.filter((stream) => stream.streamType === 27 || stream.streamType === 15);
};
var getTracksFromTransportStream = (parserState) => {
  const structure = parserState.structure.getTsStructure();
  const programMapTable = findProgramMapTableOrThrow(structure);
  const parserTracks = parserState.callbacks.tracks.getTracks();
  const mapped = filterStreamsBySupportedTypes(programMapTable.streams).map((stream) => {
    return parserTracks.find((track) => track.trackId === stream.pid);
  }).filter(truthy);
  if (mapped.length !== filterStreamsBySupportedTypes(programMapTable.streams).length) {
    throw new Error("Not all tracks found");
  }
  return mapped;
};
var hasAllTracksFromTransportStream = (parserState) => {
  try {
    getTracksFromTransportStream(parserState);
    return true;
  } catch {
    return false;
  }
};
var getHvc1CodecString = (data) => {
  const configurationVersion = data.getUint8();
  if (configurationVersion !== 1) {
    throw new Error(`Unsupported HVCC version ${configurationVersion}`);
  }
  const generalProfileSpaceTierFlagAndIdc = data.getUint8();
  let generalProfileCompatibility = data.getUint32();
  const generalProfileSpace = generalProfileSpaceTierFlagAndIdc >> 6;
  const generalTierFlag = (generalProfileSpaceTierFlagAndIdc & 32) >> 5;
  const generalProfileIdc = generalProfileSpaceTierFlagAndIdc & 31;
  const generalConstraintIndicator = data.getSlice(6);
  const generalLevelIdc = data.getUint8();
  let profileId = 0;
  for (let i = 0;i < 32; i++) {
    profileId |= generalProfileCompatibility & 1;
    if (i === 31)
      break;
    profileId <<= 1;
    generalProfileCompatibility >>= 1;
  }
  const profileSpaceChar = generalProfileSpace === 0 ? "" : generalProfileSpace === 1 ? "A" : generalProfileSpace === 2 ? "B" : "C";
  const generalTierChar = generalTierFlag === 0 ? "L" : "H";
  let hasByte = false;
  let generalConstraintString = "";
  for (let i = 5;i >= 0; i--) {
    if (generalConstraintIndicator[i] || hasByte) {
      generalConstraintString = generalConstraintIndicator[i].toString(16) + generalConstraintString;
      hasByte = true;
    }
  }
  return `${profileSpaceChar}${generalProfileIdc.toString(16)}.${profileId.toString(16)}.${generalTierChar}${generalLevelIdc}${generalConstraintString ? "." : ""}${generalConstraintString}`;
};
var mediaParserAdvancedColorToWebCodecsColor = (color2) => {
  return {
    transfer: color2.transfer,
    matrix: color2.matrix,
    primaries: color2.primaries,
    fullRange: color2.fullRange
  };
};
var parseAv1PrivateData = (data, colrAtom) => {
  const iterator = getArrayBufferIterator({
    initialData: data,
    maxBytes: data.byteLength,
    logLevel: "error"
  });
  iterator.startReadingBits();
  if (iterator.getBits(1) !== 1) {
    iterator.destroy();
    throw new Error("Expected av1 private data to be version 1");
  }
  const version = iterator.getBits(7);
  if (version !== 1) {
    iterator.destroy();
    throw new Error(`Expected av1 private data to be version 1, got ${version}`);
  }
  let str = "av01.";
  const seqProfile = iterator.getBits(3);
  str += seqProfile;
  str += ".";
  const seq_level_idx = iterator.getBits(5);
  const seq_tier_0 = iterator.getBits(1);
  str += String(seq_level_idx).padStart(2, "0");
  str += seq_tier_0 ? "H" : "M";
  str += ".";
  const high_bitdepth = iterator.getBits(1);
  const twelve_bit = iterator.getBits(1);
  const bitDepth2 = high_bitdepth && seqProfile === 2 ? twelve_bit ? 12 : 10 : high_bitdepth ? 10 : 8;
  str += bitDepth2.toString().padStart(2, "0");
  str += ".";
  const mono_chrome = iterator.getBits(1);
  str += mono_chrome ? "1" : "0";
  str += ".";
  const subsampling_x = iterator.getBits(1);
  str += subsampling_x ? "1" : "0";
  const subsampling_y = iterator.getBits(1);
  str += subsampling_y ? "1" : "0";
  const chroma_sample_position = iterator.getBits(2);
  str += subsampling_x && subsampling_y ? chroma_sample_position === 1 ? "1" : "0" : "0";
  str += ".";
  if (colrAtom && colrAtom.colorType === "transfer-characteristics") {
    str += colrAtom.primaries.toString().padStart(2, "0");
    str += ".";
    str += colrAtom.transfer.toString().padStart(2, "0");
    str += ".";
    str += colrAtom.matrixIndex.toString().padStart(2, "0");
    str += ".";
    str += colrAtom.fullRangeFlag ? "1" : "0";
  } else {
    str += "01";
    str += ".";
    str += "01";
    str += ".";
    str += "01";
    str += ".";
    str += "0";
  }
  const suffix2 = ".0.110.01.01.01.0";
  if (str.endsWith(suffix2)) {
    str = str.slice(0, -suffix2.length);
  }
  iterator.destroy();
  return str;
};
var getMatrixCoefficientsFromIndex = (index) => {
  if (index === 0) {
    return "rgb";
  }
  if (index === 1) {
    return "bt709";
  }
  if (index === 5) {
    return "bt470bg";
  }
  if (index === 6) {
    return "smpte170m";
  }
  if (index === 9) {
    return "bt2020-ncl";
  }
  return null;
};
var getTransferCharacteristicsFromIndex = (index) => {
  if (index === 1) {
    return "bt709";
  }
  if (index === 6) {
    return "smpte170m";
  }
  if (index === 8) {
    return "linear";
  }
  if (index === 13) {
    return "iec61966-2-1";
  }
  if (index === 16) {
    return "pq";
  }
  if (index === 18) {
    return "hlg";
  }
  return null;
};
var getPrimariesFromIndex = (index) => {
  if (index === 1) {
    return "bt709";
  }
  if (index === 5) {
    return "bt470bg";
  }
  if (index === 6) {
    return "smpte170m";
  }
  if (index === 9) {
    return "bt2020";
  }
  if (index === 12) {
    return "smpte432";
  }
  return null;
};
var getMainSegment = (segments) => {
  return segments.find((s) => s.type === "Segment") ?? null;
};
var getTrackCodec = (track) => {
  const child = track.value.find((b) => b.type === "CodecID");
  return child ?? null;
};
var getTrackTimestampScale = (track) => {
  const child = track.value.find((b) => b.type === "TrackTimestampScale");
  if (!child) {
    return null;
  }
  if (child.type !== "TrackTimestampScale") {
    throw new Error("Expected TrackTimestampScale");
  }
  return child.value;
};
var getTrackId = (track) => {
  const trackId = track.value.find((b) => b.type === "TrackNumber");
  if (!trackId || trackId.type !== "TrackNumber") {
    throw new Error("Expected track number segment");
  }
  return trackId.value.value;
};
var getCodecSegment = (track) => {
  const codec = track.value.find((b) => b.type === "CodecID");
  if (!codec || codec.type !== "CodecID") {
    return null;
  }
  return codec;
};
var getColourSegment = (track) => {
  const videoSegment2 = getVideoSegment(track);
  if (!videoSegment2) {
    return null;
  }
  const colour = videoSegment2.value.find((b) => b.type === "Colour");
  if (!colour || colour.type !== "Colour") {
    return null;
  }
  return colour;
};
var getTransferCharacteristicsSegment = (color2) => {
  if (!color2 || color2.type !== "Colour") {
    return null;
  }
  const box2 = color2.value.find((b) => b.type === "TransferCharacteristics");
  if (!box2 || box2.type !== "TransferCharacteristics") {
    return null;
  }
  return box2;
};
var getMatrixCoefficientsSegment = (color2) => {
  if (!color2 || color2.type !== "Colour") {
    return null;
  }
  const box2 = color2.value.find((b) => b.type === "MatrixCoefficients");
  if (!box2 || box2.type !== "MatrixCoefficients") {
    return null;
  }
  return box2;
};
var getPrimariesSegment = (color2) => {
  if (!color2 || color2.type !== "Colour") {
    return null;
  }
  const box2 = color2.value.find((b) => b.type === "Primaries");
  if (!box2 || box2.type !== "Primaries") {
    return null;
  }
  return box2;
};
var getRangeSegment = (color2) => {
  if (!color2 || color2.type !== "Colour") {
    return null;
  }
  const box2 = color2.value.find((b) => b.type === "Range");
  if (!box2 || box2.type !== "Range") {
    return null;
  }
  return box2;
};
var getDisplayHeightSegment = (track) => {
  const videoSegment2 = getVideoSegment(track);
  if (!videoSegment2) {
    return null;
  }
  const displayHeight2 = videoSegment2.value.find((b) => b.type === "DisplayHeight");
  if (!displayHeight2 || displayHeight2.type !== "DisplayHeight") {
    return null;
  }
  return displayHeight2;
};
var getTrackTypeSegment = (track) => {
  const trackType2 = track.value.find((b) => b.type === "TrackType");
  if (!trackType2 || trackType2.type !== "TrackType") {
    return null;
  }
  return trackType2;
};
var getWidthSegment = (track) => {
  const videoSegment2 = getVideoSegment(track);
  if (!videoSegment2) {
    return null;
  }
  const width = videoSegment2.value.find((b) => b.type === "PixelWidth");
  if (!width || width.type !== "PixelWidth") {
    return null;
  }
  return width;
};
var getHeightSegment = (track) => {
  const videoSegment2 = getVideoSegment(track);
  if (!videoSegment2) {
    return null;
  }
  const height = videoSegment2.value.find((b) => b.type === "PixelHeight");
  if (!height || height.type !== "PixelHeight") {
    return null;
  }
  return height;
};
var getDisplayWidthSegment = (track) => {
  const videoSegment2 = getVideoSegment(track);
  if (!videoSegment2) {
    return null;
  }
  const displayWidth2 = videoSegment2.value.find((b) => b.type === "DisplayWidth");
  if (!displayWidth2 || displayWidth2.type !== "DisplayWidth") {
    return null;
  }
  return displayWidth2;
};
var getTracksSegment = (segment) => {
  const tracksSegment = segment.value.find((b) => b.type === "Tracks");
  if (!tracksSegment) {
    return null;
  }
  return tracksSegment;
};
var getTrackWithUid = (segment, trackUid) => {
  const tracksSegment = getTracksSegment(segment);
  if (!tracksSegment) {
    return null;
  }
  const trackEntries = tracksSegment.value.filter((t) => t.type === "TrackEntry");
  const trackEntry2 = trackEntries.find((entry) => {
    return entry?.value.find((t) => t.type === "TrackUID" && t.value === trackUid);
  });
  if (!trackEntry2) {
    return null;
  }
  return trackEntry2.value.find((t) => t.type === "TrackNumber")?.value.value ?? null;
};
var getVideoSegment = (track) => {
  const videoSegment2 = track.value.find((b) => b.type === "Video");
  if (!videoSegment2 || videoSegment2.type !== "Video") {
    return null;
  }
  return videoSegment2 ?? null;
};
var getAudioSegment = (track) => {
  const audioSegment2 = track.value.find((b) => b.type === "Audio");
  if (!audioSegment2 || audioSegment2.type !== "Audio") {
    return null;
  }
  return audioSegment2 ?? null;
};
var getSampleRate = (track) => {
  const audioSegment2 = getAudioSegment(track);
  if (!audioSegment2) {
    return null;
  }
  const samplingFrequency2 = audioSegment2.value.find((b) => b.type === "SamplingFrequency");
  if (!samplingFrequency2 || samplingFrequency2.type !== "SamplingFrequency") {
    return null;
  }
  return samplingFrequency2.value.value;
};
var getNumberOfChannels = (track) => {
  const audioSegment2 = getAudioSegment(track);
  if (!audioSegment2) {
    throw new Error("Could not find audio segment");
  }
  const channels2 = audioSegment2.value.find((b) => b.type === "Channels");
  if (!channels2 || channels2.type !== "Channels") {
    return 1;
  }
  return channels2.value.value;
};
var getBitDepth = (track) => {
  const audioSegment2 = getAudioSegment(track);
  if (!audioSegment2) {
    return null;
  }
  const bitDepth2 = audioSegment2.value.find((b) => b.type === "BitDepth");
  if (!bitDepth2 || bitDepth2.type !== "BitDepth") {
    return null;
  }
  return bitDepth2.value.value;
};
var getPrivateData = (track) => {
  const privateData = track.value.find((b) => b.type === "CodecPrivate");
  if (!privateData || privateData.type !== "CodecPrivate") {
    return null;
  }
  return privateData.value;
};
var parseColorSegment = (colourSegment) => {
  const transferCharacteristics2 = getTransferCharacteristicsSegment(colourSegment);
  const matrixCoefficients2 = getMatrixCoefficientsSegment(colourSegment);
  const primaries2 = getPrimariesSegment(colourSegment);
  const range2 = getRangeSegment(colourSegment);
  return {
    transfer: transferCharacteristics2 ? getTransferCharacteristicsFromIndex(transferCharacteristics2.value.value) : null,
    matrix: matrixCoefficients2 ? getMatrixCoefficientsFromIndex(matrixCoefficients2.value.value) : null,
    primaries: primaries2 ? getPrimariesFromIndex(primaries2.value.value) : null,
    fullRange: transferCharacteristics2?.value.value && matrixCoefficients2?.value.value ? null : range2 ? Boolean(range2?.value.value) : null
  };
};
var getAudioDescription = (track) => {
  const codec = getCodecSegment(track);
  if (!codec || codec.value !== "A_VORBIS") {
    return;
  }
  const privateData = getPrivateData(track);
  if (!privateData) {
    return;
  }
  if (privateData[0] !== 2) {
    throw new Error("Expected vorbis private data version 2");
  }
  let offset = 1;
  let vorbisInfoLength = 0;
  let vorbisSkipLength = 0;
  while ((privateData[offset] & 255) === 255) {
    vorbisInfoLength += 255;
    offset++;
  }
  vorbisInfoLength += privateData[offset++] & 255;
  while ((privateData[offset] & 255) === 255) {
    vorbisSkipLength += 255;
    offset++;
  }
  vorbisSkipLength += privateData[offset++] & 255;
  if (privateData[offset] !== 1) {
    throw new Error("Error parsing vorbis codec private");
  }
  const vorbisInfo = privateData.slice(offset, offset + vorbisInfoLength);
  offset += vorbisInfoLength;
  if (privateData[offset] !== 3) {
    throw new Error("Error parsing vorbis codec private");
  }
  const vorbisComments = privateData.slice(offset, offset + vorbisSkipLength);
  offset += vorbisSkipLength;
  if (privateData[offset] !== 5) {
    throw new Error("Error parsing vorbis codec private");
  }
  const vorbisBooks = privateData.slice(offset);
  const bufferIterator = getArrayBufferIterator({
    initialData: vorbisInfo.slice(0),
    maxBytes: vorbisInfo.length,
    logLevel: "error"
  });
  bufferIterator.getUint8();
  const vorbis = bufferIterator.getByteString(6, false);
  if (vorbis !== "vorbis") {
    throw new Error("Error parsing vorbis codec private");
  }
  const vorbisVersion = bufferIterator.getUint32Le();
  if (vorbisVersion !== 0) {
    throw new Error("Error parsing vorbis codec private");
  }
  const vorbisDescription = new Uint8Array([
    2,
    vorbisInfo.length,
    vorbisComments.length,
    ...vorbisInfo,
    ...vorbisComments,
    ...vorbisBooks
  ]);
  return vorbisDescription;
};
var trackTypeToString = (trackType2) => {
  switch (trackType2) {
    case 1:
      return "video";
    case 2:
      return "audio";
    case 3:
      return "complex";
    case 4:
      return "subtitle";
    case 5:
      return "button";
    case 6:
      return "control";
    case 7:
      return "metadata";
    default:
      throw new Error(`Unknown track type: ${trackType2}`);
  }
};
var NO_CODEC_PRIVATE_SHOULD_BE_DERIVED_FROM_SPS = "no-codec-private-should-be-derived-from-sps";
var getDescription = (track) => {
  const codec = getCodecSegment(track);
  if (!codec) {
    return;
  }
  if (codec.value === "V_MPEG4/ISO/AVC" || codec.value === "V_MPEGH/ISO/HEVC") {
    const priv = getPrivateData(track);
    if (priv) {
      return priv;
    }
  }
  return;
};
var getMatroskaVideoCodecEnum = ({
  codecSegment: codec
}) => {
  if (codec.value === "V_VP8") {
    return "vp8";
  }
  if (codec.value === "V_VP9") {
    return "vp9";
  }
  if (codec.value === "V_MPEG4/ISO/AVC") {
    return "h264";
  }
  if (codec.value === "V_AV1") {
    return "av1";
  }
  if (codec.value === "V_MPEGH/ISO/HEVC") {
    return "h265";
  }
  throw new Error(`Unknown codec: ${codec.value}`);
};
var getMatroskaVideoCodecString = ({
  track,
  codecSegment: codec
}) => {
  if (codec.value === "V_VP8") {
    return "vp8";
  }
  if (codec.value === "V_VP9") {
    const priv = getPrivateData(track);
    if (priv) {
      throw new Error("@remotion/media-parser cannot handle the private data for VP9. Do you have an example file you could send so we can implement it? https://remotion.dev/report");
    }
    return "vp09.00.10.08";
  }
  if (codec.value === "V_MPEG4/ISO/AVC") {
    const priv = getPrivateData(track);
    if (priv) {
      return `avc1.${priv[1].toString(16).padStart(2, "0")}${priv[2].toString(16).padStart(2, "0")}${priv[3].toString(16).padStart(2, "0")}`;
    }
    return NO_CODEC_PRIVATE_SHOULD_BE_DERIVED_FROM_SPS;
  }
  if (codec.value === "V_MPEGH/ISO/HEVC") {
    const priv = getPrivateData(track);
    const iterator = getArrayBufferIterator({
      initialData: priv,
      maxBytes: priv.length,
      logLevel: "error"
    });
    return "hvc1." + getHvc1CodecString(iterator);
  }
  if (codec.value === "V_AV1") {
    const priv = getPrivateData(track);
    if (!priv) {
      throw new Error("Expected private data in AV1 track");
    }
    return parseAv1PrivateData(priv, null);
  }
  throw new Error(`Unknown codec: ${codec.value}`);
};
var getMatroskaAudioCodecEnum = ({
  track
}) => {
  const codec = getCodecSegment(track);
  if (!codec) {
    throw new Error("Expected codec segment");
  }
  if (codec.value === "A_OPUS") {
    return "opus";
  }
  if (codec.value === "A_VORBIS") {
    return "vorbis";
  }
  if (codec.value === "A_PCM/INT/LIT") {
    const bitDepth2 = getBitDepth(track);
    if (bitDepth2 === null) {
      throw new Error("Expected bit depth");
    }
    if (bitDepth2 === 8) {
      return "pcm-u8";
    }
    if (bitDepth2 === 16) {
      return "pcm-s16";
    }
    if (bitDepth2 === 24) {
      return "pcm-s24";
    }
    throw new Error("Unknown audio format");
  }
  if (codec.value === "A_AAC") {
    return `aac`;
  }
  if (codec.value === "A_MPEG/L3") {
    return "mp3";
  }
  throw new Error(`Unknown codec: ${codec.value}`);
};
var getMatroskaAudioCodecString = (track) => {
  const codec = getCodecSegment(track);
  if (!codec) {
    throw new Error("Expected codec segment");
  }
  if (codec.value === "A_OPUS") {
    return "opus";
  }
  if (codec.value === "A_VORBIS") {
    return "vorbis";
  }
  if (codec.value === "A_PCM/INT/LIT") {
    const bitDepth2 = getBitDepth(track);
    if (bitDepth2 === null) {
      throw new Error("Expected bit depth");
    }
    if (bitDepth2 === 8) {
      return "pcm-u8";
    }
    return "pcm-s" + bitDepth2;
  }
  if (codec.value === "A_AAC") {
    const priv = getPrivateData(track);
    const iterator = getArrayBufferIterator({
      initialData: priv,
      maxBytes: priv.length,
      logLevel: "error"
    });
    iterator.startReadingBits();
    const profile = iterator.getBits(5);
    iterator.stopReadingBits();
    iterator.destroy();
    return `mp4a.40.${profile.toString().padStart(2, "0")}`;
  }
  if (codec.value === "A_MPEG/L3") {
    return "mp3";
  }
  throw new Error(`Unknown codec: ${codec.value}`);
};
var getTrack = ({
  timescale,
  track
}) => {
  const trackType2 = getTrackTypeSegment(track);
  if (!trackType2) {
    throw new Error("Expected track type segment");
  }
  const trackId = getTrackId(track);
  if (trackTypeToString(trackType2.value.value) === "video") {
    const width = getWidthSegment(track);
    if (width === null) {
      throw new Error("Expected width segment");
    }
    const height = getHeightSegment(track);
    if (height === null) {
      throw new Error("Expected height segment");
    }
    const displayHeight2 = getDisplayHeightSegment(track);
    const displayWidth2 = getDisplayWidthSegment(track);
    const codec = getCodecSegment(track);
    if (!codec) {
      return null;
    }
    const codecPrivate2 = getPrivateData(track);
    const codecString = getMatroskaVideoCodecString({
      track,
      codecSegment: codec
    });
    const colour = getColourSegment(track);
    if (!codecString) {
      return null;
    }
    const codecEnum = getMatroskaVideoCodecEnum({
      codecSegment: codec
    });
    const codecData = codecPrivate2 === null ? null : codecEnum === "h264" ? { type: "avc-sps-pps", data: codecPrivate2 } : codecEnum === "av1" ? {
      type: "av1c-data",
      data: codecPrivate2
    } : codecEnum === "h265" ? {
      type: "hvcc-data",
      data: codecPrivate2
    } : codecEnum === "vp8" ? {
      type: "unknown-data",
      data: codecPrivate2
    } : codecEnum === "vp9" ? {
      type: "unknown-data",
      data: codecPrivate2
    } : null;
    const advancedColor = colour ? parseColorSegment(colour) : {
      fullRange: null,
      matrix: null,
      primaries: null,
      transfer: null
    };
    return {
      m3uStreamFormat: null,
      type: "video",
      trackId,
      codec: codecString,
      description: getDescription(track),
      height: displayHeight2 ? displayHeight2.value.value : height.value.value,
      width: displayWidth2 ? displayWidth2.value.value : width.value.value,
      sampleAspectRatio: {
        numerator: 1,
        denominator: 1
      },
      originalTimescale: timescale,
      codedHeight: height.value.value,
      codedWidth: width.value.value,
      displayAspectHeight: displayHeight2 ? displayHeight2.value.value : height.value.value,
      displayAspectWidth: displayWidth2 ? displayWidth2.value.value : width.value.value,
      rotation: 0,
      codecData,
      colorSpace: mediaParserAdvancedColorToWebCodecsColor(advancedColor),
      advancedColor,
      codecEnum,
      fps: null,
      startInSeconds: 0,
      timescale: WEBCODECS_TIMESCALE,
      trackMediaTimeOffsetInTrackTimescale: 0
    };
  }
  if (trackTypeToString(trackType2.value.value) === "audio") {
    const sampleRate = getSampleRate(track);
    const numberOfChannels = getNumberOfChannels(track);
    const codecPrivate2 = getPrivateData(track);
    if (sampleRate === null) {
      throw new Error("Could not find sample rate or number of channels");
    }
    const codecString = getMatroskaAudioCodecString(track);
    return {
      type: "audio",
      trackId,
      codec: codecString,
      originalTimescale: timescale,
      numberOfChannels,
      sampleRate,
      description: getAudioDescription(track),
      codecData: codecPrivate2 ? codecString === "opus" ? { type: "ogg-identification", data: codecPrivate2 } : { type: "unknown-data", data: codecPrivate2 } : null,
      codecEnum: getMatroskaAudioCodecEnum({
        track
      }),
      startInSeconds: 0,
      timescale: WEBCODECS_TIMESCALE,
      trackMediaTimeOffsetInTrackTimescale: 0
    };
  }
  return null;
};
var getTracksFromMatroska = ({
  structureState,
  webmState
}) => {
  const structure = structureState.getMatroskaStructure();
  const mainSegment = getMainSegment(structure.boxes);
  if (!mainSegment) {
    throw new Error("No main segment");
  }
  const tracksSegment = getTracksSegment(mainSegment);
  if (!tracksSegment) {
    throw new Error("No tracks segment");
  }
  const resolvedTracks = [];
  const missingInfo = [];
  for (const trackEntrySegment of tracksSegment.value) {
    if (trackEntrySegment.type === "Crc32") {
      continue;
    }
    if (trackEntrySegment.type !== "TrackEntry") {
      throw new Error("Expected track entry segment");
    }
    const track = getTrack({
      track: trackEntrySegment,
      timescale: webmState.getTimescale()
    });
    if (!track) {
      continue;
    }
    if (track.codec === NO_CODEC_PRIVATE_SHOULD_BE_DERIVED_FROM_SPS) {
      const avc = webmState.getAvcProfileForTrackNumber(track.trackId);
      if (avc) {
        resolvedTracks.push({
          ...track,
          codec: getCodecStringFromSpsAndPps(avc)
        });
      } else {
        missingInfo.push(track);
      }
    } else {
      resolvedTracks.push(track);
    }
  }
  return { missingInfo, resolved: resolvedTracks };
};
var matroskaHasTracks = ({
  structureState,
  webmState
}) => {
  const structure = structureState.getMatroskaStructure();
  const mainSegment = getMainSegment(structure.boxes);
  if (!mainSegment) {
    return false;
  }
  return getTracksSegment(mainSegment) !== null && getTracksFromMatroska({
    structureState,
    webmState
  }).missingInfo.length === 0;
};
var isoBaseMediaHasTracks = (state, mayUsePrecomputed) => {
  return Boolean(getMoovBoxFromState({
    structureState: state.structure,
    isoState: state.iso,
    mp4HeaderSegment: state.m3uPlaylistContext?.mp4HeaderSegment ?? null,
    mayUsePrecomputed
  }));
};
var getHasTracks = (state, mayUsePrecomputed) => {
  const structure = state.structure.getStructure();
  if (structure.type === "matroska") {
    return matroskaHasTracks({
      structureState: state.structure,
      webmState: state.webm
    });
  }
  if (structure.type === "iso-base-media") {
    return isoBaseMediaHasTracks(state, mayUsePrecomputed);
  }
  if (structure.type === "riff") {
    return hasAllTracksFromAvi(state);
  }
  if (structure.type === "transport-stream") {
    return hasAllTracksFromTransportStream(state);
  }
  if (structure.type === "mp3") {
    return state.callbacks.tracks.getTracks().length > 0;
  }
  if (structure.type === "wav") {
    return state.callbacks.tracks.hasAllTracks();
  }
  if (structure.type === "aac") {
    return state.callbacks.tracks.hasAllTracks();
  }
  if (structure.type === "flac") {
    return state.callbacks.tracks.hasAllTracks();
  }
  if (structure.type === "m3u") {
    return state.callbacks.tracks.hasAllTracks();
  }
  throw new Error("Unknown container " + structure);
};
var getCategorizedTracksFromMatroska = (state) => {
  const { resolved } = getTracksFromMatroska({
    structureState: state.structure,
    webmState: state.webm
  });
  return resolved;
};
var getTracksFromMoovBox = (moovBox) => {
  const mediaParserTracks = [];
  const tracks2 = getTraks(moovBox);
  for (const trakBox of tracks2) {
    const mvhdBox = getMvhdBox(moovBox);
    if (!mvhdBox) {
      throw new Error("Mvhd box is not found");
    }
    const startTime = findTrackStartTimeInSeconds({
      movieTimeScale: mvhdBox.timeScale,
      trakBox
    });
    const track = makeBaseMediaTrack(trakBox, startTime);
    if (!track) {
      continue;
    }
    mediaParserTracks.push(track);
  }
  return mediaParserTracks;
};
var getTracksFromIsoBaseMedia = ({
  mayUsePrecomputed,
  structure,
  isoState,
  m3uPlaylistContext
}) => {
  const moovBox = getMoovBoxFromState({
    structureState: structure,
    isoState,
    mp4HeaderSegment: m3uPlaylistContext?.mp4HeaderSegment ?? null,
    mayUsePrecomputed
  });
  if (!moovBox) {
    return [];
  }
  return getTracksFromMoovBox(moovBox);
};
var defaultGetTracks = (parserState) => {
  const tracks2 = parserState.callbacks.tracks.getTracks();
  if (tracks2.length === 0) {
    throw new Error("No tracks found");
  }
  return tracks2;
};
var getTracks = (state, mayUsePrecomputed) => {
  const structure = state.structure.getStructure();
  if (structure.type === "matroska") {
    return getCategorizedTracksFromMatroska(state);
  }
  if (structure.type === "iso-base-media") {
    return getTracksFromIsoBaseMedia({
      isoState: state.iso,
      m3uPlaylistContext: state.m3uPlaylistContext,
      structure: state.structure,
      mayUsePrecomputed
    });
  }
  if (structure.type === "riff") {
    return getTracksFromAvi(structure, state);
  }
  if (structure.type === "transport-stream") {
    return getTracksFromTransportStream(state);
  }
  if (structure.type === "mp3" || structure.type === "wav" || structure.type === "flac" || structure.type === "aac" || structure.type === "m3u") {
    return defaultGetTracks(state);
  }
  throw new Error(`Unknown container${structure}`);
};
var getAudioCodec = (parserState) => {
  const tracks2 = getTracks(parserState, true);
  if (tracks2.length === 0) {
    throw new Error("No tracks yet");
  }
  const audioTrack = tracks2.find((t) => t.type === "audio");
  if (!audioTrack) {
    return null;
  }
  if (audioTrack.type === "audio") {
    return audioTrack.codecEnum;
  }
  return null;
};
var hasAudioCodec = (state) => {
  return getHasTracks(state, true);
};
var getCodecSpecificatorFromEsdsBox = ({
  child
}) => {
  const descriptor = child.descriptors.find((d) => d.type === "decoder-config-descriptor");
  if (!descriptor) {
    throw new Error("No decoder-config-descriptor");
  }
  if (descriptor.type !== "decoder-config-descriptor") {
    throw new Error("Expected decoder-config-descriptor");
  }
  if (descriptor.asNumber !== 64) {
    return {
      primary: descriptor.asNumber,
      secondary: null,
      description: undefined
    };
  }
  const audioSpecificConfig = descriptor.decoderSpecificConfigs.find((d) => {
    return d.type === "mp4a-specific-config" ? d : null;
  });
  if (!audioSpecificConfig || audioSpecificConfig.type !== "mp4a-specific-config") {
    throw new Error("No audio-specific-config");
  }
  return {
    primary: descriptor.asNumber,
    secondary: audioSpecificConfig.audioObjectType,
    description: audioSpecificConfig.asBytes
  };
};
var getCodecPrivateFromTrak = (trakBox) => {
  const stsdBox = getStsdBox(trakBox);
  if (!stsdBox) {
    return null;
  }
  const audioSample = stsdBox.samples.find((s) => s.type === "audio");
  if (!audioSample || audioSample.type !== "audio") {
    return null;
  }
  const esds = audioSample.children.find((b) => b.type === "esds-box");
  if (!esds || esds.type !== "esds-box") {
    return null;
  }
  const decoderConfigDescriptor = esds.descriptors.find((d) => d.type === "decoder-config-descriptor");
  if (!decoderConfigDescriptor) {
    return null;
  }
  const mp4a = decoderConfigDescriptor.decoderSpecificConfigs.find((d) => d.type === "mp4a-specific-config");
  if (!mp4a) {
    return null;
  }
  return { type: "aac-config", data: mp4a.asBytes };
};
var onSample = (sample, children) => {
  const child = children.find((c) => c.type === "esds-box");
  if (child && child.type === "esds-box") {
    const ret = getCodecSpecificatorFromEsdsBox({ child });
    return {
      format: sample.format,
      primarySpecificator: ret.primary,
      secondarySpecificator: ret.secondary,
      description: ret.description
    };
  }
  return {
    format: sample.format,
    primarySpecificator: null,
    secondarySpecificator: null,
    description: undefined
  };
};
var getNumberOfChannelsFromTrak = (trak) => {
  const stsdBox = getStsdBox(trak);
  if (!stsdBox) {
    return null;
  }
  const sample = stsdBox.samples.find((s) => s.type === "audio");
  if (!sample || sample.type !== "audio") {
    return null;
  }
  return sample.numberOfChannels;
};
var getSampleRate2 = (trak) => {
  const stsdBox = getStsdBox(trak);
  if (!stsdBox) {
    return null;
  }
  const sample = stsdBox.samples.find((s) => s.type === "audio");
  if (!sample || sample.type !== "audio") {
    return null;
  }
  return sample.sampleRate;
};
var getAudioCodecFromTrak = (trak) => {
  const stsdBox = getStsdBox(trak);
  if (!stsdBox) {
    return null;
  }
  const sample = stsdBox.samples.find((s) => s.type === "audio");
  if (!sample || sample.type !== "audio") {
    return null;
  }
  const waveBox = sample.children.find((b) => b.type === "regular-box" && b.boxType === "wave");
  if (waveBox && waveBox.type === "regular-box" && waveBox.boxType === "wave") {
    const esdsSample = onSample(sample, waveBox.children);
    if (esdsSample) {
      return esdsSample;
    }
  }
  const ret = onSample(sample, sample.children);
  if (ret) {
    return ret;
  }
  return null;
};
var isLpcmAudioCodec = (trak) => {
  return getAudioCodecFromTrak(trak)?.format === "lpcm";
};
var isIn24AudioCodec = (trak) => {
  return getAudioCodecFromTrak(trak)?.format === "in24";
};
var isTwosAudioCodec = (trak) => {
  return getAudioCodecFromTrak(trak)?.format === "twos";
};
var getAudioCodecStringFromTrak = (trak) => {
  const codec = getAudioCodecFromTrak(trak);
  if (!codec) {
    throw new Error("Expected codec");
  }
  if (codec.format === "lpcm") {
    return {
      codecString: "pcm-s16",
      description: codec.description ? { type: "unknown-data", data: codec.description } : undefined
    };
  }
  if (codec.format === "twos") {
    return {
      codecString: "pcm-s16",
      description: codec.description ? { type: "unknown-data", data: codec.description } : undefined
    };
  }
  if (codec.format === "in24") {
    return {
      codecString: "pcm-s24",
      description: codec.description ? { type: "unknown-data", data: codec.description } : undefined
    };
  }
  const codecStringWithoutMp3Exception = [
    codec.format,
    codec.primarySpecificator ? codec.primarySpecificator.toString(16) : null,
    codec.secondarySpecificator ? codec.secondarySpecificator.toString().padStart(2, "0") : null
  ].filter(Boolean).join(".");
  const codecString = codecStringWithoutMp3Exception.toLowerCase() === "mp4a.6b" || codecStringWithoutMp3Exception.toLowerCase() === "mp4a.69" ? "mp3" : codecStringWithoutMp3Exception;
  if (codecString === "mp3") {
    return {
      codecString,
      description: codec.description ? {
        type: "unknown-data",
        data: codec.description
      } : undefined
    };
  }
  if (codecString.startsWith("mp4a.")) {
    return {
      codecString,
      description: codec.description ? {
        type: "aac-config",
        data: codec.description
      } : undefined
    };
  }
  return {
    codecString,
    description: codec.description ? {
      type: "unknown-data",
      data: codec.description
    } : undefined
  };
};
var getAudioCodecFromAudioCodecInfo = (codec) => {
  if (codec.format === "twos") {
    return "pcm-s16";
  }
  if (codec.format === "in24") {
    return "pcm-s24";
  }
  if (codec.format === "lpcm") {
    return "pcm-s16";
  }
  if (codec.format === "sowt") {
    return "aiff";
  }
  if (codec.format === "ac-3") {
    return "ac3";
  }
  if (codec.format === "Opus") {
    return "opus";
  }
  if (codec.format === "mp4a") {
    if (codec.primarySpecificator === 64) {
      return "aac";
    }
    if (codec.primarySpecificator === 107) {
      return "mp3";
    }
    if (codec.primarySpecificator === null) {
      return "aac";
    }
    throw new Error("Unknown mp4a codec: " + codec.primarySpecificator);
  }
  throw new Error(`Unknown audio format: ${codec.format}`);
};
var getAudioCodecFromTrack = (track) => {
  const audioSample = getAudioCodecFromTrak(track);
  if (!audioSample) {
    throw new Error("Could not find audio sample");
  }
  return getAudioCodecFromAudioCodecInfo(audioSample);
};
var isAudioStructure = (structure) => {
  if (structure.type === "mp3") {
    return true;
  }
  if (structure.type === "wav") {
    return true;
  }
  if (structure.type === "aac") {
    return true;
  }
  if (structure.type === "flac") {
    return true;
  }
  if (structure.type === "iso-base-media") {
    return false;
  }
  if (structure.type === "matroska") {
    return false;
  }
  if (structure.type === "transport-stream") {
    return false;
  }
  if (structure.type === "riff") {
    return false;
  }
  if (structure.type === "m3u") {
    return false;
  }
  throw new Error(`Unhandled structure type: ${structure}`);
};
var calculateFps = ({
  sttsBox,
  timeScale,
  durationInSamples
}) => {
  let totalSamples = 0;
  for (const sample of sttsBox.sampleDistribution) {
    totalSamples += sample.sampleCount;
  }
  if (totalSamples === 0) {
    return null;
  }
  const durationInSeconds = durationInSamples / timeScale;
  const fps = totalSamples / durationInSeconds;
  return fps;
};
var trakBoxContainsAudio = (trakBox) => {
  const stsd = getStsdBox(trakBox);
  if (!stsd) {
    return false;
  }
  const videoSample = stsd.samples.find((s) => s.type === "audio");
  if (!videoSample || videoSample.type !== "audio") {
    return false;
  }
  return true;
};
var trakBoxContainsVideo = (trakBox) => {
  const stsd = getStsdBox(trakBox);
  if (!stsd) {
    return false;
  }
  const videoSample = stsd.samples.find((s) => s.type === "video");
  if (!videoSample || videoSample.type !== "video") {
    return false;
  }
  return true;
};
var getTimescaleAndDuration = (trakBox) => {
  const mdhdBox = getMdhdBox(trakBox);
  if (mdhdBox) {
    return { timescale: mdhdBox.timescale, duration: mdhdBox.duration };
  }
  return null;
};
var getFpsFromMp4TrakBox = (trakBox) => {
  const timescaleAndDuration = getTimescaleAndDuration(trakBox);
  if (!timescaleAndDuration) {
    return null;
  }
  const sttsBox = getSttsBox(trakBox);
  if (!sttsBox) {
    return null;
  }
  return calculateFps({
    sttsBox,
    timeScale: timescaleAndDuration.timescale,
    durationInSamples: timescaleAndDuration.duration
  });
};
var getFpsFromIsoMaseMedia = (state) => {
  const moovBox = getMoovBoxFromState({
    structureState: state.structure,
    isoState: state.iso,
    mp4HeaderSegment: state.m3uPlaylistContext?.mp4HeaderSegment ?? null,
    mayUsePrecomputed: true
  });
  if (!moovBox) {
    return null;
  }
  const trackBoxes = getTraks(moovBox);
  const trackBox = trackBoxes.find(trakBoxContainsVideo);
  if (!trackBox) {
    return null;
  }
  return getFpsFromMp4TrakBox(trackBox);
};
var getFpsFromAvi = (structure) => {
  const strl = getStrlBoxes(structure);
  for (const s of strl) {
    const strh = getStrhBox(s.children);
    if (!strh) {
      throw new Error("No strh box");
    }
    if (strh.fccType === "auds") {
      continue;
    }
    return strh.rate;
  }
  return null;
};
var getFps = (state) => {
  const segments = state.structure.getStructure();
  if (segments.type === "iso-base-media") {
    return getFpsFromIsoMaseMedia(state);
  }
  if (segments.type === "riff") {
    return getFpsFromAvi(segments);
  }
  if (segments.type === "matroska") {
    return null;
  }
  if (segments.type === "transport-stream") {
    return null;
  }
  if (segments.type === "m3u") {
    return null;
  }
  if (segments.type === "mp3" || segments.type === "wav" || segments.type === "flac" || segments.type === "aac") {
    return null;
  }
  throw new Error("Cannot get fps, not implemented: " + segments);
};
var hasFpsSuitedForSlowFps = (state) => {
  try {
    return getFps(state) !== null;
  } catch {
    return false;
  }
};
var hasFps = (state) => {
  const structure = state.structure.getStructure();
  if (isAudioStructure(structure)) {
    return true;
  }
  if (structure.type === "matroska") {
    return true;
  }
  if (structure.type === "transport-stream") {
    return true;
  }
  if (structure.type === "m3u") {
    return true;
  }
  return hasFpsSuitedForSlowFps(state);
};
var getStsdVideoConfig = (trakBox) => {
  const stsdBox = getStsdBox(trakBox);
  if (!stsdBox) {
    return null;
  }
  const videoConfig = stsdBox.samples.find((s) => s.type === "video");
  if (!videoConfig || videoConfig.type !== "video") {
    return null;
  }
  return videoConfig;
};
var getAvccBox = (trakBox) => {
  const videoConfig = getStsdVideoConfig(trakBox);
  if (!videoConfig) {
    return null;
  }
  const avccBox = videoConfig.descriptors.find((c) => c.type === "avcc-box");
  if (!avccBox || avccBox.type !== "avcc-box") {
    return null;
  }
  return avccBox;
};
var getVpccBox = (trakBox) => {
  const videoConfig = getStsdVideoConfig(trakBox);
  if (!videoConfig) {
    return null;
  }
  const vpccBox = videoConfig.descriptors.find((c) => c.type === "vpcc-box");
  if (!vpccBox || vpccBox.type !== "vpcc-box") {
    return null;
  }
  return vpccBox;
};
var getAv1CBox = (trakBox) => {
  const videoConfig = getStsdVideoConfig(trakBox);
  if (!videoConfig) {
    return null;
  }
  const av1cBox = videoConfig.descriptors.find((c) => c.type === "av1C-box");
  if (!av1cBox || av1cBox.type !== "av1C-box") {
    return null;
  }
  return av1cBox;
};
var getPaspBox = (trakBox) => {
  const videoConfig = getStsdVideoConfig(trakBox);
  if (!videoConfig) {
    return null;
  }
  const paspBox = videoConfig.descriptors.find((c) => c.type === "pasp-box");
  if (!paspBox || paspBox.type !== "pasp-box") {
    return null;
  }
  return paspBox;
};
var getHvccBox = (trakBox) => {
  const videoConfig = getStsdVideoConfig(trakBox);
  if (!videoConfig) {
    return null;
  }
  const hvccBox = videoConfig.descriptors.find((c) => c.type === "hvcc-box");
  if (!hvccBox || hvccBox.type !== "hvcc-box") {
    return null;
  }
  return hvccBox;
};
var getSampleAspectRatio = (trakBox) => {
  const paspBox = getPaspBox(trakBox);
  if (!paspBox) {
    return {
      numerator: 1,
      denominator: 1
    };
  }
  return {
    numerator: paspBox.hSpacing,
    denominator: paspBox.vSpacing
  };
};
var getColrBox = (videoSample) => {
  const colrBox = videoSample.descriptors.find((c) => c.type === "colr-box");
  if (!colrBox || colrBox.type !== "colr-box") {
    return null;
  }
  return colrBox;
};
var applyTkhdBox = (aspectRatioApplied, tkhdBox) => {
  if (tkhdBox === null || tkhdBox.rotation === 0) {
    return {
      displayAspectWidth: aspectRatioApplied.width,
      displayAspectHeight: aspectRatioApplied.height,
      width: aspectRatioApplied.width,
      height: aspectRatioApplied.height,
      rotation: 0
    };
  }
  return {
    width: tkhdBox.width,
    height: tkhdBox.height,
    rotation: tkhdBox.rotation,
    displayAspectWidth: aspectRatioApplied.width,
    displayAspectHeight: aspectRatioApplied.height
  };
};
var applyAspectRatios = ({
  dimensions,
  sampleAspectRatio,
  displayAspectRatio
}) => {
  if (displayAspectRatio.numerator === 0) {
    return dimensions;
  }
  if (displayAspectRatio.denominator === 0) {
    return dimensions;
  }
  const newWidth = Math.round(dimensions.width * sampleAspectRatio.numerator / sampleAspectRatio.denominator);
  const newHeight = Math.floor(newWidth / (displayAspectRatio.numerator / displayAspectRatio.denominator));
  return {
    width: Math.floor(newWidth),
    height: newHeight
  };
};
function gcd(a, b) {
  return b === 0 ? a : gcd(b, a % b);
}
function reduceFraction(numerator, denominator) {
  const greatestCommonDivisor = gcd(Math.abs(numerator), Math.abs(denominator));
  return {
    numerator: numerator / greatestCommonDivisor,
    denominator: denominator / greatestCommonDivisor
  };
}
var getDisplayAspectRatio = ({
  sampleAspectRatio,
  nativeDimensions
}) => {
  const num = Math.round(nativeDimensions.width * sampleAspectRatio.numerator);
  const den = Math.round(nativeDimensions.height * sampleAspectRatio.denominator);
  return reduceFraction(num, den);
};
var getVideoCodec = (state) => {
  const track = getTracks(state, true);
  return track.find((t) => t.type === "video")?.codecEnum ?? null;
};
var hasVideoCodec = (state) => {
  return getHasTracks(state, true);
};
var getVideoPrivateData = (trakBox) => {
  const videoSample = getStsdVideoConfig(trakBox);
  const avccBox = getAvccBox(trakBox);
  const hvccBox = getHvccBox(trakBox);
  const av1cBox = getAv1CBox(trakBox);
  if (!videoSample) {
    return null;
  }
  if (avccBox) {
    return { type: "avc-sps-pps", data: avccBox.privateData };
  }
  if (hvccBox) {
    return { type: "hvcc-data", data: hvccBox.privateData };
  }
  if (av1cBox) {
    return { type: "av1c-data", data: av1cBox.privateData };
  }
  return null;
};
var getIsoBmColrConfig = (trakBox) => {
  const videoSample = getStsdVideoConfig(trakBox);
  if (!videoSample) {
    return null;
  }
  const colrAtom = getColrBox(videoSample);
  if (!colrAtom) {
    return null;
  }
  if (colrAtom.colorType !== "transfer-characteristics") {
    return null;
  }
  return {
    fullRange: colrAtom.fullRangeFlag,
    matrix: getMatrixCoefficientsFromIndex(colrAtom.matrixIndex),
    primaries: getPrimariesFromIndex(colrAtom.primaries),
    transfer: getTransferCharacteristicsFromIndex(colrAtom.transfer)
  };
};
var getVideoCodecString = (trakBox) => {
  const videoSample = getStsdVideoConfig(trakBox);
  const avccBox = getAvccBox(trakBox);
  if (!videoSample) {
    return null;
  }
  if (avccBox) {
    return `${videoSample.format}.${avccBox.configurationString}`;
  }
  const hvccBox = getHvccBox(trakBox);
  if (hvccBox) {
    return `${videoSample.format}.${hvccBox.configurationString}`;
  }
  const av1cBox = getAv1CBox(trakBox);
  if (av1cBox) {
    const colrAtom = getColrBox(videoSample);
    return parseAv1PrivateData(av1cBox.privateData, colrAtom);
  }
  const vpccBox = getVpccBox(trakBox);
  if (vpccBox) {
    return `${videoSample.format}.${vpccBox.codecString}`;
  }
  return videoSample.format;
};
var normalizeVideoRotation = (rotation) => {
  return (rotation % 360 + 360) % 360;
};
var getActualDecoderParameters = ({
  audioCodec,
  codecPrivate: codecPrivate2,
  numberOfChannels,
  sampleRate
}) => {
  if (audioCodec !== "aac") {
    return {
      numberOfChannels,
      sampleRate,
      codecPrivate: codecPrivate2
    };
  }
  if (codecPrivate2 === null) {
    return { numberOfChannels, sampleRate, codecPrivate: codecPrivate2 };
  }
  if (codecPrivate2.type !== "aac-config") {
    throw new Error("Expected AAC codec private data");
  }
  const parsed = parseAacCodecPrivate(codecPrivate2.data);
  const actual = createAacCodecPrivate({
    ...parsed,
    codecPrivate: codecPrivate2.data
  });
  return {
    numberOfChannels: parsed.channelConfiguration,
    sampleRate: parsed.sampleRate,
    codecPrivate: { type: "aac-config", data: actual }
  };
};
var getVideoCodecFromIsoTrak = (trakBox) => {
  const stsdBox = getStsdBox(trakBox);
  if (stsdBox && stsdBox.type === "stsd-box") {
    const videoSample = stsdBox.samples.find((s) => s.type === "video");
    if (videoSample && videoSample.type === "video") {
      if (videoSample.format === "hvc1" || videoSample.format === "hev1") {
        return "h265";
      }
      if (videoSample.format === "avc1") {
        return "h264";
      }
      if (videoSample.format === "av01") {
        return "av1";
      }
      if (videoSample.format === "vp09") {
        return "vp9";
      }
      if (videoSample.format === "ap4h") {
        return "prores";
      }
      if (videoSample.format === "ap4x") {
        return "prores";
      }
      if (videoSample.format === "apch") {
        return "prores";
      }
      if (videoSample.format === "apcn") {
        return "prores";
      }
      if (videoSample.format === "apcs") {
        return "prores";
      }
      if (videoSample.format === "apco") {
        return "prores";
      }
      if (videoSample.format === "aprh") {
        return "prores";
      }
      if (videoSample.format === "aprn") {
        return "prores";
      }
    }
  }
  throw new Error("Could not find video codec");
};
var makeBaseMediaTrack = (trakBox, startTimeInSeconds) => {
  const tkhdBox = getTkhdBox(trakBox);
  const videoDescriptors = getVideoDescriptors(trakBox);
  const timescaleAndDuration = getTimescaleAndDuration(trakBox);
  if (!tkhdBox) {
    throw new Error("Expected tkhd box in trak box");
  }
  if (!timescaleAndDuration) {
    throw new Error("Expected timescale and duration in trak box");
  }
  if (trakBoxContainsAudio(trakBox)) {
    const numberOfChannels = getNumberOfChannelsFromTrak(trakBox);
    if (numberOfChannels === null) {
      throw new Error("Could not find number of channels");
    }
    const sampleRate = getSampleRate2(trakBox);
    if (sampleRate === null) {
      throw new Error("Could not find sample rate");
    }
    const { codecString, description } = getAudioCodecStringFromTrak(trakBox);
    const codecPrivate2 = getCodecPrivateFromTrak(trakBox) ?? description ?? null;
    const codecEnum = getAudioCodecFromTrack(trakBox);
    const actual = getActualDecoderParameters({
      audioCodec: codecEnum,
      codecPrivate: codecPrivate2 ?? null,
      numberOfChannels,
      sampleRate
    });
    return {
      type: "audio",
      trackId: tkhdBox.trackId,
      originalTimescale: timescaleAndDuration.timescale,
      codec: codecString,
      numberOfChannels: actual.numberOfChannels,
      sampleRate: actual.sampleRate,
      description: actual.codecPrivate?.data ?? undefined,
      codecData: actual.codecPrivate,
      codecEnum,
      startInSeconds: startTimeInSeconds,
      timescale: WEBCODECS_TIMESCALE,
      trackMediaTimeOffsetInTrackTimescale: findTrackMediaTimeOffsetInTrackTimescale({
        trakBox
      })
    };
  }
  if (!trakBoxContainsVideo(trakBox)) {
    return {
      type: "other",
      trackId: tkhdBox.trackId,
      originalTimescale: timescaleAndDuration.timescale,
      trakBox,
      startInSeconds: startTimeInSeconds,
      timescale: WEBCODECS_TIMESCALE,
      trackMediaTimeOffsetInTrackTimescale: findTrackMediaTimeOffsetInTrackTimescale({
        trakBox
      })
    };
  }
  const videoSample = getStsdVideoConfig(trakBox);
  if (!videoSample) {
    throw new Error("No video sample");
  }
  const sampleAspectRatio = getSampleAspectRatio(trakBox);
  const aspectRatioApplied = applyAspectRatios({
    dimensions: videoSample,
    sampleAspectRatio,
    displayAspectRatio: getDisplayAspectRatio({
      sampleAspectRatio,
      nativeDimensions: videoSample
    })
  });
  const { displayAspectHeight, displayAspectWidth, height, rotation, width } = applyTkhdBox(aspectRatioApplied, tkhdBox);
  const codec = getVideoCodecString(trakBox);
  if (!codec) {
    throw new Error("Could not find video codec");
  }
  const privateData = getVideoPrivateData(trakBox);
  const advancedColor = getIsoBmColrConfig(trakBox) ?? {
    fullRange: null,
    matrix: null,
    primaries: null,
    transfer: null
  };
  const track = {
    m3uStreamFormat: null,
    type: "video",
    trackId: tkhdBox.trackId,
    description: videoDescriptors ?? undefined,
    originalTimescale: timescaleAndDuration.timescale,
    codec,
    sampleAspectRatio: getSampleAspectRatio(trakBox),
    width,
    height,
    codedWidth: videoSample.width,
    codedHeight: videoSample.height,
    displayAspectWidth,
    displayAspectHeight,
    rotation: normalizeVideoRotation(0 - rotation),
    codecData: privateData,
    colorSpace: mediaParserAdvancedColorToWebCodecsColor(advancedColor),
    advancedColor,
    codecEnum: getVideoCodecFromIsoTrak(trakBox),
    fps: getFpsFromMp4TrakBox(trakBox),
    startInSeconds: startTimeInSeconds,
    timescale: WEBCODECS_TIMESCALE,
    trackMediaTimeOffsetInTrackTimescale: findTrackMediaTimeOffsetInTrackTimescale({
      trakBox
    })
  };
  return track;
};
var parseMdhd = ({
  data,
  size: size4,
  fileOffset
}) => {
  const version = data.getUint8();
  data.discard(3);
  const creationTime = version === 1 ? Number(data.getUint64()) : data.getUint32();
  const modificationTime = version === 1 ? Number(data.getUint64()) : data.getUint32();
  const timescale = data.getUint32();
  const duration2 = version === 1 ? data.getUint64() : data.getUint32();
  const language2 = data.getUint16();
  const quality = data.getUint16();
  const remaining = size4 - (data.counter.getOffset() - fileOffset);
  if (remaining !== 0) {
    throw new Error(`Expected remaining bytes to be 0, got ${remaining}`);
  }
  return {
    type: "mdhd-box",
    duration: Number(duration2),
    timescale,
    version,
    language: language2,
    quality,
    creationTime,
    modificationTime
  };
};
var parseHdlr = ({
  iterator,
  size: size4,
  offset
}) => {
  const box2 = iterator.startBox(size4 - 8);
  const version = iterator.getUint8();
  if (version !== 0) {
    throw new Error(`Unsupported hdlr version: ${version}`);
  }
  iterator.discard(3);
  iterator.discard(4);
  const hdlrType = iterator.getByteString(4, false);
  iterator.discard(4);
  iterator.discard(4);
  iterator.discard(4);
  const componentName = iterator.readUntilNullTerminator();
  box2.discardRest();
  return Promise.resolve({
    type: "hdlr-box",
    boxSize: size4,
    offset,
    hdlrType,
    componentName
  });
};
var parseFromWellKnownType = (wellKnownType, iterator, size4) => {
  if (wellKnownType === 1) {
    const value = iterator.getByteString(size4, false);
    return { type: "text", value };
  }
  if (wellKnownType === 21) {
    if (size4 === 1) {
      return { type: "number", value: iterator.getInt8() };
    }
    if (size4 === 2) {
      return { type: "number", value: iterator.getInt16() };
    }
    if (size4 === 3) {
      return { type: "number", value: iterator.getInt24() };
    }
    if (size4 === 4) {
      return { type: "number", value: iterator.getInt32() };
    }
    if (size4 === 8) {
      return { type: "number", value: Number(iterator.getInt64()) };
    }
    throw new Error(`Weird size for number ${size4}`);
  }
  if (wellKnownType === 22) {
    if (size4 === 1) {
      return { type: "number", value: iterator.getUint8() };
    }
    if (size4 === 2) {
      return { type: "number", value: iterator.getUint16() };
    }
    if (size4 === 3) {
      return { type: "number", value: iterator.getUint24() };
    }
    if (size4 === 4) {
      return { type: "number", value: iterator.getUint32() };
    }
    throw new Error(`Weird size for number ${size4}`);
  }
  if (wellKnownType === 23) {
    if (size4 === 4) {
      return { type: "number", value: iterator.getFloat32() };
    }
    if (size4 === 8) {
      return { type: "number", value: iterator.getFloat64() };
    }
    throw new Error(`Weird size for number ${size4}`);
  }
  iterator.discard(size4);
  return { type: "unknown", value: null };
};
var parseIlstBox = ({
  iterator,
  size: size4,
  offset
}) => {
  const box2 = iterator.startBox(size4 - 8);
  const entries = [];
  while (iterator.counter.getOffset() < size4 + offset) {
    const metadataSize = iterator.getUint32();
    const index = iterator.getAtom();
    if (!index.startsWith("�") && !index.startsWith("\x00")) {
      if (index === "skip") {
        iterator.discard(metadataSize - 8);
        continue;
      }
      if (index === "----") {
        iterator.discard(metadataSize - 8);
        continue;
      }
      iterator.discard(metadataSize - 8);
      continue;
    }
    const innerSize = iterator.getUint32();
    const type = iterator.getAtom();
    const typeIndicator = iterator.getUint8();
    if (typeIndicator !== 0) {
      throw new Error("Expected type indicator to be 0");
    }
    const wellKnownType = iterator.getUint24();
    iterator.discard(4);
    const value = parseFromWellKnownType(wellKnownType, iterator, innerSize - 16);
    entries.push({ index, type, wellKnownType, value });
  }
  box2.discardRest();
  return {
    type: "ilst-box",
    boxSize: size4,
    offset,
    entries
  };
};
var readTrafNumber = (iterator, lengthSizeOfTrafNum) => {
  const uintTypeTrafNum = (lengthSizeOfTrafNum + 1) * 8;
  if (uintTypeTrafNum === 8) {
    return iterator.getUint8();
  }
  if (uintTypeTrafNum === 16) {
    return iterator.getUint16();
  }
  if (uintTypeTrafNum === 32) {
    return iterator.getUint32();
  }
  if (uintTypeTrafNum === 64) {
    return Number(iterator.getUint64());
  }
  throw new Error("Invalid traf number size");
};
var readTrunNumber = (iterator, lengthSizeOfTrunNum) => {
  const uintTypeTrunNum = (lengthSizeOfTrunNum + 1) * 8;
  if (uintTypeTrunNum === 8) {
    return iterator.getUint8();
  }
  if (uintTypeTrunNum === 16) {
    return iterator.getUint16();
  }
  if (uintTypeTrunNum === 32) {
    return iterator.getUint32();
  }
  if (uintTypeTrunNum === 64) {
    return Number(iterator.getUint64());
  }
  throw new Error("Invalid trun number size");
};
var readSampleNumber = (iterator, lengthSizeOfSampleNum) => {
  const uintTypeSampleNum = (lengthSizeOfSampleNum + 1) * 8;
  if (uintTypeSampleNum === 8) {
    return iterator.getUint8();
  }
  if (uintTypeSampleNum === 16) {
    return iterator.getUint16();
  }
  if (uintTypeSampleNum === 32) {
    return iterator.getUint32();
  }
  if (uintTypeSampleNum === 64) {
    return Number(iterator.getUint64());
  }
  throw new Error("Invalid sample number size");
};
var readTime = (iterator, version) => {
  if (version === 1) {
    return Number(iterator.getUint64());
  }
  return iterator.getUint32();
};
var readMoofOffset = (iterator, version) => {
  if (version === 1) {
    return Number(iterator.getUint64());
  }
  return iterator.getUint32();
};
var parseTfraBox = ({
  iterator,
  size: size4,
  offset
}) => {
  const box2 = iterator.startBox(size4 - 8);
  const version = iterator.getUint8();
  iterator.discard(3);
  const trackId = iterator.getUint32();
  iterator.getUint24();
  const tmpByte = iterator.getUint8();
  const lengthSizeOfTrafNum = tmpByte >> 4 & 3;
  const lengthSizeOfTrunNum = tmpByte >> 2 & 3;
  const lengthSizeOfSampleNum = tmpByte & 3;
  const numberOfEntries = iterator.getUint32();
  const entries = [];
  for (let i = 0;i < numberOfEntries; i++) {
    const time2 = readTime(iterator, version);
    const moofOffset = readMoofOffset(iterator, version);
    const trafNumber = readTrafNumber(iterator, lengthSizeOfTrafNum);
    const trunNumber = readTrunNumber(iterator, lengthSizeOfTrunNum);
    const sampleNumber = readSampleNumber(iterator, lengthSizeOfSampleNum);
    entries.push({
      time: time2,
      moofOffset,
      trafNumber,
      trunNumber,
      sampleNumber
    });
  }
  box2.expectNoMoreBytes();
  return {
    offset,
    boxSize: size4,
    type: "tfra-box",
    entries,
    trackId
  };
};
var parseMoov = async ({
  offset,
  size: size4,
  onlyIfMoovAtomExpected,
  iterator,
  logLevel,
  contentLength
}) => {
  const children = await getIsoBaseMediaChildren({
    onlyIfMoovAtomExpected,
    size: size4 - 8,
    iterator,
    logLevel,
    contentLength
  });
  return {
    offset,
    boxSize: size4,
    type: "moov-box",
    children
  };
};
var parseTrex = ({
  iterator,
  offset,
  size: size4
}) => {
  const box2 = iterator.startBox(size4 - 8);
  const version = iterator.getUint8();
  iterator.discard(3);
  const trackId = iterator.getUint32();
  const defaultSampleDescriptionIndex = iterator.getUint32();
  const defaultSampleDuration = iterator.getUint32();
  const defaultSampleSize = iterator.getUint32();
  const defaultSampleFlags = iterator.getUint32();
  box2.expectNoMoreBytes();
  return {
    type: "trex-box",
    boxSize: size4,
    offset,
    trackId,
    version,
    defaultSampleDescriptionIndex,
    defaultSampleDuration,
    defaultSampleSize,
    defaultSampleFlags
  };
};
var parseAv1C = ({
  data,
  size: size4
}) => {
  return {
    type: "av1C-box",
    privateData: data.getSlice(size4 - 8)
  };
};
var parseAvcc = ({
  data,
  size: size4
}) => {
  const confVersion = data.getUint8();
  if (confVersion !== 1) {
    throw new Error(`Unsupported AVCC version ${confVersion}`);
  }
  const profile = data.getUint8();
  const profileCompatibility = data.getUint8();
  const level = data.getUint8();
  const str = `${profile.toString(16).padStart(2, "0")}${profileCompatibility.toString(16).padStart(2, "0")}${level.toString(16).padStart(2, "0")}`;
  data.counter.decrement(4);
  const privateData = data.getSlice(size4 - 8);
  return {
    type: "avcc-box",
    privateData,
    configurationString: str
  };
};
var parseIccProfile = (data) => {
  const iterator = getArrayBufferIterator({
    initialData: data,
    maxBytes: data.length,
    logLevel: "error"
  });
  const size4 = iterator.getUint32();
  if (size4 !== data.length) {
    throw new Error("Invalid ICC profile size");
  }
  const preferredCMMType = iterator.getByteString(4, false);
  const profileVersion = iterator.getByteString(4, false);
  const profileDeviceClass = iterator.getByteString(4, false);
  const colorSpace = iterator.getByteString(4, false);
  const pcs = iterator.getByteString(4, false);
  const dateTime = iterator.getSlice(12);
  const signature = iterator.getByteString(4, false);
  if (signature !== "acsp") {
    throw new Error("Invalid ICC profile signature");
  }
  const primaryPlatform = iterator.getByteString(4, false);
  const profileFlags = iterator.getUint32();
  const deviceManufacturer = iterator.getByteString(4, false);
  const deviceModel = iterator.getByteString(4, false);
  const deviceAttributes = iterator.getUint64();
  const renderingIntent = iterator.getUint32();
  const pcsIlluminant1 = iterator.getUint32();
  const pcsIlluminant2 = iterator.getUint32();
  const pcsIlluminant3 = iterator.getUint32();
  const profileCreator = iterator.getByteString(4, false);
  const profileId = iterator.getByteString(16, false);
  iterator.discard(28);
  const tagCount = iterator.getUint32();
  const entries = [];
  for (let i = 0;i < tagCount; i++) {
    const entry = {
      tag: iterator.getByteString(4, false),
      offset: iterator.getUint32(),
      size: iterator.getUint32()
    };
    entries.push(entry);
  }
  let lastOffset = -1;
  let rXYZ = null;
  let gXYZ = null;
  let bXYZ = null;
  let whitePoint = null;
  for (const entry of entries) {
    const found = data.slice(entry.offset, entry.offset + entry.size);
    if (entry.tag === "rXYZ" || entry.tag === "gXYZ" || entry.tag === "bXYZ" || entry.tag === "wtpt") {
      const it = getArrayBufferIterator({
        initialData: found,
        maxBytes: found.length,
        logLevel: "error"
      });
      it.discard(4);
      const x = it.getInt32() / 65536;
      const y = it.getInt32() / 65536;
      const z = it.getInt32() / 65536;
      it.destroy();
      const point = { x, y, z };
      if (entry.tag === "rXYZ") {
        rXYZ = point;
      } else if (entry.tag === "gXYZ") {
        gXYZ = point;
      } else if (entry.tag === "bXYZ") {
        bXYZ = point;
      } else if (entry.tag === "wtpt") {
        whitePoint = point;
      }
    }
    if (lastOffset !== -1) {
      const bytesToAdvance = entry.offset - lastOffset;
      const bytesToGoBackwards = entry.size - bytesToAdvance;
      if (bytesToGoBackwards > 0) {
        iterator.counter.decrement(bytesToGoBackwards);
      }
    }
    lastOffset = entry.offset;
  }
  const profile = {
    size: size4,
    preferredCMMType,
    profileVersion,
    profileDeviceClass,
    colorSpace,
    pcs,
    dateTime,
    signature,
    primaryPlatform,
    profileFlags,
    deviceManufacturer,
    deviceModel,
    deviceAttributes,
    renderingIntent,
    pcsIlluminant: [
      pcsIlluminant1 / 65536,
      pcsIlluminant2 / 65536,
      pcsIlluminant3 / 65536
    ],
    profileCreator,
    profileId,
    entries,
    bXYZ,
    gXYZ,
    rXYZ,
    whitePoint
  };
  iterator.destroy();
  return profile;
};
var parseColorParameterBox = ({
  iterator,
  size: size4
}) => {
  const byteString = iterator.getByteString(4, false);
  if (byteString === "nclx") {
    const primaries2 = iterator.getUint16();
    const transfer = iterator.getUint16();
    const matrixIndex = iterator.getUint16();
    iterator.startReadingBits();
    const fullRangeFlag = Boolean(iterator.getBits(1));
    iterator.stopReadingBits();
    return {
      type: "colr-box",
      colorType: "transfer-characteristics",
      fullRangeFlag,
      matrixIndex,
      primaries: primaries2,
      transfer
    };
  }
  if (byteString === "nclc") {
    const primaries2 = iterator.getUint16();
    const transfer = iterator.getUint16();
    const matrixIndex = iterator.getUint16();
    return {
      type: "colr-box",
      colorType: "transfer-characteristics",
      fullRangeFlag: false,
      matrixIndex,
      primaries: primaries2,
      transfer
    };
  }
  if (byteString === "prof") {
    const profile = iterator.getSlice(size4 - 12);
    return {
      type: "colr-box",
      colorType: "icc-profile",
      profile,
      parsed: parseIccProfile(profile)
    };
  }
  throw new Error("Unexpected box type " + byteString);
};
var parseCtts = ({
  iterator,
  offset,
  size: size4
}) => {
  const version = iterator.getUint8();
  if (version !== 0 && version !== 1) {
    throw new Error(`Unsupported CTTS version ${version}`);
  }
  const flags = iterator.getSlice(3);
  const entryCount = iterator.getUint32();
  const entries = [];
  for (let i = 0;i < entryCount; i++) {
    const sampleCount = iterator.getUint32();
    const sampleOffset = iterator.getInt32();
    entries.push({
      sampleCount,
      sampleOffset
    });
  }
  return {
    type: "ctts-box",
    boxSize: size4,
    offset,
    version,
    flags: [...flags],
    entryCount,
    entries
  };
};
var parseHvcc = ({
  data,
  size: size4,
  offset
}) => {
  const privateData = data.getSlice(size4 - 8);
  data.counter.decrement(size4 - 8);
  const constraintString = getHvc1CodecString(data);
  const remaining = size4 - (data.counter.getOffset() - offset);
  data.discard(remaining);
  return {
    type: "hvcc-box",
    privateData,
    configurationString: constraintString
  };
};
var parseKeys = ({
  iterator,
  offset,
  size: size4
}) => {
  const box2 = iterator.startBox(size4 - 8);
  const version = iterator.getUint8();
  iterator.discard(3);
  const entryCount = iterator.getUint32();
  const entries = [];
  for (let i = 0;i < entryCount; i++) {
    const keySize = iterator.getUint32();
    const namespace = iterator.getAtom();
    const value = iterator.getByteString(keySize - 8, false);
    const entry = {
      keySize,
      namespace,
      value
    };
    entries.push(entry);
  }
  box2.discardRest();
  return {
    type: "keys-box",
    boxSize: size4,
    offset,
    version,
    entryCount,
    entries
  };
};
var parseMebx = async ({
  offset,
  size: size4,
  iterator,
  logLevel,
  contentLength
}) => {
  iterator.discard(6);
  const dataReferenceIndex = iterator.getUint16();
  const children = await getIsoBaseMediaChildren({
    iterator,
    size: size4 - 8,
    logLevel,
    onlyIfMoovAtomExpected: null,
    contentLength
  });
  return {
    type: "mebx-box",
    boxSize: size4,
    offset,
    dataReferenceIndex,
    format: "mebx",
    children
  };
};
var parsePasp = ({
  iterator,
  offset,
  size: size4
}) => {
  const hSpacing = iterator.getUint32();
  const vSpacing = iterator.getUint32();
  const bytesRemainingInBox = size4 - (iterator.counter.getOffset() - offset);
  iterator.discard(bytesRemainingInBox);
  return {
    type: "pasp-box",
    boxSize: size4,
    offset,
    hSpacing,
    vSpacing
  };
};
var parseStco = ({
  iterator,
  offset,
  size: size4,
  mode64Bit
}) => {
  const version = iterator.getUint8();
  if (version !== 0) {
    throw new Error(`Unsupported STSD version ${version}`);
  }
  const flags = iterator.getSlice(3);
  const entryCount = iterator.getUint32();
  const entries = [];
  for (let i = 0;i < entryCount; i++) {
    const bytesRemaining = size4 - (iterator.counter.getOffset() - offset);
    if (bytesRemaining < 4) {
      break;
    }
    entries.push(mode64Bit ? iterator.getUint64() : iterator.getUint32());
  }
  iterator.discard(size4 - (iterator.counter.getOffset() - offset));
  return {
    type: "stco-box",
    boxSize: size4,
    offset,
    version,
    flags: [...flags],
    entries,
    entryCount
  };
};
var parseStsc = ({
  iterator,
  offset,
  size: size4
}) => {
  const version = iterator.getUint8();
  if (version !== 0) {
    throw new Error(`Unsupported STSD version ${version}`);
  }
  const flags = iterator.getSlice(3);
  const entryCount = iterator.getUint32();
  const entries = new Map;
  for (let i = 0;i < entryCount; i++) {
    const firstChunk = iterator.getUint32();
    const samplesPerChunk = iterator.getUint32();
    const sampleDescriptionIndex = iterator.getUint32();
    if (sampleDescriptionIndex !== 1) {
      throw new Error(`Expected sampleDescriptionIndex to be 1, but got ${sampleDescriptionIndex}`);
    }
    entries.set(firstChunk, samplesPerChunk);
  }
  return {
    type: "stsc-box",
    boxSize: size4,
    offset,
    version,
    flags: [...flags],
    entryCount,
    entries
  };
};
var parseStsd = async ({
  offset,
  size: size4,
  iterator,
  logLevel,
  contentLength
}) => {
  const version = iterator.getUint8();
  if (version !== 0) {
    throw new Error(`Unsupported STSD version ${version}`);
  }
  iterator.discard(3);
  const numberOfEntries = iterator.getUint32();
  const bytesRemainingInBox = size4 - (iterator.counter.getOffset() - offset);
  const boxes = await parseIsoFormatBoxes({
    maxBytes: bytesRemainingInBox,
    logLevel,
    iterator,
    contentLength
  });
  if (boxes.length !== numberOfEntries) {
    throw new Error(`Expected ${numberOfEntries} sample descriptions, got ${boxes.length}`);
  }
  return {
    type: "stsd-box",
    boxSize: size4,
    offset,
    numberOfEntries,
    samples: boxes
  };
};
var parseStss = ({
  iterator,
  offset,
  boxSize
}) => {
  const version = iterator.getUint8();
  if (version !== 0) {
    throw new Error(`Unsupported STSS version ${version}`);
  }
  const flags = iterator.getSlice(3);
  const sampleCount = iterator.getUint32();
  const sampleNumber = new Set;
  for (let i = 0;i < sampleCount; i++) {
    sampleNumber.add(iterator.getUint32());
  }
  const bytesRemainingInBox = boxSize - (iterator.counter.getOffset() - offset);
  if (bytesRemainingInBox > 0) {
    throw new Error(`Unexpected bytes remaining in box stss`);
  }
  return {
    type: "stss-box",
    version,
    flags: [...flags],
    sampleNumber,
    boxSize,
    offset
  };
};
var parseStsz = ({
  iterator,
  offset,
  size: size4
}) => {
  const version = iterator.getUint8();
  if (version !== 0) {
    throw new Error(`Unsupported STSD version ${version}`);
  }
  const flags = iterator.getSlice(3);
  const sampleSize = iterator.getUint32();
  const sampleCount = iterator.getUint32();
  if (sampleSize !== 0) {
    return {
      type: "stsz-box",
      boxSize: size4,
      offset,
      version,
      flags: [...flags],
      sampleCount,
      countType: "fixed",
      sampleSize
    };
  }
  const samples = [];
  for (let i = 0;i < sampleCount; i++) {
    const bytesRemaining = size4 - (iterator.counter.getOffset() - offset);
    if (bytesRemaining < 4) {
      break;
    }
    samples.push(iterator.getUint32());
  }
  iterator.discard(size4 - (iterator.counter.getOffset() - offset));
  return {
    type: "stsz-box",
    boxSize: size4,
    offset,
    version,
    flags: [...flags],
    sampleCount,
    countType: "variable",
    entries: samples
  };
};
var parseStts = ({
  data,
  size: size4,
  fileOffset
}) => {
  const initialOffset = data.counter.getOffset();
  const initialCounter = initialOffset - fileOffset;
  const version = data.getUint8();
  if (version !== 0) {
    throw new Error(`Unsupported STTS version ${version}`);
  }
  data.discard(3);
  const entryCount = data.getUint32();
  const sampleDistributions = [];
  for (let i = 0;i < entryCount; i++) {
    const sampleCount = data.getUint32();
    const sampleDelta = data.getUint32();
    const sampleDistribution = {
      sampleCount,
      sampleDelta
    };
    sampleDistributions.push(sampleDistribution);
  }
  const bytesUsed = data.counter.getOffset() - initialOffset + initialCounter;
  if (bytesUsed !== size4) {
    throw new Error(`Expected stts box to be ${size4} bytes, but was ${bytesUsed} bytes`);
  }
  return {
    type: "stts-box",
    sampleDistribution: sampleDistributions
  };
};
var getvp09ConfigurationString = ({
  profile,
  level,
  bitDepth: bitDepth2
}) => {
  return `${String(profile).padStart(2, "0")}.${String(level).padStart(2, "0")}.${String(bitDepth2).padStart(2, "0")}`;
};
var parseVpcc = ({
  data,
  size: size4
}) => {
  const box2 = data.startBox(size4 - 8);
  const confVersion = data.getUint8();
  if (confVersion !== 1) {
    throw new Error(`Unsupported AVCC version ${confVersion}`);
  }
  data.discard(3);
  const profile = data.getUint8();
  const level = data.getUint8();
  data.startReadingBits();
  const bitDepth2 = data.getBits(4);
  const chromaSubsampling = data.getBits(3);
  const videoFullRangeFlag = data.getBits(1);
  const videoColorPrimaries = data.getBits(8);
  const videoTransferCharacteristics = data.getBits(8);
  const videoMatrixCoefficients = data.getBits(8);
  data.stopReadingBits();
  const codecInitializationDataSize = data.getUint16();
  const codecInitializationData = data.getSlice(codecInitializationDataSize);
  box2.expectNoMoreBytes();
  return {
    type: "vpcc-box",
    profile,
    level,
    bitDepth: bitDepth2,
    chromaSubsampling,
    videoFullRangeFlag,
    videoColorPrimaries,
    videoTransferCharacteristics,
    videoMatrixCoefficients,
    codecInitializationDataSize,
    codecInitializationData,
    codecString: getvp09ConfigurationString({ profile, level, bitDepth: bitDepth2 })
  };
};
var parseTfdt = ({
  iterator,
  size: size4,
  offset
}) => {
  const version = iterator.getUint8();
  iterator.discard(3);
  const num = version === 0 ? iterator.getUint32() : Number(iterator.getUint64());
  const bytesRemaining = size4 - (iterator.counter.getOffset() - offset);
  if (bytesRemaining !== 0) {
    throw new Error("expected 0 bytes " + bytesRemaining);
  }
  return {
    type: "tfdt-box",
    version,
    baseMediaDecodeTime: num,
    offset
  };
};
var getTfhd = ({
  iterator,
  offset,
  size: size4
}) => {
  const version = iterator.getUint8();
  const flags = iterator.getUint24();
  const trackId = iterator.getUint32();
  const baseDataOffsetPresent = flags & 1;
  const baseDataOffset = baseDataOffsetPresent ? Number(iterator.getUint64()) : 0;
  const baseSampleDescriptionIndexPresent = flags & 2;
  const baseSampleDescriptionIndex = baseSampleDescriptionIndexPresent ? iterator.getUint32() : 0;
  const defaultSampleDurationPresent = flags & 8;
  const defaultSampleDuration = defaultSampleDurationPresent ? iterator.getUint32() : 0;
  const defaultSampleSizePresent = flags & 16;
  const defaultSampleSize = defaultSampleSizePresent ? iterator.getUint32() : 0;
  const defaultSampleFlagsPresent = flags & 32;
  const defaultSampleFlags = defaultSampleFlagsPresent ? iterator.getUint32() : 0;
  const bytesRemaining = size4 - (iterator.counter.getOffset() - offset);
  if (bytesRemaining !== 0) {
    throw new Error("expected 0 bytes " + bytesRemaining);
  }
  return {
    type: "tfhd-box",
    version,
    trackId,
    baseDataOffset,
    baseSampleDescriptionIndex,
    defaultSampleDuration,
    defaultSampleSize,
    defaultSampleFlags
  };
};
function getRotationAngleFromMatrix(matrix) {
  const [a, b, c, d] = matrix;
  if (a === 0 && b === 0 && c === 0 && d === 0) {
    return 0;
  }
  if (Math.round(a * a + b * b) !== 1 || Math.round(c * c + d * d) !== 1) {
    throw new Error("The provided matrix is not a valid rotation matrix.");
  }
  const angleRadians = Math.atan2(c, a);
  const angleDegrees = angleRadians * (180 / Math.PI);
  return angleDegrees;
}
var applyRotation = ({
  matrix,
  width,
  height
}) => {
  const newWidth = matrix[0] * width + matrix[1] * height;
  const newHeight = matrix[2] * width + matrix[3] * height;
  return {
    width: Math.abs(newWidth),
    height: Math.abs(newHeight)
  };
};
var parseTkhd = ({
  iterator,
  offset,
  size: size4
}) => {
  const version = iterator.getUint8();
  iterator.discard(3);
  const creationTime = version === 1 ? iterator.getUint64() : iterator.getUint32();
  const modificationTime = version === 1 ? iterator.getUint64() : iterator.getUint32();
  const trackId = iterator.getUint32();
  iterator.discard(4);
  const duration2 = version === 1 ? iterator.getUint64() : iterator.getUint32();
  iterator.discard(4);
  iterator.discard(4);
  const layer = iterator.getUint16();
  const alternateGroup = iterator.getUint16();
  const volume = iterator.getUint16();
  iterator.discard(2);
  const matrix = [
    iterator.getFixedPointSigned1616Number(),
    iterator.getFixedPointSigned1616Number(),
    iterator.getFixedPointSigned230Number(),
    iterator.getFixedPointSigned1616Number(),
    iterator.getFixedPointSigned1616Number(),
    iterator.getFixedPointSigned230Number(),
    iterator.getFixedPointSigned1616Number(),
    iterator.getFixedPointSigned1616Number(),
    iterator.getFixedPointSigned230Number()
  ];
  const rotationMatrix = [matrix[0], matrix[1], matrix[3], matrix[4]];
  const widthWithoutRotationApplied = iterator.getFixedPointUnsigned1616Number();
  const heightWithoutRotationApplied = iterator.getFixedPointSigned1616Number();
  const { width, height } = applyRotation({
    matrix: rotationMatrix,
    width: widthWithoutRotationApplied,
    height: heightWithoutRotationApplied
  });
  const rotation = getRotationAngleFromMatrix(rotationMatrix);
  return {
    offset,
    boxSize: size4,
    type: "tkhd-box",
    creationTime: toUnixTimestamp(Number(creationTime)),
    modificationTime: toUnixTimestamp(Number(modificationTime)),
    trackId,
    duration: Number(duration2),
    layer,
    alternateGroup,
    volume,
    matrix,
    width,
    height,
    version,
    rotation,
    unrotatedWidth: widthWithoutRotationApplied,
    unrotatedHeight: heightWithoutRotationApplied
  };
};
var parseTrak = async ({
  size: size4,
  offsetAtStart,
  iterator,
  logLevel,
  contentLength
}) => {
  const children = await getIsoBaseMediaChildren({
    onlyIfMoovAtomExpected: null,
    size: size4 - 8,
    iterator,
    logLevel,
    contentLength
  });
  return {
    offset: offsetAtStart,
    boxSize: size4,
    type: "trak-box",
    children
  };
};
var parseTrun = ({
  iterator,
  offset,
  size: size4
}) => {
  const version = iterator.getUint8();
  if (version !== 0 && version !== 1) {
    throw new Error(`Unsupported TRUN version ${version}`);
  }
  const flags = iterator.getUint24();
  const sampleCount = iterator.getUint32();
  const dataOffset = flags & 1 ? iterator.getInt32() : null;
  const firstSampleFlags = flags & 4 ? iterator.getUint32() : null;
  const samples = [];
  for (let i = 0;i < sampleCount; i++) {
    const sampleDuration = flags & 256 ? iterator.getUint32() : null;
    const sampleSize = flags & 512 ? iterator.getUint32() : null;
    const sampleFlags = flags & 1024 ? iterator.getUint32() : null;
    const sampleCompositionTimeOffset = flags & 2048 ? version === 0 ? iterator.getUint32() : iterator.getInt32() : null;
    samples.push({
      sampleDuration,
      sampleSize,
      sampleFlags,
      sampleCompositionTimeOffset
    });
  }
  const currentOffset = iterator.counter.getOffset();
  const left3 = size4 - (currentOffset - offset);
  if (left3 !== 0) {
    throw new Error(`Unexpected data left in TRUN box: ${left3}`);
  }
  return {
    type: "trun-box",
    version,
    sampleCount,
    dataOffset,
    firstSampleFlags,
    samples
  };
};
var processBox = async ({
  iterator,
  logLevel,
  onlyIfMoovAtomExpected,
  onlyIfMdatAtomExpected,
  contentLength
}) => {
  const fileOffset = iterator.counter.getOffset();
  const { returnToCheckpoint } = iterator.startCheckpoint();
  const bytesRemaining = iterator.bytesRemaining();
  const startOff = iterator.counter.getOffset();
  const boxSizeRaw = iterator.getFourByteNumber();
  if (boxSizeRaw === 0) {
    return {
      type: "box",
      box: {
        type: "void-box",
        boxSize: 0
      }
    };
  }
  if (boxSizeRaw === 1 && iterator.bytesRemaining() < 12 || iterator.bytesRemaining() < 4) {
    iterator.counter.decrement(iterator.counter.getOffset() - fileOffset);
    throw new Error(`Expected box size of ${bytesRemaining}, got ${boxSizeRaw}. Incomplete boxes are not allowed.`);
  }
  const maxSize = contentLength - startOff;
  const boxType = iterator.getByteString(4, false);
  const boxSizeUnlimited = boxSizeRaw === 1 ? iterator.getEightByteNumber() : boxSizeRaw;
  const boxSize = Math.min(boxSizeUnlimited, maxSize);
  const headerLength = iterator.counter.getOffset() - startOff;
  if (boxType === "mdat") {
    if (!onlyIfMdatAtomExpected) {
      return { type: "nothing" };
    }
    const { mediaSectionState } = onlyIfMdatAtomExpected;
    mediaSectionState.addMediaSection({
      size: boxSize - headerLength,
      start: iterator.counter.getOffset()
    });
    return { type: "nothing" };
  }
  if (bytesRemaining < boxSize) {
    returnToCheckpoint();
    return {
      type: "fetch-more-data",
      bytesNeeded: makeFetchMoreData(boxSize - bytesRemaining)
    };
  }
  if (boxType === "ftyp") {
    return {
      type: "box",
      box: parseFtyp({ iterator, size: boxSize, offset: fileOffset })
    };
  }
  if (boxType === "elst") {
    return {
      type: "box",
      box: parseElst({
        iterator,
        size: boxSize,
        offset: fileOffset
      })
    };
  }
  if (boxType === "colr") {
    return {
      type: "box",
      box: parseColorParameterBox({
        iterator,
        size: boxSize
      })
    };
  }
  if (boxType === "mvhd") {
    const mvhdBox = parseMvhd({
      iterator,
      offset: fileOffset,
      size: boxSize
    });
    if (!onlyIfMoovAtomExpected) {
      throw new Error("State is required");
    }
    onlyIfMoovAtomExpected.movieTimeScaleState.setTrackTimescale(mvhdBox.timeScale);
    return {
      type: "box",
      box: mvhdBox
    };
  }
  if (boxType === "tkhd") {
    return {
      type: "box",
      box: parseTkhd({ iterator, offset: fileOffset, size: boxSize })
    };
  }
  if (boxType === "trun") {
    return {
      type: "box",
      box: parseTrun({ iterator, offset: fileOffset, size: boxSize })
    };
  }
  if (boxType === "tfdt") {
    return {
      type: "box",
      box: parseTfdt({ iterator, size: boxSize, offset: fileOffset })
    };
  }
  if (boxType === "stsd") {
    return {
      type: "box",
      box: await parseStsd({
        offset: fileOffset,
        size: boxSize,
        iterator,
        logLevel,
        contentLength
      })
    };
  }
  if (boxType === "stsz") {
    return {
      type: "box",
      box: parseStsz({
        iterator,
        offset: fileOffset,
        size: boxSize
      })
    };
  }
  if (boxType === "stco" || boxType === "co64") {
    return {
      type: "box",
      box: parseStco({
        iterator,
        offset: fileOffset,
        size: boxSize,
        mode64Bit: boxType === "co64"
      })
    };
  }
  if (boxType === "pasp") {
    return {
      type: "box",
      box: parsePasp({
        iterator,
        offset: fileOffset,
        size: boxSize
      })
    };
  }
  if (boxType === "stss") {
    return {
      type: "box",
      box: parseStss({
        iterator,
        offset: fileOffset,
        boxSize
      })
    };
  }
  if (boxType === "ctts") {
    return {
      type: "box",
      box: parseCtts({
        iterator,
        offset: fileOffset,
        size: boxSize
      })
    };
  }
  if (boxType === "stsc") {
    return {
      type: "box",
      box: parseStsc({
        iterator,
        offset: fileOffset,
        size: boxSize
      })
    };
  }
  if (boxType === "mebx") {
    return {
      type: "box",
      box: await parseMebx({
        offset: fileOffset,
        size: boxSize,
        iterator,
        logLevel,
        contentLength
      })
    };
  }
  if (boxType === "hdlr") {
    return {
      type: "box",
      box: await parseHdlr({ iterator, size: boxSize, offset: fileOffset })
    };
  }
  if (boxType === "keys") {
    return {
      type: "box",
      box: await parseKeys({ iterator, size: boxSize, offset: fileOffset })
    };
  }
  if (boxType === "ilst") {
    return {
      type: "box",
      box: await parseIlstBox({
        iterator,
        offset: fileOffset,
        size: boxSize
      })
    };
  }
  if (boxType === "tfra") {
    return {
      type: "box",
      box: await parseTfraBox({
        iterator,
        offset: fileOffset,
        size: boxSize
      })
    };
  }
  if (boxType === "moov") {
    if (!onlyIfMoovAtomExpected) {
      throw new Error("State is required");
    }
    const { tracks: tracks2, isoState } = onlyIfMoovAtomExpected;
    if (tracks2.hasAllTracks()) {
      iterator.discard(boxSize - 8);
      return { type: "nothing" };
    }
    if (isoState && isoState.moov.getMoovBoxAndPrecomputed() && !isoState.moov.getMoovBoxAndPrecomputed()?.precomputed) {
      Log.verbose(logLevel, "Moov box already parsed, skipping");
      iterator.discard(boxSize - 8);
      return { type: "nothing" };
    }
    const box2 = await parseMoov({
      offset: fileOffset,
      size: boxSize,
      onlyIfMoovAtomExpected,
      iterator,
      logLevel,
      contentLength
    });
    tracks2.setIsDone(logLevel);
    return { type: "box", box: box2 };
  }
  if (boxType === "trak") {
    if (!onlyIfMoovAtomExpected) {
      throw new Error("State is required");
    }
    const { tracks: tracks2, onAudioTrack, onVideoTrack } = onlyIfMoovAtomExpected;
    const trakBox = await parseTrak({
      size: boxSize,
      offsetAtStart: fileOffset,
      iterator,
      logLevel,
      contentLength
    });
    const movieTimeScale = onlyIfMoovAtomExpected.movieTimeScaleState.getTrackTimescale();
    if (movieTimeScale === null) {
      throw new Error("Movie timescale is not set");
    }
    const editList = findTrackStartTimeInSeconds({ movieTimeScale, trakBox });
    const transformedTrack = makeBaseMediaTrack(trakBox, editList);
    if (transformedTrack && transformedTrack.type === "video") {
      await registerVideoTrack({
        track: transformedTrack,
        container: "mp4",
        logLevel,
        onVideoTrack,
        registerVideoSampleCallback: onlyIfMoovAtomExpected.registerVideoSampleCallback,
        tracks: tracks2
      });
    }
    if (transformedTrack && transformedTrack.type === "audio") {
      await registerAudioTrack({
        track: transformedTrack,
        container: "mp4",
        registerAudioSampleCallback: onlyIfMoovAtomExpected.registerAudioSampleCallback,
        tracks: tracks2,
        logLevel,
        onAudioTrack
      });
    }
    return { type: "box", box: trakBox };
  }
  if (boxType === "stts") {
    return {
      type: "box",
      box: parseStts({
        data: iterator,
        size: boxSize,
        fileOffset
      })
    };
  }
  if (boxType === "avcC") {
    return {
      type: "box",
      box: parseAvcc({
        data: iterator,
        size: boxSize
      })
    };
  }
  if (boxType === "vpcC") {
    return {
      type: "box",
      box: parseVpcc({ data: iterator, size: boxSize })
    };
  }
  if (boxType === "av1C") {
    return {
      type: "box",
      box: parseAv1C({
        data: iterator,
        size: boxSize
      })
    };
  }
  if (boxType === "hvcC") {
    return {
      type: "box",
      box: parseHvcc({
        data: iterator,
        size: boxSize,
        offset: fileOffset
      })
    };
  }
  if (boxType === "tfhd") {
    return {
      type: "box",
      box: getTfhd({
        iterator,
        offset: fileOffset,
        size: boxSize
      })
    };
  }
  if (boxType === "mdhd") {
    return {
      type: "box",
      box: parseMdhd({
        data: iterator,
        size: boxSize,
        fileOffset
      })
    };
  }
  if (boxType === "esds") {
    return {
      type: "box",
      box: parseEsds({
        data: iterator,
        size: boxSize,
        fileOffset
      })
    };
  }
  if (boxType === "trex") {
    return {
      type: "box",
      box: parseTrex({ iterator, offset: fileOffset, size: boxSize })
    };
  }
  if (boxType === "moof") {
    await onlyIfMoovAtomExpected?.isoState?.mfra.triggerLoad();
  }
  if (boxType === "mdia" || boxType === "minf" || boxType === "stbl" || boxType === "udta" || boxType === "moof" || boxType === "dims" || boxType === "meta" || boxType === "wave" || boxType === "traf" || boxType === "mfra" || boxType === "edts" || boxType === "mvex" || boxType === "stsb") {
    const children = await getIsoBaseMediaChildren({
      iterator,
      size: boxSize - 8,
      logLevel,
      onlyIfMoovAtomExpected,
      contentLength
    });
    return {
      type: "box",
      box: {
        type: "regular-box",
        boxType,
        boxSize,
        children,
        offset: fileOffset
      }
    };
  }
  iterator.discard(boxSize - 8);
  Log.verbose(logLevel, "Unknown ISO Base Media Box:", boxType);
  return {
    type: "box",
    box: {
      type: "regular-box",
      boxType,
      boxSize,
      children: [],
      offset: fileOffset
    }
  };
};
var getIsoBaseMediaChildren = async ({
  size: size4,
  iterator,
  logLevel,
  onlyIfMoovAtomExpected,
  contentLength
}) => {
  const boxes = [];
  const initial = iterator.counter.getOffset();
  while (iterator.counter.getOffset() < size4 + initial) {
    const parsed = await processBox({
      iterator,
      logLevel,
      onlyIfMoovAtomExpected,
      onlyIfMdatAtomExpected: null,
      contentLength
    });
    if (parsed.type !== "box") {
      throw new Error("Expected box");
    }
    boxes.push(parsed.box);
  }
  if (iterator.counter.getOffset() > size4 + initial) {
    throw new Error(`read too many bytes - size: ${size4}, read: ${iterator.counter.getOffset() - initial}. initial offset: ${initial}`);
  }
  return boxes;
};
var videoTags = [
  "cvid",
  "jpeg",
  "smc ",
  "rle ",
  "rpza",
  "kpcd",
  "png ",
  "mjpa",
  "mjpb",
  "SVQ1",
  "SVQ3",
  "mp4v",
  "avc1",
  "dvc ",
  "dvcp",
  "gif ",
  "h263",
  "tiff",
  "raw ",
  "2vuY",
  "yuv2",
  "v308",
  "v408",
  "v216",
  "v410",
  "v210",
  "hvc1",
  "hev1",
  "ap4h",
  "av01",
  "vp08",
  "vp09"
];
var audioTags = [
  0,
  "NONE",
  "raw ",
  "twos",
  "sowt",
  "MAC3 ",
  "MAC6 ",
  "ima4",
  "fl32",
  "lpcm",
  "fl64",
  "in24",
  "in32",
  "ulaw",
  "alaw",
  1836253186,
  1836253201,
  "dvca",
  "QDMC",
  "QDM2",
  "Qclp",
  1836253269,
  ".mp3",
  "mp4a",
  "ac-3",
  "Opus"
];
var processIsoFormatBox = async ({
  iterator,
  logLevel,
  contentLength
}) => {
  const fileOffset = iterator.counter.getOffset();
  const bytesRemaining = iterator.bytesRemaining();
  const boxSize = iterator.getUint32();
  if (bytesRemaining < boxSize) {
    throw new Error(`Expected box size of ${bytesRemaining}, got ${boxSize}`);
  }
  const boxFormat = iterator.getAtom();
  const isVideo = videoTags.includes(boxFormat);
  const isAudio = audioTags.includes(boxFormat) || audioTags.includes(Number(boxFormat));
  iterator.discard(6);
  const dataReferenceIndex = iterator.getUint16();
  if (!isVideo && !isAudio) {
    const bytesRemainingInBox = boxSize - (iterator.counter.getOffset() - fileOffset);
    iterator.discard(bytesRemainingInBox);
    return {
      sample: {
        type: "unknown",
        offset: fileOffset,
        dataReferenceIndex,
        size: boxSize,
        format: boxFormat
      }
    };
  }
  if (isAudio) {
    const version = iterator.getUint16();
    const revisionLevel = iterator.getUint16();
    const vendor = iterator.getSlice(4);
    if (version === 0) {
      const numberOfChannels = iterator.getUint16();
      const sampleSize = iterator.getUint16();
      const compressionId = iterator.getUint16();
      const packetSize = iterator.getUint16();
      const sampleRate = iterator.getFixedPointUnsigned1616Number();
      const children = await getIsoBaseMediaChildren({
        iterator,
        logLevel,
        size: boxSize - (iterator.counter.getOffset() - fileOffset),
        onlyIfMoovAtomExpected: null,
        contentLength
      });
      return {
        sample: {
          format: boxFormat,
          offset: fileOffset,
          dataReferenceIndex,
          version,
          revisionLevel,
          vendor: [...Array.from(new Uint8Array(vendor))],
          size: boxSize,
          type: "audio",
          numberOfChannels,
          sampleSize,
          compressionId,
          packetSize,
          sampleRate,
          samplesPerPacket: null,
          bytesPerPacket: null,
          bytesPerFrame: null,
          bitsPerSample: null,
          children
        }
      };
    }
    if (version === 1) {
      const numberOfChannels = iterator.getUint16();
      const sampleSize = iterator.getUint16();
      const compressionId = iterator.getInt16();
      const packetSize = iterator.getUint16();
      const sampleRate = iterator.getFixedPointUnsigned1616Number();
      const samplesPerPacket = iterator.getUint32();
      const bytesPerPacket = iterator.getUint32();
      const bytesPerFrame = iterator.getUint32();
      const bytesPerSample = iterator.getUint32();
      const children = await getIsoBaseMediaChildren({
        iterator,
        logLevel,
        size: boxSize - (iterator.counter.getOffset() - fileOffset),
        onlyIfMoovAtomExpected: null,
        contentLength
      });
      return {
        sample: {
          format: boxFormat,
          offset: fileOffset,
          dataReferenceIndex,
          version,
          revisionLevel,
          vendor: [...Array.from(new Uint8Array(vendor))],
          size: boxSize,
          type: "audio",
          numberOfChannels,
          sampleSize,
          compressionId,
          packetSize,
          sampleRate,
          samplesPerPacket,
          bytesPerPacket,
          bytesPerFrame,
          bitsPerSample: bytesPerSample,
          children
        }
      };
    }
    if (version === 2) {
      iterator.getUint16();
      const sampleSize = iterator.getUint16();
      const compressionId = iterator.getUint16();
      const packetSize = iterator.getUint16();
      iterator.getFixedPointUnsigned1616Number();
      iterator.getUint32();
      const higherSampleRate = iterator.getFloat64();
      const numAudioChannel = iterator.getUint32();
      iterator.getUint32();
      const bitsPerChannel = iterator.getUint32();
      iterator.getUint32();
      const bytesPerFrame = iterator.getUint32();
      const samplesPerPacket = iterator.getUint32();
      const children = await getIsoBaseMediaChildren({
        iterator,
        logLevel,
        size: boxSize - (iterator.counter.getOffset() - fileOffset),
        onlyIfMoovAtomExpected: null,
        contentLength
      });
      return {
        sample: {
          format: boxFormat,
          offset: fileOffset,
          dataReferenceIndex,
          version,
          revisionLevel,
          vendor: [...Array.from(new Uint8Array(vendor))],
          size: boxSize,
          type: "audio",
          numberOfChannels: numAudioChannel,
          sampleSize,
          compressionId,
          packetSize,
          sampleRate: higherSampleRate,
          samplesPerPacket,
          bytesPerPacket: null,
          bytesPerFrame,
          bitsPerSample: bitsPerChannel,
          children
        }
      };
    }
    throw new Error(`Unsupported version ${version}`);
  }
  if (isVideo) {
    const version = iterator.getUint16();
    const revisionLevel = iterator.getUint16();
    const vendor = iterator.getSlice(4);
    const temporalQuality = iterator.getUint32();
    const spacialQuality = iterator.getUint32();
    const width = iterator.getUint16();
    const height = iterator.getUint16();
    const horizontalResolution = iterator.getFixedPointUnsigned1616Number();
    const verticalResolution = iterator.getFixedPointUnsigned1616Number();
    const dataSize = iterator.getUint32();
    const frameCountPerSample = iterator.getUint16();
    const compressorName = iterator.getPascalString();
    const depth = iterator.getUint16();
    const colorTableId = iterator.getInt16();
    const bytesRemainingInBox = boxSize - (iterator.counter.getOffset() - fileOffset);
    const children = bytesRemainingInBox > 8 ? await getIsoBaseMediaChildren({
      onlyIfMoovAtomExpected: null,
      iterator,
      logLevel,
      size: bytesRemainingInBox,
      contentLength
    }) : (iterator.discard(bytesRemainingInBox), []);
    return {
      sample: {
        format: boxFormat,
        offset: fileOffset,
        dataReferenceIndex,
        version,
        revisionLevel,
        vendor: [...Array.from(new Uint8Array(vendor))],
        size: boxSize,
        type: "video",
        width,
        height,
        horizontalResolutionPpi: horizontalResolution,
        verticalResolutionPpi: verticalResolution,
        spacialQuality,
        temporalQuality,
        dataSize,
        frameCountPerSample,
        compressorName,
        depth,
        colorTableId,
        descriptors: children
      }
    };
  }
  throw new Error(`Unknown sample format ${boxFormat}`);
};
var parseIsoFormatBoxes = async ({
  maxBytes,
  logLevel,
  iterator,
  contentLength
}) => {
  const samples = [];
  const initialOffset = iterator.counter.getOffset();
  while (iterator.bytesRemaining() > 0 && iterator.counter.getOffset() - initialOffset < maxBytes) {
    const { sample } = await processIsoFormatBox({
      iterator,
      logLevel,
      contentLength
    });
    if (sample) {
      samples.push(sample);
    }
  }
  return samples;
};
var Extended_SAR = 255;
var getPoc = (iterator, sps, avcState, isReferencePicture) => {
  const { pic_order_cnt_type, log2_max_pic_order_cnt_lsb_minus4 } = sps;
  if (pic_order_cnt_type !== 0) {
    return null;
  }
  const prevPicOrderCntLsb = avcState.getPrevPicOrderCntLsb();
  const prevPicOrderCntMsb = avcState.getPrevPicOrderCntMsb();
  if (log2_max_pic_order_cnt_lsb_minus4 === null) {
    throw new Error("log2_max_pic_order_cnt_lsb_minus4 is null");
  }
  const max_pic_order_cnt_lsb = 2 ** (log2_max_pic_order_cnt_lsb_minus4 + 4);
  const pic_order_cnt_lsb = iterator.getBits(log2_max_pic_order_cnt_lsb_minus4 + 4);
  let picOrderCntMsb;
  if (pic_order_cnt_lsb < prevPicOrderCntLsb && prevPicOrderCntLsb - pic_order_cnt_lsb >= max_pic_order_cnt_lsb / 2) {
    picOrderCntMsb = prevPicOrderCntMsb + max_pic_order_cnt_lsb;
  } else if (pic_order_cnt_lsb > prevPicOrderCntLsb && pic_order_cnt_lsb - prevPicOrderCntLsb > max_pic_order_cnt_lsb / 2) {
    picOrderCntMsb = prevPicOrderCntMsb - max_pic_order_cnt_lsb;
  } else {
    picOrderCntMsb = prevPicOrderCntMsb;
  }
  const poc = picOrderCntMsb + pic_order_cnt_lsb;
  if (isReferencePicture) {
    avcState.setPrevPicOrderCntLsb(pic_order_cnt_lsb);
    avcState.setPrevPicOrderCntMsb(picOrderCntMsb);
  }
  return poc;
};
var readVuiParameters = (iterator) => {
  let sar_width = null;
  let sar_height = null;
  let overscan_appropriate_flag = null;
  let video_format = null;
  let video_full_range_flag = null;
  let colour_primaries = null;
  let transfer_characteristics = null;
  let matrix_coefficients = null;
  let chroma_sample_loc_type_top_field = null;
  let chroma_sample_loc_type_bottom_field = null;
  const aspect_ratio_info_present_flag = iterator.getBits(1);
  if (aspect_ratio_info_present_flag) {
    const aspect_ratio_idc = iterator.getBits(8);
    if (aspect_ratio_idc === Extended_SAR) {
      sar_width = iterator.getBits(16);
      sar_height = iterator.getBits(16);
    }
  }
  const overscan_info_present_flag = iterator.getBits(1);
  if (overscan_info_present_flag) {
    overscan_appropriate_flag = iterator.getBits(1);
  }
  const video_signal_type_present_flag = iterator.getBits(1);
  if (video_signal_type_present_flag) {
    video_format = iterator.getBits(3);
    video_full_range_flag = Boolean(iterator.getBits(1));
    const colour_description_present_flag = iterator.getBits(1);
    if (colour_description_present_flag) {
      colour_primaries = iterator.getBits(8);
      transfer_characteristics = iterator.getBits(8);
      matrix_coefficients = iterator.getBits(8);
    }
  }
  const chroma_loc_info_present_flag = iterator.getBits(1);
  if (chroma_loc_info_present_flag) {
    chroma_sample_loc_type_top_field = iterator.readExpGolomb();
    chroma_sample_loc_type_bottom_field = iterator.readExpGolomb();
  }
  return {
    sar_width,
    sar_height,
    overscan_appropriate_flag,
    chroma_sample_loc_type_bottom_field,
    chroma_sample_loc_type_top_field,
    colour_primaries,
    matrix_coefficients,
    transfer_characteristics,
    video_format,
    video_full_range_flag
  };
};
var readSps = (iterator) => {
  const profile = iterator.getUint8();
  const compatibility = iterator.getUint8();
  const level = iterator.getUint8();
  iterator.startReadingBits();
  const seq_parameter_set_id = iterator.readExpGolomb();
  let separate_colour_plane_flag = null;
  let bit_depth_luma_minus8 = null;
  let bit_depth_chroma_minus8 = null;
  let qpprime_y_zero_transform_bypass_flag = null;
  let log2_max_frame_num_minus4 = null;
  let log2_max_pic_order_cnt_lsb_minus4 = null;
  let max_num_ref_frames = null;
  let gaps_in_frame_num_value_allowed_flag = null;
  let mb_adaptive_frame_field_flag = null;
  let direct_8x8_inference_flag = null;
  let frame_crop_left_offset = null;
  let frame_crop_right_offset = null;
  let frame_crop_top_offset = null;
  let frame_crop_bottom_offset = null;
  let vui_parameters = null;
  if (profile === 100 || profile === 110 || profile === 122 || profile === 244 || profile === 44 || profile === 83 || profile === 86 || profile === 118 || profile === 128 || profile === 138 || profile === 139 || profile === 134 || profile === 135) {
    const chromaFormat = iterator.readExpGolomb();
    if (chromaFormat === 3) {
      separate_colour_plane_flag = iterator.getBits(1);
    }
    bit_depth_luma_minus8 = iterator.readExpGolomb();
    bit_depth_chroma_minus8 = iterator.readExpGolomb();
    qpprime_y_zero_transform_bypass_flag = iterator.getBits(1);
    const seq_scaling_matrix_present_flag = iterator.getBits(1);
    const seq_scaling_list_present_flag = [];
    if (seq_scaling_matrix_present_flag) {
      for (let i = 0;i < (chromaFormat !== 3 ? 8 : 12); i++) {
        seq_scaling_list_present_flag[i] = iterator.getBits(1);
        if (seq_scaling_list_present_flag[i]) {
          if (i < 6) {
            throw new Error("Not implemented");
          } else {
            throw new Error("Not implemented");
          }
        }
      }
    }
  }
  log2_max_frame_num_minus4 = iterator.readExpGolomb();
  const pic_order_cnt_type = iterator.readExpGolomb();
  if (pic_order_cnt_type === 0) {
    log2_max_pic_order_cnt_lsb_minus4 = iterator.readExpGolomb();
  } else if (pic_order_cnt_type === 1) {
    throw new Error("pic_order_cnt_type = 1 not implemented");
  }
  max_num_ref_frames = iterator.readExpGolomb();
  gaps_in_frame_num_value_allowed_flag = iterator.getBits(1);
  const pic_width_in_mbs_minus1 = iterator.readExpGolomb();
  const pic_height_in_map_units_minus1 = iterator.readExpGolomb();
  const frame_mbs_only_flag = iterator.getBits(1);
  if (!frame_mbs_only_flag) {
    mb_adaptive_frame_field_flag = iterator.getBits(1);
  }
  direct_8x8_inference_flag = iterator.getBits(1);
  const frame_cropping_flag = iterator.getBits(1);
  if (frame_cropping_flag) {
    frame_crop_left_offset = iterator.readExpGolomb();
    frame_crop_right_offset = iterator.readExpGolomb();
    frame_crop_top_offset = iterator.readExpGolomb();
    frame_crop_bottom_offset = iterator.readExpGolomb();
  }
  const vui_parameters_present_flag = iterator.getBits(1);
  if (vui_parameters_present_flag) {
    vui_parameters = readVuiParameters(iterator);
  }
  iterator.stopReadingBits();
  return {
    profile,
    compatibility,
    level,
    bit_depth_chroma_minus8,
    bit_depth_luma_minus8,
    gaps_in_frame_num_value_allowed_flag,
    log2_max_frame_num_minus4,
    log2_max_pic_order_cnt_lsb_minus4,
    max_num_ref_frames,
    pic_height_in_map_units_minus1,
    pic_width_in_mbs_minus1,
    qpprime_y_zero_transform_bypass_flag,
    separate_colour_plane_flag,
    seq_parameter_set_id,
    direct_8x8_inference_flag,
    frame_crop_bottom_offset,
    frame_crop_left_offset,
    frame_crop_right_offset,
    frame_crop_top_offset,
    mb_adaptive_frame_field_flag,
    vui_parameters,
    pic_order_cnt_type
  };
};
var findEnd = (buffer) => {
  let zeroesInARow = 0;
  for (let i = 0;i < buffer.length; i++) {
    const val = buffer[i];
    if (val === 0) {
      zeroesInARow++;
      continue;
    }
    if (zeroesInARow >= 2 && val === 1) {
      return i - zeroesInARow;
    }
    zeroesInARow = 0;
  }
  return null;
};
var inspect = (buffer, avcState) => {
  const iterator = getArrayBufferIterator({
    initialData: buffer,
    maxBytes: buffer.byteLength,
    logLevel: "error"
  });
  iterator.startReadingBits();
  iterator.getBits(1);
  const nal_ref_idc = iterator.getBits(2);
  const isReferencePicture = nal_ref_idc !== 0;
  const type = iterator.getBits(5);
  if (type === 7) {
    iterator.stopReadingBits();
    const end = findEnd(buffer);
    const data = readSps(iterator);
    const sps = buffer.slice(0, end === null ? Infinity : end);
    avcState.setSps(data);
    if (isReferencePicture) {
      avcState.setPrevPicOrderCntLsb(0);
      avcState.setPrevPicOrderCntMsb(0);
    }
    return {
      spsData: data,
      sps,
      type: "avc-profile"
    };
  }
  if (type === 5) {
    avcState.setPrevPicOrderCntLsb(0);
    avcState.setPrevPicOrderCntMsb(0);
    iterator.readExpGolomb();
    iterator.readExpGolomb();
    iterator.readExpGolomb();
    const sps = avcState.getSps();
    if (!sps) {
      throw new Error("SPS not found");
    }
    const numberOfBitsForFrameNum = sps.log2_max_frame_num_minus4 + 4;
    iterator.getBits(numberOfBitsForFrameNum);
    iterator.readExpGolomb();
    const { pic_order_cnt_type } = sps;
    let poc = null;
    if (pic_order_cnt_type === 0) {
      poc = getPoc(iterator, sps, avcState, isReferencePicture);
    }
    iterator.stopReadingBits();
    return {
      type: "keyframe",
      poc
    };
  }
  if (type === 8) {
    iterator.stopReadingBits();
    const end = findEnd(buffer);
    const pps = buffer.slice(0, end === null ? Infinity : end);
    return {
      type: "avc-pps",
      pps
    };
  }
  if (type === 1) {
    iterator.readExpGolomb();
    const slice_type = iterator.readExpGolomb();
    const isBidirectionalFrame = slice_type === 6;
    iterator.readExpGolomb();
    const sps = avcState.getSps();
    if (!sps) {
      throw new Error("SPS not found");
    }
    const numberOfBitsForFrameNum = sps.log2_max_frame_num_minus4 + 4;
    iterator.getBits(numberOfBitsForFrameNum);
    const { pic_order_cnt_type } = sps;
    let poc = null;
    if (pic_order_cnt_type === 0) {
      poc = getPoc(iterator, sps, avcState, isReferencePicture);
    }
    iterator.stopReadingBits();
    return {
      type: "delta-frame",
      isBidirectionalFrame,
      poc
    };
  }
  iterator.destroy();
  return null;
};
var parseAvc = (buffer, avcState) => {
  let zeroesInARow = 0;
  const infos = [];
  for (let i = 0;i < buffer.length; i++) {
    const val = buffer[i];
    if (val === 0) {
      zeroesInARow++;
      continue;
    }
    if (zeroesInARow >= 2 && val === 1) {
      zeroesInARow = 0;
      const info = inspect(buffer.slice(i + 1, i + 100), avcState);
      if (info) {
        infos.push(info);
        if (info.type === "keyframe" || info.type === "delta-frame") {
          break;
        }
      }
    }
    if (val !== 1) {
      zeroesInARow = 0;
    }
  }
  return infos;
};
var parseBlockFlags = (iterator, type) => {
  if (type === matroskaElements.Block) {
    iterator.startReadingBits();
    iterator.getBits(4);
    const invisible = Boolean(iterator.getBits(1));
    const lacing = iterator.getBits(2);
    iterator.getBits(1);
    iterator.stopReadingBits();
    return {
      invisible,
      lacing,
      keyframe: null
    };
  }
  if (type === matroskaElements.SimpleBlock) {
    iterator.startReadingBits();
    const keyframe = Boolean(iterator.getBits(1));
    iterator.getBits(3);
    const invisible = Boolean(iterator.getBits(1));
    const lacing = iterator.getBits(2);
    iterator.getBits(1);
    iterator.stopReadingBits();
    return {
      invisible,
      lacing,
      keyframe
    };
  }
  throw new Error("Unexpected type");
};
var addAvcToTrackAndActivateTrackIfNecessary = async ({
  partialVideoSample,
  codec,
  structureState,
  webmState,
  trackNumber: trackNumber2,
  logLevel,
  callbacks,
  onVideoTrack,
  avcState
}) => {
  if (codec !== "V_MPEG4/ISO/AVC") {
    return;
  }
  const missingTracks = getTracksFromMatroska({
    structureState,
    webmState
  }).missingInfo;
  if (missingTracks.length === 0) {
    return;
  }
  const parsed = parseAvc(partialVideoSample.data, avcState);
  for (const parse of parsed) {
    if (parse.type === "avc-profile") {
      webmState.setAvcProfileForTrackNumber(trackNumber2, parse);
      const track = missingTracks.find((t) => t.trackId === trackNumber2);
      if (!track) {
        throw new Error("Could not find track " + trackNumber2);
      }
      const resolvedTracks = getTracksFromMatroska({
        structureState,
        webmState
      }).resolved;
      const resolvedTrack = resolvedTracks.find((t) => t.trackId === trackNumber2);
      if (!resolvedTrack) {
        throw new Error("Could not find track " + trackNumber2);
      }
      await registerVideoTrack({
        track: resolvedTrack,
        container: "webm",
        logLevel,
        onVideoTrack,
        registerVideoSampleCallback: callbacks.registerVideoSampleCallback,
        tracks: callbacks.tracks
      });
    }
  }
};
var getSampleFromBlock = async ({
  ebml,
  webmState,
  offset,
  structureState,
  callbacks,
  logLevel,
  onVideoTrack,
  avcState
}) => {
  const iterator = getArrayBufferIterator({
    initialData: ebml.value,
    maxBytes: ebml.value.length,
    logLevel: "error"
  });
  const trackNumber2 = iterator.getVint();
  if (trackNumber2 === null) {
    throw new Error("Not enough data to get track number, should not happen");
  }
  const timecodeRelativeToCluster = iterator.getInt16();
  const { keyframe } = parseBlockFlags(iterator, ebml.type === "SimpleBlock" ? matroskaElements.SimpleBlock : matroskaElements.Block);
  const { codec, trackTimescale } = webmState.getTrackInfoByNumber(trackNumber2);
  const clusterOffset = webmState.getTimestampOffsetForByteOffset(offset);
  const timescale = webmState.getTimescale();
  if (clusterOffset === undefined) {
    throw new Error("Could not find offset for byte offset " + offset);
  }
  const timecodeInNanoSeconds = (timecodeRelativeToCluster + clusterOffset) * timescale * (trackTimescale ?? 1);
  const timecodeInMicroseconds = timecodeInNanoSeconds / 1000;
  if (!codec) {
    throw new Error(`Could not find codec for track ${trackNumber2}`);
  }
  const remainingNow = ebml.value.length - iterator.counter.getOffset();
  if (codec.startsWith("V_")) {
    const partialVideoSample = {
      data: iterator.getSlice(remainingNow),
      decodingTimestamp: timecodeInMicroseconds,
      duration: undefined,
      timestamp: timecodeInMicroseconds,
      offset
    };
    if (keyframe === null) {
      iterator.destroy();
      return {
        type: "partial-video-sample",
        partialVideoSample,
        trackId: trackNumber2,
        timescale: WEBCODECS_TIMESCALE
      };
    }
    await addAvcToTrackAndActivateTrackIfNecessary({
      codec,
      partialVideoSample,
      structureState,
      webmState,
      trackNumber: trackNumber2,
      callbacks,
      logLevel,
      onVideoTrack,
      avcState
    });
    const sample = {
      ...partialVideoSample,
      type: keyframe ? "key" : "delta"
    };
    iterator.destroy();
    return {
      type: "video-sample",
      videoSample: sample,
      trackId: trackNumber2,
      timescale: WEBCODECS_TIMESCALE
    };
  }
  if (codec.startsWith("A_")) {
    const audioSample = {
      data: iterator.getSlice(remainingNow),
      timestamp: timecodeInMicroseconds,
      type: "key",
      duration: undefined,
      decodingTimestamp: timecodeInMicroseconds,
      offset
    };
    iterator.destroy();
    return {
      type: "audio-sample",
      audioSample,
      trackId: trackNumber2,
      timescale: WEBCODECS_TIMESCALE
    };
  }
  iterator.destroy();
  return {
    type: "no-sample"
  };
};
var parseEbml = async (iterator, statesForProcessing, logLevel) => {
  const hex = iterator.getMatroskaSegmentId();
  if (hex === null) {
    throw new Error("Not enough bytes left to parse EBML - this should not happen");
  }
  const off = iterator.counter.getOffset();
  const size4 = iterator.getVint();
  const minVintWidth = iterator.counter.getOffset() - off;
  if (size4 === null) {
    throw new Error("Not enough bytes left to parse EBML - this should not happen");
  }
  const hasInMap = ebmlMap[hex];
  if (!hasInMap) {
    Log.verbose(logLevel, `Unknown EBML hex ID ${JSON.stringify(hex)}`);
    iterator.discard(size4);
    return null;
  }
  if (hasInMap.type === "uint") {
    const beforeUintOffset = iterator.counter.getOffset();
    const value = size4 === 0 ? 0 : iterator.getUint(size4);
    const { name } = hasInMap;
    return {
      type: name,
      value: {
        value,
        byteLength: iterator.counter.getOffset() - beforeUintOffset
      },
      minVintWidth
    };
  }
  if (hasInMap.type === "string") {
    const value = iterator.getByteString(size4, true);
    return {
      type: hasInMap.name,
      value,
      minVintWidth
    };
  }
  if (hasInMap.type === "float") {
    const value = size4 === 0 ? 0 : size4 === 4 ? iterator.getFloat32() : iterator.getFloat64();
    return {
      type: hasInMap.name,
      value: {
        value,
        size: size4 === 4 ? "32" : "64"
      },
      minVintWidth
    };
  }
  if (hasInMap.type === "hex-string") {
    return {
      type: hasInMap.name,
      value: "0x" + [...iterator.getSlice(size4)].map((b) => b.toString(16).padStart(2, "0")).join("").replace(new RegExp("^" + hex), ""),
      minVintWidth
    };
  }
  if (hasInMap.type === "uint8array") {
    return {
      type: hasInMap.name,
      value: iterator.getSlice(size4),
      minVintWidth
    };
  }
  if (hasInMap.type === "children") {
    const children = [];
    const startOffset = iterator.counter.getOffset();
    while (true) {
      if (size4 === 0) {
        break;
      }
      const offset = iterator.counter.getOffset();
      const value = await parseEbml(iterator, statesForProcessing, logLevel);
      if (value) {
        const remapped = statesForProcessing ? await postprocessEbml({
          offset,
          ebml: value,
          statesForProcessing
        }) : value;
        children.push(remapped);
      }
      const offsetNow = iterator.counter.getOffset();
      if (offsetNow - startOffset > size4) {
        throw new Error(`Offset ${offsetNow - startOffset} is larger than the length of the hex ${size4}`);
      }
      if (offsetNow - startOffset === size4) {
        break;
      }
    }
    return { type: hasInMap.name, value: children, minVintWidth };
  }
  throw new Error(`Unknown segment type ${hasInMap.type}`);
};
var postprocessEbml = async ({
  offset,
  ebml,
  statesForProcessing: {
    webmState,
    callbacks,
    logLevel,
    onAudioTrack,
    onVideoTrack,
    structureState,
    avcState
  }
}) => {
  if (ebml.type === "TimestampScale") {
    webmState.setTimescale(ebml.value.value);
  }
  if (ebml.type === "Tracks") {
    callbacks.tracks.setIsDone(logLevel);
  }
  if (ebml.type === "TrackEntry") {
    webmState.onTrackEntrySegment(ebml);
    const track = getTrack({
      track: ebml,
      timescale: webmState.getTimescale()
    });
    if (track && track.type === "audio") {
      await registerAudioTrack({
        track,
        container: "webm",
        registerAudioSampleCallback: callbacks.registerAudioSampleCallback,
        tracks: callbacks.tracks,
        logLevel,
        onAudioTrack
      });
    }
    if (track && track.type === "video") {
      if (track.codec !== NO_CODEC_PRIVATE_SHOULD_BE_DERIVED_FROM_SPS) {
        await registerVideoTrack({
          track,
          container: "webm",
          logLevel,
          onVideoTrack,
          registerVideoSampleCallback: callbacks.registerVideoSampleCallback,
          tracks: callbacks.tracks
        });
      }
    }
  }
  if (ebml.type === "Timestamp") {
    webmState.setTimestampOffset(offset, ebml.value.value);
  }
  if (ebml.type === "Block" || ebml.type === "SimpleBlock") {
    const sample = await getSampleFromBlock({
      ebml,
      webmState,
      offset,
      structureState,
      callbacks,
      logLevel,
      onVideoTrack,
      avcState
    });
    if (sample.type === "video-sample") {
      await callbacks.onVideoSample({
        videoSample: sample.videoSample,
        trackId: sample.trackId
      });
      return {
        type: "Block",
        value: new Uint8Array([]),
        minVintWidth: ebml.minVintWidth
      };
    }
    if (sample.type === "audio-sample") {
      await callbacks.onAudioSample({
        audioSample: sample.audioSample,
        trackId: sample.trackId
      });
      return {
        type: "Block",
        value: new Uint8Array([]),
        minVintWidth: ebml.minVintWidth
      };
    }
    if (sample.type === "no-sample") {
      return {
        type: "Block",
        value: new Uint8Array([]),
        minVintWidth: ebml.minVintWidth
      };
    }
  }
  if (ebml.type === "BlockGroup") {
    const block2 = ebml.value.find((c) => c.type === "SimpleBlock" || c.type === "Block");
    if (!block2 || block2.type !== "SimpleBlock" && block2.type !== "Block") {
      throw new Error("Expected block segment");
    }
    const hasReferenceBlock = ebml.value.find((c) => c.type === "ReferenceBlock");
    const sample = block2.value.length === 0 ? null : await getSampleFromBlock({
      ebml: block2,
      webmState,
      offset,
      structureState,
      callbacks,
      logLevel,
      onVideoTrack,
      avcState
    });
    if (sample && sample.type === "partial-video-sample") {
      const completeFrame = {
        ...sample.partialVideoSample,
        type: hasReferenceBlock ? "delta" : "key"
      };
      await callbacks.onVideoSample({
        videoSample: completeFrame,
        trackId: sample.trackId
      });
    }
    return {
      type: "BlockGroup",
      value: [],
      minVintWidth: ebml.minVintWidth
    };
  }
  return ebml;
};

class IsAnImageError extends Error {
  imageType;
  dimensions;
  mimeType;
  sizeInBytes;
  fileName;
  constructor({
    dimensions,
    imageType,
    message,
    mimeType,
    sizeInBytes,
    fileName
  }) {
    super(message);
    this.name = "IsAnImageError";
    this.imageType = imageType;
    this.dimensions = dimensions;
    this.mimeType = mimeType;
    this.sizeInBytes = sizeInBytes;
    this.fileName = fileName;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, IsAnImageError);
    }
  }
}

class IsAPdfError extends Error {
  mimeType;
  sizeInBytes;
  fileName;
  constructor({
    message,
    mimeType,
    sizeInBytes,
    fileName
  }) {
    super(message);
    this.name = "IsAPdfError";
    this.mimeType = mimeType;
    this.sizeInBytes = sizeInBytes;
    this.fileName = fileName;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, IsAPdfError);
    }
  }
}

class IsAnUnsupportedFileTypeError extends Error {
  mimeType;
  sizeInBytes;
  fileName;
  constructor({
    message,
    mimeType,
    sizeInBytes,
    fileName
  }) {
    super(message);
    this.name = "IsAnUnsupportedFileTypeError";
    this.mimeType = mimeType;
    this.sizeInBytes = sizeInBytes;
    this.fileName = fileName;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, IsAnUnsupportedFileTypeError);
    }
  }
}

class MediaParserAbortError extends Error {
  constructor(message) {
    super(message);
    this.name = "MediaParserAbortError";
    this.cause = undefined;
  }
}
var hasBeenAborted = (error) => {
  return error instanceof MediaParserAbortError || error.name === "MediaParserAbortError" || error.name === "AbortError";
};
var withResolvers = function() {
  let resolve;
  let reject;
  const promise = new Promise((res, rej) => {
    resolve = res;
    reject = rej;
  });
  return { promise, resolve, reject };
};

class MediaParserEmitter {
  listeners = {
    pause: [],
    resume: [],
    abort: [],
    seek: []
  };
  readyPromise;
  #markAsReady;
  constructor() {
    const { promise, resolve } = withResolvers();
    this.readyPromise = promise;
    this.#markAsReady = resolve;
  }
  markAsReady = () => {
    this.#markAsReady();
  };
  addEventListener = (name, callback) => {
    this.listeners[name].push(callback);
  };
  removeEventListener = (name, callback) => {
    this.listeners[name] = this.listeners[name].filter((l) => l !== callback);
  };
  dispatchEvent(dispatchName, context) {
    this.listeners[dispatchName].forEach((callback) => {
      callback({ detail: context });
    });
  }
  dispatchPause = () => {
    this.readyPromise = this.readyPromise.then(() => {
      this.dispatchEvent("pause", undefined);
    });
  };
  dispatchResume = () => {
    this.readyPromise = this.readyPromise.then(() => {
      this.dispatchEvent("resume", undefined);
    });
  };
  dispatchAbort = (reason) => {
    this.readyPromise = this.readyPromise.then(() => {
      this.dispatchEvent("abort", { reason });
    });
  };
  dispatchSeek = (seek2) => {
    this.readyPromise = this.readyPromise.then(() => {
      this.dispatchEvent("seek", { seek: seek2 });
    });
  };
}
var makePauseSignal = (emitter) => {
  const waiterFns = [];
  let paused = false;
  return {
    pause: () => {
      if (paused) {
        return;
      }
      emitter.dispatchPause();
      paused = true;
    },
    resume: () => {
      if (!paused) {
        return;
      }
      paused = false;
      for (const waiterFn of waiterFns) {
        waiterFn();
      }
      waiterFns.length = 0;
      emitter.dispatchResume();
    },
    waitUntilResume: () => {
      return new Promise((resolve) => {
        if (!paused) {
          resolve();
        } else {
          waiterFns.push(resolve);
        }
      });
    }
  };
};
var performedSeeksStats = () => {
  const performedSeeks = [];
  const markLastSeekAsUserInitiated = () => {
    if (performedSeeks.length > 0) {
      performedSeeks[performedSeeks.length - 1].type = "user-initiated";
    }
  };
  return {
    recordSeek: (seek2) => {
      performedSeeks.push(seek2);
    },
    getPerformedSeeks: () => {
      return performedSeeks;
    },
    markLastSeekAsUserInitiated
  };
};
var makeSeekSignal = (emitter) => {
  let seek2 = null;
  return {
    seek: (seekRequest) => {
      seek2 = seekRequest;
      emitter.dispatchSeek(seekRequest);
    },
    getSeek() {
      return seek2;
    },
    clearSeekIfStillSame(previousSeek) {
      if (seek2 === previousSeek) {
        seek2 = null;
        return { hasChanged: false };
      }
      return { hasChanged: true };
    }
  };
};
var mediaParserController = () => {
  const abortController = new AbortController;
  const emitter = new MediaParserEmitter;
  const pauseSignal = makePauseSignal(emitter);
  const seekSignal = makeSeekSignal(emitter);
  const performedSeeksSignal = performedSeeksStats();
  const checkForAbortAndPause = async () => {
    if (abortController.signal.aborted) {
      const err = new MediaParserAbortError("Aborted");
      if (abortController.signal.reason) {
        err.cause = abortController.signal.reason;
      }
      throw err;
    }
    await pauseSignal.waitUntilResume();
  };
  let seekingHintResolution = null;
  let simulateSeekResolution = null;
  const getSeekingHints = () => {
    if (!seekingHintResolution) {
      throw new Error("The mediaParserController() was not yet used in a parseMedia() call");
    }
    return seekingHintResolution();
  };
  const simulateSeek = (seekInSeconds) => {
    if (!simulateSeekResolution) {
      throw new Error("The mediaParserController() was not yet used in a parseMedia() call");
    }
    return simulateSeekResolution(seekInSeconds);
  };
  const attachSeekingHintResolution = (callback) => {
    if (seekingHintResolution) {
      throw new Error("The mediaParserController() was used in multiple parseMedia() calls. Create a separate controller for each call.");
    }
    seekingHintResolution = callback;
  };
  const attachSimulateSeekResolution = (callback) => {
    if (simulateSeekResolution) {
      throw new Error("The mediaParserController() was used in multiple parseMedia() calls. Create a separate controller for each call.");
    }
    simulateSeekResolution = callback;
  };
  return {
    abort: (reason) => {
      abortController.abort(reason);
      emitter.dispatchAbort(reason);
    },
    seek: seekSignal.seek,
    simulateSeek,
    pause: pauseSignal.pause,
    resume: pauseSignal.resume,
    addEventListener: emitter.addEventListener,
    removeEventListener: emitter.removeEventListener,
    getSeekingHints,
    _internals: {
      signal: abortController.signal,
      checkForAbortAndPause,
      seekSignal,
      markAsReadyToEmitEvents: emitter.markAsReady,
      performedSeeksSignal,
      attachSeekingHintResolution,
      attachSimulateSeekResolution
    }
  };
};
var isIndependentSegments = (structure) => {
  if (structure === null || structure.type !== "m3u") {
    return false;
  }
  return structure.boxes.some((box2) => box2.type === "m3u-independent-segments" || box2.type === "m3u-stream-info");
};
var getM3uStreams = ({
  structure,
  originalSrc,
  readerInterface
}) => {
  if (structure === null || structure.type !== "m3u") {
    return null;
  }
  const boxes = [];
  for (let i = 0;i < structure.boxes.length; i++) {
    const str = structure.boxes[i];
    if (str.type === "m3u-stream-info") {
      const next = structure.boxes[i + 1];
      if (next.type !== "m3u-text-value") {
        throw new Error("Expected m3u-text-value");
      }
      const associatedPlaylists = [];
      if (str.audio) {
        const match = structure.boxes.filter((box2) => {
          return box2.type === "m3u-media-info" && box2.groupId === str.audio;
        });
        for (const audioTrack of match) {
          associatedPlaylists.push({
            autoselect: audioTrack.autoselect,
            channels: audioTrack.channels,
            default: audioTrack.default,
            groupId: audioTrack.groupId,
            language: audioTrack.language,
            name: audioTrack.name,
            src: readerInterface.createAdjacentFileSource(audioTrack.uri, originalSrc),
            id: associatedPlaylists.length,
            isAudio: true
          });
        }
      }
      boxes.push({
        src: readerInterface.createAdjacentFileSource(next.value, originalSrc),
        averageBandwidthInBitsPerSec: str.averageBandwidthInBitsPerSec,
        bandwidthInBitsPerSec: str.bandwidthInBitsPerSec,
        codecs: str.codecs,
        dimensions: str.dimensions,
        associatedPlaylists
      });
    }
  }
  if (boxes.length === 0) {
    return null;
  }
  const sorted = boxes.slice().sort((a, b) => {
    const aResolution = a.dimensions ? a.dimensions.width * a.dimensions.height : 0;
    const bResolution = b.dimensions ? b.dimensions.width * b.dimensions.height : 0;
    if (aResolution === bResolution) {
      const bandwidthA = a.averageBandwidthInBitsPerSec ?? a.bandwidthInBitsPerSec ?? 0;
      const bandwidthB = b.averageBandwidthInBitsPerSec ?? b.bandwidthInBitsPerSec ?? 0;
      return bandwidthB - bandwidthA;
    }
    return bResolution - aResolution;
  });
  return sorted.map((box2, index) => ({ ...box2, id: index }));
};
var m3uHasStreams = (state) => {
  const structure = state.structure.getStructureOrNull();
  if (!structure) {
    return false;
  }
  if (structure.type !== "m3u") {
    return true;
  }
  return state.m3u.hasFinishedManifest();
};
var getContainer = (segments) => {
  if (segments.type === "iso-base-media") {
    return "mp4";
  }
  if (segments.type === "matroska") {
    return "webm";
  }
  if (segments.type === "transport-stream") {
    return "transport-stream";
  }
  if (segments.type === "mp3") {
    return "mp3";
  }
  if (segments.type === "wav") {
    return "wav";
  }
  if (segments.type === "flac") {
    return "flac";
  }
  if (segments.type === "riff") {
    if (isRiffAvi2(segments)) {
      return "avi";
    }
    throw new Error("Unknown RIFF container " + segments.type);
  }
  if (segments.type === "aac") {
    return "aac";
  }
  if (segments.type === "m3u") {
    return "m3u8";
  }
  throw new Error("Unknown container " + segments);
};
var hasContainer = (boxes) => {
  try {
    return getContainer(boxes) !== null;
  } catch {
    return false;
  }
};
var getDimensions = (state) => {
  const structure = state.structure.getStructureOrNull();
  if (structure && isAudioStructure(structure)) {
    return null;
  }
  const tracks2 = getTracks(state, true);
  if (!tracks2.length) {
    return null;
  }
  const firstVideoTrack = tracks2.find((t) => t.type === "video");
  if (!firstVideoTrack) {
    return null;
  }
  return {
    width: firstVideoTrack.width,
    height: firstVideoTrack.height,
    rotation: firstVideoTrack.rotation,
    unrotatedHeight: firstVideoTrack.displayAspectHeight,
    unrotatedWidth: firstVideoTrack.displayAspectWidth
  };
};
var hasDimensions = (state) => {
  const structure = state.structure.getStructureOrNull();
  if (structure && isAudioStructure(structure)) {
    return true;
  }
  try {
    return getDimensions(state) !== null;
  } catch {
    return false;
  }
};
var getDurationFromFlac = (parserState) => {
  const structure = parserState.structure.getFlacStructure();
  const streaminfo = structure.boxes.find((b) => b.type === "flac-streaminfo");
  if (!streaminfo) {
    throw new Error("Streaminfo not found");
  }
  return streaminfo.totalSamples / streaminfo.sampleRate;
};
var areSamplesComplete = ({
  moofBoxes,
  tfraBoxes
}) => {
  if (moofBoxes.length === 0) {
    return true;
  }
  return tfraBoxes.length > 0 && tfraBoxes.every((t) => t.entries.length === moofBoxes.length);
};
var getSamplesFromTraf = (trafSegment, moofOffset, trexBoxes) => {
  if (trafSegment.type !== "regular-box" || trafSegment.boxType !== "traf") {
    throw new Error("Expected traf-box");
  }
  const tfhdBox = getTfhdBox(trafSegment);
  const trexBox = trexBoxes.find((t) => t.trackId === tfhdBox?.trackId) ?? null;
  const defaultTrackSampleDuration = tfhdBox?.defaultSampleDuration || trexBox?.defaultSampleDuration || null;
  const defaultTrackSampleSize = tfhdBox?.defaultSampleSize || trexBox?.defaultSampleSize || null;
  const defaultTrackSampleFlags = tfhdBox?.defaultSampleFlags ?? trexBox?.defaultSampleFlags ?? null;
  const tfdtBox = getTfdtBox(trafSegment);
  const trunBoxes = getTrunBoxes(trafSegment);
  let time2 = 0;
  let offset = 0;
  let dataOffset = 0;
  const samples = [];
  for (const trunBox of trunBoxes) {
    let i = -1;
    if (trunBox.dataOffset) {
      dataOffset = trunBox.dataOffset;
      offset = 0;
    }
    for (const sample of trunBox.samples) {
      i++;
      const duration2 = sample.sampleDuration || defaultTrackSampleDuration;
      if (duration2 === null) {
        throw new Error("Expected duration");
      }
      const size4 = sample.sampleSize ?? defaultTrackSampleSize;
      if (size4 === null) {
        throw new Error("Expected size");
      }
      const isFirstSample = i === 0;
      const sampleFlags = sample.sampleFlags ? sample.sampleFlags : isFirstSample && trunBox.firstSampleFlags !== null ? trunBox.firstSampleFlags : defaultTrackSampleFlags;
      if (sampleFlags === null) {
        throw new Error("Expected sample flags");
      }
      const keyframe = !(sampleFlags >> 16 & 1);
      const dts = time2 + (tfdtBox?.baseMediaDecodeTime ?? 0);
      const samplePosition = {
        offset: offset + (moofOffset ?? 0) + (dataOffset ?? 0),
        decodingTimestamp: dts,
        timestamp: dts + (sample.sampleCompositionTimeOffset ?? 0),
        duration: duration2,
        isKeyframe: keyframe,
        size: size4,
        chunk: 0,
        bigEndian: false,
        chunkSize: null
      };
      samples.push(samplePosition);
      offset += size4;
      time2 += duration2;
    }
  }
  return samples;
};
var getSamplesFromMoof = ({
  moofBox,
  trackId,
  trexBoxes
}) => {
  const mapped = moofBox.trafBoxes.map((traf) => {
    const tfhdBox = getTfhdBox(traf);
    if (!tfhdBox || tfhdBox.trackId !== trackId) {
      return [];
    }
    return getSamplesFromTraf(traf, moofBox.offset, trexBoxes);
  });
  return mapped.flat(1);
};
var collectSamplePositionsFromMoofBoxes = ({
  moofBoxes,
  tkhdBox,
  isComplete,
  trexBoxes
}) => {
  const samplePositions = moofBoxes.map((m, index) => {
    const isLastFragment = index === moofBoxes.length - 1 && isComplete;
    return {
      isLastFragment,
      samples: getSamplesFromMoof({
        moofBox: m,
        trackId: tkhdBox.trackId,
        trexBoxes
      })
    };
  });
  return { samplePositions, isComplete };
};
var getSamplePositions = ({
  stcoBox,
  stszBox,
  stscBox,
  stssBox,
  sttsBox,
  cttsBox
}) => {
  const sttsDeltas = [];
  for (const distribution of sttsBox.sampleDistribution) {
    for (let i = 0;i < distribution.sampleCount; i++) {
      sttsDeltas.push(distribution.sampleDelta);
    }
  }
  const cttsEntries = [];
  for (const entry of cttsBox?.entries ?? [
    { sampleCount: sttsDeltas.length, sampleOffset: 0 }
  ]) {
    for (let i = 0;i < entry.sampleCount; i++) {
      cttsEntries.push(entry.sampleOffset);
    }
  }
  let dts = 0;
  const chunks = stcoBox.entries;
  const samples = [];
  let samplesPerChunk = 1;
  for (let i = 0;i < chunks.length; i++) {
    const hasEntry = stscBox.entries.get(i + 1);
    if (hasEntry !== undefined) {
      samplesPerChunk = hasEntry;
    }
    let offsetInThisChunk = 0;
    for (let j = 0;j < samplesPerChunk; j++) {
      const size4 = stszBox.countType === "fixed" ? stszBox.sampleSize : stszBox.entries[samples.length];
      const isKeyframe = stssBox ? stssBox.sampleNumber.has(samples.length + 1) : true;
      const delta = sttsDeltas[samples.length];
      const ctsOffset = cttsEntries[samples.length];
      const cts = dts + ctsOffset;
      samples.push({
        offset: Number(chunks[i]) + offsetInThisChunk,
        size: size4,
        isKeyframe,
        decodingTimestamp: dts,
        timestamp: cts,
        duration: delta,
        chunk: i,
        bigEndian: false,
        chunkSize: null
      });
      dts += delta;
      offsetInThisChunk += size4;
    }
  }
  return samples;
};
var getGroupedSamplesPositionsFromMp4 = ({
  trakBox,
  bigEndian
}) => {
  const stscBox = getStscBox(trakBox);
  const stszBox = getStszBox(trakBox);
  const stcoBox = getStcoBox(trakBox);
  if (!stscBox) {
    throw new Error("Expected stsc box in trak box");
  }
  if (!stcoBox) {
    throw new Error("Expected stco box in trak box");
  }
  if (!stszBox) {
    throw new Error("Expected stsz box in trak box");
  }
  if (stszBox.countType !== "fixed") {
    throw new Error("Only supporting fixed count type in stsz box");
  }
  const samples = [];
  let timestamp = 0;
  const stscKeys = Array.from(stscBox.entries.keys());
  for (let i = 0;i < stcoBox.entries.length; i++) {
    const entry = stcoBox.entries[i];
    const chunk = i + 1;
    const stscEntry = stscKeys.findLast((e) => e <= chunk);
    if (stscEntry === undefined) {
      throw new Error("should not be");
    }
    const samplesPerChunk = stscBox.entries.get(stscEntry);
    if (samplesPerChunk === undefined) {
      throw new Error("should not be");
    }
    samples.push({
      chunk,
      timestamp,
      decodingTimestamp: timestamp,
      offset: Number(entry),
      size: stszBox.sampleSize * samplesPerChunk,
      duration: samplesPerChunk,
      isKeyframe: true,
      bigEndian,
      chunkSize: stszBox.sampleSize
    });
    timestamp += samplesPerChunk;
  }
  return samples;
};
var shouldGroupAudioSamples = (trakBox) => {
  const isLpcm = isLpcmAudioCodec(trakBox);
  const isIn24 = isIn24AudioCodec(trakBox);
  const isTwos = isTwosAudioCodec(trakBox);
  if (isLpcm || isIn24 || isTwos) {
    return {
      bigEndian: isTwos || isIn24
    };
  }
  return null;
};
var collectSamplePositionsFromTrak = (trakBox) => {
  const shouldGroupSamples = shouldGroupAudioSamples(trakBox);
  const timescaleAndDuration = getTimescaleAndDuration(trakBox);
  if (shouldGroupSamples) {
    return getGroupedSamplesPositionsFromMp4({
      trakBox,
      bigEndian: shouldGroupSamples.bigEndian
    });
  }
  const stszBox = getStszBox(trakBox);
  const stcoBox = getStcoBox(trakBox);
  const stscBox = getStscBox(trakBox);
  const stssBox = getStssBox(trakBox);
  const sttsBox = getSttsBox(trakBox);
  const cttsBox = getCttsBox(trakBox);
  if (!stszBox) {
    throw new Error("Expected stsz box in trak box");
  }
  if (!stcoBox) {
    throw new Error("Expected stco box in trak box");
  }
  if (!stscBox) {
    throw new Error("Expected stsc box in trak box");
  }
  if (!sttsBox) {
    throw new Error("Expected stts box in trak box");
  }
  if (!timescaleAndDuration) {
    throw new Error("Expected timescale and duration in trak box");
  }
  const samplePositions = getSamplePositions({
    stcoBox,
    stscBox,
    stszBox,
    stssBox,
    sttsBox,
    cttsBox
  });
  return samplePositions;
};
var getSamplePositionsFromTrack = ({
  trakBox,
  moofBoxes,
  moofComplete,
  trexBoxes
}) => {
  const tkhdBox = getTkhdBox(trakBox);
  if (!tkhdBox) {
    throw new Error("Expected tkhd box in trak box");
  }
  if (moofBoxes.length > 0) {
    const { samplePositions } = collectSamplePositionsFromMoofBoxes({
      moofBoxes,
      tkhdBox,
      isComplete: moofComplete,
      trexBoxes
    });
    return {
      samplePositions: samplePositions.map((s) => s.samples).flat(1),
      isComplete: moofComplete
    };
  }
  return {
    samplePositions: collectSamplePositionsFromTrak(trakBox),
    isComplete: true
  };
};
var getAllPlaylists = ({
  structure,
  src
}) => {
  const isIndependent = isIndependentSegments(structure);
  if (!isIndependent) {
    return [
      {
        type: "m3u-playlist",
        boxes: structure.boxes,
        src
      }
    ];
  }
  const playlists = structure.boxes.filter((box2) => box2.type === "m3u-playlist");
  return playlists;
};
var getPlaylist = (structure, src) => {
  const allPlaylists = getAllPlaylists({ structure, src });
  const playlists = allPlaylists.find((box2) => box2.src === src);
  if (!playlists) {
    throw new Error(`Expected m3u-playlist with src ${src}`);
  }
  return playlists;
};
var getDurationFromPlaylist = (playlist) => {
  const duration2 = playlist.boxes.filter((box2) => box2.type === "m3u-extinf");
  if (duration2.length === 0) {
    throw new Error("Expected duration in m3u playlist");
  }
  return duration2.reduce((acc, d) => acc + d.value, 0);
};
var getDurationFromM3u = (state) => {
  const playlists = getAllPlaylists({
    structure: state.structure.getM3uStructure(),
    src: state.src
  });
  return Math.max(...playlists.map((p) => {
    return getDurationFromPlaylist(p);
  }));
};
var getUnroundedMpegFrameLength = ({
  samplesPerFrame,
  bitrateKbit,
  samplingFrequency: samplingFrequency2,
  padding: padding3,
  layer
}) => {
  if (layer === 1) {
    throw new Error("MPEG Layer I is not supported");
  }
  return samplesPerFrame / 8 * bitrateKbit / samplingFrequency2 * 1000 + (padding3 ? layer === 1 ? 4 : 1 : 0);
};
var getAverageMpegFrameLength = ({
  samplesPerFrame,
  bitrateKbit,
  samplingFrequency: samplingFrequency2,
  layer
}) => {
  const withoutPadding = getUnroundedMpegFrameLength({
    bitrateKbit,
    layer,
    padding: false,
    samplesPerFrame,
    samplingFrequency: samplingFrequency2
  });
  const rounded = Math.floor(withoutPadding);
  const rest = withoutPadding % 1;
  return rest * (rounded + 1) + (1 - rest) * rounded;
};
var getMpegFrameLength = ({
  samplesPerFrame,
  bitrateKbit,
  samplingFrequency: samplingFrequency2,
  padding: padding3,
  layer
}) => {
  return Math.floor(getUnroundedMpegFrameLength({
    bitrateKbit,
    layer,
    padding: padding3,
    samplesPerFrame,
    samplingFrequency: samplingFrequency2
  }));
};
var getSamplesPerMpegFrame = ({
  mpegVersion,
  layer
}) => {
  if (mpegVersion === 1) {
    if (layer === 1) {
      return 384;
    }
    if (layer === 2 || layer === 3) {
      return 1152;
    }
  }
  if (mpegVersion === 2) {
    if (layer === 1) {
      return 384;
    }
    if (layer === 2) {
      return 1152;
    }
    if (layer === 3) {
      return 576;
    }
  }
  throw new Error("Invalid MPEG layer");
};
var getDurationFromMp3Xing = ({
  xingData,
  samplesPerFrame
}) => {
  const xingFrames = xingData.numberOfFrames;
  if (!xingFrames) {
    throw new Error("Cannot get duration of VBR MP3 file - no frames");
  }
  const { sampleRate } = xingData;
  if (!sampleRate) {
    throw new Error("Cannot get duration of VBR MP3 file - no sample rate");
  }
  const xingSamples = xingFrames * samplesPerFrame;
  return xingSamples / sampleRate;
};
var getDurationFromMp3 = (state) => {
  const mp3Info = state.mp3.getMp3Info();
  const mp3BitrateInfo = state.mp3.getMp3BitrateInfo();
  if (!mp3Info || !mp3BitrateInfo) {
    return null;
  }
  const samplesPerFrame = getSamplesPerMpegFrame({
    layer: mp3Info.layer,
    mpegVersion: mp3Info.mpegVersion
  });
  if (mp3BitrateInfo.type === "variable") {
    return getDurationFromMp3Xing({
      xingData: mp3BitrateInfo.xingData,
      samplesPerFrame
    });
  }
  const frameLengthInBytes = getMpegFrameLength({
    bitrateKbit: mp3BitrateInfo.bitrateInKbit,
    padding: false,
    samplesPerFrame,
    samplingFrequency: mp3Info.sampleRate,
    layer: mp3Info.layer
  });
  const frames = Math.floor((state.contentLength - state.mediaSection.getMediaSectionAssertOnlyOne().start) / frameLengthInBytes);
  const samples = frames * samplesPerFrame;
  const durationInSeconds = samples / mp3Info.sampleRate;
  return durationInSeconds;
};
var getDurationFromAvi = (structure) => {
  const strl = getStrlBoxes(structure);
  const lengths = [];
  for (const s of strl) {
    const strh = getStrhBox(s.children);
    if (!strh) {
      throw new Error("No strh box");
    }
    const samplesPerSecond = strh.rate / strh.scale;
    const streamLength = strh.length / samplesPerSecond;
    lengths.push(streamLength);
  }
  return Math.max(...lengths);
};
var getDurationFromWav = (state) => {
  const structure = state.structure.getWavStructure();
  const fmt = structure.boxes.find((b) => b.type === "wav-fmt");
  if (!fmt) {
    throw new Error("Expected fmt box");
  }
  const dataBox = structure.boxes.find((b) => b.type === "wav-data");
  if (!dataBox) {
    throw new Error("Expected data box");
  }
  const durationInSeconds = dataBox.dataSize / (fmt.sampleRate * fmt.blockAlign);
  return durationInSeconds;
};
var precomputedTfraState = () => {
  let tfraBoxes = [];
  return {
    getTfraBoxes: () => tfraBoxes,
    setTfraBoxes: (boxes) => {
      tfraBoxes = boxes;
    }
  };
};
var deduplicateTfraBoxesByOffset = (tfraBoxes) => {
  return tfraBoxes.filter((m, i, arr) => i === arr.findIndex((t) => t.offset === m.offset));
};
var getDurationFromMatroska = (segments) => {
  const mainSegment = segments.find((s) => s.type === "Segment");
  if (!mainSegment || mainSegment.type !== "Segment") {
    return null;
  }
  const { value: children } = mainSegment;
  if (!children) {
    return null;
  }
  const infoSegment = children.find((s) => s.type === "Info");
  const relevantBoxes = [
    ...mainSegment.value,
    ...infoSegment && infoSegment.type === "Info" ? infoSegment.value : []
  ];
  const timestampScale2 = relevantBoxes.find((s) => s.type === "TimestampScale");
  if (!timestampScale2 || timestampScale2.type !== "TimestampScale") {
    return null;
  }
  const duration2 = relevantBoxes.find((s) => s.type === "Duration");
  if (!duration2 || duration2.type !== "Duration") {
    return null;
  }
  return duration2.value.value / timestampScale2.value.value * 1000;
};
var getDurationFromIsoBaseMedia = (parserState) => {
  const structure = parserState.structure.getIsoStructure();
  const moovBox = getMoovBoxFromState({
    structureState: parserState.structure,
    isoState: parserState.iso,
    mp4HeaderSegment: parserState.m3uPlaylistContext?.mp4HeaderSegment ?? null,
    mayUsePrecomputed: true
  });
  if (!moovBox) {
    return null;
  }
  const moofBoxes = getMoofBoxes(structure.boxes);
  const mfra = parserState.iso.mfra.getIfAlreadyLoaded();
  const tfraBoxes = deduplicateTfraBoxesByOffset([
    ...mfra ? getTfraBoxesFromMfraBoxChildren(mfra) : [],
    ...getTfraBoxes(structure.boxes)
  ]);
  if (!areSamplesComplete({ moofBoxes, tfraBoxes })) {
    return null;
  }
  const mvhdBox = getMvhdBox(moovBox);
  if (!mvhdBox) {
    return null;
  }
  if (mvhdBox.type !== "mvhd-box") {
    throw new Error("Expected mvhd-box");
  }
  if (mvhdBox.durationInSeconds > 0) {
    return mvhdBox.durationInSeconds;
  }
  const tracks2 = getTracks(parserState, true);
  const allSamples = tracks2.map((t) => {
    const { originalTimescale: ts } = t;
    const trakBox = getTrakBoxByTrackId(moovBox, t.trackId);
    if (!trakBox) {
      return null;
    }
    const { samplePositions, isComplete } = getSamplePositionsFromTrack({
      trakBox,
      moofBoxes,
      moofComplete: areSamplesComplete({ moofBoxes, tfraBoxes }),
      trexBoxes: getTrexBoxes(moovBox)
    });
    if (!isComplete) {
      return null;
    }
    if (samplePositions.length === 0) {
      return null;
    }
    const highest = samplePositions?.map((sp) => (sp.timestamp + sp.duration) / ts).reduce((a, b) => Math.max(a, b), 0);
    return highest ?? 0;
  });
  if (allSamples.every((s) => s === null)) {
    return null;
  }
  const highestTimestamp = Math.max(...allSamples.filter((s) => s !== null));
  return highestTimestamp;
};
var getDuration = (parserState) => {
  const structure = parserState.structure.getStructure();
  if (structure.type === "matroska") {
    return getDurationFromMatroska(structure.boxes);
  }
  if (structure.type === "iso-base-media") {
    return getDurationFromIsoBaseMedia(parserState);
  }
  if (structure.type === "riff") {
    return getDurationFromAvi(structure);
  }
  if (structure.type === "transport-stream") {
    return null;
  }
  if (structure.type === "mp3") {
    return getDurationFromMp3(parserState);
  }
  if (structure.type === "wav") {
    return getDurationFromWav(parserState);
  }
  if (structure.type === "aac") {
    return null;
  }
  if (structure.type === "flac") {
    return getDurationFromFlac(parserState);
  }
  if (structure.type === "m3u") {
    return getDurationFromM3u(parserState);
  }
  throw new Error("Has no duration " + structure);
};
var hasDuration = (parserState) => {
  const structure = parserState.structure.getStructureOrNull();
  if (structure === null) {
    return false;
  }
  return getHasTracks(parserState, true);
};
var hasSlowDuration = (parserState) => {
  try {
    if (!hasDuration(parserState)) {
      return false;
    }
    return getDuration(parserState) !== null;
  } catch {
    return false;
  }
};
var isVideoTrackHdr = (track) => {
  return track.advancedColor.matrix === "bt2020-ncl" && (track.advancedColor.transfer === "hlg" || track.advancedColor.transfer === "pq") && track.advancedColor.primaries === "bt2020";
};
var getIsHdr = (state) => {
  const tracks2 = getTracks(state, true);
  return tracks2.some((track) => track.type === "video" && isVideoTrackHdr(track));
};
var hasHdr = (state) => {
  return getHasTracks(state, true);
};
var getKeyframesFromIsoBaseMedia = (state) => {
  const tracks2 = getTracksFromIsoBaseMedia({
    isoState: state.iso,
    m3uPlaylistContext: state.m3uPlaylistContext,
    structure: state.structure,
    mayUsePrecomputed: true
  });
  const videoTracks = tracks2.filter((t) => t.type === "video");
  const structure = state.structure.getIsoStructure();
  const moofBoxes = getMoofBoxes(structure.boxes);
  const tfraBoxes = getTfraBoxes(structure.boxes);
  const moov = getMoovFromFromIsoStructure(structure);
  if (!moov) {
    return [];
  }
  const allSamples = videoTracks.map((t) => {
    const { originalTimescale: ts } = t;
    const trakBox = getTrakBoxByTrackId(moov, t.trackId);
    if (!trakBox) {
      return [];
    }
    const { samplePositions, isComplete } = getSamplePositionsFromTrack({
      trakBox,
      moofBoxes,
      moofComplete: areSamplesComplete({
        moofBoxes,
        tfraBoxes
      }),
      trexBoxes: getTrexBoxes(moov)
    });
    if (!isComplete) {
      return [];
    }
    const keyframes = samplePositions.filter((k) => {
      return k.isKeyframe;
    }).map((k) => {
      return {
        trackId: t.trackId,
        presentationTimeInSeconds: k.timestamp / ts,
        decodingTimeInSeconds: k.decodingTimestamp / ts,
        positionInBytes: k.offset,
        sizeInBytes: k.size
      };
    });
    return keyframes;
  });
  return allSamples.flat();
};
var getKeyframes = (state) => {
  const structure = state.structure.getStructure();
  if (structure.type === "iso-base-media") {
    return getKeyframesFromIsoBaseMedia(state);
  }
  return null;
};
var hasKeyframes = (parserState) => {
  const structure = parserState.structure.getStructure();
  if (structure.type === "iso-base-media") {
    return getHasTracks(parserState, true);
  }
  return true;
};
var getMetadataFromFlac = (structure) => {
  const box2 = structure.boxes.find((b) => b.type === "flac-vorbis-comment");
  if (!box2) {
    return null;
  }
  return box2.fields;
};
var getMetadataFromMp3 = (mp3Structure) => {
  const findHeader = mp3Structure.boxes.find((b) => b.type === "id3-header");
  return findHeader ? findHeader.metatags : null;
};
var getMetadataFromWav = (structure) => {
  const list2 = structure.boxes.find((b) => b.type === "wav-list");
  if (!list2) {
    return null;
  }
  return list2.metadata;
};
var mapToKey = (index) => {
  if (index === "�ART") {
    return "artist";
  }
  if (index === "�alb") {
    return "album";
  }
  if (index === "�cmt") {
    return "comment";
  }
  if (index === "�day") {
    return "releaseDate";
  }
  if (index === "�gen") {
    return "genre";
  }
  if (index === "�nam") {
    return "title";
  }
  if (index === "�too") {
    return "encoder";
  }
  if (index === "�wrt") {
    return "writer";
  }
  if (index === "�cpy") {
    return "copyright";
  }
  if (index === "�dir") {
    return "director";
  }
  if (index === "�prd") {
    return "producer";
  }
  if (index === "�des") {
    return "description";
  }
  return null;
};
var parseIlstBoxWithoutKeys = (ilstBox) => {
  return ilstBox.entries.map((entry) => {
    const key4 = mapToKey(entry.index);
    if (!key4) {
      return null;
    }
    if (entry.value.type === "unknown") {
      return null;
    }
    return {
      trackId: null,
      key: key4,
      value: entry.value.value
    };
  }).filter(truthy);
};
var parseIsoMetaBox = (meta, trackId) => {
  const ilstBox = meta.children.find((b) => b.type === "ilst-box");
  const keysBox = meta.children.find((b) => b.type === "keys-box");
  if (!ilstBox || !keysBox) {
    if (ilstBox) {
      return parseIlstBoxWithoutKeys(ilstBox);
    }
    return [];
  }
  const entries = [];
  for (let i = 0;i < ilstBox.entries.length; i++) {
    const ilstEntry = ilstBox.entries[i];
    const keysEntry = keysBox.entries[i];
    if (ilstEntry.value.type !== "unknown") {
      const value = typeof ilstEntry.value.value === "string" && ilstEntry.value.value.endsWith("\x00") ? ilstEntry.value.value.slice(0, -1) : ilstEntry.value.value;
      entries.push({
        key: keysEntry.value,
        value,
        trackId
      });
    }
  }
  return entries;
};
var getMetadataFromIsoBase = (state) => {
  const moov = getMoovBoxFromState({
    structureState: state.structure,
    isoState: state.iso,
    mp4HeaderSegment: state.m3uPlaylistContext?.mp4HeaderSegment ?? null,
    mayUsePrecomputed: true
  });
  if (!moov) {
    return [];
  }
  const traks = getTraks(moov);
  const meta = moov.children.find((b) => b.type === "regular-box" && b.boxType === "meta");
  const udta = moov.children.find((b) => b.type === "regular-box" && b.boxType === "udta");
  const metaInUdta = udta?.children.find((b) => {
    return b.type === "regular-box" && b.boxType === "meta";
  });
  const metaInTracks = traks.map((t) => {
    const metaBox = t.children.find((child) => child.type === "regular-box" && child.boxType === "meta");
    if (metaBox) {
      const tkhd = getTkhdBox(t);
      if (!tkhd) {
        throw new Error("No tkhd box found");
      }
      return parseIsoMetaBox(metaBox, tkhd.trackId);
    }
    return null;
  }).filter(truthy);
  return [
    ...meta ? parseIsoMetaBox(meta, null) : [],
    ...metaInUdta ? parseIsoMetaBox(metaInUdta, null) : [],
    ...metaInTracks.flat(1)
  ];
};
var removeEndZeroes = (value) => {
  return value.endsWith("\x00") ? removeEndZeroes(value.slice(0, -1)) : value;
};
var parseSimpleTagIntoEbml = (children, trackId) => {
  const tagName = children.find((c) => c.type === "TagName");
  const tagString = children.find((c) => c.type === "TagString");
  if (!tagName || !tagString) {
    return null;
  }
  return {
    trackId,
    key: tagName.value.toLowerCase(),
    value: removeEndZeroes(tagString.value)
  };
};
var getMetadataFromMatroska = (structure) => {
  const entries = [];
  for (const segment of structure.boxes) {
    if (segment.type !== "Segment") {
      continue;
    }
    const tags2 = segment.value.filter((s) => s.type === "Tags");
    for (const tag of tags2) {
      for (const child of tag.value) {
        if (child.type !== "Tag") {
          continue;
        }
        let trackId = null;
        const target = child.value.find((c) => c.type === "Targets");
        if (target) {
          const tagTrackId = target.value.find((c) => c.type === "TagTrackUID")?.value;
          if (tagTrackId) {
            trackId = getTrackWithUid(segment, tagTrackId);
          }
        }
        const simpleTags = child.value.filter((s) => s.type === "SimpleTag");
        for (const simpleTag of simpleTags) {
          const parsed = parseSimpleTagIntoEbml(simpleTag.value, trackId);
          if (parsed) {
            entries.push(parsed);
          }
        }
      }
    }
  }
  return entries;
};
var getMetadataFromRiff = (structure) => {
  const boxes = structure.boxes.find((b) => b.type === "list-box" && b.listType === "INFO");
  if (!boxes) {
    return [];
  }
  const { children } = boxes;
  return children.map((child) => {
    if (child.type !== "isft-box") {
      return null;
    }
    return {
      trackId: null,
      key: "encoder",
      value: child.software
    };
  }).filter(truthy);
};
var getMetadata = (state) => {
  const structure = state.structure.getStructure();
  if (structure.type === "matroska") {
    return getMetadataFromMatroska(structure);
  }
  if (structure.type === "riff") {
    return getMetadataFromRiff(structure);
  }
  if (structure.type === "transport-stream" || structure.type === "m3u") {
    return [];
  }
  if (structure.type === "mp3") {
    const tags2 = getMetadataFromMp3(structure);
    return tags2 ?? [];
  }
  if (structure.type === "wav") {
    return getMetadataFromWav(structure) ?? [];
  }
  if (structure.type === "aac") {
    return [];
  }
  if (structure.type === "flac") {
    return getMetadataFromFlac(structure) ?? [];
  }
  if (structure.type === "iso-base-media") {
    return getMetadataFromIsoBase(state);
  }
  throw new Error("Unknown container " + structure);
};
var hasMetadata = (structure) => {
  if (structure.type === "mp3") {
    return getMetadataFromMp3(structure) !== null;
  }
  if (structure.type === "wav") {
    return getMetadataFromWav(structure) !== null;
  }
  if (structure.type === "m3u" || structure.type === "transport-stream" || structure.type === "aac") {
    return true;
  }
  if (structure.type === "flac") {
    return getMetadataFromFlac(structure) !== null;
  }
  if (structure.type === "iso-base-media") {
    return false;
  }
  if (structure.type === "matroska") {
    return false;
  }
  if (structure.type === "riff") {
    return false;
  }
  throw new Error("Unknown container " + structure);
};
function parseLocation(locationString) {
  const locationPattern = /^([+-]\d{2}\.?\d{0,10})([+-]\d{3}\.?\d{0,10})([+-]\d+(\.\d+)?)?\/$/;
  const match = locationString.match(locationPattern);
  if (!match) {
    return null;
  }
  const latitude = parseFloat(match[1]);
  const longitude = parseFloat(match[2]);
  const altitude = match[3] ? parseFloat(match[3]) : null;
  return {
    latitude,
    longitude,
    altitude
  };
}
var getLocation = (state) => {
  const metadata = getMetadata(state);
  const locationEntry = metadata.find((entry) => entry.key === "com.apple.quicktime.location.ISO6709");
  const horizontalAccuracy = metadata.find((entry) => entry.key === "com.apple.quicktime.location.accuracy.horizontal");
  if (locationEntry) {
    const parsed = parseLocation(locationEntry.value);
    if (parsed === null) {
      return null;
    }
    return {
      ...parsed,
      horizontalAccuracy: horizontalAccuracy?.value ? parseFloat(String(horizontalAccuracy.value)) : null
    };
  }
  return null;
};
var getNumberOfAudioChannels = (state) => {
  return state.callbacks.tracks.getTracks().find((track) => {
    return track.type === "audio";
  })?.numberOfChannels ?? null;
};
var hasNumberOfAudioChannels = (state) => {
  return state.callbacks.tracks.hasAllTracks();
};
var getSampleRate3 = (state) => {
  return state.callbacks.tracks.getTracks().find((track) => {
    return track.type === "audio";
  })?.sampleRate ?? null;
};
var hasSampleRate = (state) => {
  return state.callbacks.tracks.hasAllTracks();
};
var getSeekingByteForAac = ({
  time: time2,
  seekingHints
}) => {
  let bestAudioSample;
  for (const hint of seekingHints.audioSampleMap) {
    if (hint.timeInSeconds > time2) {
      continue;
    }
    if (hint.timeInSeconds + hint.durationInSeconds < time2 && !seekingHints.lastSampleObserved) {
      continue;
    }
    if (!bestAudioSample) {
      bestAudioSample = hint;
      continue;
    }
    if (bestAudioSample.timeInSeconds < hint.timeInSeconds) {
      bestAudioSample = hint;
    }
  }
  if (bestAudioSample) {
    return {
      type: "do-seek",
      byte: bestAudioSample.offset,
      timeInSeconds: bestAudioSample.timeInSeconds
    };
  }
  return { type: "valid-but-must-wait" };
};
var getSeekingByteForFlac = ({
  time: time2,
  seekingHints
}) => {
  let bestAudioSample;
  for (const hint of seekingHints.audioSampleMap) {
    if (hint.timeInSeconds > time2) {
      continue;
    }
    if (hint.timeInSeconds + hint.durationInSeconds < time2 && !seekingHints.lastSampleObserved) {
      continue;
    }
    if (!bestAudioSample) {
      bestAudioSample = hint;
      continue;
    }
    if (bestAudioSample.timeInSeconds < hint.timeInSeconds) {
      bestAudioSample = hint;
    }
  }
  if (bestAudioSample) {
    return bestAudioSample;
  }
  return null;
};
var findKeyframeBeforeTime = ({
  samplePositions,
  time: time2,
  timescale,
  mediaSections,
  logLevel,
  startInSeconds
}) => {
  let videoByte = 0;
  let videoSample = null;
  for (const sample of samplePositions) {
    const ctsInSeconds = sample.timestamp / timescale + startInSeconds;
    const dtsInSeconds = sample.decodingTimestamp / timescale + startInSeconds;
    if (!sample.isKeyframe) {
      continue;
    }
    if (!(ctsInSeconds <= time2 || dtsInSeconds <= time2)) {
      continue;
    }
    if (videoByte <= sample.offset) {
      videoByte = sample.offset;
      videoSample = sample;
    }
  }
  if (!videoSample) {
    throw new Error("No sample found");
  }
  const mediaSection = mediaSections.find((section) => videoSample.offset >= section.start && videoSample.offset < section.start + section.size);
  if (!mediaSection) {
    Log.trace(logLevel, "Found a sample, but the offset has not yet been marked as a video section yet. Not yet able to seek, but probably once we have started reading the next box.", videoSample);
    return null;
  }
  return videoSample;
};
var findAnyTrackWithSamplePositions = (allTracks, struc) => {
  const moov = getMoovFromFromIsoStructure(struc);
  if (!moov) {
    return null;
  }
  for (const track of allTracks) {
    if (track.type === "video" || track.type === "audio") {
      const trakBox = getTrakBoxByTrackId(moov, track.trackId);
      if (!trakBox) {
        continue;
      }
      const { samplePositions } = getSamplePositionsFromTrack({
        trakBox,
        moofBoxes: getMoofBoxes(struc.boxes),
        moofComplete: areSamplesComplete({
          moofBoxes: getMoofBoxes(struc.boxes),
          tfraBoxes: getTfraBoxes(struc.boxes)
        }),
        trexBoxes: getTrexBoxes(moov)
      });
      if (samplePositions.length === 0) {
        continue;
      }
      return { track, samplePositions };
    }
  }
  return null;
};
var findTrackToSeek = (allTracks, structure) => {
  const firstVideoTrack = allTracks.find((t) => t.type === "video");
  const struc = structure.getIsoStructure();
  if (!firstVideoTrack) {
    return findAnyTrackWithSamplePositions(allTracks, struc);
  }
  const moov = getMoovFromFromIsoStructure(struc);
  if (!moov) {
    return null;
  }
  const trakBox = getTrakBoxByTrackId(moov, firstVideoTrack.trackId);
  if (!trakBox) {
    return null;
  }
  const { samplePositions } = getSamplePositionsFromTrack({
    trakBox,
    moofBoxes: getMoofBoxes(struc.boxes),
    moofComplete: areSamplesComplete({
      moofBoxes: getMoofBoxes(struc.boxes),
      tfraBoxes: getTfraBoxes(struc.boxes)
    }),
    trexBoxes: getTrexBoxes(moov)
  });
  if (samplePositions.length === 0) {
    return findAnyTrackWithSamplePositions(allTracks, struc);
  }
  return { track: firstVideoTrack, samplePositions };
};
var isByteInMediaSection = ({
  position,
  mediaSections
}) => {
  if (mediaSections.length === 0) {
    return "no-section-defined";
  }
  for (const section of mediaSections) {
    if (position >= section.start && position < section.start + section.size) {
      return "in-section";
    }
  }
  return "outside-section";
};
var getCurrentMediaSection = ({
  offset,
  mediaSections
}) => {
  for (const section of mediaSections) {
    if (offset >= section.start && offset < section.start + section.size) {
      return section;
    }
  }
  return null;
};
var mediaSectionState = () => {
  const mediaSections = [];
  const addMediaSection = (section) => {
    const overlaps = mediaSections.some((existingSection) => section.start < existingSection.start + existingSection.size && section.start + section.size > existingSection.start);
    if (overlaps) {
      return;
    }
    for (let i = mediaSections.length - 1;i >= 0; i--) {
      const existingSection = mediaSections[i];
      if (section.start <= existingSection.start && section.start + section.size >= existingSection.start + existingSection.size) {
        mediaSections.splice(i, 1);
      }
    }
    mediaSections.push(section);
  };
  const getMediaSections = () => {
    return mediaSections;
  };
  const isCurrentByteInMediaSection = (iterator) => {
    const offset = iterator.counter.getOffset();
    return isByteInMediaSection({
      position: offset,
      mediaSections
    });
  };
  const getMediaSectionAssertOnlyOne = () => {
    if (mediaSections.length !== 1) {
      throw new Error("Expected only one video section");
    }
    return mediaSections[0];
  };
  return {
    addMediaSection,
    getMediaSections,
    isCurrentByteInMediaSection,
    isByteInMediaSection,
    getCurrentMediaSection,
    getMediaSectionAssertOnlyOne,
    mediaSections
  };
};
var getSamplePositionBounds = (samplePositions, timescale) => {
  let min = Infinity;
  let max = -Infinity;
  for (const samplePosition of samplePositions) {
    const timestampMin = Math.min(samplePosition.timestamp, samplePosition.decodingTimestamp);
    const timestampMax = Math.max(samplePosition.timestamp, samplePosition.decodingTimestamp) + (samplePosition.duration ?? 0);
    if (timestampMin < min) {
      min = timestampMin;
    }
    if (timestampMax > max) {
      max = timestampMax;
    }
  }
  return { min: min / timescale, max: max / timescale };
};
var findBestSegmentFromTfra = ({
  mfra,
  time: time2,
  firstTrack,
  timescale
}) => {
  const tfra = mfra.find((b) => b.type === "tfra-box" && b.trackId === firstTrack.trackId);
  if (!tfra) {
    return null;
  }
  let bestSegment = null;
  for (const segment of tfra.entries) {
    if (segment.time / timescale <= time2) {
      bestSegment = segment;
    }
  }
  if (!bestSegment) {
    return null;
  }
  const currentSegmentIndex = tfra.entries.indexOf(bestSegment);
  const offsetOfNext = currentSegmentIndex === tfra.entries.length - 1 ? Infinity : tfra.entries[currentSegmentIndex + 1].moofOffset;
  return {
    start: bestSegment.moofOffset,
    end: offsetOfNext
  };
};
var getSeekingByteFromFragmentedMp4 = async ({
  info,
  time: time2,
  logLevel,
  currentPosition,
  isoState,
  tracks: tracks2,
  isLastChunkInPlaylist,
  structure,
  mp4HeaderSegment
}) => {
  const firstVideoTrack = tracks2.find((t) => t.type === "video");
  const firstTrack = firstVideoTrack ?? tracks2.find((t) => t.type === "audio");
  if (!firstTrack) {
    throw new Error("no video and no audio tracks");
  }
  const moov = getMoovBoxFromState({
    structureState: structure,
    isoState,
    mp4HeaderSegment,
    mayUsePrecomputed: true
  });
  if (!moov) {
    throw new Error("No moov atom found");
  }
  const trakBox = getTrakBoxByTrackId(moov, firstTrack.trackId);
  if (!trakBox) {
    throw new Error("No trak box found");
  }
  const tkhdBox = getTkhdBox(trakBox);
  if (!tkhdBox) {
    throw new Error("Expected tkhd box in trak box");
  }
  const isComplete = areSamplesComplete({
    moofBoxes: info.moofBoxes,
    tfraBoxes: info.tfraBoxes
  });
  const { samplePositions: samplePositionsArray } = collectSamplePositionsFromMoofBoxes({
    moofBoxes: info.moofBoxes,
    tkhdBox,
    isComplete,
    trexBoxes: getTrexBoxes(moov)
  });
  Log.trace(logLevel, "Fragmented MP4 - Checking if we have seeking info for this time range");
  for (const positions of samplePositionsArray) {
    const { min, max } = getSamplePositionBounds(positions.samples, firstTrack.originalTimescale);
    if (min <= time2 && (positions.isLastFragment || isLastChunkInPlaylist || time2 <= max)) {
      Log.trace(logLevel, `Fragmented MP4 - Found that we have seeking info for this time range: ${min} <= ${time2} <= ${max}`);
      const kf = findKeyframeBeforeTime({
        samplePositions: positions.samples,
        time: time2,
        timescale: firstTrack.originalTimescale,
        logLevel,
        mediaSections: info.mediaSections,
        startInSeconds: firstTrack.startInSeconds
      });
      if (kf) {
        return {
          type: "do-seek",
          byte: kf.offset,
          timeInSeconds: Math.min(kf.decodingTimestamp, kf.timestamp) / firstTrack.originalTimescale
        };
      }
    }
  }
  const atom = await (info.mfraAlreadyLoaded ? Promise.resolve(info.mfraAlreadyLoaded) : isoState.mfra.triggerLoad());
  if (atom) {
    const moofOffset = findBestSegmentFromTfra({
      mfra: atom,
      time: time2,
      firstTrack,
      timescale: firstTrack.originalTimescale
    });
    if (moofOffset !== null && !(moofOffset.start <= currentPosition && currentPosition < moofOffset.end)) {
      Log.verbose(logLevel, `Fragmented MP4 - Found based on mfra information that we should seek to: ${moofOffset.start} ${moofOffset.end}`);
      return {
        type: "intermediary-seek",
        byte: moofOffset.start
      };
    }
  }
  Log.trace(logLevel, "Fragmented MP4 - No seeking info found for this time range.");
  if (isByteInMediaSection({
    position: currentPosition,
    mediaSections: info.mediaSections
  }) !== "in-section") {
    return {
      type: "valid-but-must-wait"
    };
  }
  Log.trace(logLevel, "Fragmented MP4 - Inside the wrong video section, skipping to the end of the section");
  const mediaSection = getCurrentMediaSection({
    offset: currentPosition,
    mediaSections: info.mediaSections
  });
  if (!mediaSection) {
    throw new Error("No video section defined");
  }
  return {
    type: "intermediary-seek",
    byte: mediaSection.start + mediaSection.size
  };
};
var getSeekingByteFromIsoBaseMedia = ({
  info,
  time: time2,
  logLevel,
  currentPosition,
  isoState,
  m3uPlaylistContext,
  structure
}) => {
  const tracks2 = getTracksFromIsoBaseMedia({
    isoState,
    m3uPlaylistContext,
    structure,
    mayUsePrecomputed: false
  });
  const hasMoov = Boolean(getMoovBoxFromState({
    structureState: structure,
    isoState,
    mayUsePrecomputed: false,
    mp4HeaderSegment: m3uPlaylistContext?.mp4HeaderSegment ?? null
  }));
  if (!hasMoov) {
    Log.trace(logLevel, "No moov box found, must wait");
    return Promise.resolve({
      type: "valid-but-must-wait"
    });
  }
  if (info.moofBoxes.length > 0) {
    return getSeekingByteFromFragmentedMp4({
      info,
      time: time2,
      logLevel,
      currentPosition,
      isoState,
      tracks: tracks2,
      isLastChunkInPlaylist: m3uPlaylistContext?.isLastChunkInPlaylist ?? false,
      structure,
      mp4HeaderSegment: m3uPlaylistContext?.mp4HeaderSegment ?? null
    });
  }
  const trackWithSamplePositions = findTrackToSeek(tracks2, structure);
  if (!trackWithSamplePositions) {
    return Promise.resolve({
      type: "valid-but-must-wait"
    });
  }
  const { track, samplePositions } = trackWithSamplePositions;
  const keyframe = findKeyframeBeforeTime({
    samplePositions,
    time: time2,
    timescale: track.originalTimescale,
    logLevel,
    mediaSections: info.mediaSections,
    startInSeconds: track.startInSeconds
  });
  if (keyframe) {
    return Promise.resolve({
      type: "do-seek",
      byte: keyframe.offset,
      timeInSeconds: Math.min(keyframe.decodingTimestamp, keyframe.timestamp) / track.originalTimescale
    });
  }
  return Promise.resolve({
    type: "invalid"
  });
};
var clearM3uStateInPrepareForSeek = ({
  m3uState,
  logLevel
}) => {
  const selectedPlaylists = m3uState.getSelectedPlaylists();
  for (const playlistUrl of selectedPlaylists) {
    const streamRun = m3uState.getM3uStreamRun(playlistUrl);
    if (streamRun) {
      streamRun.abort();
    }
    Log.trace(logLevel, "Clearing M3U stream run for", playlistUrl);
    m3uState.setM3uStreamRun(playlistUrl, null);
  }
  m3uState.clearAllChunksProcessed();
  m3uState.sampleSorter.clearSamples();
};
var getSeekingByteForM3u8 = ({
  time: time2,
  currentPosition,
  m3uState,
  logLevel
}) => {
  clearM3uStateInPrepareForSeek({ m3uState, logLevel });
  const selectedPlaylists = m3uState.getSelectedPlaylists();
  for (const playlistUrl of selectedPlaylists) {
    m3uState.setSeekToSecondsToProcess(playlistUrl, {
      targetTime: time2
    });
  }
  return {
    type: "do-seek",
    byte: currentPosition,
    timeInSeconds: time2
  };
};
var getApproximateByteFromBitrate = ({
  mp3BitrateInfo,
  timeInSeconds,
  mp3Info,
  mediaSection,
  contentLength
}) => {
  if (mp3BitrateInfo.type === "variable") {
    return null;
  }
  const samplesPerFrame = getSamplesPerMpegFrame({
    layer: mp3Info.layer,
    mpegVersion: mp3Info.mpegVersion
  });
  const frameLengthInBytes = getMpegFrameLength({
    bitrateKbit: mp3BitrateInfo.bitrateInKbit,
    padding: false,
    samplesPerFrame,
    samplingFrequency: mp3Info.sampleRate,
    layer: mp3Info.layer
  });
  const frameIndexUnclamped = Math.floor(timeInSeconds * mp3Info.sampleRate / samplesPerFrame);
  const frames = Math.floor((contentLength - mediaSection.start) / frameLengthInBytes);
  const frameIndex = Math.min(frames - 1, frameIndexUnclamped);
  const byteRelativeToMediaSection = frameIndex * frameLengthInBytes;
  const byteBeforeFrame = byteRelativeToMediaSection + mediaSection.start;
  return byteBeforeFrame;
};
var getByteFromObservedSamples = ({
  info,
  timeInSeconds
}) => {
  let bestAudioSample;
  for (const hint of info.audioSampleMap) {
    if (hint.timeInSeconds > timeInSeconds) {
      continue;
    }
    if (hint.timeInSeconds + hint.durationInSeconds < timeInSeconds && !info.lastSampleObserved) {
      continue;
    }
    if (!bestAudioSample) {
      bestAudioSample = hint;
      continue;
    }
    if (bestAudioSample.timeInSeconds < hint.timeInSeconds) {
      bestAudioSample = hint;
    }
  }
  return bestAudioSample;
};
var SAMPLE_RATES = [44100, 48000, 32000, 99999];
var FRAMES_FLAG = 1;
var BYTES_FLAG = 2;
var TOC_FLAG = 4;
var VBR_SCALE_FLAG = 8;
var extractI4 = (data, offset) => {
  let x = 0;
  x = data[offset];
  x <<= 8;
  x |= data[offset + 1];
  x <<= 8;
  x |= data[offset + 2];
  x <<= 8;
  x |= data[offset + 3];
  return x;
};
var parseXing = (data) => {
  const h_id = data[1] >> 3 & 1;
  const h_sr_index = data[2] >> 2 & 3;
  const h_mode = data[3] >> 6 & 3;
  let xingOffset = 0;
  if (h_id) {
    if (h_mode !== 3) {
      xingOffset += 32 + 4;
    } else {
      xingOffset += 17 + 4;
    }
  } else if (h_mode !== 3) {
    xingOffset += 17 + 4;
  } else {
    xingOffset += 9 + 4;
  }
  const expectXing = new TextDecoder("utf8").decode(data.slice(xingOffset, xingOffset + 4));
  if (expectXing !== "Xing") {
    throw new Error("Invalid Xing header");
  }
  let sampleRate = SAMPLE_RATES[h_sr_index];
  if (h_id === 0) {
    sampleRate >>= 1;
  }
  let offset = xingOffset + 4;
  const flags = extractI4(data, offset);
  offset += 4;
  let numberOfFrames;
  let fileSize;
  let tableOfContents;
  let vbrScale;
  if (flags & FRAMES_FLAG) {
    numberOfFrames = extractI4(data, offset);
    offset += 4;
  }
  if (flags & BYTES_FLAG) {
    fileSize = extractI4(data, offset);
    offset += 4;
  }
  if (flags & TOC_FLAG) {
    tableOfContents = data.slice(offset, offset + 100);
    offset += 100;
  }
  if (flags & VBR_SCALE_FLAG) {
    vbrScale = extractI4(data, offset);
    offset += 4;
  }
  if (offset > data.length) {
    throw new Error("xing header was parsed wrong: read beyond available data");
  }
  return {
    sampleRate,
    numberOfFrames: numberOfFrames ?? null,
    fileSize: fileSize ?? null,
    tableOfContents: tableOfContents ? Array.from(tableOfContents.slice(0, 100)) : null,
    vbrScale: vbrScale ?? null
  };
};
var getSeekPointInBytes = ({
  fileSize,
  percentBetween0And100,
  tableOfContents
}) => {
  let index = Math.floor(percentBetween0And100);
  if (index > 99) {
    index = 99;
  }
  const fa = tableOfContents[index];
  let fb;
  if (index < 99) {
    fb = tableOfContents[index + 1];
  } else {
    fb = 256;
  }
  const fx = fa + (fb - fa) * (percentBetween0And100 - index);
  const seekPoint = 1 / 256 * fx * fileSize;
  return Math.floor(seekPoint);
};
var getTimeFromPosition = ({
  position,
  fileSize,
  tableOfContents,
  durationInSeconds
}) => {
  const positionNormalized = position / fileSize * 256;
  let index = 0;
  while (index < 99 && tableOfContents[index + 1] <= positionNormalized) {
    index++;
  }
  const fa = tableOfContents[index];
  const fb = index < 99 ? tableOfContents[index + 1] : 256;
  const percentWithinSegment = (positionNormalized - fa) / (fb - fa);
  const percentBetween0And100 = index + percentWithinSegment;
  return percentBetween0And100 / 100 * durationInSeconds;
};
var getSeekPointFromXing = ({
  timeInSeconds,
  xingData,
  mp3Info
}) => {
  const samplesPerFrame = getSamplesPerMpegFrame({
    layer: mp3Info.layer,
    mpegVersion: mp3Info.mpegVersion
  });
  const duration2 = getDurationFromMp3Xing({
    xingData,
    samplesPerFrame
  });
  const totalSamples = timeInSeconds * xingData.sampleRate;
  const oneFrameSubtracted = totalSamples - samplesPerFrame;
  const timeToTarget = Math.max(0, oneFrameSubtracted / xingData.sampleRate);
  if (!xingData.fileSize || !xingData.tableOfContents) {
    throw new Error("Cannot seek of VBR MP3 file");
  }
  return getSeekPointInBytes({
    fileSize: xingData.fileSize,
    percentBetween0And100: timeToTarget / duration2 * 100,
    tableOfContents: xingData.tableOfContents
  });
};
var getSeekingByteForMp3 = ({
  time: time2,
  info
}) => {
  if (info.mp3BitrateInfo === null || info.mp3Info === null || info.mediaSection === null) {
    return {
      type: "valid-but-must-wait"
    };
  }
  const approximateByte = getApproximateByteFromBitrate({
    mp3BitrateInfo: info.mp3BitrateInfo,
    timeInSeconds: time2,
    mp3Info: info.mp3Info,
    mediaSection: info.mediaSection,
    contentLength: info.contentLength
  });
  const bestAudioSample = getByteFromObservedSamples({
    info,
    timeInSeconds: time2
  });
  const xingSeekPoint = info.mp3BitrateInfo.type === "variable" ? getSeekPointFromXing({
    mp3Info: info.mp3Info,
    timeInSeconds: time2,
    xingData: info.mp3BitrateInfo.xingData
  }) : null;
  const candidates = [
    approximateByte,
    bestAudioSample?.offset ?? null,
    xingSeekPoint
  ].filter((b) => b !== null);
  if (candidates.length === 0) {
    return {
      type: "valid-but-must-wait"
    };
  }
  const byte = Math.max(...candidates);
  const timeInSeconds = byte === bestAudioSample?.offset ? bestAudioSample.timeInSeconds : time2;
  return {
    type: "do-seek",
    byte,
    timeInSeconds
  };
};
function findLastKeyframe({
  keyframes,
  timeInSeconds
}) {
  let bestKeyframe = null;
  for (const keyframe of keyframes) {
    if (keyframe.presentationTimeInSeconds > timeInSeconds && keyframe.decodingTimeInSeconds > timeInSeconds) {
      break;
    }
    if (bestKeyframe === null || keyframe.presentationTimeInSeconds > bestKeyframe.presentationTimeInSeconds) {
      bestKeyframe = keyframe;
    }
  }
  return bestKeyframe;
}
var getSeekingByteForRiff = async ({
  info,
  time: time2,
  riffState,
  avcState
}) => {
  const idx1Entries = await (info.hasIndex ? riffState.lazyIdx1.waitForLoaded() : Promise.resolve(null));
  if (idx1Entries === null) {
    const lastKeyframe = findLastKeyframe({
      keyframes: info.observedKeyframes,
      timeInSeconds: time2
    });
    if (lastKeyframe === null) {
      return {
        type: "valid-but-must-wait"
      };
    }
    riffState.sampleCounter.setSamplesFromSeek(lastKeyframe.sampleCounts);
    riffState.queuedBFrames.clear();
    avcState.clear();
    return {
      type: "do-seek",
      byte: lastKeyframe.positionInBytes,
      timeInSeconds: Math.min(lastKeyframe.decodingTimeInSeconds, lastKeyframe.presentationTimeInSeconds)
    };
  }
  if (idx1Entries.videoTrackIndex === null) {
    throw new Error("videoTrackIndex is null");
  }
  if (info.samplesPerSecond === null) {
    throw new Error("samplesPerSecond is null");
  }
  const index = Math.floor(time2 * info.samplesPerSecond);
  let bestEntry = null;
  for (const entry of idx1Entries.entries) {
    if (entry.sampleCounts[idx1Entries.videoTrackIndex] > index) {
      continue;
    }
    if (bestEntry && entry.sampleCounts[idx1Entries.videoTrackIndex] < bestEntry.sampleCounts[idx1Entries.videoTrackIndex]) {
      continue;
    }
    bestEntry = entry;
  }
  if (!bestEntry) {
    throw new Error("No best entry");
  }
  if (info.moviOffset === null) {
    throw new Error("moviOffset is null");
  }
  riffState.sampleCounter.setSamplesFromSeek(bestEntry.sampleCounts);
  riffState.queuedBFrames.clear();
  avcState.clear();
  return {
    type: "do-seek",
    byte: bestEntry.offset + info.moviOffset - 4,
    timeInSeconds: bestEntry.sampleCounts[idx1Entries.videoTrackIndex] / info.samplesPerSecond
  };
};
var fixFloat = (value) => {
  if (value % 1 < 0.0000001) {
    return Math.floor(value);
  }
  if (value % 1 > 0.9999999) {
    return Math.ceil(value);
  }
  return value;
};
var convertAudioOrVideoSampleToWebCodecsTimestamps = ({
  sample,
  timescale
}) => {
  if (timescale === WEBCODECS_TIMESCALE) {
    return sample;
  }
  const { decodingTimestamp: dts, timestamp } = sample;
  return {
    decodingTimestamp: fixFloat(dts * (WEBCODECS_TIMESCALE / timescale)),
    timestamp: fixFloat(timestamp * (WEBCODECS_TIMESCALE / timescale)),
    duration: sample.duration === undefined ? undefined : fixFloat(sample.duration * (WEBCODECS_TIMESCALE / timescale)),
    data: sample.data,
    type: sample.type,
    offset: sample.offset,
    ..."avc" in sample ? { avc: sample.avc } : {}
  };
};
var getDimensionsFromSps = (sps) => {
  const height = sps.pic_height_in_map_units_minus1;
  const width = sps.pic_width_in_mbs_minus1;
  return {
    height: (height + 1) * 16 - (sps.frame_crop_bottom_offset ?? 0) * 2 - (sps.frame_crop_top_offset ?? 0) * 2,
    width: (width + 1) * 16 - (sps.frame_crop_right_offset ?? 0) * 2 - (sps.frame_crop_left_offset ?? 0) * 2
  };
};
var getSampleAspectRatioFromSps = (sps) => {
  if (sps.vui_parameters?.sar_height && sps.vui_parameters.sar_width) {
    return {
      width: sps.vui_parameters.sar_width,
      height: sps.vui_parameters.sar_height
    };
  }
  return {
    width: 1,
    height: 1
  };
};
var getVideoColorFromSps = (sps) => {
  const matrixCoefficients2 = sps.vui_parameters?.matrix_coefficients;
  const transferCharacteristics2 = sps.vui_parameters?.transfer_characteristics;
  const colorPrimaries = sps.vui_parameters?.colour_primaries;
  return {
    matrix: matrixCoefficients2 ? getMatrixCoefficientsFromIndex(matrixCoefficients2) : null,
    transfer: transferCharacteristics2 ? getTransferCharacteristicsFromIndex(transferCharacteristics2) : null,
    primaries: colorPrimaries ? getPrimariesFromIndex(colorPrimaries) : null,
    fullRange: sps.vui_parameters?.video_full_range_flag ?? null
  };
};
var getKeyFrameOrDeltaFromAvcInfo = (infos) => {
  const keyOrDelta = infos.find((i) => i.type === "keyframe" || i.type === "delta-frame");
  if (!keyOrDelta) {
    throw new Error("expected avc to contain info about key or delta");
  }
  return keyOrDelta.type === "keyframe" ? "key" : keyOrDelta.isBidirectionalFrame ? "bidirectional" : "delta";
};
var getSpsAndPps = (infos) => {
  const avcProfile = infos.find((i) => i.type === "avc-profile");
  const ppsProfile = infos.find((i) => i.type === "avc-pps");
  if (!avcProfile || !ppsProfile) {
    throw new Error("Expected avcProfile and ppsProfile");
  }
  return { pps: ppsProfile, sps: avcProfile };
};
var MPEG_TIMESCALE = 90000;
var handleAvcPacket = async ({
  streamBuffer,
  programId,
  offset,
  sampleCallbacks,
  logLevel,
  onVideoTrack,
  transportStream,
  makeSamplesStartAtZero,
  avcState
}) => {
  const avc = parseAvc(streamBuffer.getBuffer(), avcState);
  const isTrackRegistered = sampleCallbacks.tracks.getTracks().find((t) => {
    return t.trackId === programId;
  });
  if (!isTrackRegistered) {
    const spsAndPps = getSpsAndPps(avc);
    const dimensions = getDimensionsFromSps(spsAndPps.sps.spsData);
    const sampleAspectRatio = getSampleAspectRatioFromSps(spsAndPps.sps.spsData);
    const startOffset = makeSamplesStartAtZero ? Math.min(streamBuffer.pesHeader.pts, streamBuffer.pesHeader.dts ?? Infinity) : 0;
    transportStream.startOffset.setOffset({
      trackId: programId,
      newOffset: startOffset
    });
    const codecPrivate2 = createSpsPpsData(spsAndPps);
    const advancedColor = getVideoColorFromSps(spsAndPps.sps.spsData);
    const track = {
      m3uStreamFormat: null,
      rotation: 0,
      trackId: programId,
      type: "video",
      originalTimescale: MPEG_TIMESCALE,
      codec: getCodecStringFromSpsAndPps(spsAndPps.sps),
      codecData: { type: "avc-sps-pps", data: codecPrivate2 },
      fps: null,
      codedWidth: dimensions.width,
      codedHeight: dimensions.height,
      height: dimensions.height,
      width: dimensions.width,
      displayAspectWidth: dimensions.width,
      displayAspectHeight: dimensions.height,
      codecEnum: "h264",
      description: undefined,
      sampleAspectRatio: {
        denominator: sampleAspectRatio.height,
        numerator: sampleAspectRatio.width
      },
      colorSpace: mediaParserAdvancedColorToWebCodecsColor(advancedColor),
      advancedColor,
      startInSeconds: 0,
      timescale: WEBCODECS_TIMESCALE,
      trackMediaTimeOffsetInTrackTimescale: 0
    };
    await registerVideoTrack({
      track,
      container: "transport-stream",
      logLevel,
      onVideoTrack,
      registerVideoSampleCallback: sampleCallbacks.registerVideoSampleCallback,
      tracks: sampleCallbacks.tracks
    });
  }
  const type = getKeyFrameOrDeltaFromAvcInfo(avc);
  const sample = {
    decodingTimestamp: (streamBuffer.pesHeader.dts ?? streamBuffer.pesHeader.pts) - transportStream.startOffset.getOffset(programId),
    timestamp: streamBuffer.pesHeader.pts - transportStream.startOffset.getOffset(programId),
    duration: undefined,
    data: streamBuffer.getBuffer(),
    type: type === "bidirectional" ? "delta" : type,
    offset
  };
  if (type === "key") {
    transportStream.observedPesHeaders.markPtsAsKeyframe(streamBuffer.pesHeader.pts);
  }
  const videoSample = convertAudioOrVideoSampleToWebCodecsTimestamps({
    sample,
    timescale: MPEG_TIMESCALE
  });
  await sampleCallbacks.onVideoSample({
    videoSample,
    trackId: programId
  });
  transportStream.lastEmittedSample.setLastEmittedSample(sample);
};
var WAVE_SAMPLES_PER_SECOND = 25;
var getSeekingByteFromWav = ({
  info,
  time: time2
}) => {
  const bytesPerSecond = info.sampleRate * info.blockAlign;
  const durationInSeconds = info.mediaSection.size / bytesPerSecond;
  const timeRoundedDown = Math.floor(Math.min(time2, durationInSeconds - 0.0000001) * WAVE_SAMPLES_PER_SECOND) / WAVE_SAMPLES_PER_SECOND;
  const byteOffset = bytesPerSecond * timeRoundedDown;
  return Promise.resolve({
    type: "do-seek",
    byte: byteOffset + info.mediaSection.start,
    timeInSeconds: timeRoundedDown
  });
};
var toSeconds = (timeInTimescale, track) => {
  return timeInTimescale / track.timescale * 1000;
};
var findBiggestCueBeforeTime = ({
  cues,
  time: time2,
  track
}) => {
  let biggestCueBeforeTime;
  for (const cue of cues) {
    const cueTimeInSeconds = toSeconds(cue.timeInTimescale, track);
    if (cueTimeInSeconds < time2 && (!biggestCueBeforeTime || cueTimeInSeconds > toSeconds(biggestCueBeforeTime.timeInTimescale, track))) {
      biggestCueBeforeTime = cue;
    }
  }
  return biggestCueBeforeTime;
};
var findKeyframeBeforeTime2 = ({
  keyframes,
  time: time2
}) => {
  let keyframeBeforeTime;
  for (const keyframe of keyframes) {
    if (keyframe.decodingTimeInSeconds < time2 && (!keyframeBeforeTime || keyframe.decodingTimeInSeconds > keyframeBeforeTime.decodingTimeInSeconds)) {
      keyframeBeforeTime = keyframe;
    }
  }
  return keyframeBeforeTime ?? null;
};
var getByteFromCues = ({
  cuesResponse,
  time: time2,
  info,
  logLevel
}) => {
  if (!cuesResponse) {
    Log.trace(logLevel, "Has no Matroska cues at the moment, cannot use them");
    return null;
  }
  const { cues, segmentOffset } = cuesResponse;
  Log.trace(logLevel, "Has Matroska cues. Will use them to perform a seek.");
  const biggestCueBeforeTime = findBiggestCueBeforeTime({
    cues,
    time: time2,
    track: info.track
  });
  if (!biggestCueBeforeTime) {
    return null;
  }
  return {
    byte: biggestCueBeforeTime.clusterPositionInSegment + segmentOffset,
    timeInSeconds: toSeconds(biggestCueBeforeTime.timeInTimescale, info.track)
  };
};
var getSeekingByteFromMatroska = async ({
  time: time2,
  webmState,
  info,
  logLevel,
  mediaSection
}) => {
  if (!info.track) {
    Log.trace(logLevel, "No video track found, cannot seek yet");
    return {
      type: "valid-but-must-wait"
    };
  }
  const cuesResponse = info.loadedCues ?? await webmState.cues.getLoadedCues();
  const byteFromObservedKeyframe = findKeyframeBeforeTime2({
    keyframes: info.keyframes,
    time: time2
  });
  const byteFromCues = getByteFromCues({
    cuesResponse,
    time: time2,
    info,
    logLevel
  });
  const byteFromFirstMediaSection = webmState.getFirstCluster()?.start ?? null;
  const seekPossibilities = [
    byteFromCues?.byte ?? null,
    byteFromObservedKeyframe?.positionInBytes ?? null,
    byteFromFirstMediaSection
  ].filter((n) => n !== null);
  const byteToSeekTo = seekPossibilities.length === 0 ? null : Math.max(...seekPossibilities);
  if (byteToSeekTo === null) {
    return {
      type: "invalid"
    };
  }
  mediaSection.addMediaSection({
    start: byteToSeekTo,
    size: 1
  });
  const timeInSeconds = (() => {
    if (byteToSeekTo === byteFromObservedKeyframe?.positionInBytes) {
      return Math.min(byteFromObservedKeyframe.decodingTimeInSeconds, byteFromObservedKeyframe.presentationTimeInSeconds);
    }
    if (byteToSeekTo === byteFromCues?.byte) {
      return byteFromCues.timeInSeconds;
    }
    if (byteToSeekTo === byteFromFirstMediaSection) {
      return 0;
    }
    throw new Error("Should not happen");
  })();
  return {
    type: "do-seek",
    byte: byteToSeekTo,
    timeInSeconds
  };
};
var makeObservedPesHeader = () => {
  const pesHeaders = [];
  const confirmedAsKeyframe = [];
  const addPesHeader = (pesHeader) => {
    if (pesHeaders.find((p) => p.offset === pesHeader.offset)) {
      return;
    }
    pesHeaders.push(pesHeader);
  };
  const markPtsAsKeyframe = (pts) => {
    confirmedAsKeyframe.push(pts);
  };
  const getPesKeyframeHeaders = () => {
    return pesHeaders.filter((p) => confirmedAsKeyframe.includes(p.pts));
  };
  const setPesKeyframesFromSeekingHints = (hints) => {
    for (const pesHeader of hints.observedPesHeaders) {
      addPesHeader(pesHeader);
      markPtsAsKeyframe(pesHeader.pts);
    }
  };
  const state = {
    pesHeaders,
    addPesHeader,
    markPtsAsKeyframe,
    getPesKeyframeHeaders,
    setPesKeyframesFromSeekingHints
  };
  return state;
};
var getLastKeyFrameBeforeTimeInSeconds = ({
  observedPesHeaders,
  timeInSeconds,
  ptsStartOffset
}) => {
  return observedPesHeaders.findLast((k) => (k.pts - ptsStartOffset) / MPEG_TIMESCALE <= timeInSeconds);
};
var getSeekingByte = ({
  info,
  time: time2,
  logLevel,
  currentPosition,
  isoState,
  transportStream,
  webmState,
  mediaSection,
  m3uPlaylistContext,
  structure,
  riffState,
  m3uState,
  avcState
}) => {
  if (info.type === "iso-base-media-seeking-hints") {
    return getSeekingByteFromIsoBaseMedia({
      info,
      time: time2,
      logLevel,
      currentPosition,
      isoState,
      structure,
      m3uPlaylistContext
    });
  }
  if (info.type === "wav-seeking-hints") {
    return getSeekingByteFromWav({
      info,
      time: time2
    });
  }
  if (info.type === "webm-seeking-hints") {
    return getSeekingByteFromMatroska({
      info,
      time: time2,
      webmState,
      logLevel,
      mediaSection
    });
  }
  if (info.type === "flac-seeking-hints") {
    const byte = getSeekingByteForFlac({
      seekingHints: info,
      time: time2
    });
    if (byte) {
      return Promise.resolve({
        type: "do-seek",
        byte: byte.offset,
        timeInSeconds: byte.timeInSeconds
      });
    }
    return Promise.resolve({
      type: "valid-but-must-wait"
    });
  }
  if (info.type === "transport-stream-seeking-hints") {
    const lastKeyframeBeforeTimeInSeconds = getLastKeyFrameBeforeTimeInSeconds({
      observedPesHeaders: info.observedPesHeaders,
      timeInSeconds: time2,
      ptsStartOffset: info.ptsStartOffset
    });
    if (!lastKeyframeBeforeTimeInSeconds) {
      transportStream.resetBeforeSeek();
      return Promise.resolve({
        type: "do-seek",
        byte: 0,
        timeInSeconds: 0
      });
    }
    const byte = lastKeyframeBeforeTimeInSeconds.offset;
    transportStream.resetBeforeSeek();
    return Promise.resolve({
      type: "do-seek",
      byte,
      timeInSeconds: Math.min(lastKeyframeBeforeTimeInSeconds.pts, lastKeyframeBeforeTimeInSeconds.dts ?? Infinity) / MPEG_TIMESCALE
    });
  }
  if (info.type === "riff-seeking-hints") {
    return getSeekingByteForRiff({
      info,
      time: time2,
      riffState,
      avcState
    });
  }
  if (info.type === "mp3-seeking-hints") {
    return Promise.resolve(getSeekingByteForMp3({
      info,
      time: time2
    }));
  }
  if (info.type === "aac-seeking-hints") {
    return Promise.resolve(getSeekingByteForAac({
      time: time2,
      seekingHints: info
    }));
  }
  if (info.type === "m3u8-seeking-hints") {
    return Promise.resolve(getSeekingByteForM3u8({
      time: time2,
      currentPosition,
      m3uState,
      logLevel
    }));
  }
  throw new Error(`Unknown seeking info type: ${info}`);
};
var getSeekingHintsForAac = ({
  aacState,
  samplesObserved
}) => {
  return {
    type: "aac-seeking-hints",
    audioSampleMap: aacState.audioSamples.getSamples(),
    lastSampleObserved: samplesObserved.getLastSampleObserved()
  };
};
var setSeekingHintsForAac = () => {};
var getSeekingHintsForFlac = ({
  flacState,
  samplesObserved
}) => {
  return {
    type: "flac-seeking-hints",
    audioSampleMap: flacState.audioSamples.getSamples(),
    blockingBitStrategy: flacState.getBlockingBitStrategy() ?? null,
    lastSampleObserved: samplesObserved.getLastSampleObserved()
  };
};
var setSeekingHintsForFlac = ({
  hints,
  state
}) => {
  if (hints.blockingBitStrategy !== null) {
    state.flac.setBlockingBitStrategy(hints.blockingBitStrategy);
  }
  state.flac.audioSamples.setFromSeekingHints(hints.audioSampleMap);
};
var getSeekingHintsFromMp4 = ({
  structureState,
  isoState,
  mp4HeaderSegment,
  mediaSectionState: mediaSectionState2
}) => {
  const structure = structureState.getIsoStructure();
  const moovAtom = getMoovBoxFromState({
    isoState,
    mp4HeaderSegment,
    structureState,
    mayUsePrecomputed: true
  });
  const moofBoxes = deduplicateMoofBoxesByOffset([
    ...isoState.moof.getMoofBoxes(),
    ...getMoofBoxes(structure.boxes)
  ]);
  const tfraBoxes = deduplicateTfraBoxesByOffset([
    ...isoState.tfra.getTfraBoxes(),
    ...getTfraBoxes(structure.boxes)
  ]);
  if (!moovAtom) {
    return null;
  }
  return {
    type: "iso-base-media-seeking-hints",
    moovBox: moovAtom,
    moofBoxes,
    tfraBoxes,
    mediaSections: mediaSectionState2.getMediaSections(),
    mfraAlreadyLoaded: isoState.mfra.getIfAlreadyLoaded()
  };
};
var setSeekingHintsForMp4 = ({}) => {};
var getSeekingHintsForM3u = () => {
  return {
    type: "m3u8-seeking-hints"
  };
};
var getSeekingHintsForMp3 = ({
  mp3State,
  samplesObserved,
  mediaSectionState: mediaSectionState2,
  contentLength
}) => {
  return {
    type: "mp3-seeking-hints",
    audioSampleMap: mp3State.audioSamples.getSamples(),
    lastSampleObserved: samplesObserved.getLastSampleObserved(),
    mp3BitrateInfo: mp3State.getMp3BitrateInfo(),
    mp3Info: mp3State.getMp3Info(),
    mediaSection: mediaSectionState2.getMediaSections()[0] ?? null,
    contentLength
  };
};
var setSeekingHintsForMp3 = ({
  hints,
  state
}) => {
  state.mp3.audioSamples.setFromSeekingHints(hints.audioSampleMap);
};
var riffHasIndex = (structure) => {
  return structure.boxes.find((b) => b.type === "list-box" && b.listType === "hdrl")?.children.find((box2) => box2.type === "avih-box")?.hasIndex ?? false;
};
var getSeekingHintsForRiff = ({
  structureState,
  riffState,
  mediaSectionState: mediaSectionState2
}) => {
  const structure = structureState.getRiffStructure();
  const strl = getStrlBoxes(structure);
  let samplesPerSecond = null;
  for (const s of strl) {
    const strh = getStrhBox(s.children);
    if (!strh) {
      throw new Error("No strh box");
    }
    if (strh.strf.type !== "strf-box-video") {
      continue;
    }
    samplesPerSecond = strh.rate / strh.scale;
    break;
  }
  return {
    type: "riff-seeking-hints",
    hasIndex: riffHasIndex(structure),
    idx1Entries: riffState.lazyIdx1.getIfAlreadyLoaded(),
    samplesPerSecond,
    moviOffset: mediaSectionState2.getMediaSections()[0]?.start ?? null,
    observedKeyframes: riffState.sampleCounter.riffKeys.getKeyframes()
  };
};
var setSeekingHintsForRiff = ({
  hints,
  state
}) => {
  state.riff.lazyIdx1.setFromSeekingHints(hints);
  state.riff.sampleCounter.riffKeys.setFromSeekingHints(hints.observedKeyframes);
};
var getSeekingHintsFromTransportStream = (transportStream, tracksState) => {
  const firstVideoTrack = tracksState.getTracks().find((t) => t.type === "video");
  if (!firstVideoTrack) {
    return null;
  }
  return {
    type: "transport-stream-seeking-hints",
    observedPesHeaders: transportStream.observedPesHeaders.getPesKeyframeHeaders(),
    ptsStartOffset: transportStream.startOffset.getOffset(firstVideoTrack.trackId),
    firstVideoTrackId: firstVideoTrack.trackId
  };
};
var setSeekingHintsForTransportStream = ({
  hints,
  state
}) => {
  state.transportStream.observedPesHeaders.setPesKeyframesFromSeekingHints(hints);
  state.transportStream.startOffset.setOffset({
    trackId: hints.firstVideoTrackId,
    newOffset: hints.ptsStartOffset
  });
};
var getSeekingHintsFromWav = ({
  structure,
  mediaSectionState: mediaSectionState2
}) => {
  const fmtBox = structure.boxes.find((box2) => box2.type === "wav-fmt");
  if (!fmtBox) {
    return null;
  }
  const mediaSection = mediaSectionState2.getMediaSections();
  if (mediaSection.length !== 1) {
    return null;
  }
  return {
    type: "wav-seeking-hints",
    sampleRate: fmtBox.sampleRate,
    blockAlign: fmtBox.blockAlign,
    mediaSection: mediaSection[0]
  };
};
var setSeekingHintsForWav = ({
  hints,
  state
}) => {
  state.mediaSection.addMediaSection(hints.mediaSection);
};
var getSeekingHintsFromMatroska = (tracksState, keyframesState, webmState) => {
  const tracks2 = tracksState.getTracks();
  const firstVideoTrack = tracks2.find((track) => track.type === "video");
  const keyframes = keyframesState.getKeyframes();
  const loadedCues = webmState.cues.getIfAlreadyLoaded();
  return {
    type: "webm-seeking-hints",
    track: firstVideoTrack ? {
      timescale: firstVideoTrack.originalTimescale,
      trackId: firstVideoTrack.trackId
    } : null,
    keyframes,
    loadedCues,
    timestampMap: webmState.getTimeStampMapForSeekingHints()
  };
};
var setSeekingHintsForWebm = ({
  hints,
  state
}) => {
  state.webm.cues.setFromSeekingHints(hints);
  state.keyframes.setFromSeekingHints(hints.keyframes);
  state.webm.setTimeStampMapForSeekingHints(hints.timestampMap);
};
var getSeekingHints = ({
  structureState,
  m3uPlaylistContext,
  mediaSectionState: mediaSectionState2,
  isoState,
  transportStream,
  tracksState,
  keyframesState,
  webmState,
  flacState,
  samplesObserved,
  riffState,
  mp3State,
  contentLength,
  aacState
}) => {
  const structure = structureState.getStructureOrNull();
  if (!structure) {
    return null;
  }
  if (structure.type === "iso-base-media") {
    return getSeekingHintsFromMp4({
      structureState,
      isoState,
      mp4HeaderSegment: m3uPlaylistContext?.mp4HeaderSegment ?? null,
      mediaSectionState: mediaSectionState2
    });
  }
  if (structure.type === "wav") {
    return getSeekingHintsFromWav({
      structure,
      mediaSectionState: mediaSectionState2
    });
  }
  if (structure.type === "matroska") {
    return getSeekingHintsFromMatroska(tracksState, keyframesState, webmState);
  }
  if (structure.type === "transport-stream") {
    return getSeekingHintsFromTransportStream(transportStream, tracksState);
  }
  if (structure.type === "flac") {
    return getSeekingHintsForFlac({
      flacState,
      samplesObserved
    });
  }
  if (structure.type === "riff") {
    return getSeekingHintsForRiff({
      structureState,
      riffState,
      mediaSectionState: mediaSectionState2
    });
  }
  if (structure.type === "mp3") {
    return getSeekingHintsForMp3({
      mp3State,
      samplesObserved,
      mediaSectionState: mediaSectionState2,
      contentLength
    });
  }
  if (structure.type === "aac") {
    return getSeekingHintsForAac({
      aacState,
      samplesObserved
    });
  }
  if (structure.type === "m3u") {
    return getSeekingHintsForM3u();
  }
  throw new Error(`Seeking is not supported for this format: ${structure}`);
};
var seekBackwards = async ({
  iterator,
  seekTo,
  readerInterface,
  src,
  controller,
  logLevel,
  currentReader,
  prefetchCache
}) => {
  const howManyBytesWeCanGoBack = iterator.counter.getDiscardedOffset();
  if (iterator.counter.getOffset() - howManyBytesWeCanGoBack <= seekTo) {
    Log.verbose(logLevel, `Seeking back to ${seekTo}`);
    iterator.skipTo(seekTo);
    return;
  }
  const time2 = Date.now();
  Log.verbose(logLevel, `Seeking in video from position ${iterator.counter.getOffset()} -> ${seekTo}. Re-reading because this portion is not available.`);
  await currentReader.getCurrent().abort();
  const { reader: newReader } = await readerInterface.read({
    src,
    range: seekTo,
    controller,
    logLevel,
    prefetchCache
  });
  iterator.replaceData(new Uint8Array([]), seekTo);
  Log.verbose(logLevel, `Re-reading took ${Date.now() - time2}ms. New position: ${iterator.counter.getOffset()}`);
  currentReader.setCurrent(newReader);
};
var fieldsNeedSamplesMap = {
  slowDurationInSeconds: true,
  slowFps: true,
  slowKeyframes: true,
  slowNumberOfFrames: true,
  audioCodec: false,
  container: false,
  dimensions: false,
  durationInSeconds: false,
  fps: false,
  internalStats: false,
  isHdr: false,
  name: false,
  rotation: false,
  size: false,
  slowStructure: false,
  tracks: false,
  unrotatedDimensions: false,
  videoCodec: false,
  metadata: false,
  location: false,
  mimeType: false,
  keyframes: false,
  images: false,
  numberOfAudioChannels: false,
  sampleRate: false,
  slowAudioBitrate: true,
  slowVideoBitrate: true,
  m3uStreams: false
};
var needsToIterateOverSamples = ({
  fields,
  emittedFields
}) => {
  const keys = Object.keys(fields ?? {});
  const selectedKeys = keys.filter((k) => fields[k]);
  return selectedKeys.some((k) => fieldsNeedSamplesMap[k] && !emittedFields[k]);
};
var fieldsNeedEverySampleMap = {
  ...fieldsNeedSamplesMap,
  slowDurationInSeconds: false
};
var needsToIterateOverEverySample = ({
  fields,
  emittedFields
}) => {
  const keys = Object.keys(fields ?? {});
  const selectedKeys = keys.filter((k) => fields[k]);
  return selectedKeys.some((k) => fieldsNeedEverySampleMap[k] && !emittedFields[k]);
};
var disallowForwardSeekIfSamplesAreNeeded = ({
  seekTo,
  previousPosition,
  fields
}) => {
  const fieldsNeedingSamples = Object.entries(fields).filter(([, value]) => value).map(([key4]) => key4).filter((key4) => fieldsNeedSamplesMap[key4]);
  if (fieldsNeedingSamples.length > 0) {
    throw new Error(`Forward seeking is not allowed when the following fields are requested from parseMedia(): ${fieldsNeedingSamples.join(", ")}. Seek was from 0x${previousPosition.toString(16)} to 0x${seekTo.toString(16)}. Either don't seek forward, or don't request these fields.`);
  }
};
var seekForward = async ({
  seekTo,
  userInitiated,
  iterator,
  fields,
  logLevel,
  currentReader,
  readerInterface,
  src,
  controller,
  discardReadBytes,
  prefetchCache
}) => {
  if (userInitiated) {
    disallowForwardSeekIfSamplesAreNeeded({
      fields,
      seekTo,
      previousPosition: iterator.counter.getOffset()
    });
  }
  const alreadyHasBuffer = iterator.bytesRemaining() >= seekTo - iterator.counter.getOffset();
  Log.verbose(logLevel, `Performing seek from ${iterator.counter.getOffset()} to ${seekTo}`);
  if (alreadyHasBuffer) {
    iterator.skipTo(seekTo);
    Log.verbose(logLevel, `Already read ahead enough, skipping forward`);
    return;
  }
  const time2 = Date.now();
  Log.verbose(logLevel, `Skipping over video data from position ${iterator.counter.getOffset()} -> ${seekTo}. Re-reading because this portion is not available`);
  await currentReader.getCurrent().abort();
  const { reader: newReader } = await readerInterface.read({
    src,
    range: seekTo,
    controller,
    logLevel,
    prefetchCache
  });
  iterator.skipTo(seekTo);
  await discardReadBytes(true);
  Log.verbose(logLevel, `Re-reading took ${Date.now() - time2}ms. New position: ${iterator.counter.getOffset()}`);
  currentReader.setCurrent(newReader);
};
var performSeek = async ({
  seekTo,
  userInitiated,
  controller,
  mediaSection,
  iterator,
  seekInfiniteLoop,
  logLevel,
  mode,
  contentLength,
  currentReader,
  readerInterface,
  src,
  discardReadBytes,
  fields,
  prefetchCache,
  isoState
}) => {
  const byteInMediaSection = isByteInMediaSection({
    position: seekTo,
    mediaSections: mediaSection.getMediaSections()
  });
  if (byteInMediaSection !== "in-section" && userInitiated) {
    const sections = mediaSection.getMediaSections();
    const sectionStrings = sections.map((section) => {
      return `start: ${section.start}, end: ${section.size + section.start}`;
    });
    throw new Error(`Cannot seek to a byte that is not in the video section. Seeking to: ${seekTo}, sections: ${sectionStrings.join(" | ")}`);
  }
  seekInfiniteLoop.registerSeek(seekTo);
  if (seekTo <= iterator.counter.getOffset() && mode === "download") {
    throw new Error(`Seeking backwards is not supported in parseAndDownloadMedia() mode. Current position: ${iterator.counter.getOffset()}, seekTo: ${seekTo}`);
  }
  if (seekTo > contentLength) {
    throw new Error(`Cannot seek beyond the end of the file: ${seekTo} > ${contentLength}`);
  }
  if (mode === "download") {
    Log.verbose(logLevel, `Skipping over video data from position ${iterator.counter.getOffset()} -> ${seekTo}. Fetching but not reading all the data inbetween because in download mode`);
    iterator.discard(seekTo - iterator.counter.getOffset());
    return;
  }
  await controller._internals.checkForAbortAndPause();
  const alreadyAtByte = iterator.counter.getOffset() === seekTo;
  if (alreadyAtByte) {
    Log.verbose(logLevel, `Already at the desired position, seeking done`);
    controller._internals.performedSeeksSignal.markLastSeekAsUserInitiated();
    return;
  }
  const skippingForward = seekTo > iterator.counter.getOffset();
  controller._internals.performedSeeksSignal.recordSeek({
    from: iterator.counter.getOffset(),
    to: seekTo,
    type: userInitiated ? "user-initiated" : "internal"
  });
  if (skippingForward) {
    await seekForward({
      seekTo,
      userInitiated,
      iterator,
      fields,
      logLevel,
      currentReader,
      readerInterface,
      src,
      controller,
      discardReadBytes,
      prefetchCache
    });
  } else {
    await seekBackwards({
      controller,
      seekTo,
      iterator,
      logLevel,
      currentReader,
      readerInterface,
      src,
      prefetchCache
    });
  }
  if (userInitiated) {
    isoState.flatSamples.updateAfterSeek(seekTo);
  }
  await controller._internals.checkForAbortAndPause();
};
var turnSeekIntoByte = async ({
  seek: seek2,
  mediaSectionState: mediaSectionState2,
  logLevel,
  iterator,
  structureState,
  m3uPlaylistContext,
  isoState,
  transportStream,
  tracksState,
  webmState,
  keyframes,
  flacState,
  samplesObserved,
  riffState,
  mp3State,
  contentLength,
  aacState,
  m3uState,
  avcState
}) => {
  const mediaSections = mediaSectionState2.getMediaSections();
  if (mediaSections.length === 0) {
    Log.trace(logLevel, "No media sections defined, cannot seek yet");
    return {
      type: "valid-but-must-wait"
    };
  }
  if (seek2 < 0) {
    throw new Error(`Cannot seek to a negative time: ${JSON.stringify(seek2)}`);
  }
  const seekingHints = getSeekingHints({
    riffState,
    samplesObserved,
    structureState,
    mediaSectionState: mediaSectionState2,
    isoState,
    transportStream,
    tracksState,
    keyframesState: keyframes,
    webmState,
    flacState,
    mp3State,
    contentLength,
    aacState,
    m3uPlaylistContext
  });
  if (!seekingHints) {
    Log.trace(logLevel, "No seeking info, cannot seek yet");
    return {
      type: "valid-but-must-wait"
    };
  }
  const seekingByte = await getSeekingByte({
    info: seekingHints,
    time: seek2,
    logLevel,
    currentPosition: iterator.counter.getOffset(),
    isoState,
    transportStream,
    webmState,
    mediaSection: mediaSectionState2,
    m3uPlaylistContext,
    structure: structureState,
    riffState,
    m3uState,
    avcState
  });
  return seekingByte;
};
var getWorkOnSeekRequestOptions = (state) => {
  return {
    logLevel: state.logLevel,
    controller: state.controller,
    isoState: state.iso,
    iterator: state.iterator,
    structureState: state.structure,
    src: state.src,
    contentLength: state.contentLength,
    readerInterface: state.readerInterface,
    mediaSection: state.mediaSection,
    m3uPlaylistContext: state.m3uPlaylistContext,
    mode: state.mode,
    seekInfiniteLoop: state.seekInfiniteLoop,
    currentReader: state.currentReader,
    discardReadBytes: state.discardReadBytes,
    fields: state.fields,
    transportStream: state.transportStream,
    tracksState: state.callbacks.tracks,
    webmState: state.webm,
    keyframes: state.keyframes,
    flacState: state.flac,
    samplesObserved: state.samplesObserved,
    riffState: state.riff,
    mp3State: state.mp3,
    aacState: state.aac,
    m3uState: state.m3u,
    prefetchCache: state.prefetchCache,
    avcState: state.avc
  };
};
var workOnSeekRequest = async (options) => {
  const {
    logLevel,
    controller,
    mediaSection,
    m3uPlaylistContext,
    isoState,
    iterator,
    structureState,
    src,
    contentLength,
    readerInterface,
    mode,
    seekInfiniteLoop,
    currentReader,
    discardReadBytes,
    fields,
    transportStream,
    tracksState,
    webmState,
    keyframes,
    flacState,
    samplesObserved,
    riffState,
    mp3State,
    aacState,
    prefetchCache,
    m3uState,
    avcState
  } = options;
  const seek2 = controller._internals.seekSignal.getSeek();
  if (seek2 === null) {
    return;
  }
  Log.trace(logLevel, `Has seek request for ${src}: ${JSON.stringify(seek2)}`);
  const resolution = await turnSeekIntoByte({
    seek: seek2,
    mediaSectionState: mediaSection,
    logLevel,
    iterator,
    structureState,
    m3uPlaylistContext,
    isoState,
    transportStream,
    tracksState,
    webmState,
    keyframes,
    flacState,
    samplesObserved,
    riffState,
    mp3State,
    contentLength,
    aacState,
    m3uState,
    avcState
  });
  Log.trace(logLevel, `Seek action: ${JSON.stringify(resolution)}`);
  if (resolution.type === "intermediary-seek") {
    await performSeek({
      seekTo: resolution.byte,
      userInitiated: false,
      controller,
      mediaSection,
      iterator,
      logLevel,
      mode,
      contentLength,
      seekInfiniteLoop,
      currentReader,
      readerInterface,
      src,
      discardReadBytes,
      fields,
      prefetchCache,
      isoState
    });
    return;
  }
  if (resolution.type === "do-seek") {
    await performSeek({
      seekTo: resolution.byte,
      userInitiated: true,
      controller,
      mediaSection,
      iterator,
      logLevel,
      mode,
      contentLength,
      seekInfiniteLoop,
      currentReader,
      readerInterface,
      src,
      discardReadBytes,
      fields,
      prefetchCache,
      isoState
    });
    const { hasChanged } = controller._internals.seekSignal.clearSeekIfStillSame(seek2);
    if (hasChanged) {
      Log.trace(logLevel, `Seek request has changed while seeking, seeking again`);
      await workOnSeekRequest(options);
    }
    return;
  }
  if (resolution.type === "invalid") {
    throw new Error(`The seek request ${JSON.stringify(seek2)} cannot be processed`);
  }
  if (resolution.type === "valid-but-must-wait") {
    Log.trace(logLevel, "Seek request is valid but cannot be processed yet");
  }
};
var emitAvailableInfo = async ({
  hasInfo,
  state
}) => {
  const keys = Object.keys(hasInfo);
  const {
    emittedFields,
    fieldsInReturnValue,
    returnValue,
    name,
    callbackFunctions
  } = state;
  for (const key4 of keys) {
    await workOnSeekRequest(getWorkOnSeekRequestOptions(state));
    if (key4 === "slowStructure") {
      if (hasInfo.slowStructure && !emittedFields.slowStructure) {
        await callbackFunctions.onSlowStructure?.(state.structure.getStructure());
        if (fieldsInReturnValue.slowStructure) {
          returnValue.slowStructure = state.structure.getStructure();
        }
        emittedFields.slowStructure = true;
      }
      continue;
    }
    if (key4 === "durationInSeconds") {
      if (hasInfo.durationInSeconds) {
        if (!emittedFields.durationInSeconds) {
          const durationInSeconds = getDuration(state);
          await callbackFunctions.onDurationInSeconds?.(durationInSeconds);
          if (fieldsInReturnValue.durationInSeconds) {
            returnValue.durationInSeconds = durationInSeconds;
          }
          emittedFields.durationInSeconds = true;
        }
      }
      continue;
    }
    if (key4 === "slowDurationInSeconds") {
      if (hasInfo.slowDurationInSeconds && !emittedFields.slowDurationInSeconds) {
        const slowDurationInSeconds = getDuration(state) ?? state.samplesObserved.getSlowDurationInSeconds();
        await callbackFunctions.onSlowDurationInSeconds?.(slowDurationInSeconds);
        if (fieldsInReturnValue.slowDurationInSeconds) {
          returnValue.slowDurationInSeconds = slowDurationInSeconds;
        }
        emittedFields.slowDurationInSeconds = true;
      }
      continue;
    }
    if (key4 === "fps") {
      if (hasInfo.fps) {
        if (!emittedFields.fps) {
          const fps = getFps(state);
          await callbackFunctions.onFps?.(fps);
          if (fieldsInReturnValue.fps) {
            returnValue.fps = fps;
          }
          emittedFields.fps = true;
        }
        if (!emittedFields.slowFps) {
          const fps = getFps(state);
          if (fps) {
            await callbackFunctions.onSlowFps?.(fps);
            if (fieldsInReturnValue.slowFps) {
              returnValue.slowFps = fps;
            }
            emittedFields.slowFps = true;
          }
        }
      }
      continue;
    }
    if (key4 === "slowFps") {
      if (hasInfo.slowFps && !emittedFields.slowFps) {
        const slowFps = getFps(state) ?? state.samplesObserved.getFps();
        await callbackFunctions.onSlowFps?.(slowFps);
        if (fieldsInReturnValue.slowFps) {
          returnValue.slowFps = slowFps;
        }
        emittedFields.slowFps = true;
      }
      continue;
    }
    if (key4 === "dimensions") {
      if (hasInfo.dimensions && !emittedFields.dimensions) {
        const dimensionsQueried = getDimensions(state);
        const dimensions = dimensionsQueried === null ? null : {
          height: dimensionsQueried.height,
          width: dimensionsQueried.width
        };
        await callbackFunctions.onDimensions?.(dimensions);
        if (fieldsInReturnValue.dimensions) {
          returnValue.dimensions = dimensions;
        }
        emittedFields.dimensions = true;
      }
      continue;
    }
    if (key4 === "unrotatedDimensions") {
      if (hasInfo.unrotatedDimensions && !emittedFields.unrotatedDimensions) {
        const dimensionsQueried = getDimensions(state);
        const unrotatedDimensions = dimensionsQueried === null ? null : {
          height: dimensionsQueried.unrotatedHeight,
          width: dimensionsQueried.unrotatedWidth
        };
        await callbackFunctions.onUnrotatedDimensions?.(unrotatedDimensions);
        if (fieldsInReturnValue.unrotatedDimensions) {
          returnValue.unrotatedDimensions = unrotatedDimensions;
        }
        emittedFields.unrotatedDimensions = true;
      }
      continue;
    }
    if (key4 === "rotation") {
      if (hasInfo.rotation && !emittedFields.rotation) {
        const dimensionsQueried = getDimensions(state);
        const rotation = dimensionsQueried?.rotation ?? 0;
        await callbackFunctions.onRotation?.(rotation);
        if (fieldsInReturnValue.rotation) {
          returnValue.rotation = rotation;
        }
        emittedFields.rotation = true;
      }
      continue;
    }
    if (key4 === "videoCodec") {
      if (!emittedFields.videoCodec && hasInfo.videoCodec) {
        const videoCodec = getVideoCodec(state);
        await callbackFunctions.onVideoCodec?.(videoCodec);
        if (fieldsInReturnValue.videoCodec) {
          returnValue.videoCodec = videoCodec;
        }
        emittedFields.videoCodec = true;
      }
      continue;
    }
    if (key4 === "audioCodec") {
      if (!emittedFields.audioCodec && hasInfo.audioCodec) {
        const audioCodec = getAudioCodec(state);
        await callbackFunctions.onAudioCodec?.(audioCodec);
        if (fieldsInReturnValue.audioCodec) {
          returnValue.audioCodec = audioCodec;
        }
        emittedFields.audioCodec = true;
      }
      continue;
    }
    if (key4 === "tracks") {
      if (!emittedFields.tracks && hasInfo.tracks) {
        const tracks2 = getTracks(state, true);
        await callbackFunctions.onTracks?.(tracks2);
        if (fieldsInReturnValue.tracks) {
          returnValue.tracks = tracks2;
        }
        emittedFields.tracks = true;
      }
      continue;
    }
    if (key4 === "internalStats") {
      if (hasInfo.internalStats) {
        const internalStats = state.getInternalStats();
        if (fieldsInReturnValue.internalStats) {
          returnValue.internalStats = internalStats;
        }
        emittedFields.internalStats = true;
      }
      continue;
    }
    if (key4 === "size") {
      if (!emittedFields.size && hasInfo.size) {
        await callbackFunctions.onSize?.(state.contentLength);
        if (fieldsInReturnValue.size) {
          returnValue.size = state.contentLength;
        }
        emittedFields.size = true;
      }
      continue;
    }
    if (key4 === "mimeType") {
      if (!emittedFields.mimeType && hasInfo.mimeType) {
        await callbackFunctions.onMimeType?.(state.mimeType);
        if (fieldsInReturnValue.mimeType) {
          returnValue.mimeType = state.mimeType;
        }
        emittedFields.mimeType = true;
      }
      continue;
    }
    if (key4 === "name") {
      if (!emittedFields.name && hasInfo.name) {
        await callbackFunctions.onName?.(name);
        if (fieldsInReturnValue.name) {
          returnValue.name = name;
        }
        emittedFields.name = true;
      }
      continue;
    }
    if (key4 === "isHdr") {
      if (!returnValue.isHdr && hasInfo.isHdr) {
        const isHdr = getIsHdr(state);
        await callbackFunctions.onIsHdr?.(isHdr);
        if (fieldsInReturnValue.isHdr) {
          returnValue.isHdr = isHdr;
        }
        emittedFields.isHdr = true;
      }
      continue;
    }
    if (key4 === "container") {
      if (!returnValue.container && hasInfo.container) {
        const container42 = getContainer(state.structure.getStructure());
        await callbackFunctions.onContainer?.(container42);
        if (fieldsInReturnValue.container) {
          returnValue.container = container42;
        }
        emittedFields.container = true;
      }
      continue;
    }
    if (key4 === "metadata") {
      if (!emittedFields.metadata && hasInfo.metadata) {
        const metadata = getMetadata(state);
        await callbackFunctions.onMetadata?.(metadata);
        if (fieldsInReturnValue.metadata) {
          returnValue.metadata = metadata;
        }
        emittedFields.metadata = true;
      }
      continue;
    }
    if (key4 === "location") {
      if (!emittedFields.location && hasInfo.location) {
        const location2 = getLocation(state);
        await callbackFunctions.onLocation?.(location2);
        if (fieldsInReturnValue.location) {
          returnValue.location = location2;
        }
        emittedFields.location = true;
      }
      continue;
    }
    if (key4 === "slowKeyframes") {
      if (!emittedFields.slowKeyframes && hasInfo.slowKeyframes) {
        await callbackFunctions.onSlowKeyframes?.(state.keyframes.getKeyframes());
        if (fieldsInReturnValue.slowKeyframes) {
          returnValue.slowKeyframes = state.keyframes.getKeyframes();
        }
        emittedFields.slowKeyframes = true;
      }
      continue;
    }
    if (key4 === "slowNumberOfFrames") {
      if (!emittedFields.slowNumberOfFrames && hasInfo.slowNumberOfFrames) {
        await callbackFunctions.onSlowNumberOfFrames?.(state.samplesObserved.getSlowNumberOfFrames());
        if (fieldsInReturnValue.slowNumberOfFrames) {
          returnValue.slowNumberOfFrames = state.samplesObserved.getSlowNumberOfFrames();
        }
        emittedFields.slowNumberOfFrames = true;
      }
      continue;
    }
    if (key4 === "slowAudioBitrate") {
      if (!emittedFields.slowAudioBitrate && hasInfo.slowAudioBitrate) {
        await callbackFunctions.onSlowAudioBitrate?.(state.samplesObserved.getAudioBitrate());
        if (fieldsInReturnValue.slowAudioBitrate) {
          returnValue.slowAudioBitrate = state.samplesObserved.getAudioBitrate();
        }
        emittedFields.slowAudioBitrate = true;
      }
      continue;
    }
    if (key4 === "slowVideoBitrate") {
      if (!emittedFields.slowVideoBitrate && hasInfo.slowVideoBitrate) {
        await callbackFunctions.onSlowVideoBitrate?.(state.samplesObserved.getVideoBitrate());
        if (fieldsInReturnValue.slowVideoBitrate) {
          returnValue.slowVideoBitrate = state.samplesObserved.getVideoBitrate();
        }
        emittedFields.slowVideoBitrate = true;
      }
      continue;
    }
    if (key4 === "keyframes") {
      if (!emittedFields.keyframes && hasInfo.keyframes) {
        await callbackFunctions.onKeyframes?.(getKeyframes(state));
        if (fieldsInReturnValue.keyframes) {
          returnValue.keyframes = getKeyframes(state);
        }
        emittedFields.keyframes = true;
      }
      continue;
    }
    if (key4 === "images") {
      if (!emittedFields.images && hasInfo.images) {
        await callbackFunctions.onImages?.(state.images.images);
        if (fieldsInReturnValue.images) {
          returnValue.images = state.images.images;
        }
        emittedFields.images = true;
      }
      continue;
    }
    if (key4 === "sampleRate") {
      if (!emittedFields.sampleRate && hasInfo.sampleRate) {
        const sampleRate = getSampleRate3(state);
        await callbackFunctions.onSampleRate?.(sampleRate);
        if (fieldsInReturnValue.sampleRate) {
          returnValue.sampleRate = sampleRate;
        }
        emittedFields.sampleRate = true;
      }
      continue;
    }
    if (key4 === "numberOfAudioChannels") {
      if (!emittedFields.numberOfAudioChannels && hasInfo.numberOfAudioChannels) {
        const numberOfAudioChannels = getNumberOfAudioChannels(state);
        await callbackFunctions.onNumberOfAudioChannels?.(numberOfAudioChannels);
        if (fieldsInReturnValue.numberOfAudioChannels) {
          returnValue.numberOfAudioChannels = numberOfAudioChannels;
        }
        emittedFields.numberOfAudioChannels = true;
      }
      continue;
    }
    if (key4 === "m3uStreams") {
      if (!emittedFields.m3uStreams && hasInfo.m3uStreams) {
        const streams = getM3uStreams({
          structure: state.structure.getStructureOrNull(),
          originalSrc: state.src,
          readerInterface: state.readerInterface
        });
        await callbackFunctions.onM3uStreams?.(streams);
        if (fieldsInReturnValue.m3uStreams) {
          returnValue.m3uStreams = streams;
        }
        emittedFields.m3uStreams = true;
      }
      continue;
    }
    throw new Error(`Unhandled key: ${key4}`);
  }
  await workOnSeekRequest(getWorkOnSeekRequestOptions(state));
};
var getHasCallbacks = (state) => {
  const hasNoTrackHandlers = !state.callbacks.hasAudioTrackHandlers && !state.callbacks.hasVideoTrackHandlers;
  if (hasNoTrackHandlers) {
    return false;
  }
  const hasAllTracksAndNoCallbacks = !state.callbacks.tracks.hasAllTracks() || Object.values(state.callbacks.videoSampleCallbacks).length > 0 || Object.values(state.callbacks.audioSampleCallbacks).length > 0;
  return hasAllTracksAndNoCallbacks;
};
var missesMatroskaTracks = (state) => {
  const struct = state.structure.getStructureOrNull();
  if (struct === null) {
    return false;
  }
  if (struct.type !== "matroska") {
    return false;
  }
  const mainSegment = getMainSegment(struct.boxes);
  if (mainSegment === null) {
    return false;
  }
  return getTracksFromMatroska({
    structureState: state.structure,
    webmState: state.webm
  }).missingInfo.length > 0;
};
var maySkipVideoData = ({ state }) => {
  const hasCallbacks = getHasCallbacks(state);
  return !hasCallbacks && !needsToIterateOverSamples({
    emittedFields: state.emittedFields,
    fields: state.fields
  }) && !missesMatroskaTracks(state);
};
var maySkipOverSamplesInTheMiddle = ({
  state
}) => {
  const hasCallbacks = getHasCallbacks(state);
  return !hasCallbacks && !needsToIterateOverEverySample({
    emittedFields: state.emittedFields,
    fields: state.fields
  });
};
var getAvailableInfo = ({
  state
}) => {
  const keys = Object.entries(state.fields).filter(([, value]) => value);
  const structure = state.structure.getStructureOrNull();
  const infos = keys.map(([_key]) => {
    const key4 = _key;
    if (key4 === "slowStructure") {
      return false;
    }
    if (key4 === "durationInSeconds") {
      return Boolean(structure && hasDuration(state));
    }
    if (key4 === "slowDurationInSeconds") {
      const res = Boolean(structure && hasSlowDuration(state));
      return res;
    }
    if (key4 === "dimensions" || key4 === "rotation" || key4 === "unrotatedDimensions") {
      return Boolean(structure && hasDimensions(state));
    }
    if (key4 === "fps") {
      return Boolean(structure && hasFps(state));
    }
    if (key4 === "slowFps") {
      return Boolean(structure && hasFpsSuitedForSlowFps(state));
    }
    if (key4 === "isHdr") {
      return Boolean(structure && hasHdr(state));
    }
    if (key4 === "videoCodec") {
      return Boolean(structure && hasVideoCodec(state));
    }
    if (key4 === "audioCodec") {
      return Boolean(structure && hasAudioCodec(state));
    }
    if (key4 === "tracks") {
      return Boolean(structure && getHasTracks(state, true));
    }
    if (key4 === "keyframes") {
      return Boolean(structure && hasKeyframes(state));
    }
    if (key4 === "internalStats") {
      return true;
    }
    if (key4 === "size") {
      return true;
    }
    if (key4 === "mimeType") {
      return true;
    }
    if (key4 === "name") {
      return true;
    }
    if (key4 === "container") {
      return Boolean(structure && hasContainer(structure));
    }
    if (key4 === "metadata" || key4 === "location" || key4 === "images") {
      return Boolean(structure && hasMetadata(structure));
    }
    if (key4 === "slowKeyframes" || key4 === "slowVideoBitrate" || key4 === "slowAudioBitrate" || key4 === "slowNumberOfFrames") {
      return false;
    }
    if (key4 === "numberOfAudioChannels") {
      return hasNumberOfAudioChannels(state);
    }
    if (key4 === "sampleRate") {
      return hasSampleRate(state);
    }
    if (key4 === "m3uStreams") {
      return m3uHasStreams(state);
    }
    throw new Error(`Unknown field passed: ${key4}. Available fields: ${Object.keys(state.fields).join(", ")}`);
  });
  const entries = [];
  let i = 0;
  for (const [key4] of keys) {
    entries.push([key4, infos[i++]]);
  }
  return Object.fromEntries(entries);
};
var hasAllInfo = ({ state }) => {
  const availableInfo = getAvailableInfo({
    state
  });
  if (!Object.values(availableInfo).every(Boolean)) {
    return false;
  }
  if (maySkipVideoData({ state })) {
    return true;
  }
  if (state.callbacks.canSkipTracksState.canSkipTracks()) {
    return true;
  }
  return false;
};
var emitAllInfo = async (state) => {
  const allFields = Object.keys(state.fields).reduce((acc, key4) => {
    if (state.fields?.[key4]) {
      acc[key4] = true;
    }
    return acc;
  }, {});
  await emitAvailableInfo({
    hasInfo: allFields,
    state
  });
};
var triggerInfoEmit = async (state) => {
  const availableInfo = getAvailableInfo({
    state
  });
  await emitAvailableInfo({
    hasInfo: availableInfo,
    state
  });
};
var checkIfDone = async (state) => {
  const startCheck = Date.now();
  const hasAll = hasAllInfo({
    state
  });
  state.timings.timeCheckingIfDone += Date.now() - startCheck;
  if (hasAll && state.mode === "query") {
    Log.verbose(state.logLevel, "Got all info, skipping to the end.");
    state.increaseSkippedBytes(state.contentLength - state.iterator.counter.getOffset());
    return true;
  }
  if (state.iterator.counter.getOffset() === state.contentLength) {
    if (state.structure.getStructure().type === "m3u" && !state.m3u.getAllChunksProcessedOverall()) {
      return false;
    }
    state.riff.queuedBFrames.flush();
    if (state.riff.queuedBFrames.hasReleasedFrames()) {
      return false;
    }
    Log.verbose(state.logLevel, "Reached end of file");
    await state.discardReadBytes(true);
    return true;
  }
  if (state.iterator.counter.getOffset() + state.iterator.bytesRemaining() === state.contentLength && state.errored) {
    Log.verbose(state.logLevel, "Reached end of file and errorred");
    return true;
  }
  return false;
};
var makeProgressObject = (state) => {
  return {
    bytes: state.iterator.counter.getOffset(),
    percentage: state.contentLength ? state.iterator.counter.getOffset() / state.contentLength : null,
    totalBytes: state.contentLength
  };
};
var parseAac = async (state) => {
  const { iterator } = state;
  const startOffset = iterator.counter.getOffset();
  iterator.startReadingBits();
  const syncWord = iterator.getBits(12);
  if (syncWord !== 4095) {
    throw new Error("Invalid syncword: " + syncWord);
  }
  const id = iterator.getBits(1);
  if (id !== 0) {
    throw new Error("Only supporting MPEG-4 for .aac");
  }
  const layer = iterator.getBits(2);
  if (layer !== 0) {
    throw new Error("Only supporting layer 0 for .aac");
  }
  const protectionAbsent = iterator.getBits(1);
  const audioObjectType = iterator.getBits(2);
  const samplingFrequencyIndex = iterator.getBits(4);
  const sampleRate = getSampleRateFromSampleFrequencyIndex(samplingFrequencyIndex);
  iterator.getBits(1);
  const channelConfiguration = iterator.getBits(3);
  const codecPrivate2 = createAacCodecPrivate({
    audioObjectType,
    sampleRate,
    channelConfiguration,
    codecPrivate: null
  });
  iterator.getBits(1);
  iterator.getBits(1);
  iterator.getBits(1);
  iterator.getBits(1);
  const frameLength = iterator.getBits(13);
  iterator.getBits(11);
  iterator.getBits(2);
  if (!protectionAbsent) {
    iterator.getBits(16);
  }
  iterator.stopReadingBits();
  iterator.counter.decrement(iterator.counter.getOffset() - startOffset);
  const data = iterator.getSlice(frameLength);
  if (state.callbacks.tracks.getTracks().length === 0) {
    state.mediaSection.addMediaSection({
      start: startOffset,
      size: state.contentLength - startOffset
    });
    await registerAudioTrack({
      container: "aac",
      track: {
        codec: mapAudioObjectTypeToCodecString(audioObjectType),
        codecEnum: "aac",
        codecData: { type: "aac-config", data: codecPrivate2 },
        description: codecPrivate2,
        numberOfChannels: channelConfiguration,
        sampleRate,
        originalTimescale: WEBCODECS_TIMESCALE,
        trackId: 0,
        type: "audio",
        startInSeconds: 0,
        timescale: WEBCODECS_TIMESCALE,
        trackMediaTimeOffsetInTrackTimescale: 0
      },
      registerAudioSampleCallback: state.callbacks.registerAudioSampleCallback,
      tracks: state.callbacks.tracks,
      logLevel: state.logLevel,
      onAudioTrack: state.onAudioTrack
    });
    state.callbacks.tracks.setIsDone(state.logLevel);
  }
  const duration2 = 1024 / sampleRate;
  const { index } = state.aac.addSample({ offset: startOffset, size: frameLength });
  const timestamp = 1024 / sampleRate * index;
  state.aac.audioSamples.addSample({
    timeInSeconds: timestamp,
    offset: startOffset,
    durationInSeconds: duration2
  });
  const audioSample = convertAudioOrVideoSampleToWebCodecsTimestamps({
    sample: {
      duration: duration2,
      type: "key",
      data,
      offset: startOffset,
      decodingTimestamp: timestamp,
      timestamp
    },
    timescale: 1
  });
  await state.callbacks.onAudioSample({
    audioSample,
    trackId: 0
  });
  return Promise.resolve(null);
};
var getBlockSize = (iterator) => {
  const bits = iterator.getBits(4);
  if (bits === 0) {
    throw new Error("Reserved block size");
  }
  if (bits === 1) {
    return 192;
  }
  if (bits >= 2 && bits <= 5) {
    return 144 * 2 ** bits;
  }
  if (bits === 6) {
    return "uncommon-u8";
  }
  if (bits === 7) {
    return "uncommon-u16";
  }
  if (bits >= 8 && bits <= 15) {
    return 2 ** bits;
  }
  throw new Error("Invalid block size");
};
var getChannelCount = (iterator) => {
  const bits = iterator.getBits(4);
  if (bits === 0) {
    return 1;
  }
  if (bits === 1) {
    return 2;
  }
  if (bits === 2) {
    return 3;
  }
  if (bits === 3) {
    return 4;
  }
  if (bits === 4) {
    return 5;
  }
  if (bits === 5) {
    return 6;
  }
  if (bits === 6) {
    return 7;
  }
  if (bits === 7) {
    return 8;
  }
  if (bits === 8 || bits === 9 || bits === 10) {
    return 2;
  }
  throw new Error(`Invalid channel count: ${bits.toString(2)}`);
};
var getSampleRate4 = (iterator, state) => {
  const mode = iterator.getBits(4);
  if (mode === 0) {
    const structure = state.structure.getFlacStructure();
    const sampleRate = structure.boxes.find((box2) => box2.type === "flac-streaminfo")?.sampleRate ?? null;
    if (sampleRate === null) {
      throw new Error("Sample rate not found");
    }
    return sampleRate;
  }
  if (mode === 1) {
    return 88200;
  }
  if (mode === 2) {
    return 176400;
  }
  if (mode === 3) {
    return 192000;
  }
  if (mode === 4) {
    return 8000;
  }
  if (mode === 5) {
    return 16000;
  }
  if (mode === 6) {
    return 22050;
  }
  if (mode === 7) {
    return 24000;
  }
  if (mode === 8) {
    return 32000;
  }
  if (mode === 9) {
    return 44100;
  }
  if (mode === 10) {
    return 48000;
  }
  if (mode === 11) {
    return 96000;
  }
  if (mode === 12) {
    return "uncommon-u8";
  }
  if (mode === 13) {
    return "uncommon-u16";
  }
  if (mode === 14) {
    return "uncommon-u16-10";
  }
  throw new Error(`Invalid sample rate mode: ${mode.toString(2)}`);
};
function calculateCRC8(data) {
  const polynomial = 7;
  let crc = 0;
  for (const byte of data) {
    crc ^= byte;
    for (let i = 0;i < 8; i++) {
      if ((crc & 128) !== 0) {
        crc = crc << 1 ^ polynomial;
      } else {
        crc <<= 1;
      }
      crc &= 255;
    }
  }
  return crc;
}
var parseFrameHeader = ({
  iterator,
  state
}) => {
  if (iterator.bytesRemaining() < 10) {
    return null;
  }
  const startOffset = iterator.counter.getOffset();
  iterator.discard(2);
  iterator.startReadingBits();
  const blockSizeBits = getBlockSize(iterator);
  const sampleRateBits = getSampleRate4(iterator, state);
  getChannelCount(iterator);
  iterator.getBits(3);
  iterator.getBits(1);
  const num = iterator.getFlacCodecNumber();
  const blockSize = blockSizeBits === "uncommon-u16" ? iterator.getBits(16) + 1 : blockSizeBits === "uncommon-u8" ? iterator.getBits(8) + 1 : blockSizeBits;
  const sampleRate = sampleRateBits === "uncommon-u16" ? iterator.getBits(16) : sampleRateBits === "uncommon-u16-10" ? iterator.getBits(16) * 10 : sampleRateBits === "uncommon-u8" ? iterator.getBits(8) : sampleRateBits;
  iterator.stopReadingBits();
  const size4 = iterator.counter.getOffset() - startOffset;
  const crc = iterator.getUint8();
  iterator.counter.decrement(size4 + 1);
  const crcCalculated = calculateCRC8(iterator.getSlice(size4));
  iterator.counter.decrement(size4);
  if (crcCalculated !== crc) {
    return null;
  }
  return { num, blockSize, sampleRate };
};
var emitSample = async ({
  state,
  data,
  offset
}) => {
  const iterator = getArrayBufferIterator({
    initialData: data,
    maxBytes: data.length,
    logLevel: "error"
  });
  const parsed = parseFrameHeader({ iterator, state });
  if (!parsed) {
    throw new Error("Invalid CRC");
  }
  const { blockSize, num, sampleRate } = parsed;
  const duration2 = blockSize / sampleRate;
  const structure = state.structure.getFlacStructure();
  const streamInfo = structure.boxes.find((box2) => box2.type === "flac-streaminfo");
  if (!streamInfo) {
    throw new Error("Stream info not found");
  }
  if (streamInfo.minimumBlockSize !== streamInfo.maximumBlockSize) {
    throw new Error("Cannot determine timestamp");
  }
  const timestamp = num * streamInfo.maximumBlockSize / streamInfo.sampleRate;
  state.flac.audioSamples.addSample({
    timeInSeconds: timestamp,
    offset,
    durationInSeconds: duration2
  });
  const audioSample = convertAudioOrVideoSampleToWebCodecsTimestamps({
    sample: {
      data,
      duration: duration2,
      decodingTimestamp: timestamp,
      timestamp,
      type: "key",
      offset
    },
    timescale: 1
  });
  await state.callbacks.onAudioSample({
    audioSample,
    trackId: 0
  });
  iterator.destroy();
};
var parseFlacFrame = async ({
  state,
  iterator
}) => {
  const blockingBit = state.flac.getBlockingBitStrategy();
  const offset = iterator.counter.getOffset();
  const { returnToCheckpoint } = iterator.startCheckpoint();
  iterator.startReadingBits();
  if (blockingBit === undefined) {
    const bits = iterator.getBits(15);
    if (bits !== 32764) {
      throw new Error("Invalid sync code");
    }
    state.flac.setBlockingBitStrategy(iterator.getBits(1));
  } else if (blockingBit === 1) {
    const bits = iterator.getBits(16);
    if (bits !== 65529) {
      throw new Error("Blocking bit changed, it should not");
    }
  } else if (blockingBit === 0) {
    const bits = iterator.getBits(16);
    if (bits !== 65528) {
      throw new Error("Blocking bit changed, it should not");
    }
  }
  const setBlockingBit = state.flac.getBlockingBitStrategy();
  if (setBlockingBit === undefined) {
    throw new Error("Blocking bit should be set");
  }
  iterator.stopReadingBits();
  const structure = state.structure.getFlacStructure();
  const minimumFrameSize = structure.boxes.find((b) => b.type === "flac-streaminfo")?.minimumFrameSize ?? null;
  if (minimumFrameSize === null) {
    throw new Error("Expected flac-streaminfo");
  }
  if (minimumFrameSize !== 0) {
    iterator.getSlice(minimumFrameSize - 2);
  }
  while (true) {
    if (iterator.counter.getOffset() === state.contentLength) {
      const size4 = iterator.counter.getOffset() - offset;
      returnToCheckpoint();
      const slice = iterator.getSlice(size4);
      await emitSample({ state, data: slice, offset });
      break;
    }
    if (iterator.bytesRemaining() === 0) {
      returnToCheckpoint();
      break;
    }
    const nextByte = iterator.getUint8();
    if (nextByte === 255) {
      const nextBits = iterator.getUint8();
      const expected = setBlockingBit === 1 ? 249 : 248;
      if (nextBits !== expected) {
        iterator.counter.decrement(1);
        continue;
      }
      iterator.counter.decrement(2);
      const nextIsLegit = parseFrameHeader({ iterator, state });
      if (!nextIsLegit) {
        iterator.discard(1);
        continue;
      }
      const size4 = iterator.counter.getOffset() - offset;
      returnToCheckpoint();
      const data = iterator.getSlice(size4);
      await emitSample({ state, data, offset });
      break;
    }
  }
  return null;
};
var parseFlacHeader = ({
  state
}) => {
  state.structure.getFlacStructure().boxes.push({
    type: "flac-header"
  });
  return Promise.resolve(null);
};
var parseVorbisComment = ({
  state,
  iterator,
  size: size4
}) => {
  const { expectNoMoreBytes } = iterator.startBox(size4);
  const box2 = {
    type: "flac-vorbis-comment",
    fields: []
  };
  const vendorLength = iterator.getUint32Le();
  const vendorString = iterator.getByteString(vendorLength, true);
  const numberOfFields = iterator.getUint32Le();
  box2.fields.push({ key: "vendor", value: vendorString, trackId: null });
  for (let i = 0;i < numberOfFields; i++) {
    const fieldLength = iterator.getUint32Le();
    const field = iterator.getByteString(fieldLength, true);
    const [key4, value] = field.split("=");
    box2.fields.push({ key: key4.toLowerCase(), value, trackId: null });
  }
  state.structure.getFlacStructure().boxes.push(box2);
  expectNoMoreBytes();
  return Promise.resolve(null);
};
var parseStreamInfo = async ({
  iterator,
  state
}) => {
  const counter = iterator.counter.getOffset();
  const minimumBlockSize = iterator.getUint16();
  const maximumBlockSize = iterator.getUint16();
  const minimumFrameSize = iterator.getUint24();
  const maximumFrameSize = iterator.getUint24();
  iterator.startReadingBits();
  const sampleRate = iterator.getBits(20);
  const channels2 = iterator.getBits(3) + 1;
  const bitsPerSample = iterator.getBits(5);
  const totalSamples = iterator.getBits(36);
  iterator.getBits(128);
  iterator.stopReadingBits();
  const counterNow = iterator.counter.getOffset();
  const size4 = counterNow - counter;
  iterator.counter.decrement(size4);
  const asUint8Array = iterator.getSlice(size4);
  const flacStreamInfo = {
    type: "flac-streaminfo",
    bitsPerSample,
    channels: channels2,
    maximumBlockSize,
    maximumFrameSize,
    minimumBlockSize,
    minimumFrameSize,
    sampleRate,
    totalSamples
  };
  state.structure.getFlacStructure().boxes.push(flacStreamInfo);
  await registerAudioTrack({
    container: "flac",
    track: {
      codec: "flac",
      type: "audio",
      description: asUint8Array,
      codecData: { type: "flac-description", data: asUint8Array },
      codecEnum: "flac",
      numberOfChannels: channels2,
      sampleRate,
      originalTimescale: WEBCODECS_TIMESCALE,
      trackId: 0,
      startInSeconds: 0,
      timescale: WEBCODECS_TIMESCALE,
      trackMediaTimeOffsetInTrackTimescale: 0
    },
    registerAudioSampleCallback: state.callbacks.registerAudioSampleCallback,
    tracks: state.callbacks.tracks,
    logLevel: state.logLevel,
    onAudioTrack: state.onAudioTrack
  });
  state.callbacks.tracks.setIsDone(state.logLevel);
  return Promise.resolve(null);
};
var parseFlacUnkownBlock = ({
  iterator,
  state,
  size: size4
}) => {
  iterator.discard(size4);
  state.structure.getFlacStructure().boxes.push({
    type: "flac-header"
  });
  return Promise.resolve(null);
};
var flacTypes = {
  streaminfo: 0,
  vorbisComment: 4
};
var parseMetaBlock = ({
  iterator,
  state
}) => {
  iterator.startReadingBits();
  const isLastMetadata = iterator.getBits(1);
  const metaBlockType = iterator.getBits(7);
  iterator.stopReadingBits();
  const size4 = iterator.getUint24();
  if (isLastMetadata) {
    state.mediaSection.addMediaSection({
      start: iterator.counter.getOffset() + size4,
      size: state.contentLength - iterator.counter.getOffset() - size4
    });
  }
  if (metaBlockType === flacTypes.streaminfo) {
    return parseStreamInfo({ iterator, state });
  }
  if (metaBlockType === flacTypes.vorbisComment) {
    return parseVorbisComment({ iterator, state, size: size4 });
  }
  return parseFlacUnkownBlock({ iterator, state, size: size4 });
};
var parseFlac = ({
  iterator,
  state
}) => {
  const mediaSectionState2 = state.mediaSection.isCurrentByteInMediaSection(iterator);
  if (mediaSectionState2 === "in-section") {
    if (maySkipVideoData({ state })) {
      return Promise.resolve(makeSkip(state.contentLength));
    }
    return parseFlacFrame({ state, iterator });
  }
  const bytes = iterator.getByteString(4, true);
  if (bytes === "fLaC") {
    return parseFlacHeader({ state, iterator });
  }
  iterator.counter.decrement(4);
  return parseMetaBlock({
    iterator,
    state
  });
};
var calculateSamplePositions = ({
  state,
  mediaSectionStart,
  trackIds
}) => {
  const tracks2 = getTracks(state, true);
  const moofBoxes = getMoofBoxes(state.structure.getIsoStructure().boxes);
  const tfraBoxes = deduplicateTfraBoxesByOffset([
    ...state.iso.tfra.getTfraBoxes(),
    ...getTfraBoxes(state.structure.getIsoStructure().boxes)
  ]);
  const moofComplete = areSamplesComplete({ moofBoxes, tfraBoxes });
  const relevantMoofBox = moofBoxes.find((moofBox) => moofBox.offset + moofBox.size + 8 === mediaSectionStart);
  if (moofBoxes.length > 0 && !relevantMoofBox) {
    throw new Error("No relevant moof box found");
  }
  const moov = getMoovBoxFromState({
    structureState: state.structure,
    isoState: state.iso,
    mp4HeaderSegment: state.m3uPlaylistContext?.mp4HeaderSegment ?? null,
    mayUsePrecomputed: true
  });
  if (!moov) {
    throw new Error("No moov box found");
  }
  const trackIdAndSamplePositions = [];
  for (const track of tracks2) {
    const trakBox = getTrakBoxByTrackId(moov, track.trackId);
    if (!trackIds.includes(track.trackId)) {
      Log.verbose(state.logLevel, "Skipping calculating sample positions for track", track.trackId);
      continue;
    }
    if (!trakBox) {
      throw new Error("No trak box found");
    }
    const { samplePositions } = getSamplePositionsFromTrack({
      trakBox,
      moofBoxes: relevantMoofBox ? [relevantMoofBox] : [],
      moofComplete,
      trexBoxes: getTrexBoxes(moov)
    });
    trackIdAndSamplePositions.push({
      trackId: track.trackId,
      samplePositions
    });
  }
  return trackIdAndSamplePositions;
};
var updateSampleIndicesAfterSeek = ({
  samplePositionsForMdatStart,
  seekedByte
}) => {
  const currentSampleIndices = {};
  const keys = Object.keys(samplePositionsForMdatStart).map(Number).sort();
  const mdat = keys.find((key4) => seekedByte >= key4);
  if (!mdat) {
    return currentSampleIndices;
  }
  const samplePositions = samplePositionsForMdatStart[mdat];
  if (!samplePositions) {
    return currentSampleIndices;
  }
  for (const track of samplePositions) {
    const currentSampleIndex = track.samplePositions.findIndex((sample) => sample.offset >= seekedByte);
    if (!currentSampleIndices[mdat]) {
      currentSampleIndices[mdat] = {};
    }
    if (!currentSampleIndices[mdat][track.trackId]) {
      currentSampleIndices[mdat][track.trackId] = 0;
    }
    if (currentSampleIndex === -1) {
      currentSampleIndices[mdat][track.trackId] = track.samplePositions.length;
    } else {
      currentSampleIndices[mdat][track.trackId] = currentSampleIndex;
    }
  }
  return currentSampleIndices;
};
var cachedSamplePositionsState = () => {
  const samplePositionsForMdatStart = {};
  let currentSampleIndex = {};
  return {
    getSamples: (mdatStart) => {
      return samplePositionsForMdatStart[mdatStart] ?? null;
    },
    setSamples: (mdatStart, samples) => {
      samplePositionsForMdatStart[mdatStart] = samples;
    },
    setCurrentSampleIndex: (mdatStart, trackId, index) => {
      if (!currentSampleIndex[mdatStart]) {
        currentSampleIndex[mdatStart] = {};
      }
      if (!currentSampleIndex[mdatStart][trackId]) {
        currentSampleIndex[mdatStart][trackId] = 0;
      }
      currentSampleIndex[mdatStart][trackId] = index;
    },
    getCurrentSampleIndices: (mdatStart) => {
      return currentSampleIndex[mdatStart] ?? {};
    },
    updateAfterSeek: (seekedByte) => {
      currentSampleIndex = updateSampleIndicesAfterSeek({
        samplePositionsForMdatStart,
        seekedByte
      });
    }
  };
};
var getSampleWithLowestDts = (samplePositions, currentSampleIndexMap) => {
  const lowestDts = [];
  for (const track of samplePositions) {
    const currentSampleIndex = currentSampleIndexMap[track.trackId] ?? 0;
    const currentSample = track.samplePositions[currentSampleIndex];
    if (currentSample && (lowestDts.length === 0 || currentSample.decodingTimestamp <= lowestDts[0].samplePosition.decodingTimestamp)) {
      lowestDts.push({
        samplePosition: currentSample,
        trackId: track.trackId,
        index: currentSampleIndex
      });
    }
  }
  return lowestDts;
};
var getLastMoofBox = (boxes) => {
  if (boxes) {
    const tfras = boxes.filter((b) => b.type === "tfra-box");
    const lastMoofOffsets = tfras.map((f) => {
      if (f.entries.length <= 1) {
        return null;
      }
      return f.entries[f.entries.length - 1].moofOffset;
    });
    if (lastMoofOffsets.length > 0) {
      const maxOffset = Math.max(...lastMoofOffsets.filter(truthy));
      return maxOffset;
    }
    return null;
  }
};
var getMaxFirstMoofOffset = (boxes) => {
  const tfras = boxes.filter((b) => b.type === "tfra-box");
  const firstMoofOffsets = tfras.map((f) => {
    return f.entries[0].moofOffset;
  });
  return Math.max(...firstMoofOffsets.filter(truthy));
};
var needsTracksForField = ({
  field,
  structure
}) => {
  if (field === "dimensions") {
    if (structure?.type === "riff") {
      return false;
    }
    return true;
  }
  if (field === "audioCodec" || field === "durationInSeconds" || field === "slowDurationInSeconds" || field === "slowFps" || field === "fps" || field === "isHdr" || field === "rotation" || field === "slowStructure" || field === "tracks" || field === "unrotatedDimensions" || field === "videoCodec" || field === "metadata" || field === "location" || field === "slowKeyframes" || field === "slowNumberOfFrames" || field === "keyframes" || field === "images" || field === "sampleRate" || field === "numberOfAudioChannels" || field === "slowAudioBitrate" || field === "slowVideoBitrate" || field === "m3uStreams") {
    return true;
  }
  if (field === "container" || field === "internalStats" || field === "mimeType" || field === "name" || field === "size") {
    return false;
  }
  throw new Error(`field not implemeted ${field}`);
};
var makeCanSkipTracksState = ({
  hasAudioTrackHandlers,
  fields,
  hasVideoTrackHandlers,
  structure
}) => {
  const doFieldsNeedTracks = () => {
    const keys = Object.keys(fields ?? {});
    const selectedKeys = keys.filter((k) => fields[k]);
    return selectedKeys.some((k) => needsTracksForField({
      field: k,
      structure: structure.getStructureOrNull()
    }));
  };
  return {
    doFieldsNeedTracks,
    canSkipTracks: () => {
      if (hasAudioTrackHandlers || hasVideoTrackHandlers) {
        return false;
      }
      return !doFieldsNeedTracks();
    }
  };
};
var makeTracksSectionState = (canSkipTracksState, src) => {
  const tracks2 = [];
  let doneWithTracks = false;
  return {
    hasAllTracks: () => doneWithTracks,
    getIsDone: () => doneWithTracks,
    setIsDone: (logLevel) => {
      if (doneWithTracks) {
        throw new Error("Error in Media Parser: Tracks have already been parsed");
      }
      Log.verbose(logLevel, "All tracks have been parsed");
      doneWithTracks = true;
    },
    addTrack: (track) => {
      tracks2.push(track);
    },
    getTracks: () => {
      return tracks2;
    },
    ensureHasTracksAtEnd: (fields) => {
      if (canSkipTracksState.canSkipTracks()) {
        return;
      }
      if (!fields.tracks) {
        return;
      }
      if (!doneWithTracks) {
        throw new Error("Error in Media Parser: End of parsing of " + src + " has been reached, but no tracks have been found ");
      }
    }
  };
};
var structureState = () => {
  let structure = null;
  const getStructure = () => {
    if (structure === null) {
      throw new Error("Expected structure");
    }
    return structure;
  };
  return {
    getStructureOrNull: () => {
      return structure;
    },
    getStructure,
    setStructure: (value) => {
      structure = value;
    },
    getFlacStructure: () => {
      const struc = getStructure();
      if (struc.type !== "flac") {
        throw new Error("Invalid structure type");
      }
      return struc;
    },
    getIsoStructure: () => {
      const struc = getStructure();
      if (struc.type !== "iso-base-media") {
        throw new Error("Invalid structure type");
      }
      return struc;
    },
    getMp3Structure: () => {
      const struc = getStructure();
      if (struc.type !== "mp3") {
        throw new Error("Invalid structure type");
      }
      return struc;
    },
    getM3uStructure: () => {
      const struc = getStructure();
      if (struc.type !== "m3u") {
        throw new Error("Invalid structure type");
      }
      return struc;
    },
    getRiffStructure: () => {
      const struc = getStructure();
      if (struc.type !== "riff") {
        throw new Error("Invalid structure type");
      }
      return struc;
    },
    getTsStructure: () => {
      const struc = getStructure();
      if (struc.type !== "transport-stream") {
        throw new Error("Invalid structure type");
      }
      return struc;
    },
    getWavStructure: () => {
      const struc = getStructure();
      if (struc.type !== "wav") {
        throw new Error("Invalid structure type");
      }
      return struc;
    },
    getMatroskaStructure: () => {
      const struc = getStructure();
      if (struc.type !== "matroska") {
        throw new Error("Invalid structure type");
      }
      return struc;
    }
  };
};
var getMoovAtom = async ({
  endOfMdat,
  state
}) => {
  const headerSegment = state.m3uPlaylistContext?.mp4HeaderSegment;
  if (headerSegment) {
    const segment = getMoovFromFromIsoStructure(headerSegment);
    if (!segment) {
      throw new Error("No moov box found in header segment");
    }
    return segment;
  }
  const start = Date.now();
  Log.verbose(state.logLevel, "Starting second fetch to get moov atom");
  const { reader } = await state.readerInterface.read({
    src: state.src,
    range: endOfMdat,
    controller: state.controller,
    logLevel: state.logLevel,
    prefetchCache: state.prefetchCache
  });
  const onAudioTrack = state.onAudioTrack ? async ({ track, container: container42 }) => {
    await registerAudioTrack({
      track,
      container: container42,
      logLevel: state.logLevel,
      onAudioTrack: state.onAudioTrack,
      registerAudioSampleCallback: state.callbacks.registerAudioSampleCallback,
      tracks: state.callbacks.tracks
    });
    return null;
  } : null;
  const onVideoTrack = state.onVideoTrack ? async ({ track, container: container42 }) => {
    await registerVideoTrack({
      track,
      container: container42,
      logLevel: state.logLevel,
      onVideoTrack: state.onVideoTrack,
      registerVideoSampleCallback: state.callbacks.registerVideoSampleCallback,
      tracks: state.callbacks.tracks
    });
    return null;
  } : null;
  const iterator = getArrayBufferIterator({
    initialData: new Uint8Array([]),
    maxBytes: state.contentLength - endOfMdat,
    logLevel: "error"
  });
  while (true) {
    const result = await reader.reader.read();
    if (result.value) {
      iterator.addData(result.value);
    }
    if (result.done) {
      break;
    }
  }
  const boxes = [];
  const canSkipTracksState = makeCanSkipTracksState({
    hasAudioTrackHandlers: false,
    fields: { slowStructure: true },
    hasVideoTrackHandlers: false,
    structure: structureState()
  });
  const tracksState = makeTracksSectionState(canSkipTracksState, state.src);
  while (true) {
    const box2 = await processBox({
      iterator,
      logLevel: state.logLevel,
      onlyIfMoovAtomExpected: {
        tracks: tracksState,
        isoState: null,
        movieTimeScaleState: state.iso.movieTimeScale,
        onAudioTrack,
        onVideoTrack,
        registerVideoSampleCallback: () => Promise.resolve(),
        registerAudioSampleCallback: () => Promise.resolve()
      },
      onlyIfMdatAtomExpected: null,
      contentLength: state.contentLength - endOfMdat
    });
    if (box2.type === "box") {
      boxes.push(box2.box);
    }
    if (iterator.counter.getOffset() + endOfMdat > state.contentLength) {
      throw new Error("Read past end of file");
    }
    if (iterator.counter.getOffset() + endOfMdat === state.contentLength) {
      break;
    }
  }
  const moov = boxes.find((b) => b.type === "moov-box");
  if (!moov) {
    throw new Error("No moov box found");
  }
  Log.verbose(state.logLevel, `Finished fetching moov atom in ${Date.now() - start}ms`);
  return moov;
};
var postprocessBytes = ({
  bytes,
  bigEndian,
  chunkSize
}) => {
  if (!bigEndian) {
    return bytes;
  }
  if (chunkSize === null) {
    return bytes;
  }
  const newBuffer = new Uint8Array(bytes);
  for (let i = 0;i < newBuffer.length; i += chunkSize) {
    const slice = newBuffer.slice(i, i + chunkSize);
    slice.reverse();
    newBuffer.set(slice, i);
  }
  return newBuffer;
};
var parseMdatSection = async (state) => {
  const mediaSection = getCurrentMediaSection({
    offset: state.iterator.counter.getOffset(),
    mediaSections: state.mediaSection.getMediaSections()
  });
  if (!mediaSection) {
    throw new Error("No video section defined");
  }
  const endOfMdat = mediaSection.size + mediaSection.start;
  if (maySkipVideoData({ state })) {
    const mfra = state.iso.mfra.getIfAlreadyLoaded();
    if (mfra) {
      const lastMoof = getLastMoofBox(mfra);
      if (lastMoof && lastMoof > endOfMdat) {
        Log.verbose(state.logLevel, "Skipping to last moof", lastMoof);
        return makeSkip(lastMoof);
      }
    }
    return makeSkip(endOfMdat);
  }
  if (maySkipOverSamplesInTheMiddle({ state })) {
    const mfra = state.iso.mfra.getIfAlreadyLoaded();
    if (mfra) {
      const lastMoof = getLastMoofBox(mfra);
      const firstMax = getMaxFirstMoofOffset(mfra);
      const mediaSectionsBiggerThanMoof = state.mediaSection.getMediaSections().filter((m) => m.start > firstMax).length;
      if (mediaSectionsBiggerThanMoof > 1 && lastMoof && lastMoof > endOfMdat) {
        Log.verbose(state.logLevel, "Skipping to last moof because only first and last samples are needed");
        return makeSkip(lastMoof);
      }
    }
  }
  const alreadyHasMoov = getHasTracks(state, true);
  if (!alreadyHasMoov) {
    const moov = await getMoovAtom({
      endOfMdat,
      state
    });
    const tracksFromMoov = getTracksFromMoovBox(moov);
    state.iso.moov.setMoovBox({
      moovBox: moov,
      precomputed: false
    });
    const existingTracks = state.callbacks.tracks.getTracks();
    for (const trackFromMoov of tracksFromMoov) {
      if (existingTracks.find((t) => t.trackId === trackFromMoov.trackId)) {
        continue;
      }
      if (trackFromMoov.type === "other") {
        continue;
      }
      state.callbacks.tracks.addTrack(trackFromMoov);
    }
    state.callbacks.tracks.setIsDone(state.logLevel);
    state.structure.getIsoStructure().boxes.push(moov);
    return parseMdatSection(state);
  }
  const tracks2 = state.callbacks.tracks.getTracks();
  if (!state.iso.flatSamples.getSamples(mediaSection.start)) {
    const samplePosition = calculateSamplePositions({
      state,
      mediaSectionStart: mediaSection.start,
      trackIds: tracks2.map((t) => t.trackId)
    });
    state.iso.flatSamples.setSamples(mediaSection.start, samplePosition);
  }
  const samplePositions = state.iso.flatSamples.getSamples(mediaSection.start);
  const sampleIndices = state.iso.flatSamples.getCurrentSampleIndices(mediaSection.start);
  const nextSampleArray = getSampleWithLowestDts(samplePositions, sampleIndices);
  if (nextSampleArray.length === 0) {
    Log.verbose(state.logLevel, "Iterated over all samples.", endOfMdat);
    return makeSkip(endOfMdat);
  }
  const exactMatch = nextSampleArray.find((s) => s.samplePosition.offset === state.iterator.counter.getOffset());
  const nextSample = exactMatch ?? nextSampleArray[0];
  if (nextSample.samplePosition.offset !== state.iterator.counter.getOffset()) {
    return makeSkip(nextSample.samplePosition.offset);
  }
  if (nextSample.samplePosition.offset + nextSample.samplePosition.size > state.contentLength) {
    Log.verbose(state.logLevel, "Sample is beyond the end of the file. Don't process it.", nextSample.samplePosition.offset + nextSample.samplePosition.size, endOfMdat);
    return makeSkip(endOfMdat);
  }
  const { iterator } = state;
  if (iterator.bytesRemaining() < nextSample.samplePosition.size) {
    return makeFetchMoreData(nextSample.samplePosition.size - iterator.bytesRemaining());
  }
  const {
    timestamp: rawCts,
    decodingTimestamp: rawDts,
    duration: duration2,
    isKeyframe,
    offset,
    bigEndian,
    chunkSize
  } = nextSample.samplePosition;
  const track = tracks2.find((t) => t.trackId === nextSample.trackId);
  const {
    originalTimescale,
    startInSeconds,
    trackMediaTimeOffsetInTrackTimescale,
    timescale: trackTimescale
  } = track;
  const cts = rawCts + startInSeconds * originalTimescale - trackMediaTimeOffsetInTrackTimescale / trackTimescale * WEBCODECS_TIMESCALE;
  const dts = rawDts + startInSeconds * originalTimescale - trackMediaTimeOffsetInTrackTimescale / trackTimescale * WEBCODECS_TIMESCALE;
  const bytes = postprocessBytes({
    bytes: iterator.getSlice(nextSample.samplePosition.size),
    bigEndian,
    chunkSize
  });
  if (track.type === "audio") {
    const audioSample = convertAudioOrVideoSampleToWebCodecsTimestamps({
      sample: {
        data: bytes,
        timestamp: cts,
        duration: duration2,
        decodingTimestamp: dts,
        type: isKeyframe ? "key" : "delta",
        offset
      },
      timescale: originalTimescale
    });
    await state.callbacks.onAudioSample({
      audioSample,
      trackId: track.trackId
    });
  }
  if (track.type === "video") {
    const nalUnitType = bytes[4] & 31;
    let isRecoveryPoint = false;
    if (nalUnitType === 6) {
      const seiType = bytes[5];
      isRecoveryPoint = seiType === 6;
    }
    const videoSample = convertAudioOrVideoSampleToWebCodecsTimestamps({
      sample: {
        data: bytes,
        timestamp: cts,
        duration: duration2,
        decodingTimestamp: dts,
        type: isKeyframe && !isRecoveryPoint ? "key" : "delta",
        offset
      },
      timescale: originalTimescale
    });
    await state.callbacks.onVideoSample({
      videoSample,
      trackId: track.trackId
    });
  }
  state.iso.flatSamples.setCurrentSampleIndex(mediaSection.start, nextSample.trackId, nextSample.index + 1);
  return null;
};
var parseIsoBaseMedia = async (state) => {
  const mediaSectionState2 = state.mediaSection.isCurrentByteInMediaSection(state.iterator);
  if (mediaSectionState2 === "in-section") {
    const skipTo = await parseMdatSection(state);
    return skipTo;
  }
  const result = await processBox({
    iterator: state.iterator,
    logLevel: state.logLevel,
    onlyIfMoovAtomExpected: {
      tracks: state.callbacks.tracks,
      isoState: state.iso,
      movieTimeScaleState: state.iso.movieTimeScale,
      onAudioTrack: state.onAudioTrack,
      onVideoTrack: state.onVideoTrack,
      registerAudioSampleCallback: state.callbacks.registerAudioSampleCallback,
      registerVideoSampleCallback: state.callbacks.registerVideoSampleCallback
    },
    onlyIfMdatAtomExpected: {
      mediaSectionState: state.mediaSection
    },
    contentLength: state.contentLength
  });
  if (result.type === "fetch-more-data") {
    return result.bytesNeeded;
  }
  if (result.type === "box") {
    state.structure.getIsoStructure().boxes.push(result.box);
  }
  return null;
};
function splitRespectingQuotes(input2) {
  const result = [];
  let currentPart = "";
  let insideQuote = false;
  for (let i = 0;i < input2.length; i++) {
    const char = input2[i];
    if (char === '"') {
      insideQuote = !insideQuote;
      currentPart += char;
    } else if (char === "," && !insideQuote) {
      result.push(currentPart);
      currentPart = "";
    } else {
      currentPart += char;
    }
  }
  if (currentPart) {
    result.push(currentPart);
  }
  return result;
}
var parseStreamInf = (str) => {
  const quotes = splitRespectingQuotes(str);
  const map = {};
  for (const quote of quotes) {
    const firstColon = quote.indexOf("=");
    const key4 = firstColon === -1 ? quote : quote.slice(0, firstColon);
    const value = firstColon === -1 ? null : quote.slice(firstColon + 1);
    if (value === null) {
      throw new Error("Value is null");
    }
    const actualValue = value?.startsWith('"') && value?.endsWith('"') ? value.slice(1, -1) : value;
    map[key4] = actualValue;
  }
  return {
    type: "m3u-stream-info",
    averageBandwidthInBitsPerSec: map["AVERAGE-BANDWIDTH"] ? parseInt(map["AVERAGE-BANDWIDTH"], 10) : null,
    bandwidthInBitsPerSec: map.BANDWIDTH ? parseInt(map.BANDWIDTH, 10) : null,
    codecs: map.CODECS ? map.CODECS.split(",") : null,
    dimensions: map.RESOLUTION ? {
      width: parseInt(map.RESOLUTION.split("x")[0], 10),
      height: parseInt(map.RESOLUTION.split("x")[1], 10)
    } : null,
    audio: map.AUDIO || null
  };
};
var parseM3uKeyValue = (str) => {
  const quotes = splitRespectingQuotes(str);
  const map = {};
  for (const quote of quotes) {
    const firstColon = quote.indexOf("=");
    const key4 = firstColon === -1 ? quote : quote.slice(0, firstColon);
    const value = firstColon === -1 ? null : quote.slice(firstColon + 1);
    if (value === null) {
      throw new Error("Value is null");
    }
    const actualValue = value?.startsWith('"') && value?.endsWith('"') ? value.slice(1, -1) : value;
    map[key4] = actualValue;
  }
  return map;
};
var parseM3uMediaDirective = (str) => {
  const map = parseM3uKeyValue(str);
  return {
    type: "m3u-media-info",
    autoselect: map.AUTOSELECT === "YES",
    channels: map.CHANNELS ? parseInt(map.CHANNELS, 10) : null,
    default: map.DEFAULT === "YES",
    groupId: map["GROUP-ID"],
    language: map.LANGUAGE || null,
    name: map.NAME || null,
    uri: map.URI,
    mediaType: map.TYPE || null
  };
};
var parseM3uDirective = (str) => {
  const firstColon = str.indexOf(":");
  const directive = (firstColon === -1 ? str : str.slice(0, firstColon)).trim();
  const value = firstColon === -1 ? null : str.slice(firstColon + 1);
  if (directive === "#EXT-X-VERSION") {
    if (!value) {
      throw new Error("EXT-X-VERSION directive must have a value");
    }
    return {
      type: "m3u-version",
      version: value
    };
  }
  if (directive === "#EXT-X-INDEPENDENT-SEGMENTS") {
    return {
      type: "m3u-independent-segments"
    };
  }
  if (directive === "#EXT-X-MEDIA") {
    if (!value) {
      throw new Error("EXT-X-MEDIA directive must have a value");
    }
    const parsed = parseM3uMediaDirective(value);
    return parsed;
  }
  if (directive === "#EXT-X-TARGETDURATION") {
    if (!value) {
      throw new Error("EXT-X-TARGETDURATION directive must have a value");
    }
    return {
      type: "m3u-target-duration",
      duration: parseFloat(value)
    };
  }
  if (directive === "#EXTINF") {
    if (!value) {
      throw new Error("EXTINF has no value");
    }
    return {
      type: "m3u-extinf",
      value: parseFloat(value)
    };
  }
  if (directive === "#EXT-X-ENDLIST") {
    return {
      type: "m3u-endlist"
    };
  }
  if (directive === "#EXT-X-PLAYLIST-TYPE") {
    if (!value) {
      throw new Error("#EXT-X-PLAYLIST-TYPE. directive must have a value");
    }
    return {
      type: "m3u-playlist-type",
      playlistType: value
    };
  }
  if (directive === "#EXT-X-MEDIA-SEQUENCE") {
    if (!value) {
      throw new Error("#EXT-X-MEDIA-SEQUENCE directive must have a value");
    }
    return {
      type: "m3u-media-sequence",
      value: Number(value)
    };
  }
  if (directive === "#EXT-X-DISCONTINUITY-SEQUENCE") {
    if (!value) {
      throw new Error("#EXT-X-DISCONTINUITY-SEQUENCE directive must have a value");
    }
    return {
      type: "m3u-discontinuity-sequence",
      value: Number(value)
    };
  }
  if (directive === "#EXT-X-STREAM-INF") {
    if (!value) {
      throw new Error("EXT-X-STREAM-INF directive must have a value");
    }
    const res = parseStreamInf(value);
    return res;
  }
  if (directive === "#EXT-X-I-FRAME-STREAM-INF") {
    return {
      type: "m3u-i-frame-stream-info"
    };
  }
  if (directive === "#EXT-X-ALLOW-CACHE") {
    if (!value) {
      throw new Error("#EXT-X-ALLOW-CACHE directive must have a value");
    }
    return {
      type: "m3u-allow-cache",
      allowsCache: value === "YES"
    };
  }
  if (directive === "#EXT-X-MAP") {
    if (!value) {
      throw new Error("#EXT-X-MAP directive must have a value");
    }
    const p = parseM3uKeyValue(value);
    if (!p.URI) {
      throw new Error("EXT-X-MAP directive must have a URI");
    }
    return {
      type: "m3u-map",
      value: p.URI
    };
  }
  throw new Error(`Unknown directive ${directive}. Value: ${value}`);
};
var parseM3u8Text = (line4, boxes) => {
  if (line4 === "#EXTM3U") {
    boxes.push({
      type: "m3u-header"
    });
    return;
  }
  if (line4.startsWith("#")) {
    boxes.push(parseM3uDirective(line4));
    return;
  }
  if (line4.trim()) {
    boxes.push({
      type: "m3u-text-value",
      value: line4
    });
  }
};
var fetchM3u8Stream = async ({
  url,
  readerInterface
}) => {
  const text2 = await readerInterface.readWholeAsText(url);
  const lines2 = text2.split(`
`);
  const boxes = [];
  for (const line4 of lines2) {
    parseM3u8Text(line4.trim(), boxes);
  }
  return boxes;
};
var selectAssociatedPlaylists = async ({
  playlists,
  fn,
  skipAudioTracks
}) => {
  if (playlists.length < 1) {
    return Promise.resolve([]);
  }
  const streams = await fn({ associatedPlaylists: playlists });
  if (!Array.isArray(streams)) {
    throw new Error("Expected an array of associated playlists");
  }
  const selectedStreams = [];
  for (const stream of streams) {
    if (stream.isAudio && skipAudioTracks) {
      continue;
    }
    if (!playlists.find((playlist) => playlist.src === stream.src)) {
      throw new Error(`The associated playlist ${JSON.stringify(streams)} cannot be selected because it was not in the list of selectable playlists`);
    }
    selectedStreams.push(stream);
  }
  return selectedStreams;
};
var defaultSelectM3uAssociatedPlaylists = ({ associatedPlaylists }) => {
  if (associatedPlaylists.length === 1) {
    return associatedPlaylists;
  }
  return associatedPlaylists.filter((playlist) => playlist.default);
};
var selectStream = async ({
  streams,
  fn
}) => {
  if (streams.length < 1) {
    throw new Error("No streams found");
  }
  const selectedStreamId = await fn({ streams });
  const selectedStream = streams.find((stream) => stream.id === selectedStreamId);
  if (!selectedStream) {
    throw new Error(`No stream with the id ${selectedStreamId} found`);
  }
  return Promise.resolve(selectedStream);
};
var defaultSelectM3uStreamFn = ({ streams }) => {
  return Promise.resolve(streams[0].id);
};
var afterManifestFetch = async ({
  structure,
  m3uState,
  src,
  selectM3uStreamFn,
  logLevel,
  selectAssociatedPlaylistsFn,
  readerInterface,
  onAudioTrack,
  canSkipTracks
}) => {
  const independentSegments = isIndependentSegments(structure);
  if (!independentSegments) {
    if (!src) {
      throw new Error("No src");
    }
    m3uState.setSelectedMainPlaylist({
      type: "initial-url",
      url: src
    });
    return m3uState.setReadyToIterateOverM3u();
  }
  const streams = getM3uStreams({ structure, originalSrc: src, readerInterface });
  if (streams === null) {
    throw new Error("No streams found");
  }
  const selectedPlaylist = await selectStream({ streams, fn: selectM3uStreamFn });
  if (!selectedPlaylist.dimensions) {
    throw new Error("Stream does not have a resolution");
  }
  m3uState.setSelectedMainPlaylist({
    type: "selected-stream",
    stream: selectedPlaylist
  });
  const skipAudioTracks = onAudioTrack === null && canSkipTracks.doFieldsNeedTracks() === false;
  const associatedPlaylists = await selectAssociatedPlaylists({
    playlists: selectedPlaylist.associatedPlaylists,
    fn: selectAssociatedPlaylistsFn,
    skipAudioTracks
  });
  m3uState.setAssociatedPlaylists(associatedPlaylists);
  const playlistUrls = [
    selectedPlaylist.src,
    ...associatedPlaylists.map((p) => p.src)
  ];
  const struc = await Promise.all(playlistUrls.map(async (url) => {
    Log.verbose(logLevel, `Fetching playlist ${url}`);
    const boxes = await fetchM3u8Stream({ url, readerInterface });
    return {
      type: "m3u-playlist",
      boxes,
      src: url
    };
  }));
  structure.boxes.push(...struc);
  m3uState.setReadyToIterateOverM3u();
};
var parseM3uManifest = ({
  iterator,
  structure,
  contentLength
}) => {
  const start = iterator.startCheckpoint();
  const line4 = iterator.readUntilLineEnd();
  if (iterator.counter.getOffset() > contentLength) {
    throw new Error("Unexpected end of file");
  }
  if (line4 === null) {
    start.returnToCheckpoint();
    return Promise.resolve(null);
  }
  parseM3u8Text(line4.trim(), structure.boxes);
  return Promise.resolve(null);
};
var forwardMediaParserControllerPauseResume = ({
  parentController,
  childController
}) => {
  const onAbort = ({ detail }) => {
    childController.abort(detail.reason);
  };
  const onResume = () => {
    childController.resume();
  };
  const onPause = () => {
    childController.pause();
  };
  parentController.addEventListener("abort", onAbort);
  parentController.addEventListener("resume", onResume);
  parentController.addEventListener("pause", onPause);
  return {
    cleanup: () => {
      parentController.removeEventListener("abort", onAbort);
      parentController.removeEventListener("resume", onResume);
      parentController.removeEventListener("pause", onPause);
    }
  };
};
var getLengthAndReader = async ({
  canLiveWithoutContentLength,
  res,
  ownController,
  requestedWithoutRange
}) => {
  const length = res.headers.get("content-length");
  const contentLength = length === null ? null : parseInt(length, 10);
  if (requestedWithoutRange || canLiveWithoutContentLength && contentLength === null) {
    const buffer = await res.arrayBuffer();
    const encoded = new Uint8Array(buffer);
    let streamCancelled = false;
    const stream = new ReadableStream({
      start(controller) {
        if (ownController.signal.aborted) {
          return;
        }
        if (streamCancelled) {
          return;
        }
        try {
          controller.enqueue(encoded);
          controller.close();
        } catch {}
      },
      cancel() {
        streamCancelled = true;
      }
    });
    return {
      contentLength: encoded.byteLength,
      reader: {
        reader: stream.getReader(),
        abort: () => {
          ownController.abort();
          return Promise.resolve();
        }
      },
      needsContentRange: false
    };
  }
  if (!res.body) {
    throw new Error("No body");
  }
  const reader = res.body.getReader();
  return {
    reader: {
      reader,
      abort: () => {
        ownController.abort();
        return Promise.resolve();
      }
    },
    contentLength,
    needsContentRange: true
  };
};
var resolveUrl = (src) => {
  try {
    const resolvedUrl = typeof window !== "undefined" && typeof window.location !== "undefined" ? new URL(src, window.location.origin) : new URL(src);
    return resolvedUrl;
  } catch {
    return src;
  }
};
function parseContentRange(input2) {
  const matches = input2.match(/^(\w+) ((\d+)-(\d+)|\*)\/(\d+|\*)$/);
  if (!matches)
    return null;
  const [, unit, , start, end, size4] = matches;
  const range2 = {
    unit,
    start: start != null ? Number(start) : null,
    end: end != null ? Number(end) : null,
    size: size4 === "*" ? null : Number(size4)
  };
  if (range2.start === null && range2.end === null && range2.size === null) {
    return null;
  }
  return range2;
}
var validateContentRangeAndDetectIfSupported = ({
  requestedRange,
  parsedContentRange,
  statusCode
}) => {
  if (statusCode === 206) {
    return { supportsContentRange: true };
  }
  if (typeof requestedRange === "number" && parsedContentRange?.start !== requestedRange) {
    if (requestedRange === 0) {
      return { supportsContentRange: false };
    }
    throw new Error(`Range header (${requestedRange}) does not match content-range header (${parsedContentRange?.start})`);
  }
  if (requestedRange !== null && typeof requestedRange !== "number" && (parsedContentRange?.start !== requestedRange[0] || parsedContentRange?.end !== requestedRange[1])) {
    throw new Error(`Range header (${requestedRange}) does not match content-range header (${parsedContentRange?.start})`);
  }
  return { supportsContentRange: true };
};
var makeFetchRequest = async ({
  range: range2,
  src,
  controller
}) => {
  const resolvedUrl = resolveUrl(src);
  const resolvedUrlString = resolvedUrl.toString();
  if (!resolvedUrlString.startsWith("https://") && !resolvedUrlString.startsWith("blob:") && !resolvedUrlString.startsWith("http://")) {
    return Promise.reject(new Error(`${resolvedUrlString} is not a URL - needs to start with http:// or https:// or blob:. If you want to read a local file, pass \`reader: nodeReader\` to parseMedia().`));
  }
  const ownController = new AbortController;
  const cache = typeof navigator !== "undefined" && navigator.userAgent.includes("Cloudflare-Workers") ? undefined : "no-store";
  const requestedRange = range2 === null ? 0 : range2;
  const asString = typeof resolvedUrl === "string" ? resolvedUrl : resolvedUrl.pathname;
  const requestWithoutRange = asString.endsWith(".m3u8");
  const canLiveWithoutContentLength = asString.endsWith(".m3u8") || asString.endsWith(".ts");
  const headers = requestedRange === 0 && requestWithoutRange ? {} : typeof requestedRange === "number" ? {
    Range: `bytes=${requestedRange}-`
  } : {
    Range: `bytes=${`${requestedRange[0]}-${requestedRange[1]}`}`
  };
  const res = await fetch(resolvedUrl, {
    headers,
    signal: ownController.signal,
    cache
  });
  const contentRange = res.headers.get("content-range");
  const parsedContentRange = contentRange ? parseContentRange(contentRange) : null;
  if (!res.ok) {
    throw new Error(`Server returned status code ${res.status} for ${resolvedUrl} and range ${requestedRange}`);
  }
  const { supportsContentRange } = validateContentRangeAndDetectIfSupported({
    requestedRange,
    parsedContentRange,
    statusCode: res.status
  });
  if (controller) {
    controller._internals.signal.addEventListener("abort", () => {
      ownController.abort(new MediaParserAbortError("Aborted by user"));
    }, { once: true });
  }
  const contentDisposition = res.headers.get("content-disposition");
  const name = contentDisposition?.match(/filename="([^"]+)"/)?.[1];
  const { contentLength, needsContentRange, reader } = await getLengthAndReader({
    canLiveWithoutContentLength,
    res,
    ownController,
    requestedWithoutRange: requestWithoutRange
  });
  const contentType = res.headers.get("content-type");
  return {
    contentLength,
    needsContentRange,
    reader,
    name,
    contentType,
    supportsContentRange
  };
};
var cacheKey = ({
  src,
  range: range2
}) => {
  return `${src}-${JSON.stringify(range2)}`;
};
var makeFetchRequestOrGetCached = ({
  range: range2,
  src,
  controller,
  logLevel,
  prefetchCache
}) => {
  const key4 = cacheKey({ src, range: range2 });
  const cached = prefetchCache.get(key4);
  if (cached) {
    Log.verbose(logLevel, `Reading from preload cache for ${key4}`);
    return cached;
  }
  Log.verbose(logLevel, `Fetching ${key4}`);
  const result = makeFetchRequest({ range: range2, src, controller });
  prefetchCache.set(key4, result);
  return result;
};
var fetchReadContent = async ({
  src,
  range: range2,
  controller,
  logLevel,
  prefetchCache
}) => {
  if (typeof src !== "string" && src instanceof URL === false) {
    throw new Error("src must be a string when using `fetchReader`");
  }
  const fallbackName = src.toString().split("/").pop();
  const res = makeFetchRequestOrGetCached({
    range: range2,
    src,
    controller,
    logLevel,
    prefetchCache
  });
  const key4 = cacheKey({ src, range: range2 });
  prefetchCache.delete(key4);
  const {
    reader,
    contentLength,
    needsContentRange,
    name,
    supportsContentRange,
    contentType
  } = await res;
  if (controller) {
    controller._internals.signal.addEventListener("abort", () => {
      reader.reader.cancel().catch(() => {});
    }, { once: true });
  }
  return {
    reader,
    contentLength,
    contentType,
    name: name ?? fallbackName,
    supportsContentRange,
    needsContentRange
  };
};
var fetchPreload = ({
  src,
  range: range2,
  logLevel,
  prefetchCache
}) => {
  if (typeof src !== "string" && src instanceof URL === false) {
    throw new Error("src must be a string when using `fetchReader`");
  }
  const key4 = cacheKey({ src, range: range2 });
  if (prefetchCache.has(key4)) {
    return prefetchCache.get(key4);
  }
  makeFetchRequestOrGetCached({
    range: range2,
    src,
    controller: null,
    logLevel,
    prefetchCache
  });
};
var fetchReadWholeAsText = async (src) => {
  if (typeof src !== "string" && src instanceof URL === false) {
    throw new Error("src must be a string when using `fetchReader`");
  }
  const res = await fetch(src);
  if (!res.ok) {
    throw new Error(`Failed to fetch ${src} (HTTP code: ${res.status})`);
  }
  return res.text();
};
var fetchCreateAdjacentFileSource = (relativePath, src) => {
  if (typeof src !== "string" && src instanceof URL === false) {
    throw new Error("src must be a string or URL when using `fetchReader`");
  }
  return new URL(relativePath, src).toString();
};
var webFileReadContent = ({ src, range: range2, controller }) => {
  if (typeof src === "string" || src instanceof URL) {
    throw new Error("`inputTypeFileReader` only supports `File` objects");
  }
  const part = range2 === null ? src : typeof range2 === "number" ? src.slice(range2) : src.slice(range2[0], range2[1] + 1);
  const stream = part.stream();
  const streamReader = stream.getReader();
  if (controller) {
    controller._internals.signal.addEventListener("abort", () => {
      streamReader.cancel();
    }, { once: true });
  }
  return Promise.resolve({
    reader: {
      reader: streamReader,
      async abort() {
        try {
          await streamReader.cancel();
        } catch {}
        return Promise.resolve();
      }
    },
    contentLength: src.size,
    name: src instanceof File ? src.name : src.toString(),
    supportsContentRange: true,
    contentType: src.type,
    needsContentRange: true
  });
};
var webFileReadWholeAsText = () => {
  throw new Error("`webFileReader` cannot read auxiliary files.");
};
var webFileCreateAdjacentFileSource = () => {
  throw new Error("`webFileReader` cannot create adjacent file sources.");
};
var webReader = {
  read: (params) => {
    if (params.src instanceof Blob) {
      return webFileReadContent(params);
    }
    return fetchReadContent(params);
  },
  createAdjacentFileSource: (relativePath, src) => {
    if (src instanceof Blob) {
      return webFileCreateAdjacentFileSource(relativePath, src);
    }
    return fetchCreateAdjacentFileSource(relativePath, src);
  },
  readWholeAsText: (src) => {
    if (src instanceof Blob) {
      return webFileReadWholeAsText(src);
    }
    return fetchReadWholeAsText(src);
  },
  preload: ({ range: range2, src, logLevel, prefetchCache }) => {
    if (src instanceof Blob) {
      return;
    }
    return fetchPreload({ range: range2, src, logLevel, prefetchCache });
  }
};
var parseMedia = (options) => {
  if (!options) {
    return Promise.reject(new Error("No options provided. See https://www.remotion.dev/media-parser for how to get started."));
  }
  return internalParseMedia({
    fields: options.fields ?? null,
    logLevel: options.logLevel ?? "info",
    onAudioCodec: options.onAudioCodec ?? null,
    onAudioTrack: options.onAudioTrack ?? null,
    onContainer: options.onContainer ?? null,
    onDimensions: options.onDimensions ?? null,
    onDurationInSeconds: options.onDurationInSeconds ?? null,
    onFps: options.onFps ?? null,
    onImages: options.onImages ?? null,
    onInternalStats: options.onInternalStats ?? null,
    onIsHdr: options.onIsHdr ?? null,
    onKeyframes: options.onKeyframes ?? null,
    onLocation: options.onLocation ?? null,
    onMetadata: options.onMetadata ?? null,
    onMimeType: options.onMimeType ?? null,
    onName: options.onName ?? null,
    onNumberOfAudioChannels: options.onNumberOfAudioChannels ?? null,
    onParseProgress: options.onParseProgress ?? null,
    onRotation: options.onRotation ?? null,
    onSampleRate: options.onSampleRate ?? null,
    onSize: options.onSize ?? null,
    onSlowAudioBitrate: options.onSlowAudioBitrate ?? null,
    onSlowDurationInSeconds: options.onSlowDurationInSeconds ?? null,
    onSlowFps: options.onSlowFps ?? null,
    onSlowKeyframes: options.onSlowKeyframes ?? null,
    onSlowNumberOfFrames: options.onSlowNumberOfFrames ?? null,
    onSlowVideoBitrate: options.onSlowVideoBitrate ?? null,
    onSlowStructure: options.onSlowStructure ?? null,
    onM3uStreams: options.onM3uStreams ?? null,
    onTracks: options.onTracks ?? null,
    onUnrotatedDimensions: options.onUnrotatedDimensions ?? null,
    onVideoCodec: options.onVideoCodec ?? null,
    onVideoTrack: options.onVideoTrack ?? null,
    progressIntervalInMs: options.progressIntervalInMs ?? null,
    reader: options.reader ?? webReader,
    controller: options.controller ?? undefined,
    selectM3uStream: options.selectM3uStream ?? defaultSelectM3uStreamFn,
    selectM3uAssociatedPlaylists: options.selectM3uAssociatedPlaylists ?? defaultSelectM3uAssociatedPlaylists,
    m3uPlaylistContext: options.m3uPlaylistContext ?? null,
    src: options.src,
    mode: "query",
    onDiscardedData: null,
    onError: () => ({ action: "fail" }),
    acknowledgeRemotionLicense: Boolean(options.acknowledgeRemotionLicense),
    apiName: "parseMedia()",
    makeSamplesStartAtZero: options.makeSamplesStartAtZero ?? true,
    seekingHints: options.seekingHints ?? null
  });
};
var considerSeekBasedOnChunk = async ({
  sample,
  parentController,
  childController,
  callback,
  m3uState,
  playlistUrl,
  subtractChunks,
  chunkIndex
}) => {
  const pendingSeek = m3uState.getSeekToSecondsToProcess(playlistUrl);
  if (pendingSeek === null) {
    await callback(sample);
    return;
  }
  const timestamp = Math.min(sample.decodingTimestamp / WEBCODECS_TIMESCALE, sample.timestamp / WEBCODECS_TIMESCALE);
  if (timestamp > pendingSeek.targetTime && chunkIndex !== null && chunkIndex > 0) {
    m3uState.setNextSeekShouldSubtractChunks(playlistUrl, subtractChunks + 1);
    parentController.seek(pendingSeek.targetTime);
    return;
  }
  childController.seek(pendingSeek.targetTime);
  m3uState.setNextSeekShouldSubtractChunks(playlistUrl, 0);
  m3uState.setSeekToSecondsToProcess(playlistUrl, null);
};
var getChunks = (playlist) => {
  const chunks = [];
  for (let i = 0;i < playlist.boxes.length; i++) {
    const box2 = playlist.boxes[i];
    if (box2.type === "m3u-map") {
      chunks.push({ duration: 0, url: box2.value, isHeader: true });
      continue;
    }
    if (box2.type === "m3u-extinf") {
      const nextBox = playlist.boxes[i + 1];
      i++;
      if (nextBox.type !== "m3u-text-value") {
        throw new Error("Expected m3u-text-value");
      }
      chunks.push({ duration: box2.value, url: nextBox.value, isHeader: false });
    }
    continue;
  }
  return chunks;
};
var getChunkToSeekTo = ({
  chunks,
  seekToSecondsToProcess
}) => {
  let duration2 = 0;
  for (let i = 0;i < chunks.length; i++) {
    if (duration2 >= seekToSecondsToProcess) {
      return Math.max(0, i - 1);
    }
    duration2 += chunks[i].duration;
  }
  return Math.max(0, chunks.length - 1);
};
var processM3uChunk = ({
  playlistUrl,
  state,
  structure,
  audioDone,
  videoDone
}) => {
  const { promise, reject, resolve } = withResolvers();
  const onGlobalAudioTrack = audioDone ? null : async (track) => {
    const existingTracks = state.callbacks.tracks.getTracks();
    let { trackId } = track;
    while (existingTracks.find((t) => t.trackId === trackId)) {
      trackId++;
    }
    const onAudioSample = await registerAudioTrack({
      container: "m3u8",
      track: {
        ...track,
        trackId
      },
      registerAudioSampleCallback: state.callbacks.registerAudioSampleCallback,
      tracks: state.callbacks.tracks,
      logLevel: state.logLevel,
      onAudioTrack: state.onAudioTrack
    });
    state.m3u.sampleSorter.addToStreamWithTrack(playlistUrl);
    if (onAudioSample === null) {
      return null;
    }
    state.m3u.sampleSorter.addAudioStreamToConsider(playlistUrl, onAudioSample);
    return async (sample) => {
      await state.m3u.sampleSorter.addAudioSample(playlistUrl, sample);
    };
  };
  const onGlobalVideoTrack = videoDone ? null : async (track) => {
    const existingTracks = state.callbacks.tracks.getTracks();
    let { trackId } = track;
    while (existingTracks.find((t) => t.trackId === trackId)) {
      trackId++;
    }
    const onVideoSample = await registerVideoTrack({
      container: "m3u8",
      track: {
        ...track,
        trackId
      },
      logLevel: state.logLevel,
      onVideoTrack: state.onVideoTrack,
      registerVideoSampleCallback: state.callbacks.registerVideoSampleCallback,
      tracks: state.callbacks.tracks
    });
    state.m3u.sampleSorter.addToStreamWithTrack(playlistUrl);
    if (onVideoSample === null) {
      return null;
    }
    state.m3u.sampleSorter.addVideoStreamToConsider(playlistUrl, onVideoSample);
    return async (sample) => {
      await state.m3u.sampleSorter.addVideoSample(playlistUrl, sample);
    };
  };
  const pausableIterator = async () => {
    const playlist = getPlaylist(structure, playlistUrl);
    const chunks = getChunks(playlist);
    const seekToSecondsToProcess = state.m3u.getSeekToSecondsToProcess(playlistUrl);
    const chunksToSubtract = state.m3u.getNextSeekShouldSubtractChunks(playlistUrl);
    let chunkIndex = null;
    if (seekToSecondsToProcess !== null) {
      chunkIndex = Math.max(0, getChunkToSeekTo({
        chunks,
        seekToSecondsToProcess: seekToSecondsToProcess.targetTime
      }) - chunksToSubtract);
    }
    const currentPromise = {
      resolver: () => {
        return;
      },
      rejector: reject
    };
    const requiresHeaderToBeFetched = chunks[0].isHeader;
    for (const chunk of chunks) {
      const mp4HeaderSegment = state.m3u.getMp4HeaderSegment(playlistUrl);
      if (requiresHeaderToBeFetched && mp4HeaderSegment && chunk.isHeader) {
        continue;
      }
      if (chunkIndex !== null && chunks.indexOf(chunk) < chunkIndex && !chunk.isHeader) {
        continue;
      }
      currentPromise.resolver = (newRun) => {
        state.m3u.setM3uStreamRun(playlistUrl, newRun);
        resolve();
      };
      currentPromise.rejector = reject;
      const childController = mediaParserController();
      const forwarded = forwardMediaParserControllerPauseResume({
        childController,
        parentController: state.controller
      });
      const nextChunk = chunks[chunks.indexOf(chunk) + 1];
      if (nextChunk) {
        const nextChunkSource = state.readerInterface.createAdjacentFileSource(nextChunk.url, playlistUrl);
        state.readerInterface.preload({
          logLevel: state.logLevel,
          range: null,
          src: nextChunkSource,
          prefetchCache: state.prefetchCache
        });
      }
      const makeContinuationFn = () => {
        return {
          continue() {
            const resolver = withResolvers();
            currentPromise.resolver = resolver.resolve;
            currentPromise.rejector = resolver.reject;
            childController.resume();
            return resolver.promise;
          },
          abort() {
            childController.abort();
          }
        };
      };
      const isLastChunk = chunk === chunks[chunks.length - 1];
      await childController._internals.checkForAbortAndPause();
      const src = state.readerInterface.createAdjacentFileSource(chunk.url, playlistUrl);
      try {
        const data = await parseMedia({
          src,
          acknowledgeRemotionLicense: true,
          logLevel: state.logLevel,
          controller: childController,
          progressIntervalInMs: 0,
          onParseProgress: () => {
            childController.pause();
            currentPromise.resolver(makeContinuationFn());
          },
          fields: chunk.isHeader ? { slowStructure: true } : undefined,
          onTracks: () => {
            if (!state.m3u.hasEmittedDoneWithTracks(playlistUrl)) {
              state.m3u.setHasEmittedDoneWithTracks(playlistUrl);
              const allDone = state.m3u.setTracksDone(playlistUrl);
              if (allDone) {
                state.callbacks.tracks.setIsDone(state.logLevel);
              }
              return null;
            }
          },
          onAudioTrack: onGlobalAudioTrack === null ? null : async ({ track }) => {
            const callbackOrFalse = state.m3u.hasEmittedAudioTrack(playlistUrl);
            if (callbackOrFalse === false) {
              const callback = await onGlobalAudioTrack(track);
              if (!callback) {
                state.m3u.setHasEmittedAudioTrack(playlistUrl, null);
                return null;
              }
              state.m3u.setHasEmittedAudioTrack(playlistUrl, callback);
              return async (sample) => {
                await considerSeekBasedOnChunk({
                  sample,
                  callback,
                  parentController: state.controller,
                  childController,
                  m3uState: state.m3u,
                  playlistUrl,
                  subtractChunks: chunksToSubtract,
                  chunkIndex
                });
              };
            }
            if (callbackOrFalse === null) {
              return null;
            }
            return async (sample) => {
              await considerSeekBasedOnChunk({
                sample,
                m3uState: state.m3u,
                playlistUrl,
                callback: callbackOrFalse,
                parentController: state.controller,
                childController,
                subtractChunks: chunksToSubtract,
                chunkIndex
              });
            };
          },
          onVideoTrack: onGlobalVideoTrack === null ? null : async ({ track }) => {
            const callbackOrFalse = state.m3u.hasEmittedVideoTrack(playlistUrl);
            if (callbackOrFalse === false) {
              const callback = await onGlobalVideoTrack({
                ...track,
                m3uStreamFormat: chunk.isHeader || mp4HeaderSegment ? "mp4" : "ts"
              });
              if (!callback) {
                state.m3u.setHasEmittedVideoTrack(playlistUrl, null);
                return null;
              }
              state.m3u.setHasEmittedVideoTrack(playlistUrl, callback);
              return async (sample) => {
                await considerSeekBasedOnChunk({
                  sample,
                  m3uState: state.m3u,
                  playlistUrl,
                  callback,
                  parentController: state.controller,
                  childController,
                  subtractChunks: chunksToSubtract,
                  chunkIndex
                });
              };
            }
            if (callbackOrFalse === null) {
              return null;
            }
            return async (sample) => {
              await considerSeekBasedOnChunk({
                sample,
                m3uState: state.m3u,
                playlistUrl,
                callback: callbackOrFalse,
                parentController: state.controller,
                childController,
                subtractChunks: chunksToSubtract,
                chunkIndex
              });
            };
          },
          reader: state.readerInterface,
          makeSamplesStartAtZero: false,
          m3uPlaylistContext: {
            mp4HeaderSegment,
            isLastChunkInPlaylist: isLastChunk
          }
        });
        if (chunk.isHeader) {
          if (data.slowStructure.type !== "iso-base-media") {
            throw new Error("Expected an mp4 file");
          }
          state.m3u.setMp4HeaderSegment(playlistUrl, data.slowStructure);
        }
      } catch (e) {
        currentPromise.rejector(e);
        throw e;
      }
      forwarded.cleanup();
      if (!isLastChunk) {
        childController.pause();
        currentPromise.resolver(makeContinuationFn());
      }
    }
    currentPromise.resolver(null);
  };
  const run = pausableIterator();
  run.catch((err) => {
    reject(err);
  });
  return promise;
};
var runOverM3u = async ({
  state,
  structure,
  playlistUrl,
  logLevel
}) => {
  const tracksDone = state.m3u.getTrackDone(playlistUrl);
  const hasAudioStreamToConsider = state.m3u.sampleSorter.hasAudioStreamToConsider(playlistUrl);
  const hasVideoStreamToConsider = state.m3u.sampleSorter.hasVideoStreamToConsider(playlistUrl);
  const audioDone = !hasAudioStreamToConsider && tracksDone;
  const videoDone = !hasVideoStreamToConsider && tracksDone;
  const bothDone = audioDone && videoDone;
  if (bothDone) {
    state.m3u.setAllChunksProcessed(playlistUrl);
    return;
  }
  const existingRun = state.m3u.getM3uStreamRun(playlistUrl);
  if (existingRun) {
    Log.trace(logLevel, "Existing M3U parsing process found for", playlistUrl);
    const run = await existingRun.continue();
    state.m3u.setM3uStreamRun(playlistUrl, run);
    if (!run) {
      state.m3u.setAllChunksProcessed(playlistUrl);
    }
    return;
  }
  Log.trace(logLevel, "Starting new M3U parsing process for", playlistUrl);
  await processM3uChunk({
    playlistUrl,
    state,
    structure,
    audioDone,
    videoDone
  });
};
var parseM3u = async ({ state }) => {
  const structure = state.structure.getM3uStructure();
  if (state.m3u.isReadyToIterateOverM3u()) {
    const selectedPlaylists = state.m3u.getSelectedPlaylists();
    const whichPlaylistToRunOver = state.m3u.sampleSorter.getNextStreamToRun(selectedPlaylists);
    await runOverM3u({
      state,
      structure,
      playlistUrl: whichPlaylistToRunOver,
      logLevel: state.logLevel
    });
    return null;
  }
  if (state.m3u.hasFinishedManifest()) {
    if (typeof state.src !== "string" && !(state.src instanceof URL)) {
      throw new Error("Expected src to be a string");
    }
    state.mediaSection.addMediaSection({
      start: 0,
      size: state.contentLength + 1
    });
    await afterManifestFetch({
      structure,
      m3uState: state.m3u,
      src: state.src.toString(),
      selectM3uStreamFn: state.selectM3uStreamFn,
      logLevel: state.logLevel,
      selectAssociatedPlaylistsFn: state.selectM3uAssociatedPlaylistsFn,
      readerInterface: state.readerInterface,
      onAudioTrack: state.onAudioTrack,
      canSkipTracks: state.callbacks.canSkipTracksState
    });
    return null;
  }
  const box2 = await parseM3uManifest({
    iterator: state.iterator,
    structure,
    contentLength: state.contentLength
  });
  const isDoneNow = state.iterator.counter.getOffset() === state.contentLength;
  if (isDoneNow) {
    state.m3u.setHasFinishedManifest();
  }
  return box2;
};
function combine28Bits(a, b, c, d) {
  const val1 = a & 127;
  const val2 = b & 127;
  const val3 = c & 127;
  const val4 = d & 127;
  return val1 << 21 | val2 << 14 | val3 << 7 | val4;
}
var parseId3 = ({ state }) => {
  const { iterator } = state;
  if (iterator.bytesRemaining() < 9) {
    return;
  }
  const { returnToCheckpoint } = iterator.startCheckpoint();
  iterator.discard(3);
  const versionMajor = iterator.getUint8();
  const versionMinor = iterator.getUint8();
  const flags = iterator.getUint8();
  const sizeArr = iterator.getSlice(4);
  const size4 = combine28Bits(sizeArr[0], sizeArr[1], sizeArr[2], sizeArr[3]);
  if (iterator.bytesRemaining() < size4) {
    returnToCheckpoint();
    return;
  }
  const entries = [];
  const initial = iterator.counter.getOffset();
  while (iterator.counter.getOffset() < size4 + initial) {
    const name = versionMajor === 3 || versionMajor === 4 ? iterator.getByteString(4, true) : iterator.getByteString(3, true);
    if (name === "") {
      iterator.discard(size4 + initial - iterator.counter.getOffset());
      break;
    }
    const s = versionMajor === 4 ? iterator.getSyncSafeInt32() : versionMajor === 3 ? iterator.getUint32() : iterator.getUint24();
    if (versionMajor === 3 || versionMajor === 4) {
      iterator.getUint16();
    }
    let subtract = 0;
    if (!name.startsWith("W")) {
      iterator.getUint8();
      subtract += 1;
    }
    if (name === "APIC") {
      const { discardRest } = iterator.planBytes(s - subtract);
      const mimeType = iterator.readUntilNullTerminator();
      iterator.getUint16();
      const description = iterator.readUntilNullTerminator();
      iterator.discard(1);
      const data = discardRest();
      state.images.addImage({
        data,
        description,
        mimeType
      });
    } else {
      const information = iterator.getByteString(s - subtract, true);
      entries.push({
        key: name,
        value: information,
        trackId: null
      });
    }
  }
  state.structure.getMp3Structure().boxes.push({
    type: "id3-header",
    flags,
    size: size4,
    versionMajor,
    versionMinor,
    metatags: entries
  });
};
var parseID3V1 = (iterator) => {
  if (iterator.bytesRemaining() < 128) {
    return;
  }
  iterator.discard(128);
};
function getSamplingFrequency({
  bits,
  mpegVersion
}) {
  const samplingTable = {
    0: { MPEG1: 44100, MPEG2: 22050 },
    1: { MPEG1: 48000, MPEG2: 24000 },
    2: { MPEG1: 32000, MPEG2: 16000 },
    3: { MPEG1: "reserved", MPEG2: "reserved" }
  };
  const key4 = `MPEG${mpegVersion}`;
  const value = samplingTable[bits][key4];
  if (value === "reserved") {
    throw new Error("Reserved sampling frequency");
  }
  if (!value) {
    throw new Error("Invalid sampling frequency for MPEG version: " + JSON.stringify({ bits, version: mpegVersion }));
  }
  return value;
}
function getBitrateKB({
  bits,
  mpegVersion,
  level
}) {
  const bitrateTable = {
    0: {
      "V1,L1": "free",
      "V1,L2": "free",
      "V1,L3": "free",
      "V2,L1": "free",
      "V2,L2&L3": "free"
    },
    1: { "V1,L1": 32, "V1,L2": 32, "V1,L3": 32, "V2,L1": 32, "V2,L2&L3": 8 },
    2: {
      "V1,L1": 64,
      "V1,L2": 48,
      "V1,L3": 40,
      "V2,L1": 48,
      "V2,L2&L3": 16
    },
    3: {
      "V1,L1": 96,
      "V1,L2": 56,
      "V1,L3": 48,
      "V2,L1": 56,
      "V2,L2&L3": 24
    },
    4: {
      "V1,L1": 128,
      "V1,L2": 64,
      "V1,L3": 56,
      "V2,L1": 64,
      "V2,L2&L3": 32
    },
    5: {
      "V1,L1": 160,
      "V1,L2": 80,
      "V1,L3": 64,
      "V2,L1": 80,
      "V2,L2&L3": 40
    },
    6: {
      "V1,L1": 192,
      "V1,L2": 96,
      "V1,L3": 80,
      "V2,L1": 96,
      "V2,L2&L3": 48
    },
    7: {
      "V1,L1": 224,
      "V1,L2": 112,
      "V1,L3": 96,
      "V2,L1": 112,
      "V2,L2&L3": 56
    },
    8: {
      "V1,L1": 256,
      "V1,L2": 128,
      "V1,L3": 112,
      "V2,L1": 128,
      "V2,L2&L3": 64
    },
    9: {
      "V1,L1": 288,
      "V1,L2": 160,
      "V1,L3": 128,
      "V2,L1": 144,
      "V2,L2&L3": 80
    },
    10: {
      "V1,L1": 320,
      "V1,L2": 192,
      "V1,L3": 160,
      "V2,L1": 160,
      "V2,L2&L3": 96
    },
    11: {
      "V1,L1": 352,
      "V1,L2": 224,
      "V1,L3": 192,
      "V2,L1": 176,
      "V2,L2&L3": 112
    },
    12: {
      "V1,L1": 384,
      "V1,L2": 256,
      "V1,L3": 224,
      "V2,L1": 192,
      "V2,L2&L3": 128
    },
    13: {
      "V1,L1": 416,
      "V1,L2": 320,
      "V1,L3": 256,
      "V2,L1": 224,
      "V2,L2&L3": 144
    },
    14: {
      "V1,L1": 448,
      "V1,L2": 384,
      "V1,L3": 320,
      "V2,L1": 256,
      "V2,L2&L3": 160
    },
    15: {
      "V1,L1": "bad",
      "V1,L2": "bad",
      "V1,L3": "bad",
      "V2,L1": "bad",
      "V2,L2&L3": "bad"
    }
  };
  let key4;
  if (mpegVersion === 2 && (level === 2 || level === 3)) {
    key4 = "V2,L2&L3";
  } else {
    key4 = `V${mpegVersion},L${level}`;
  }
  return bitrateTable[bits][key4];
}
var innerParseMp3PacketHeader = (iterator) => {
  for (let i = 0;i < 11; i++) {
    const expectToBe1 = iterator.getBits(1);
    if (expectToBe1 !== 1) {
      throw new Error("Expected 1");
    }
  }
  const audioVersionId = iterator.getBits(2);
  if (audioVersionId !== 3 && audioVersionId !== 2 && audioVersionId !== 0) {
    throw new Error("Expected MPEG Version 1 or 2");
  }
  const mpegVersion = audioVersionId === 3 ? 1 : 2;
  const layerBits = iterator.getBits(2);
  if (layerBits === 0) {
    throw new Error("Expected Layer I, II or III");
  }
  const layer = layerBits === 3 ? 1 : layerBits === 2 ? 2 : 3;
  iterator.getBits(1);
  const bitrateIndex = iterator.getBits(4);
  const bitrateInKbit = getBitrateKB({
    bits: bitrateIndex,
    mpegVersion,
    level: layer
  });
  if (bitrateInKbit === "bad") {
    throw new Error("Invalid bitrate");
  }
  if (bitrateInKbit === "free") {
    throw new Error("Free bitrate not supported");
  }
  const samplingFrequencyIndex = iterator.getBits(2);
  const baseSampleRate = getSamplingFrequency({
    bits: samplingFrequencyIndex,
    mpegVersion
  });
  const sampleRate = audioVersionId === 0 ? baseSampleRate / 2 : baseSampleRate;
  const padding3 = Boolean(iterator.getBits(1));
  iterator.getBits(1);
  const channelMode = iterator.getBits(2);
  iterator.getBits(2);
  iterator.getBits(1);
  iterator.getBits(1);
  iterator.getBits(2);
  const numberOfChannels = channelMode === 3 ? 1 : 2;
  const samplesPerFrame = getSamplesPerMpegFrame({ mpegVersion, layer });
  const frameLength = getMpegFrameLength({
    bitrateKbit: bitrateInKbit,
    padding: padding3,
    samplesPerFrame,
    samplingFrequency: sampleRate,
    layer
  });
  return {
    frameLength,
    bitrateInKbit,
    layer,
    mpegVersion,
    numberOfChannels,
    sampleRate,
    samplesPerFrame
  };
};
var parseMp3PacketHeader = (iterator) => {
  iterator.startReadingBits();
  const d = innerParseMp3PacketHeader(iterator);
  iterator.stopReadingBits();
  return d;
};
var isMp3PacketHeaderHere = (iterator) => {
  const offset = iterator.counter.getOffset();
  iterator.startReadingBits();
  try {
    const res = innerParseMp3PacketHeader(iterator);
    iterator.stopReadingBits();
    iterator.counter.decrement(iterator.counter.getOffset() - offset);
    return res;
  } catch {
    iterator.stopReadingBits();
    iterator.counter.decrement(iterator.counter.getOffset() - offset);
    return false;
  }
};
var isMp3PacketHeaderHereAndInNext = (iterator) => {
  const offset = iterator.counter.getOffset();
  const res = isMp3PacketHeaderHere(iterator);
  if (!res) {
    return false;
  }
  if (iterator.bytesRemaining() <= res.frameLength) {
    return true;
  }
  iterator.counter.increment(res.frameLength);
  const isHere = isMp3PacketHeaderHere(iterator);
  iterator.counter.decrement(iterator.counter.getOffset() - offset);
  return isHere;
};
var getAudioSampleFromCbr = ({
  bitrateInKbit,
  initialOffset,
  layer,
  sampleRate,
  samplesPerFrame,
  data,
  state
}) => {
  const avgLength = getAverageMpegFrameLength({
    bitrateKbit: bitrateInKbit,
    layer,
    samplesPerFrame,
    samplingFrequency: sampleRate
  });
  const mp3Info = state.mp3.getMp3Info();
  if (!mp3Info) {
    throw new Error("No MP3 info");
  }
  const nthFrame = Math.round((initialOffset - state.mediaSection.getMediaSectionAssertOnlyOne().start) / avgLength);
  const durationInSeconds = samplesPerFrame / sampleRate;
  const timeInSeconds = nthFrame * samplesPerFrame / sampleRate;
  const timestamp = Math.floor(timeInSeconds * WEBCODECS_TIMESCALE);
  const duration2 = Math.floor(durationInSeconds * WEBCODECS_TIMESCALE);
  const audioSample = {
    data,
    decodingTimestamp: timestamp,
    duration: duration2,
    offset: initialOffset,
    timestamp,
    type: "key"
  };
  return { audioSample, timeInSeconds, durationInSeconds };
};
var getAudioSampleFromVbr = ({
  info,
  position,
  mp3Info,
  data
}) => {
  if (!mp3Info) {
    throw new Error("No MP3 info");
  }
  const samplesPerFrame = getSamplesPerMpegFrame({
    layer: mp3Info.layer,
    mpegVersion: mp3Info.mpegVersion
  });
  const wholeFileDuration = getDurationFromMp3Xing({
    samplesPerFrame,
    xingData: info.xingData
  });
  if (!info.xingData.fileSize) {
    throw new Error("file size");
  }
  if (!info.xingData.tableOfContents) {
    throw new Error("table of contents");
  }
  const timeInSeconds = getTimeFromPosition({
    durationInSeconds: wholeFileDuration,
    fileSize: info.xingData.fileSize,
    position,
    tableOfContents: info.xingData.tableOfContents
  });
  const durationInSeconds = samplesPerFrame / info.xingData.sampleRate;
  const timestamp = Math.floor(timeInSeconds * WEBCODECS_TIMESCALE);
  const duration2 = Math.floor(durationInSeconds * WEBCODECS_TIMESCALE);
  const audioSample = {
    data,
    decodingTimestamp: timestamp,
    duration: duration2,
    offset: position,
    timestamp,
    type: "key"
  };
  return { timeInSeconds, audioSample, durationInSeconds };
};
var parseMpegHeader = async ({
  state
}) => {
  const { iterator } = state;
  const initialOffset = iterator.counter.getOffset();
  if (iterator.bytesRemaining() < 32) {
    return;
  }
  const {
    frameLength,
    bitrateInKbit,
    layer,
    mpegVersion,
    numberOfChannels,
    sampleRate,
    samplesPerFrame
  } = parseMp3PacketHeader(iterator);
  const cbrMp3Info = state.mp3.getMp3BitrateInfo();
  if (cbrMp3Info && cbrMp3Info.type === "constant") {
    if (bitrateInKbit !== cbrMp3Info.bitrateInKbit) {
      throw new Error(`Bitrate mismatch at offset ${initialOffset}: ${bitrateInKbit} !== ${cbrMp3Info.bitrateInKbit}`);
    }
  }
  const offsetNow = iterator.counter.getOffset();
  iterator.counter.decrement(offsetNow - initialOffset);
  const data = iterator.getSlice(frameLength);
  if (state.callbacks.tracks.getTracks().length === 0) {
    const info = {
      layer,
      mpegVersion,
      sampleRate
    };
    const asText = new TextDecoder().decode(data);
    if (asText.includes("VBRI")) {
      throw new Error("MP3 files with VBRI are currently unsupported because we have no sample file. Submit this file at remotion.dev/report if you would like us to support this file.");
    }
    if (asText.includes("Info")) {
      return;
    }
    const isVbr = asText.includes("Xing");
    if (isVbr) {
      const xingData = parseXing(data);
      Log.verbose(state.logLevel, "MP3 has variable bit rate. Requiring whole file to be read");
      state.mp3.setMp3BitrateInfo({
        type: "variable",
        xingData
      });
      return;
    }
    if (!state.mp3.getMp3BitrateInfo()) {
      state.mp3.setMp3BitrateInfo({
        bitrateInKbit,
        type: "constant"
      });
    }
    state.mp3.setMp3Info(info);
    await registerAudioTrack({
      container: "mp3",
      track: {
        type: "audio",
        codec: "mp3",
        codecData: null,
        codecEnum: "mp3",
        description: undefined,
        numberOfChannels,
        sampleRate,
        originalTimescale: 1e6,
        trackId: 0,
        startInSeconds: 0,
        timescale: WEBCODECS_TIMESCALE,
        trackMediaTimeOffsetInTrackTimescale: 0
      },
      registerAudioSampleCallback: state.callbacks.registerAudioSampleCallback,
      tracks: state.callbacks.tracks,
      logLevel: state.logLevel,
      onAudioTrack: state.onAudioTrack
    });
    state.callbacks.tracks.setIsDone(state.logLevel);
    state.mediaSection.addMediaSection({
      start: initialOffset,
      size: state.contentLength - initialOffset
    });
  }
  const bitrateInfo = state.mp3.getMp3BitrateInfo();
  if (!bitrateInfo) {
    throw new Error("No bitrate info");
  }
  const sample = bitrateInfo.type === "constant" ? getAudioSampleFromCbr({
    bitrateInKbit,
    data,
    initialOffset,
    layer,
    sampleRate,
    samplesPerFrame,
    state
  }) : getAudioSampleFromVbr({
    data,
    info: bitrateInfo,
    mp3Info: state.mp3.getMp3Info(),
    position: initialOffset
  });
  const { audioSample, timeInSeconds, durationInSeconds } = sample;
  state.mp3.audioSamples.addSample({
    timeInSeconds,
    offset: initialOffset,
    durationInSeconds
  });
  await state.callbacks.onAudioSample({
    audioSample,
    trackId: 0
  });
};
var discardUntilSyncword = ({
  iterator
}) => {
  while (true) {
    const next2Bytes = iterator.getUint8();
    if (next2Bytes !== 255) {
      continue;
    }
    if (iterator.bytesRemaining() === 0) {
      break;
    }
    const nextByte = iterator.getUint8();
    const mask = 224;
    if ((nextByte & mask) !== mask) {
      continue;
    }
    iterator.counter.decrement(2);
    if (isMp3PacketHeaderHereAndInNext(iterator)) {
      break;
    } else {
      iterator.counter.increment(2);
    }
  }
};
var parseMp3 = async (state) => {
  const { iterator } = state;
  if (iterator.bytesRemaining() < 3) {
    return null;
  }
  if (state.mediaSection.isCurrentByteInMediaSection(iterator) === "in-section") {
    discardUntilSyncword({ iterator });
    await parseMpegHeader({
      state
    });
    return null;
  }
  const { returnToCheckpoint } = iterator.startCheckpoint();
  const bytes = iterator.getSlice(3);
  returnToCheckpoint();
  if (bytes[0] === 84 && bytes[1] === 65 && bytes[2] === 71) {
    parseID3V1(iterator);
    return null;
  }
  if (bytes[0] === 73 && bytes[1] === 68 && bytes[2] === 51) {
    parseId3({ state });
    return null;
  }
  if (bytes[0] === 255) {
    await parseMpegHeader({
      state
    });
    return null;
  }
  throw new Error("Unknown MP3 header " + JSON.stringify(bytes));
};
var getStrhForIndex = (structure, trackId) => {
  const boxes = getStrlBoxes(structure);
  const box2 = boxes[trackId];
  if (!box2) {
    throw new Error("Expected box");
  }
  const strh = getStrhBox(box2.children);
  if (!strh) {
    throw new Error("strh");
  }
  return strh;
};
var getKeyFrameOffsetAndPocs = ({
  state,
  sample,
  trackId
}) => {
  if (sample.type === "key") {
    const sampleOffset = state.riff.sampleCounter.getSampleCountForTrack({
      trackId
    });
    return {
      sampleOffsetAtKeyframe: sampleOffset,
      pocsAtKeyframeOffset: [sample.avc?.poc ?? 0]
    };
  }
  const riffKeyframes = state.riff.sampleCounter.riffKeys.getKeyframes();
  const keyframeAtOffset = riffKeyframes.findLast((k) => k.positionInBytes <= sample.offset);
  if (!keyframeAtOffset) {
    throw new Error("no keyframe at offset");
  }
  const sampleOffsetAtKeyframe = keyframeAtOffset.sampleCounts[trackId];
  const pocsAtKeyframeOffset = state.riff.sampleCounter.getPocAtKeyframeOffset({
    keyframeOffset: keyframeAtOffset.positionInBytes
  });
  return {
    sampleOffsetAtKeyframe,
    pocsAtKeyframeOffset
  };
};
var convertQueuedSampleToMediaParserSample = ({
  sample,
  state,
  trackId
}) => {
  const strh = getStrhForIndex(state.structure.getRiffStructure(), trackId);
  const samplesPerSecond = strh.rate / strh.scale;
  const { sampleOffsetAtKeyframe, pocsAtKeyframeOffset } = getKeyFrameOffsetAndPocs({
    sample,
    state,
    trackId
  });
  const indexOfPoc = pocsAtKeyframeOffset.findIndex((poc) => poc === sample.avc?.poc);
  if (indexOfPoc === -1) {
    throw new Error("poc not found");
  }
  const nthSample = indexOfPoc + sampleOffsetAtKeyframe;
  const timestamp = nthSample / samplesPerSecond;
  const videoSample = convertAudioOrVideoSampleToWebCodecsTimestamps({
    sample: {
      ...sample,
      timestamp,
      decodingTimestamp: timestamp
    },
    timescale: 1
  });
  return videoSample;
};
var isMoviAtom = (iterator, ckId) => {
  if (ckId !== "LIST") {
    return false;
  }
  const listType = iterator.getByteString(4, false);
  iterator.counter.decrement(4);
  return listType === "movi";
};
var AVIF_HAS_INDEX = 16;
var parseAvih = ({
  iterator,
  size: size4
}) => {
  const { expectNoMoreBytes } = iterator.startBox(size4);
  const dwMicroSecPerFrame = iterator.getUint32Le();
  const dwMaxBytesPerSec = iterator.getUint32Le();
  const paddingGranularity = iterator.getUint32Le();
  const flags = iterator.getUint32Le();
  const totalFrames = iterator.getUint32Le();
  const initialFrames = iterator.getUint32Le();
  const streams = iterator.getUint32Le();
  const suggestedBufferSize = iterator.getUint32Le();
  const width = iterator.getUint32Le();
  const height = iterator.getUint32Le();
  const hasIndex = (flags & AVIF_HAS_INDEX) !== 0;
  iterator.discard(16);
  expectNoMoreBytes();
  return {
    type: "avih-box",
    hasIndex,
    microSecPerFrame: dwMicroSecPerFrame,
    maxBytesPerSecond: dwMaxBytesPerSec,
    paddingGranularity,
    flags,
    totalFrames,
    initialFrames,
    streams,
    suggestedBufferSize,
    height,
    width
  };
};
var AVIIF_KEYFRAME = 16;
var parseIdx1 = ({
  iterator,
  size: size4
}) => {
  const box2 = iterator.startBox(size4);
  const offset = iterator.counter.getOffset();
  const entries = [];
  const sampleCounts = {};
  let videoTrackIndex = null;
  while (iterator.counter.getOffset() < offset + size4) {
    const chunkId = iterator.getByteString(4, false);
    const flags = iterator.getUint32Le();
    const moffset = iterator.getUint32Le();
    const msize = iterator.getUint32Le();
    const chunk = chunkId.match(/^([0-9]{2})(wb|dc)$/);
    const isVideo = chunkId.endsWith("dc");
    if (isVideo) {
      videoTrackIndex = chunk ? parseInt(chunk[1], 10) : null;
    }
    const trackId = chunk ? parseInt(chunk[1], 10) : null;
    if (trackId === null) {
      continue;
    }
    if (!sampleCounts[trackId]) {
      sampleCounts[trackId] = 0;
    }
    const isKeyFrame = (flags & AVIIF_KEYFRAME) !== 0;
    if (isKeyFrame) {
      entries.push({
        flags,
        id: chunkId,
        offset: moffset,
        size: msize,
        sampleCounts: { ...sampleCounts }
      });
    }
    sampleCounts[trackId]++;
  }
  box2.expectNoMoreBytes();
  return {
    type: "idx1-box",
    entries,
    videoTrackIndex
  };
};
var parseIsft = ({
  iterator,
  size: size4
}) => {
  const { expectNoMoreBytes } = iterator.startBox(size4);
  const software = iterator.getByteString(size4 - 1, false);
  const last = iterator.getUint8();
  if (last !== 0) {
    throw new Error(`Expected 0 byte, got ${last}`);
  }
  expectNoMoreBytes();
  return {
    type: "isft-box",
    software
  };
};
var parseListBox = async ({
  size: size4,
  iterator,
  stateIfExpectingSideEffects
}) => {
  const counter = iterator.counter.getOffset();
  const listType = iterator.getByteString(4, false);
  if (listType === "movi") {
    throw new Error("should not be handled here");
  }
  const boxes = [];
  const maxOffset = counter + size4;
  while (iterator.counter.getOffset() < maxOffset) {
    const box2 = await expectRiffBox({
      iterator,
      stateIfExpectingSideEffects
    });
    if (box2 === null) {
      throw new Error("Unexpected result");
    }
    if (stateIfExpectingSideEffects) {
      await postProcessRiffBox(stateIfExpectingSideEffects, box2);
    }
    boxes.push(box2);
  }
  return {
    type: "list-box",
    listType,
    children: boxes
  };
};
var parseStrfAudio = ({
  iterator,
  size: size4
}) => {
  const box2 = iterator.startBox(size4);
  const formatTag = iterator.getUint16Le();
  const numberOfChannels = iterator.getUint16Le();
  const samplesPerSec = iterator.getUint32Le();
  const avgBytesPerSec = iterator.getUint32Le();
  const blockAlign = iterator.getUint16Le();
  const bitsPerSample = iterator.getUint16Le();
  const cbSize = iterator.getUint16Le();
  box2.expectNoMoreBytes();
  return {
    type: "strf-box-audio",
    avgBytesPerSecond: avgBytesPerSec,
    bitsPerSample,
    blockAlign,
    cbSize,
    formatTag,
    numberOfChannels,
    sampleRate: samplesPerSec
  };
};
var parseStrfVideo = ({
  iterator,
  size: size4
}) => {
  const box2 = iterator.startBox(size4);
  const biSize = iterator.getUint32Le();
  const width = iterator.getInt32Le();
  const height = iterator.getInt32Le();
  const planes = iterator.getUint16Le();
  const bitCount = iterator.getUint16Le();
  const compression = iterator.getByteString(4, false);
  const sizeImage = iterator.getUint32Le();
  const xPelsPerMeter = iterator.getInt32Le();
  const yPelsPerMeter = iterator.getInt32Le();
  const clrUsed = iterator.getUint32Le();
  const clrImportant = iterator.getUint32Le();
  box2.expectNoMoreBytes();
  return {
    type: "strf-box-video",
    biSize,
    bitCount,
    clrImportant,
    clrUsed,
    compression,
    height,
    planes,
    sizeImage,
    width,
    xPelsPerMeter,
    yPelsPerMeter
  };
};
var parseStrf = ({
  iterator,
  size: size4,
  fccType
}) => {
  if (fccType === "vids") {
    return parseStrfVideo({ iterator, size: size4 });
  }
  if (fccType === "auds") {
    return parseStrfAudio({ iterator, size: size4 });
  }
  throw new Error(`Unsupported fccType: ${fccType}`);
};
var parseStrh = ({
  iterator,
  size: size4
}) => {
  const box2 = iterator.startBox(size4);
  const fccType = iterator.getByteString(4, false);
  if (fccType !== "vids" && fccType !== "auds") {
    throw new Error("Expected AVI handler to be vids / auds");
  }
  const handler = fccType === "vids" ? iterator.getByteString(4, false) : iterator.getUint32Le();
  if (typeof handler === "string" && handler !== "H264") {
    throw new Error(`Only H264 is supported as a stream type in .avi, got ${handler}`);
  }
  if (fccType === "auds" && handler !== 1) {
    throw new Error(`Only "1" is supported as a stream type in .avi, got ${handler}`);
  }
  const flags = iterator.getUint32Le();
  const priority = iterator.getUint16Le();
  const language2 = iterator.getUint16Le();
  const initialFrames = iterator.getUint32Le();
  const scale = iterator.getUint32Le();
  const rate = iterator.getUint32Le();
  const start = iterator.getUint32Le();
  const length = iterator.getUint32Le();
  const suggestedBufferSize = iterator.getUint32Le();
  const quality = iterator.getUint32Le();
  const sampleSize = iterator.getUint32Le();
  box2.discardRest();
  const ckId = iterator.getByteString(4, false);
  const ckSize = iterator.getUint32Le();
  if (ckId !== "strf") {
    throw new Error(`Expected strf, got ${JSON.stringify(ckId)}`);
  }
  if (iterator.bytesRemaining() < ckSize) {
    throw new Error("Expected strf to be complete");
  }
  const strf = parseStrf({ iterator, size: ckSize, fccType });
  return {
    type: "strh-box",
    fccType,
    handler,
    flags,
    priority,
    initialFrames,
    length,
    quality,
    rate,
    sampleSize,
    scale,
    start,
    suggestedBufferSize,
    language: language2,
    strf
  };
};
var parseRiffBox = ({
  size: size4,
  id,
  iterator,
  stateIfExpectingSideEffects
}) => {
  if (id === "LIST") {
    return parseListBox({
      size: size4,
      iterator,
      stateIfExpectingSideEffects
    });
  }
  if (id === "ISFT") {
    return Promise.resolve(parseIsft({ iterator, size: size4 }));
  }
  if (id === "avih") {
    return Promise.resolve(parseAvih({ iterator, size: size4 }));
  }
  if (id === "strh") {
    return Promise.resolve(parseStrh({ iterator, size: size4 }));
  }
  if (id === "idx1") {
    return Promise.resolve(parseIdx1({ iterator, size: size4 }));
  }
  iterator.discard(size4);
  const box2 = {
    type: "riff-box",
    size: size4,
    id
  };
  return Promise.resolve(box2);
};
var postProcessRiffBox = async (state, box2) => {
  if (box2.type === "strh-box") {
    if (box2.strf.type === "strf-box-audio" && state.onAudioTrack) {
      const audioTrack = makeAviAudioTrack({
        index: state.riff.getNextTrackIndex(),
        strf: box2.strf
      });
      await registerAudioTrack({
        track: audioTrack,
        container: "avi",
        registerAudioSampleCallback: state.callbacks.registerAudioSampleCallback,
        tracks: state.callbacks.tracks,
        logLevel: state.logLevel,
        onAudioTrack: state.onAudioTrack
      });
    }
    if (state.onVideoTrack && box2.strf.type === "strf-box-video") {
      const videoTrack = makeAviVideoTrack({
        strh: box2,
        index: state.riff.getNextTrackIndex(),
        strf: box2.strf
      });
      registerVideoTrackWhenProfileIsAvailable({
        state,
        track: videoTrack,
        container: "avi"
      });
    }
    state.riff.incrementNextTrackIndex();
  }
};
var expectRiffBox = async ({
  iterator,
  stateIfExpectingSideEffects
}) => {
  if (iterator.bytesRemaining() < 16) {
    return null;
  }
  const checkpoint = iterator.startCheckpoint();
  const ckId = iterator.getByteString(4, false);
  const ckSize = iterator.getUint32Le();
  if (isMoviAtom(iterator, ckId)) {
    iterator.discard(4);
    if (!stateIfExpectingSideEffects) {
      throw new Error("No state if expecting side effects");
    }
    stateIfExpectingSideEffects.mediaSection.addMediaSection({
      start: iterator.counter.getOffset(),
      size: ckSize - 4
    });
    if (riffHasIndex(stateIfExpectingSideEffects.structure.getRiffStructure())) {
      stateIfExpectingSideEffects.riff.lazyIdx1.triggerLoad(iterator.counter.getOffset() + ckSize - 4);
    }
    return null;
  }
  if (iterator.bytesRemaining() < ckSize) {
    checkpoint.returnToCheckpoint();
    return null;
  }
  const box2 = await parseRiffBox({
    id: ckId,
    size: ckSize,
    iterator,
    stateIfExpectingSideEffects
  });
  return box2;
};
var handleChunk = async ({
  state,
  ckId,
  ckSize
}) => {
  const { iterator } = state;
  const offset = iterator.counter.getOffset() - 8;
  const videoChunk = ckId.match(/^([0-9]{2})dc$/);
  if (videoChunk) {
    const trackId = parseInt(videoChunk[1], 10);
    const strh = getStrhForIndex(state.structure.getRiffStructure(), trackId);
    const samplesPerSecond = strh.rate / strh.scale;
    const data = iterator.getSlice(ckSize);
    const infos = parseAvc(data, state.avc);
    const keyOrDelta = getKeyFrameOrDeltaFromAvcInfo(infos);
    const info = infos.find((i) => i.type === "keyframe" || i.type === "delta-frame");
    const avcProfile = infos.find((i) => i.type === "avc-profile");
    const ppsProfile = infos.find((i) => i.type === "avc-pps");
    if (avcProfile && ppsProfile && !state.riff.getAvcProfile()) {
      await state.riff.onProfile({ pps: ppsProfile, sps: avcProfile });
      state.callbacks.tracks.setIsDone(state.logLevel);
    }
    const rawSample = {
      data,
      duration: 1 / samplesPerSecond,
      type: keyOrDelta === "bidirectional" ? "delta" : keyOrDelta,
      offset,
      avc: info
    };
    const maxFramesInBuffer = state.avc.getMaxFramesInBuffer();
    if (maxFramesInBuffer === null) {
      throw new Error("maxFramesInBuffer is null");
    }
    if ((info?.poc ?? null) === null) {
      throw new Error("poc is null");
    }
    const keyframeOffset = state.riff.sampleCounter.getKeyframeAtOffset(rawSample);
    if (keyframeOffset !== null) {
      state.riff.sampleCounter.setPocAtKeyframeOffset({
        keyframeOffset,
        poc: info.poc
      });
    }
    state.riff.queuedBFrames.addFrame({
      frame: rawSample,
      trackId,
      maxFramesInBuffer,
      timescale: samplesPerSecond
    });
    const releasedFrame = state.riff.queuedBFrames.getReleasedFrame();
    if (!releasedFrame) {
      return;
    }
    const videoSample = convertQueuedSampleToMediaParserSample({
      sample: releasedFrame.sample,
      state,
      trackId: releasedFrame.trackId
    });
    state.riff.sampleCounter.onVideoSample({
      trackId,
      videoSample
    });
    await state.callbacks.onVideoSample({
      videoSample,
      trackId
    });
  }
  const audioChunk = ckId.match(/^([0-9]{2})wb$/);
  if (audioChunk) {
    const trackId = parseInt(audioChunk[1], 10);
    const strh = getStrhForIndex(state.structure.getRiffStructure(), trackId);
    const { strf } = strh;
    if (strf.type !== "strf-box-audio") {
      throw new Error("audio");
    }
    const samplesPerSecond = strh.rate / strh.scale * strf.numberOfChannels;
    const nthSample = state.riff.sampleCounter.getSampleCountForTrack({
      trackId
    });
    const timeInSec = nthSample / samplesPerSecond;
    const timestamp = Math.floor(timeInSec * WEBCODECS_TIMESCALE);
    const data = iterator.getSlice(ckSize);
    const audioSample = {
      decodingTimestamp: timestamp,
      data,
      duration: undefined,
      timestamp,
      type: "key",
      offset
    };
    state.riff.sampleCounter.onAudioSample(trackId, audioSample);
    await state.callbacks.onAudioSample({
      audioSample,
      trackId
    });
  }
};
var parseMovi = async ({
  state
}) => {
  const { iterator } = state;
  if (iterator.bytesRemaining() < 8) {
    return Promise.resolve();
  }
  const checkpoint = iterator.startCheckpoint();
  const ckId = iterator.getByteString(4, false);
  const ckSize = iterator.getUint32Le();
  if (iterator.bytesRemaining() < ckSize) {
    checkpoint.returnToCheckpoint();
    return Promise.resolve();
  }
  await handleChunk({ state, ckId, ckSize });
  const mediaSection = state.mediaSection.getMediaSectionAssertOnlyOne();
  const maxOffset = mediaSection.start + mediaSection.size;
  while (iterator.counter.getOffset() < maxOffset && iterator.bytesRemaining() > 0) {
    if (iterator.getUint8() !== 0) {
      iterator.counter.decrement(1);
      break;
    }
  }
};
var parseMediaSection = async (state) => {
  await parseMovi({
    state
  });
  const tracks2 = getTracks(state, false);
  if (!tracks2.some((t) => t.type === "video" && t.codec === TO_BE_OVERRIDDEN_LATER) && !state.callbacks.tracks.getIsDone()) {
    state.callbacks.tracks.setIsDone(state.logLevel);
  }
};
var parseRiffBody = async (state) => {
  const releasedFrame = state.riff.queuedBFrames.getReleasedFrame();
  if (releasedFrame) {
    const converted = convertQueuedSampleToMediaParserSample({
      sample: releasedFrame.sample,
      state,
      trackId: releasedFrame.trackId
    });
    state.riff.sampleCounter.onVideoSample({
      trackId: releasedFrame.trackId,
      videoSample: converted
    });
    await state.callbacks.onVideoSample({
      videoSample: converted,
      trackId: releasedFrame.trackId
    });
    return null;
  }
  if (state.mediaSection.isCurrentByteInMediaSection(state.iterator) === "in-section") {
    if (maySkipVideoData({
      state
    }) && state.riff.getAvcProfile()) {
      const mediaSection = getCurrentMediaSection({
        offset: state.iterator.counter.getOffset(),
        mediaSections: state.mediaSection.getMediaSections()
      });
      if (!mediaSection) {
        throw new Error("No video section defined");
      }
      return Promise.resolve(makeSkip(mediaSection.start + mediaSection.size));
    }
    await parseMediaSection(state);
    return null;
  }
  const box2 = await expectRiffBox({
    iterator: state.iterator,
    stateIfExpectingSideEffects: state
  });
  if (box2 !== null) {
    await postProcessRiffBox(state, box2);
    const structure = state.structure.getRiffStructure();
    structure.boxes.push(box2);
  }
  return null;
};
var parseRiffHeader = (state) => {
  const riff = state.iterator.getByteString(4, false);
  if (riff !== "RIFF") {
    throw new Error("Not a RIFF file");
  }
  const structure = state.structure.getRiffStructure();
  const size4 = state.iterator.getUint32Le();
  const fileType = state.iterator.getByteString(4, false);
  if (fileType !== "WAVE" && fileType !== "AVI") {
    throw new Error(`File type ${fileType} not supported`);
  }
  structure.boxes.push({ type: "riff-header", fileSize: size4, fileType });
  return null;
};
var parseRiff = (state) => {
  if (state.iterator.counter.getOffset() === 0) {
    return Promise.resolve(parseRiffHeader(state));
  }
  return parseRiffBody(state);
};
var discardRestOfPacket = (iterator) => {
  const next188 = 188 - iterator.counter.getOffset() % 188;
  iterator.discard(next188);
};
var getRestOfPacket = (iterator) => {
  const next188 = 188 - iterator.counter.getOffset() % 188;
  return iterator.getSlice(next188);
};
var parsePatTable = (iterator, tableId) => {
  iterator.getUint16();
  iterator.startReadingBits();
  iterator.getBits(7);
  iterator.getBits(1);
  const sectionNumber = iterator.getBits(8);
  const lastSectionNumber = iterator.getBits(8);
  if (tableId !== 0) {
    throw new Error("Invalid table ID: " + tableId);
  }
  const tables = [];
  for (let i = sectionNumber;i <= lastSectionNumber; i++) {
    const programNumber = iterator.getBits(16);
    iterator.getBits(3);
    const programMapIdentifier = iterator.getBits(13);
    tables.push({
      type: "transport-stream-program-association-table",
      programNumber,
      programMapIdentifier
    });
  }
  iterator.stopReadingBits();
  return {
    type: "transport-stream-pat-box",
    tableId: tableId.toString(16),
    pat: tables
  };
};
var parsePat = (iterator) => {
  iterator.startReadingBits();
  const tableId = iterator.getBits(8);
  iterator.getBits(1);
  iterator.getBits(1);
  iterator.getBits(4);
  const sectionLength = iterator.getBits(10);
  if (sectionLength > 1021) {
    throw new Error("Invalid section length");
  }
  iterator.stopReadingBits();
  const tables = parsePatTable(iterator, tableId);
  discardRestOfPacket(iterator);
  return tables;
};
var parseSdt = (iterator) => {
  iterator.startReadingBits();
  iterator.getBits(8);
  iterator.getBits(1);
  iterator.getBits(1);
  iterator.getBits(2);
  const sectionLength = iterator.getBits(12);
  iterator.stopReadingBits();
  iterator.discard(sectionLength);
  discardRestOfPacket(iterator);
  return {
    type: "transport-stream-sdt-box"
  };
};
var parsePes = ({
  iterator,
  offset
}) => {
  const ident = iterator.getUint24();
  if (ident !== 1) {
    throw new Error(`Unexpected PES packet start code: ${ident.toString(16)}`);
  }
  const streamId = iterator.getUint8();
  iterator.getUint16();
  iterator.startReadingBits();
  const markerBits = iterator.getBits(2);
  if (markerBits !== 2) {
    throw new Error(`Invalid marker bits: ${markerBits}`);
  }
  const scrambled = iterator.getBits(2);
  if (scrambled !== 0) {
    throw new Error(`Only supporting non-scrambled streams`);
  }
  const priority = iterator.getBits(1);
  iterator.getBits(1);
  iterator.getBits(1);
  iterator.getBits(1);
  const ptsPresent = iterator.getBits(1);
  const dtsPresent = iterator.getBits(1);
  if (!ptsPresent && dtsPresent) {
    throw new Error(`DTS is present but not PTS, this is not allowed in the spec`);
  }
  iterator.getBits(1);
  iterator.getBits(1);
  iterator.getBits(1);
  iterator.getBits(1);
  iterator.getBits(1);
  iterator.getBits(1);
  const pesHeaderLength = iterator.getBits(8);
  const offsetAfterHeader = iterator.counter.getOffset();
  let pts = null;
  if (!ptsPresent) {
    throw new Error(`PTS is required`);
  }
  const fourBits = iterator.getBits(4);
  if (fourBits !== 3 && fourBits !== 2) {
    throw new Error(`Invalid PTS marker bits: ${fourBits}`);
  }
  const pts1 = iterator.getBits(3);
  iterator.getBits(1);
  const pts2 = iterator.getBits(15);
  iterator.getBits(1);
  const pts3 = iterator.getBits(15);
  iterator.getBits(1);
  pts = pts1 << 30 | pts2 << 15 | pts3;
  let dts = null;
  if (dtsPresent) {
    const _fourBits = iterator.getBits(4);
    if (_fourBits !== 1) {
      throw new Error(`Invalid DTS marker bits: ${_fourBits}`);
    }
    const dts1 = iterator.getBits(3);
    iterator.getBits(1);
    const dts2 = iterator.getBits(15);
    iterator.getBits(1);
    const dts3 = iterator.getBits(15);
    iterator.getBits(1);
    dts = dts1 << 30 | dts2 << 15 | dts3;
  }
  iterator.stopReadingBits();
  iterator.discard(pesHeaderLength - (iterator.counter.getOffset() - offsetAfterHeader));
  const packet = {
    dts,
    pts,
    streamId,
    priority,
    offset
  };
  return packet;
};
var parsePmtTable = ({
  iterator,
  tableId,
  sectionLength
}) => {
  const start = iterator.counter.getOffset();
  iterator.getUint16();
  iterator.startReadingBits();
  iterator.getBits(7);
  iterator.getBits(1);
  const sectionNumber = iterator.getBits(8);
  const lastSectionNumber = iterator.getBits(8);
  const tables = [];
  iterator.getBits(3);
  iterator.getBits(13);
  iterator.getBits(4);
  const programInfoLength = iterator.getBits(12);
  iterator.getBits(programInfoLength * 8);
  for (let i = sectionNumber;i <= lastSectionNumber; i++) {
    const streams = [];
    while (true) {
      const streamType = iterator.getBits(8);
      iterator.getBits(3);
      const elementaryPid = iterator.getBits(13);
      iterator.getBits(4);
      const esInfoLength = iterator.getBits(12);
      iterator.getBits(esInfoLength * 8);
      streams.push({ streamType, pid: elementaryPid });
      const remaining = sectionLength - (iterator.counter.getOffset() - start);
      if (remaining <= 4) {
        break;
      }
    }
    tables.push({
      type: "transport-stream-program-map-table",
      streams
    });
  }
  if (tables.length !== 1) {
    throw new Error("Does not PMT table with more than 1 entry, uncommon");
  }
  iterator.stopReadingBits();
  return {
    type: "transport-stream-pmt-box",
    tableId,
    streams: tables[0].streams
  };
};
var parsePmt = (iterator) => {
  iterator.startReadingBits();
  const tableId = iterator.getBits(8);
  iterator.getBits(1);
  iterator.getBits(1);
  iterator.getBits(4);
  const sectionLength = iterator.getBits(10);
  if (sectionLength > 1021) {
    throw new Error("Invalid section length");
  }
  iterator.stopReadingBits();
  const tables = parsePmtTable({ iterator, tableId, sectionLength });
  discardRestOfPacket(iterator);
  return tables;
};
function findNthSubarrayIndex({
  array,
  subarray,
  n,
  startIndex,
  startCount
}) {
  const subarrayLength = subarray.length;
  const arrayLength = array.length;
  let count = startCount;
  let i = startIndex;
  for (i;i <= arrayLength - subarrayLength; i++) {
    let match = true;
    for (let j = 0;j < subarrayLength; j++) {
      if (array[i + j] !== subarray[j]) {
        match = false;
        break;
      }
    }
    if (match) {
      count++;
      if (count === n) {
        return { type: "found", index: i };
      }
    }
  }
  return { type: "not-found", index: i, count };
}
var readAdtsHeader = (buffer) => {
  if (buffer.byteLength < 9) {
    return null;
  }
  const iterator = getArrayBufferIterator({
    initialData: buffer,
    maxBytes: buffer.byteLength,
    logLevel: "error"
  });
  iterator.startReadingBits();
  const bits = iterator.getBits(12);
  if (bits !== 4095) {
    throw new Error("Invalid ADTS header ");
  }
  const id = iterator.getBits(1);
  if (id !== 0) {
    throw new Error("Only supporting MPEG-4 for .ts");
  }
  const layer = iterator.getBits(2);
  if (layer !== 0) {
    throw new Error("Only supporting layer 0 for .ts");
  }
  const protectionAbsent = iterator.getBits(1);
  const audioObjectType = iterator.getBits(2);
  const samplingFrequencyIndex = iterator.getBits(4);
  const sampleRate = getSampleRateFromSampleFrequencyIndex(samplingFrequencyIndex);
  iterator.getBits(1);
  const channelConfiguration = iterator.getBits(3);
  const codecPrivate2 = createAacCodecPrivate({
    audioObjectType,
    sampleRate,
    channelConfiguration,
    codecPrivate: null
  });
  iterator.getBits(1);
  iterator.getBits(1);
  iterator.getBits(1);
  iterator.getBits(1);
  const frameLength = iterator.getBits(13);
  iterator.getBits(11);
  iterator.getBits(2);
  if (!protectionAbsent) {
    iterator.getBits(16);
  }
  iterator.stopReadingBits();
  iterator.destroy();
  return {
    frameLength,
    codecPrivate: codecPrivate2,
    channelConfiguration,
    sampleRate,
    audioObjectType
  };
};
var handleAacPacket = async ({
  streamBuffer,
  programId,
  offset,
  sampleCallbacks,
  logLevel,
  onAudioTrack,
  transportStream,
  makeSamplesStartAtZero
}) => {
  const adtsHeader = readAdtsHeader(streamBuffer.getBuffer());
  if (!adtsHeader) {
    throw new Error("Invalid ADTS header - too short");
  }
  const { channelConfiguration, codecPrivate: codecPrivate2, sampleRate, audioObjectType } = adtsHeader;
  const isTrackRegistered = sampleCallbacks.tracks.getTracks().find((t) => {
    return t.trackId === programId;
  });
  if (!isTrackRegistered) {
    const startOffset = makeSamplesStartAtZero ? Math.min(streamBuffer.pesHeader.pts, streamBuffer.pesHeader.dts ?? Infinity) : 0;
    transportStream.startOffset.setOffset({
      trackId: programId,
      newOffset: startOffset
    });
    const track = {
      type: "audio",
      codecData: { type: "aac-config", data: codecPrivate2 },
      trackId: programId,
      originalTimescale: MPEG_TIMESCALE,
      codecEnum: "aac",
      codec: mapAudioObjectTypeToCodecString(audioObjectType),
      description: codecPrivate2,
      numberOfChannels: channelConfiguration,
      sampleRate,
      startInSeconds: 0,
      timescale: WEBCODECS_TIMESCALE,
      trackMediaTimeOffsetInTrackTimescale: 0
    };
    await registerAudioTrack({
      track,
      container: "transport-stream",
      registerAudioSampleCallback: sampleCallbacks.registerAudioSampleCallback,
      tracks: sampleCallbacks.tracks,
      logLevel,
      onAudioTrack
    });
  }
  const sample = {
    decodingTimestamp: (streamBuffer.pesHeader.dts ?? streamBuffer.pesHeader.pts) - transportStream.startOffset.getOffset(programId),
    timestamp: streamBuffer.pesHeader.pts - transportStream.startOffset.getOffset(programId),
    duration: undefined,
    data: streamBuffer.getBuffer(),
    type: "key",
    offset
  };
  const audioSample = convertAudioOrVideoSampleToWebCodecsTimestamps({
    sample,
    timescale: MPEG_TIMESCALE
  });
  await sampleCallbacks.onAudioSample({
    audioSample,
    trackId: programId
  });
  transportStream.lastEmittedSample.setLastEmittedSample(sample);
};
var makeTransportStreamPacketBuffer = ({
  buffers,
  pesHeader,
  offset
}) => {
  let currentBuf = buffers ? [buffers] : [];
  let subarrayIndex = null;
  const getBuffer = () => {
    if (currentBuf.length === 0) {
      return new Uint8Array;
    }
    if (currentBuf.length === 1) {
      return currentBuf[0];
    }
    currentBuf = [combineUint8Arrays(currentBuf)];
    return currentBuf[0];
  };
  let fastFind = null;
  return {
    pesHeader,
    offset,
    getBuffer,
    addBuffer: (buffer) => {
      currentBuf.push(buffer);
      subarrayIndex = null;
    },
    get2ndSubArrayIndex: () => {
      if (subarrayIndex === null) {
        const result = findNthSubarrayIndex({
          array: getBuffer(),
          subarray: new Uint8Array([0, 0, 1, 9]),
          n: 2,
          startIndex: fastFind?.index ?? 0,
          startCount: fastFind?.count ?? 0
        });
        if (result.type === "found") {
          subarrayIndex = result.index;
          fastFind = null;
        } else {
          fastFind = result;
          return -1;
        }
      }
      return subarrayIndex;
    }
  };
};
var processStreamBuffer = async ({
  streamBuffer,
  programId,
  structure,
  sampleCallbacks,
  logLevel,
  onAudioTrack,
  onVideoTrack,
  transportStream,
  makeSamplesStartAtZero,
  avcState
}) => {
  const stream = getStreamForId(structure, programId);
  if (!stream) {
    throw new Error("No stream found");
  }
  if (stream.streamType === 2) {
    throw new Error("H.262 video stream not supported");
  }
  if (stream.streamType === 27) {
    await handleAvcPacket({
      programId,
      streamBuffer,
      sampleCallbacks,
      logLevel,
      onVideoTrack,
      offset: streamBuffer.offset,
      transportStream,
      makeSamplesStartAtZero,
      avcState
    });
  } else if (stream.streamType === 15) {
    await handleAacPacket({
      streamBuffer,
      programId,
      offset: streamBuffer.offset,
      sampleCallbacks,
      logLevel,
      onAudioTrack,
      transportStream,
      makeSamplesStartAtZero
    });
  }
  if (!sampleCallbacks.tracks.hasAllTracks()) {
    const tracksRegistered = sampleCallbacks.tracks.getTracks().length;
    const { streams } = findProgramMapTableOrThrow(structure);
    if (filterStreamsBySupportedTypes(streams).length === tracksRegistered) {
      sampleCallbacks.tracks.setIsDone(logLevel);
    }
  }
};
var processFinalStreamBuffers = async ({
  structure,
  sampleCallbacks,
  logLevel,
  onAudioTrack,
  onVideoTrack,
  transportStream,
  makeSamplesStartAtZero,
  avcState
}) => {
  for (const [programId, buffer] of transportStream.streamBuffers) {
    if (buffer.getBuffer().byteLength > 0) {
      await processStreamBuffer({
        streamBuffer: buffer,
        programId,
        structure,
        sampleCallbacks,
        logLevel,
        onAudioTrack,
        onVideoTrack,
        transportStream,
        makeSamplesStartAtZero,
        avcState
      });
      transportStream.streamBuffers.delete(programId);
    }
  }
};
var parseStream = ({
  transportStreamEntry,
  programId,
  iterator,
  transportStream
}) => {
  const restOfPacket = getRestOfPacket(iterator);
  const offset = iterator.counter.getOffset();
  const { streamBuffers, nextPesHeaderStore: nextPesHeader } = transportStream;
  if (!streamBuffers.has(transportStreamEntry.pid)) {
    streamBuffers.set(programId, makeTransportStreamPacketBuffer({
      pesHeader: nextPesHeader.getNextPesHeader(),
      buffers: null,
      offset
    }));
  }
  const streamBuffer = streamBuffers.get(transportStreamEntry.pid);
  streamBuffer.addBuffer(restOfPacket);
};
var parsePacket = ({
  iterator,
  structure,
  transportStream
}) => {
  const offset = iterator.counter.getOffset();
  const syncByte = iterator.getUint8();
  if (syncByte !== 71) {
    throw new Error("Invalid sync byte");
  }
  iterator.startReadingBits();
  iterator.getBits(1);
  const payloadUnitStartIndicator = iterator.getBits(1);
  iterator.getBits(1);
  const programId = iterator.getBits(13);
  iterator.getBits(2);
  const adaptationFieldControl1 = iterator.getBits(1);
  iterator.getBits(1);
  iterator.getBits(4);
  iterator.stopReadingBits();
  if (adaptationFieldControl1 === 1) {
    iterator.startReadingBits();
    const adaptationFieldLength = iterator.getBits(8);
    const headerOffset = iterator.counter.getOffset();
    if (adaptationFieldLength > 0) {
      iterator.getBits(1);
      iterator.getBits(1);
      iterator.getBits(1);
      iterator.getBits(1);
      iterator.getBits(1);
      iterator.getBits(1);
      iterator.getBits(1);
      iterator.getBits(1);
    }
    const remaining = adaptationFieldLength - (iterator.counter.getOffset() - headerOffset);
    iterator.stopReadingBits();
    const toDiscard = Math.max(0, remaining);
    iterator.discard(toDiscard);
  }
  const read = iterator.counter.getOffset() - offset;
  if (read === 188) {
    return null;
  }
  const pat = structure.boxes.find((b) => b.type === "transport-stream-pmt-box");
  const isPes = payloadUnitStartIndicator && pat?.streams.find((e) => e.pid === programId);
  if (isPes) {
    const packetPes = parsePes({ iterator, offset });
    transportStream.nextPesHeaderStore.setNextPesHeader(packetPes);
    transportStream.observedPesHeaders.addPesHeader(packetPes);
  } else if (payloadUnitStartIndicator === 1) {
    iterator.getUint8();
  }
  if (programId === 0) {
    return parsePat(iterator);
  }
  if (programId === 17) {
    return parseSdt(iterator);
  }
  const program = programId === 17 ? null : getProgramForId(structure, programId);
  if (program) {
    const pmt = parsePmt(iterator);
    return pmt;
  }
  const transportStreamEntry = getStreamForId(structure, programId);
  if (transportStreamEntry) {
    parseStream({
      transportStreamEntry,
      iterator,
      transportStream,
      programId
    });
    return null;
  }
  throw new Error("Unknown packet identifier");
};
var canProcessAudio = ({
  streamBuffer
}) => {
  const expectedLength = readAdtsHeader(streamBuffer.getBuffer())?.frameLength ?? null;
  if (expectedLength === null) {
    return false;
  }
  if (expectedLength > streamBuffer.getBuffer().length) {
    return false;
  }
  return true;
};
var processAudio = async ({
  transportStreamEntry,
  structure,
  offset,
  sampleCallbacks,
  logLevel,
  onAudioTrack,
  onVideoTrack,
  transportStream,
  makeSamplesStartAtZero,
  avcState
}) => {
  const { streamBuffers, nextPesHeaderStore: nextPesHeader } = transportStream;
  const streamBuffer = streamBuffers.get(transportStreamEntry.pid);
  if (!streamBuffer) {
    throw new Error("Stream buffer not found");
  }
  const expectedLength = readAdtsHeader(streamBuffer.getBuffer())?.frameLength ?? null;
  if (expectedLength === null) {
    throw new Error("Expected length is null");
  }
  if (expectedLength > streamBuffer.getBuffer().length) {
    throw new Error("Expected length is greater than stream buffer length");
  }
  await processStreamBuffer({
    streamBuffer: makeTransportStreamPacketBuffer({
      buffers: streamBuffer.getBuffer().slice(0, expectedLength),
      offset,
      pesHeader: streamBuffer.pesHeader
    }),
    programId: transportStreamEntry.pid,
    structure,
    sampleCallbacks,
    logLevel,
    onAudioTrack,
    onVideoTrack,
    transportStream,
    makeSamplesStartAtZero,
    avcState
  });
  const rest = streamBuffer.getBuffer().slice(expectedLength);
  streamBuffers.set(transportStreamEntry.pid, makeTransportStreamPacketBuffer({
    buffers: rest,
    pesHeader: nextPesHeader.getNextPesHeader(),
    offset
  }));
};
var canProcessVideo = ({
  streamBuffer
}) => {
  const indexOfSeparator = streamBuffer.get2ndSubArrayIndex();
  if (indexOfSeparator === -1 || indexOfSeparator === 0) {
    return false;
  }
  return true;
};
var processVideo = async ({
  programId,
  structure,
  streamBuffer,
  sampleCallbacks,
  logLevel,
  onAudioTrack,
  onVideoTrack,
  transportStream,
  makeSamplesStartAtZero,
  avcState
}) => {
  const indexOfSeparator = streamBuffer.get2ndSubArrayIndex();
  if (indexOfSeparator === -1 || indexOfSeparator === 0) {
    throw new Error("cannot process avc stream");
  }
  const buf = streamBuffer.getBuffer();
  const packet = buf.slice(0, indexOfSeparator);
  const rest = buf.slice(indexOfSeparator);
  await processStreamBuffer({
    streamBuffer: makeTransportStreamPacketBuffer({
      offset: streamBuffer.offset,
      pesHeader: streamBuffer.pesHeader,
      buffers: packet
    }),
    programId,
    structure,
    sampleCallbacks,
    logLevel,
    onAudioTrack,
    onVideoTrack,
    transportStream,
    makeSamplesStartAtZero,
    avcState
  });
  return rest;
};
var processSampleIfPossible = async (state) => {
  const programMap = findProgramMapOrNull(state.structure.getTsStructure());
  if (!programMap) {
    return;
  }
  let processed = false;
  for (const stream of programMap.streams) {
    const streamBuffer = state.transportStream.streamBuffers.get(stream.pid);
    if (!streamBuffer) {
      continue;
    }
    if (stream.streamType === 27) {
      if (canProcessVideo({ streamBuffer })) {
        const rest = await processVideo({
          programId: stream.pid,
          structure: state.structure.getTsStructure(),
          streamBuffer,
          sampleCallbacks: state.callbacks,
          logLevel: state.logLevel,
          onAudioTrack: state.onAudioTrack,
          onVideoTrack: state.onVideoTrack,
          transportStream: state.transportStream,
          makeSamplesStartAtZero: state.makeSamplesStartAtZero,
          avcState: state.avc
        });
        state.transportStream.streamBuffers.delete(stream.pid);
        state.transportStream.streamBuffers.set(stream.pid, makeTransportStreamPacketBuffer({
          pesHeader: state.transportStream.nextPesHeaderStore.getNextPesHeader(),
          buffers: rest,
          offset: state.iterator.counter.getOffset()
        }));
        processed = true;
        break;
      }
    }
    if (stream.streamType === 15) {
      if (canProcessAudio({ streamBuffer })) {
        await processAudio({
          structure: state.structure.getTsStructure(),
          offset: state.iterator.counter.getOffset(),
          sampleCallbacks: state.callbacks,
          logLevel: state.logLevel,
          onAudioTrack: state.onAudioTrack,
          onVideoTrack: state.onVideoTrack,
          transportStream: state.transportStream,
          makeSamplesStartAtZero: state.makeSamplesStartAtZero,
          transportStreamEntry: stream,
          avcState: state.avc
        });
        processed = true;
        break;
      }
    }
  }
  return processed;
};
var parseTransportStream = async (state) => {
  const structure = state.structure.getTsStructure();
  const processed = await processSampleIfPossible(state);
  if (processed) {
    return Promise.resolve(null);
  }
  const { iterator } = state;
  if (iterator.bytesRemaining() < 188) {
    return Promise.resolve(null);
  }
  const packet = parsePacket({
    iterator,
    structure,
    transportStream: state.transportStream
  });
  if (packet) {
    structure.boxes.push(packet);
  }
  if (iterator.bytesRemaining() === 0) {
    await processFinalStreamBuffers({
      transportStream: state.transportStream,
      structure,
      sampleCallbacks: state.callbacks,
      logLevel: state.logLevel,
      onAudioTrack: state.onAudioTrack,
      onVideoTrack: state.onVideoTrack,
      makeSamplesStartAtZero: state.makeSamplesStartAtZero,
      avcState: state.avc
    });
  }
  return Promise.resolve(null);
};
var parseData = ({
  state
}) => {
  const { iterator } = state;
  const ckSize = iterator.getUint32Le();
  const box2 = {
    type: "wav-data",
    dataSize: ckSize
  };
  state.structure.getWavStructure().boxes.push(box2);
  state.callbacks.tracks.setIsDone(state.logLevel);
  state.mediaSection.addMediaSection({
    size: ckSize,
    start: iterator.counter.getOffset()
  });
  if (maySkipVideoData({ state })) {
    return Promise.resolve(makeSkip(iterator.counter.getOffset() + ckSize));
  }
  return Promise.resolve(null);
};
var parseFact = ({
  state
}) => {
  const { iterator } = state;
  const size4 = iterator.getUint32Le();
  if (size4 !== 4) {
    throw new Error(`Expected size 4 for fact box, got ${size4}`);
  }
  const numberOfSamplesPerChannel = iterator.getUint32Le();
  const factBox = {
    type: "wav-fact",
    numberOfSamplesPerChannel
  };
  state.structure.getWavStructure().boxes.push(factBox);
  return Promise.resolve(null);
};
var WMMEDIASUBTYPE_PCM = [
  1,
  0,
  0,
  0,
  0,
  0,
  16,
  0,
  128,
  0,
  0,
  170,
  0,
  56,
  155,
  113
];
var KSDATAFORMAT_SUBTYPE_IEEE_FLOAT = [
  3,
  0,
  0,
  0,
  0,
  0,
  16,
  0,
  128,
  0,
  0,
  170,
  0,
  56,
  155,
  113
];
var subformatIsPcm = (subformat) => {
  return subformat.every((value, index) => value === WMMEDIASUBTYPE_PCM[index]);
};
var subformatIsIeeeFloat = (subformat) => {
  return subformat.every((value, index) => value === KSDATAFORMAT_SUBTYPE_IEEE_FLOAT[index]);
};
var CHANNELS = {
  0: "Front Left",
  1: "Front Right",
  2: "Front Center",
  3: "Low Frequency",
  4: "Back Left",
  5: "Back Right",
  6: "Front Left of Center",
  7: "Front Right of Center",
  8: "Back Center",
  9: "Side Left",
  10: "Side Right",
  11: "Top Center",
  12: "Top Front Left",
  13: "Top Front Center",
  14: "Top Front Right",
  15: "Top Back Left",
  16: "Top Back Center",
  17: "Top Back Right"
};
function getChannelsFromMask(channelMask) {
  const channels2 = [];
  for (let bit = 0;bit < 18; bit++) {
    if ((channelMask & 1 << bit) !== 0) {
      const channelName = CHANNELS[bit];
      if (channelName) {
        channels2.push(channelName);
      } else {
        channels2.push(`Unknown Channel (bit ${bit})`);
      }
    }
  }
  return channels2;
}
var parseFmt = async ({
  state
}) => {
  const { iterator } = state;
  const ckSize = iterator.getUint32Le();
  const box2 = iterator.startBox(ckSize);
  const audioFormat = iterator.getUint16Le();
  if (audioFormat !== 1 && audioFormat !== 65534) {
    throw new Error(`Only supporting WAVE with PCM audio format, but got ${audioFormat}`);
  }
  const numberOfChannels = iterator.getUint16Le();
  const sampleRate = iterator.getUint32Le();
  const byteRate = iterator.getUint32Le();
  const blockAlign = iterator.getUint16Le();
  const bitsPerSample = iterator.getUint16Le();
  const format = bitsPerSample === 16 ? "pcm-s16" : bitsPerSample === 32 ? "pcm-s32" : bitsPerSample === 24 ? "pcm-s24" : null;
  if (format === null) {
    throw new Error(`Unsupported bits per sample: ${bitsPerSample}`);
  }
  const wavHeader = {
    bitsPerSample,
    blockAlign,
    byteRate,
    numberOfChannels,
    sampleRate,
    type: "wav-fmt"
  };
  state.structure.getWavStructure().boxes.push(wavHeader);
  if (audioFormat === 65534) {
    const extraSize = iterator.getUint16Le();
    if (extraSize !== 22) {
      throw new Error(`Only supporting WAVE with 22 extra bytes, but got ${extraSize} bytes extra size`);
    }
    iterator.getUint16Le();
    const channelMask = iterator.getUint32Le();
    const subFormat = iterator.getSlice(16);
    if (subFormat.length !== 16) {
      throw new Error(`Only supporting WAVE with PCM audio format, but got ${subFormat.length}`);
    }
    if (subformatIsPcm(subFormat)) {} else if (subformatIsIeeeFloat(subFormat)) {} else {
      throw new Error(`Unsupported subformat: ${subFormat}`);
    }
    const channels2 = getChannelsFromMask(channelMask);
    wavHeader.numberOfChannels = channels2.length;
  }
  await registerAudioTrack({
    track: {
      type: "audio",
      codec: format,
      codecData: null,
      description: undefined,
      codecEnum: format,
      numberOfChannels,
      sampleRate,
      originalTimescale: 1e6,
      trackId: 0,
      startInSeconds: 0,
      timescale: WEBCODECS_TIMESCALE,
      trackMediaTimeOffsetInTrackTimescale: 0
    },
    container: "wav",
    registerAudioSampleCallback: state.callbacks.registerAudioSampleCallback,
    tracks: state.callbacks.tracks,
    logLevel: state.logLevel,
    onAudioTrack: state.onAudioTrack
  });
  box2.expectNoMoreBytes();
  return Promise.resolve(null);
};
var parseHeader = ({
  state
}) => {
  const fileSize = state.iterator.getUint32Le();
  const fileType = state.iterator.getByteString(4, false);
  if (fileType !== "WAVE") {
    throw new Error(`Expected WAVE, got ${fileType}`);
  }
  const header2 = {
    type: "wav-header",
    fileSize
  };
  state.structure.getWavStructure().boxes.push(header2);
  return Promise.resolve(null);
};
var parseId32 = ({
  state
}) => {
  const { iterator } = state;
  const id3Size = iterator.getUint32Le();
  iterator.discard(id3Size);
  const id3Box = {
    type: "wav-id3"
  };
  state.structure.getWavStructure().boxes.push(id3Box);
  return Promise.resolve(null);
};
var parseJunk = ({
  state
}) => {
  const { iterator } = state;
  const ckSize = iterator.getUint32Le();
  Log.trace(state.logLevel, `Skipping JUNK chunk of size ${ckSize}`);
  iterator.discard(ckSize);
  return Promise.resolve(null);
};
var parseList = ({
  state
}) => {
  const { iterator } = state;
  const ckSize = iterator.getUint32Le();
  const box2 = iterator.startBox(ckSize);
  const startOffset = iterator.counter.getOffset();
  const type = iterator.getByteString(4, false);
  if (type !== "INFO") {
    iterator.discard(ckSize - 4);
    return Promise.resolve(null);
  }
  const metadata = [];
  const remainingBytes = () => ckSize - (iterator.counter.getOffset() - startOffset);
  while (remainingBytes() > 0) {
    const byte = iterator.getUint8();
    if (byte === 0) {
      continue;
    }
    iterator.counter.decrement(1);
    const key4 = iterator.getByteString(4, false);
    const size4 = iterator.getUint32Le();
    const value = iterator.getByteString(size4, true);
    metadata.push({
      key: key4,
      trackId: null,
      value
    });
  }
  const wavList = {
    type: "wav-list",
    metadata
  };
  state.structure.getWavStructure().boxes.push(wavList);
  box2.expectNoMoreBytes();
  return Promise.resolve(null);
};
var parseMediaSection2 = async ({
  state
}) => {
  const { iterator } = state;
  const structure = state.structure.getWavStructure();
  const videoSection = state.mediaSection.getMediaSectionAssertOnlyOne();
  const maxOffset = videoSection.start + videoSection.size;
  const maxRead = maxOffset - iterator.counter.getOffset();
  const offset = iterator.counter.getOffset();
  const fmtBox = structure.boxes.find((box2) => box2.type === "wav-fmt");
  if (!fmtBox) {
    throw new Error("Expected fmt box");
  }
  const toRead = Math.min(maxRead, fmtBox.sampleRate * fmtBox.blockAlign / WAVE_SAMPLES_PER_SECOND);
  const duration2 = toRead / (fmtBox.sampleRate * fmtBox.blockAlign);
  const timestamp = (offset - videoSection.start) / (fmtBox.sampleRate * fmtBox.blockAlign);
  const data = iterator.getSlice(toRead);
  const audioSample = convertAudioOrVideoSampleToWebCodecsTimestamps({
    sample: {
      decodingTimestamp: timestamp,
      data,
      duration: duration2,
      timestamp,
      type: "key",
      offset
    },
    timescale: 1
  });
  await state.callbacks.onAudioSample({
    audioSample,
    trackId: 0
  });
  return null;
};
var parseWav = (state) => {
  const { iterator } = state;
  const insideMediaSection = state.mediaSection.isCurrentByteInMediaSection(iterator);
  if (insideMediaSection === "in-section") {
    return parseMediaSection2({ state });
  }
  const type = iterator.getByteString(4, false).toLowerCase();
  Log.trace(state.logLevel, `Processing box type ${type}`);
  if (type === "riff") {
    return parseHeader({ state });
  }
  if (type === "fmt") {
    return parseFmt({ state });
  }
  if (type === "data") {
    return parseData({ state });
  }
  if (type === "list") {
    return parseList({ state });
  }
  if (type === "id3") {
    return parseId32({ state });
  }
  if (type === "junk" || type === "fllr" || type === "bext" || type === "cue") {
    return parseJunk({ state });
  }
  if (type === "fact") {
    return parseFact({ state });
  }
  if (type === "\x00") {
    return Promise.resolve(null);
  }
  throw new Error(`Unknown WAV box type ${type}`);
};
var getByteForSeek = ({
  seekHeadSegment,
  offset
}) => {
  const value = seekHeadSegment.value.map((v) => {
    if (v.type !== "Seek") {
      return null;
    }
    const seekId2 = v.value.find((_v) => {
      return _v.type === "SeekID" && _v.value === matroskaElements.Cues;
    });
    if (!seekId2) {
      return null;
    }
    const seekPosition2 = v.value.find((_v) => {
      return _v.type === "SeekPosition";
    });
    if (!seekPosition2) {
      return false;
    }
    return seekPosition2.value;
  }).filter(truthy);
  if (value.length === 0) {
    return null;
  }
  return value[0].value + offset;
};
var expectSegment = async ({
  statesForProcessing,
  isInsideSegment,
  iterator,
  logLevel,
  mediaSectionState: mediaSectionState2
}) => {
  if (iterator.bytesRemaining() === 0) {
    throw new Error("has no bytes");
  }
  const offset = iterator.counter.getOffset();
  const { returnToCheckpoint } = iterator.startCheckpoint();
  const segmentId = iterator.getMatroskaSegmentId();
  if (segmentId === null) {
    returnToCheckpoint();
    return null;
  }
  const offsetBeforeVInt = iterator.counter.getOffset();
  const size4 = iterator.getVint();
  const offsetAfterVInt = iterator.counter.getOffset();
  if (size4 === null) {
    returnToCheckpoint();
    return null;
  }
  const bytesRemainingNow = iterator.bytesRemaining();
  Log.trace(logLevel, "Segment ID:", ebmlMap[segmentId]?.name, "Size:" + size4, bytesRemainingNow);
  if (segmentId === matroskaElements.Segment) {
    if (!statesForProcessing) {
      throw new Error("States for processing are required");
    }
    statesForProcessing.webmState.addSegment({
      start: offset,
      size: size4
    });
    const newSegment = {
      type: "Segment",
      minVintWidth: offsetAfterVInt - offsetBeforeVInt,
      value: []
    };
    return newSegment;
  }
  if (segmentId === matroskaElements.Cluster) {
    if (isInsideSegment === null) {
      throw new Error("Expected to be inside segment");
    }
    if (!statesForProcessing) {
      throw new Error("States for processing are required");
    }
    if (mediaSectionState2) {
      mediaSectionState2.addMediaSection({
        start: offset,
        size: size4
      });
    }
    statesForProcessing.webmState.addCluster({
      start: offset,
      size: size4 + (offsetAfterVInt - offset),
      segment: isInsideSegment.index
    });
    const newSegment = {
      type: "Cluster",
      minVintWidth: offsetAfterVInt - offsetBeforeVInt,
      value: []
    };
    return newSegment;
  }
  if (bytesRemainingNow < size4) {
    returnToCheckpoint();
    return null;
  }
  const segment = await parseSegment({
    segmentId,
    length: size4,
    headerReadSoFar: iterator.counter.getOffset() - offset,
    statesForProcessing,
    iterator,
    logLevel
  });
  return segment;
};
var parseSegment = async ({
  segmentId,
  length,
  iterator,
  headerReadSoFar,
  statesForProcessing,
  logLevel
}) => {
  if (length < 0) {
    throw new Error(`Expected length of ${segmentId} to be greater or equal 0`);
  }
  iterator.counter.decrement(headerReadSoFar);
  const offset = iterator.counter.getOffset();
  const ebml = await parseEbml(iterator, statesForProcessing, logLevel);
  if (ebml === null) {
    return null;
  }
  if (!statesForProcessing) {
    return ebml;
  }
  const remapped = await postprocessEbml({
    offset,
    ebml,
    statesForProcessing
  });
  return remapped;
};
var selectStatesForProcessing = ({
  callbacks,
  logLevel,
  onAudioTrack,
  onVideoTrack,
  structure,
  webm,
  avc
}) => {
  return {
    webmState: webm,
    callbacks,
    logLevel,
    onAudioTrack,
    onVideoTrack,
    structureState: structure,
    avcState: avc
  };
};
var parseWebm = async (state) => {
  const structure = state.structure.getMatroskaStructure();
  const { iterator } = state;
  const offset = iterator.counter.getOffset();
  const isInsideSegment = state.webm.isInsideSegment(iterator);
  const isInsideCluster = state.webm.isInsideCluster(offset);
  const results = await expectSegment({
    iterator,
    logLevel: state.logLevel,
    statesForProcessing: selectStatesForProcessing(state),
    isInsideSegment,
    mediaSectionState: state.mediaSection
  });
  if (results?.type === "SeekHead") {
    const position = getByteForSeek({ seekHeadSegment: results, offset });
    if (position !== null) {
      state.webm.cues.triggerLoad(position, offset);
    }
  }
  if (results === null) {
    return null;
  }
  if (isInsideCluster) {
    if (maySkipVideoData({ state })) {
      return makeSkip(Math.min(state.contentLength, isInsideCluster.size + isInsideCluster.start));
    }
    const segments = structure.boxes.filter((box2) => box2.type === "Segment");
    const segment = segments[isInsideCluster.segment];
    if (!segment) {
      throw new Error("Expected segment");
    }
    const clusters = segment.value.find((box2) => box2.type === "Cluster");
    if (!clusters) {
      throw new Error("Expected cluster");
    }
    if (results.type !== "Block" && results.type !== "SimpleBlock") {
      clusters.value.push(results);
    }
  } else if (isInsideSegment) {
    const segments = structure.boxes.filter((box2) => box2.type === "Segment");
    const segment = segments[isInsideSegment.index];
    if (!segment) {
      throw new Error("Expected segment");
    }
    segment.value.push(results);
  } else {
    structure.boxes.push(results);
  }
  return null;
};
var initVideo = async ({ state }) => {
  const fileType = state.iterator.detectFileType();
  const { mimeType, name, contentLength } = state;
  if (fileType.type === "riff") {
    Log.verbose(state.logLevel, "Detected RIFF container");
    state.structure.setStructure({
      type: "riff",
      boxes: []
    });
    return;
  }
  if (state.m3uPlaylistContext?.mp4HeaderSegment) {
    Log.verbose(state.logLevel, "Detected ISO Base Media segment");
    const moovAtom = getMoovFromFromIsoStructure(state.m3uPlaylistContext.mp4HeaderSegment);
    if (!moovAtom) {
      throw new Error("No moov box found");
    }
    const tracks2 = getTracksFromMoovBox(moovAtom);
    for (const track of tracks2.filter((t) => t.type === "video")) {
      await registerVideoTrack({
        track,
        container: "mp4",
        logLevel: state.logLevel,
        onVideoTrack: state.onVideoTrack,
        registerVideoSampleCallback: state.callbacks.registerVideoSampleCallback,
        tracks: state.callbacks.tracks
      });
    }
    for (const track of tracks2.filter((t) => t.type === "audio")) {
      await registerAudioTrack({
        track,
        container: "mp4",
        registerAudioSampleCallback: state.callbacks.registerAudioSampleCallback,
        tracks: state.callbacks.tracks,
        logLevel: state.logLevel,
        onAudioTrack: state.onAudioTrack
      });
    }
    state.callbacks.tracks.setIsDone(state.logLevel);
    state.structure.setStructure({
      type: "iso-base-media",
      boxes: []
    });
    return;
  }
  if (fileType.type === "iso-base-media") {
    Log.verbose(state.logLevel, "Detected ISO Base Media container");
    state.structure.setStructure({
      type: "iso-base-media",
      boxes: []
    });
    return;
  }
  if (fileType.type === "webm") {
    Log.verbose(state.logLevel, "Detected Matroska container");
    state.structure.setStructure({
      boxes: [],
      type: "matroska"
    });
    return;
  }
  if (fileType.type === "transport-stream") {
    Log.verbose(state.logLevel, "Detected MPEG-2 Transport Stream");
    state.mediaSection.addMediaSection({
      start: 0,
      size: contentLength
    });
    state.structure.setStructure({
      boxes: [],
      type: "transport-stream"
    });
    return;
  }
  if (fileType.type === "mp3") {
    Log.verbose(state.logLevel, "Detected MP3");
    const structure = {
      boxes: [],
      type: "mp3"
    };
    state.structure.setStructure(structure);
    return;
  }
  if (fileType.type === "wav") {
    Log.verbose(state.logLevel, "Detected WAV");
    const structure = {
      boxes: [],
      type: "wav"
    };
    state.structure.setStructure(structure);
    return;
  }
  if (fileType.type === "flac") {
    Log.verbose(state.logLevel, "Detected FLAC");
    const structure = {
      boxes: [],
      type: "flac"
    };
    state.structure.setStructure(structure);
    return;
  }
  if (fileType.type === "aac") {
    Log.verbose(state.logLevel, "Detected AAC");
    state.structure.setStructure({
      type: "aac",
      boxes: []
    });
    return;
  }
  if (fileType.type === "m3u") {
    Log.verbose(state.logLevel, "Detected M3U");
    state.structure.setStructure({
      type: "m3u",
      boxes: []
    });
    return;
  }
  if (fileType.type === "pdf") {
    return Promise.reject(new IsAPdfError({
      message: "GIF files are not supported",
      mimeType,
      sizeInBytes: contentLength,
      fileName: name
    }));
  }
  if (fileType.type === "bmp" || fileType.type === "jpeg" || fileType.type === "png" || fileType.type === "webp" || fileType.type === "gif") {
    return Promise.reject(new IsAnImageError({
      message: "Image files are not supported",
      imageType: fileType.type,
      dimensions: fileType.dimensions,
      mimeType,
      sizeInBytes: contentLength,
      fileName: name
    }));
  }
  if (fileType.type === "unknown") {
    return Promise.reject(new IsAnUnsupportedFileTypeError({
      message: "Unknown file format",
      mimeType,
      sizeInBytes: contentLength,
      fileName: name
    }));
  }
  return Promise.reject(new Error("Unknown video format " + fileType));
};
var runParseIteration = async ({
  state
}) => {
  const structure = state.structure.getStructureOrNull();
  if (structure && structure.type === "m3u") {
    return parseM3u({ state });
  }
  if (structure === null) {
    await initVideo({
      state
    });
    return null;
  }
  if (structure.type === "riff") {
    return parseRiff(state);
  }
  if (structure.type === "mp3") {
    return parseMp3(state);
  }
  if (structure.type === "iso-base-media") {
    return parseIsoBaseMedia(state);
  }
  if (structure.type === "matroska") {
    return parseWebm(state);
  }
  if (structure.type === "transport-stream") {
    return parseTransportStream(state);
  }
  if (structure.type === "wav") {
    return parseWav(state);
  }
  if (structure.type === "aac") {
    return parseAac(state);
  }
  if (structure.type === "flac") {
    return parseFlac({ state, iterator: state.iterator });
  }
  return Promise.reject(new Error("Unknown video format " + structure));
};
var fetchMoreData = async (state) => {
  await state.controller._internals.checkForAbortAndPause();
  const result = await state.currentReader.getCurrent().reader.read();
  if (result.value) {
    state.iterator.addData(result.value);
  }
  return result.done;
};
var parseLoop = async ({
  state,
  throttledState,
  onError
}) => {
  let iterationWithThisOffset = 0;
  while (!await checkIfDone(state)) {
    await state.controller._internals.checkForAbortAndPause();
    await workOnSeekRequest(getWorkOnSeekRequestOptions(state));
    const offsetBefore = state.iterator.counter.getOffset();
    const readStart = Date.now();
    while (state.iterator.bytesRemaining() < 0) {
      const done = await fetchMoreData(state);
      if (done) {
        break;
      }
    }
    if (iterationWithThisOffset > 0 || state.iterator.bytesRemaining() <= 1e5) {
      await fetchMoreData(state);
    }
    state.timings.timeReadingData += Date.now() - readStart;
    throttledState.update?.(() => makeProgressObject(state));
    if (!state.errored) {
      Log.trace(state.logLevel, `Continuing parsing of file, currently at position ${state.iterator.counter.getOffset()}/${state.contentLength} (0x${state.iterator.counter.getOffset().toString(16)})`);
      if (iterationWithThisOffset > 300 && state.structure.getStructure().type !== "m3u") {
        throw new Error("Infinite loop detected. The parser is not progressing. This is likely a bug in the parser. You can report this at https://remotion.dev/report and we will fix it as soon as possible.");
      }
      try {
        await triggerInfoEmit(state);
        await state.controller._internals.checkForAbortAndPause();
        const parseLoopStart = Date.now();
        const result = await runParseIteration({
          state
        });
        state.timings.timeInParseLoop += Date.now() - parseLoopStart;
        if (result !== null && result.action === "fetch-more-data") {
          Log.verbose(state.logLevel, `Need to fetch ${result.bytesNeeded} more bytes before we can continue`);
          const startBytesRemaining = state.iterator.bytesRemaining();
          while (true) {
            const done = await fetchMoreData(state);
            if (done) {
              break;
            }
            if (state.iterator.bytesRemaining() - startBytesRemaining >= result.bytesNeeded) {
              break;
            }
          }
          continue;
        }
        if (result !== null && result.action === "skip") {
          state.increaseSkippedBytes(result.skipTo - state.iterator.counter.getOffset());
          if (result.skipTo === state.contentLength) {
            state.iterator.discard(result.skipTo - state.iterator.counter.getOffset());
            Log.verbose(state.logLevel, "Skipped to end of file, not fetching.");
            break;
          }
          const seekStart = Date.now();
          await performSeek({
            seekTo: result.skipTo,
            userInitiated: false,
            controller: state.controller,
            mediaSection: state.mediaSection,
            iterator: state.iterator,
            logLevel: state.logLevel,
            mode: state.mode,
            contentLength: state.contentLength,
            seekInfiniteLoop: state.seekInfiniteLoop,
            currentReader: state.currentReader,
            readerInterface: state.readerInterface,
            fields: state.fields,
            src: state.src,
            discardReadBytes: state.discardReadBytes,
            prefetchCache: state.prefetchCache,
            isoState: state.iso
          });
          state.timings.timeSeeking += Date.now() - seekStart;
        }
      } catch (e) {
        const err = await onError(e);
        if (!err.action) {
          throw new Error('onError was used but did not return an "action" field. See docs for this API on how to use onError.');
        }
        if (err.action === "fail") {
          throw e;
        }
        if (err.action === "download") {
          state.errored = e;
          Log.verbose(state.logLevel, "Error was handled by onError and deciding to continue.");
        }
      }
    }
    const timeFreeStart = Date.now();
    await state.discardReadBytes(false);
    state.timings.timeFreeingData += Date.now() - timeFreeStart;
    const didProgress = state.iterator.counter.getOffset() > offsetBefore;
    if (!didProgress) {
      iterationWithThisOffset++;
    } else {
      iterationWithThisOffset = 0;
    }
  }
  state.samplesObserved.setLastSampleObserved();
  await state.callbacks.callTracksDoneCallback();
  if (state.controller._internals.seekSignal.getSeek() !== null) {
    Log.verbose(state.logLevel, "Reached end of samples, but there is a pending seek. Trying to seek...");
    await workOnSeekRequest(getWorkOnSeekRequestOptions(state));
    if (state.controller._internals.seekSignal.getSeek() !== null) {
      throw new Error("Reached the end of the file even though a seek was requested. This is likely a bug in the parser. You can report this at https://remotion.dev/report and we will fix it as soon as possible.");
    }
    await parseLoop({
      onError,
      throttledState,
      state
    });
  }
};
var printTimings = (state) => {
  Log.verbose(state.logLevel, `Time iterating over file: ${state.timings.timeIterating}ms`);
  Log.verbose(state.logLevel, `Time fetching data: ${state.timings.timeReadingData}ms`);
  Log.verbose(state.logLevel, `Time seeking: ${state.timings.timeSeeking}ms`);
  Log.verbose(state.logLevel, `Time checking if done: ${state.timings.timeCheckingIfDone}ms`);
  Log.verbose(state.logLevel, `Time freeing data: ${state.timings.timeFreeingData}ms`);
  Log.verbose(state.logLevel, `Time in parse loop: ${state.timings.timeInParseLoop}ms`);
};
var warningShown = false;
var warnIfRemotionLicenseNotAcknowledged = ({
  acknowledgeRemotionLicense,
  logLevel,
  apiName
}) => {
  if (acknowledgeRemotionLicense) {
    return;
  }
  if (warningShown) {
    return;
  }
  warningShown = true;
  Log.warn(logLevel, `Note: Some companies are required to obtain a license to use @remotion/media-parser. See: https://remotion.dev/license
Pass \`acknowledgeRemotionLicense: true\` to \`${apiName}\` function to make this message disappear.`);
};
var setSeekingHints = ({
  hints,
  state
}) => {
  if (hints.type === "iso-base-media-seeking-hints") {
    setSeekingHintsForMp4({ hints, state });
    return;
  }
  if (hints.type === "wav-seeking-hints") {
    setSeekingHintsForWav({ hints, state });
    return;
  }
  if (hints.type === "transport-stream-seeking-hints") {
    setSeekingHintsForTransportStream({ hints, state });
    return;
  }
  if (hints.type === "webm-seeking-hints") {
    setSeekingHintsForWebm({ hints, state });
    return;
  }
  if (hints.type === "flac-seeking-hints") {
    setSeekingHintsForFlac({ hints, state });
    return;
  }
  if (hints.type === "riff-seeking-hints") {
    setSeekingHintsForRiff({ hints, state });
    return;
  }
  if (hints.type === "mp3-seeking-hints") {
    setSeekingHintsForMp3({ hints, state });
    return;
  }
  if (hints.type === "aac-seeking-hints") {
    setSeekingHintsForAac();
    return;
  }
  if (hints.type === "m3u8-seeking-hints") {
    return;
  }
  throw new Error(`Unknown seeking hints type: ${hints}`);
};
var getFieldsFromCallback = ({
  fields,
  callbacks
}) => {
  const newFields = {
    audioCodec: Boolean(callbacks.onAudioCodec),
    container: Boolean(callbacks.onContainer),
    dimensions: Boolean(callbacks.onDimensions),
    durationInSeconds: Boolean(callbacks.onDurationInSeconds),
    fps: Boolean(callbacks.onFps),
    internalStats: Boolean(callbacks.onInternalStats),
    isHdr: Boolean(callbacks.onIsHdr),
    location: Boolean(callbacks.onLocation),
    metadata: Boolean(callbacks.onMetadata),
    mimeType: Boolean(callbacks.onMimeType),
    name: Boolean(callbacks.onName),
    rotation: Boolean(callbacks.onRotation),
    size: Boolean(callbacks.onSize),
    slowStructure: Boolean(callbacks.onSlowStructure),
    tracks: Boolean(callbacks.onTracks),
    unrotatedDimensions: Boolean(callbacks.onUnrotatedDimensions),
    videoCodec: Boolean(callbacks.onVideoCodec),
    slowKeyframes: Boolean(callbacks.onSlowKeyframes),
    slowDurationInSeconds: Boolean(callbacks.onSlowDurationInSeconds),
    slowFps: Boolean(callbacks.onSlowFps),
    slowNumberOfFrames: Boolean(callbacks.onSlowNumberOfFrames),
    keyframes: Boolean(callbacks.onKeyframes),
    images: Boolean(callbacks.onImages),
    numberOfAudioChannels: Boolean(callbacks.onNumberOfAudioChannels),
    sampleRate: Boolean(callbacks.onSampleRate),
    slowAudioBitrate: Boolean(callbacks.onSlowAudioBitrate),
    slowVideoBitrate: Boolean(callbacks.onSlowVideoBitrate),
    m3uStreams: Boolean(callbacks.onM3uStreams),
    ...fields
  };
  return newFields;
};
var audioSampleMapState = () => {
  let map = [];
  const addSample = (audioSampleOffset) => {
    if (map.find((m) => m.offset === audioSampleOffset.offset)) {
      return;
    }
    map.push(audioSampleOffset);
  };
  return {
    addSample,
    getSamples: () => map,
    setFromSeekingHints: (newMap) => {
      map = newMap;
    }
  };
};
var aacState = () => {
  const samples = [];
  const audioSamples = audioSampleMapState();
  return {
    addSample: ({ offset, size: size4 }) => {
      const index = samples.findIndex((s) => s.offset === offset);
      if (index !== -1) {
        return samples[index];
      }
      samples.push({ offset, index: samples.length, size: size4 });
      return samples[samples.length - 1];
    },
    getSamples: () => samples,
    audioSamples
  };
};
var maxMacroblocksByLevel = {
  10: 396,
  11: 900,
  12: 2376,
  13: 2376,
  20: 2376,
  21: 4752,
  22: 8100,
  30: 8100,
  31: 18000,
  32: 20480,
  40: 32768,
  41: 32768,
  42: 34816,
  50: 110400,
  51: 184320,
  52: 184320,
  60: 696320,
  61: 696320,
  62: 696320
};
var macroBlocksPerFrame = (sps) => {
  const { pic_width_in_mbs_minus1, pic_height_in_map_units_minus1 } = sps;
  return (pic_width_in_mbs_minus1 + 1) * (pic_height_in_map_units_minus1 + 1);
};
var maxMacroblockBufferSize = (sps) => {
  const { level } = sps;
  const maxMacroblocks = maxMacroblocksByLevel[level];
  if (maxMacroblocks === undefined) {
    throw new Error(`Unsupported level: ${level.toString(16)}`);
  }
  return maxMacroblocks;
};
var avcState = () => {
  let prevPicOrderCntLsb = 0;
  let prevPicOrderCntMsb = 0;
  let sps = null;
  let maxFramesInBuffer = null;
  return {
    getPrevPicOrderCntLsb() {
      return prevPicOrderCntLsb;
    },
    getPrevPicOrderCntMsb() {
      return prevPicOrderCntMsb;
    },
    setPrevPicOrderCntLsb(value) {
      prevPicOrderCntLsb = value;
    },
    setPrevPicOrderCntMsb(value) {
      prevPicOrderCntMsb = value;
    },
    setSps(value) {
      const macroblockBufferSize = macroBlocksPerFrame(value);
      const maxBufferSize = maxMacroblockBufferSize(value);
      const maxFrames = Math.min(16, Math.floor(maxBufferSize / macroblockBufferSize));
      maxFramesInBuffer = maxFrames;
      sps = value;
    },
    getSps() {
      return sps;
    },
    getMaxFramesInBuffer() {
      return maxFramesInBuffer;
    },
    clear() {
      maxFramesInBuffer = null;
      sps = null;
      prevPicOrderCntLsb = 0;
      prevPicOrderCntMsb = 0;
    }
  };
};
var currentReader = (initialReader) => {
  let current = initialReader;
  return {
    getCurrent: () => current,
    setCurrent: (newReader) => {
      current = newReader;
    }
  };
};
var emittedState = () => {
  const emittedFields = {
    audioCodec: false,
    container: false,
    dimensions: false,
    durationInSeconds: false,
    fps: false,
    internalStats: false,
    isHdr: false,
    location: false,
    metadata: false,
    mimeType: false,
    name: false,
    rotation: false,
    size: false,
    slowStructure: false,
    tracks: false,
    videoCodec: false,
    unrotatedDimensions: false,
    slowDurationInSeconds: false,
    slowFps: false,
    slowKeyframes: false,
    slowNumberOfFrames: false,
    keyframes: false,
    images: false,
    numberOfAudioChannels: false,
    sampleRate: false,
    slowAudioBitrate: false,
    slowVideoBitrate: false,
    m3uStreams: false
  };
  return emittedFields;
};
var flacState = () => {
  let blockingBitStrategy;
  const audioSamples = audioSampleMapState();
  return {
    setBlockingBitStrategy: (strategy) => {
      blockingBitStrategy = strategy;
    },
    getBlockingBitStrategy: () => blockingBitStrategy,
    audioSamples
  };
};
var imagesState = () => {
  const images = [];
  const addImage = (image) => {
    images.push(image);
  };
  return {
    images,
    addImage
  };
};
var getMfraAtom = async ({
  src,
  contentLength,
  readerInterface,
  controller,
  parentSize,
  logLevel,
  prefetchCache
}) => {
  const result = await readerInterface.read({
    controller,
    range: [contentLength - parentSize, contentLength - 1],
    src,
    logLevel,
    prefetchCache
  });
  const iterator = getArrayBufferIterator({
    initialData: new Uint8Array,
    maxBytes: parentSize,
    logLevel: "error"
  });
  while (true) {
    const res = await result.reader.reader.read();
    if (res.value) {
      iterator.addData(res.value);
    }
    if (res.done) {
      break;
    }
  }
  return iterator;
};
var getMfroAtom = async ({
  src,
  contentLength,
  readerInterface,
  controller,
  logLevel,
  prefetchCache
}) => {
  const result = await readerInterface.read({
    controller,
    range: [contentLength - 16, contentLength - 1],
    src,
    logLevel,
    prefetchCache
  });
  const { value } = await result.reader.reader.read();
  if (!value) {
    return null;
  }
  result.reader.abort();
  const iterator = getArrayBufferIterator({
    initialData: value,
    maxBytes: value.length,
    logLevel: "error"
  });
  const size4 = iterator.getUint32();
  if (size4 !== 16) {
    iterator.destroy();
    return null;
  }
  const atom = iterator.getByteString(4, false);
  if (atom !== "mfro") {
    iterator.destroy();
    return null;
  }
  const version = iterator.getUint8();
  if (version !== 0) {
    iterator.destroy();
    return null;
  }
  iterator.discard(3);
  const parentSize = iterator.getUint32();
  iterator.destroy();
  return parentSize;
};
var getMfraSeekingBox = async ({
  contentLength,
  controller,
  readerInterface,
  src,
  logLevel,
  prefetchCache
}) => {
  const parentSize = await getMfroAtom({
    contentLength,
    controller,
    readerInterface,
    src,
    logLevel,
    prefetchCache
  });
  if (!parentSize) {
    return null;
  }
  const mfraAtom = await getMfraAtom({
    contentLength,
    controller,
    readerInterface,
    src,
    parentSize,
    logLevel,
    prefetchCache
  });
  mfraAtom.discard(8);
  return getIsoBaseMediaChildren({
    iterator: mfraAtom,
    logLevel,
    size: parentSize - 8,
    onlyIfMoovAtomExpected: null,
    contentLength
  });
};
var lazyMfraLoad = ({
  contentLength,
  controller,
  readerInterface,
  src,
  logLevel,
  prefetchCache
}) => {
  let prom = null;
  let result = null;
  const triggerLoad = () => {
    if (prom) {
      return prom;
    }
    Log.verbose(logLevel, "Moof box found, trying to lazy load mfra");
    prom = getMfraSeekingBox({
      contentLength,
      controller,
      readerInterface,
      src,
      logLevel,
      prefetchCache
    }).then((boxes) => {
      Log.verbose(logLevel, boxes ? "Lazily found mfra atom." : "No mfra atom found.");
      result = boxes;
      return boxes;
    });
    return prom;
  };
  const getIfAlreadyLoaded = () => {
    if (result) {
      return result;
    }
    return null;
  };
  const setFromSeekingHints = (hints) => {
    result = hints.mfraAlreadyLoaded;
  };
  return {
    triggerLoad,
    getIfAlreadyLoaded,
    setFromSeekingHints
  };
};
var moovState = () => {
  let moovBox = null;
  return {
    setMoovBox: (moov) => {
      moovBox = moov;
    },
    getMoovBoxAndPrecomputed: () => moovBox
  };
};
var movieTimeScaleState = () => {
  let trackTimescale = null;
  return {
    getTrackTimescale: () => trackTimescale,
    setTrackTimescale: (timescale) => {
      trackTimescale = timescale;
    }
  };
};
var isoBaseMediaState = ({
  contentLength,
  controller,
  readerInterface,
  src,
  logLevel,
  prefetchCache
}) => {
  return {
    flatSamples: cachedSamplePositionsState(),
    moov: moovState(),
    mfra: lazyMfraLoad({
      contentLength,
      controller,
      readerInterface,
      src,
      logLevel,
      prefetchCache
    }),
    moof: precomputedMoofState(),
    tfra: precomputedTfraState(),
    movieTimeScale: movieTimeScaleState()
  };
};
var keyframesState = () => {
  const keyframes = [];
  const addKeyframe = (keyframe) => {
    if (keyframes.find((k) => k.positionInBytes === keyframe.positionInBytes)) {
      return;
    }
    keyframes.push(keyframe);
  };
  const getKeyframes2 = () => {
    keyframes.sort((a, b) => a.positionInBytes - b.positionInBytes);
    return keyframes;
  };
  const setFromSeekingHints = (keyframesFromHints) => {
    for (const keyframe of keyframesFromHints) {
      addKeyframe(keyframe);
    }
  };
  return {
    addKeyframe,
    getKeyframes: getKeyframes2,
    setFromSeekingHints
  };
};
var sampleSorter = ({
  logLevel,
  getAllChunksProcessedForPlaylist
}) => {
  const streamsWithTracks = [];
  const audioCallbacks = {};
  const videoCallbacks = {};
  let latestSample = {};
  return {
    clearSamples: () => {
      latestSample = {};
    },
    addToStreamWithTrack: (src) => {
      streamsWithTracks.push(src);
    },
    addVideoStreamToConsider: (src, callback) => {
      videoCallbacks[src] = callback;
    },
    addAudioStreamToConsider: (src, callback) => {
      audioCallbacks[src] = callback;
    },
    hasAudioStreamToConsider: (src) => {
      return Boolean(audioCallbacks[src]);
    },
    hasVideoStreamToConsider: (src) => {
      return Boolean(videoCallbacks[src]);
    },
    addAudioSample: async (src, sample) => {
      const callback = audioCallbacks[src];
      if (!callback) {
        throw new Error("No callback found for audio sample");
      }
      latestSample[src] = sample.decodingTimestamp;
      await callback(sample);
    },
    addVideoSample: async (src, sample) => {
      const callback = videoCallbacks[src];
      if (!callback) {
        throw new Error("No callback found for video sample.");
      }
      latestSample[src] = sample.decodingTimestamp;
      await callback(sample);
    },
    getNextStreamToRun: (streams) => {
      for (const stream of streams) {
        if (getAllChunksProcessedForPlaylist(stream)) {
          continue;
        }
        if (!streamsWithTracks.includes(stream)) {
          Log.trace(logLevel, `Did not yet detect track of ${stream}, working on that`);
          return stream;
        }
      }
      let smallestDts = Infinity;
      for (const stream of streams) {
        if (getAllChunksProcessedForPlaylist(stream)) {
          continue;
        }
        if ((latestSample[stream] ?? 0) < smallestDts) {
          smallestDts = latestSample[stream] ?? 0;
        }
      }
      for (const stream of streams) {
        if (getAllChunksProcessedForPlaylist(stream)) {
          continue;
        }
        if ((latestSample[stream] ?? 0) === smallestDts) {
          Log.trace(logLevel, `Working on ${stream} because it has the smallest DTS`);
          return stream;
        }
      }
      throw new Error("should be done with parsing now");
    }
  };
};
var m3uState = (logLevel) => {
  let selectedMainPlaylist = null;
  let associatedPlaylists = null;
  const hasEmittedVideoTrack = {};
  const hasEmittedAudioTrack = {};
  const hasEmittedDoneWithTracks = {};
  let hasFinishedManifest = false;
  const seekToSecondsToProcess = {};
  const nextSeekShouldSubtractChunks = {};
  let readyToIterateOverM3u = false;
  const allChunksProcessed = {};
  const m3uStreamRuns = {};
  const tracksDone = {};
  const getMainPlaylistUrl = () => {
    if (!selectedMainPlaylist) {
      throw new Error("No main playlist selected");
    }
    const playlistUrl = selectedMainPlaylist.type === "initial-url" ? selectedMainPlaylist.url : selectedMainPlaylist.stream.src;
    return playlistUrl;
  };
  const getSelectedPlaylists = () => {
    return [
      getMainPlaylistUrl(),
      ...(associatedPlaylists ?? []).map((p) => p.src)
    ];
  };
  const getAllChunksProcessedForPlaylist = (src) => allChunksProcessed[src];
  const mp4HeaderSegments = {};
  const setMp4HeaderSegment = (playlistUrl, structure) => {
    mp4HeaderSegments[playlistUrl] = structure;
  };
  const getMp4HeaderSegment = (playlistUrl) => {
    return mp4HeaderSegments[playlistUrl];
  };
  return {
    setSelectedMainPlaylist: (stream) => {
      selectedMainPlaylist = stream;
    },
    getSelectedMainPlaylist: () => selectedMainPlaylist,
    setHasEmittedVideoTrack: (src, callback) => {
      hasEmittedVideoTrack[src] = callback;
    },
    hasEmittedVideoTrack: (src) => {
      const value = hasEmittedVideoTrack[src];
      if (value === undefined) {
        return false;
      }
      return value;
    },
    setHasEmittedAudioTrack: (src, callback) => {
      hasEmittedAudioTrack[src] = callback;
    },
    hasEmittedAudioTrack: (src) => {
      const value = hasEmittedAudioTrack[src];
      if (value === undefined) {
        return false;
      }
      return value;
    },
    setHasEmittedDoneWithTracks: (src) => {
      hasEmittedDoneWithTracks[src] = true;
    },
    hasEmittedDoneWithTracks: (src) => hasEmittedDoneWithTracks[src] !== undefined,
    setReadyToIterateOverM3u: () => {
      readyToIterateOverM3u = true;
    },
    isReadyToIterateOverM3u: () => readyToIterateOverM3u,
    setAllChunksProcessed: (src) => {
      allChunksProcessed[src] = true;
    },
    clearAllChunksProcessed: () => {
      Object.keys(allChunksProcessed).forEach((key4) => {
        delete allChunksProcessed[key4];
      });
    },
    getAllChunksProcessedForPlaylist,
    getAllChunksProcessedOverall: () => {
      if (!selectedMainPlaylist) {
        return false;
      }
      const selectedPlaylists = getSelectedPlaylists();
      return selectedPlaylists.every((url) => allChunksProcessed[url]);
    },
    setHasFinishedManifest: () => {
      hasFinishedManifest = true;
    },
    hasFinishedManifest: () => hasFinishedManifest,
    setM3uStreamRun: (playlistUrl, run) => {
      if (!run) {
        delete m3uStreamRuns[playlistUrl];
        return;
      }
      m3uStreamRuns[playlistUrl] = run;
    },
    setTracksDone: (playlistUrl) => {
      tracksDone[playlistUrl] = true;
      const selectedPlaylists = getSelectedPlaylists();
      return selectedPlaylists.every((url) => tracksDone[url]);
    },
    getTrackDone: (playlistUrl) => {
      return tracksDone[playlistUrl];
    },
    clearTracksDone: () => {
      Object.keys(tracksDone).forEach((key4) => {
        delete tracksDone[key4];
      });
    },
    getM3uStreamRun: (playlistUrl) => m3uStreamRuns[playlistUrl] ?? null,
    abortM3UStreamRuns: () => {
      const values = Object.values(m3uStreamRuns);
      if (values.length === 0) {
        return;
      }
      Log.trace(logLevel, `Aborting ${values.length} M3U stream runs`);
      values.forEach((run) => {
        run.abort();
      });
    },
    setAssociatedPlaylists: (playlists) => {
      associatedPlaylists = playlists;
    },
    getAssociatedPlaylists: () => associatedPlaylists,
    getSelectedPlaylists,
    sampleSorter: sampleSorter({ logLevel, getAllChunksProcessedForPlaylist }),
    setMp4HeaderSegment,
    getMp4HeaderSegment,
    setSeekToSecondsToProcess: (playlistUrl, m3uSeek) => {
      seekToSecondsToProcess[playlistUrl] = m3uSeek;
    },
    getSeekToSecondsToProcess: (playlistUrl) => seekToSecondsToProcess[playlistUrl] ?? null,
    setNextSeekShouldSubtractChunks: (playlistUrl, chunks) => {
      nextSeekShouldSubtractChunks[playlistUrl] = chunks;
    },
    getNextSeekShouldSubtractChunks: (playlistUrl) => nextSeekShouldSubtractChunks[playlistUrl] ?? 0
  };
};
var formatCues = (cues) => {
  const matroskaCues = [];
  for (const cue of cues) {
    if (cue.type === "Crc32") {
      continue;
    }
    if (cue.type !== "CuePoint") {
      throw new Error("Expected CuePoint");
    }
    const cueTime = cue.value.find((_cue) => _cue.type === "CueTime");
    if (!cueTime) {
      throw new Error("Expected CueTime");
    }
    const cueTrackPositions = cue.value.find((c) => c.type === "CueTrackPositions");
    if (!cueTrackPositions) {
      throw new Error("Expected CueTrackPositions");
    }
    const cueTimeValue = cueTime.value.value;
    const cueTrack = cueTrackPositions.value.find((_c) => _c.type === "CueTrack");
    if (!cueTrack) {
      throw new Error("Expected CueTrack");
    }
    const cueClusterPosition = cueTrackPositions.value.find((_c) => _c.type === "CueClusterPosition");
    if (!cueClusterPosition) {
      throw new Error("Expected CueClusterPosition");
    }
    const cueRelativePosition = cueTrackPositions.value.find((_c) => _c.type === "CueRelativePosition");
    const matroskaCue = {
      trackId: cueTrack.value.value,
      timeInTimescale: cueTimeValue,
      clusterPositionInSegment: cueClusterPosition.value.value,
      relativePosition: cueRelativePosition?.value.value ?? 0
    };
    matroskaCues.push(matroskaCue);
  }
  return matroskaCues;
};
var fetchWebmCues = async ({
  src,
  readerInterface,
  controller,
  position,
  logLevel,
  prefetchCache
}) => {
  const result = await readerInterface.read({
    controller,
    range: position,
    src,
    logLevel,
    prefetchCache
  });
  const { value } = await result.reader.reader.read();
  if (!value) {
    return null;
  }
  result.reader.abort();
  const iterator = getArrayBufferIterator({
    initialData: value,
    maxBytes: value.length,
    logLevel: "error"
  });
  const segment = await expectSegment({
    iterator,
    logLevel,
    statesForProcessing: null,
    isInsideSegment: null,
    mediaSectionState: null
  });
  iterator.destroy();
  if (!segment?.value) {
    return null;
  }
  return formatCues(segment.value);
};
var lazyCuesFetch = ({
  controller,
  logLevel,
  readerInterface,
  src,
  prefetchCache
}) => {
  let prom = null;
  let sOffset = null;
  let result = null;
  const triggerLoad = (position, segmentOffset) => {
    if (result) {
      return Promise.resolve(result);
    }
    if (prom) {
      return prom;
    }
    if (sOffset && sOffset !== segmentOffset) {
      throw new Error("Segment offset mismatch");
    }
    sOffset = segmentOffset;
    Log.verbose(logLevel, "Cues box found, trying to lazy load cues");
    prom = fetchWebmCues({
      controller,
      logLevel,
      position,
      readerInterface,
      src,
      prefetchCache
    }).then((cues) => {
      Log.verbose(logLevel, "Cues loaded");
      result = cues;
      return cues;
    });
    return prom;
  };
  const getLoadedCues = async () => {
    if (!prom) {
      return null;
    }
    if (result) {
      if (!sOffset) {
        throw new Error("Segment offset not set");
      }
      return {
        cues: result,
        segmentOffset: sOffset
      };
    }
    const cues = await prom;
    if (!cues) {
      return null;
    }
    if (!sOffset) {
      throw new Error("Segment offset not set");
    }
    return {
      cues,
      segmentOffset: sOffset
    };
  };
  const getIfAlreadyLoaded = () => {
    if (result) {
      if (sOffset === null) {
        throw new Error("Segment offset not set");
      }
      return {
        cues: result,
        segmentOffset: sOffset
      };
    }
    return null;
  };
  const setFromSeekingHints = (hints) => {
    result = hints.loadedCues?.cues ?? null;
    sOffset = hints.loadedCues?.segmentOffset ?? null;
  };
  return {
    triggerLoad,
    getLoadedCues,
    getIfAlreadyLoaded,
    setFromSeekingHints
  };
};
var webmState = ({
  controller,
  logLevel,
  readerInterface,
  src,
  prefetchCache
}) => {
  const trackEntries = {};
  const onTrackEntrySegment = (trackEntry2) => {
    const trackId = getTrackId(trackEntry2);
    if (!trackId) {
      throw new Error("Expected track id");
    }
    if (trackEntries[trackId]) {
      return;
    }
    const codec = getTrackCodec(trackEntry2);
    if (!codec) {
      throw new Error("Expected codec");
    }
    const trackTimescale = getTrackTimestampScale(trackEntry2);
    trackEntries[trackId] = {
      codec: codec.value,
      trackTimescale: trackTimescale?.value ?? null
    };
  };
  let timestampMap = new Map;
  const getTimestampOffsetForByteOffset = (byteOffset) => {
    const entries = Array.from(timestampMap.entries());
    const sortedByByteOffset = entries.sort((a, b) => {
      return a[0] - b[0];
    }).reverse();
    for (const [offset, timestamp] of sortedByByteOffset) {
      if (offset >= byteOffset) {
        continue;
      }
      return timestamp;
    }
    return timestampMap.get(byteOffset);
  };
  const setTimestampOffset = (byteOffset, timestamp) => {
    timestampMap.set(byteOffset, timestamp);
  };
  let timescale = null;
  const setTimescale = (newTimescale) => {
    timescale = newTimescale;
  };
  const getTimescale = () => {
    if (timescale === null) {
      return 1e6;
    }
    return timescale;
  };
  const segments = [];
  const clusters = [];
  const avcProfilesMap = {};
  const setAvcProfileForTrackNumber = (trackNumber2, avcProfile) => {
    avcProfilesMap[trackNumber2] = avcProfile;
  };
  const getAvcProfileForTrackNumber = (trackNumber2) => {
    return avcProfilesMap[trackNumber2] ?? null;
  };
  const cues = lazyCuesFetch({
    controller,
    logLevel,
    readerInterface,
    src,
    prefetchCache
  });
  const getTimeStampMapForSeekingHints = () => {
    return timestampMap;
  };
  const setTimeStampMapForSeekingHints = (newTimestampMap) => {
    timestampMap = newTimestampMap;
  };
  return {
    cues,
    onTrackEntrySegment,
    getTrackInfoByNumber: (id) => trackEntries[id],
    setTimestampOffset,
    getTimestampOffsetForByteOffset,
    getTimeStampMapForSeekingHints,
    setTimeStampMapForSeekingHints,
    getTimescale,
    setTimescale,
    addSegment: (seg) => {
      const segment = {
        ...seg,
        index: segments.length
      };
      segments.push(segment);
    },
    addCluster: (cluster) => {
      const exists = clusters.some((existingCluster) => existingCluster.start === cluster.start);
      if (!exists) {
        clusters.push(cluster);
      }
    },
    getFirstCluster: () => {
      return clusters.find((cluster) => cluster.segment === 0);
    },
    isInsideSegment: (iterator) => {
      const offset = iterator.counter.getOffset();
      const insideClusters = segments.filter((cluster) => {
        return offset >= cluster.start && offset <= cluster.start + cluster.size;
      });
      if (insideClusters.length > 1) {
        throw new Error("Expected to only be inside 1 cluster");
      }
      return insideClusters[0] ?? null;
    },
    isInsideCluster: (offset) => {
      for (const cluster of clusters) {
        if (offset >= cluster.start && offset < cluster.start + cluster.size) {
          return cluster;
        }
      }
      return null;
    },
    setAvcProfileForTrackNumber,
    getAvcProfileForTrackNumber
  };
};
var makeMp3State = () => {
  let mp3Info = null;
  let bitrateInfo = null;
  const audioSamples = audioSampleMapState();
  return {
    getMp3Info: () => mp3Info,
    setMp3Info: (info) => {
      mp3Info = info;
    },
    getMp3BitrateInfo: () => bitrateInfo,
    setMp3BitrateInfo: (info) => {
      bitrateInfo = info;
    },
    audioSamples
  };
};
var fetchIdx1 = async ({
  src,
  readerInterface,
  controller,
  position,
  logLevel,
  prefetchCache,
  contentLength
}) => {
  Log.verbose(logLevel, "Making request to fetch idx1 from ", src, "position", position);
  const result = await readerInterface.read({
    controller,
    range: position,
    src,
    logLevel,
    prefetchCache
  });
  if (result.contentLength === null) {
    throw new Error("Content length is null");
  }
  const iterator = getArrayBufferIterator({
    initialData: new Uint8Array,
    maxBytes: contentLength - position + 1,
    logLevel: "error"
  });
  while (true) {
    const res = await result.reader.reader.read();
    if (res.value) {
      iterator.addData(res.value);
    }
    if (res.done) {
      break;
    }
  }
  const box2 = await expectRiffBox({
    iterator,
    stateIfExpectingSideEffects: null
  });
  iterator.destroy();
  if (box2 === null || box2.type !== "idx1-box") {
    throw new Error("Expected idx1-box");
  }
  return {
    entries: box2.entries.filter((entry) => entry.id.endsWith("dc")),
    videoTrackIndex: box2.videoTrackIndex
  };
};
var lazyIdx1Fetch = ({
  controller,
  logLevel,
  readerInterface,
  src,
  prefetchCache,
  contentLength
}) => {
  let prom = null;
  let result = null;
  const triggerLoad = (position) => {
    if (result) {
      return Promise.resolve(result);
    }
    if (prom) {
      return prom;
    }
    prom = fetchIdx1({
      controller,
      logLevel,
      position,
      readerInterface,
      src,
      prefetchCache,
      contentLength
    }).then((entries) => {
      prom = null;
      result = entries;
      return entries;
    });
    return prom;
  };
  const getLoadedIdx1 = async () => {
    if (!prom) {
      return null;
    }
    const entries = await prom;
    return entries;
  };
  const getIfAlreadyLoaded = () => {
    if (result) {
      return result;
    }
    return null;
  };
  const setFromSeekingHints = (hints) => {
    if (hints.idx1Entries) {
      result = hints.idx1Entries;
    }
  };
  const waitForLoaded = () => {
    if (result) {
      return Promise.resolve(result);
    }
    if (prom) {
      return prom;
    }
    return Promise.resolve(null);
  };
  return {
    triggerLoad,
    getLoadedIdx1,
    getIfAlreadyLoaded,
    setFromSeekingHints,
    waitForLoaded
  };
};
var queuedBFramesState = () => {
  const queuedFrames = [];
  const releasedFrames = [];
  const flush = () => {
    releasedFrames.push(...queuedFrames);
    queuedFrames.length = 0;
  };
  return {
    addFrame: ({
      frame: frame2,
      maxFramesInBuffer,
      trackId,
      timescale
    }) => {
      if (frame2.type === "key") {
        flush();
        releasedFrames.push({ sample: frame2, trackId, timescale });
        return;
      }
      queuedFrames.push({ sample: frame2, trackId, timescale });
      if (queuedFrames.length > maxFramesInBuffer) {
        releasedFrames.push(queuedFrames.shift());
      }
    },
    flush,
    getReleasedFrame: () => {
      if (releasedFrames.length === 0) {
        return null;
      }
      return releasedFrames.shift();
    },
    hasReleasedFrames: () => {
      return releasedFrames.length > 0;
    },
    clear: () => {
      releasedFrames.length = 0;
      queuedFrames.length = 0;
    }
  };
};
var riffKeyframesState = () => {
  const keyframes = [];
  const addKeyframe = (keyframe) => {
    if (keyframes.find((k) => k.positionInBytes === keyframe.positionInBytes)) {
      return;
    }
    keyframes.push(keyframe);
    keyframes.sort((a, b) => a.positionInBytes - b.positionInBytes);
  };
  const getKeyframes2 = () => {
    return keyframes;
  };
  const setFromSeekingHints = (keyframesFromHints) => {
    for (const keyframe of keyframesFromHints) {
      addKeyframe(keyframe);
    }
  };
  return {
    addKeyframe,
    getKeyframes: getKeyframes2,
    setFromSeekingHints
  };
};
var riffSampleCounter = () => {
  const samplesForTrack = {};
  const pocsAtKeyframeOffset = {};
  const riffKeys = riffKeyframesState();
  const onAudioSample = (trackId, audioSample) => {
    if (typeof samplesForTrack[trackId] === "undefined") {
      samplesForTrack[trackId] = 0;
    }
    if (audioSample.data.length > 0) {
      samplesForTrack[trackId]++;
    }
    samplesForTrack[trackId]++;
  };
  const onVideoSample = ({
    trackId,
    videoSample
  }) => {
    if (typeof samplesForTrack[trackId] === "undefined") {
      samplesForTrack[trackId] = 0;
    }
    if (videoSample.type === "key") {
      riffKeys.addKeyframe({
        trackId,
        decodingTimeInSeconds: videoSample.decodingTimestamp / WEBCODECS_TIMESCALE,
        positionInBytes: videoSample.offset,
        presentationTimeInSeconds: videoSample.timestamp / WEBCODECS_TIMESCALE,
        sizeInBytes: videoSample.data.length,
        sampleCounts: { ...samplesForTrack }
      });
    }
    if (videoSample.data.length > 0) {
      samplesForTrack[trackId]++;
    }
  };
  const getSampleCountForTrack = ({ trackId }) => {
    return samplesForTrack[trackId] ?? 0;
  };
  const setSamplesFromSeek = (samples) => {
    for (const trackId in samples) {
      samplesForTrack[trackId] = samples[trackId];
    }
  };
  const setPocAtKeyframeOffset = ({
    keyframeOffset,
    poc
  }) => {
    if (typeof pocsAtKeyframeOffset[keyframeOffset] === "undefined") {
      pocsAtKeyframeOffset[keyframeOffset] = [];
    }
    if (pocsAtKeyframeOffset[keyframeOffset].includes(poc)) {
      return;
    }
    pocsAtKeyframeOffset[keyframeOffset].push(poc);
    pocsAtKeyframeOffset[keyframeOffset].sort((a, b) => a - b);
  };
  const getPocAtKeyframeOffset = ({
    keyframeOffset
  }) => {
    return pocsAtKeyframeOffset[keyframeOffset];
  };
  const getKeyframeAtOffset = (sample) => {
    if (sample.type === "key") {
      return sample.offset;
    }
    return riffKeys.getKeyframes().findLast((k) => k.positionInBytes <= sample.offset)?.positionInBytes ?? null;
  };
  return {
    onAudioSample,
    onVideoSample,
    getSampleCountForTrack,
    setSamplesFromSeek,
    riffKeys,
    setPocAtKeyframeOffset,
    getPocAtKeyframeOffset,
    getKeyframeAtOffset
  };
};
var riffSpecificState = ({
  controller,
  logLevel,
  readerInterface,
  src,
  prefetchCache,
  contentLength
}) => {
  let avcProfile = null;
  let nextTrackIndex = 0;
  const profileCallbacks = [];
  const registerOnAvcProfileCallback = (callback) => {
    profileCallbacks.push(callback);
  };
  const onProfile = async (profile) => {
    avcProfile = profile;
    for (const callback of profileCallbacks) {
      await callback(profile);
    }
    profileCallbacks.length = 0;
  };
  const lazyIdx1 = lazyIdx1Fetch({
    controller,
    logLevel,
    readerInterface,
    src,
    prefetchCache,
    contentLength
  });
  const sampleCounter = riffSampleCounter();
  const queuedBFrames = queuedBFramesState();
  return {
    getAvcProfile: () => {
      return avcProfile;
    },
    onProfile,
    registerOnAvcProfileCallback,
    getNextTrackIndex: () => {
      return nextTrackIndex;
    },
    queuedBFrames,
    incrementNextTrackIndex: () => {
      nextTrackIndex++;
    },
    lazyIdx1,
    sampleCounter
  };
};
var callbacksState = ({
  controller,
  hasAudioTrackHandlers,
  hasVideoTrackHandlers,
  fields,
  keyframes,
  emittedFields,
  samplesObserved,
  structure,
  src,
  seekSignal,
  logLevel
}) => {
  const videoSampleCallbacks = {};
  const audioSampleCallbacks = {};
  const onTrackDoneCallback = {};
  const queuedAudioSamples = {};
  const queuedVideoSamples = {};
  const canSkipTracksState = makeCanSkipTracksState({
    hasAudioTrackHandlers,
    fields,
    hasVideoTrackHandlers,
    structure
  });
  const tracksState = makeTracksSectionState(canSkipTracksState, src);
  return {
    registerVideoSampleCallback: async (id, callback) => {
      if (callback === null) {
        delete videoSampleCallbacks[id];
        return;
      }
      videoSampleCallbacks[id] = callback;
      for (const queued of queuedVideoSamples[id] ?? []) {
        await callback(queued);
      }
      queuedVideoSamples[id] = [];
    },
    onAudioSample: async ({
      audioSample,
      trackId
    }) => {
      if (controller._internals.signal.aborted) {
        throw new Error("Aborted");
      }
      const callback = audioSampleCallbacks[trackId];
      if (audioSample.data.length > 0) {
        if (callback) {
          if (seekSignal.getSeek() !== null) {
            Log.trace(logLevel, "Not emitting sample because seek is processing");
          } else {
            const trackDoneCallback = await callback(audioSample);
            onTrackDoneCallback[trackId] = trackDoneCallback ?? null;
          }
        }
      }
      if (needsToIterateOverSamples({ emittedFields, fields })) {
        samplesObserved.addAudioSample(audioSample);
      }
    },
    onVideoSample: async ({
      trackId,
      videoSample
    }) => {
      if (controller._internals.signal.aborted) {
        throw new Error("Aborted");
      }
      if (videoSample.data.length > 0) {
        const callback = videoSampleCallbacks[trackId];
        if (callback) {
          if (seekSignal.getSeek() !== null) {
            Log.trace(logLevel, "Not emitting sample because seek is processing");
          } else {
            const trackDoneCallback = await callback(videoSample);
            onTrackDoneCallback[trackId] = trackDoneCallback ?? null;
          }
        }
      }
      if (videoSample.type === "key") {
        keyframes.addKeyframe({
          trackId,
          decodingTimeInSeconds: videoSample.decodingTimestamp / WEBCODECS_TIMESCALE,
          positionInBytes: videoSample.offset,
          presentationTimeInSeconds: videoSample.timestamp / WEBCODECS_TIMESCALE,
          sizeInBytes: videoSample.data.length
        });
      }
      if (needsToIterateOverSamples({
        fields,
        emittedFields
      })) {
        samplesObserved.addVideoSample(videoSample);
      }
    },
    canSkipTracksState,
    registerAudioSampleCallback: async (id, callback) => {
      if (callback === null) {
        delete audioSampleCallbacks[id];
        return;
      }
      audioSampleCallbacks[id] = callback;
      for (const queued of queuedAudioSamples[id] ?? []) {
        await callback(queued);
      }
      queuedAudioSamples[id] = [];
    },
    tracks: tracksState,
    audioSampleCallbacks,
    videoSampleCallbacks,
    hasAudioTrackHandlers,
    hasVideoTrackHandlers,
    callTracksDoneCallback: async () => {
      for (const callback of Object.values(onTrackDoneCallback)) {
        if (callback) {
          await callback();
        }
      }
    }
  };
};
var samplesObservedState = () => {
  let smallestVideoSample;
  let largestVideoSample;
  let smallestAudioSample;
  let largestAudioSample;
  let lastSampleObserved = false;
  const videoSamples = new Map;
  const audioSamples = new Map;
  const getSlowVideoDurationInSeconds = () => {
    return (largestVideoSample ?? 0) - (smallestVideoSample ?? 0);
  };
  const getSlowAudioDurationInSeconds = () => {
    return (largestAudioSample ?? 0) - (smallestAudioSample ?? 0);
  };
  const getSlowDurationInSeconds = () => {
    const smallestSample = Math.min(smallestAudioSample ?? Infinity, smallestVideoSample ?? Infinity);
    const largestSample = Math.max(largestAudioSample ?? 0, largestVideoSample ?? 0);
    if (smallestSample === Infinity || largestSample === Infinity) {
      return 0;
    }
    return largestSample - smallestSample;
  };
  const addVideoSample = (videoSample) => {
    videoSamples.set(videoSample.timestamp, videoSample.data.byteLength);
    const presentationTimeInSeconds = videoSample.timestamp / WEBCODECS_TIMESCALE;
    const duration2 = (videoSample.duration ?? 0) / WEBCODECS_TIMESCALE;
    if (largestVideoSample === undefined || presentationTimeInSeconds > largestVideoSample) {
      largestVideoSample = presentationTimeInSeconds + duration2;
    }
    if (smallestVideoSample === undefined || presentationTimeInSeconds < smallestVideoSample) {
      smallestVideoSample = presentationTimeInSeconds;
    }
  };
  const addAudioSample = (audioSample) => {
    audioSamples.set(audioSample.timestamp, audioSample.data.byteLength);
    const presentationTimeInSeconds = audioSample.timestamp / WEBCODECS_TIMESCALE;
    const duration2 = (audioSample.duration ?? 0) / WEBCODECS_TIMESCALE;
    if (largestAudioSample === undefined || presentationTimeInSeconds > largestAudioSample) {
      largestAudioSample = presentationTimeInSeconds + duration2;
    }
    if (smallestAudioSample === undefined || presentationTimeInSeconds < smallestAudioSample) {
      smallestAudioSample = presentationTimeInSeconds;
    }
  };
  const getFps2 = () => {
    const videoDuration = (largestVideoSample ?? 0) - (smallestVideoSample ?? 0);
    if (videoDuration === 0) {
      return 0;
    }
    return (videoSamples.size - 1) / videoDuration;
  };
  const getSlowNumberOfFrames = () => videoSamples.size;
  const getAudioBitrate = () => {
    const audioDuration = getSlowAudioDurationInSeconds();
    if (audioDuration === 0 || audioSamples.size === 0) {
      return null;
    }
    const audioSizesInBytes = Array.from(audioSamples.values()).reduce((acc, size4) => acc + size4, 0);
    return audioSizesInBytes * 8 / audioDuration;
  };
  const getVideoBitrate = () => {
    const videoDuration = getSlowVideoDurationInSeconds();
    if (videoDuration === 0 || videoSamples.size === 0) {
      return null;
    }
    const videoSizesInBytes = Array.from(videoSamples.values()).reduce((acc, size4) => acc + size4, 0);
    return videoSizesInBytes * 8 / videoDuration;
  };
  const getLastSampleObserved = () => lastSampleObserved;
  const setLastSampleObserved = () => {
    lastSampleObserved = true;
  };
  return {
    addVideoSample,
    addAudioSample,
    getSlowDurationInSeconds,
    getFps: getFps2,
    getSlowNumberOfFrames,
    getAudioBitrate,
    getVideoBitrate,
    getLastSampleObserved,
    setLastSampleObserved,
    getAmountOfSamplesObserved: () => videoSamples.size + audioSamples.size
  };
};
var seekInfiniteLoopDetectionState = () => {
  let lastSeek = null;
  let firstSeekTime = null;
  return {
    registerSeek: (byte) => {
      const now = Date.now();
      if (!lastSeek || lastSeek.byte !== byte) {
        lastSeek = { byte, numberOfTimes: 1 };
        firstSeekTime = now;
        return;
      }
      lastSeek.numberOfTimes++;
      if (lastSeek.numberOfTimes >= 10 && firstSeekTime && now - firstSeekTime <= 2000) {
        throw new Error(`Seeking infinite loop detected: Seeked to byte 0x${byte.toString(16)} ${lastSeek.numberOfTimes} times in a row in the last 2 seconds. Check your usage of .seek().`);
      }
      if (now - firstSeekTime > 2000) {
        lastSeek = { byte, numberOfTimes: 1 };
        firstSeekTime = now;
      }
    },
    reset: () => {
      lastSeek = null;
      firstSeekTime = null;
    }
  };
};
var timingsState = () => {
  return {
    timeIterating: 0,
    timeReadingData: 0,
    timeSeeking: 0,
    timeCheckingIfDone: 0,
    timeFreeingData: 0,
    timeInParseLoop: 0
  };
};
var lastEmittedSampleState = () => {
  let lastEmittedSample = null;
  return {
    setLastEmittedSample: (sample) => {
      lastEmittedSample = sample;
    },
    getLastEmittedSample: () => lastEmittedSample,
    resetLastEmittedSample: () => {
      lastEmittedSample = null;
    }
  };
};
var makeNextPesHeaderStore = () => {
  let nextPesHeader = null;
  return {
    setNextPesHeader: (pesHeader) => {
      nextPesHeader = pesHeader;
    },
    getNextPesHeader: () => {
      if (!nextPesHeader) {
        throw new Error("No next PES header found");
      }
      return nextPesHeader;
    }
  };
};
var ptsStartOffsetStore = () => {
  const offsets = {};
  return {
    getOffset: (trackId) => offsets[trackId] || 0,
    setOffset: ({ newOffset, trackId }) => {
      offsets[trackId] = newOffset;
    }
  };
};
var transportStreamState = () => {
  const streamBuffers = new Map;
  const startOffset = ptsStartOffsetStore();
  const lastEmittedSample = lastEmittedSampleState();
  const state = {
    nextPesHeaderStore: makeNextPesHeaderStore(),
    observedPesHeaders: makeObservedPesHeader(),
    streamBuffers,
    startOffset,
    resetBeforeSeek: () => {
      state.streamBuffers.clear();
      state.nextPesHeaderStore = makeNextPesHeaderStore();
    },
    lastEmittedSample
  };
  return state;
};
var makeParserState = ({
  hasAudioTrackHandlers,
  hasVideoTrackHandlers,
  controller,
  onAudioTrack,
  onVideoTrack,
  contentLength,
  logLevel,
  mode,
  src,
  readerInterface,
  onDiscardedData,
  selectM3uStreamFn,
  selectM3uAssociatedPlaylistsFn,
  m3uPlaylistContext,
  contentType,
  name,
  callbacks,
  fieldsInReturnValue,
  mimeType,
  initialReaderInstance,
  makeSamplesStartAtZero,
  prefetchCache
}) => {
  let skippedBytes = 0;
  const returnValue = {};
  const iterator = getArrayBufferIterator({
    initialData: new Uint8Array([]),
    maxBytes: contentLength,
    logLevel
  });
  const increaseSkippedBytes = (bytes) => {
    skippedBytes += bytes;
  };
  const structure = structureState();
  const keyframes = keyframesState();
  const emittedFields = emittedState();
  const samplesObserved = samplesObservedState();
  const mp3 = makeMp3State();
  const images = imagesState();
  const timings = timingsState();
  const seekInfiniteLoop = seekInfiniteLoopDetectionState();
  const currentReaderState = currentReader(initialReaderInstance);
  const avc = avcState();
  const errored = null;
  const discardReadBytes = async (force) => {
    const { bytesRemoved, removedData } = iterator.removeBytesRead(force, mode);
    if (bytesRemoved) {
      Log.verbose(logLevel, `Freed ${bytesRemoved} bytes`);
    }
    if (removedData && onDiscardedData) {
      await onDiscardedData(removedData);
    }
  };
  const fields = getFieldsFromCallback({
    fields: fieldsInReturnValue,
    callbacks
  });
  const mediaSection = mediaSectionState();
  return {
    riff: riffSpecificState({
      controller,
      logLevel,
      readerInterface,
      src,
      prefetchCache,
      contentLength
    }),
    transportStream: transportStreamState(),
    webm: webmState({
      controller,
      logLevel,
      readerInterface,
      src,
      prefetchCache
    }),
    iso: isoBaseMediaState({
      contentLength,
      controller,
      readerInterface,
      src,
      logLevel,
      prefetchCache
    }),
    mp3,
    aac: aacState(),
    flac: flacState(),
    m3u: m3uState(logLevel),
    timings,
    callbacks: callbacksState({
      controller,
      hasAudioTrackHandlers,
      hasVideoTrackHandlers,
      fields,
      keyframes,
      emittedFields,
      samplesObserved,
      structure,
      src,
      seekSignal: controller._internals.seekSignal,
      logLevel
    }),
    getInternalStats: () => ({
      skippedBytes,
      finalCursorOffset: iterator.counter.getOffset() ?? 0
    }),
    getSkipBytes: () => skippedBytes,
    increaseSkippedBytes,
    keyframes,
    structure,
    onAudioTrack,
    onVideoTrack,
    emittedFields,
    fields,
    samplesObserved,
    contentLength,
    images,
    mediaSection,
    logLevel,
    iterator,
    controller,
    mode,
    src,
    readerInterface,
    discardReadBytes,
    selectM3uStreamFn,
    selectM3uAssociatedPlaylistsFn,
    m3uPlaylistContext,
    contentType,
    name,
    returnValue,
    callbackFunctions: callbacks,
    fieldsInReturnValue,
    mimeType,
    errored,
    currentReader: currentReaderState,
    seekInfiniteLoop,
    makeSamplesStartAtZero,
    prefetchCache,
    avc
  };
};
var throttledStateUpdate = ({
  updateFn,
  everyMilliseconds,
  controller
}) => {
  let currentState = {
    bytes: 0,
    percentage: null,
    totalBytes: null
  };
  if (!updateFn) {
    return {
      get: () => currentState,
      update: null,
      stopAndGetLastProgress: () => {}
    };
  }
  let lastUpdated = null;
  const callUpdateIfChanged = () => {
    if (currentState === lastUpdated) {
      return;
    }
    updateFn(currentState);
    lastUpdated = currentState;
  };
  let cleanup = () => {};
  if (everyMilliseconds > 0) {
    const interval = setInterval(() => {
      callUpdateIfChanged();
    }, everyMilliseconds);
    const onAbort = () => {
      clearInterval(interval);
    };
    controller._internals.signal.addEventListener("abort", onAbort, {
      once: true
    });
    cleanup = () => {
      clearInterval(interval);
      controller._internals.signal.removeEventListener("abort", onAbort);
    };
  }
  return {
    get: () => currentState,
    update: (fn) => {
      currentState = fn(currentState);
      if (everyMilliseconds === 0) {
        callUpdateIfChanged();
      }
    },
    stopAndGetLastProgress: () => {
      cleanup();
      return currentState;
    }
  };
};
var internalParseMedia = async function({
  src,
  fields: _fieldsInReturnValue,
  reader: readerInterface,
  onAudioTrack,
  onVideoTrack,
  controller = mediaParserController(),
  logLevel,
  onParseProgress: onParseProgressDoNotCallDirectly,
  progressIntervalInMs,
  mode,
  onDiscardedData,
  onError,
  acknowledgeRemotionLicense,
  apiName,
  selectM3uStream: selectM3uStreamFn,
  selectM3uAssociatedPlaylists: selectM3uAssociatedPlaylistsFn,
  m3uPlaylistContext,
  makeSamplesStartAtZero,
  seekingHints,
  ...more
}) {
  if (!src) {
    throw new Error('No "src" provided');
  }
  controller._internals.markAsReadyToEmitEvents();
  warnIfRemotionLicenseNotAcknowledged({
    acknowledgeRemotionLicense,
    logLevel,
    apiName
  });
  Log.verbose(logLevel, `Reading ${typeof src === "string" ? src : src instanceof URL ? src.toString() : src instanceof File ? src.name : src.toString()}`);
  const prefetchCache = new Map;
  const {
    reader: readerInstance,
    contentLength,
    name,
    contentType,
    supportsContentRange,
    needsContentRange
  } = await readerInterface.read({
    src,
    range: null,
    controller,
    logLevel,
    prefetchCache
  });
  if (contentLength === null) {
    throw new Error(`Cannot read media ${src} without a content length. This is currently not supported. Ensure the media has a "Content-Length" HTTP header.`);
  }
  if (!supportsContentRange && needsContentRange) {
    throw new Error('Cannot read media without it supporting the "Content-Range" header. This is currently not supported. Ensure the media supports the "Content-Range" HTTP header.');
  }
  const hasAudioTrackHandlers = Boolean(onAudioTrack);
  const hasVideoTrackHandlers = Boolean(onVideoTrack);
  const state = makeParserState({
    hasAudioTrackHandlers,
    hasVideoTrackHandlers,
    controller,
    onAudioTrack: onAudioTrack ?? null,
    onVideoTrack: onVideoTrack ?? null,
    contentLength,
    logLevel,
    mode,
    readerInterface,
    src,
    onDiscardedData,
    selectM3uStreamFn,
    selectM3uAssociatedPlaylistsFn,
    m3uPlaylistContext,
    contentType,
    name,
    callbacks: more,
    fieldsInReturnValue: _fieldsInReturnValue ?? {},
    mimeType: contentType,
    initialReaderInstance: readerInstance,
    makeSamplesStartAtZero,
    prefetchCache
  });
  if (seekingHints) {
    setSeekingHints({ hints: seekingHints, state });
  }
  controller._internals.attachSeekingHintResolution(() => Promise.resolve(getSeekingHints({
    tracksState: state.callbacks.tracks,
    keyframesState: state.keyframes,
    webmState: state.webm,
    structureState: state.structure,
    m3uPlaylistContext: state.m3uPlaylistContext,
    mediaSectionState: state.mediaSection,
    isoState: state.iso,
    transportStream: state.transportStream,
    flacState: state.flac,
    samplesObserved: state.samplesObserved,
    riffState: state.riff,
    mp3State: state.mp3,
    contentLength: state.contentLength,
    aacState: state.aac
  })));
  controller._internals.attachSimulateSeekResolution((seek2) => {
    const {
      aacState: aacState2,
      avcState: avcState2,
      flacState: flacState2,
      isoState,
      iterator,
      keyframes,
      m3uState: m3uState2,
      mediaSection,
      mp3State,
      riffState,
      samplesObserved,
      structureState: structureState2,
      tracksState,
      transportStream,
      webmState: webmState2
    } = getWorkOnSeekRequestOptions(state);
    return turnSeekIntoByte({
      aacState: aacState2,
      seek: seek2,
      avcState: avcState2,
      contentLength,
      flacState: flacState2,
      isoState,
      iterator,
      keyframes,
      logLevel,
      m3uPlaylistContext,
      m3uState: m3uState2,
      mediaSectionState: mediaSection,
      mp3State,
      riffState,
      samplesObserved,
      structureState: structureState2,
      tracksState,
      transportStream,
      webmState: webmState2
    });
  });
  if (!hasAudioTrackHandlers && !hasVideoTrackHandlers && Object.values(state.fields).every((v) => !v) && mode === "query") {
    Log.warn(logLevel, new Error("Warning - No `fields` and no `on*` callbacks were passed to `parseMedia()`. Specify the data you would like to retrieve."));
  }
  const throttledState = throttledStateUpdate({
    updateFn: onParseProgressDoNotCallDirectly ?? null,
    everyMilliseconds: progressIntervalInMs ?? 100,
    controller,
    totalBytes: contentLength
  });
  await triggerInfoEmit(state);
  await parseLoop({ state, throttledState, onError });
  Log.verbose(logLevel, "Finished parsing file");
  await emitAllInfo(state);
  printTimings(state);
  state.currentReader.getCurrent().abort();
  state.iterator?.destroy();
  state.callbacks.tracks.ensureHasTracksAtEnd(state.fields);
  state.m3u.abortM3UStreamRuns();
  prefetchCache.clear();
  if (state.errored) {
    throw state.errored;
  }
  if (state.controller._internals.seekSignal.getSeek() !== null) {
    throw new Error("Should not finish while a seek is pending");
  }
  return state.returnValue;
};

// src/helpers/use-max-media-duration.ts
import { getVideoMetadata as getVideoMetadata2 } from "@remotion/media-utils";
import { useEffect as useEffect64, useState as useState64 } from "react";
var cache = new Map;
var getSrc = (s) => {
  if (s.type === "video") {
    return s.src;
  }
  if (s.type === "audio") {
    return s.src;
  }
  return null;
};
var useMaxMediaDuration = (s, fps) => {
  const src = getSrc(s);
  const [maxMediaDuration, setMaxMediaDuration] = useState64(src ? cache.get(src) ?? null : Infinity);
  useEffect64(() => {
    if (!src) {
      return;
    }
    const controller = mediaParserController();
    parseMedia({
      src,
      controller,
      acknowledgeRemotionLicense: true,
      onDurationInSeconds: (duration2) => {
        const durationOrInfinity = duration2 ?? Infinity;
        cache.set(src, Math.floor(durationOrInfinity * fps));
        setMaxMediaDuration(Math.floor(durationOrInfinity * fps));
      }
    }).catch((e) => {
      if (hasBeenAborted(e)) {
        return;
      }
      getVideoMetadata2(src).then((metadata) => {
        const durationOrInfinity = metadata.durationInSeconds ?? Infinity;
        cache.set(src, Math.floor(durationOrInfinity * fps));
        setMaxMediaDuration(Math.floor(durationOrInfinity * fps));
      }).catch(() => {});
      throw e;
    });
    return () => {
      try {
        controller.abort();
      } catch {}
    };
  }, [src, fps]);
  return maxMediaDuration;
};

// src/components/AudioWaveform.tsx
import { getAudioData, getWaveformPortion } from "@remotion/media-utils";
import { useEffect as useEffect65, useMemo as useMemo105, useRef as useRef35, useState as useState65 } from "react";
import { Internals as Internals53 } from "remotion";

// src/components/AudioWaveformBar.tsx
import { useMemo as useMemo104 } from "react";
import { jsx as jsx194 } from "react/jsx-runtime";
var WAVEFORM_BAR_LENGTH = 2;
var WAVEFORM_BAR_MARGIN = 1;
var container42 = {
  width: WAVEFORM_BAR_LENGTH,
  backgroundColor: "rgba(255, 255, 255, 0.6)",
  marginLeft: WAVEFORM_BAR_MARGIN,
  borderRadius: 2
};
var AudioWaveformBar = ({ amplitude }) => {
  const style11 = useMemo104(() => {
    return {
      ...container42,
      height: getTimelineLayerHeight("other") * amplitude * (1 / 0.6366)
    };
  }, [amplitude]);
  return /* @__PURE__ */ jsx194("div", {
    style: style11
  });
};

// src/components/AudioWaveform.tsx
import { jsx as jsx195, jsxs as jsxs93 } from "react/jsx-runtime";
var container43 = {
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-end",
  position: "absolute",
  height: getTimelineLayerHeight("other")
};
var errorMessage = {
  fontSize: 13,
  paddingTop: 6,
  paddingBottom: 6,
  paddingLeft: 12,
  paddingRight: 12,
  alignSelf: "flex-start",
  maxWidth: 450,
  opacity: 0.75
};
var canvasStyle = {
  position: "absolute"
};
var AudioWaveform = ({
  src,
  startFrom,
  durationInFrames,
  visualizationWidth,
  volume,
  doesVolumeChange,
  playbackRate
}) => {
  const [metadata, setMetadata] = useState65(null);
  const [error, setError] = useState65(null);
  const mountState = useRef35({ isMounted: true });
  const vidConf = Internals53.useUnsafeVideoConfig();
  if (vidConf === null) {
    throw new Error("Expected video config");
  }
  const canvas = useRef35(null);
  useEffect65(() => {
    const { current } = mountState;
    current.isMounted = true;
    return () => {
      current.isMounted = false;
    };
  }, []);
  useEffect65(() => {
    if (!canvas.current) {
      return;
    }
    const context = canvas.current.getContext("2d");
    if (!context) {
      return;
    }
    context.clearRect(0, 0, visualizationWidth, getTimelineLayerHeight("other"));
    if (!doesVolumeChange || typeof volume === "number") {
      return;
    }
    const volumes = volume.split(",").map((v) => Number(v));
    context.beginPath();
    context.moveTo(0, getTimelineLayerHeight("other"));
    volumes.forEach((v, index) => {
      const x = index / (volumes.length - 1) * visualizationWidth;
      const y = (1 - v) * (getTimelineLayerHeight("other") - TIMELINE_BORDER * 2) + 1;
      if (index === 0) {
        context.moveTo(x, y);
      } else {
        context.lineTo(x, y);
      }
    });
    context.strokeStyle = LIGHT_TRANSPARENT;
    context.stroke();
  }, [visualizationWidth, metadata, startFrom, volume, doesVolumeChange]);
  useEffect65(() => {
    setError(null);
    getAudioData(src).then((data) => {
      if (mountState.current.isMounted) {
        setMetadata(data);
      }
    }).catch((err) => {
      if (mountState.current.isMounted) {
        setError(err);
      }
    });
  }, [src, vidConf.fps]);
  const normalized = useMemo105(() => {
    if (!metadata || metadata.numberOfChannels === 0) {
      return [];
    }
    const numberOfSamples = Math.floor(visualizationWidth / (WAVEFORM_BAR_LENGTH + WAVEFORM_BAR_MARGIN));
    return getWaveformPortion({
      audioData: metadata,
      startTimeInSeconds: startFrom / vidConf.fps,
      durationInSeconds: Math.min(durationInFrames / vidConf.fps * playbackRate, metadata.durationInSeconds),
      numberOfSamples,
      normalize: false
    });
  }, [
    durationInFrames,
    vidConf.fps,
    metadata,
    playbackRate,
    startFrom,
    visualizationWidth
  ]);
  if (error) {
    return /* @__PURE__ */ jsx195("div", {
      style: container43,
      children: /* @__PURE__ */ jsx195("div", {
        style: errorMessage,
        children: "No waveform available. Audio might not support CORS."
      })
    });
  }
  if (!metadata) {
    return null;
  }
  return /* @__PURE__ */ jsxs93("div", {
    style: container43,
    children: [
      normalized.map((w) => {
        return /* @__PURE__ */ jsx195(AudioWaveformBar, {
          amplitude: w.amplitude * (typeof volume === "number" ? volume : 1)
        }, w.index);
      }),
      /* @__PURE__ */ jsx195("canvas", {
        ref: canvas,
        style: canvasStyle,
        width: visualizationWidth,
        height: getTimelineLayerHeight("other")
      })
    ]
  });
};

// src/components/Timeline/LoopedTimelineIndicators.tsx
import React134 from "react";
import { AbsoluteFill as AbsoluteFill4 } from "remotion";

// src/components/Timeline/LoopedIndicator.tsx
import { AbsoluteFill as AbsoluteFill3 } from "remotion";
import { jsx as jsx196, jsxs as jsxs94 } from "react/jsx-runtime";
var width = {
  width: 30,
  flexDirection: "row",
  display: "flex",
  position: "relative"
};
var icon5 = {
  height: 12
};
var Icon = () => /* @__PURE__ */ jsx196("svg", {
  viewBox: "0 0 512 512",
  style: icon5,
  children: /* @__PURE__ */ jsx196("path", {
    fill: LIGHT_COLOR,
    d: "M512 256c0 88.224-71.775 160-160 160H170.067l34.512 32.419c9.875 9.276 10.119 24.883.539 34.464l-10.775 10.775c-9.373 9.372-24.568 9.372-33.941 0l-92.686-92.686c-9.373-9.373-9.373-24.568 0-33.941l92.686-92.686c9.373-9.373 24.568-9.373 33.941 0l10.775 10.775c9.581 9.581 9.337 25.187-.539 34.464L170.067 352H352c52.935 0 96-43.065 96-96 0-13.958-2.996-27.228-8.376-39.204-4.061-9.039-2.284-19.626 4.723-26.633l12.183-12.183c11.499-11.499 30.965-8.526 38.312 5.982C505.814 205.624 512 230.103 512 256zM72.376 295.204C66.996 283.228 64 269.958 64 256c0-52.935 43.065-96 96-96h181.933l-34.512 32.419c-9.875 9.276-10.119 24.883-.539 34.464l10.775 10.775c9.373 9.372 24.568 9.372 33.941 0l92.686-92.686c9.373-9.373 9.373-24.568 0-33.941l-92.686-92.686c-9.373-9.373-24.568-9.373-33.941 0L306.882 29.12c-9.581 9.581-9.337 25.187.539 34.464L341.933 96H160C71.775 96 0 167.776 0 256c0 25.897 6.186 50.376 17.157 72.039 7.347 14.508 26.813 17.481 38.312 5.982l12.183-12.183c7.008-7.008 8.786-17.595 4.724-26.634z"
  })
});
var topLine = {
  top: 0,
  height: 2,
  width: 1,
  background: LIGHT_COLOR
};
var bottomLine = {
  top: 0,
  height: 2,
  width: 1,
  background: LIGHT_COLOR
};
var topContainer = {
  justifyContent: "flex-start",
  alignItems: "center"
};
var centerContainer = {
  justifyContent: "center",
  alignItems: "center"
};
var bottomContainer = {
  justifyContent: "flex-end",
  alignItems: "center"
};
var LoopedIndicator = () => {
  return /* @__PURE__ */ jsxs94("div", {
    style: width,
    children: [
      /* @__PURE__ */ jsx196(AbsoluteFill3, {
        style: topContainer,
        children: /* @__PURE__ */ jsx196("div", {
          style: topLine
        })
      }),
      /* @__PURE__ */ jsx196(AbsoluteFill3, {
        style: bottomContainer,
        children: /* @__PURE__ */ jsx196("div", {
          style: bottomLine
        })
      }),
      /* @__PURE__ */ jsx196(AbsoluteFill3, {
        style: centerContainer,
        children: /* @__PURE__ */ jsx196(Icon, {})
      })
    ]
  });
};

// src/components/Timeline/LoopedTimelineIndicators.tsx
import { jsx as jsx197, jsxs as jsxs95 } from "react/jsx-runtime";
var row6 = {
  flexDirection: "row"
};
var LoopedTimelineIndicator = ({ loops }) => {
  return /* @__PURE__ */ jsx197(AbsoluteFill4, {
    style: row6,
    children: new Array(loops).fill(true).map((_l, i) => {
      return /* @__PURE__ */ jsxs95(React134.Fragment, {
        children: [
          /* @__PURE__ */ jsx197(Flex, {}),
          i === loops - 1 ? null : /* @__PURE__ */ jsx197(LoopedIndicator, {})
        ]
      }, i);
    })
  });
};

// src/components/Timeline/TimelineSequenceFrame.tsx
import { jsx as jsx198 } from "react/jsx-runtime";
var relativeFrameStyle = {
  fontSize: 11,
  fontFamily: "Arial, Helvetica, sans-serif",
  color: "white",
  opacity: 0.5
};
var TimelineSequenceFrame = ({ roundedFrame, premounted, postmounted }) => {
  return /* @__PURE__ */ jsx198("div", {
    style: relativeFrameStyle,
    children: premounted ? "0 (Premounted)" : postmounted !== null ? `${postmounted} (Postmounted)` : roundedFrame
  });
};

// src/components/Timeline/TimelineVideoInfo.tsx
import { rotateAndResizeVideoFrame } from "@remotion/webcodecs";
import { extractFramesOnWebWorker } from "@remotion/webcodecs/worker";
import { useEffect as useEffect66, useRef as useRef36, useState as useState66 } from "react";
import { useVideoConfig as useVideoConfig5 } from "remotion";

// src/helpers/frame-database.ts
var makeFrameDatabaseKey = (src, timestamp) => `${src}|${timestamp}`;
var frameDatabase = new Map;
var aspectRatioCache = new Map;
var getTimestampFromFrameDatabaseKey = (key4) => {
  const split = key4.split("|");
  return Number(split[split.length - 1]);
};
var getAspectRatioFromCache = (src) => {
  const cached = aspectRatioCache.get(src);
  if (cached) {
    return cached;
  }
  return null;
};
var MAX_FRAMES_IN_CACHE = 12340;
var clearOldFrames = () => {
  if (frameDatabase.size <= MAX_FRAMES_IN_CACHE) {
    return;
  }
  const framesToRemove = Array.from(frameDatabase.entries()).sort((a, b) => a[1].lastUsed - b[1].lastUsed);
  for (const [key4, frame2] of framesToRemove.slice(0, framesToRemove.length - MAX_FRAMES_IN_CACHE)) {
    frame2.frame.close();
    frameDatabase.delete(key4);
  }
};

// src/components/Timeline/TimelineVideoInfo.tsx
import { jsx as jsx199 } from "react/jsx-runtime";
var HEIGHT = getTimelineLayerHeight("video") - 2;
var containerStyle2 = {
  height: HEIGHT,
  width: "100%",
  backgroundColor: "rgba(0, 0, 0, 0.3)",
  display: "flex",
  borderTopLeftRadius: 2,
  borderBottomLeftRadius: 2,
  fontSize: 10,
  fontFamily: "Arial, Helvetica"
};
var MAX_TIME_DEVIATION = WEBCODECS_TIMESCALE * 0.05;
var getDurationOfOneFrame = ({
  visualizationWidth,
  aspectRatio,
  segmentDuration
}) => {
  const framesFitInWidthUnrounded = visualizationWidth / (HEIGHT * aspectRatio);
  return segmentDuration / framesFitInWidthUnrounded * WEBCODECS_TIMESCALE;
};
var fixRounding = (value) => {
  if (value % 1 >= 0.49999999) {
    return Math.ceil(value);
  }
  return Math.floor(value);
};
var calculateTimestampSlots = ({
  visualizationWidth,
  fromSeconds,
  segmentDuration,
  aspectRatio
}) => {
  const framesFitInWidthUnrounded = visualizationWidth / (HEIGHT * aspectRatio);
  const framesFitInWidth = Math.ceil(framesFitInWidthUnrounded);
  const durationOfOneFrame = getDurationOfOneFrame({
    visualizationWidth,
    aspectRatio,
    segmentDuration
  });
  const timestampTargets = [];
  for (let i = 0;i < framesFitInWidth + 1; i++) {
    const target = fromSeconds * WEBCODECS_TIMESCALE + durationOfOneFrame * (i + 0.5);
    const snappedToDuration = (Math.round(fixRounding(target / durationOfOneFrame)) - 1) * durationOfOneFrame;
    timestampTargets.push(snappedToDuration);
  }
  return timestampTargets;
};
var ensureSlots = ({
  filledSlots,
  visualizationWidth,
  fromSeconds,
  toSeconds: toSeconds2,
  aspectRatio
}) => {
  const segmentDuration = toSeconds2 - fromSeconds;
  const timestampTargets = calculateTimestampSlots({
    visualizationWidth,
    fromSeconds,
    segmentDuration,
    aspectRatio
  });
  for (const timestamp of timestampTargets) {
    if (!filledSlots.has(timestamp)) {
      filledSlots.set(timestamp, undefined);
    }
  }
};
var drawSlot = ({
  frame: frame2,
  ctx,
  filledSlots,
  visualizationWidth,
  timestamp,
  segmentDuration,
  fromSeconds
}) => {
  const durationOfOneFrame = getDurationOfOneFrame({
    visualizationWidth,
    aspectRatio: frame2.displayWidth / frame2.displayHeight,
    segmentDuration
  });
  const relativeTimestamp = timestamp - fromSeconds * WEBCODECS_TIMESCALE;
  const frameIndex = relativeTimestamp / durationOfOneFrame;
  const left3 = Math.floor(frameIndex * frame2.displayWidth / window.devicePixelRatio);
  ctx.drawImage(frame2, left3, 0, frame2.displayWidth / window.devicePixelRatio, frame2.displayHeight / window.devicePixelRatio);
  filledSlots.set(timestamp, frame2.timestamp);
};
var fillWithCachedFrames = ({
  ctx,
  visualizationWidth,
  filledSlots,
  src,
  segmentDuration,
  fromSeconds
}) => {
  const keys = Array.from(frameDatabase.keys()).filter((k) => k.startsWith(src));
  const targets = Array.from(filledSlots.keys());
  for (const timestamp of targets) {
    let bestKey;
    let bestDistance = Infinity;
    for (const key4 of keys) {
      const distance = Math.abs(getTimestampFromFrameDatabaseKey(key4) - timestamp);
      if (distance < bestDistance) {
        bestDistance = distance;
        bestKey = key4;
      }
    }
    if (!bestKey) {
      continue;
    }
    const frame2 = frameDatabase.get(bestKey);
    if (!frame2) {
      continue;
    }
    const alreadyFilled = filledSlots.get(timestamp);
    if (alreadyFilled && Math.abs(alreadyFilled - timestamp) <= Math.abs(frame2.frame.timestamp - timestamp)) {
      continue;
    }
    frame2.lastUsed = Date.now();
    drawSlot({
      ctx,
      frame: frame2.frame,
      filledSlots,
      visualizationWidth,
      timestamp,
      segmentDuration,
      fromSeconds
    });
  }
};
var fillFrameWhereItFits = ({
  frame: frame2,
  filledSlots,
  ctx,
  visualizationWidth,
  segmentDuration,
  fromSeconds
}) => {
  const slots = Array.from(filledSlots.keys());
  for (let i = 0;i < slots.length; i++) {
    const slot = slots[i];
    if (Math.abs(slot - frame2.timestamp) > MAX_TIME_DEVIATION) {
      continue;
    }
    const filled = filledSlots.get(slot);
    if (filled && Math.abs(filled - slot) <= Math.abs(filled - frame2.timestamp)) {
      continue;
    }
    drawSlot({
      ctx,
      frame: frame2,
      filledSlots,
      visualizationWidth,
      timestamp: slot,
      segmentDuration,
      fromSeconds
    });
  }
};
var TimelineVideoInfo = ({ src, visualizationWidth, startFrom, durationInFrames }) => {
  const { fps } = useVideoConfig5();
  const ref = useRef36(null);
  const [error, setError] = useState66(null);
  const aspectRatio = useRef36(getAspectRatioFromCache(src));
  useEffect66(() => {
    if (error) {
      return;
    }
    const { current } = ref;
    if (!current) {
      return;
    }
    const controller = new AbortController;
    const canvas = document.createElement("canvas");
    canvas.width = visualizationWidth;
    canvas.height = HEIGHT;
    const ctx = canvas.getContext("2d");
    if (!ctx) {
      return;
    }
    current.appendChild(canvas);
    const filledSlots = new Map;
    const fromSeconds = startFrom / fps;
    const toSeconds2 = (startFrom + durationInFrames) / fps;
    if (aspectRatio.current !== null) {
      ensureSlots({
        filledSlots,
        visualizationWidth,
        fromSeconds,
        toSeconds: toSeconds2,
        aspectRatio: aspectRatio.current
      });
      fillWithCachedFrames({
        ctx,
        visualizationWidth,
        filledSlots,
        src,
        segmentDuration: toSeconds2 - fromSeconds,
        fromSeconds
      });
      const unfilled = Array.from(filledSlots.keys()).filter((timestamp) => !filledSlots.get(timestamp));
      if (unfilled.length === 0) {
        return () => {
          current.removeChild(canvas);
          clearOldFrames();
        };
      }
    }
    clearOldFrames();
    extractFramesOnWebWorker({
      acknowledgeRemotionLicense: true,
      timestampsInSeconds: ({ track }) => {
        aspectRatio.current = track.width / track.height;
        aspectRatioCache.set(src, aspectRatio.current);
        ensureSlots({
          filledSlots,
          fromSeconds,
          toSeconds: toSeconds2,
          visualizationWidth,
          aspectRatio: aspectRatio.current
        });
        return Array.from(filledSlots.keys()).map((timestamp) => timestamp / WEBCODECS_TIMESCALE);
      },
      src,
      onFrame: (frame2) => {
        const scale = HEIGHT / frame2.displayHeight * window.devicePixelRatio;
        const transformed = rotateAndResizeVideoFrame({
          frame: frame2,
          resizeOperation: {
            mode: "scale",
            scale
          },
          rotation: 0,
          needsToBeMultipleOfTwo: false
        });
        if (transformed !== frame2) {
          frame2.close();
        }
        const databaseKey = makeFrameDatabaseKey(src, transformed.timestamp);
        const existingFrame = frameDatabase.get(databaseKey);
        if (existingFrame) {
          existingFrame.frame.close();
        }
        frameDatabase.set(databaseKey, {
          frame: transformed,
          lastUsed: Date.now()
        });
        if (aspectRatio.current === null) {
          throw new Error("Aspect ratio is not set");
        }
        ensureSlots({
          filledSlots,
          fromSeconds,
          toSeconds: toSeconds2,
          visualizationWidth,
          aspectRatio: aspectRatio.current
        });
        fillFrameWhereItFits({
          ctx,
          filledSlots,
          visualizationWidth,
          frame: transformed,
          segmentDuration: toSeconds2 - fromSeconds,
          fromSeconds
        });
      },
      signal: controller.signal
    }).then(() => {
      fillWithCachedFrames({
        ctx,
        visualizationWidth,
        filledSlots,
        src,
        segmentDuration: toSeconds2 - fromSeconds,
        fromSeconds
      });
    }).catch((e) => {
      if (hasBeenAborted(e)) {
        return;
      }
      setError(e);
    }).finally(() => {
      clearOldFrames();
    });
    return () => {
      controller.abort();
      current.removeChild(canvas);
    };
  }, [durationInFrames, error, fps, src, startFrom, visualizationWidth]);
  return /* @__PURE__ */ jsx199("div", {
    ref,
    style: containerStyle2
  });
};

// src/components/Timeline/TimelineSequence.tsx
import { jsx as jsx200, jsxs as jsxs96 } from "react/jsx-runtime";
var AUDIO_GRADIENT = "linear-gradient(rgb(16 171 58), rgb(43 165 63) 60%)";
var VIDEO_GRADIENT = "linear-gradient(to top, #8e44ad, #9b59b6)";
var TimelineSequence = ({ s }) => {
  const windowWidth = useContext66(TimelineWidthContext);
  if (windowWidth === null) {
    return null;
  }
  return /* @__PURE__ */ jsx200(Inner4, {
    windowWidth,
    s
  });
};
var Inner4 = ({ s, windowWidth }) => {
  const video = Internals54.useVideo();
  const maxMediaDuration = useMaxMediaDuration(s, video?.fps ?? 30);
  if (!video) {
    throw new TypeError("Expected video config");
  }
  const frame2 = useCurrentFrame2();
  const relativeFrame = frame2 - s.from;
  const relativeFrameWithPremount = relativeFrame + (s.premountDisplay ?? 0);
  const relativeFrameWithPostmount = relativeFrame - s.duration;
  const roundedFrame = Math.round(relativeFrame * 100) / 100;
  const isInRange = relativeFrame >= 0 && relativeFrame < s.duration;
  const isPremounting = relativeFrameWithPremount >= 0 && relativeFrameWithPremount < s.duration && !isInRange;
  const isPostmounting = relativeFrameWithPostmount >= 0 && relativeFrameWithPostmount < (s.postmountDisplay ?? 0) && !isInRange;
  const { marginLeft, width: width2, premountWidth, postmountWidth } = useMemo106(() => {
    return getTimelineSequenceLayout({
      durationInFrames: s.loopDisplay ? s.loopDisplay.durationInFrames * s.loopDisplay.numberOfTimes : s.duration,
      startFrom: s.loopDisplay ? s.from + s.loopDisplay.startOffset : s.from,
      startFromMedia: s.type === "sequence" ? 0 : s.startMediaFrom,
      maxMediaDuration,
      video,
      windowWidth,
      premountDisplay: s.premountDisplay,
      postmountDisplay: s.postmountDisplay
    });
  }, [maxMediaDuration, s, video, windowWidth]);
  const style11 = useMemo106(() => {
    return {
      background: s.type === "audio" ? AUDIO_GRADIENT : s.type === "video" ? VIDEO_GRADIENT : BLUE,
      border: SEQUENCE_BORDER_WIDTH + "px solid rgba(255, 255, 255, 0.2)",
      borderRadius: 2,
      position: "absolute",
      height: getTimelineLayerHeight(s.type === "video" ? "video" : "other"),
      marginLeft,
      width: width2,
      color: "white",
      overflow: "hidden",
      opacity: isInRange ? 1 : 0.5
    };
  }, [isInRange, marginLeft, s.type, width2]);
  if (maxMediaDuration === null) {
    return null;
  }
  return /* @__PURE__ */ jsxs96("div", {
    style: style11,
    title: s.displayName,
    children: [
      premountWidth ? /* @__PURE__ */ jsx200("div", {
        style: {
          width: premountWidth,
          height: "100%",
          background: `repeating-linear-gradient(
							-45deg,
							transparent,
							transparent 2px,
							rgba(255, 255, 255, ${isPremounting ? 0.5 : 0.2}) 2px,
							rgba(255, 255, 255, ${isPremounting ? 0.5 : 0.2}) 4px
						)`,
          position: "absolute"
        }
      }) : null,
      postmountWidth ? /* @__PURE__ */ jsx200("div", {
        style: {
          width: postmountWidth,
          height: "100%",
          background: `repeating-linear-gradient(
							-45deg,
							transparent,
							transparent 2px,
							rgba(255, 255, 255, ${isPostmounting ? 0.5 : 0.2}) 2px,
							rgba(255, 255, 255, ${isPostmounting ? 0.5 : 0.2}) 4px
						)`,
          position: "absolute",
          right: 0
        }
      }) : null,
      s.type === "audio" ? /* @__PURE__ */ jsx200(AudioWaveform, {
        src: s.src,
        doesVolumeChange: s.doesVolumeChange,
        visualizationWidth: width2,
        startFrom: s.startMediaFrom,
        durationInFrames: s.duration,
        volume: s.volume,
        playbackRate: s.playbackRate
      }) : null,
      s.type === "video" ? /* @__PURE__ */ jsx200(TimelineVideoInfo, {
        src: s.src,
        visualizationWidth: width2,
        startFrom: s.startMediaFrom,
        durationInFrames: s.duration
      }) : null,
      s.loopDisplay === undefined ? null : /* @__PURE__ */ jsx200(LoopedTimelineIndicator, {
        loops: s.loopDisplay.numberOfTimes
      }),
      s.type !== "audio" && s.type !== "video" && s.loopDisplay === undefined && (isInRange || isPremounting || isPostmounting) ? /* @__PURE__ */ jsx200("div", {
        style: {
          paddingLeft: 5 + (premountWidth ?? 0),
          height: "100%",
          display: "flex",
          alignItems: "center"
        },
        children: /* @__PURE__ */ jsx200(TimelineSequenceFrame, {
          premounted: isPremounting,
          postmounted: isPostmounting ? s.duration - 1 : null,
          roundedFrame
        })
      }) : null
    ]
  }, s.id);
};

// src/components/Timeline/is-collapsed.ts
var isTrackHidden = (track) => {
  if (!track.sequence.parent) {
    return false;
  }
  return !track.sequence.showInTimeline;
};

// src/components/Timeline/TimelineTracks.tsx
import { jsx as jsx201, jsxs as jsxs97 } from "react/jsx-runtime";
var content = {
  paddingLeft: TIMELINE_PADDING,
  paddingRight: TIMELINE_PADDING,
  paddingTop: 1
};
var timelineContent = {
  minHeight: "100%"
};
var TimelineTracks = ({ timeline, hasBeenCut }) => {
  const timelineStyle = useMemo107(() => {
    return {
      ...timelineContent,
      width: 100 + "%"
    };
  }, []);
  return /* @__PURE__ */ jsxs97("div", {
    style: timelineStyle,
    children: [
      /* @__PURE__ */ jsxs97("div", {
        style: content,
        children: [
          /* @__PURE__ */ jsx201(TimelineTimePadding, {}),
          timeline.map((track) => {
            if (isTrackHidden(track)) {
              return null;
            }
            return /* @__PURE__ */ jsx201("div", {
              style: {
                height: getTimelineLayerHeight(track.sequence.type === "video" ? "video" : "other"),
                marginBottom: TIMELINE_ITEM_BORDER_BOTTOM
              },
              children: /* @__PURE__ */ jsx201(TimelineSequence, {
                s: track.sequence
              })
            }, track.sequence.id);
          })
        ]
      }),
      hasBeenCut ? /* @__PURE__ */ jsx201(MaxTimelineTracksReached, {}) : null
    ]
  });
};

// src/components/Timeline/Timeline.tsx
import { jsx as jsx202, jsxs as jsxs98 } from "react/jsx-runtime";
var container44 = {
  minHeight: "100%",
  flex: 1,
  display: "flex",
  height: 0,
  overflowY: "auto",
  backgroundColor: BACKGROUND
};
var noop2 = () => {
  return;
};
var Timeline = () => {
  const { sequences } = useContext67(Internals55.SequenceManager);
  const videoConfig = Internals55.useUnsafeVideoConfig();
  const timeline = useMemo108(() => {
    if (!videoConfig) {
      return [];
    }
    return calculateTimeline({
      sequences,
      sequenceDuration: videoConfig.durationInFrames
    });
  }, [sequences, videoConfig]);
  const durationInFrames = videoConfig?.durationInFrames ?? 0;
  const filtered = useMemo108(() => {
    const withoutHidden = timeline.filter((t) => !isTrackHidden(t));
    const withoutAfter = withoutHidden.filter((t) => {
      return t.sequence.from <= durationInFrames && t.sequence.duration > 0;
    });
    return withoutAfter.filter((t) => t.sequence.showInTimeline);
  }, [durationInFrames, timeline]);
  const shown = filtered.slice(0, MAX_TIMELINE_TRACKS);
  const hasBeenCut = filtered.length > shown.length;
  const inner2 = useMemo108(() => {
    return {
      height: shown.reduce((acc, track) => {
        return acc + getTimelineLayerHeight(track.sequence.type === "video" ? "video" : "other") + Number(TIMELINE_ITEM_BORDER_BOTTOM);
      }, 0) + TIMELINE_ITEM_BORDER_BOTTOM + (hasBeenCut ? MAX_TIMELINE_TRACKS_NOTICE_HEIGHT : 0) + TIMELINE_TIME_INDICATOR_HEIGHT,
      display: "flex",
      flex: 1,
      minHeight: "100%",
      overflowX: "hidden"
    };
  }, [hasBeenCut, shown]);
  return /* @__PURE__ */ jsx202("div", {
    ref: timelineVerticalScroll,
    style: container44,
    className: "css-reset " + VERTICAL_SCROLLBAR_CLASSNAME,
    children: /* @__PURE__ */ jsx202(TimelineWidthProvider, {
      children: /* @__PURE__ */ jsx202("div", {
        style: inner2,
        children: /* @__PURE__ */ jsxs98(SplitterContainer, {
          orientation: "vertical",
          defaultFlex: 0.2,
          id: "names-to-timeline",
          maxFlex: 0.5,
          minFlex: 0.15,
          children: [
            /* @__PURE__ */ jsx202(SplitterElement, {
              type: "flexer",
              sticky: /* @__PURE__ */ jsx202(TimelineTimePlaceholders, {}),
              children: /* @__PURE__ */ jsx202(TimelineList, {
                timeline: shown
              })
            }),
            /* @__PURE__ */ jsx202(SplitterHandle, {
              onCollapse: noop2,
              allowToCollapse: "none"
            }),
            /* @__PURE__ */ jsx202(SplitterElement, {
              type: "anti-flexer",
              sticky: null,
              children: /* @__PURE__ */ jsxs98(TimelineScrollable, {
                children: [
                  /* @__PURE__ */ jsx202(TimelineTracks, {
                    timeline: shown,
                    hasBeenCut
                  }),
                  /* @__PURE__ */ jsx202(TimelineInOutPointer, {}),
                  /* @__PURE__ */ jsx202(TimelinePlayCursorSyncer, {}),
                  /* @__PURE__ */ jsx202(TimelineDragHandler, {}),
                  /* @__PURE__ */ jsx202(TimelineTimeIndicators, {}),
                  /* @__PURE__ */ jsx202(TimelineSlider, {})
                ]
              })
            })
          ]
        })
      })
    })
  });
};

// src/components/EditorContent.tsx
import { jsx as jsx203, jsxs as jsxs99, Fragment as Fragment28 } from "react/jsx-runtime";
var noop3 = () => {
  return;
};
var container45 = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  height: 0
};
var EditorContent = ({ readOnlyStudio, children }) => {
  const isStill = useIsStill();
  const { canvasContent } = useContext68(Internals56.CompositionManager);
  const onlyTopPanel = canvasContent === null || isStill || canvasContent.type !== "composition";
  return /* @__PURE__ */ jsxs99("div", {
    style: container45,
    children: [
      /* @__PURE__ */ jsx203(InitialCompositionLoader, {}),
      /* @__PURE__ */ jsx203(MenuToolbar, {
        readOnlyStudio
      }),
      /* @__PURE__ */ jsxs99(SplitterContainer, {
        orientation: "horizontal",
        id: "top-to-bottom",
        maxFlex: 0.9,
        minFlex: 0.2,
        defaultFlex: 0.75,
        children: [
          /* @__PURE__ */ jsx203(SplitterElement, {
            sticky: null,
            type: "flexer",
            children
          }),
          onlyTopPanel ? null : /* @__PURE__ */ jsxs99(Fragment28, {
            children: [
              /* @__PURE__ */ jsx203(SplitterHandle, {
                allowToCollapse: "none",
                onCollapse: noop3
              }),
              /* @__PURE__ */ jsx203(SplitterElement, {
                sticky: null,
                type: "anti-flexer",
                children: /* @__PURE__ */ jsx203(Timeline, {})
              })
            ]
          })
        ]
      })
    ]
  });
};

// src/components/GlobalKeybindings.tsx
import { useContext as useContext69, useEffect as useEffect67 } from "react";
var GlobalKeybindings = () => {
  const keybindings = useKeybinding();
  const { setSelectedModal } = useContext69(ModalsContext);
  const { setCheckerboard } = useContext69(CheckerboardContext);
  const { navigateToNextComposition, navigateToPreviousComposition } = useCompositionNavigation();
  useEffect67(() => {
    const nKey = keybindings.registerKeybinding({
      event: "keypress",
      key: "n",
      callback: () => {
        showNotification(`To make a new composition, right-click an existing one and select "Duplicate"`, 5000);
      },
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const cmdKKey = keybindings.registerKeybinding({
      event: "keydown",
      key: "k",
      callback: () => {
        setSelectedModal({
          type: "quick-switcher",
          mode: "compositions",
          invocationTimestamp: Date.now()
        });
      },
      triggerIfInputFieldFocused: true,
      keepRegisteredWhenNotHighestContext: false,
      commandCtrlKey: true,
      preventDefault: true
    });
    const cmdIKey = keybindings.registerKeybinding({
      event: "keydown",
      key: "i",
      callback: () => {
        askAiModalRef.current?.toggle();
      },
      triggerIfInputFieldFocused: true,
      keepRegisteredWhenNotHighestContext: true,
      commandCtrlKey: true,
      preventDefault: true
    });
    const cKey = keybindings.registerKeybinding({
      event: "keypress",
      key: "t",
      callback: () => {
        setCheckerboard((c) => !c);
      },
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const questionMark = keybindings.registerKeybinding({
      event: "keypress",
      key: "?",
      callback: () => {
        setSelectedModal({
          type: "quick-switcher",
          mode: "docs",
          invocationTimestamp: Date.now()
        });
      },
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const pageDown = keybindings.registerKeybinding({
      event: "keydown",
      key: "PageDown",
      callback: navigateToNextComposition,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const pageUp = keybindings.registerKeybinding({
      event: "keydown",
      key: "PageUp",
      callback: navigateToPreviousComposition,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      nKey.unregister();
      cKey.unregister();
      questionMark.unregister();
      cmdKKey.unregister();
      cmdIKey.unregister();
      pageDown.unregister();
      pageUp.unregister();
    };
  }, [
    keybindings,
    setCheckerboard,
    setSelectedModal,
    navigateToNextComposition,
    navigateToPreviousComposition
  ]);
  return null;
};

// src/components/Modals.tsx
import { useContext as useContext81 } from "react";

// src/components/InstallPackage.tsx
import { apiDocs, descriptions, installableMap } from "@remotion/studio-shared";
import React142, { useCallback as useCallback100, useContext as useContext71, useEffect as useEffect68 } from "react";
import { VERSION as VERSION2 } from "remotion";

// src/api/install-package.ts
import { getRemotionEnvironment as getRemotionEnvironment4 } from "remotion";
var installPackages = (packageNames) => {
  if (!getRemotionEnvironment4().isStudio) {
    throw new Error("installPackages() is only available in the Studio");
  }
  if (window.remotion_isReadOnlyStudio) {
    throw new Error("installPackages() is not available in Read-Only Studio");
  }
  return callApi("/api/install-package", { packageNames });
};

// src/components/InstallablePackage.tsx
import { jsx as jsx204, jsxs as jsxs100 } from "react/jsx-runtime";
var FONT_SIZE = 13;
var InstallablePackageComp = ({ isInstalled, pkg, link, description }) => {
  return /* @__PURE__ */ jsxs100("div", {
    style: {
      fontSize: FONT_SIZE,
      lineHeight: 1.2,
      paddingBottom: 4,
      paddingTop: 4
    },
    children: [
      /* @__PURE__ */ jsx204("a", {
        href: link,
        style: {
          fontSize: FONT_SIZE,
          color: TEXT_COLOR,
          textDecoration: "none"
        },
        target: "_blank",
        children: pkg
      }),
      " ",
      isInstalled ? /* @__PURE__ */ jsx204("span", {
        style: { opacity: 0.3, fontSize: "inherit" },
        children: "(installed)"
      }) : null,
      /* @__PURE__ */ jsx204("br", {}),
      /* @__PURE__ */ jsx204("span", {
        style: { color: LIGHT_TEXT, fontSize: FONT_SIZE },
        children: description
      })
    ]
  });
};

// src/components/ModalButton.tsx
import { useMemo as useMemo109 } from "react";
import { jsx as jsx205 } from "react/jsx-runtime";
var buttonStyle5 = {
  backgroundColor: BLUE,
  color: "white"
};
var ModalButton = (props) => {
  const style11 = useMemo109(() => {
    return {
      ...buttonStyle5,
      backgroundColor: props.disabled ? BLUE_DISABLED : BLUE
    };
  }, [props.disabled]);
  return /* @__PURE__ */ jsx205(Button, {
    ...props,
    style: style11
  });
};

// src/components/ModalFooter.tsx
import { jsx as jsx206 } from "react/jsx-runtime";
var content2 = {
  padding: 12,
  paddingRight: 12,
  flex: 1,
  fontSize: 13,
  minWidth: 500
};
var ModalFooterContainer = ({ children }) => {
  return /* @__PURE__ */ jsx206("div", {
    style: { ...content2, borderTop: "1px solid black" },
    children
  });
};

// src/components/NewComposition/DismissableModal.tsx
import { useCallback as useCallback99, useContext as useContext70 } from "react";
import { jsx as jsx207 } from "react/jsx-runtime";
var DismissableModal = ({ children }) => {
  const { setSelectedModal } = useContext70(ModalsContext);
  const onQuit = useCallback99(() => {
    setSelectedModal(null);
  }, [setSelectedModal]);
  return /* @__PURE__ */ jsx207(ModalContainer, {
    onOutsideClick: onQuit,
    onEscape: onQuit,
    children
  });
};

// src/components/InstallPackage.tsx
import { jsx as jsx208, jsxs as jsxs101 } from "react/jsx-runtime";
var container46 = {
  padding: 20,
  maxHeight: 400,
  overflowY: "auto"
};
var text2 = {
  fontSize: 14
};
var InstallPackageModal = ({ packageManager }) => {
  const [state, setState] = React142.useState({ type: "idle" });
  const [map, setMap] = React142.useState({});
  const { previewServerState: ctx } = useContext71(StudioServerConnectionCtx);
  const selectedPackages = Object.keys(map).filter((pkg) => map[pkg]);
  const onClick = useCallback100(async () => {
    if (state.type === "done") {
      setState({ type: "restarting" });
      restartStudio();
      return;
    }
    setState({ type: "installing" });
    try {
      await installPackages(selectedPackages);
      setState({ type: "done" });
    } catch (err) {
      setState({ type: "error", error: err });
    }
  }, [selectedPackages, state.type]);
  const canSelectPackages = state.type === "idle" && ctx.type === "connected";
  const disabled = !(canSelectPackages || state.type === "done") || selectedPackages.length === 0;
  const { registerKeybinding } = useKeybinding();
  useEffect68(() => {
    if (disabled) {
      return;
    }
    const enter = registerKeybinding({
      callback() {
        onClick();
      },
      commandCtrlKey: true,
      key: "Enter",
      event: "keydown",
      preventDefault: true,
      triggerIfInputFieldFocused: true,
      keepRegisteredWhenNotHighestContext: true
    });
    return () => {
      enter.unregister();
    };
  }, [disabled, onClick, registerKeybinding]);
  return /* @__PURE__ */ jsxs101(DismissableModal, {
    children: [
      /* @__PURE__ */ jsx208(ModalHeader, {
        title: "Install packages"
      }),
      /* @__PURE__ */ jsx208("div", {
        style: container46,
        className: VERTICAL_SCROLLBAR_CLASSNAME,
        children: state.type === "done" ? /* @__PURE__ */ jsxs101("div", {
          style: text2,
          children: [
            "Installed package",
            selectedPackages.length === 1 ? "" : "s",
            " ",
            "successfully. Restart the server to complete."
          ]
        }) : state.type === "restarting" ? /* @__PURE__ */ jsx208("div", {
          style: text2,
          children: "Restarting the Studio server..."
        }) : state.type === "installing" ? /* @__PURE__ */ jsxs101("div", {
          style: text2,
          children: [
            "Installing package",
            selectedPackages.length === 1 ? "" : "s",
            ". Check your terminal for progress."
          ]
        }) : /* @__PURE__ */ jsx208("div", {
          style: text2,
          children: Object.entries(installableMap).filter(([, install]) => install).map(([pkgShort]) => {
            const pkg = pkgShort === "core" ? "remotion" : `@remotion/${pkgShort}`;
            const isInstalled = window.remotion_installedPackages?.includes(pkg) ?? false;
            const link = apiDocs[pkgShort];
            const description = descriptions[pkgShort];
            if (!link) {
              throw new Error("No link for " + pkg);
            }
            if (!description) {
              throw new Error("No description for " + pkg);
            }
            return /* @__PURE__ */ jsxs101(Row, {
              align: "center",
              children: [
                /* @__PURE__ */ jsx208(Checkbox, {
                  checked: map[pkg],
                  name: pkg,
                  onChange: () => {
                    setMap((prev) => ({ ...prev, [pkg]: !prev[pkg] }));
                  },
                  disabled: !canSelectPackages || isInstalled
                }),
                /* @__PURE__ */ jsx208(Spacing, {
                  x: 1.5
                }),
                /* @__PURE__ */ jsx208(InstallablePackageComp, {
                  description,
                  isInstalled,
                  link,
                  pkg
                })
              ]
            }, pkg);
          })
        })
      }),
      /* @__PURE__ */ jsx208(ModalFooterContainer, {
        children: /* @__PURE__ */ jsxs101(Row, {
          align: "center",
          children: [
            state.type === "idle" ? /* @__PURE__ */ jsxs101("span", {
              style: { color: LIGHT_TEXT, fontSize: 13, lineHeight: 1.2 },
              children: [
                "This will install ",
                selectedPackages.length,
                " package",
                selectedPackages.length === 1 ? "" : "s",
                /* @__PURE__ */ jsx208("br", {}),
                "using ",
                packageManager,
                ", Remotion v",
                VERSION2
              ]
            }) : null,
            /* @__PURE__ */ jsx208(Flex, {}),
            /* @__PURE__ */ jsxs101(ModalButton, {
              onClick,
              disabled,
              children: [
                state.type === "restarting" ? "Restarting..." : state.type === "installing" ? "Installing..." : state.type === "done" ? "Restart Server" : "Install",
                disabled ? null : /* @__PURE__ */ jsx208(ShortcutHint, {
                  keyToPress: "↵",
                  cmdOrCtrl: true
                })
              ]
            })
          ]
        })
      })
    ]
  });
};

// src/components/NewComposition/DeleteComposition.tsx
import { useCallback as useCallback102, useContext as useContext74, useMemo as useMemo111 } from "react";

// src/components/RenderModal/ResolveCompositionBeforeModal.tsx
import React143, { useContext as useContext72, useEffect as useEffect69, useMemo as useMemo110 } from "react";
import { Internals as Internals57 } from "remotion";
import { jsx as jsx209, jsxs as jsxs102 } from "react/jsx-runtime";
var loaderContainer2 = {
  paddingTop: 40,
  paddingBottom: 40,
  paddingLeft: 100,
  paddingRight: 100,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column"
};
var loaderLabel2 = {
  fontSize: 14,
  color: LIGHT_TEXT,
  fontFamily: "sans-serif",
  lineHeight: 1.5
};
var ResolvedCompositionContext = React143.createContext(null);
var ResolveCompositionBeforeModal = ({ compositionId, children }) => {
  const resolved = Internals57.useResolvedVideoConfig(compositionId);
  const unresolvedContext = useContext72(Internals57.CompositionManager);
  const unresolved = unresolvedContext.compositions.find((c) => compositionId === c.id);
  useEffect69(() => {
    const { current } = Internals57.resolveCompositionsRef;
    if (!current) {
      throw new Error("No ref to trigger composition calc");
    }
    current.setCurrentRenderModalComposition(compositionId);
    return () => {
      current.setCurrentRenderModalComposition(null);
    };
  }, [compositionId]);
  if (!unresolved) {
    throw new Error("Composition not found: " + compositionId);
  }
  const value = useMemo110(() => {
    return {
      resolved,
      unresolved
    };
  }, [resolved, unresolved]);
  if (!resolved || resolved.type === "loading") {
    return /* @__PURE__ */ jsx209(RunningCalculateMetadata, {});
  }
  if (resolved.type === "error") {
    return /* @__PURE__ */ jsxs102("div", {
      style: loaderContainer2,
      children: [
        /* @__PURE__ */ jsx209(Spacing, {
          y: 2
        }),
        /* @__PURE__ */ jsxs102("div", {
          style: loaderLabel2,
          children: [
            "Running ",
            /* @__PURE__ */ jsx209("code", {
              style: inlineCodeSnippet,
              children: "calculateMetadata()"
            }),
            " ",
            "yielded an error:"
          ]
        }),
        /* @__PURE__ */ jsx209(Spacing, {
          y: 1
        }),
        /* @__PURE__ */ jsx209("div", {
          style: loaderLabel2,
          children: resolved.error.message || "Unknown error"
        })
      ]
    });
  }
  return /* @__PURE__ */ jsx209(ResolvedCompositionContext.Provider, {
    value,
    children
  });
};

// src/components/NewComposition/CodemodFooter.tsx
import { useCallback as useCallback101, useContext as useContext73, useEffect as useEffect70, useState as useState67 } from "react";

// src/components/NewComposition/DiffPreview.tsx
import { jsx as jsx210, jsxs as jsxs103 } from "react/jsx-runtime";
var CodemodDiffPreview = ({ status }) => {
  if (status.type === "loading") {
    return null;
  }
  if (status.type === "fail") {
    return /* @__PURE__ */ jsx210("span", {
      style: { color: FAIL_COLOR, fontSize: 13, lineHeight: 1.2 },
      children: status.error
    });
  }
  return /* @__PURE__ */ jsxs103("div", {
    style: { lineHeight: 1.2 },
    children: [
      /* @__PURE__ */ jsx210("span", {
        style: { color: LIGHT_TEXT, fontSize: 13, lineHeight: 1.2 },
        children: "This will edit your Root file."
      }),
      /* @__PURE__ */ jsx210("br", {}),
      /* @__PURE__ */ jsxs103("span", {
        style: { color: BLUE, fontSize: 13, lineHeight: 1.2 },
        children: [
          status.diff.additions,
          " addition",
          status.diff.additions === 1 ? "" : "s",
          ","
        ]
      }),
      " ",
      /* @__PURE__ */ jsxs103("span", {
        style: {
          color: SELECTED_GUIDE,
          fontSize: 13,
          lineHeight: 1.2
        },
        children: [
          status.diff.deletions,
          " deletion",
          status.diff.deletions === 1 ? "" : "s"
        ]
      })
    ]
  });
};

// src/components/NewComposition/CodemodFooter.tsx
import { jsx as jsx211, jsxs as jsxs104 } from "react/jsx-runtime";
var CodemodFooter = ({
  codemod,
  valid,
  loadingNotification,
  successNotification,
  errorNotification,
  genericSubmitLabel,
  submitLabel
}) => {
  const [submitting, setSubmitting] = useState67(false);
  const { setSelectedModal } = useContext73(ModalsContext);
  const [codemodStatus, setCanApplyCodemod] = useState67({
    type: "loading"
  });
  const [projectInfo, setProjectInfo] = useState67(null);
  useEffect70(() => {
    const controller = new AbortController;
    getProjectInfo(controller.signal).then((info) => {
      setProjectInfo(info.projectInfo);
    }).catch((err) => {
      showNotification(`Could not get project info: ${err.message}. Unable to duplicate composition`, 3000);
    });
    return () => {
      controller.abort();
    };
  }, []);
  const trigger = useCallback101(() => {
    setSubmitting(true);
    setSelectedModal(null);
    const notification2 = showNotification(loadingNotification, null);
    applyCodemod({
      codemod,
      dryRun: false,
      signal: new AbortController().signal
    }).then(() => {
      notification2.replaceContent(successNotification, 2000);
    }).catch((err) => {
      notification2.replaceContent(`${errorNotification}: ${err.message}`, 2000);
    });
  }, [
    codemod,
    errorNotification,
    loadingNotification,
    setSelectedModal,
    successNotification
  ]);
  const getCanApplyCodemod = useCallback101(async (signal) => {
    const res = await applyCodemod({
      codemod,
      dryRun: true,
      signal
    });
    if (res.success) {
      setCanApplyCodemod({ type: "success", diff: res.diff });
    } else {
      setCanApplyCodemod({
        type: "fail",
        error: res.reason
      });
    }
  }, [codemod]);
  useEffect70(() => {
    const abortController = new AbortController;
    let aborted = false;
    getCanApplyCodemod(abortController.signal).then(() => {
      return;
    }).catch((err) => {
      if (aborted) {
        return;
      }
      showNotification(`Cannot duplicate composition: ${err.message}`, 3000);
    });
    return () => {
      aborted = true;
      abortController.abort();
    };
  }, [codemodStatus, getCanApplyCodemod, setSelectedModal]);
  const disabled = !valid || submitting || projectInfo === null || codemodStatus.type !== "success";
  const { registerKeybinding } = useKeybinding();
  useEffect70(() => {
    if (disabled) {
      return;
    }
    const enter = registerKeybinding({
      callback() {
        trigger();
      },
      commandCtrlKey: true,
      key: "Enter",
      event: "keydown",
      preventDefault: true,
      triggerIfInputFieldFocused: true,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      enter.unregister();
    };
  }, [disabled, registerKeybinding, trigger, valid]);
  return /* @__PURE__ */ jsxs104(Row, {
    align: "center",
    children: [
      /* @__PURE__ */ jsx211(CodemodDiffPreview, {
        status: codemodStatus
      }),
      /* @__PURE__ */ jsx211(Flex, {}),
      /* @__PURE__ */ jsx211(Spacing, {
        block: true,
        x: 2
      }),
      /* @__PURE__ */ jsxs104(ModalButton, {
        onClick: trigger,
        disabled,
        children: [
          projectInfo && projectInfo.relativeRootFile ? submitLabel({ relativeRootPath: projectInfo.relativeRootFile }) : genericSubmitLabel,
          /* @__PURE__ */ jsx211(ShortcutHint, {
            keyToPress: "↵",
            cmdOrCtrl: true
          })
        ]
      })
    ]
  });
};

// src/components/NewComposition/DeleteComposition.tsx
import { jsx as jsx212, jsxs as jsxs105, Fragment as Fragment29 } from "react/jsx-runtime";
var content3 = {
  padding: 16,
  fontSize: 14,
  flex: 1,
  minWidth: 500
};
var DeleteCompositionLoaded = ({ compositionId }) => {
  const context = useContext74(ResolvedCompositionContext);
  if (!context) {
    throw new Error("Resolved composition context");
  }
  const { unresolved } = context;
  const codemod = useMemo111(() => {
    return {
      type: "delete-composition",
      idToDelete: compositionId
    };
  }, [compositionId]);
  const onSubmit = useCallback102((e) => {
    e.preventDefault();
  }, []);
  return /* @__PURE__ */ jsxs105(Fragment29, {
    children: [
      /* @__PURE__ */ jsx212(ModalHeader, {
        title: "Delete composition"
      }),
      /* @__PURE__ */ jsxs105("form", {
        onSubmit,
        children: [
          /* @__PURE__ */ jsxs105("div", {
            style: content3,
            children: [
              "Do you want to delete the",
              " ",
              /* @__PURE__ */ jsx212("code", {
                style: inlineCodeSnippet,
                children: unresolved.durationInFrames === 1 ? `<Still>` : "<Composition>"
              }),
              " ",
              "with ID ",
              '"',
              unresolved.id,
              '"',
              "?",
              /* @__PURE__ */ jsx212("br", {}),
              "The associated ",
              /* @__PURE__ */ jsx212("code", {
                style: inlineCodeSnippet,
                children: "component"
              }),
              " will remain in your code."
            ]
          }),
          /* @__PURE__ */ jsx212(ModalFooterContainer, {
            children: /* @__PURE__ */ jsx212(CodemodFooter, {
              errorNotification: `Could not delete composition`,
              loadingNotification: "Deleting",
              successNotification: `Deleted ${unresolved.id}`,
              genericSubmitLabel: `Delete`,
              submitLabel: ({ relativeRootPath }) => `Delete from ${relativeRootPath}`,
              codemod,
              valid: true
            })
          })
        ]
      })
    ]
  });
};
var DeleteComposition = ({ compositionId }) => {
  return /* @__PURE__ */ jsx212(DismissableModal, {
    children: /* @__PURE__ */ jsx212(ResolveCompositionBeforeModal, {
      compositionId,
      children: /* @__PURE__ */ jsx212(DeleteCompositionLoaded, {
        compositionId
      })
    })
  });
};

// src/components/NewComposition/DuplicateComposition.tsx
import { useCallback as useCallback104, useContext as useContext75, useMemo as useMemo112, useState as useState68 } from "react";
import { Internals as Internals59 } from "remotion";

// src/helpers/validate-new-comp-data.ts
import { Internals as Internals58 } from "remotion";
var validateCompositionName = (compName, compositions) => {
  if (!Internals58.isCompositionIdValid(compName)) {
    return Internals58.invalidCompositionErrorMessage;
  }
  if (compositions.find((c) => c.id === compName)) {
    return `A composition with that name already exists.`;
  }
  return null;
};
var validateCompositionDimension = (dimension, value) => {
  if (Number(value) % 2 !== 0) {
    return `${dimension} should be divisible by 2, since H264 codec doesn't support odd dimensions.`;
  }
  if (Number.isNaN(Number(value))) {
    return "Invalid number.";
  }
  if (Number(value) === 0) {
    return dimension + " cannot be zero.";
  }
  return null;
};
var validateCompositionDuration = (value) => {
  if (value % 1 !== 0) {
    return `Duration must be an integer.`;
  }
  if (Number.isNaN(value)) {
    return "Invalid number.";
  }
  if (value === 0) {
    return "Duration cannot be zero.";
  }
  return null;
};

// src/components/NewComposition/NewCompDuration.tsx
import { useCallback as useCallback103 } from "react";
import { jsx as jsx213, jsxs as jsxs106, Fragment as Fragment30 } from "react/jsx-runtime";
var NewCompDuration = ({ durationInFrames, setDurationInFrames }) => {
  const onDurationInFramesChanged = useCallback103((newValue) => {
    setDurationInFrames(Number(newValue));
  }, [setDurationInFrames]);
  const onDurationChangedDirectly = useCallback103((newVal) => {
    setDurationInFrames(newVal);
  }, [setDurationInFrames]);
  const compDurationErrMessage = validateCompositionDuration(durationInFrames);
  return /* @__PURE__ */ jsxs106("div", {
    style: optionRow,
    children: [
      /* @__PURE__ */ jsx213("div", {
        style: label5,
        children: "Duration in frames"
      }),
      /* @__PURE__ */ jsxs106("div", {
        style: rightRow,
        children: [
          /* @__PURE__ */ jsx213(InputDragger, {
            type: "number",
            value: durationInFrames,
            onTextChange: onDurationInFramesChanged,
            placeholder: "Duration (frames)",
            name: "durationInFrames",
            min: 1,
            step: 1,
            required: true,
            status: "ok",
            max: 300000,
            onValueChange: onDurationChangedDirectly,
            rightAlign: false
          }),
          compDurationErrMessage ? /* @__PURE__ */ jsxs106(Fragment30, {
            children: [
              /* @__PURE__ */ jsx213(Spacing, {
                y: 1,
                block: true
              }),
              /* @__PURE__ */ jsx213(ValidationMessage, {
                align: "flex-start",
                message: compDurationErrMessage,
                type: "error"
              })
            ]
          }) : null
        ]
      })
    ]
  });
};

// src/components/NewComposition/DuplicateComposition.tsx
import { jsx as jsx214, jsxs as jsxs107, Fragment as Fragment31 } from "react/jsx-runtime";
var content4 = {
  padding: 12,
  paddingRight: 12,
  flex: 1,
  fontSize: 13,
  minWidth: 500
};
var comboBoxStyle = {
  width: 190
};
var DuplicateCompositionLoaded = ({ initialType }) => {
  const context = useContext75(ResolvedCompositionContext);
  if (!context) {
    throw new Error("Resolved composition context");
  }
  const { resolved, unresolved } = context;
  const [initialCompType] = useState68(initialType);
  const hadDimensionsDefined = unresolved.width && unresolved.height;
  const hadFpsDefined = unresolved.fps !== undefined;
  const hadDurationDefined = unresolved.durationInFrames !== undefined;
  const [selectedFrameRate, setFrameRate] = useState68(resolved.result.fps);
  const { compositions } = useContext75(Internals59.CompositionManager);
  const [type, setType] = useState68(initialCompType);
  const [newId, setName] = useState68(() => {
    const numberAtEnd = resolved.result.id.match(/([0-9]+)$/)?.[0];
    let prefix = numberAtEnd ? Number(numberAtEnd) : 1;
    const initialName = resolved.result.id.replace(/([0-9]+)$/, "");
    let currentName = initialName;
    while (true) {
      currentName = initialName + prefix;
      const err = validateCompositionName(currentName, compositions);
      if (!err) {
        break;
      }
      prefix++;
    }
    return currentName;
  });
  const [size4, setSize] = useState68(() => ({
    width: resolved.result.width,
    height: resolved.result.height
  }));
  const [durationInFrames, setDurationInFrames] = useState68(resolved.result.durationInFrames);
  const onTypeChanged = useCallback104((newType) => {
    setType(newType);
  }, []);
  const onWidthChanged = useCallback104((newValue) => {
    setSize((s) => {
      const { height } = s;
      const newWidth = Number(newValue);
      return {
        height,
        width: newWidth
      };
    });
  }, []);
  const onWidthDirectlyChanged = useCallback104((newWidth) => {
    setSize((s) => {
      const { height } = s;
      return {
        height,
        width: newWidth
      };
    });
  }, []);
  const onHeightDirectlyChanged = useCallback104((newHeight) => {
    setSize((s) => {
      const { width: width2 } = s;
      return {
        width: width2,
        height: newHeight
      };
    });
  }, []);
  const onHeightChanged = useCallback104((newValue) => {
    setSize((s) => {
      const { width: width2 } = s;
      const newHeight = Number(newValue);
      return {
        width: width2,
        height: newHeight
      };
    });
  }, []);
  const onNameChange = useCallback104((e) => {
    setName(e.target.value);
  }, []);
  const onTextFpsChange = useCallback104((newFps) => {
    setFrameRate(Number(newFps));
  }, []);
  const onFpsChange = useCallback104((newFps) => {
    setFrameRate(newFps);
  }, []);
  const compNameErrMessage = validateCompositionName(newId, compositions);
  const compWidthErrMessage = validateCompositionDimension("Width", size4.width);
  const compHeightErrMessage = validateCompositionDimension("Height", size4.height);
  const typeValues = useMemo112(() => {
    return [
      {
        id: "composition",
        keyHint: null,
        label: "<Composition />",
        leftItem: null,
        onClick: () => onTypeChanged("composition"),
        subMenu: null,
        type: "item",
        value: "composition",
        quickSwitcherLabel: null
      },
      {
        id: "still",
        keyHint: null,
        label: "<Still />",
        leftItem: null,
        onClick: () => onTypeChanged("still"),
        subMenu: null,
        type: "item",
        value: "still",
        quickSwitcherLabel: null
      }
    ];
  }, [onTypeChanged]);
  const valid = compNameErrMessage === null && compWidthErrMessage === null && compHeightErrMessage === null;
  const codemod = useMemo112(() => {
    return {
      type: "duplicate-composition",
      idToDuplicate: resolved.result.id,
      newDurationInFrames: hadDurationDefined ? Number(durationInFrames) : null,
      newFps: hadFpsDefined ? Number(selectedFrameRate) : null,
      newHeight: hadDimensionsDefined ? Number(size4.height) : null,
      newWidth: hadDimensionsDefined ? Number(size4.width) : null,
      newId,
      tag: type === "still" ? "Still" : "Composition"
    };
  }, [
    durationInFrames,
    hadDimensionsDefined,
    hadDurationDefined,
    hadFpsDefined,
    newId,
    resolved.result.id,
    selectedFrameRate,
    size4.height,
    size4.width,
    type
  ]);
  const onSubmit = useCallback104((e) => {
    e.preventDefault();
  }, []);
  return /* @__PURE__ */ jsxs107(Fragment31, {
    children: [
      /* @__PURE__ */ jsx214(ModalHeader, {
        title: `Duplicate ${resolved.result.id}`
      }),
      /* @__PURE__ */ jsxs107("form", {
        onSubmit,
        children: [
          /* @__PURE__ */ jsxs107("div", {
            style: content4,
            children: [
              initialCompType === "composition" ? /* @__PURE__ */ jsxs107("div", {
                style: optionRow,
                children: [
                  /* @__PURE__ */ jsx214("div", {
                    style: label5,
                    children: "Type"
                  }),
                  /* @__PURE__ */ jsx214("div", {
                    style: rightRow,
                    children: /* @__PURE__ */ jsx214(Combobox, {
                      title: "Type of composition",
                      style: comboBoxStyle,
                      values: typeValues,
                      selectedId: type
                    })
                  })
                ]
              }) : null,
              /* @__PURE__ */ jsxs107("div", {
                style: optionRow,
                children: [
                  /* @__PURE__ */ jsx214("div", {
                    style: label5,
                    children: "ID"
                  }),
                  /* @__PURE__ */ jsx214("div", {
                    style: rightRow,
                    children: /* @__PURE__ */ jsxs107("div", {
                      children: [
                        /* @__PURE__ */ jsx214(RemotionInput, {
                          value: newId,
                          onChange: onNameChange,
                          type: "text",
                          autoFocus: true,
                          placeholder: "Composition ID",
                          status: "ok",
                          rightAlign: true
                        }),
                        compNameErrMessage ? /* @__PURE__ */ jsxs107(Fragment31, {
                          children: [
                            /* @__PURE__ */ jsx214(Spacing, {
                              y: 1,
                              block: true
                            }),
                            /* @__PURE__ */ jsx214(ValidationMessage, {
                              align: "flex-start",
                              message: compNameErrMessage,
                              type: "error"
                            })
                          ]
                        }) : null
                      ]
                    })
                  })
                ]
              }),
              hadDimensionsDefined ? /* @__PURE__ */ jsxs107(Fragment31, {
                children: [
                  /* @__PURE__ */ jsxs107("div", {
                    style: optionRow,
                    children: [
                      /* @__PURE__ */ jsx214("div", {
                        style: label5,
                        children: "Width"
                      }),
                      /* @__PURE__ */ jsxs107("div", {
                        style: rightRow,
                        children: [
                          /* @__PURE__ */ jsx214(InputDragger, {
                            type: "number",
                            value: size4.width,
                            placeholder: "Width",
                            onTextChange: onWidthChanged,
                            name: "width",
                            step: 2,
                            min: 2,
                            required: true,
                            status: "ok",
                            formatter: (w) => `${w}px`,
                            max: 1e8,
                            onValueChange: onWidthDirectlyChanged,
                            rightAlign: false
                          }),
                          compWidthErrMessage ? /* @__PURE__ */ jsxs107(Fragment31, {
                            children: [
                              /* @__PURE__ */ jsx214(Spacing, {
                                y: 1,
                                block: true
                              }),
                              /* @__PURE__ */ jsx214(ValidationMessage, {
                                align: "flex-start",
                                message: compWidthErrMessage,
                                type: "error"
                              })
                            ]
                          }) : null
                        ]
                      })
                    ]
                  }),
                  /* @__PURE__ */ jsxs107("div", {
                    style: optionRow,
                    children: [
                      /* @__PURE__ */ jsx214("div", {
                        style: label5,
                        children: "Height"
                      }),
                      /* @__PURE__ */ jsxs107("div", {
                        style: rightRow,
                        children: [
                          /* @__PURE__ */ jsx214(InputDragger, {
                            type: "number",
                            value: size4.height,
                            onTextChange: onHeightChanged,
                            placeholder: "Height",
                            name: "height",
                            step: 2,
                            required: true,
                            formatter: (h) => `${h}px`,
                            min: 2,
                            status: "ok",
                            max: 1e8,
                            onValueChange: onHeightDirectlyChanged,
                            rightAlign: false
                          }),
                          compHeightErrMessage ? /* @__PURE__ */ jsxs107(Fragment31, {
                            children: [
                              /* @__PURE__ */ jsx214(Spacing, {
                                y: 1,
                                block: true
                              }),
                              /* @__PURE__ */ jsx214(ValidationMessage, {
                                align: "flex-start",
                                message: compHeightErrMessage,
                                type: "error"
                              })
                            ]
                          }) : null
                        ]
                      })
                    ]
                  })
                ]
              }) : null,
              type === "composition" && hadDurationDefined ? /* @__PURE__ */ jsx214(NewCompDuration, {
                durationInFrames,
                setDurationInFrames
              }) : null,
              type === "composition" && hadFpsDefined ? /* @__PURE__ */ jsxs107("div", {
                style: optionRow,
                children: [
                  /* @__PURE__ */ jsx214("div", {
                    style: label5,
                    children: "FPS"
                  }),
                  /* @__PURE__ */ jsx214("div", {
                    style: rightRow,
                    children: /* @__PURE__ */ jsx214(InputDragger, {
                      type: "number",
                      value: selectedFrameRate,
                      onTextChange: onTextFpsChange,
                      placeholder: "Frame rate (fps)",
                      name: "fps",
                      min: 1,
                      required: true,
                      status: "ok",
                      max: 240,
                      step: 0.01,
                      onValueChange: onFpsChange,
                      rightAlign: false
                    })
                  })
                ]
              }) : null
            ]
          }),
          /* @__PURE__ */ jsx214(ModalFooterContainer, {
            children: /* @__PURE__ */ jsx214(CodemodFooter, {
              loadingNotification: "Duplicating...",
              errorNotification: "Could not duplicate composition",
              successNotification: `Duplicated ${unresolved.id} as ${newId}`,
              genericSubmitLabel: "Duplicate",
              submitLabel: ({ relativeRootPath }) => `Add to ${relativeRootPath}`,
              codemod,
              valid
            })
          })
        ]
      })
    ]
  });
};
var DuplicateComposition = ({ compositionId, compositionType }) => {
  return /* @__PURE__ */ jsx214(DismissableModal, {
    children: /* @__PURE__ */ jsx214(ResolveCompositionBeforeModal, {
      compositionId,
      children: /* @__PURE__ */ jsx214(DuplicateCompositionLoaded, {
        initialType: compositionType
      })
    })
  });
};

// src/components/NewComposition/RenameComposition.tsx
import { useCallback as useCallback105, useContext as useContext76, useMemo as useMemo113, useState as useState69 } from "react";
import { Internals as Internals60 } from "remotion";
import { jsx as jsx215, jsxs as jsxs108, Fragment as Fragment32 } from "react/jsx-runtime";
var content5 = {
  padding: 12,
  paddingRight: 12,
  flex: 1,
  fontSize: 13,
  minWidth: 500
};
var RenameCompositionLoaded = () => {
  const context = useContext76(ResolvedCompositionContext);
  if (!context) {
    throw new Error("Resolved composition context");
  }
  const { resolved } = context;
  const { compositions } = useContext76(Internals60.CompositionManager);
  const [newId, setName] = useState69(() => {
    return resolved.result.id;
  });
  const onNameChange = useCallback105((e) => {
    setName(e.target.value);
  }, []);
  const compNameErrMessage = newId === resolved.result.id ? null : validateCompositionName(newId, compositions);
  const valid = compNameErrMessage === null && resolved.result.id !== newId;
  const codemod = useMemo113(() => {
    return {
      type: "rename-composition",
      idToRename: resolved.result.id,
      newId
    };
  }, [newId, resolved.result.id]);
  const onSubmit = useCallback105((e) => {
    e.preventDefault();
  }, []);
  return /* @__PURE__ */ jsxs108(Fragment32, {
    children: [
      /* @__PURE__ */ jsx215(ModalHeader, {
        title: `Rename ${resolved.result.id}`
      }),
      /* @__PURE__ */ jsxs108("form", {
        onSubmit,
        children: [
          /* @__PURE__ */ jsx215("div", {
            style: content5,
            children: /* @__PURE__ */ jsxs108("div", {
              style: optionRow,
              children: [
                /* @__PURE__ */ jsx215("div", {
                  style: label5,
                  children: "ID"
                }),
                /* @__PURE__ */ jsx215("div", {
                  style: rightRow,
                  children: /* @__PURE__ */ jsxs108("div", {
                    children: [
                      /* @__PURE__ */ jsx215(RemotionInput, {
                        value: newId,
                        onChange: onNameChange,
                        type: "text",
                        autoFocus: true,
                        placeholder: "Composition ID",
                        status: "ok",
                        rightAlign: true
                      }),
                      compNameErrMessage ? /* @__PURE__ */ jsxs108(Fragment32, {
                        children: [
                          /* @__PURE__ */ jsx215(Spacing, {
                            y: 1,
                            block: true
                          }),
                          /* @__PURE__ */ jsx215(ValidationMessage, {
                            align: "flex-start",
                            message: compNameErrMessage,
                            type: "error"
                          })
                        ]
                      }) : null
                    ]
                  })
                })
              ]
            })
          }),
          /* @__PURE__ */ jsx215(ModalFooterContainer, {
            children: /* @__PURE__ */ jsx215(CodemodFooter, {
              loadingNotification: "Renaming...",
              errorNotification: "Could not rename composition",
              successNotification: `Renamed to ${newId}`,
              genericSubmitLabel: "Rename",
              submitLabel: ({ relativeRootPath }) => `Modify ${relativeRootPath}`,
              codemod,
              valid
            })
          })
        ]
      })
    ]
  });
};
var RenameComposition = ({ compositionId }) => {
  return /* @__PURE__ */ jsx215(DismissableModal, {
    children: /* @__PURE__ */ jsx215(ResolveCompositionBeforeModal, {
      compositionId,
      children: /* @__PURE__ */ jsx215(RenameCompositionLoaded, {})
    })
  });
};

// src/components/QuickSwitcher/QuickSwitcherContent.tsx
import {
  useCallback as useCallback106,
  useContext as useContext77,
  useEffect as useEffect72,
  useMemo as useMemo115,
  useRef as useRef38,
  useState as useState71
} from "react";
import { Internals as Internals61 } from "remotion";

// src/icons/keys.tsx
import { jsx as jsx216 } from "react/jsx-runtime";
var iconStyle5 = {
  width: 10,
  display: "inline"
};
var ShiftIcon = () => {
  return /* @__PURE__ */ jsx216("svg", {
    style: iconStyle5,
    viewBox: "0 0 448 512",
    children: /* @__PURE__ */ jsx216("path", {
      fill: "currentColor",
      d: "M48.048 304h73.798v128c0 26.51 21.49 48 48 48h108.308c26.51 0 48-21.49 48-48V304h73.789c42.638 0 64.151-51.731 33.941-81.941l-175.943-176c-18.745-18.745-49.137-18.746-67.882 0l-175.952 176C-16.042 252.208 5.325 304 48.048 304zM224 80l176 176H278.154v176H169.846V256H48L224 80z"
    })
  });
};
var ArrowLeft = () => {
  return /* @__PURE__ */ jsx216("svg", {
    style: iconStyle5,
    viewBox: "0 0 448 512",
    children: /* @__PURE__ */ jsx216("path", {
      fill: "currentColor",
      d: "M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"
    })
  });
};
var ArrowRight = () => {
  return /* @__PURE__ */ jsx216("svg", {
    style: iconStyle5,
    viewBox: "0 0 448 512",
    children: /* @__PURE__ */ jsx216("path", {
      fill: "currentColor",
      d: "M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"
    })
  });
};

// src/components/KeyboardShortcutsExplainer.tsx
import { jsx as jsx217, jsxs as jsxs109 } from "react/jsx-runtime";
var left3 = {
  width: 85,
  paddingTop: 8,
  paddingBottom: 8
};
var key4 = {
  background: INPUT_BACKGROUND,
  padding: "3px 6px",
  color: "white",
  borderRadius: 3,
  border: "1px solid " + INPUT_BORDER_COLOR_UNHOVERED,
  borderBottomWidth: 3,
  fontSize: 14,
  fontFamily: "monospace"
};
var right2 = {
  fontSize: 14,
  color: "#eee"
};
var container47 = {
  paddingLeft: 20,
  paddingRight: 40,
  paddingTop: 10,
  paddingBottom: 10
};
var title4 = {
  fontWeight: "bold",
  color: "white",
  fontSize: 14,
  marginBottom: 10
};
var keyboardShortcutsDisabled = {
  padding: 12,
  width: "100%",
  fontSize: 14,
  backgroundColor: "rgba(255, 255, 255, 0.1)"
};
var ul = {
  marginTop: 0,
  marginBottom: 0
};
var li = {
  fontSize: 14
};
var KeyboardShortcutsExplainer = () => {
  return /* @__PURE__ */ jsxs109("div", {
    children: [
      areKeyboardShortcutsDisabled() ? /* @__PURE__ */ jsxs109("div", {
        style: keyboardShortcutsDisabled,
        children: [
          "Keyboard shortcuts disabled either due to:",
          /* @__PURE__ */ jsxs109("ul", {
            style: ul,
            children: [
              /* @__PURE__ */ jsx217("li", {
                style: li,
                children: "a) --disable-keyboard-shortcuts being passed"
              }),
              /* @__PURE__ */ jsx217("li", {
                style: li,
                children: "b) Config.setKeyboardShortcutsEnabled(false) being set or"
              }),
              /* @__PURE__ */ jsx217("li", {
                style: li,
                children: " c) a Remotion version mismatch."
              })
            ]
          })
        ]
      }) : null,
      /* @__PURE__ */ jsxs109(Row, {
        style: container47,
        children: [
          /* @__PURE__ */ jsxs109(Column, {
            children: [
              /* @__PURE__ */ jsx217("div", {
                style: title4,
                children: "Playback"
              }),
              /* @__PURE__ */ jsxs109(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsxs109("div", {
                    style: left3,
                    children: [
                      /* @__PURE__ */ jsx217("kbd", {
                        style: key4,
                        children: /* @__PURE__ */ jsx217(ShiftIcon, {})
                      }),
                      /* @__PURE__ */ jsx217(Spacing, {
                        x: 0.3
                      }),
                      /* @__PURE__ */ jsx217("kbd", {
                        style: key4,
                        children: /* @__PURE__ */ jsx217(ArrowLeft, {})
                      })
                    ]
                  }),
                  /* @__PURE__ */ jsx217("div", {
                    style: right2,
                    children: "1 second back"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs109(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx217("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx217("kbd", {
                      style: key4,
                      children: /* @__PURE__ */ jsx217(ArrowLeft, {})
                    })
                  }),
                  /* @__PURE__ */ jsx217("div", {
                    style: right2,
                    children: "Previous frame"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs109(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx217("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx217("kbd", {
                      style: key4,
                      children: "Space"
                    })
                  }),
                  /* @__PURE__ */ jsx217("div", {
                    style: right2,
                    children: "Play / Pause"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs109(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx217("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx217("kbd", {
                      style: key4,
                      children: /* @__PURE__ */ jsx217(ArrowRight, {})
                    })
                  }),
                  /* @__PURE__ */ jsx217("div", {
                    style: right2,
                    children: "Next frame"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs109(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsxs109("div", {
                    style: left3,
                    children: [
                      /* @__PURE__ */ jsx217("kbd", {
                        style: key4,
                        children: /* @__PURE__ */ jsx217(ShiftIcon, {})
                      }),
                      /* @__PURE__ */ jsx217(Spacing, {
                        x: 0.3
                      }),
                      /* @__PURE__ */ jsx217("kbd", {
                        style: key4,
                        children: /* @__PURE__ */ jsx217(ArrowRight, {})
                      })
                    ]
                  }),
                  /* @__PURE__ */ jsx217("div", {
                    style: right2,
                    children: "1 second forward"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs109(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx217("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx217("kbd", {
                      style: key4,
                      children: "A"
                    })
                  }),
                  /* @__PURE__ */ jsx217("div", {
                    style: right2,
                    children: "Jump to beginning"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs109(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx217("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx217("kbd", {
                      style: key4,
                      children: "E"
                    })
                  }),
                  /* @__PURE__ */ jsx217("div", {
                    style: right2,
                    children: "Jump to end"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs109(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx217("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx217("kbd", {
                      style: key4,
                      children: "J"
                    })
                  }),
                  /* @__PURE__ */ jsx217("div", {
                    style: right2,
                    children: "Reverse playback"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs109(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx217("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx217("kbd", {
                      style: key4,
                      children: "K"
                    })
                  }),
                  /* @__PURE__ */ jsx217("div", {
                    style: right2,
                    children: "Pause"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs109(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx217("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx217("kbd", {
                      style: key4,
                      children: "L"
                    })
                  }),
                  /* @__PURE__ */ jsx217("div", {
                    style: right2,
                    children: "Play / Speed up"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs109(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx217("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx217("kbd", {
                      style: key4,
                      children: "G"
                    })
                  }),
                  /* @__PURE__ */ jsx217("div", {
                    style: right2,
                    children: "Go to frame"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs109(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx217("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx217("kbd", {
                      style: key4,
                      children: "Enter"
                    })
                  }),
                  /* @__PURE__ */ jsx217("div", {
                    style: right2,
                    children: "Pause & return to playback start"
                  })
                ]
              }),
              /* @__PURE__ */ jsx217("br", {}),
              /* @__PURE__ */ jsx217("div", {
                style: title4,
                children: "Sidebar"
              }),
              /* @__PURE__ */ jsxs109(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsxs109("div", {
                    style: left3,
                    children: [
                      /* @__PURE__ */ jsx217("kbd", {
                        style: key4,
                        children: cmdOrCtrlCharacter
                      }),
                      /* @__PURE__ */ jsx217(Spacing, {
                        x: 0.3
                      }),
                      /* @__PURE__ */ jsx217("kbd", {
                        style: key4,
                        children: "B"
                      })
                    ]
                  }),
                  /* @__PURE__ */ jsx217("div", {
                    style: right2,
                    children: "Toggle left sidebar"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs109(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsxs109("div", {
                    style: left3,
                    children: [
                      /* @__PURE__ */ jsx217("kbd", {
                        style: key4,
                        children: cmdOrCtrlCharacter
                      }),
                      /* @__PURE__ */ jsx217(Spacing, {
                        x: 0.3
                      }),
                      /* @__PURE__ */ jsx217("kbd", {
                        style: key4,
                        children: "J"
                      })
                    ]
                  }),
                  /* @__PURE__ */ jsx217("div", {
                    style: right2,
                    children: "Toggle right sidebar"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs109(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsxs109("div", {
                    style: left3,
                    children: [
                      /* @__PURE__ */ jsx217("kbd", {
                        style: key4,
                        children: cmdOrCtrlCharacter
                      }),
                      /* @__PURE__ */ jsx217(Spacing, {
                        x: 0.3
                      }),
                      /* @__PURE__ */ jsx217("kbd", {
                        style: key4,
                        children: "G"
                      })
                    ]
                  }),
                  /* @__PURE__ */ jsx217("div", {
                    style: right2,
                    children: "Toggle both sidebars"
                  })
                ]
              }),
              /* @__PURE__ */ jsx217("br", {}),
              /* @__PURE__ */ jsx217("div", {
                style: title4,
                children: "View"
              }),
              /* @__PURE__ */ jsxs109(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx217("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx217("kbd", {
                      style: key4,
                      children: "F"
                    })
                  }),
                  /* @__PURE__ */ jsx217("div", {
                    style: right2,
                    children: "Enter fullscreen"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs109(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx217("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx217("kbd", {
                      style: key4,
                      children: "Esc"
                    })
                  }),
                  /* @__PURE__ */ jsx217("div", {
                    style: right2,
                    children: "Exit fullscreen"
                  })
                ]
              })
            ]
          }),
          /* @__PURE__ */ jsx217(Spacing, {
            x: 8
          }),
          /* @__PURE__ */ jsxs109(Column, {
            children: [
              /* @__PURE__ */ jsx217("div", {
                style: title4,
                children: "Navigation"
              }),
              /* @__PURE__ */ jsxs109(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx217("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx217("kbd", {
                      style: key4,
                      children: "PageUp"
                    })
                  }),
                  /* @__PURE__ */ jsx217("div", {
                    style: right2,
                    children: "Previous composition"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs109(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx217("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx217("kbd", {
                      style: key4,
                      children: "PageDown"
                    })
                  }),
                  /* @__PURE__ */ jsx217("div", {
                    style: right2,
                    children: "Next composition"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs109(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx217("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx217("kbd", {
                      style: key4,
                      children: "R"
                    })
                  }),
                  /* @__PURE__ */ jsx217("div", {
                    style: right2,
                    children: "Render composition"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs109(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx217("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx217("kbd", {
                      style: key4,
                      children: "T"
                    })
                  }),
                  /* @__PURE__ */ jsx217("div", {
                    style: right2,
                    children: "Toggle checkerboard background"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs109(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx217("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx217("kbd", {
                      style: key4,
                      children: "?"
                    })
                  }),
                  /* @__PURE__ */ jsx217("div", {
                    style: right2,
                    children: "Show keyboard shortcuts"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs109(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsxs109("div", {
                    style: left3,
                    children: [
                      /* @__PURE__ */ jsx217("kbd", {
                        style: key4,
                        children: cmdOrCtrlCharacter
                      }),
                      /* @__PURE__ */ jsx217(Spacing, {
                        x: 0.3
                      }),
                      /* @__PURE__ */ jsx217("kbd", {
                        style: key4,
                        children: "K"
                      })
                    ]
                  }),
                  /* @__PURE__ */ jsx217("div", {
                    style: right2,
                    children: "Quick Switcher"
                  })
                ]
              }),
              /* @__PURE__ */ jsx217("br", {}),
              /* @__PURE__ */ jsx217("div", {
                style: title4,
                children: "Playback range"
              }),
              /* @__PURE__ */ jsxs109(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx217("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx217("kbd", {
                      style: key4,
                      children: "I"
                    })
                  }),
                  /* @__PURE__ */ jsx217("div", {
                    style: right2,
                    children: "Set In Point"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs109(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx217("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx217("kbd", {
                      style: key4,
                      children: "O"
                    })
                  }),
                  /* @__PURE__ */ jsx217("div", {
                    style: right2,
                    children: "Set Out Point"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs109(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx217("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx217("kbd", {
                      style: key4,
                      children: "X"
                    })
                  }),
                  /* @__PURE__ */ jsx217("div", {
                    style: right2,
                    children: "Clear In/Out Points"
                  })
                ]
              }),
              /* @__PURE__ */ jsx217("br", {}),
              /* @__PURE__ */ jsx217("div", {
                style: title4,
                children: "Zoom"
              }),
              /* @__PURE__ */ jsxs109(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx217("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx217("kbd", {
                      style: key4,
                      children: "+"
                    })
                  }),
                  /* @__PURE__ */ jsx217("div", {
                    style: right2,
                    children: "Zoom in"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs109(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx217("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx217("kbd", {
                      style: key4,
                      children: "-"
                    })
                  }),
                  /* @__PURE__ */ jsx217("div", {
                    style: right2,
                    children: "Zoom out"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs109(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx217("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx217("kbd", {
                      style: key4,
                      children: "0"
                    })
                  }),
                  /* @__PURE__ */ jsx217("div", {
                    style: right2,
                    children: "Reset zoom"
                  })
                ]
              }),
              " ",
              /* @__PURE__ */ jsx217("br", {}),
              /* @__PURE__ */ jsx217("div", {
                style: title4,
                children: "Props Editor"
              }),
              /* @__PURE__ */ jsxs109(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsxs109("div", {
                    style: left3,
                    children: [
                      /* @__PURE__ */ jsx217("kbd", {
                        style: key4,
                        children: cmdOrCtrlCharacter
                      }),
                      /* @__PURE__ */ jsx217(Spacing, {
                        x: 0.3
                      }),
                      /* @__PURE__ */ jsx217("kbd", {
                        style: key4,
                        children: "S"
                      })
                    ]
                  }),
                  /* @__PURE__ */ jsx217("div", {
                    style: right2,
                    children: "Save"
                  })
                ]
              }),
              /* @__PURE__ */ jsx217("br", {}),
              /* @__PURE__ */ jsx217("div", {
                style: title4,
                children: "AI"
              }),
              /* @__PURE__ */ jsxs109(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsxs109("div", {
                    style: left3,
                    children: [
                      /* @__PURE__ */ jsx217("kbd", {
                        style: key4,
                        children: cmdOrCtrlCharacter
                      }),
                      /* @__PURE__ */ jsx217(Spacing, {
                        x: 0.3
                      }),
                      /* @__PURE__ */ jsx217("kbd", {
                        style: key4,
                        children: "I"
                      })
                    ]
                  }),
                  /* @__PURE__ */ jsx217("div", {
                    style: right2,
                    children: "Ask AI"
                  })
                ]
              })
            ]
          })
        ]
      })
    ]
  });
};

// src/components/QuickSwitcher/AlgoliaCredit.tsx
import { jsx as jsx218 } from "react/jsx-runtime";
var link = {
  display: "inline-flex"
};
var AlgoliaCredit = () => {
  return /* @__PURE__ */ jsx218("a", {
    style: link,
    href: "https://www.algolia.com/ref/docsearch/?utm_source=www.remotion.dev&utm_medium=referral&utm_content=powered_by&utm_campaign=docsearch",
    target: "_blank",
    rel: "noopener noreferrer",
    children: /* @__PURE__ */ jsx218("svg", {
      width: "77",
      height: "19",
      "aria-label": "Algolia",
      role: "img",
      children: /* @__PURE__ */ jsx218("path", {
        d: "M2.5067 0h14.0245c1.384.001 2.5058 1.1205 2.5068 2.5017V16.5c-.0014 1.3808-1.1232 2.4995-2.5068 2.5H2.5067C1.1232 18.9995.0014 17.8808 0 16.5V2.4958A2.495 2.495 0 01.735.7294 2.505 2.505 0 012.5068 0zM37.95 15.0695c-3.7068.0168-3.7068-2.986-3.7068-3.4634L34.2372.3576 36.498 0v11.1794c0 .2715 0 1.9889 1.452 1.994v1.8961zm-9.1666-1.8388c.694 0 1.2086-.0397 1.5678-.1088v-2.2934a5.3639 5.3639 0 00-1.3303-.1679 4.8283 4.8283 0 00-.758.0582 2.2845 2.2845 0 00-.688.2024c-.2029.0979-.371.2362-.4919.4142-.1268.1788-.185.2826-.185.5533 0 .5297.185.8359.5205 1.0375.3355.2016.7928.3053 1.365.3053v-.0008zm-.1969-8.1817c.7463 0 1.3768.092 1.8856.2767.5088.1838.9195.4428 1.2204.7717.3068.334.5147.7777.6423 1.251.1327.4723.196.991.196 1.5603v5.798c-.5235.1036-1.05.192-1.5787.2649-.7048.1037-1.4976.156-2.3774.156-.5832 0-1.1215-.0582-1.6016-.167a3.385 3.385 0 01-1.2432-.5364 2.6034 2.6034 0 01-.8037-.9565c-.191-.3922-.29-.9447-.29-1.5208 0-.5533.11-.905.3246-1.2863a2.7351 2.7351 0 01.8849-.9329c.376-.242.8029-.415 1.2948-.5187a7.4517 7.4517 0 011.5381-.156 7.1162 7.1162 0 011.6667.2024V8.886c0-.259-.0296-.5061-.093-.7372a1.5847 1.5847 0 00-.3245-.6158 1.5079 1.5079 0 00-.6119-.4158 2.6788 2.6788 0 00-.966-.173c-.5206 0-.9948.0634-1.4283.1384a6.5481 6.5481 0 00-1.065.259l-.2712-1.849c.2831-.0986.7048-.1964 1.2491-.2943a9.2979 9.2979 0 011.752-.1501v.0008zm44.6597 8.1193c.6947 0 1.2086-.0405 1.567-.1097v-2.2942a5.3743 5.3743 0 00-1.3303-.1679c-.2485 0-.503.0177-.7573.0582a2.2853 2.2853 0 00-.688.2024 1.2333 1.2333 0 00-.4918.4142c-.1268.1788-.1843.2826-.1843.5533 0 .5297.1843.8359.5198 1.0375.3414.2066.7927.3053 1.365.3053v.0009zm-.191-8.1767c.7463 0 1.3768.0912 1.8856.2759.5087.1847.9195.4436 1.2204.7717.3.329.5147.7786.6414 1.251a5.7248 5.7248 0 01.197 1.562v5.7972c-.3466.0742-.874.1602-1.5788.2648-.7049.1038-1.4976.1552-2.3774.1552-.5832 0-1.1215-.0573-1.6016-.167a3.385 3.385 0 01-1.2432-.5356 2.6034 2.6034 0 01-.8038-.9565c-.191-.3922-.2898-.9447-.2898-1.5216 0-.5533.1098-.905.3245-1.2854a2.7373 2.7373 0 01.8849-.9338c.376-.2412.8029-.4141 1.2947-.5178a7.4545 7.4545 0 012.325-.1097c.2781.0287.5672.081.879.156v-.3686a2.7781 2.7781 0 00-.092-.738 1.5788 1.5788 0 00-.3246-.6166 1.5079 1.5079 0 00-.612-.415 2.6797 2.6797 0 00-.966-.1729c-.5205 0-.9947.0633-1.4282.1384a6.5608 6.5608 0 00-1.065.259l-.2712-1.8498c.283-.0979.7048-.1957 1.2491-.2935a9.8597 9.8597 0 011.752-.1494zm-6.79-1.072c-.7576.001-1.373-.6103-1.3759-1.3664 0-.755.6128-1.3664 1.376-1.3664.764 0 1.3775.6115 1.3775 1.3664s-.6195 1.3664-1.3776 1.3664zm1.1393 11.1507h-2.2726V5.3409l2.2734-.3568v10.0845l-.0008.0017zm-3.984 0c-3.707.0168-3.707-2.986-3.707-3.4642L59.7069.3576 61.9685 0v11.1794c0 .2715 0 1.9889 1.452 1.994V15.0703zm-7.3512-4.979c0-.975-.2138-1.7873-.6305-2.3516-.4167-.571-.9998-.852-1.747-.852-.7454 0-1.3302.281-1.7452.852-.4166.5702-.6195 1.3765-.6195 2.3516 0 .9851.208 1.6473.6254 2.2183.4158.576.9998.8587 1.7461.8587.7454 0 1.3303-.2885 1.747-.8595.4158-.5761.6237-1.2315.6237-2.2184v.0009zm2.3132-.006c0 .7609-.1099 1.3361-.3356 1.9654a4.654 4.654 0 01-.9533 1.6076A4.214 4.214 0 0155.613 14.69c-.579.2412-1.4697.3795-1.9143.3795-.4462-.005-1.3303-.1324-1.9033-.3795a4.307 4.307 0 01-1.474-1.0316c-.4115-.4445-.7293-.9801-.9609-1.6076a5.3423 5.3423 0 01-.3465-1.9653c0-.7608.104-1.493.3356-2.1155a4.683 4.683 0 01.9719-1.5958 4.3383 4.3383 0 011.479-1.0257c.5739-.242 1.2043-.3567 1.8864-.3567.6829 0 1.3125.1197 1.8906.3567a4.1245 4.1245 0 011.4816 1.0257 4.7587 4.7587 0 01.9592 1.5958c.2426.6225.3643 1.3547.3643 2.1155zm-17.0198 0c0 .9448.208 1.9932.6238 2.431.4166.4386.955.6579 1.6142.6579.3584 0 .6998-.0523 1.0176-.1502.3186-.0978.5721-.2134.775-.3517V7.0784a8.8706 8.8706 0 00-1.4926-.1906c-.8206-.0236-1.4452.312-1.8847.8468-.4335.5365-.6533 1.476-.6533 2.3516v-.0008zm6.2863 4.4485c0 1.5385-.3938 2.662-1.1866 3.3773-.791.7136-2.0005 1.0712-3.6308 1.0712-.5958 0-1.834-.1156-2.8228-.334l.3643-1.7865c.8282.173 1.9202.2193 2.4932.2193.9077 0 1.555-.1847 1.943-.5533.388-.3686.578-.916.578-1.643v-.3687a6.8289 6.8289 0 01-.8848.3349c-.3634.1096-.786.167-1.261.167-.6246 0-1.1917-.0979-1.7055-.2944a3.5554 3.5554 0 01-1.3244-.8645c-.3642-.3796-.6541-.8579-.8561-1.4289-.2028-.571-.3068-1.59-.3068-2.339 0-.7034.1099-1.5856.3245-2.1735.2198-.5871.5316-1.0949.9542-1.515.4167-.42.9255-.743 1.5213-.98a5.5923 5.5923 0 012.052-.3855c.7353 0 1.4114.092 2.0707.2024.6592.1088 1.2204.2236 1.6776.35v8.945-.0008zM11.5026 4.2418v-.6511c-.0005-.4553-.3704-.8241-.8266-.8241H8.749c-.4561 0-.826.3688-.8265.824v.669c0 .0742.0693.1264.1445.1096a6.0346 6.0346 0 011.6768-.2362 6.125 6.125 0 011.6202.2185.1116.1116 0 00.1386-.1097zm-5.2806.852l-.3296-.3282a.8266.8266 0 00-1.168 0l-.393.3922a.8199.8199 0 000 1.164l.3237.323c.0524.0515.1268.0397.1733-.0117.191-.259.3989-.507.6305-.7372.2374-.2362.48-.4437.7462-.6335.0575-.0354.0634-.1155.017-.1687zm3.5159 2.069v2.818c0 .081.0879.1392.1622.0987l2.5102-1.2964c.0574-.0287.0752-.0987.0464-.1552a3.1237 3.1237 0 00-2.603-1.574c-.0575 0-.115.0456-.115.1097l-.0008-.0009zm.0008 6.789c-2.0933.0005-3.7915-1.6912-3.7947-3.7804C5.9468 8.0821 7.6452 6.39 9.7387 6.391c2.0932-.0005 3.7911 1.6914 3.794 3.7804a3.7783 3.7783 0 01-1.1124 2.675 3.7936 3.7936 0 01-2.6824 1.1054h.0008zM9.738 4.8002c-1.9218 0-3.6975 1.0232-4.6584 2.6841a5.359 5.359 0 000 5.3683c.9609 1.661 2.7366 2.6841 4.6584 2.6841a5.3891 5.3891 0 003.8073-1.5725 5.3675 5.3675 0 001.578-3.7987 5.3574 5.3574 0 00-1.5771-3.797A5.379 5.379 0 009.7387 4.801l-.0008-.0008z",
        fill: "currentColor",
        fillRule: "evenodd"
      })
    })
  });
};

// src/components/QuickSwitcher/NoResults.tsx
import { jsxs as jsxs110 } from "react/jsx-runtime";
var container48 = {
  padding: 80,
  color: LIGHT_TEXT,
  textAlign: "center",
  fontSize: 14
};
var MODE_TO_STRING = {
  commands: "commands",
  compositions: "compositions",
  docs: "documentation"
};
var QuickSwitcherNoResults = ({ query, mode }) => {
  return /* @__PURE__ */ jsxs110("div", {
    style: container48,
    children: [
      "No ",
      MODE_TO_STRING[mode],
      " matching ",
      '"',
      query,
      '"'
    ]
  });
};

// src/components/QuickSwitcher/QuickSwitcherResult.tsx
import { useEffect as useEffect71, useMemo as useMemo114, useRef as useRef37, useState as useState70 } from "react";
import { jsx as jsx219, jsxs as jsxs111, Fragment as Fragment33 } from "react/jsx-runtime";
var container49 = {
  paddingLeft: 16,
  paddingRight: 16,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  cursor: "pointer"
};
var label8 = {
  whiteSpace: "nowrap",
  textOverflow: "ellipsis"
};
var searchLabel = {
  ...label8,
  lineHeight: 1.25
};
var iconStyle6 = {
  width: 14,
  height: 14
};
var labelContainer = {
  overflow: "hidden",
  flex: 1,
  paddingTop: 5,
  paddingBottom: 5
};
var QuickSwitcherResult = ({ result, selected }) => {
  const [hovered, setIsHovered] = useState70(false);
  const ref = useRef37(null);
  const keybindings = useKeybinding();
  useEffect71(() => {
    const { current } = ref;
    if (!current) {
      return;
    }
    const onMouseEnter = () => setIsHovered(true);
    const onMouseLeave = () => setIsHovered(false);
    current.addEventListener("mouseenter", onMouseEnter);
    current.addEventListener("mouseleave", onMouseLeave);
    return () => {
      current.removeEventListener("mouseenter", onMouseEnter);
      current.removeEventListener("mouseleave", onMouseLeave);
    };
  }, []);
  useEffect71(() => {
    if (!selected) {
      return;
    }
    const binding = keybindings.registerKeybinding({
      key: "Enter",
      callback: result.onSelected,
      commandCtrlKey: false,
      event: "keydown",
      preventDefault: true,
      triggerIfInputFieldFocused: true,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      binding.unregister();
    };
  }, [keybindings, result.onSelected, selected]);
  useEffect71(() => {
    if (selected) {
      ref.current?.scrollIntoView({
        block: "nearest",
        inline: "center"
      });
    }
  }, [selected]);
  const style11 = useMemo114(() => {
    return {
      ...container49,
      backgroundColor: getBackgroundFromHoverState({
        hovered,
        selected
      })
    };
  }, [hovered, selected]);
  const labelStyle5 = useMemo114(() => {
    return {
      ...result.type === "search-result" ? searchLabel : label8,
      color: result.type === "search-result" ? LIGHT_TEXT : selected || hovered ? "white" : LIGHT_TEXT,
      fontSize: 15
    };
  }, [hovered, result.type, selected]);
  return /* @__PURE__ */ jsxs111("div", {
    ref,
    style: style11,
    onClick: result.onSelected,
    children: [
      result.type === "composition" ? result.compositionType === "still" ? /* @__PURE__ */ jsx219(StillIcon, {
        color: selected ? "white" : LIGHT_TEXT,
        style: iconStyle6
      }) : /* @__PURE__ */ jsx219(FilmIcon, {
        color: selected ? "white" : LIGHT_TEXT,
        style: iconStyle6
      }) : null,
      /* @__PURE__ */ jsx219(Spacing, {
        x: 1
      }),
      /* @__PURE__ */ jsx219("div", {
        style: labelContainer,
        children: result.type === "search-result" ? /* @__PURE__ */ jsxs111(Fragment33, {
          children: [
            /* @__PURE__ */ jsx219("div", {
              dangerouslySetInnerHTML: {
                __html: result.titleLine
              },
              style: labelStyle5
            }),
            /* @__PURE__ */ jsx219("div", {
              dangerouslySetInnerHTML: {
                __html: result.subtitleLine
              },
              style: labelStyle5
            })
          ]
        }) : /* @__PURE__ */ jsx219("div", {
          style: labelStyle5,
          children: result.title
        })
      })
    ]
  }, result.id);
};

// src/components/QuickSwitcher/algolia-search.ts
import { NoReactInternals as NoReactInternals15 } from "remotion/no-react";
var ALGOLIA_API_KEY = "3e42dbd4f895fe93ff5cf40d860c4a85";
var ALGOLIA_APPLICATION_ID = "PLSDUOL1CA";
var AGOLIA_SEARCH_URL = "https://plsduol1ca-dsn.algolia.net/1/indexes/*/queries";
var algoliaSearch = async (query) => {
  const url = new URL(AGOLIA_SEARCH_URL);
  url.searchParams.set("x-algolia-agen", encodeURIComponent("Remotion Studio DocSearch"));
  url.searchParams.set("x-algolia-api-key", ALGOLIA_API_KEY);
  url.searchParams.set("x-algolia-application-id", ALGOLIA_APPLICATION_ID);
  const { results } = await fetch(url.toString(), {
    headers: {
      "content-type": "application/x-www-form-urlencoded"
    },
    body: JSON.stringify({
      requests: [
        {
          query,
          indexName: "remotion",
          params: 'attributesToRetrieve=["hierarchy.lvl0","hierarchy.lvl1","hierarchy.lvl2","hierarchy.lvl3","hierarchy.lvl4","hierarchy.lvl5","hierarchy.lvl6","content","type","url"]&attributesToSnippet=["hierarchy.lvl1:10","hierarchy.lvl2:10","hierarchy.lvl3:10","hierarchy.lvl4:10","hierarchy.lvl5:10","hierarchy.lvl6:10","content:10"]&hitsPerPage=20'
        }
      ]
    }),
    method: "POST"
  }).then((res) => res.json());
  const { hits } = results[0];
  return hits.map((hit) => {
    const entries = Object.values(hit._highlightResult.hierarchy);
    const result = entries.find((value) => value.matchLevel === "full") ?? entries.find((value) => value.matchLevel === "partial");
    const { subtitle: subtitle3, title: title5 } = splitMatchIntoTitleAndSubtitle(hit);
    if (!result) {
      return null;
    }
    return {
      type: "search-result",
      id: hit.objectID,
      title: "Should not display",
      titleLine: title5,
      subtitleLine: subtitle3,
      onSelected: () => {
        window.open(hit.url);
      }
    };
  }).filter(NoReactInternals15.truthy);
};
var splitMatchIntoTitleAndSubtitle = (match) => {
  const main = match.type === "content" ? match._highlightResult.content : match._highlightResult.hierarchy[match.type];
  const title5 = main.value;
  const subtitle3 = Object.entries(match._highlightResult.hierarchy).filter(([level]) => level !== match.type).map((value) => value[1].value).join(" • ");
  return { title: title5, subtitle: subtitle3 };
};

// src/components/QuickSwitcher/fuzzy-search.ts
function fuzzySearch(query, dataset) {
  const q = query ? query.trim().toLowerCase() : "";
  const matchingIndices = [];
  if (q.length === 0) {
    for (let i = 0;i < dataset.length; i++) {
      matchingIndices.push(i);
    }
    return dataset.filter((_, i) => matchingIndices.includes(i));
  }
  dataset.forEach((d, index) => {
    const s = d.title.trim().toLowerCase();
    let i = 0;
    let n = -1;
    let l;
    for (;l = q[i++]; )
      if (!~(n = s.indexOf(l, n + 1)))
        return;
    matchingIndices.push(index);
  });
  return dataset.filter((_, i) => matchingIndices.includes(i));
}

// src/components/QuickSwitcher/QuickSwitcherContent.tsx
import { jsx as jsx220, jsxs as jsxs112, Fragment as Fragment34 } from "react/jsx-runtime";
var input2 = {
  width: "100%"
};
var modeSelector = {
  paddingLeft: 16,
  paddingRight: 16,
  display: "flex",
  flexDirection: "row",
  paddingTop: 8,
  paddingBottom: 5
};
var modeItem = {
  appearance: "none",
  border: "none",
  fontFamily: "inherit",
  padding: 0,
  fontSize: 13,
  cursor: "pointer"
};
var modeInactive = {
  ...modeItem,
  color: LIGHT_TEXT
};
var modeActive = {
  ...modeItem,
  color: "white",
  fontWeight: "bold"
};
var content6 = {
  paddingLeft: 16,
  paddingRight: 16,
  paddingTop: 4,
  paddingBottom: 10,
  display: "flex",
  flexDirection: "row",
  alignItems: "center"
};
var loopIndex = (index, length) => {
  if (index < 0) {
    index += length;
  }
  return index % length;
};
var stripQuery = (query) => {
  if (query.startsWith(">") || query.startsWith("?")) {
    return query.substring(1).trim();
  }
  return query.trim();
};
var mapQueryToMode = (query) => {
  return query.startsWith(">") ? "commands" : query.startsWith("?") ? "docs" : "compositions";
};
var mapModeToQuery = (mode) => {
  if (mode === "commands") {
    return "> ";
  }
  if (mode === "compositions") {
    return "";
  }
  if (mode === "docs") {
    return "? ";
  }
  throw new Error("no mode" + mode);
};
var QuickSwitcherContent = ({ initialMode, invocationTimestamp, readOnlyStudio }) => {
  const { compositions } = useContext77(Internals61.CompositionManager);
  const [state, setState] = useState71(() => {
    return {
      query: mapModeToQuery(initialMode),
      selectedIndex: 0
    };
  });
  useEffect72(() => {
    setState({
      query: mapModeToQuery(initialMode),
      selectedIndex: 0
    });
  }, [initialMode, invocationTimestamp]);
  const inputRef = useRef38(null);
  const selectComposition = useSelectComposition();
  const closeMenu = useCallback106(() => {
    return;
  }, []);
  const actions = useMenuStructure(closeMenu, readOnlyStudio);
  const [docResults, setDocResults] = useState71({ type: "initial" });
  const { setSelectedModal } = useContext77(ModalsContext);
  const keybindings = useKeybinding();
  const mode = mapQueryToMode(state.query);
  const actualQuery = useMemo115(() => {
    return stripQuery(state.query);
  }, [state.query]);
  const menuActions = useMemo115(() => {
    if (mode !== "commands") {
      return [];
    }
    return makeSearchResults(actions, setSelectedModal);
  }, [actions, mode, setSelectedModal]);
  const resultsArray = useMemo115(() => {
    if (mode === "commands") {
      return fuzzySearch(actualQuery, menuActions);
    }
    if (mode === "docs" && docResults.type === "results") {
      return docResults.results;
    }
    return fuzzySearch(actualQuery, compositions.map((c) => {
      return {
        id: "composition-" + c.id,
        title: c.id,
        type: "composition",
        onSelected: () => {
          selectComposition(c, true);
          setSelectedModal(null);
          const selector = `.__remotion-composition[data-compname="${c.id}"]`;
          Internals61.compositionSelectorRef.current?.expandComposition(c.id);
          waitForElm(selector).then(() => {
            document.querySelector(selector)?.scrollIntoView({ block: "center" });
          });
        },
        compositionType: isCompositionStill(c) ? "still" : "composition"
      };
    }));
  }, [
    mode,
    actualQuery,
    compositions,
    menuActions,
    docResults,
    selectComposition,
    setSelectedModal
  ]);
  const onArrowDown = useCallback106(() => {
    setState((s) => {
      return {
        ...s,
        selectedIndex: s.selectedIndex + 1
      };
    });
  }, []);
  const onArrowUp = useCallback106(() => {
    setState((s) => {
      return {
        ...s,
        selectedIndex: s.selectedIndex - 1
      };
    });
  }, []);
  useEffect72(() => {
    const binding = keybindings.registerKeybinding({
      key: "ArrowUp",
      callback: onArrowUp,
      commandCtrlKey: false,
      event: "keydown",
      preventDefault: true,
      triggerIfInputFieldFocused: true,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      binding.unregister();
    };
  }, [keybindings, onArrowDown, onArrowUp]);
  useEffect72(() => {
    if (mode !== "docs") {
      return;
    }
    if (actualQuery.trim() === "") {
      setDocResults({ type: "initial" });
      return;
    }
    let cancelled = false;
    setDocResults({ type: "loading" });
    algoliaSearch(actualQuery).then((agoliaResults) => {
      if (cancelled) {
        return;
      }
      setDocResults({ type: "results", results: agoliaResults });
    }).catch((err) => {
      if (cancelled) {
        return;
      }
      setDocResults({ type: "error", error: err });
    });
    return () => {
      cancelled = true;
    };
  }, [actualQuery, mode]);
  useEffect72(() => {
    const binding = keybindings.registerKeybinding({
      key: "ArrowDown",
      callback: onArrowDown,
      commandCtrlKey: false,
      event: "keydown",
      preventDefault: true,
      triggerIfInputFieldFocused: true,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      binding.unregister();
    };
  }, [keybindings, onArrowDown]);
  const onTextChange = useCallback106((e) => {
    setState({ query: e.target.value, selectedIndex: 0 });
  }, []);
  const selectedIndexRounded = loopIndex(state.selectedIndex, resultsArray.length);
  const onActionsSelected = useCallback106(() => {
    setState((s) => ({
      query: `> ${stripQuery(s.query)}`,
      selectedIndex: 0
    }));
    inputRef.current?.focus();
  }, []);
  const onCompositionsSelected = useCallback106(() => {
    setState((s) => ({
      query: stripQuery(s.query),
      selectedIndex: 0
    }));
    inputRef.current?.focus();
  }, []);
  const onDocSearchSelected = useCallback106(() => {
    setState((s) => ({
      query: `? ${stripQuery(s.query)}`,
      selectedIndex: 0
    }));
    setDocResults({ type: "initial" });
    inputRef.current?.focus();
  }, []);
  const showKeyboardShortcuts = mode === "docs" && actualQuery.trim() === "";
  const showSearchLoadingState = mode === "docs" && docResults.type === "loading";
  const container50 = useMemo115(() => {
    return {
      width: showKeyboardShortcuts ? 800 : 500
    };
  }, [showKeyboardShortcuts]);
  const results = useMemo115(() => {
    if (showKeyboardShortcuts) {
      return {
        maxHeight: 600,
        overflowY: "auto"
      };
    }
    return {
      overflowY: "auto",
      height: 300
    };
  }, [showKeyboardShortcuts]);
  return /* @__PURE__ */ jsxs112("div", {
    style: container50,
    children: [
      /* @__PURE__ */ jsxs112("div", {
        style: modeSelector,
        children: [
          /* @__PURE__ */ jsx220("button", {
            onClick: onCompositionsSelected,
            style: mode === "compositions" ? modeActive : modeInactive,
            type: "button",
            children: "Compositions"
          }),
          /* @__PURE__ */ jsx220(Spacing, {
            x: 1
          }),
          /* @__PURE__ */ jsx220("button", {
            onClick: onActionsSelected,
            style: mode === "commands" ? modeActive : modeInactive,
            type: "button",
            children: "Actions"
          }),
          /* @__PURE__ */ jsx220(Spacing, {
            x: 1
          }),
          /* @__PURE__ */ jsx220("button", {
            onClick: onDocSearchSelected,
            style: mode === "docs" ? modeActive : modeInactive,
            type: "button",
            children: "Documentation"
          })
        ]
      }),
      /* @__PURE__ */ jsxs112("div", {
        style: content6,
        children: [
          /* @__PURE__ */ jsx220(RemotionInput, {
            ref: inputRef,
            type: "text",
            style: input2,
            autoFocus: true,
            status: "ok",
            value: state.query,
            onChange: onTextChange,
            placeholder: "Search compositions...",
            rightAlign: false
          }),
          showKeyboardShortcuts ? /* @__PURE__ */ jsxs112(Fragment34, {
            children: [
              /* @__PURE__ */ jsx220(Spacing, {
                x: 2
              }),
              " ",
              /* @__PURE__ */ jsx220(AlgoliaCredit, {})
            ]
          }) : null
        ]
      }),
      /* @__PURE__ */ jsx220("div", {
        style: results,
        className: VERTICAL_SCROLLBAR_CLASSNAME,
        children: showKeyboardShortcuts ? /* @__PURE__ */ jsx220(KeyboardShortcutsExplainer, {}) : showSearchLoadingState ? null : resultsArray.length === 0 ? /* @__PURE__ */ jsx220(QuickSwitcherNoResults, {
          mode,
          query: actualQuery
        }) : resultsArray.map((result, i) => {
          return /* @__PURE__ */ jsx220(QuickSwitcherResult, {
            selected: selectedIndexRounded === i,
            result
          }, result.id);
        })
      })
    ]
  });
};
function waitForElm(selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      resolve(document.querySelector(selector));
      return;
    }
    const observer = new MutationObserver(() => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}

// src/components/QuickSwitcher/QuickSwitcher.tsx
import { jsx as jsx221 } from "react/jsx-runtime";
var QuickSwitcher = ({ initialMode, invocationTimestamp, readOnlyStudio }) => {
  return /* @__PURE__ */ jsx221(DismissableModal, {
    children: /* @__PURE__ */ jsx221(QuickSwitcherContent, {
      readOnlyStudio,
      invocationTimestamp,
      initialMode
    })
  });
};
var QuickSwitcher_default = QuickSwitcher;

// src/components/RenderModal/RenderModal.tsx
import { BrowserSafeApis as BrowserSafeApis10 } from "@remotion/renderer/client";
import { getDefaultOutLocation } from "@remotion/studio-shared";
import {
  useCallback as useCallback124,
  useContext as useContext79,
  useEffect as useEffect75,
  useMemo as useMemo125,
  useReducer as useReducer2,
  useRef as useRef40,
  useState as useState77
} from "react";

// src/helpers/convert-env-variables.ts
var envVariablesObjectToArray = (envVariables) => {
  return Object.entries(envVariables).map(([key5, one]) => [
    key5.trim().toUpperCase(),
    one.trim()
  ]);
};
var envVariablesArrayToObject = (envVariables) => {
  return envVariables.map(([key5, val]) => [key5.trim(), val.trim()]).filter(([key5, val]) => key5 && val).reduce((acc, [key5, value]) => {
    acc[key5.toUpperCase()] = value;
    return acc;
  }, {});
};

// src/helpers/render-modal-sections.ts
import { useMemo as useMemo116, useState as useState72 } from "react";
var useRenderModalSections = (renderMode, codec) => {
  const [selectedTab, setTab] = useState72("general");
  const shownTabs = useMemo116(() => {
    if (renderMode === "audio") {
      return ["general", "data", "audio", "advanced"];
    }
    if (renderMode === "still") {
      return ["general", "data", "picture", "advanced"];
    }
    if (renderMode === "sequence") {
      return ["general", "data", "picture", "advanced"];
    }
    if (renderMode === "video") {
      if (codec === "gif") {
        return ["general", "data", "picture", "gif", "advanced"];
      }
      return ["general", "data", "picture", "audio", "advanced"];
    }
    throw new TypeError("Unknown render mode");
  }, [codec, renderMode]);
  const tab = useMemo116(() => {
    if (!shownTabs.includes(selectedTab)) {
      return shownTabs[0];
    }
    return selectedTab;
  }, [selectedTab, shownTabs]);
  return useMemo116(() => {
    return { tab, setTab, shownTabs };
  }, [tab, shownTabs]);
};

// src/icons/audio.tsx
import { jsx as jsx222 } from "react/jsx-runtime";
var AudioIcon = (props) => /* @__PURE__ */ jsx222("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  ...props,
  children: /* @__PURE__ */ jsx222("path", {
    fill: "currentcolor",
    d: "M243 32.32C105.5 39.15 0 157.8 0 295.5v120.4C0 451.3 28.63 480 64 480h32c17.62 0 32-14.38 32-32V288c0-17.62-14.38-32-32-32H64c-10.79 0-20.8 2.9-29.72 7.7 14.2-106.8 100.5-193.9 210.4-199.4 120.5-5.965 221.7 83.92 234 199.9-9.08-5.1-19.48-8.2-30.68-8.2h-32c-17.62 0-32 14.38-32 32v160c0 17.62 14.38 32 32 32h32c35.38 0 64-28.75 64-64.13V287.9c0-145.4-122-262.88-269-255.58zM64 288h32v160H64c-17.62 0-32-14.5-32-32.13v-95.75C32 302.5 46.38 288 64 288zm416 127.9c0 17.6-14.4 32.1-32 32.1h-32V288h32c17.62 0 32 14.5 32 32.13v95.77z"
  })
});

// src/icons/data.tsx
import { jsx as jsx223 } from "react/jsx-runtime";
var DataIcon = (props) => {
  return /* @__PURE__ */ jsx223("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ...props,
    children: /* @__PURE__ */ jsx223("path", {
      fill: "currentcolor",
      d: "M224 512C100.3 512 0 476.2 0 432V80C0 35.82 100.3 0 224 0C347.7 0 448 35.82 448 80V432C448 476.2 347.7 512 224 512zM416 80.45C415.7 79.69 414.4 77.27 409.8 73.31C402.4 67.11 389.9 60.09 371.6 53.57C335.4 40.62 283.2 32 224 32C164.8 32 112.6 40.62 76.37 53.57C58.1 60.09 45.59 67.11 38.25 73.31C33.55 77.27 32.29 79.69 32 80.45V182.1C46.47 192.7 69.9 202.8 100.9 210.4C135.5 218.9 177.1 224 224 224C270 224 312.5 218.9 347.1 210.4C378.1 202.8 401.5 192.7 416 182.1V80.45zM416 219.5C398.8 228.4 377.9 235.8 354.8 241.5C317.3 250.7 272.2 256 224 256C175.8 256 130.7 250.7 93.22 241.5C70.11 235.8 49.18 228.4 32 219.5V310.1C46.47 320.7 69.9 330.8 100.9 338.4C135.5 346.9 177.1 352 224 352C270 352 312.5 346.9 347.1 338.4C378.1 330.8 401.5 320.7 416 310.1V219.5zM38.25 438.7C45.59 444.9 58.1 451.9 76.37 458.4C112.6 471.4 164.8 480 224 480C283.2 480 335.4 471.4 371.6 458.4C389.9 451.9 402.4 444.9 409.8 438.7C414.4 434.7 415.7 432.3 416 431.6V347.5C398.8 356.4 377.9 363.8 354.8 369.5C317.3 378.7 272.2 384 224 384C175.8 384 130.7 378.7 93.22 369.5C70.11 363.8 49.18 356.4 32 347.5V431.6C32.29 432.3 33.55 434.7 38.25 438.7zM416 431.4C416.1 431.3 416.1 431.3 416.1 431.3L416 431.4zM31.96 431.4C31.94 431.3 31.93 431.3 31.92 431.3L31.96 431.4zM31.96 80.56C31.93 80.65 31.92 80.7 31.92 80.7L31.96 80.56zM416.1 80.7C416.1 80.7 416.1 80.65 416 80.56z"
    })
  });
};

// src/icons/frame.tsx
import { jsx as jsx224 } from "react/jsx-runtime";
var PicIcon = (props) => /* @__PURE__ */ jsx224("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  ...props,
  children: /* @__PURE__ */ jsx224("path", {
    fill: "currentcolor",
    d: "M324.9 157.8c-11.38-17.38-39.89-17.31-51.23-.063L200.5 268.5l-16.4-22.6c-11.4-16.8-38.2-16-49.7 0l-64.52 89.16c-6.797 9.406-7.75 21.72-2.547 32C72.53 377.5 83.05 384 94.75 384h322.5c11.41 0 21.8-6.281 27.14-16.38a30.922 30.922 0 0 0-1.516-31.56L324.9 157.8zM95.8 352l62.39-87.38 29.91 41.34c3.1 4.24 8.3 7.24 13.3 6.64 5.25-.125 10.12-2.781 13.02-7.188l83.83-129.9L415 352H95.8zM447.1 32h-384C28.65 32-.01 60.65-.01 96v320c0 35.35 28.65 64 63.1 64h384c35.35 0 64-28.65 64-64V96c.01-35.35-27.79-64-63.99-64zM480 416c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V96c0-17.64 14.36-32 32-32h384c17.64 0 32 14.36 32 32v320zM144 192c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm0-64c8.822 0 15.1 7.178 15.1 16s-6.3 16-15.1 16-16-7.2-16-16 7.2-16 16-16z"
  })
});

// src/icons/gear.tsx
import { jsx as jsx225 } from "react/jsx-runtime";
var GearIcon = (props) => /* @__PURE__ */ jsx225("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  ...props,
  children: /* @__PURE__ */ jsx225("path", {
    fill: "currentcolor",
    d: "M168 255.1c0-47.7 39.4-88 88-88s88 40.3 88 88c0 49.5-39.4 88.9-88 88.9s-88-39.4-88-88.9zm88-56c-30.9 0-56 26-56 56 0 31.8 25.1 56 56 56s56-24.2 56-56c0-30-25.1-56-56-56zM65.67 230.6l-40.33-36.8c-11.12-10.1-13.68-26.6-6.16-39.6l30.24-52.4c7.52-13.02 23.09-19.05 37.42-14.48l51.96 16.58c13.4-10.34 28.2-18.94 44-25.47l11.7-53.27C197.7 10.47 210.7 0 225.8 0h60.4c15.1 0 28.1 10.47 31.3 25.16l11.7 53.27c14.9 6.53 30.6 15.13 44 25.47l52-16.58c14.3-4.57 29.9 1.46 37.4 14.48l30.2 52.4c7.5 13 5 29.5-6.1 39.6l-40.4 36.8c1.1 8.3 1.7 16.8 1.7 24.5 0 9.5-.6 18-1.7 26.3l40.4 36.8c11.1 10.1 13.6 26.6 6.1 39.6l-30.2 52.4c-7.5 13-23.1 19-37.4 14.5l-52-16.6c-13.4 10.3-29.1 18.9-44 25.5l-11.7 53.2c-3.2 14.7-16.2 25.2-31.3 25.2h-60.4c-15.1 0-28.1-10.5-31.3-25.2l-11.7-53.2c-15.8-6.6-30.6-15.2-44-25.5l-51.96 16.6c-14.33 4.5-29.9-1.5-37.42-14.5l-30.24-52.4c-7.52-13-4.96-29.5 6.16-39.6l40.33-36.8c-1.1-8.3-1.67-16.8-1.67-26.3 0-7.7.57-16.2 1.67-24.5zm92.73-101.4-13.3 10.3-67.97-21.7-30.24 52.4 52.69 48-2.19 16.6c-.92 6.9-1.39 14-1.39 20.3 0 8.1.47 15.2 1.39 22.1l2.19 16.6-52.69 48 30.24 52.4 67.97-21.7 13.3 10.3c11.1 8.6 23.5 15.8 36.6 20.3l15.5 7.3 15.3 69.6h60.4l15.3-69.6 14.6-7.3c14-4.5 26.4-11.7 37.5-20.3l13.3-10.3 68 21.7 30.2-52.4-52.7-48 2.2-16.6c.9-6.9 1.4-14 1.4-21.2 0-7.2-.5-14.3-1.4-21.2l-2.2-16.6 52.7-48-30.2-52.4-68 21.7-13.3-10.3c-11.1-8.6-23.5-15.8-37.5-21.2l-14.6-6.4L286.2 32h-60.4l-15.3 69.6L195 108c-13.1 5.4-25.5 12.6-36.6 21.2z"
  })
});

// src/icons/gif.tsx
import { jsx as jsx226 } from "react/jsx-runtime";
var GifIcon = (props) => /* @__PURE__ */ jsx226("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 576 512",
  ...props,
  children: /* @__PURE__ */ jsx226("path", {
    fill: "currentcolor",
    d: "M512 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h448c35.35 0 64-28.65 64-64V96c0-35.35-28.7-64-64-64zm32 384c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V96c0-17.64 14.36-32 32-32h448c17.64 0 32 14.36 32 32v320zm-80-256h-96c-8.8 0-16 7.2-16 16v160c0 8.844 7.156 16 16 16s16-7.156 16-16v-64h56c8.844 0 16-7.156 16-16s-7.156-16-16-16h-56v-48h80c8.8 0 16-7.2 16-16s-7.2-16-16-16zm-160 0c-8.8 0-16 7.2-16 16v160c0 8.844 7.156 16 16 16s16-7.156 16-16V176c0-8.8-7.2-16-16-16zm-64 80h-64c-8.8 0-16 7.2-16 16s7.156 16 16 16h48v33.45c-24.83 19.91-69.13 18.16-91.48-4.203-24.95-24.95-24.95-65.55 0-90.5 25.03-25 64.19-25 89.22 0 6.25 6.25 16.38 6.25 22.62 0s6.25-16.38 0-22.62c-37.69-37.72-96.78-37.72-134.5 0-37.42 37.42-37.42 98.33 0 135.8C127.8 341.8 153.5 352 180.6 352c27.06 0 52.84-10.25 70.7-28.12 3-2.98 4.7-7.08 4.7-11.28V256c0-8.8-7.2-16-16-16z"
  })
});

// src/components/Tabs/vertical.tsx
import { useCallback as useCallback107, useMemo as useMemo117, useState as useState73 } from "react";
import { jsx as jsx227 } from "react/jsx-runtime";
var selectorButton2 = {
  border: "none",
  flex: 1,
  padding: 8,
  paddingLeft: 16,
  display: "flex",
  flexDirection: "row",
  fontSize: 14,
  color: "inherit",
  alignItems: "center"
};
var VerticalTab = ({ children, onClick, style: style11, selected }) => {
  const [hovered, setHovered] = useState73(false);
  const { tabIndex } = useZIndex();
  const onPointerEnter = useCallback107(() => {
    setHovered(true);
  }, []);
  const onPointerLeave = useCallback107(() => {
    setHovered(false);
  }, []);
  const definiteStyle = useMemo117(() => {
    return {
      ...selectorButton2,
      backgroundColor: selected ? SELECTED_BACKGROUND : hovered ? CLEAR_HOVER : "transparent",
      color: selected ? "white" : LIGHT_TEXT,
      boxShadow: selected ? "none" : undefined,
      ...style11
    };
  }, [hovered, selected, style11]);
  return /* @__PURE__ */ jsx227("button", {
    style: definiteStyle,
    type: "button",
    onClick,
    tabIndex,
    onPointerLeave,
    onPointerEnter,
    children
  });
};

// src/components/RenderModal/CrfSetting.tsx
import { BrowserSafeApis as BrowserSafeApis2 } from "@remotion/renderer/client";
import { useState as useState75 } from "react";

// src/components/RenderModal/NumberSetting.tsx
import { useCallback as useCallback109 } from "react";

// src/components/RenderModal/OptionExplainerBubble.tsx
import { BrowserSafeApis } from "@remotion/renderer/client";

// src/components/RenderModal/CliCopyButton.tsx
import { useCallback as useCallback108, useEffect as useEffect73, useMemo as useMemo118, useState as useState74 } from "react";
import { jsx as jsx228 } from "react/jsx-runtime";
var svgStyle2 = {
  width: 16,
  height: 16,
  verticalAlign: "sub"
};
var copiedStyle = {
  fontSize: "14px",
  minHeight: "30px",
  minWidth: "30px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
};
var buttonStyle6 = {
  width: "30px",
  height: "30px",
  border: "none",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
};
var CliCopyButton = ({
  valueToCopy
}) => {
  const [copied, setCopied] = useState74(false);
  const [hovered, setHovered] = useState74(false);
  const fillColor = useMemo118(() => {
    return hovered ? "white" : LIGHT_TEXT;
  }, [hovered]);
  const clipboardIcon = /* @__PURE__ */ jsx228(ClipboardIcon, {
    color: fillColor,
    style: svgStyle2
  });
  const checkSvg = /* @__PURE__ */ jsx228("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    style: svgStyle2,
    children: /* @__PURE__ */ jsx228("path", {
      fill: fillColor,
      d: "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"
    })
  });
  const onPointerEnter = useCallback108(() => {
    setHovered(true);
  }, []);
  const onPointerLeave = useCallback108(() => {
    setHovered(false);
  }, []);
  useEffect73(() => {
    if (!copied) {
      return;
    }
    const handleClear = () => {
      setCopied(false);
      setHovered(false);
    };
    const to = setTimeout(() => handleClear(), 2000);
    return () => clearTimeout(to);
  }, [copied]);
  return copied ? /* @__PURE__ */ jsx228("span", {
    style: copiedStyle,
    children: checkSvg
  }) : /* @__PURE__ */ jsx228("button", {
    type: "button",
    onPointerEnter,
    onPointerLeave,
    style: buttonStyle6,
    onClick: () => {
      navigator.clipboard.writeText(valueToCopy);
      setCopied(true);
    },
    children: clipboardIcon
  });
};

// src/components/RenderModal/OptionExplainer.tsx
import { jsx as jsx229, jsxs as jsxs113, Fragment as Fragment35 } from "react/jsx-runtime";
var container50 = {
  fontSize: 14,
  paddingTop: 10,
  paddingBottom: 10,
  backgroundColor: INPUT_BACKGROUND
};
var padding3 = {
  paddingLeft: 20,
  paddingRight: 20
};
var title5 = {
  fontSize: 14
};
var description = {
  fontSize: 14,
  maxWidth: 400
};
var link2 = {
  fontSize: 14,
  maxWidth: 200,
  color: "#0b84f3",
  wordWrap: "break-word",
  textDecoration: "none"
};
var infoRow = {
  ...padding3,
  fontSize: 14,
  display: "flex",
  flexDirection: "row",
  alignItems: "center"
};
var infoRowLabel = {
  width: 150,
  fontSize: 14,
  color: "white"
};
var flexSpacer = {
  display: "flex",
  flex: 1
};
var copyWrapper = {
  display: "flex",
  justifyContent: "flex-end"
};
var OptionExplainer = ({ option }) => {
  return /* @__PURE__ */ jsxs113("div", {
    style: container50,
    className: "__remotion-info-button-container",
    children: [
      /* @__PURE__ */ jsxs113("div", {
        style: padding3,
        children: [
          /* @__PURE__ */ jsxs113("div", {
            children: [
              /* @__PURE__ */ jsx229("strong", {
                style: title5,
                children: option.name
              }),
              option.docLink ? /* @__PURE__ */ jsxs113(Fragment35, {
                children: [
                  /* @__PURE__ */ jsx229(Spacing, {
                    x: 1
                  }),
                  /* @__PURE__ */ jsx229("a", {
                    style: link2,
                    href: option.docLink,
                    target: "_blank",
                    children: "Docs"
                  })
                ]
              }) : null
            ]
          }),
          /* @__PURE__ */ jsx229("div", {
            style: description,
            children: option.description("ssr")
          })
        ]
      }),
      /* @__PURE__ */ jsx229(Spacing, {
        y: 0.5,
        block: true
      }),
      /* @__PURE__ */ jsx229(MenuDivider, {}),
      /* @__PURE__ */ jsx229(Spacing, {
        y: 0.5,
        block: true
      }),
      /* @__PURE__ */ jsxs113("div", {
        children: [
          /* @__PURE__ */ jsxs113("div", {
            style: infoRow,
            children: [
              /* @__PURE__ */ jsx229("div", {
                style: infoRowLabel,
                children: "CLI flag"
              }),
              /* @__PURE__ */ jsx229("div", {
                style: flexSpacer
              }),
              /* @__PURE__ */ jsxs113("code", {
                children: [
                  "--",
                  option.cliFlag
                ]
              }),
              /* @__PURE__ */ jsx229("div", {
                style: copyWrapper,
                children: /* @__PURE__ */ jsx229(CliCopyButton, {
                  valueToCopy: option.cliFlag
                })
              })
            ]
          }),
          option.ssrName ? /* @__PURE__ */ jsxs113("div", {
            style: infoRow,
            children: [
              /* @__PURE__ */ jsx229("div", {
                style: infoRowLabel,
                children: "Node.JS option"
              }),
              /* @__PURE__ */ jsx229("div", {
                style: flexSpacer
              }),
              /* @__PURE__ */ jsx229("code", {
                children: option.ssrName
              }),
              /* @__PURE__ */ jsx229(Spacing, {
                x: 3.75
              })
            ]
          }) : null,
          /* @__PURE__ */ jsx229("div", {
            style: infoRow
          })
        ]
      })
    ]
  });
};

// src/components/RenderModal/OptionExplainerBubble.tsx
import { jsx as jsx230 } from "react/jsx-runtime";
var OptionExplainerBubble = ({ id }) => {
  const option = BrowserSafeApis.options[id];
  return /* @__PURE__ */ jsx230(InfoBubble, {
    title: "Learn more about this option",
    children: /* @__PURE__ */ jsx230(OptionExplainer, {
      option
    })
  });
};

// src/components/RenderModal/NumberSetting.tsx
import { jsx as jsx231, jsxs as jsxs114, Fragment as Fragment36 } from "react/jsx-runtime";
var NumberSetting = ({ name, value, step, hint, onValueChanged, max, min, formatter }) => {
  const onTextChanged = useCallback109((e) => {
    onValueChanged((q) => {
      const newSetting = step < 1 ? parseFloat(e) : parseInt(e, 10);
      if (Number.isNaN(newSetting)) {
        return q;
      }
      return Math.min(max ?? Infinity, Math.max(newSetting, min));
    });
  }, [max, min, onValueChanged, step]);
  const onValueChange = useCallback109((newConcurrency) => {
    onValueChanged(newConcurrency);
  }, [onValueChanged]);
  return /* @__PURE__ */ jsxs114("div", {
    style: optionRow,
    children: [
      /* @__PURE__ */ jsxs114("div", {
        style: label5,
        children: [
          name,
          hint ? /* @__PURE__ */ jsxs114(Fragment36, {
            children: [
              /* @__PURE__ */ jsx231(Spacing, {
                x: 0.5
              }),
              /* @__PURE__ */ jsx231(OptionExplainerBubble, {
                id: hint
              })
            ]
          }) : null
        ]
      }),
      /* @__PURE__ */ jsx231("div", {
        style: rightRow,
        children: /* @__PURE__ */ jsx231(RightAlignInput, {
          children: /* @__PURE__ */ jsx231(InputDragger, {
            value,
            name: name.toLowerCase(),
            onTextChange: onTextChanged,
            onValueChange,
            step,
            placeholder: [min, max].map((f) => f !== null && f !== undefined ? f : "").join("-"),
            min,
            max,
            formatter,
            status: "ok",
            rightAlign: true
          })
        })
      })
    ]
  });
};

// src/components/RenderModal/CrfSetting.tsx
import { jsx as jsx232 } from "react/jsx-runtime";
var getDefaultCrfState = () => {
  return BrowserSafeApis2.validCodecs.map((c) => {
    return [c, BrowserSafeApis2.getDefaultCrfForCodec(c)];
  }).reduce((acc, [codec, crf]) => {
    return {
      ...acc,
      [codec]: crf
    };
  }, {});
};
var useCrfState = (codec) => {
  const [state, setState] = useState75(() => getDefaultCrfState());
  const range2 = BrowserSafeApis2.getValidCrfRanges(codec);
  const setCrf = (updater) => {
    setState((q) => {
      const val = q[codec];
      if (val === null) {
        throw new TypeError(`Got unexpected codec "${codec}"`);
      }
      return {
        ...q,
        [codec]: typeof updater === "number" ? updater : updater(val)
      };
    });
  };
  return {
    crf: state[codec],
    setCrf,
    minCrf: range2[0],
    maxCrf: range2[1]
  };
};
var CrfSetting = ({ crf, setCrf, min, max, option }) => {
  return /* @__PURE__ */ jsx232(NumberSetting, {
    min,
    max,
    name: "CRF",
    onValueChanged: setCrf,
    value: crf,
    step: 1,
    hint: option
  });
};

// src/components/RenderModal/RenderModalAdvanced.tsx
import { BrowserSafeApis as BrowserSafeApis3 } from "@remotion/renderer/client";
import { useCallback as useCallback113, useMemo as useMemo119 } from "react";

// src/helpers/presets-labels.ts
var labelx264Preset = (profile) => {
  if (profile === "ultrafast") {
    return "ultrafast";
  }
  if (profile === "superfast") {
    return "superfast";
  }
  if (profile === "veryfast") {
    return "veryfast";
  }
  if (profile === "faster") {
    return "faster";
  }
  if (profile === "fast") {
    return "fast";
  }
  if (profile === "medium") {
    return "medium";
  }
  if (profile === "slow") {
    return "slow";
  }
  if (profile === "slower") {
    return "slower";
  }
  if (profile === "veryslow") {
    return "veryslow";
  }
  if (profile === "placebo") {
    return "placebo";
  }
  throw new TypeError(`Unknown x264 preset: ${profile}`);
};

// src/components/RenderModal/RenderModalEnvironmentVariables.tsx
import { useCallback as useCallback112 } from "react";

// src/components/RenderModal/EnvInput.tsx
import React153, { useCallback as useCallback111 } from "react";

// src/components/RenderModal/InlineEyeIcon.tsx
import { useCallback as useCallback110 } from "react";
import { jsx as jsx233 } from "react/jsx-runtime";
var clearIcon2 = {
  height: 14,
  color: "currentColor"
};
var InlineEyeButton = ({ onClick, enabled }) => {
  const renderAction = useCallback110((color2) => {
    return enabled ? /* @__PURE__ */ jsx233("svg", {
      style: clearIcon2,
      viewBox: "0 0 640 512",
      children: /* @__PURE__ */ jsx233("path", {
        fill: color2,
        d: "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM605.5 268.3c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-51.2 0-96 14.8-133.9 36.8l27.3 21.5C244.6 74.2 280.2 64 320 64c70.4 0 127.7 32 170.8 72c43.1 40 71.9 88 85.2 120c-9.2 22.1-25.9 52-49.5 81.5l25.1 19.8c25.6-32 43.7-64.4 53.9-89zM88.4 154.7c-25.6 32-43.7 64.4-53.9 89c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c51.2 0 96-14.8 133.9-36.8l-27.3-21.5C395.4 437.8 359.8 448 320 448c-70.4 0-127.7-32-170.8-72C106.1 336 77.3 288 64 256c9.2-22.1 25.9-52 49.5-81.5L88.4 154.7zM320 384c16.7 0 32.7-3.2 47.4-9.1l-30.9-24.4c-5.4 .9-10.9 1.4-16.5 1.4c-51 0-92.8-39.8-95.8-90.1l-30.9-24.4c-.9 6-1.3 12.2-1.3 18.5c0 70.7 57.3 128 128 128zM448 256c0-70.7-57.3-128-128-128c-16.7 0-32.7 3.2-47.4 9.1l30.9 24.4c5.4-.9 10.9-1.4 16.5-1.4c51 0 92.8 39.8 95.8 90.1l30.9 24.4c.9-6 1.3-12.2 1.3-18.5z"
      })
    }) : /* @__PURE__ */ jsx233("svg", {
      style: clearIcon2,
      viewBox: "0 0 576 512",
      children: /* @__PURE__ */ jsx233("path", {
        fill: color2,
        d: "M117.2 136C160.3 96 217.6 64 288 64s127.7 32 170.8 72c43.1 40 71.9 88 85.2 120c-13.3 32-42.1 80-85.2 120c-43.1 40-100.4 72-170.8 72s-127.7-32-170.8-72C74.1 336 45.3 288 32 256c13.3-32 42.1-80 85.2-120zM288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM192 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z"
      })
    });
  }, [enabled]);
  return /* @__PURE__ */ jsx233(InlineAction, {
    renderAction,
    onClick
  });
};

// src/components/RenderModal/EnvInput.tsx
import { jsx as jsx234, jsxs as jsxs115, Fragment as Fragment37 } from "react/jsx-runtime";
var input3 = {
  flex: 1,
  width: "100%"
};
var validationStyle = {
  paddingLeft: optionRow.paddingLeft,
  paddingRight: optionRow.paddingRight
};
var EnvInput = ({
  onEnvKeyChange,
  onEnvValChange,
  envKey,
  envVal,
  onDelete,
  index,
  autoFocus,
  isDuplicate
}) => {
  const [showInPlainText, setShowInPlainText] = React153.useState(false);
  const [initialWarningKeyMissing, setKeyWarningEligible] = React153.useState(() => {
    return envKey.trim() === "" && envVal.trim() !== "";
  });
  const [initialWarningValMissing, setValueWarningEligible] = React153.useState(() => {
    return envKey.trim() !== "" && envVal.trim() === "";
  });
  const isKeyMissing = envKey.trim() === "" && initialWarningKeyMissing && envVal.trim() !== "";
  const isValMissing = envVal.trim() === "" && initialWarningValMissing && envKey.trim() !== "";
  const handleDelete = useCallback111(() => {
    onDelete(index);
  }, [index, onDelete]);
  const togglePlainText = useCallback111(() => {
    setShowInPlainText((prev) => !prev);
  }, []);
  const handleKeyChange = useCallback111((e) => {
    onEnvKeyChange(index, e.target.value);
  }, [index, onEnvKeyChange]);
  const handleValueChange = useCallback111((e) => {
    onEnvValChange(index, e.target.value);
  }, [index, onEnvValChange]);
  const makeKeyWarningEligible = useCallback111(() => {
    setKeyWarningEligible(true);
  }, []);
  const makeValueWarningEligible = useCallback111(() => {
    setValueWarningEligible(true);
  }, []);
  const isNodeEnvKey = envKey.trim() === "NODE_ENV";
  return /* @__PURE__ */ jsxs115(Fragment37, {
    children: [
      /* @__PURE__ */ jsxs115(Row, {
        align: "center",
        style: optionRow,
        children: [
          /* @__PURE__ */ jsx234(RemotionInput, {
            status: isNodeEnvKey || isDuplicate || isKeyMissing ? "warning" : "ok",
            type: "text",
            placeholder: "Key",
            style: input3,
            value: envKey,
            onBlur: makeKeyWarningEligible,
            autoFocus,
            onChange: handleKeyChange,
            rightAlign: false
          }),
          /* @__PURE__ */ jsx234(Spacing, {
            x: 1
          }),
          /* @__PURE__ */ jsx234(RemotionInput, {
            status: isValMissing ? "warning" : "ok",
            placeholder: "Value",
            type: showInPlainText ? "text" : "password",
            style: input3,
            value: envVal,
            onBlur: makeValueWarningEligible,
            onChange: handleValueChange,
            rightAlign: false
          }),
          /* @__PURE__ */ jsx234(Spacing, {
            x: 1.5
          }),
          /* @__PURE__ */ jsx234(InlineEyeButton, {
            enabled: !showInPlainText,
            onClick: togglePlainText
          }),
          /* @__PURE__ */ jsx234(InlineRemoveButton, {
            onClick: handleDelete
          })
        ]
      }),
      isNodeEnvKey ? /* @__PURE__ */ jsx234("div", {
        style: validationStyle,
        children: /* @__PURE__ */ jsx234(ValidationMessage, {
          align: "flex-start",
          type: "warning",
          message: "NODE_ENV will be overwritten by Remotion during the render process."
        })
      }) : null,
      isDuplicate ? /* @__PURE__ */ jsx234("div", {
        style: validationStyle,
        children: /* @__PURE__ */ jsx234(ValidationMessage, {
          align: "flex-start",
          type: "warning",
          message: `${envKey.toUpperCase()} is already defined.`
        })
      }) : null,
      isKeyMissing ? /* @__PURE__ */ jsx234("div", {
        style: validationStyle,
        children: /* @__PURE__ */ jsx234(ValidationMessage, {
          align: "flex-start",
          type: "warning",
          message: "Key is missing."
        })
      }) : null,
      isValMissing ? /* @__PURE__ */ jsx234("div", {
        style: validationStyle,
        children: /* @__PURE__ */ jsx234(ValidationMessage, {
          align: "flex-start",
          type: "warning",
          message: "Value is missing."
        })
      }) : null
    ]
  });
};

// src/components/RenderModal/RenderModalEnvironmentVariables.tsx
import { jsx as jsx235, jsxs as jsxs116 } from "react/jsx-runtime";
var title6 = {
  fontSize: 14,
  fontWeight: "bold",
  color: LIGHT_TEXT,
  marginLeft: 16
};
var container51 = {
  marginTop: 20
};
var button5 = {
  marginLeft: 16
};
var RenderModalEnvironmentVariables = ({ envVariables, setEnvVariables }) => {
  const onEnvValChange = useCallback112((index, value) => {
    setEnvVariables((oldEnv) => {
      const newEnv = [...oldEnv];
      newEnv[index][1] = value;
      return newEnv;
    });
  }, [setEnvVariables]);
  const onEnvKeyChange = useCallback112((index, value) => {
    setEnvVariables((oldEnv) => {
      const newEnv = [...oldEnv];
      newEnv[index][0] = value;
      return newEnv;
    });
  }, [setEnvVariables]);
  const onDelete = useCallback112((index) => {
    setEnvVariables((oldEnv) => oldEnv.filter((_, idx) => idx !== index));
  }, [setEnvVariables]);
  const addField = useCallback112(() => {
    setEnvVariables((oldEnv) => [...oldEnv, ["", ""]]);
  }, [setEnvVariables]);
  const usedKeys = [];
  return /* @__PURE__ */ jsxs116("div", {
    style: container51,
    children: [
      /* @__PURE__ */ jsx235("strong", {
        style: title6,
        children: "Environment variables"
      }),
      envVariables.map((env, i) => {
        let isDuplicate = false;
        if (usedKeys.includes(env[0].toUpperCase())) {
          isDuplicate = true;
        }
        usedKeys.push(env[0].toUpperCase());
        return /* @__PURE__ */ jsx235(EnvInput, {
          onEnvKeyChange,
          onEnvValChange,
          envKey: env[0],
          envVal: env[1],
          onDelete,
          index: i,
          isDuplicate,
          autoFocus: i === envVariables.length - 1 && env[0] === ""
        }, i);
      }),
      /* @__PURE__ */ jsx235(Spacing, {
        y: 1,
        block: true
      }),
      /* @__PURE__ */ jsx235(Button, {
        style: button5,
        onClick: addField,
        children: "+ Add env variable"
      }),
      /* @__PURE__ */ jsx235(Spacing, {
        y: 1,
        block: true
      })
    ]
  });
};

// src/components/RenderModal/RenderModalHr.tsx
import { jsx as jsx236 } from "react/jsx-runtime";
var hrStyle = {
  margin: "0 0 0 0",
  padding: "0 0 0 0",
  border: "none",
  borderTop: "1px solid #000",
  marginRight: 16,
  marginLeft: 16,
  marginTop: 8,
  marginBottom: 8
};
var RenderModalHr = () => {
  return /* @__PURE__ */ jsx236("div", {
    style: hrStyle
  });
};

// src/components/RenderModal/RenderModalAdvanced.tsx
import { jsx as jsx237, jsxs as jsxs117 } from "react/jsx-runtime";
var container52 = {
  flex: 1,
  overflowY: "auto"
};
var RenderModalAdvanced = ({
  renderMode,
  maxConcurrency,
  minConcurrency,
  setConcurrency,
  concurrency,
  delayRenderTimeout,
  setDelayRenderTimeout,
  disallowParallelEncoding,
  setDisallowParallelEncoding,
  setDisableWebSecurity,
  setIgnoreCertificateErrors,
  setHeadless,
  headless,
  ignoreCertificateErrors,
  disableWebSecurity,
  openGlOption,
  setOpenGlOption,
  setEnvVariables,
  envVariables,
  setx264Preset,
  x264Preset,
  codec,
  offthreadVideoCacheSizeInBytes,
  setOffthreadVideoCacheSizeInBytes,
  offthreadVideoThreads,
  setOffthreadVideoThreads,
  enableMultiProcessOnLinux,
  setChromiumMultiProcessOnLinux,
  setUserAgent,
  userAgent,
  beep,
  setBeep,
  repro,
  setRepro,
  hardwareAcceleration,
  chromeModeOption,
  setChromeModeOption,
  setHardwareAcceleration
}) => {
  const extendedOpenGlOptions = useMemo119(() => {
    return [
      "angle",
      "egl",
      "swangle",
      "swiftshader",
      "vulkan",
      "angle-egl",
      "default"
    ];
  }, []);
  const toggleCustomOffthreadVideoCacheSizeInBytes = useCallback113(() => {
    setOffthreadVideoCacheSizeInBytes((previous) => {
      if (previous === null) {
        return 512 * 1024 * 1024;
      }
      return null;
    });
  }, [setOffthreadVideoCacheSizeInBytes]);
  const toggleCustomOffthreadVideoThreads = useCallback113(() => {
    setOffthreadVideoThreads((previous) => {
      if (previous === null) {
        return 2;
      }
      return null;
    });
  }, [setOffthreadVideoThreads]);
  const toggleCustomUserAgent = useCallback113(() => {
    setUserAgent((previous) => {
      if (previous === null) {
        return "Mozilla/5.0 (Remotion)";
      }
      return null;
    });
  }, [setUserAgent]);
  const onDisallowParallelEncodingChanged = useCallback113((e) => {
    setDisallowParallelEncoding(e.target.checked);
  }, [setDisallowParallelEncoding]);
  const onDisableWebSecurityChanged = useCallback113((e) => {
    setDisableWebSecurity(e.target.checked);
  }, [setDisableWebSecurity]);
  const onEnableMultiProcessOnLinux = useCallback113((e) => {
    setChromiumMultiProcessOnLinux(e.target.checked);
  }, [setChromiumMultiProcessOnLinux]);
  const onIgnoreCertificatErrors = useCallback113((e) => {
    setIgnoreCertificateErrors(e.target.checked);
  }, [setIgnoreCertificateErrors]);
  const onHeadless = useCallback113((e) => {
    setHeadless(e.target.checked);
  }, [setHeadless]);
  const onUserAgentChanged = useCallback113((e) => {
    setUserAgent(e.target.value);
  }, [setUserAgent]);
  const onPlayBeepSound = useCallback113((e) => {
    setBeep(e.target.checked);
  }, [setBeep]);
  const onReproToggle = useCallback113((e) => {
    setRepro(e.target.checked);
  }, [setRepro]);
  const openGlOptions = useMemo119(() => {
    return extendedOpenGlOptions.map((option) => {
      return {
        label: option === "default" ? "Default" : option,
        onClick: () => setOpenGlOption(option),
        key: option,
        leftItem: openGlOption === option ? /* @__PURE__ */ jsx237(Checkmark, {}) : null,
        id: option,
        keyHint: null,
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item",
        value: option
      };
    });
  }, [extendedOpenGlOptions, openGlOption, setOpenGlOption]);
  const chromeModeOptions = useMemo119(() => {
    return BrowserSafeApis3.validChromeModeOptions.map((option) => {
      return {
        label: option,
        onClick: () => setChromeModeOption(option),
        key: option,
        leftItem: chromeModeOption === option ? /* @__PURE__ */ jsx237(Checkmark, {}) : null,
        id: option,
        keyHint: null,
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item",
        value: option
      };
    });
  }, [chromeModeOption, setChromeModeOption]);
  const x264PresetOptions = useMemo119(() => {
    return BrowserSafeApis3.x264PresetOptions.map((option) => {
      return {
        label: labelx264Preset(option),
        onClick: () => setx264Preset(option),
        key: option,
        type: "item",
        id: option,
        keyHint: null,
        leftItem: x264Preset === option ? /* @__PURE__ */ jsx237(Checkmark, {}) : null,
        quickSwitcherLabel: null,
        subMenu: null,
        value: option
      };
    });
  }, [setx264Preset, x264Preset]);
  const hardwareAccelerationValues = useMemo119(() => {
    return BrowserSafeApis3.hardwareAccelerationOptions.map((option) => {
      return {
        label: option,
        onClick: () => setHardwareAcceleration(option),
        leftItem: hardwareAcceleration === option ? /* @__PURE__ */ jsx237(Checkmark, {}) : null,
        subMenu: null,
        quickSwitcherLabel: null,
        type: "item",
        id: option,
        keyHint: null,
        value: option
      };
    });
  }, [hardwareAcceleration, setHardwareAcceleration]);
  const changeOffthreadVideoCacheSizeInBytes = useCallback113((cb) => {
    setOffthreadVideoCacheSizeInBytes((prev) => {
      if (prev === null) {
        throw new TypeError("Expected previous value");
      }
      if (typeof cb === "function") {
        return cb(prev);
      }
      return cb;
    });
  }, [setOffthreadVideoCacheSizeInBytes]);
  const changeOffthreadVideoThreads = useCallback113((cb) => {
    setOffthreadVideoThreads((prev) => {
      if (prev === null) {
        throw new TypeError("Expected previous value");
      }
      if (typeof cb === "function") {
        return cb(prev);
      }
      return cb;
    });
  }, [setOffthreadVideoThreads]);
  return /* @__PURE__ */ jsxs117("div", {
    style: container52,
    className: VERTICAL_SCROLLBAR_CLASSNAME,
    children: [
      renderMode === "still" ? null : /* @__PURE__ */ jsx237(NumberSetting, {
        min: minConcurrency,
        max: maxConcurrency,
        step: 1,
        name: "Concurrency",
        formatter: (w) => `${w}x`,
        onValueChanged: setConcurrency,
        value: concurrency
      }),
      renderMode === "video" && codec === "h264" ? /* @__PURE__ */ jsxs117("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsxs117("div", {
            style: label5,
            children: [
              "x264 Preset",
              /* @__PURE__ */ jsx237(Spacing, {
                x: 0.5
              }),
              /* @__PURE__ */ jsx237(OptionExplainerBubble, {
                id: "x264Option"
              })
            ]
          }),
          /* @__PURE__ */ jsx237("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx237(Combobox, {
              title: x264Preset,
              selectedId: x264Preset,
              values: x264PresetOptions
            })
          })
        ]
      }) : null,
      renderMode === "video" ? /* @__PURE__ */ jsxs117("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsxs117("div", {
            style: label5,
            children: [
              "Hardware acceleration",
              /* @__PURE__ */ jsx237(Spacing, {
                x: 0.5
              }),
              /* @__PURE__ */ jsx237(OptionExplainerBubble, {
                id: "hardwareAccelerationOption"
              })
            ]
          }),
          /* @__PURE__ */ jsx237("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx237(Combobox, {
              title: hardwareAcceleration,
              selectedId: hardwareAcceleration,
              values: hardwareAccelerationValues
            })
          })
        ]
      }) : null,
      /* @__PURE__ */ jsx237(NumberSetting, {
        min: 7000,
        max: 900000,
        name: "delayRender() timeout",
        onValueChanged: setDelayRenderTimeout,
        formatter: (w) => `${w}ms`,
        step: 1000,
        hint: "delayRenderTimeoutInMillisecondsOption",
        value: delayRenderTimeout
      }),
      /* @__PURE__ */ jsxs117("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsx237("div", {
            style: label5,
            children: "No parallel encoding"
          }),
          /* @__PURE__ */ jsx237("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx237(Checkbox, {
              checked: disallowParallelEncoding,
              onChange: onDisallowParallelEncodingChanged,
              name: "disallow-parallel-encoding"
            })
          })
        ]
      }),
      renderMode === "audio" ? null : /* @__PURE__ */ jsxs117("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsx237("div", {
            style: label5,
            children: "Custom OffthreadVideo cache"
          }),
          /* @__PURE__ */ jsx237(Spacing, {
            x: 0.5
          }),
          /* @__PURE__ */ jsx237(OptionExplainerBubble, {
            id: "offthreadVideoCacheSizeInBytesOption"
          }),
          /* @__PURE__ */ jsx237("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx237(Checkbox, {
              checked: offthreadVideoCacheSizeInBytes !== null,
              onChange: toggleCustomOffthreadVideoCacheSizeInBytes,
              name: "custom-audio-bitrate"
            })
          })
        ]
      }),
      renderMode === "audio" || offthreadVideoCacheSizeInBytes === null ? null : /* @__PURE__ */ jsx237(NumberSetting, {
        min: 0,
        max: 2000 * 1024 * 1024,
        step: 1024,
        name: "OffthreadVideo cache size",
        formatter: (w) => `${w} bytes`,
        onValueChanged: changeOffthreadVideoCacheSizeInBytes,
        value: offthreadVideoCacheSizeInBytes
      }),
      renderMode === "audio" ? null : /* @__PURE__ */ jsxs117("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsx237("div", {
            style: label5,
            children: "OffthreadVideo threads"
          }),
          /* @__PURE__ */ jsx237(Spacing, {
            x: 0.5
          }),
          /* @__PURE__ */ jsx237(OptionExplainerBubble, {
            id: "offthreadVideoThreadsOption"
          }),
          /* @__PURE__ */ jsx237("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx237(Checkbox, {
              checked: offthreadVideoThreads !== null,
              onChange: toggleCustomOffthreadVideoThreads,
              name: "offthread-video-threads"
            })
          })
        ]
      }),
      renderMode === "audio" || offthreadVideoThreads === null ? null : /* @__PURE__ */ jsx237(NumberSetting, {
        min: 0,
        max: 16,
        step: 1,
        name: "OffthreadVideo threads",
        formatter: (w) => `${w}x`,
        onValueChanged: changeOffthreadVideoThreads,
        value: offthreadVideoThreads
      }),
      /* @__PURE__ */ jsx237(RenderModalHr, {}),
      /* @__PURE__ */ jsxs117("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsx237("div", {
            style: label5,
            children: "Disable web security"
          }),
          /* @__PURE__ */ jsx237("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx237(Checkbox, {
              checked: disableWebSecurity,
              onChange: onDisableWebSecurityChanged,
              name: "disable-web-security"
            })
          })
        ]
      }),
      /* @__PURE__ */ jsxs117("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsx237("div", {
            style: label5,
            children: "Ignore certificate errors"
          }),
          /* @__PURE__ */ jsx237("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx237(Checkbox, {
              checked: ignoreCertificateErrors,
              onChange: onIgnoreCertificatErrors,
              name: "ignore-certificate-errors"
            })
          })
        ]
      }),
      /* @__PURE__ */ jsxs117("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsxs117("div", {
            style: label5,
            children: [
              "Headless mode",
              /* @__PURE__ */ jsx237(Spacing, {
                x: 0.5
              }),
              /* @__PURE__ */ jsx237(OptionExplainerBubble, {
                id: "headlessOption"
              })
            ]
          }),
          /* @__PURE__ */ jsx237("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx237(Checkbox, {
              checked: headless,
              onChange: onHeadless,
              name: "headless"
            })
          })
        ]
      }),
      /* @__PURE__ */ jsxs117("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsxs117("div", {
            style: label5,
            children: [
              "Chrome Mode ",
              /* @__PURE__ */ jsx237(Spacing, {
                x: 0.5
              }),
              /* @__PURE__ */ jsx237(OptionExplainerBubble, {
                id: "chromeModeOption"
              })
            ]
          }),
          /* @__PURE__ */ jsx237("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx237(Combobox, {
              values: chromeModeOptions,
              selectedId: chromeModeOption,
              title: "Chrome mode"
            })
          })
        ]
      }),
      /* @__PURE__ */ jsxs117("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsxs117("div", {
            style: label5,
            children: [
              "OpenGL render backend ",
              /* @__PURE__ */ jsx237(Spacing, {
                x: 0.5
              }),
              /* @__PURE__ */ jsx237(OptionExplainerBubble, {
                id: "glOption"
              })
            ]
          }),
          /* @__PURE__ */ jsx237("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx237(Combobox, {
              values: openGlOptions,
              selectedId: openGlOption,
              title: "OpenGl option"
            })
          })
        ]
      }),
      /* @__PURE__ */ jsxs117("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsx237("div", {
            style: label5,
            children: "Multi-process Chrome on Linux"
          }),
          /* @__PURE__ */ jsx237(Spacing, {
            x: 0.5
          }),
          /* @__PURE__ */ jsx237(OptionExplainerBubble, {
            id: "enableMultiprocessOnLinuxOption"
          }),
          /* @__PURE__ */ jsx237("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx237(Checkbox, {
              checked: enableMultiProcessOnLinux,
              onChange: onEnableMultiProcessOnLinux,
              name: "enable-multi-process-on-linux"
            })
          })
        ]
      }),
      /* @__PURE__ */ jsxs117("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsx237("div", {
            style: label5,
            children: "Custom User Agent"
          }),
          /* @__PURE__ */ jsx237("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx237(Checkbox, {
              checked: userAgent !== null,
              onChange: toggleCustomUserAgent,
              name: "custom-user-agent"
            })
          })
        ]
      }),
      userAgent === null ? null : /* @__PURE__ */ jsxs117("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsx237("div", {
            style: label5,
            children: "User Agent"
          }),
          /* @__PURE__ */ jsx237("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx237("div", {
              children: /* @__PURE__ */ jsx237(RemotionInput, {
                style: input,
                value: userAgent,
                onChange: onUserAgentChanged,
                status: "ok",
                rightAlign: true
              })
            })
          })
        ]
      }),
      /* @__PURE__ */ jsxs117("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsxs117("div", {
            style: label5,
            children: [
              "Create a reproduction ",
              /* @__PURE__ */ jsx237(OptionExplainerBubble, {
                id: "reproOption"
              })
            ]
          }),
          /* @__PURE__ */ jsx237("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx237(Checkbox, {
              checked: repro,
              onChange: onReproToggle,
              name: "repro"
            })
          })
        ]
      }),
      /* @__PURE__ */ jsxs117("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsxs117("div", {
            style: label5,
            children: [
              "Beep when finished ",
              /* @__PURE__ */ jsx237(OptionExplainerBubble, {
                id: "beepOnFinishOption"
              })
            ]
          }),
          /* @__PURE__ */ jsx237("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx237(Checkbox, {
              checked: beep,
              onChange: onPlayBeepSound,
              name: "beep-when-finished"
            })
          })
        ]
      }),
      /* @__PURE__ */ jsx237(RenderModalHr, {}),
      /* @__PURE__ */ jsx237(RenderModalEnvironmentVariables, {
        envVariables,
        setEnvVariables
      })
    ]
  });
};

// src/components/RenderModal/RenderModalAudio.tsx
import { BrowserSafeApis as BrowserSafeApis5 } from "@remotion/renderer/client";
import { useCallback as useCallback117 } from "react";

// src/components/RenderModal/EnforceAudioTrackSetting.tsx
import { useCallback as useCallback114 } from "react";
import { jsx as jsx238, jsxs as jsxs118 } from "react/jsx-runtime";
var EnforceAudioTrackSetting = ({ enforceAudioTrack, muted, setEnforceAudioTrack }) => {
  const onEnforceAudioTrackChanged = useCallback114((e) => {
    setEnforceAudioTrack(e.target.checked);
  }, [setEnforceAudioTrack]);
  return /* @__PURE__ */ jsxs118("div", {
    style: optionRow,
    children: [
      /* @__PURE__ */ jsxs118("div", {
        style: label5,
        children: [
          "Enforce Audio Track",
          /* @__PURE__ */ jsx238(Spacing, {
            x: 0.5
          }),
          /* @__PURE__ */ jsx238(OptionExplainerBubble, {
            id: "enforceAudioOption"
          })
        ]
      }),
      /* @__PURE__ */ jsx238("div", {
        style: rightRow,
        children: /* @__PURE__ */ jsx238(Checkbox, {
          disabled: muted && !enforceAudioTrack,
          checked: enforceAudioTrack,
          onChange: onEnforceAudioTrackChanged,
          name: "enforce-audio-track"
        })
      })
    ]
  });
};

// src/components/RenderModal/MutedSetting.tsx
import { useCallback as useCallback115 } from "react";
import { jsx as jsx239, jsxs as jsxs119 } from "react/jsx-runtime";
var MutedSetting = ({ muted, setMuted, enforceAudioTrack }) => {
  const onMutedChanged = useCallback115((e) => {
    setMuted(e.target.checked);
  }, [setMuted]);
  return /* @__PURE__ */ jsxs119("div", {
    style: optionRow,
    children: [
      /* @__PURE__ */ jsxs119("div", {
        style: label5,
        children: [
          "Muted",
          /* @__PURE__ */ jsx239(Spacing, {
            x: 0.5
          }),
          /* @__PURE__ */ jsx239(OptionExplainerBubble, {
            id: "mutedOption"
          })
        ]
      }),
      /* @__PURE__ */ jsx239(Spacing, {
        x: 0.25
      }),
      /* @__PURE__ */ jsx239("div", {
        style: rightRow,
        children: /* @__PURE__ */ jsx239(Checkbox, {
          checked: muted,
          disabled: enforceAudioTrack && !muted,
          onChange: onMutedChanged,
          name: "muted"
        })
      })
    ]
  });
};

// src/components/RenderModal/SeparateAudioOption.tsx
import { BrowserSafeApis as BrowserSafeApis4 } from "@remotion/renderer/client";
import { useCallback as useCallback116, useMemo as useMemo120 } from "react";

// src/helpers/use-file-existence.ts
import { useContext as useContext78, useEffect as useEffect74, useRef as useRef39, useState as useState76 } from "react";
var useFileExistence = (outName) => {
  const [exists, setExists] = useState76(false);
  const { previewServerState: state, subscribeToEvent } = useContext78(StudioServerConnectionCtx);
  const clientId = state.type === "connected" ? state.clientId : undefined;
  const currentOutName = useRef39("");
  currentOutName.current = outName;
  useEffect74(() => {
    if (!clientId) {
      return;
    }
    subscribeToFileExistenceWatcher({
      file: outName,
      clientId
    }).then((_exists) => {
      if (currentOutName.current === outName) {
        setExists(_exists);
      }
    });
    return () => {
      unsubscribeFromFileExistenceWatcher({ file: outName, clientId });
    };
  }, [clientId, outName]);
  useEffect74(() => {
    const listener = (event) => {
      if (event.type !== "watched-file-deleted") {
        return;
      }
      if (event.file !== currentOutName.current) {
        return;
      }
      if (currentOutName.current === outName) {
        setExists(false);
      }
    };
    const unsub = subscribeToEvent("watched-file-deleted", listener);
    return () => {
      unsub();
    };
  }, [outName, subscribeToEvent]);
  useEffect74(() => {
    const listener = (event) => {
      if (event.type !== "watched-file-undeleted") {
        return;
      }
      if (event.file !== outName) {
        return;
      }
      if (currentOutName.current === outName) {
        setExists(true);
      }
    };
    const unsub = subscribeToEvent("watched-file-undeleted", listener);
    return () => {
      unsub();
    };
  }, [outName, subscribeToEvent]);
  return exists;
};

// src/components/RenderModal/RenderModalOutputName.tsx
import { jsx as jsx240, jsxs as jsxs120, Fragment as Fragment38 } from "react/jsx-runtime";
var RenderModalOutputName = ({
  existence,
  inputStyle: inputStyle2,
  outName,
  onValueChange,
  validationMessage,
  label: labelText
}) => {
  return /* @__PURE__ */ jsxs120("div", {
    style: optionRow,
    children: [
      /* @__PURE__ */ jsx240(Column, {
        children: /* @__PURE__ */ jsx240("div", {
          style: label5,
          children: labelText
        })
      }),
      /* @__PURE__ */ jsx240("div", {
        style: rightRow,
        children: /* @__PURE__ */ jsxs120("div", {
          children: [
            /* @__PURE__ */ jsx240(RemotionInput, {
              status: validationMessage ? "error" : existence ? "warning" : "ok",
              style: inputStyle2,
              type: "text",
              value: outName,
              onChange: onValueChange,
              rightAlign: true
            }),
            validationMessage ? /* @__PURE__ */ jsxs120(Fragment38, {
              children: [
                /* @__PURE__ */ jsx240(Spacing, {
                  y: 1,
                  block: true
                }),
                /* @__PURE__ */ jsx240(ValidationMessage, {
                  align: "flex-end",
                  message: validationMessage,
                  type: "error"
                })
              ]
            }) : existence ? /* @__PURE__ */ jsxs120(Fragment38, {
              children: [
                /* @__PURE__ */ jsx240(Spacing, {
                  y: 1,
                  block: true
                }),
                /* @__PURE__ */ jsx240(ValidationMessage, {
                  align: "flex-end",
                  message: "Will be overwritten",
                  type: "warning"
                })
              ]
            }) : null
          ]
        })
      })
    ]
  });
};

// src/components/RenderModal/get-string-before-suffix.ts
var getStringBeforeSuffix = (fileName) => {
  const dotPos = fileName.lastIndexOf(".");
  if (dotPos === -1) {
    return fileName;
  }
  return fileName.substring(0, dotPos);
};

// src/components/RenderModal/SeparateAudioOption.tsx
import { jsx as jsx241, jsxs as jsxs121, Fragment as Fragment39 } from "react/jsx-runtime";
var SeparateAudioOptionInput = ({ separateAudioTo, setSeparateAudioTo, audioCodec }) => {
  const existence = useFileExistence(separateAudioTo);
  const onValueChange = useCallback116((e) => {
    setSeparateAudioTo(e.target.value);
  }, [setSeparateAudioTo]);
  const validationMessage = useMemo120(() => {
    const expectedExtension = BrowserSafeApis4.getExtensionFromAudioCodec(audioCodec);
    const actualExtension = separateAudioTo.split(".").pop();
    if (actualExtension !== expectedExtension) {
      return `Expected extension: .${expectedExtension}`;
    }
    return null;
  }, [audioCodec, separateAudioTo]);
  return /* @__PURE__ */ jsx241(RenderModalOutputName, {
    existence,
    inputStyle: input,
    onValueChange,
    outName: separateAudioTo,
    label: "Separate audio to",
    validationMessage
  });
};
var SeparateAudioOption = ({ separateAudioTo, setSeparateAudioTo, audioCodec, outName }) => {
  const onSeparateAudioChange = useCallback116((e) => {
    if (e.target.checked) {
      const extension = BrowserSafeApis4.getExtensionFromAudioCodec(audioCodec);
      setSeparateAudioTo(`${getStringBeforeSuffix(outName)}.${extension}`);
    } else {
      setSeparateAudioTo(null);
    }
  }, [audioCodec, outName, setSeparateAudioTo]);
  return /* @__PURE__ */ jsxs121(Fragment39, {
    children: [
      /* @__PURE__ */ jsxs121("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsxs121("div", {
            style: label5,
            children: [
              "Separate audio",
              /* @__PURE__ */ jsx241(Spacing, {
                x: 0.5
              }),
              /* @__PURE__ */ jsx241(OptionExplainerBubble, {
                id: "separateAudioOption"
              })
            ]
          }),
          /* @__PURE__ */ jsx241("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx241(Checkbox, {
              disabled: false,
              checked: Boolean(separateAudioTo),
              onChange: onSeparateAudioChange,
              name: "separate-audio-to"
            })
          })
        ]
      }),
      separateAudioTo === null ? null : /* @__PURE__ */ jsx241(SeparateAudioOptionInput, {
        separateAudioTo,
        setSeparateAudioTo,
        audioCodec
      })
    ]
  });
};

// src/components/RenderModal/human-readable-audio-codecs.ts
var humanReadableAudioCodec = (audioCodec) => {
  if (audioCodec === "aac") {
    return "AAC";
  }
  if (audioCodec === "mp3") {
    return "MP3";
  }
  if (audioCodec === "pcm-16") {
    return "Lossless";
  }
  if (audioCodec === "opus") {
    return "Opus";
  }
};

// src/components/RenderModal/RenderModalAudio.tsx
import { jsx as jsx242, jsxs as jsxs122, Fragment as Fragment40 } from "react/jsx-runtime";
var container53 = {
  flex: 1,
  overflowY: "auto"
};
var RenderModalAudio = ({
  muted,
  setMuted,
  renderMode,
  enforceAudioTrack,
  setEnforceAudioTrackState,
  setShouldHaveCustomTargetAudioBitrate,
  shouldHaveCustomTargetAudioBitrate,
  setCustomTargetAudioBitrateValue,
  customTargetAudioBitrate,
  audioCodec,
  codec,
  setAudioCodec,
  forSeamlessAacConcatenation,
  setForSeamlessAacConcatenation,
  separateAudioTo,
  setSeparateAudioTo,
  outName
}) => {
  const onShouldHaveTargetAudioBitrateChanged = useCallback117((e) => {
    setShouldHaveCustomTargetAudioBitrate(e.target.checked);
  }, [setShouldHaveCustomTargetAudioBitrate]);
  const onTargetAudioBitrateChanged = useCallback117((e) => {
    setCustomTargetAudioBitrateValue(e.target.value);
  }, [setCustomTargetAudioBitrateValue]);
  const onSeamlessAacConcatenationChanges = useCallback117((e) => {
    setForSeamlessAacConcatenation(e.target.checked);
  }, [setForSeamlessAacConcatenation]);
  const audioCodecOptions = useCallback117((currentCodec) => {
    return BrowserSafeApis5.supportedAudioCodecs[currentCodec].map((audioCodecOption) => {
      return {
        label: humanReadableAudioCodec(audioCodecOption),
        onClick: () => setAudioCodec(audioCodecOption),
        key: audioCodecOption,
        leftItem: codec === audioCodecOption ? /* @__PURE__ */ jsx242(Checkmark, {}) : null,
        id: audioCodecOption,
        keyHint: null,
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item",
        value: audioCodecOption
      };
    });
  }, [codec, setAudioCodec]);
  return /* @__PURE__ */ jsxs122("div", {
    style: container53,
    className: VERTICAL_SCROLLBAR_CLASSNAME,
    children: [
      renderMode === "video" ? /* @__PURE__ */ jsxs122(Fragment40, {
        children: [
          /* @__PURE__ */ jsx242(MutedSetting, {
            enforceAudioTrack,
            muted,
            setMuted
          }),
          /* @__PURE__ */ jsx242(RenderModalHr, {})
        ]
      }) : null,
      renderMode === "video" && audioCodecOptions(codec).length >= 2 && !muted ? /* @__PURE__ */ jsxs122("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsxs122("div", {
            style: label5,
            children: [
              "Audio Codec ",
              /* @__PURE__ */ jsx242(Spacing, {
                x: 0.5
              }),
              /* @__PURE__ */ jsx242(OptionExplainerBubble, {
                id: "audioCodecOption"
              })
            ]
          }),
          /* @__PURE__ */ jsx242("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx242(Combobox, {
              values: audioCodecOptions(codec),
              selectedId: audioCodec,
              title: "AudioCodec"
            })
          })
        ]
      }) : null,
      (renderMode === "video" || renderMode === "audio") && !muted && /* @__PURE__ */ jsxs122(Fragment40, {
        children: [
          /* @__PURE__ */ jsx242(EnforceAudioTrackSetting, {
            muted,
            enforceAudioTrack,
            setEnforceAudioTrack: setEnforceAudioTrackState
          }),
          /* @__PURE__ */ jsx242(RenderModalHr, {})
        ]
      }),
      renderMode === "video" && !muted ? /* @__PURE__ */ jsx242(SeparateAudioOption, {
        separateAudioTo,
        setSeparateAudioTo,
        audioCodec,
        outName
      }) : null,
      audioCodec === "aac" && !muted ? /* @__PURE__ */ jsxs122("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsxs122("div", {
            style: label5,
            children: [
              "For seamless AAC concatenation",
              /* @__PURE__ */ jsx242(Spacing, {
                x: 0.5
              }),
              /* @__PURE__ */ jsx242(OptionExplainerBubble, {
                id: "forSeamlessAacConcatenationOption"
              })
            ]
          }),
          /* @__PURE__ */ jsx242("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx242(Checkbox, {
              disabled: false,
              checked: forSeamlessAacConcatenation,
              onChange: onSeamlessAacConcatenationChanges,
              name: "enforce-audio-track"
            })
          })
        ]
      }) : null,
      renderMode === "still" || muted ? null : /* @__PURE__ */ jsxs122("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsxs122("div", {
            style: label5,
            children: [
              "Custom audio bitrate",
              " ",
              /* @__PURE__ */ jsx242(OptionExplainerBubble, {
                id: "audioBitrateOption"
              })
            ]
          }),
          /* @__PURE__ */ jsx242("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx242(Checkbox, {
              checked: shouldHaveCustomTargetAudioBitrate,
              onChange: onShouldHaveTargetAudioBitrateChanged,
              name: "custom-audio-bitrate"
            })
          })
        ]
      }),
      shouldHaveCustomTargetAudioBitrate && renderMode !== "still" && !muted ? /* @__PURE__ */ jsxs122("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsx242("div", {
            style: label5,
            children: "Target audio bitrate"
          }),
          /* @__PURE__ */ jsx242("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx242("div", {
              children: /* @__PURE__ */ jsx242(RemotionInput, {
                style: input,
                value: customTargetAudioBitrate,
                onChange: onTargetAudioBitrateChanged,
                status: "ok",
                rightAlign: true
              })
            })
          })
        ]
      }) : null
    ]
  });
};

// src/components/RenderModal/RenderModalBasic.tsx
import { BrowserSafeApis as BrowserSafeApis6 } from "@remotion/renderer/client";
import { NoReactAPIs } from "@remotion/renderer/pure";
import { useCallback as useCallback120, useMemo as useMemo122 } from "react";

// src/helpers/prores-labels.ts
var labelProResProfile = (profile) => {
  if (profile === "4444") {
    return "4444";
  }
  if (profile === "4444-xq") {
    return "4444 XQ (Best)";
  }
  if (profile === "hq") {
    return "HQ";
  }
  if (profile === "proxy") {
    return "Proxy (Worst)";
  }
  if (profile === "light") {
    return "Light";
  }
  if (profile === "standard") {
    return "Standard";
  }
  throw new TypeError(`Unknown ProRes profile: ${profile}`);
};

// src/components/RenderModal/FrameRangeSetting.tsx
import { useCallback as useCallback119 } from "react";

// src/components/RenderModal/MultiRangeSlider.tsx
import { useCallback as useCallback118, useMemo as useMemo121 } from "react";
import { jsx as jsx243, jsxs as jsxs123 } from "react/jsx-runtime";
var container54 = {
  borderColor: "black",
  borderStyle: "solid",
  borderWidth: "2px",
  height: 39,
  width: 220,
  position: "relative",
  backgroundColor: INPUT_BACKGROUND,
  marginLeft: 8,
  marginRight: 8,
  borderRadius: 2
};
var sliderRange = {
  position: "absolute",
  top: 0,
  backgroundColor: BLUE,
  height: 35
};
var MultiRangeSlider = ({
  min,
  max,
  start,
  end,
  step,
  onLeftThumbDrag,
  onRightThumbDrag
}) => {
  const getPercent = useCallback118((value) => Math.round((value - min) / (max - min) * 100), [min, max]);
  const rangeStyle = useMemo121(() => {
    const minPercent = getPercent(start);
    const maxPercent = getPercent(end);
    return {
      ...sliderRange,
      left: `${minPercent}%`,
      width: `${maxPercent - minPercent}%`
    };
  }, [end, getPercent, start]);
  const onChangeLeft = useCallback118((event) => {
    const value = Math.min(Number(event.target.value), end - 1);
    onLeftThumbDrag(value);
  }, [end, onLeftThumbDrag]);
  const onChangeRight = useCallback118((event) => {
    const value = Math.max(Number(event.target.value), start + 1);
    onRightThumbDrag(value);
  }, [onRightThumbDrag, start]);
  return /* @__PURE__ */ jsxs123("div", {
    style: container54,
    children: [
      /* @__PURE__ */ jsx243("input", {
        type: "range",
        min,
        max,
        value: start,
        step,
        onChange: onChangeLeft,
        className: "__remotion_thumb"
      }),
      /* @__PURE__ */ jsx243("input", {
        type: "range",
        min,
        max,
        value: end,
        step,
        onChange: onChangeRight,
        className: "__remotion_thumb"
      }),
      /* @__PURE__ */ jsx243("div", {
        style: rangeStyle
      })
    ]
  });
};

// src/components/RenderModal/FrameRangeSetting.tsx
import { jsx as jsx244, jsxs as jsxs124 } from "react/jsx-runtime";
var INPUT_WIDTH = 40;
var FrameRangeSetting = ({ startFrame, endFrame, setEndFrame, durationInFrames, setStartFrame }) => {
  const minStartFrame = 0;
  const maxEndFrame = durationInFrames - 1;
  const onStartFrameChangedDirectly = useCallback119((newStartFrame) => {
    setStartFrame(newStartFrame);
  }, [setStartFrame]);
  const onEndFrameChangedDirectly = useCallback119((newEndFrame) => {
    setEndFrame(newEndFrame);
  }, [setEndFrame]);
  const onStartFrameChanged = useCallback119((newVal) => {
    onStartFrameChangedDirectly(parseInt(newVal, 10));
  }, [onStartFrameChangedDirectly]);
  const onEndFrameChanged = useCallback119((newVal) => {
    onEndFrameChangedDirectly(parseInt(newVal, 10));
  }, [onEndFrameChangedDirectly]);
  return /* @__PURE__ */ jsxs124("div", {
    style: optionRow,
    children: [
      /* @__PURE__ */ jsx244("div", {
        style: label5,
        children: "Frame range"
      }),
      /* @__PURE__ */ jsxs124("div", {
        style: rightRow,
        children: [
          /* @__PURE__ */ jsx244("div", {
            style: { width: INPUT_WIDTH },
            children: /* @__PURE__ */ jsx244(InputDragger, {
              min: minStartFrame,
              max: endFrame - 1,
              name: "Start frame",
              value: startFrame,
              step: 1,
              onTextChange: onStartFrameChanged,
              onValueChange: onStartFrameChangedDirectly,
              status: "ok",
              rightAlign: true,
              style: { width: INPUT_WIDTH }
            })
          }),
          /* @__PURE__ */ jsx244(MultiRangeSlider, {
            min: minStartFrame,
            max: maxEndFrame,
            start: startFrame,
            end: endFrame,
            step: 1,
            onLeftThumbDrag: onStartFrameChangedDirectly,
            onRightThumbDrag: onEndFrameChangedDirectly
          }),
          " ",
          /* @__PURE__ */ jsx244("div", {
            style: { width: INPUT_WIDTH },
            children: /* @__PURE__ */ jsx244(InputDragger, {
              min: startFrame + 1,
              max: maxEndFrame,
              name: "End frame",
              value: endFrame,
              step: 1,
              onTextChange: onEndFrameChanged,
              onValueChange: onEndFrameChangedDirectly,
              status: "ok",
              rightAlign: true,
              style: { width: INPUT_WIDTH }
            })
          })
        ]
      })
    ]
  });
};

// src/components/RenderModal/human-readable-codec.ts
var humanReadableCodec = (codec) => {
  if (codec === "aac") {
    return "AAC";
  }
  if (codec === "mp3") {
    return "MP3";
  }
  if (codec === "gif") {
    return "GIF";
  }
  if (codec === "h264") {
    return "H.264";
  }
  if (codec === "h264-mkv") {
    return "H.264 (Matroska)";
  }
  if (codec === "h264-ts") {
    return "H.264 (Transport Stream)";
  }
  if (codec === "h265") {
    return "H.265";
  }
  if (codec === "prores") {
    return "ProRes";
  }
  if (codec === "vp8") {
    return "VP8";
  }
  if (codec === "vp9") {
    return "VP9";
  }
  if (codec === "wav") {
    return "Waveform";
  }
  throw new TypeError(`Got unexpected codec "${codec}"`);
};

// src/components/RenderModal/RenderModalBasic.tsx
import { jsx as jsx245, jsxs as jsxs125 } from "react/jsx-runtime";
var container55 = {
  flex: 1
};
var RenderModalBasic = ({
  renderMode,
  imageFormatOptions,
  outName,
  codec,
  setVideoCodec: setCodec,
  proResProfile,
  setProResProfile,
  frame: frame2,
  setFrame,
  resolvedComposition,
  setOutName,
  setEndFrame,
  endFrame,
  setStartFrame,
  startFrame,
  validationMessage,
  setVerboseLogging,
  logLevel
}) => {
  const existence = useFileExistence(outName);
  const videoCodecOptions = useMemo122(() => {
    return BrowserSafeApis6.validCodecs.filter((c) => {
      return NoReactAPIs.isAudioCodec(c) === (renderMode === "audio");
    }).map((codecOption) => {
      return {
        label: humanReadableCodec(codecOption),
        onClick: () => setCodec(codecOption),
        key: codecOption,
        leftItem: codec === codecOption ? /* @__PURE__ */ jsx245(Checkmark, {}) : null,
        id: codecOption,
        keyHint: null,
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item",
        value: codecOption
      };
    });
  }, [renderMode, setCodec, codec]);
  const proResProfileOptions = useMemo122(() => {
    return BrowserSafeApis6.proResProfileOptions.map((option) => {
      return {
        label: labelProResProfile(option),
        onClick: () => setProResProfile(option),
        key: option,
        selected: proResProfile === option,
        type: "item",
        id: option,
        keyHint: null,
        leftItem: null,
        quickSwitcherLabel: null,
        subMenu: null,
        value: option
      };
    });
  }, [proResProfile, setProResProfile]);
  const onFrameSetDirectly = useCallback120((newFrame) => {
    setFrame(newFrame);
  }, [setFrame]);
  const onFrameChanged = useCallback120((e) => {
    setFrame((q) => {
      const newFrame = parseFloat(e);
      if (Number.isNaN(newFrame)) {
        return q;
      }
      return newFrame;
    });
  }, [setFrame]);
  const onValueChange = useCallback120((e) => {
    setOutName(e.target.value);
  }, [setOutName]);
  const onVerboseLoggingChanged = useCallback120((e) => {
    setVerboseLogging(e.target.checked ? "verbose" : "info");
  }, [setVerboseLogging]);
  return /* @__PURE__ */ jsxs125("div", {
    style: container55,
    children: [
      renderMode === "still" || renderMode === "sequence" ? /* @__PURE__ */ jsxs125("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsx245("div", {
            style: label5,
            children: "Format"
          }),
          /* @__PURE__ */ jsx245("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx245(SegmentedControl, {
              items: imageFormatOptions,
              needsWrapping: true
            })
          })
        ]
      }) : /* @__PURE__ */ jsxs125("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsxs125("div", {
            style: label5,
            children: [
              "Codec",
              /* @__PURE__ */ jsx245(Spacing, {
                x: 0.5
              }),
              /* @__PURE__ */ jsx245(OptionExplainerBubble, {
                id: "videoCodecOption"
              })
            ]
          }),
          /* @__PURE__ */ jsx245("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx245(Combobox, {
              values: videoCodecOptions,
              selectedId: codec,
              title: "Codec"
            })
          })
        ]
      }),
      renderMode === "still" && resolvedComposition.durationInFrames > 1 ? /* @__PURE__ */ jsxs125("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsx245("div", {
            style: label5,
            children: "Frame"
          }),
          /* @__PURE__ */ jsx245("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx245(RightAlignInput, {
              children: /* @__PURE__ */ jsx245(InputDragger, {
                value: frame2,
                onTextChange: onFrameChanged,
                placeholder: `0-${resolvedComposition.durationInFrames - 1}`,
                onValueChange: onFrameSetDirectly,
                name: "frame",
                step: 1,
                min: 0,
                status: "ok",
                max: resolvedComposition.durationInFrames - 1,
                rightAlign: true
              })
            })
          })
        ]
      }) : null,
      renderMode === "video" && codec === "prores" ? /* @__PURE__ */ jsxs125("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsx245("div", {
            style: label5,
            children: "ProRes profile"
          }),
          /* @__PURE__ */ jsx245("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx245(Combobox, {
              title: "proResProfile",
              selectedId: proResProfile,
              values: proResProfileOptions
            })
          })
        ]
      }) : null,
      renderMode === "still" ? null : /* @__PURE__ */ jsx245(FrameRangeSetting, {
        durationInFrames: resolvedComposition.durationInFrames,
        endFrame,
        setEndFrame,
        setStartFrame,
        startFrame
      }),
      /* @__PURE__ */ jsx245(RenderModalOutputName, {
        existence,
        inputStyle: input,
        outName,
        onValueChange,
        validationMessage,
        label: renderMode === "sequence" ? "Folder name" : "Output name"
      }),
      /* @__PURE__ */ jsxs125("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsxs125("div", {
            style: label5,
            children: [
              "Verbose logging ",
              /* @__PURE__ */ jsx245(Spacing, {
                x: 0.5
              }),
              /* @__PURE__ */ jsx245(OptionExplainerBubble, {
                id: "logLevelOption"
              })
            ]
          }),
          /* @__PURE__ */ jsx245("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx245(Checkbox, {
              checked: logLevel === "verbose",
              onChange: onVerboseLoggingChanged,
              name: "verbose-logging"
            })
          })
        ]
      })
    ]
  });
};

// src/components/RenderModal/RenderModalGif.tsx
import { useCallback as useCallback122 } from "react";

// src/components/RenderModal/NumberOfLoopsSetting.tsx
import { useCallback as useCallback121 } from "react";
import { jsx as jsx246, jsxs as jsxs126 } from "react/jsx-runtime";
var min = 0;
var NumberOfLoopsSetting = ({ numberOfGifLoops, setNumberOfGifLoops }) => {
  const onNumberOfGifLoopsChangedDirectly = useCallback121((newConcurrency) => {
    setNumberOfGifLoops(newConcurrency);
  }, [setNumberOfGifLoops]);
  const onNumberOfGifLoopsChanged = useCallback121((e) => {
    setNumberOfGifLoops((q) => {
      const newConcurrency = parseInt(e, 10);
      if (Number.isNaN(newConcurrency)) {
        return q;
      }
      const newConcurrencyClamped = Math.max(newConcurrency, min);
      return newConcurrencyClamped;
    });
  }, [setNumberOfGifLoops]);
  return /* @__PURE__ */ jsxs126("div", {
    style: optionRow,
    children: [
      /* @__PURE__ */ jsx246("div", {
        style: label5,
        children: "Number of loops"
      }),
      /* @__PURE__ */ jsx246("div", {
        style: rightRow,
        children: /* @__PURE__ */ jsx246(RightAlignInput, {
          children: /* @__PURE__ */ jsx246(InputDragger, {
            value: numberOfGifLoops,
            onTextChange: onNumberOfGifLoopsChanged,
            placeholder: `${min}-`,
            onValueChange: onNumberOfGifLoopsChangedDirectly,
            name: "number-of-gif-loops",
            step: 1,
            min,
            status: "ok",
            rightAlign: true
          })
        })
      })
    ]
  });
};

// src/components/RenderModal/RenderModalGif.tsx
import { jsx as jsx247, jsxs as jsxs127 } from "react/jsx-runtime";
var container56 = {
  flex: 1
};
var RenderModalGif = ({
  everyNthFrame,
  limitNumberOfGifLoops,
  numberOfGifLoopsSetting,
  setEveryNthFrameSetting,
  setLimitNumberOfGifLoops,
  setNumberOfGifLoopsSetting
}) => {
  const onShouldLimitNumberOfGifLoops = useCallback122((e) => {
    setLimitNumberOfGifLoops(e.target.checked);
  }, [setLimitNumberOfGifLoops]);
  return /* @__PURE__ */ jsxs127("div", {
    style: container56,
    children: [
      /* @__PURE__ */ jsx247(NumberSetting, {
        name: "Every nth frame",
        min: 1,
        onValueChanged: setEveryNthFrameSetting,
        value: everyNthFrame,
        step: 1
      }),
      /* @__PURE__ */ jsxs127("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsxs127("div", {
            style: label5,
            children: [
              "Limit GIF loops ",
              /* @__PURE__ */ jsx247(Spacing, {
                x: 0.5
              }),
              /* @__PURE__ */ jsx247(OptionExplainerBubble, {
                id: "numberOfGifLoopsOption"
              })
            ]
          }),
          /* @__PURE__ */ jsx247("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx247(Checkbox, {
              checked: limitNumberOfGifLoops,
              onChange: onShouldLimitNumberOfGifLoops,
              name: "limitNumberOfGifLoops"
            })
          })
        ]
      }),
      limitNumberOfGifLoops ? /* @__PURE__ */ jsx247(NumberOfLoopsSetting, {
        numberOfGifLoops: numberOfGifLoopsSetting,
        setNumberOfGifLoops: setNumberOfGifLoopsSetting
      }) : null
    ]
  });
};

// src/components/RenderModal/RenderModalPicture.tsx
import { BrowserSafeApis as BrowserSafeApis7 } from "@remotion/renderer/client";
import { useCallback as useCallback123, useMemo as useMemo124 } from "react";

// src/components/RenderModal/JpegQualitySetting.tsx
import { jsx as jsx248 } from "react/jsx-runtime";
var MIN_JPEG_QUALITY = 1;
var MAX_JPEG_QUALITY = 100;
var JpegQualitySetting = ({ jpegQuality, setJpegQuality }) => {
  return /* @__PURE__ */ jsx248(NumberSetting, {
    min: MIN_JPEG_QUALITY,
    max: MAX_JPEG_QUALITY,
    step: 1,
    name: "JPEG Quality",
    onValueChanged: setJpegQuality,
    value: jpegQuality,
    hint: "jpegQualityOption"
  });
};

// src/components/RenderModal/ScaleSetting.tsx
import { useMemo as useMemo123 } from "react";
import { jsx as jsx249, jsxs as jsxs128, Fragment as Fragment41 } from "react/jsx-runtime";
var MIN_SCALE = 0.1;
var MAX_SCALE = 10;
var outputDimensionsStyle = {
  fontSize: 13,
  color: LIGHT_TEXT,
  fontFamily: "sans-serif",
  paddingRight: 16,
  textAlign: "right",
  marginBottom: 14,
  marginTop: -10
};
var ScaleSetting = ({ scale, setScale, compositionWidth, compositionHeight }) => {
  const outputDimensions = useMemo123(() => {
    const outputWidth = Math.round(compositionWidth * scale);
    const outputHeight = Math.round(compositionHeight * scale);
    return `${outputWidth}×${outputHeight}`;
  }, [compositionWidth, compositionHeight, scale]);
  return /* @__PURE__ */ jsxs128(Fragment41, {
    children: [
      /* @__PURE__ */ jsx249(NumberSetting, {
        min: MIN_SCALE,
        max: MAX_SCALE,
        step: 0.1,
        name: "Scale",
        formatter: (w) => {
          if (typeof w === "number") {
            return `${w.toFixed(1)}x`;
          }
          return `${w}x`;
        },
        onValueChanged: setScale,
        value: scale,
        hint: "scaleOption"
      }),
      scale !== 1 && /* @__PURE__ */ jsxs128("div", {
        style: outputDimensionsStyle,
        children: [
          "Output resolution: ",
          outputDimensions
        ]
      })
    ]
  });
};

// src/components/RenderModal/RenderModalPicture.tsx
import { jsx as jsx250, jsxs as jsxs129, Fragment as Fragment42 } from "react/jsx-runtime";
var qualityControlModes = ["crf", "bitrate"];
var container57 = {
  flex: 1,
  overflowY: "auto"
};
var RenderModalPicture = ({
  renderMode,
  scale,
  setScale,
  pixelFormat,
  imageFormatOptions,
  setQualityControl,
  qualityControlType,
  videoImageFormat,
  setJpegQuality,
  jpegQuality,
  maxCrf,
  minCrf,
  setCrf,
  shouldDisplayQualityControlPicker,
  setCustomTargetVideoBitrateValue,
  crf,
  customTargetVideoBitrate,
  stillImageFormat,
  colorSpace,
  setColorSpace,
  pixelFormatOptions,
  encodingBufferSize,
  encodingMaxRate,
  setEncodingBufferSize,
  setEncodingMaxRate,
  compositionWidth,
  compositionHeight
}) => {
  const colorSpaceOptions = useMemo124(() => {
    return BrowserSafeApis7.validColorSpaces.map((option) => {
      return {
        label: option,
        onClick: () => setColorSpace(option),
        key: option,
        id: option,
        keyHint: null,
        leftItem: colorSpace === option ? /* @__PURE__ */ jsx250(Checkmark, {}) : null,
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item",
        value: option
      };
    });
  }, [colorSpace, setColorSpace]);
  const qualityControlOptions = useMemo124(() => {
    return qualityControlModes.map((option) => {
      return {
        label: option === "crf" ? "CRF" : "Bitrate",
        onClick: () => setQualityControl(option),
        key: option,
        selected: qualityControlType === option
      };
    });
  }, [qualityControlType, setQualityControl]);
  const onTargetVideoBitrateChanged = useCallback123((e) => {
    setCustomTargetVideoBitrateValue(e.target.value);
  }, [setCustomTargetVideoBitrateValue]);
  const onEncodingBufferSizeToggled = useCallback123((e) => {
    setEncodingBufferSize(e.target.checked ? "10000k" : null);
  }, [setEncodingBufferSize]);
  const onEncodingMaxRateToggled = useCallback123((e) => {
    setEncodingMaxRate(e.target.checked ? "5000k" : null);
  }, [setEncodingMaxRate]);
  const onEncodingBufferSizeChanged = useCallback123((e) => {
    setEncodingBufferSize(e.target.value);
  }, [setEncodingBufferSize]);
  const onEncodingMaxRateChanged = useCallback123((e) => {
    setEncodingMaxRate(e.target.value);
  }, [setEncodingMaxRate]);
  return /* @__PURE__ */ jsxs129("div", {
    style: container57,
    className: VERTICAL_SCROLLBAR_CLASSNAME,
    children: [
      renderMode === "video" ? /* @__PURE__ */ jsxs129("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsx250("div", {
            style: label5,
            children: "Image Format"
          }),
          /* @__PURE__ */ jsx250("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx250(SegmentedControl, {
              items: imageFormatOptions,
              needsWrapping: false
            })
          })
        ]
      }) : null,
      renderMode === "video" && videoImageFormat === "jpeg" && /* @__PURE__ */ jsx250(JpegQualitySetting, {
        jpegQuality,
        setJpegQuality
      }),
      renderMode === "still" && stillImageFormat === "jpeg" && /* @__PURE__ */ jsx250(JpegQualitySetting, {
        jpegQuality,
        setJpegQuality
      }),
      renderMode === "video" && qualityControlType !== null ? /* @__PURE__ */ jsx250(RenderModalHr, {}) : null,
      shouldDisplayQualityControlPicker && renderMode === "video" ? /* @__PURE__ */ jsxs129("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsx250("div", {
            style: label5,
            children: "Quality control"
          }),
          /* @__PURE__ */ jsx250("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx250(SegmentedControl, {
              items: qualityControlOptions,
              needsWrapping: true
            })
          })
        ]
      }) : null,
      qualityControlType === "crf" && renderMode !== "still" && renderMode !== "sequence" && crf !== null ? /* @__PURE__ */ jsx250(CrfSetting, {
        crf,
        min: minCrf,
        max: maxCrf,
        setCrf,
        option: "crfOption"
      }) : null,
      qualityControlType === "bitrate" && renderMode === "video" ? /* @__PURE__ */ jsxs129("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsxs129("div", {
            style: label5,
            children: [
              "Target video bitrate",
              /* @__PURE__ */ jsx250(Spacing, {
                x: 0.5
              }),
              /* @__PURE__ */ jsx250(OptionExplainerBubble, {
                id: "videoBitrateOption"
              })
            ]
          }),
          /* @__PURE__ */ jsx250("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx250("div", {
              children: /* @__PURE__ */ jsx250(RemotionInput, {
                style: input,
                value: customTargetVideoBitrate,
                onChange: onTargetVideoBitrateChanged,
                status: "ok",
                rightAlign: true
              })
            })
          })
        ]
      }) : null,
      renderMode === "video" ? /* @__PURE__ */ jsxs129(Fragment42, {
        children: [
          /* @__PURE__ */ jsxs129("div", {
            style: optionRow,
            children: [
              /* @__PURE__ */ jsxs129("div", {
                style: label5,
                children: [
                  "Custom FFmpeg -bufsize",
                  /* @__PURE__ */ jsx250(Spacing, {
                    x: 0.5
                  }),
                  /* @__PURE__ */ jsx250(OptionExplainerBubble, {
                    id: "encodingBufferSizeOption"
                  })
                ]
              }),
              /* @__PURE__ */ jsx250("div", {
                style: rightRow,
                children: /* @__PURE__ */ jsx250(Checkbox, {
                  checked: encodingBufferSize !== null,
                  onChange: onEncodingBufferSizeToggled,
                  name: "encoding-buffer-size"
                })
              })
            ]
          }),
          encodingBufferSize === null ? null : /* @__PURE__ */ jsxs129("div", {
            style: optionRow,
            children: [
              /* @__PURE__ */ jsx250("div", {
                style: label5,
                children: "-bufsize value"
              }),
              /* @__PURE__ */ jsx250("div", {
                style: rightRow,
                children: /* @__PURE__ */ jsx250("div", {
                  children: /* @__PURE__ */ jsx250(RemotionInput, {
                    style: input,
                    value: encodingBufferSize,
                    onChange: onEncodingBufferSizeChanged,
                    status: "ok",
                    rightAlign: true
                  })
                })
              })
            ]
          }),
          /* @__PURE__ */ jsxs129("div", {
            style: optionRow,
            children: [
              /* @__PURE__ */ jsxs129("div", {
                style: label5,
                children: [
                  "Custom FFmpeg -maxrate",
                  /* @__PURE__ */ jsx250(Spacing, {
                    x: 0.5
                  }),
                  /* @__PURE__ */ jsx250(OptionExplainerBubble, {
                    id: "encodingMaxRateOption"
                  })
                ]
              }),
              /* @__PURE__ */ jsx250("div", {
                style: rightRow,
                children: /* @__PURE__ */ jsx250(Checkbox, {
                  checked: encodingMaxRate !== null,
                  onChange: onEncodingMaxRateToggled,
                  name: "encoding-max-rate"
                })
              })
            ]
          }),
          encodingMaxRate === null ? null : /* @__PURE__ */ jsxs129("div", {
            style: optionRow,
            children: [
              /* @__PURE__ */ jsx250("div", {
                style: label5,
                children: "-maxrate value"
              }),
              /* @__PURE__ */ jsx250("div", {
                style: rightRow,
                children: /* @__PURE__ */ jsx250("div", {
                  children: /* @__PURE__ */ jsx250(RemotionInput, {
                    style: input,
                    value: encodingMaxRate,
                    onChange: onEncodingMaxRateChanged,
                    status: "ok",
                    rightAlign: true
                  })
                })
              })
            ]
          })
        ]
      }) : null,
      renderMode === "video" ? /* @__PURE__ */ jsx250(RenderModalHr, {}) : null,
      /* @__PURE__ */ jsx250(ScaleSetting, {
        scale,
        setScale,
        compositionWidth,
        compositionHeight
      }),
      renderMode === "video" ? /* @__PURE__ */ jsx250(RenderModalHr, {}) : null,
      renderMode === "video" ? /* @__PURE__ */ jsxs129("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsx250("div", {
            style: label5,
            children: "Pixel format"
          }),
          /* @__PURE__ */ jsx250("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx250(Combobox, {
              values: pixelFormatOptions,
              selectedId: pixelFormat,
              title: "Pixel Format"
            })
          })
        ]
      }) : null,
      renderMode === "video" ? /* @__PURE__ */ jsxs129("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsxs129("div", {
            style: label5,
            children: [
              "Color space",
              /* @__PURE__ */ jsx250(Spacing, {
                x: 0.5
              }),
              /* @__PURE__ */ jsx250(OptionExplainerBubble, {
                id: "colorSpaceOption"
              })
            ]
          }),
          /* @__PURE__ */ jsx250("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx250(Combobox, {
              values: colorSpaceOptions,
              selectedId: colorSpace,
              title: "Color Space"
            })
          })
        ]
      }) : null
    ]
  });
};

// src/components/RenderModal/get-default-codecs.ts
import { BrowserSafeApis as BrowserSafeApis8 } from "@remotion/renderer/client";
import { NoReactAPIs as NoReactAPIs2 } from "@remotion/renderer/pure";
var getDefaultCodecs = ({
  defaultConfigurationVideoCodec,
  compositionDefaultVideoCodec,
  renderType,
  defaultConfigurationAudioCodec
}) => {
  const userPreferredVideoCodec = compositionDefaultVideoCodec ?? defaultConfigurationVideoCodec ?? "h264";
  const userPreferredVideoCodecForAudioTab = userPreferredVideoCodec === "aac" ? "aac" : userPreferredVideoCodec === "mp3" ? "mp3" : userPreferredVideoCodec === "wav" ? "wav" : defaultConfigurationAudioCodec === "pcm-16" ? "wav" : defaultConfigurationAudioCodec === "mp3" ? "mp3" : "aac";
  const isVideoCodecAnAudioCodec = NoReactAPIs2.isAudioCodec(userPreferredVideoCodec);
  if (isVideoCodecAnAudioCodec) {
    return {
      initialAudioCodec: userPreferredVideoCodec,
      initialRenderType: "audio",
      initialVideoCodec: userPreferredVideoCodec,
      initialVideoCodecForAudioTab: userPreferredVideoCodecForAudioTab,
      initialVideoCodecForVideoTab: NoReactAPIs2.isAudioCodec(defaultConfigurationVideoCodec) ? "h264" : defaultConfigurationVideoCodec
    };
  }
  const suitableAudioCodecForVideoCodec = BrowserSafeApis8.defaultAudioCodecs[userPreferredVideoCodec].compressed;
  return {
    initialAudioCodec: defaultConfigurationAudioCodec ?? suitableAudioCodecForVideoCodec,
    initialVideoCodec: userPreferredVideoCodec,
    initialRenderType: renderType,
    initialVideoCodecForAudioTab: userPreferredVideoCodecForAudioTab,
    initialVideoCodecForVideoTab: userPreferredVideoCodec
  };
};

// src/components/RenderModal/out-name-checker.ts
import { BrowserSafeApis as BrowserSafeApis9 } from "@remotion/renderer/client";
var invalidCharacters = ["?", "*", "+", ":", "%"];
var isValidStillExtension = (extension, stillImageFormat) => {
  if (stillImageFormat === "jpeg" && extension === "jpg") {
    return true;
  }
  return extension === stillImageFormat;
};
var validateOutnameGui = ({
  outName,
  codec,
  audioCodec,
  renderMode,
  stillImageFormat,
  separateAudioTo
}) => {
  try {
    isValidOutName({
      audioCodec,
      codec,
      outName,
      renderMode,
      stillImageFormat,
      separateAudioTo
    });
    return { valid: true };
  } catch (err) {
    return { valid: false, error: err };
  }
};
var isValidOutName = ({
  outName,
  codec,
  audioCodec,
  renderMode,
  stillImageFormat,
  separateAudioTo
}) => {
  const extension = outName.substring(outName.lastIndexOf(".") + 1);
  const prefix = outName.substring(0, outName.lastIndexOf("."));
  const map = BrowserSafeApis9.defaultFileExtensionMap[codec];
  if (BrowserSafeApis9.supportedAudioCodecs[codec].length > 0 && !(audioCodec in map.forAudioCodec)) {
    throw new Error(`Audio codec ${audioCodec} is not supported for codec ${codec}`);
  }
  const hasDotAfterSlash = () => {
    const substrings = prefix.split("/");
    for (const str of substrings) {
      if (str[0] === ".") {
        return true;
      }
    }
    return false;
  };
  const hasInvalidChar = () => {
    return prefix.split("").some((char) => invalidCharacters.includes(char));
  };
  if (renderMode === "video" || renderMode === "audio") {
    BrowserSafeApis9.validateOutputFilename({
      codec,
      audioCodecSetting: audioCodec ?? null,
      extension,
      preferLossless: false,
      separateAudioTo
    });
  }
  if (prefix.length < 1 && renderMode !== "sequence") {
    throw new Error("The prefix must be at least 1 character long");
  }
  if (prefix[0] === "." || hasDotAfterSlash()) {
    throw new Error("The output name must not start with a dot");
  }
  if (hasInvalidChar()) {
    throw new Error("Filename can't contain the following characters:  ?, *, +, %, :");
  }
  if (renderMode === "still" && stillImageFormat && !isValidStillExtension(extension, stillImageFormat)) {
    throw new Error(`The extension ${extension} is not supported for still image format ${stillImageFormat}`);
  }
  if (renderMode === "sequence") {
    if (outName.includes(".")) {
      throw new Error("Folder names must not contain a dot");
    }
  }
};

// src/components/RenderModal/RenderModal.tsx
import { jsx as jsx251, jsxs as jsxs130 } from "react/jsx-runtime";
var initialState2 = { type: "idle" };
var reducer2 = (state, action) => {
  if (action.type === "start") {
    return {
      type: "load"
    };
  }
  if (action.type === "fail") {
    return {
      type: "error"
    };
  }
  if (action.type === "succeed") {
    return {
      type: "success"
    };
  }
  return state;
};
var container58 = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  padding: "12px 16px",
  borderBottom: "1px solid black"
};
var optionsPanel = {
  display: "flex",
  width: "100%"
};
var horizontalLayout = {
  display: "flex",
  flexDirection: "row",
  overflowY: "auto",
  flex: 1
};
var leftSidebar = {
  padding: 12
};
var horizontalTab = {
  width: 250,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  textAlign: "left",
  fontSize: 16,
  fontWeight: "bold",
  paddingLeft: 15,
  paddingTop: 12,
  paddingBottom: 12
};
var iconContainer = {
  width: 20,
  height: 20,
  marginRight: 15,
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center"
};
var icon6 = {
  color: "currentcolor",
  height: 20
};
var buttonStyle7 = {
  backgroundColor: BLUE,
  color: "white"
};
var flexer = {
  flex: 1
};
var outer3 = {
  width: getMaxModalWidth(1000),
  height: getMaxModalHeight(640),
  overflow: "hidden",
  display: "flex",
  flexDirection: "column"
};
var RenderModal = ({
  initialFrame,
  initialVideoImageFormat,
  initialStillImageFormat,
  initialJpegQuality,
  initialScale,
  initialLogLevel,
  initialConcurrency,
  maxConcurrency,
  minConcurrency,
  initialMuted,
  initialEnforceAudioTrack,
  initialProResProfile,
  initialx264Preset,
  initialPixelFormat,
  initialVideoBitrate,
  initialAudioBitrate,
  initialEveryNthFrame,
  initialNumberOfGifLoops,
  initialDelayRenderTimeout,
  initialOffthreadVideoCacheSizeInBytes,
  initialEnvVariables,
  initialDisableWebSecurity,
  initialGl,
  initialHeadless,
  initialIgnoreCertificateErrors,
  initialEncodingBufferSize,
  initialEncodingMaxRate,
  initialOffthreadVideoThreads,
  initialUserAgent,
  defaultProps,
  inFrameMark,
  outFrameMark,
  initialColorSpace,
  initialMultiProcessOnLinux,
  defaultConfigurationAudioCodec,
  defaultConfigurationVideoCodec,
  initialBeep,
  initialRepro,
  initialForSeamlessAacConcatenation,
  renderTypeOfLastRender,
  initialHardwareAcceleration,
  defaultMetadata,
  initialChromeMode
}) => {
  const { setSelectedModal } = useContext79(ModalsContext);
  const context = useContext79(ResolvedCompositionContext);
  if (!context) {
    throw new Error("Should not be able to render without resolving comp first");
  }
  const {
    resolved: { result: resolvedComposition },
    unresolved: unresolvedComposition
  } = context;
  const isMounted = useRef40(true);
  const [isVideo] = useState77(() => {
    return typeof resolvedComposition.durationInFrames === "undefined" ? true : resolvedComposition.durationInFrames > 1;
  });
  const [
    {
      initialAudioCodec,
      initialRenderType,
      initialVideoCodec,
      initialVideoCodecForAudioTab,
      initialVideoCodecForVideoTab
    }
  ] = useState77(() => {
    return getDefaultCodecs({
      defaultConfigurationVideoCodec,
      compositionDefaultVideoCodec: resolvedComposition.defaultCodec,
      defaultConfigurationAudioCodec,
      renderType: renderTypeOfLastRender ?? (isVideo ? "video" : "still")
    });
  });
  const [state, dispatch] = useReducer2(reducer2, initialState2);
  const [unclampedFrame, setFrame] = useState77(() => initialFrame);
  const [saving, setSaving] = useState77(false);
  const [stillImageFormat, setStillImageFormat] = useState77(() => initialStillImageFormat);
  const [videoImageFormat, setVideoImageFormat] = useState77(() => initialVideoImageFormat);
  const [sequenceImageFormat, setSequenceImageFormat] = useState77(() => initialStillImageFormat === "jpeg" ? "jpeg" : "png");
  const [concurrency, setConcurrency] = useState77(() => initialConcurrency);
  const [videoCodecForVideoTab, setVideoCodecForVideoTab] = useState77(() => initialVideoCodecForVideoTab);
  const [userSelectedAudioCodec, setUserSelectedAudioCodec] = useState77(() => initialAudioCodec);
  const [separateAudioTo, setSeparateAudioTo] = useState77(null);
  const [envVariables, setEnvVariables] = useState77(() => envVariablesObjectToArray(initialEnvVariables).filter(([key5]) => key5 !== "NODE_ENV"));
  const [initialOutName] = useState77(() => {
    return getDefaultOutLocation({
      compositionName: resolvedComposition.id,
      defaultExtension: initialRenderType === "still" ? initialStillImageFormat : isVideo ? BrowserSafeApis10.getFileExtensionFromCodec(initialVideoCodec, initialAudioCodec) : initialStillImageFormat,
      type: "asset",
      compositionDefaultOutName: resolvedComposition.defaultOutName
    });
  });
  const [videoCodecForAudioTab, setVideoCodecForAudioTab] = useState77(() => initialVideoCodecForAudioTab);
  const [mutedState, setMuted] = useState77(() => initialMuted);
  const [repro, setRepro] = useState77(() => initialRepro);
  const [enforceAudioTrackState, setEnforceAudioTrackState] = useState77(() => initialEnforceAudioTrack);
  const [forSeamlessAacConcatenation, setForSeamlessAacConcatenation] = useState77(() => initialForSeamlessAacConcatenation);
  const [renderMode, setRenderModeState] = useState77(initialRenderType);
  const [jpegQuality, setJpegQuality] = useState77(() => initialJpegQuality);
  const [scale, setScale] = useState77(() => initialScale);
  const [logLevel, setLogLevel] = useState77(() => initialLogLevel);
  const [disallowParallelEncoding, setDisallowParallelEncoding] = useState77(false);
  const [disableWebSecurity, setDisableWebSecurity] = useState77(() => initialDisableWebSecurity);
  const [headless, setHeadless] = useState77(() => initialHeadless);
  const [beepOnFinish, setBeepOnFinish] = useState77(() => initialBeep);
  const [ignoreCertificateErrors, setIgnoreCertificateErrors] = useState77(() => initialIgnoreCertificateErrors);
  const [multiProcessOnLinux, setChromiumMultiProcessOnLinux] = useState77(() => initialMultiProcessOnLinux);
  const [openGlOption, setOpenGlOption] = useState77(() => initialGl ?? "default");
  const [colorSpace, setColorSpace] = useState77(() => initialColorSpace);
  const [userAgent, setUserAgent] = useState77(() => initialUserAgent === null ? null : initialUserAgent.trim() === "" ? null : initialUserAgent);
  const chromiumOptions = useMemo125(() => {
    return {
      headless,
      disableWebSecurity,
      ignoreCertificateErrors,
      gl: openGlOption === "default" ? null : openGlOption,
      userAgent: userAgent === null ? null : userAgent.trim() === "" ? null : userAgent,
      enableMultiProcessOnLinux: multiProcessOnLinux
    };
  }, [
    headless,
    disableWebSecurity,
    ignoreCertificateErrors,
    openGlOption,
    userAgent,
    multiProcessOnLinux
  ]);
  const [outName, setOutName] = useState77(() => initialOutName);
  const [endFrameOrNull, setEndFrame] = useState77(() => outFrameMark ?? null);
  const [startFrameOrNull, setStartFrame] = useState77(() => inFrameMark ?? null);
  const [proResProfileSetting, setProResProfile] = useState77(() => initialProResProfile);
  const [x264PresetSetting, setx264Preset] = useState77(() => initialx264Preset);
  const [hardwareAcceleration, setHardwareAcceleration] = useState77(() => initialHardwareAcceleration);
  const [userPreferredPixelFormat, setPixelFormat] = useState77(() => initialPixelFormat);
  const [preferredQualityControlType, setQualityControl] = useState77(() => initialVideoBitrate === null ? "crf" : "bitrate");
  const [
    shouldHaveCustomTargetAudioBitrate,
    setShouldHaveCustomTargetAudioBitrate
  ] = useState77(() => initialAudioBitrate !== null);
  const [customTargetAudioBitrate, setCustomTargetAudioBitrateValue] = useState77(() => initialAudioBitrate ?? "320K");
  const [customTargetVideoBitrate, setCustomTargetVideoBitrateValue] = useState77(() => initialVideoBitrate ?? "1M");
  const [encodingMaxRate, setEncodingMaxRate] = useState77(() => initialEncodingMaxRate ?? null);
  const [encodingBufferSize, setEncodingBufferSize] = useState77(() => initialEncodingBufferSize ?? null);
  const [limitNumberOfGifLoops, setLimitNumberOfGifLoops] = useState77(() => initialNumberOfGifLoops !== null);
  const [numberOfGifLoopsSetting, setNumberOfGifLoopsSetting] = useState77(() => initialNumberOfGifLoops ?? 0);
  const [delayRenderTimeout, setDelayRenderTimeout] = useState77(() => initialDelayRenderTimeout);
  const [chromeMode, setChromeMode] = useState77(() => initialChromeMode);
  const [offthreadVideoCacheSizeInBytes, setOffthreadVideoCacheSizeInBytes] = useState77(initialOffthreadVideoCacheSizeInBytes);
  const [offthreadVideoThreads, setOffthreadVideoThreads] = useState77(() => initialOffthreadVideoThreads);
  const codec = useMemo125(() => {
    if (renderMode === "audio") {
      return videoCodecForAudioTab;
    }
    return videoCodecForVideoTab;
  }, [videoCodecForAudioTab, renderMode, videoCodecForVideoTab]);
  const numberOfGifLoops = useMemo125(() => {
    if (codec === "gif" && limitNumberOfGifLoops) {
      return numberOfGifLoopsSetting;
    }
    return null;
  }, [codec, limitNumberOfGifLoops, numberOfGifLoopsSetting]);
  const audioBitrate = useMemo125(() => {
    if (shouldHaveCustomTargetAudioBitrate) {
      return customTargetAudioBitrate;
    }
    return null;
  }, [customTargetAudioBitrate, shouldHaveCustomTargetAudioBitrate]);
  const supportsCrf = BrowserSafeApis10.codecSupportsCrf(codec);
  const supportsVideoBitrate = BrowserSafeApis10.codecSupportsVideoBitrate(codec);
  const supportsBothQualityControls = useMemo125(() => {
    return supportsCrf && supportsVideoBitrate;
  }, [supportsCrf, supportsVideoBitrate]);
  const qualityControlType = useMemo125(() => {
    if (supportsBothQualityControls) {
      return preferredQualityControlType;
    }
    if (supportsCrf) {
      return "crf";
    }
    if (supportsVideoBitrate) {
      return "bitrate";
    }
    return null;
  }, [
    preferredQualityControlType,
    supportsBothQualityControls,
    supportsCrf,
    supportsVideoBitrate
  ]);
  const videoBitrate = useMemo125(() => {
    if (qualityControlType === "bitrate") {
      return customTargetVideoBitrate;
    }
    return null;
  }, [customTargetVideoBitrate, qualityControlType]);
  const { crf, maxCrf, minCrf, setCrf } = useCrfState(codec);
  const dispatchIfMounted = useCallback124((payload) => {
    if (isMounted.current === false)
      return;
    dispatch(payload);
  }, []);
  const muted = useMemo125(() => {
    if (renderMode === "video") {
      return mutedState;
    }
    return false;
  }, [mutedState, renderMode]);
  const enforceAudioTrack = useMemo125(() => {
    if (renderMode === "video") {
      return enforceAudioTrackState;
    }
    if (renderMode === "audio") {
      return enforceAudioTrackState;
    }
    return false;
  }, [enforceAudioTrackState, renderMode]);
  const proResProfile = useMemo125(() => {
    if (renderMode === "video" && codec === "prores") {
      return proResProfileSetting;
    }
    return null;
  }, [codec, proResProfileSetting, renderMode]);
  const x264Preset = useMemo125(() => {
    if (renderMode === "video" && codec === "h264") {
      return x264PresetSetting;
    }
    return null;
  }, [codec, x264PresetSetting, renderMode]);
  const [inputProps, setInputProps] = useState77(() => defaultProps);
  const [metadata] = useState77(() => defaultMetadata);
  const endFrame = useMemo125(() => {
    if (endFrameOrNull === null) {
      return resolvedComposition.durationInFrames - 1;
    }
    return Math.max(0, Math.min(resolvedComposition.durationInFrames - 1, endFrameOrNull));
  }, [resolvedComposition.durationInFrames, endFrameOrNull]);
  const startFrame = useMemo125(() => {
    if (startFrameOrNull === null) {
      return 0;
    }
    return Math.max(0, Math.min(endFrame - 1, startFrameOrNull));
  }, [endFrame, startFrameOrNull]);
  const frame2 = useMemo125(() => {
    const parsed = Math.floor(unclampedFrame);
    return Math.max(0, Math.min(resolvedComposition.durationInFrames - 1, parsed));
  }, [resolvedComposition.durationInFrames, unclampedFrame]);
  const deriveFinalAudioCodec = useCallback124((passedVideoCodec, passedAudioCodec) => {
    if (passedAudioCodec !== null && BrowserSafeApis10.supportedAudioCodecs[passedVideoCodec].includes(passedAudioCodec)) {
      return passedAudioCodec;
    }
    return BrowserSafeApis10.defaultAudioCodecs[passedVideoCodec].compressed;
  }, []);
  const setDefaultOutName = useCallback124((options) => {
    if (options.type === "still") {
      setOutName((prev) => {
        const newFileName = getStringBeforeSuffix(prev) + "." + options.imageFormat;
        return newFileName;
      });
    } else if (options.type === "sequence") {
      setOutName((prev) => {
        const folderName = getStringBeforeSuffix(prev);
        return folderName;
      });
    } else {
      setOutName((prev) => {
        const codecSuffix = BrowserSafeApis10.getFileExtensionFromCodec(options.codec, deriveFinalAudioCodec(options.codec, options.audioCodec));
        const newFileName = getStringBeforeSuffix(prev) + "." + codecSuffix;
        return newFileName;
      });
    }
  }, [deriveFinalAudioCodec]);
  const setAudioCodec = useCallback124((newAudioCodec) => {
    setUserSelectedAudioCodec(newAudioCodec);
    setDefaultOutName({
      type: "render",
      codec: videoCodecForVideoTab,
      audioCodec: newAudioCodec
    });
    setSeparateAudioTo((prev) => {
      if (prev === null) {
        return null;
      }
      const newExtension = BrowserSafeApis10.getExtensionFromAudioCodec(newAudioCodec);
      const newFileName = getStringBeforeSuffix(prev) + "." + newExtension;
      return newFileName;
    });
  }, [setDefaultOutName, videoCodecForVideoTab]);
  const setCodec = useCallback124((newCodec) => {
    if (renderMode === "audio") {
      setVideoCodecForAudioTab(newCodec);
    } else {
      setVideoCodecForVideoTab(newCodec);
    }
    setDefaultOutName({
      type: "render",
      codec: newCodec,
      audioCodec: deriveFinalAudioCodec(newCodec, userSelectedAudioCodec)
    });
  }, [
    userSelectedAudioCodec,
    deriveFinalAudioCodec,
    renderMode,
    setDefaultOutName
  ]);
  const setStillFormat = useCallback124((format) => {
    setStillImageFormat(format);
    setDefaultOutName({ type: "still", imageFormat: format });
  }, [setDefaultOutName]);
  const { setSidebarCollapsedState } = useContext79(SidebarContext);
  const onClickStill = useCallback124(() => {
    setSidebarCollapsedState({ left: null, right: "expanded" });
    persistSelectedOptionsSidebarPanel2("renders");
    optionsSidebarTabs.current?.selectRendersPanel();
    dispatchIfMounted({ type: "start" });
    addStillRenderJob({
      compositionId: resolvedComposition.id,
      outName,
      imageFormat: stillImageFormat,
      jpegQuality,
      frame: frame2,
      scale,
      logLevel,
      chromiumOptions,
      delayRenderTimeout,
      envVariables: envVariablesArrayToObject(envVariables),
      inputProps,
      offthreadVideoCacheSizeInBytes,
      multiProcessOnLinux,
      beepOnFinish,
      metadata,
      chromeMode,
      offthreadVideoThreads
    }).then(() => {
      dispatchIfMounted({ type: "succeed" });
      setSelectedModal(null);
    }).catch(() => {
      dispatchIfMounted({ type: "fail" });
    });
  }, [
    setSidebarCollapsedState,
    dispatchIfMounted,
    resolvedComposition.id,
    outName,
    stillImageFormat,
    jpegQuality,
    frame2,
    scale,
    logLevel,
    chromiumOptions,
    delayRenderTimeout,
    envVariables,
    inputProps,
    offthreadVideoCacheSizeInBytes,
    multiProcessOnLinux,
    beepOnFinish,
    setSelectedModal,
    metadata,
    chromeMode,
    offthreadVideoThreads
  ]);
  const [everyNthFrameSetting, setEveryNthFrameSetting] = useState77(() => initialEveryNthFrame);
  const everyNthFrame = useMemo125(() => {
    if (codec === "gif") {
      return everyNthFrameSetting;
    }
    return 1;
  }, [codec, everyNthFrameSetting]);
  const audioCodec = deriveFinalAudioCodec(codec, userSelectedAudioCodec);
  const availablePixelFormats = useMemo125(() => {
    return BrowserSafeApis10.validPixelFormatsForCodec(codec);
  }, [codec]);
  const pixelFormat = useMemo125(() => {
    if (availablePixelFormats.includes(userPreferredPixelFormat)) {
      return userPreferredPixelFormat;
    }
    return availablePixelFormats[0];
  }, [availablePixelFormats, userPreferredPixelFormat]);
  const onClickVideo = useCallback124(() => {
    setSidebarCollapsedState({ left: null, right: "expanded" });
    persistSelectedOptionsSidebarPanel2("renders");
    optionsSidebarTabs.current?.selectRendersPanel();
    dispatchIfMounted({ type: "start" });
    addVideoRenderJob({
      compositionId: resolvedComposition.id,
      outName,
      imageFormat: videoImageFormat,
      jpegQuality: stillImageFormat === "jpeg" ? jpegQuality : null,
      scale,
      logLevel,
      codec,
      concurrency,
      crf: qualityControlType === "crf" ? crf : null,
      endFrame,
      startFrame,
      muted,
      enforceAudioTrack,
      proResProfile,
      x264Preset,
      pixelFormat,
      audioBitrate,
      videoBitrate,
      everyNthFrame,
      numberOfGifLoops,
      delayRenderTimeout,
      audioCodec,
      disallowParallelEncoding,
      chromiumOptions,
      envVariables: envVariablesArrayToObject(envVariables),
      inputProps,
      offthreadVideoCacheSizeInBytes,
      colorSpace,
      multiProcessOnLinux,
      encodingBufferSize,
      encodingMaxRate,
      beepOnFinish,
      repro,
      forSeamlessAacConcatenation,
      separateAudioTo,
      metadata,
      hardwareAcceleration,
      chromeMode,
      offthreadVideoThreads
    }).then(() => {
      dispatchIfMounted({ type: "succeed" });
      setSelectedModal(null);
    }).catch(() => {
      dispatchIfMounted({ type: "fail" });
    });
  }, [
    setSidebarCollapsedState,
    dispatchIfMounted,
    resolvedComposition.id,
    outName,
    videoImageFormat,
    stillImageFormat,
    jpegQuality,
    scale,
    logLevel,
    codec,
    concurrency,
    qualityControlType,
    crf,
    endFrame,
    startFrame,
    muted,
    enforceAudioTrack,
    proResProfile,
    x264Preset,
    pixelFormat,
    audioBitrate,
    videoBitrate,
    everyNthFrame,
    numberOfGifLoops,
    delayRenderTimeout,
    audioCodec,
    disallowParallelEncoding,
    chromiumOptions,
    envVariables,
    inputProps,
    offthreadVideoCacheSizeInBytes,
    colorSpace,
    multiProcessOnLinux,
    encodingBufferSize,
    encodingMaxRate,
    beepOnFinish,
    repro,
    forSeamlessAacConcatenation,
    separateAudioTo,
    setSelectedModal,
    metadata,
    hardwareAcceleration,
    chromeMode,
    offthreadVideoThreads
  ]);
  const onClickSequence = useCallback124(() => {
    setSidebarCollapsedState({ left: null, right: "expanded" });
    persistSelectedOptionsSidebarPanel2("renders");
    optionsSidebarTabs.current?.selectRendersPanel();
    dispatchIfMounted({ type: "start" });
    addSequenceRenderJob({
      compositionId: resolvedComposition.id,
      outName,
      imageFormat: sequenceImageFormat,
      scale,
      logLevel,
      concurrency,
      endFrame,
      jpegQuality,
      startFrame,
      delayRenderTimeout,
      chromiumOptions,
      envVariables: envVariablesArrayToObject(envVariables),
      inputProps,
      offthreadVideoCacheSizeInBytes,
      disallowParallelEncoding,
      multiProcessOnLinux,
      beepOnFinish,
      repro,
      metadata,
      chromeMode,
      offthreadVideoThreads
    }).then(() => {
      dispatchIfMounted({ type: "succeed" });
      setSelectedModal(null);
    }).catch(() => {
      dispatchIfMounted({ type: "fail" });
    });
  }, [
    setSidebarCollapsedState,
    dispatchIfMounted,
    resolvedComposition.id,
    outName,
    sequenceImageFormat,
    scale,
    logLevel,
    concurrency,
    endFrame,
    jpegQuality,
    startFrame,
    delayRenderTimeout,
    chromiumOptions,
    envVariables,
    inputProps,
    offthreadVideoCacheSizeInBytes,
    disallowParallelEncoding,
    multiProcessOnLinux,
    beepOnFinish,
    repro,
    setSelectedModal,
    metadata,
    chromeMode,
    offthreadVideoThreads
  ]);
  useEffect75(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);
  const imageFormatOptions = useMemo125(() => {
    if (renderMode === "still") {
      return [
        {
          label: "PNG",
          onClick: () => setStillFormat("png"),
          key: "png",
          selected: stillImageFormat === "png"
        },
        {
          label: "JPEG",
          onClick: () => setStillFormat("jpeg"),
          key: "jpeg",
          selected: stillImageFormat === "jpeg"
        },
        {
          label: "PDF",
          onClick: () => setStillFormat("pdf"),
          key: "pdf",
          selected: stillImageFormat === "pdf"
        },
        {
          label: "WebP",
          onClick: () => setStillFormat("webp"),
          key: "webp",
          selected: stillImageFormat === "webp"
        }
      ];
    }
    if (renderMode === "sequence") {
      return [
        {
          label: "PNG",
          onClick: () => setSequenceImageFormat("png"),
          key: "png",
          selected: sequenceImageFormat === "png"
        },
        {
          label: "JPEG",
          onClick: () => setSequenceImageFormat("jpeg"),
          key: "jpeg",
          selected: sequenceImageFormat === "jpeg"
        }
      ];
    }
    return [
      {
        label: "PNG",
        onClick: () => setVideoImageFormat("png"),
        key: "png",
        selected: videoImageFormat === "png"
      },
      {
        label: "JPEG",
        onClick: () => setVideoImageFormat("jpeg"),
        key: "jpeg",
        selected: videoImageFormat === "jpeg"
      }
    ];
  }, [
    renderMode,
    videoImageFormat,
    stillImageFormat,
    setStillFormat,
    sequenceImageFormat
  ]);
  const setRenderMode = useCallback124((newRenderMode) => {
    setRenderModeState(newRenderMode);
    if (newRenderMode === "audio") {
      setDefaultOutName({
        type: "render",
        codec: videoCodecForAudioTab,
        audioCodec: deriveFinalAudioCodec(videoCodecForAudioTab, userSelectedAudioCodec)
      });
    }
    if (newRenderMode === "video") {
      setDefaultOutName({
        type: "render",
        codec: videoCodecForVideoTab,
        audioCodec: deriveFinalAudioCodec(videoCodecForVideoTab, userSelectedAudioCodec)
      });
    }
    if (newRenderMode === "still") {
      setDefaultOutName({ type: "still", imageFormat: stillImageFormat });
    }
    if (newRenderMode === "sequence") {
      setDefaultOutName({ type: "sequence" });
    }
  }, [
    videoCodecForAudioTab,
    userSelectedAudioCodec,
    deriveFinalAudioCodec,
    setDefaultOutName,
    stillImageFormat,
    videoCodecForVideoTab
  ]);
  const renderTabOptions = useMemo125(() => {
    if (resolvedComposition?.durationInFrames < 2) {
      return [
        {
          label: "Still",
          onClick: () => {
            setRenderMode("still");
          },
          key: "still",
          selected: renderMode === "still"
        }
      ];
    }
    return [
      {
        label: "Still",
        onClick: () => {
          setRenderMode("still");
        },
        key: "still",
        selected: renderMode === "still"
      },
      {
        label: "Video",
        onClick: () => {
          setRenderMode("video");
        },
        key: "video",
        selected: renderMode === "video"
      },
      {
        label: "Audio",
        onClick: () => {
          setRenderMode("audio");
        },
        key: "audio",
        selected: renderMode === "audio"
      },
      {
        label: "Image sequence",
        onClick: () => {
          setRenderMode("sequence");
        },
        key: "sequence",
        selected: renderMode === "sequence"
      }
    ];
  }, [resolvedComposition?.durationInFrames, renderMode, setRenderMode]);
  const outnameValidation = validateOutnameGui({
    outName,
    codec,
    audioCodec,
    renderMode,
    stillImageFormat,
    separateAudioTo
  });
  const { tab, setTab, shownTabs } = useRenderModalSections(renderMode, codec);
  const { registerKeybinding } = useKeybinding();
  const renderDisabled = state.type === "load" || !outnameValidation.valid;
  const trigger = useCallback124(() => {
    if (renderMode === "still") {
      onClickStill();
    } else if (renderMode === "sequence") {
      onClickSequence();
    } else {
      onClickVideo();
    }
  }, [renderMode, onClickStill, onClickSequence, onClickVideo]);
  useEffect75(() => {
    if (renderDisabled) {
      return;
    }
    const enter = registerKeybinding({
      callback() {
        trigger();
      },
      commandCtrlKey: true,
      key: "Enter",
      event: "keydown",
      preventDefault: true,
      triggerIfInputFieldFocused: true,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      enter.unregister();
    };
  }, [registerKeybinding, renderDisabled, trigger]);
  const pixelFormatOptions = useMemo125(() => {
    return availablePixelFormats.map((option) => {
      return {
        label: option,
        onClick: () => setPixelFormat(option),
        key: option,
        id: option,
        keyHint: null,
        leftItem: pixelFormat === option ? /* @__PURE__ */ jsx251(Checkmark, {}) : null,
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item",
        value: option
      };
    });
  }, [availablePixelFormats, pixelFormat]);
  return /* @__PURE__ */ jsxs130("div", {
    style: outer3,
    children: [
      /* @__PURE__ */ jsx251(ModalHeader, {
        title: `Render ${resolvedComposition.id}`
      }),
      /* @__PURE__ */ jsxs130("div", {
        style: container58,
        children: [
          /* @__PURE__ */ jsx251(SegmentedControl, {
            items: renderTabOptions,
            needsWrapping: false
          }),
          /* @__PURE__ */ jsx251("div", {
            style: flexer
          }),
          /* @__PURE__ */ jsxs130(Button, {
            autoFocus: true,
            onClick: trigger,
            disabled: renderDisabled,
            style: {
              ...buttonStyle7,
              backgroundColor: outnameValidation.valid ? BLUE : BLUE_DISABLED
            },
            children: [
              state.type === "idle" ? `Render ${renderMode}` : "Rendering...",
              /* @__PURE__ */ jsx251(ShortcutHint, {
                keyToPress: "↵",
                cmdOrCtrl: true
              })
            ]
          })
        ]
      }),
      /* @__PURE__ */ jsxs130("div", {
        style: horizontalLayout,
        children: [
          /* @__PURE__ */ jsxs130("div", {
            style: leftSidebar,
            children: [
              shownTabs.includes("general") ? /* @__PURE__ */ jsxs130(VerticalTab, {
                style: horizontalTab,
                selected: tab === "general",
                onClick: () => setTab("general"),
                children: [
                  /* @__PURE__ */ jsx251("div", {
                    style: iconContainer,
                    children: /* @__PURE__ */ jsx251(FileIcon, {
                      style: icon6
                    })
                  }),
                  "General"
                ]
              }) : null,
              shownTabs.includes("data") ? /* @__PURE__ */ jsxs130(VerticalTab, {
                style: horizontalTab,
                selected: tab === "data",
                onClick: () => setTab("data"),
                children: [
                  /* @__PURE__ */ jsx251("div", {
                    style: iconContainer,
                    children: /* @__PURE__ */ jsx251(DataIcon, {
                      style: icon6
                    })
                  }),
                  "Input Props"
                ]
              }) : null,
              shownTabs.includes("picture") ? /* @__PURE__ */ jsxs130(VerticalTab, {
                style: horizontalTab,
                selected: tab === "picture",
                onClick: () => setTab("picture"),
                children: [
                  /* @__PURE__ */ jsx251("div", {
                    style: iconContainer,
                    children: /* @__PURE__ */ jsx251(PicIcon, {
                      style: icon6
                    })
                  }),
                  "Picture"
                ]
              }) : null,
              shownTabs.includes("audio") ? /* @__PURE__ */ jsxs130(VerticalTab, {
                style: horizontalTab,
                selected: tab === "audio",
                onClick: () => setTab("audio"),
                children: [
                  /* @__PURE__ */ jsx251("div", {
                    style: iconContainer,
                    children: /* @__PURE__ */ jsx251(AudioIcon, {
                      style: icon6
                    })
                  }),
                  "Audio"
                ]
              }) : null,
              shownTabs.includes("gif") ? /* @__PURE__ */ jsxs130(VerticalTab, {
                style: horizontalTab,
                selected: tab === "gif",
                onClick: () => setTab("gif"),
                children: [
                  /* @__PURE__ */ jsx251("div", {
                    style: iconContainer,
                    children: /* @__PURE__ */ jsx251(GifIcon, {
                      style: icon6
                    })
                  }),
                  "GIF"
                ]
              }) : null,
              shownTabs.includes("advanced") ? /* @__PURE__ */ jsxs130(VerticalTab, {
                style: horizontalTab,
                selected: tab === "advanced",
                onClick: () => setTab("advanced"),
                children: [
                  /* @__PURE__ */ jsx251("div", {
                    style: iconContainer,
                    children: /* @__PURE__ */ jsx251(GearIcon, {
                      style: icon6
                    })
                  }),
                  "Other"
                ]
              }) : null
            ]
          }),
          /* @__PURE__ */ jsx251("div", {
            style: optionsPanel,
            className: VERTICAL_SCROLLBAR_CLASSNAME,
            children: tab === "general" ? /* @__PURE__ */ jsx251(RenderModalBasic, {
              codec,
              resolvedComposition,
              frame: frame2,
              imageFormatOptions,
              outName,
              proResProfile,
              renderMode,
              setVideoCodec: setCodec,
              setFrame,
              setOutName,
              setProResProfile,
              endFrame,
              setEndFrame,
              setStartFrame,
              setVerboseLogging: setLogLevel,
              logLevel,
              startFrame,
              validationMessage: outnameValidation.valid ? null : outnameValidation.error.message
            }) : tab === "picture" ? /* @__PURE__ */ jsx251(RenderModalPicture, {
              renderMode,
              scale,
              setScale,
              pixelFormat,
              pixelFormatOptions,
              imageFormatOptions,
              crf,
              setCrf,
              customTargetVideoBitrate,
              maxCrf,
              minCrf,
              jpegQuality,
              qualityControlType,
              setJpegQuality,
              setColorSpace,
              colorSpace,
              setCustomTargetVideoBitrateValue,
              setQualityControl,
              videoImageFormat,
              stillImageFormat,
              shouldDisplayQualityControlPicker: supportsBothQualityControls,
              encodingBufferSize,
              setEncodingBufferSize,
              encodingMaxRate,
              setEncodingMaxRate,
              compositionWidth: resolvedComposition.width,
              compositionHeight: resolvedComposition.height
            }) : tab === "audio" ? /* @__PURE__ */ jsx251(RenderModalAudio, {
              muted,
              renderMode,
              setMuted,
              codec,
              audioCodec,
              setAudioCodec,
              enforceAudioTrack,
              setEnforceAudioTrackState,
              customTargetAudioBitrate,
              setCustomTargetAudioBitrateValue,
              setShouldHaveCustomTargetAudioBitrate,
              shouldHaveCustomTargetAudioBitrate,
              forSeamlessAacConcatenation,
              setForSeamlessAacConcatenation,
              separateAudioTo,
              setSeparateAudioTo,
              outName
            }) : tab === "gif" ? /* @__PURE__ */ jsx251(RenderModalGif, {
              everyNthFrame,
              limitNumberOfGifLoops,
              numberOfGifLoopsSetting,
              setEveryNthFrameSetting,
              setLimitNumberOfGifLoops,
              setNumberOfGifLoopsSetting
            }) : tab === "data" ? /* @__PURE__ */ jsx251(DataEditor, {
              defaultProps: inputProps,
              setDefaultProps: setInputProps,
              unresolvedComposition,
              mayShowSaveButton: false,
              propsEditType: "input-props",
              saving,
              setSaving,
              readOnlyStudio: false
            }) : /* @__PURE__ */ jsx251(RenderModalAdvanced, {
              x264Preset,
              setx264Preset,
              concurrency,
              maxConcurrency,
              minConcurrency,
              renderMode,
              setConcurrency,
              delayRenderTimeout,
              setDelayRenderTimeout,
              disallowParallelEncoding,
              setDisallowParallelEncoding,
              setDisableWebSecurity,
              setIgnoreCertificateErrors,
              setHeadless,
              headless,
              ignoreCertificateErrors,
              disableWebSecurity,
              openGlOption,
              setOpenGlOption,
              setEnvVariables,
              envVariables,
              offthreadVideoCacheSizeInBytes,
              setOffthreadVideoCacheSizeInBytes,
              offthreadVideoThreads,
              setOffthreadVideoThreads,
              enableMultiProcessOnLinux: multiProcessOnLinux,
              setChromiumMultiProcessOnLinux,
              codec,
              userAgent,
              setUserAgent,
              setBeep: setBeepOnFinish,
              beep: beepOnFinish,
              repro,
              setRepro,
              hardwareAcceleration,
              setHardwareAcceleration,
              chromeModeOption: chromeMode,
              setChromeModeOption: setChromeMode
            })
          })
        ]
      })
    ]
  });
};
var RenderModalWithLoader = (props) => {
  return /* @__PURE__ */ jsx251(DismissableModal, {
    children: /* @__PURE__ */ jsx251(ResolveCompositionBeforeModal, {
      compositionId: props.compositionId,
      children: /* @__PURE__ */ jsx251(RenderModal, {
        ...props
      })
    })
  });
};

// src/components/RenderModal/RenderStatusModal.tsx
import { useCallback as useCallback126, useContext as useContext80 } from "react";

// src/components/RenderModal/GuiRenderStatus.tsx
import { useCallback as useCallback125, useMemo as useMemo126 } from "react";

// src/components/RenderQueue/SuccessIcon.tsx
import { jsx as jsx252 } from "react/jsx-runtime";
var iconStyle7 = {
  height: RENDER_STATUS_INDICATOR_SIZE,
  width: RENDER_STATUS_INDICATOR_SIZE
};
var SuccessIcon = () => {
  return /* @__PURE__ */ jsx252("svg", {
    style: iconStyle7,
    viewBox: "0 0 512 512",
    children: /* @__PURE__ */ jsx252("path", {
      fill: LIGHT_TEXT,
      d: "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM369 209L241 337l-17 17-17-17-64-64-17-17L160 222.1l17 17 47 47L335 175l17-17L385.9 192l-17 17z"
    })
  });
};

// src/components/RenderModal/GuiRenderStatus.tsx
import { jsx as jsx253, jsxs as jsxs131 } from "react/jsx-runtime";
var progressItem = {
  padding: 10,
  display: "flex",
  flexDirection: "row",
  alignItems: "center"
};
var label9 = {
  fontSize: 14,
  width: 400,
  color: "white"
};
var right3 = {
  fontSize: 14,
  color: LIGHT_TEXT,
  textAlign: "right",
  flex: 1
};
var BundlingProgress = ({ progress, doneIn }) => {
  return /* @__PURE__ */ jsxs131("div", {
    style: progressItem,
    children: [
      progress === 1 ? /* @__PURE__ */ jsx253(SuccessIcon, {}) : /* @__PURE__ */ jsx253(CircularProgress, {
        progress
      }),
      /* @__PURE__ */ jsx253(Spacing, {
        x: 1
      }),
      /* @__PURE__ */ jsx253("div", {
        style: label9,
        children: progress === 1 ? "Bundled" : `Bundling ${progress * 100}%`
      }),
      doneIn ? /* @__PURE__ */ jsxs131("div", {
        style: right3,
        children: [
          doneIn,
          "ms"
        ]
      }) : null
    ]
  });
};
var RenderingProgress = ({ progress }) => {
  return /* @__PURE__ */ jsxs131("div", {
    style: progressItem,
    children: [
      progress.frames === progress.totalFrames ? /* @__PURE__ */ jsx253(SuccessIcon, {}) : /* @__PURE__ */ jsx253(CircularProgress, {
        progress: progress.frames / progress.totalFrames
      }),
      /* @__PURE__ */ jsx253(Spacing, {
        x: 1
      }),
      /* @__PURE__ */ jsx253("div", {
        style: label9,
        children: progress.doneIn ? `Rendered ${progress.totalFrames} frames` : `Rendering ${progress.frames} / ${progress.totalFrames} frames`
      }),
      progress.doneIn ? /* @__PURE__ */ jsxs131("div", {
        style: right3,
        children: [
          progress.doneIn,
          "ms"
        ]
      }) : null
    ]
  });
};
var StitchingProgress = ({ progress }) => {
  return /* @__PURE__ */ jsxs131("div", {
    style: progressItem,
    children: [
      progress.frames === progress.totalFrames ? /* @__PURE__ */ jsx253(SuccessIcon, {}) : /* @__PURE__ */ jsx253(CircularProgress, {
        progress: progress.frames / progress.totalFrames
      }),
      /* @__PURE__ */ jsx253(Spacing, {
        x: 1
      }),
      /* @__PURE__ */ jsx253("div", {
        style: label9,
        children: progress.doneIn ? `Encoded ${progress.totalFrames} frames` : `Encoding ${progress.frames} / ${progress.totalFrames} frames`
      }),
      progress.doneIn ? /* @__PURE__ */ jsxs131("div", {
        style: right3,
        children: [
          progress.doneIn,
          "ms"
        ]
      }) : null
    ]
  });
};
var DownloadsProgress = ({ downloads }) => {
  const allHaveProgress = downloads.every((a) => a.totalBytes);
  const totalBytes = allHaveProgress ? downloads.reduce((a, b) => a + b.totalBytes, 0) : null;
  const downloaded = allHaveProgress ? downloads.reduce((a, b) => a + b.downloaded, 0) : null;
  const progress = allHaveProgress ? downloaded / totalBytes : 0.1;
  return /* @__PURE__ */ jsxs131("div", {
    style: progressItem,
    children: [
      progress === 1 ? /* @__PURE__ */ jsx253(SuccessIcon, {}) : /* @__PURE__ */ jsx253(CircularProgress, {
        progress
      }),
      /* @__PURE__ */ jsx253(Spacing, {
        x: 1
      }),
      /* @__PURE__ */ jsxs131("div", {
        style: label9,
        children: [
          "Downloading ",
          downloads.length,
          " file",
          downloads.length === 1 ? "" : "s"
        ]
      })
    ]
  });
};
var OpenFile = ({ job }) => {
  const labelStyle5 = useMemo126(() => {
    return {
      ...label9,
      textAlign: "left",
      appearance: "none",
      border: 0,
      paddingLeft: 0,
      cursor: job.deletedOutputLocation ? "inherit" : "pointer",
      textDecoration: job.deletedOutputLocation ? "line-through" : "none"
    };
  }, [job.deletedOutputLocation]);
  const onClick = useCallback125(() => {
    openInFileExplorer({ directory: job.outName });
  }, [job.outName]);
  return /* @__PURE__ */ jsxs131("div", {
    style: progressItem,
    children: [
      /* @__PURE__ */ jsx253(SuccessIcon, {}),
      /* @__PURE__ */ jsx253(Spacing, {
        x: 1
      }),
      /* @__PURE__ */ jsx253("button", {
        style: labelStyle5,
        type: "button",
        onClick,
        children: job.outName
      }),
      /* @__PURE__ */ jsx253("div", {
        style: right3,
        children: /* @__PURE__ */ jsx253(RenderQueueOpenInFinderItem, {
          job
        })
      })
    ]
  });
};
var GuiRenderStatus = ({ job }) => {
  if (job.status === "idle" || job.status === "failed") {
    throw new Error("This component should not be rendered when the job is idle");
  }
  return /* @__PURE__ */ jsxs131("div", {
    children: [
      /* @__PURE__ */ jsx253(Spacing, {
        y: 0.5
      }),
      /* @__PURE__ */ jsx253(BundlingProgress, {
        progress: job.progress.bundling.progress,
        doneIn: job.progress.bundling.doneIn
      }),
      job.progress.rendering ? /* @__PURE__ */ jsx253(RenderingProgress, {
        progress: job.progress.rendering
      }) : null,
      job.progress.stitching ? /* @__PURE__ */ jsx253(StitchingProgress, {
        progress: job.progress.stitching
      }) : null,
      job.progress.downloads.length > 0 ? /* @__PURE__ */ jsx253(DownloadsProgress, {
        downloads: job.progress.downloads
      }) : null,
      job.status === "done" ? /* @__PURE__ */ jsx253(OpenFile, {
        job
      }) : null,
      /* @__PURE__ */ jsx253(Spacing, {
        y: 1
      })
    ]
  });
};

// src/components/RenderModal/RenderStatusModal.tsx
import { jsx as jsx254, jsxs as jsxs132, Fragment as Fragment43 } from "react/jsx-runtime";
var container59 = {
  padding: 20,
  maxWidth: 900,
  paddingTop: 0
};
var codeBlock = {
  backgroundColor: "#222",
  whiteSpace: "pre",
  padding: 12,
  borderRadius: 4,
  fontFamily: "monospace",
  overflow: "auto",
  maxHeight: 300
};
var spacer3 = {
  height: SPACING_UNIT,
  width: SPACING_UNIT
};
var buttonRow = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end"
};
var RenderStatusModal = ({
  jobId
}) => {
  const { setSelectedModal } = useContext80(ModalsContext);
  const { jobs } = useContext80(RenderQueueContext);
  const job = jobs.find((j) => j.id === jobId);
  if (!job) {
    throw new Error("job not found");
  }
  const onQuit = useCallback126(() => {
    setSelectedModal(null);
  }, [setSelectedModal]);
  const onRetry = useCallback126(() => {
    const retryPayload = makeRetryPayload(job);
    setSelectedModal(retryPayload);
  }, [job, setSelectedModal]);
  const onClickOnRemove = useCallback126(() => {
    setSelectedModal(null);
    removeRenderJob(job).catch((err) => {
      showNotification(`Could not remove job: ${err.message}`, 2000);
    });
  }, [job, setSelectedModal]);
  const onClickOnCancel = useCallback126(() => {
    cancelRenderJob(job).catch((err) => {
      showNotification(`Could not cancel job: ${err.message}`, 2000);
    });
  }, [job]);
  if (!job || job.status === "idle") {
    throw new Error("should not have rendered this modal");
  }
  return /* @__PURE__ */ jsxs132(ModalContainer, {
    onOutsideClick: onQuit,
    onEscape: onQuit,
    children: [
      /* @__PURE__ */ jsx254(ModalHeader, {
        title: `Render ${job.compositionId}`
      }),
      /* @__PURE__ */ jsxs132("div", {
        style: container59,
        children: [
          job.status === "failed" ? /* @__PURE__ */ jsxs132(Fragment43, {
            children: [
              /* @__PURE__ */ jsx254("p", {
                children: "The render failed because of the following error:"
              }),
              /* @__PURE__ */ jsx254("div", {
                className: HORIZONTAL_SCROLLBAR_CLASSNAME,
                style: codeBlock,
                children: job.error.stack
              })
            ]
          }) : null,
          job.status === "done" || job.status === "running" ? /* @__PURE__ */ jsx254(GuiRenderStatus, {
            job
          }) : null,
          /* @__PURE__ */ jsx254("div", {
            style: spacer3
          }),
          /* @__PURE__ */ jsxs132("div", {
            style: buttonRow,
            children: [
              job.status === "running" ? /* @__PURE__ */ jsx254(Button, {
                onClick: onClickOnCancel,
                children: "Cancel render"
              }) : /* @__PURE__ */ jsx254(Button, {
                onClick: onClickOnRemove,
                children: "Remove render"
              }),
              /* @__PURE__ */ jsx254(Flex, {}),
              job.status === "failed" ? /* @__PURE__ */ jsx254(Button, {
                onClick: onRetry,
                children: "Retry"
              }) : null,
              /* @__PURE__ */ jsx254("div", {
                style: spacer3
              }),
              /* @__PURE__ */ jsx254(Button, {
                onClick: onQuit,
                children: "Close"
              })
            ]
          })
        ]
      })
    ]
  });
};

// src/components/UpdateModal/UpdateModal.tsx
import { useCallback as useCallback129, useMemo as useMemo128 } from "react";

// src/components/CopyButton.tsx
import { useCallback as useCallback127, useEffect as useEffect76, useState as useState78 } from "react";
import { jsx as jsx255, jsxs as jsxs133 } from "react/jsx-runtime";
var iconStyle8 = {
  width: 16,
  height: 16,
  color: "white"
};
var buttonContainerStyle = {
  display: "flex",
  minWidth: "114px"
};
var copyIcon = /* @__PURE__ */ jsx255("svg", {
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "far",
  "data-icon": "clipboard",
  className: "svg-inline--fa fa-clipboard fa-w-12",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 384 512",
  style: iconStyle8,
  children: /* @__PURE__ */ jsx255("path", {
    fill: "currentColor",
    d: "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm144 418c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V118c0-3.3 2.7-6 6-6h42v36c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-36h42c3.3 0 6 2.7 6 6z"
  })
});
var labelStyle5 = {
  fontSize: 14
};
var CopyButton = ({ textToCopy, label: label10, labelWhenCopied }) => {
  const [copied, setCopied] = useState78(false);
  const onClick = useCallback127(() => {
    copyText(textToCopy).then(() => {
      setCopied(Date.now());
    }).catch((err) => {
      showNotification(`Could not copy: ${err.message}`, 2000);
    });
  }, [textToCopy]);
  useEffect76(() => {
    if (!copied) {
      return;
    }
    const to = setTimeout(() => setCopied(false), 2000);
    return () => clearTimeout(to);
  }, [copied]);
  return /* @__PURE__ */ jsxs133(Button, {
    onClick,
    buttonContainerStyle,
    children: [
      copyIcon,
      /* @__PURE__ */ jsx255(Spacing, {
        x: 1.5
      }),
      " ",
      /* @__PURE__ */ jsx255("span", {
        style: labelStyle5,
        children: copied ? labelWhenCopied : label10
      })
    ]
  });
};

// src/components/UpdateModal/OpenIssueButton.tsx
import { useCallback as useCallback128, useMemo as useMemo127, useState as useState79 } from "react";
import { jsx as jsx256 } from "react/jsx-runtime";
var svgStyle3 = {
  width: "11px",
  height: "11px"
};
var buttonStyle8 = {
  border: "none",
  width: "24px",
  height: "24px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
};
var OpenIssueButton = ({ link: link3 }) => {
  const [hovered, setHovered] = useState79(false);
  const buttonTooltip = `Open GitHub issue in new Tab`;
  const handleClick = useCallback128(() => {
    window.open(link3, "_blank");
  }, [link3]);
  const svgFillColor = useMemo127(() => {
    return hovered ? "white" : LIGHT_TEXT;
  }, [hovered]);
  const openInEditorSvg = /* @__PURE__ */ jsx256("svg", {
    viewBox: "0 0 512 512",
    style: svgStyle3,
    children: /* @__PURE__ */ jsx256("path", {
      fill: svgFillColor,
      d: "M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"
    })
  });
  const onPointerEnter = useCallback128(() => {
    setHovered(true);
  }, []);
  const onPointerLeave = useCallback128(() => {
    setHovered(false);
  }, []);
  return /* @__PURE__ */ jsx256("button", {
    title: buttonTooltip,
    type: "button",
    onPointerEnter,
    onPointerLeave,
    style: buttonStyle8,
    onClick: handleClick,
    children: openInEditorSvg
  });
};

// src/components/KnownBugs.tsx
import { jsx as jsx257, jsxs as jsxs134 } from "react/jsx-runtime";
var container60 = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center"
};
var text3 = {
  fontSize: 14,
  flex: 1
};
var KnownBugs = ({ bugs }) => {
  const bugElements = bugs.map((bug) => {
    return /* @__PURE__ */ jsxs134("div", {
      style: container60,
      children: [
        /* @__PURE__ */ jsxs134("div", {
          style: text3,
          children: [
            "\uD83E\uDEB2 ",
            bug.title
          ]
        }),
        /* @__PURE__ */ jsx257(OpenIssueButton, {
          link: bug.link
        })
      ]
    }, bug.description + bug.link);
  });
  return /* @__PURE__ */ jsx257("div", {
    children: bugElements
  });
};

// src/components/UpdateModal/UpdateModal.tsx
import { jsx as jsx258, jsxs as jsxs135, Fragment as Fragment44 } from "react/jsx-runtime";
var container61 = {
  padding: 20,
  paddingTop: 0
};
var text4 = {
  fontSize: 14
};
var title7 = {
  paddingTop: 12,
  paddingBottom: 8,
  ...text4
};
var code = {
  background: SELECTED_BACKGROUND,
  padding: "12px 10px",
  fontSize: 14,
  marginTop: 10,
  marginBottom: 10
};
var link3 = {
  fontWeight: "bold",
  color: BLUE,
  textDecoration: "none",
  ...text4
};
var commands = {
  npm: "npx remotion upgrade",
  yarn: "yarn remotion upgrade",
  pnpm: "pnpm exec remotion upgrade",
  bun: "bun remotion upgrade",
  unknown: "npx remotion upgrade"
};
var UpdateModal = ({ info, knownBugs }) => {
  const hasKnownBugs = useMemo128(() => {
    return knownBugs && knownBugs?.length > 0;
  }, [knownBugs]);
  const command = commands[info.packageManager];
  const onClick = useCallback129(() => {
    copyText(command).catch((err) => {
      showNotification(`Could not copy: ${err.message}`, 2000);
    });
  }, [command]);
  return /* @__PURE__ */ jsxs135(DismissableModal, {
    children: [
      /* @__PURE__ */ jsx258(ModalHeader, {
        title: "Update available"
      }),
      /* @__PURE__ */ jsxs135("div", {
        style: container61,
        children: [
          hasKnownBugs ? /* @__PURE__ */ jsxs135(Fragment44, {
            children: [
              /* @__PURE__ */ jsxs135("div", {
                style: title7,
                children: [
                  "The currently installed version ",
                  info.currentVersion,
                  " has the following known bugs:"
                ]
              }),
              /* @__PURE__ */ jsx258(KnownBugs, {
                bugs: knownBugs
              }),
              /* @__PURE__ */ jsx258("div", {
                style: { height: "20px" }
              }),
              /* @__PURE__ */ jsx258("div", {
                style: text4,
                children: "To upgrade, run the following command:"
              })
            ]
          }) : /* @__PURE__ */ jsx258("div", {
            style: title7,
            children: "A new update for Remotion is available! Run the following command:"
          }),
          /* @__PURE__ */ jsxs135(Row, {
            align: "center",
            children: [
              /* @__PURE__ */ jsx258(Flex, {
                children: /* @__PURE__ */ jsx258("pre", {
                  onClick,
                  style: code,
                  children: command
                })
              }),
              /* @__PURE__ */ jsx258(Spacing, {
                x: 1
              }),
              /* @__PURE__ */ jsx258(CopyButton, {
                textToCopy: command,
                label: "Copy",
                labelWhenCopied: "Copied!"
              })
            ]
          }),
          /* @__PURE__ */ jsxs135("div", {
            style: text4,
            children: [
              "This will upgrade Remotion from ",
              info.currentVersion,
              " to",
              " ",
              info.latestVersion,
              "."
            ]
          }),
          /* @__PURE__ */ jsxs135("div", {
            style: text4,
            children: [
              "Read the",
              " ",
              /* @__PURE__ */ jsx258("a", {
                style: link3,
                target: "_blank",
                href: "https://github.com/remotion-dev/remotion/releases",
                children: "Release notes"
              }),
              " ",
              "to know what",
              "'s",
              " new in Remotion."
            ]
          })
        ]
      })
    ]
  });
};

// src/components/Modals.tsx
import { jsx as jsx259, jsxs as jsxs136, Fragment as Fragment45 } from "react/jsx-runtime";
var Modals = ({ readOnlyStudio }) => {
  const { selectedModal: modalContextType } = useContext81(ModalsContext);
  const canRender = useContext81(StudioServerConnectionCtx).previewServerState.type === "connected";
  return /* @__PURE__ */ jsxs136(Fragment45, {
    children: [
      modalContextType && modalContextType.type === "duplicate-comp" && /* @__PURE__ */ jsx259(DuplicateComposition, {
        compositionType: modalContextType.compositionType,
        compositionId: modalContextType.compositionId
      }),
      modalContextType && modalContextType.type === "delete-comp" && /* @__PURE__ */ jsx259(DeleteComposition, {
        compositionId: modalContextType.compositionId
      }),
      modalContextType && modalContextType.type === "rename-comp" && /* @__PURE__ */ jsx259(RenameComposition, {
        compositionId: modalContextType.compositionId
      }),
      modalContextType && canRender && modalContextType.type === "render" && /* @__PURE__ */ jsx259(RenderModalWithLoader, {
        initialFrame: modalContextType.initialFrame,
        compositionId: modalContextType.compositionId,
        initialVideoImageFormat: modalContextType.initialVideoImageFormat,
        initialJpegQuality: modalContextType.initialJpegQuality,
        initialScale: modalContextType.initialScale,
        initialLogLevel: modalContextType.initialLogLevel,
        initialOffthreadVideoCacheSizeInBytes: modalContextType.initialOffthreadVideoCacheSizeInBytes,
        initialOffthreadVideoThreads: modalContextType.initialOffthreadVideoThreads,
        initialConcurrency: modalContextType.initialConcurrency,
        maxConcurrency: modalContextType.maxConcurrency,
        minConcurrency: modalContextType.minConcurrency,
        initialStillImageFormat: modalContextType.initialStillImageFormat,
        initialMuted: modalContextType.initialMuted,
        initialEnforceAudioTrack: modalContextType.initialEnforceAudioTrack,
        initialProResProfile: modalContextType.initialProResProfile,
        initialx264Preset: modalContextType.initialx264Preset,
        initialPixelFormat: modalContextType.initialPixelFormat,
        initialAudioBitrate: modalContextType.initialAudioBitrate,
        initialVideoBitrate: modalContextType.initialVideoBitrate,
        initialEveryNthFrame: modalContextType.initialEveryNthFrame,
        initialNumberOfGifLoops: modalContextType.initialNumberOfGifLoops,
        initialDelayRenderTimeout: modalContextType.initialDelayRenderTimeout,
        initialEnvVariables: modalContextType.initialEnvVariables,
        initialDisableWebSecurity: modalContextType.initialDisableWebSecurity,
        initialGl: modalContextType.initialOpenGlRenderer,
        initialHeadless: modalContextType.initialHeadless,
        initialIgnoreCertificateErrors: modalContextType.initialIgnoreCertificateErrors,
        initialEncodingBufferSize: modalContextType.initialEncodingBufferSize,
        initialEncodingMaxRate: modalContextType.initialEncodingMaxRate,
        initialUserAgent: modalContextType.initialUserAgent,
        initialColorSpace: modalContextType.initialColorSpace,
        initialMultiProcessOnLinux: modalContextType.initialMultiProcessOnLinux,
        initialRepro: modalContextType.initialRepro,
        initialBeep: modalContextType.initialBeep,
        initialForSeamlessAacConcatenation: modalContextType.initialForSeamlessAacConcatenation,
        defaultProps: modalContextType.defaultProps,
        inFrameMark: modalContextType.inFrameMark,
        outFrameMark: modalContextType.outFrameMark,
        defaultConfigurationAudioCodec: modalContextType.defaultConfigurationAudioCodec,
        defaultConfigurationVideoCodec: modalContextType.defaultConfigurationVideoCodec,
        renderTypeOfLastRender: modalContextType.renderTypeOfLastRender,
        defaultMetadata: modalContextType.defaulMetadata,
        initialHardwareAcceleration: modalContextType.initialHardwareAcceleration,
        initialChromeMode: modalContextType.initialChromeMode
      }),
      modalContextType && canRender && modalContextType.type === "render-progress" && /* @__PURE__ */ jsx259(RenderStatusModal, {
        jobId: modalContextType.jobId
      }),
      modalContextType && modalContextType.type === "update" && /* @__PURE__ */ jsx259(UpdateModal, {
        info: modalContextType.info,
        knownBugs: modalContextType.knownBugs
      }),
      modalContextType && modalContextType.type === "install-packages" && /* @__PURE__ */ jsx259(InstallPackageModal, {
        packageManager: modalContextType.packageManager
      }),
      modalContextType && modalContextType.type === "quick-switcher" && /* @__PURE__ */ jsx259(QuickSwitcher_default, {
        readOnlyStudio,
        invocationTimestamp: modalContextType.invocationTimestamp,
        initialMode: modalContextType.mode
      }),
      /* @__PURE__ */ jsx259(AskAiModal, {})
    ]
  });
};

// src/components/Editor.tsx
import { jsx as jsx260, jsxs as jsxs137 } from "react/jsx-runtime";
var background2 = {
  backgroundColor: BACKGROUND,
  display: "flex",
  width: "100%",
  height: "100%",
  flexDirection: "column",
  position: "absolute"
};
var DEFAULT_BUFFER_STATE_DELAY_IN_MILLISECONDS = 300;
var BUFFER_STATE_DELAY_IN_MILLISECONDS = typeof process.env.BUFFER_STATE_DELAY_IN_MILLISECONDS === "undefined" || process.env.BUFFER_STATE_DELAY_IN_MILLISECONDS === null ? DEFAULT_BUFFER_STATE_DELAY_IN_MILLISECONDS : Number(process.env.BUFFER_STATE_DELAY_IN_MILLISECONDS);
var Editor = ({ Root, readOnlyStudio }) => {
  const size4 = PlayerInternals19.useElementSize(drawRef, {
    triggerOnWindowResize: false,
    shouldApplyCssTransforms: true
  });
  useEffect77(() => {
    if (readOnlyStudio) {
      return;
    }
    const listenToChanges = (e) => {
      if (window.remotion_unsavedProps) {
        e.returnValue = "Are you sure you want to leave?";
      }
    };
    window.addEventListener("beforeunload", listenToChanges);
    return () => {
      window.removeEventListener("beforeunload", listenToChanges);
    };
  }, [readOnlyStudio]);
  const [canvasMounted, setCanvasMounted] = React173.useState(false);
  const onMounted = useCallback130(() => {
    setCanvasMounted(true);
  }, []);
  const value = useMemo129(() => {
    if (!size4) {
      return null;
    }
    return {
      type: "canvas-size",
      canvasSize: size4
    };
  }, [size4]);
  const MemoRoot = useMemo129(() => {
    return React173.memo(Root);
  }, [Root]);
  return /* @__PURE__ */ jsx260(HigherZIndex, {
    onEscape: noop,
    onOutsideClick: noop,
    children: /* @__PURE__ */ jsxs137(TimelineZoomContext, {
      children: [
        /* @__PURE__ */ jsx260(Internals62.CurrentScaleContext.Provider, {
          value,
          children: /* @__PURE__ */ jsxs137("div", {
            style: background2,
            children: [
              canvasMounted ? /* @__PURE__ */ jsx260(MemoRoot, {}) : null,
              /* @__PURE__ */ jsxs137(Internals62.CanUseRemotionHooksProvider, {
                children: [
                  /* @__PURE__ */ jsx260(EditorContent, {
                    readOnlyStudio,
                    children: /* @__PURE__ */ jsx260(TopPanel, {
                      drawRef,
                      bufferStateDelayInMilliseconds: BUFFER_STATE_DELAY_IN_MILLISECONDS,
                      onMounted,
                      readOnlyStudio
                    })
                  }),
                  /* @__PURE__ */ jsx260(GlobalKeybindings, {})
                ]
              })
            ]
          })
        }),
        /* @__PURE__ */ jsx260(Modals, {
          readOnlyStudio
        }),
        /* @__PURE__ */ jsx260(NotificationCenter, {})
      ]
    })
  });
};

// src/components/EditorContexts.tsx
import { PlayerInternals as PlayerInternals20 } from "@remotion/player";

// src/state/preview-size.tsx
import { useCallback as useCallback131, useContext as useContext82, useMemo as useMemo130, useState as useState80 } from "react";
import { Internals as Internals63 } from "remotion";
import { jsx as jsx261 } from "react/jsx-runtime";
var key5 = "remotion.previewSize";
var persistPreviewSizeOption = (option) => {
  localStorage.setItem(key5, JSON.stringify(option));
};
var loadPreviewSizeOption = () => {
  const item2 = localStorage.getItem(key5);
  if (item2 === null) {
    return {
      size: "auto",
      translation: {
        x: 0,
        y: 0
      }
    };
  }
  return JSON.parse(item2);
};
var PreviewSizeProvider = ({ children }) => {
  const [size4, setSizeState] = useState80(() => loadPreviewSizeOption());
  const [translation, setTranslation] = useState80(() => {
    return {
      x: 0,
      y: 0
    };
  });
  const { editorZoomGestures } = useContext82(EditorZoomGesturesContext);
  const setSize = useCallback131((newValue) => {
    setSizeState((prevState) => {
      const newVal = newValue(prevState);
      persistPreviewSizeOption(newVal);
      return newVal;
    });
  }, []);
  const previewSizeCtx = useMemo130(() => {
    return {
      size: editorZoomGestures ? size4 : {
        size: size4.size,
        translation: {
          x: 0,
          y: 0
        }
      },
      setSize,
      translation,
      setTranslation
    };
  }, [editorZoomGestures, size4, setSize, translation]);
  return /* @__PURE__ */ jsx261(Internals63.PreviewSizeContext.Provider, {
    value: previewSizeCtx,
    children
  });
};

// src/components/CheckerboardProvider.tsx
import { useCallback as useCallback132, useMemo as useMemo131, useState as useState81 } from "react";
import { jsx as jsx262 } from "react/jsx-runtime";
var CheckerboardProvider = ({ children }) => {
  const [checkerboard, setCheckerboardState] = useState81(() => loadCheckerboardOption());
  const setCheckerboard = useCallback132((newValue) => {
    setCheckerboardState((prevState) => {
      const newVal = newValue(prevState);
      persistCheckerboardOption(newVal);
      return newVal;
    });
  }, []);
  const checkerboardCtx = useMemo131(() => {
    return {
      checkerboard,
      setCheckerboard
    };
  }, [checkerboard, setCheckerboard]);
  return /* @__PURE__ */ jsx262(CheckerboardContext.Provider, {
    value: checkerboardCtx,
    children
  });
};

// src/components/MediaVolumeProvider.tsx
import { useMemo as useMemo132, useState as useState82 } from "react";
import { Internals as Internals64 } from "remotion";
import { jsx as jsx263 } from "react/jsx-runtime";
var MediaVolumeProvider = ({ children }) => {
  const [mediaMuted, setMediaMuted] = useState82(() => loadMuteOption());
  const [mediaVolume, setMediaVolume] = useState82(1);
  const mediaVolumeContextValue = useMemo132(() => {
    return {
      mediaMuted,
      mediaVolume
    };
  }, [mediaMuted, mediaVolume]);
  const setMediaVolumeContextValue = useMemo132(() => {
    return {
      setMediaMuted,
      setMediaVolume
    };
  }, []);
  return /* @__PURE__ */ jsx263(Internals64.MediaVolumeContext.Provider, {
    value: mediaVolumeContextValue,
    children: /* @__PURE__ */ jsx263(Internals64.SetMediaVolumeContext.Provider, {
      value: setMediaVolumeContextValue,
      children
    })
  });
};

// src/components/ModalsProvider.tsx
import { useMemo as useMemo133, useState as useState83 } from "react";
import { jsx as jsx264 } from "react/jsx-runtime";
var ModalsProvider = ({ children }) => {
  const [modalContextType, setModalContextType] = useState83(null);
  const modalsContext = useMemo133(() => {
    return {
      selectedModal: modalContextType,
      setSelectedModal: setModalContextType
    };
  }, [modalContextType]);
  return /* @__PURE__ */ jsx264(ModalsContext.Provider, {
    value: modalsContext,
    children
  });
};

// src/components/SetTimelineInOutProvider.tsx
import { useEffect as useEffect78, useMemo as useMemo134, useState as useState84 } from "react";

// src/state/marks.ts
var localStorageKey5 = () => `remotion.editor.marksv2`;
var persistMarks = (marks) => {
  localStorage.setItem(localStorageKey5(), JSON.stringify(marks));
};
var loadMarks = () => {
  const item2 = localStorage.getItem(localStorageKey5());
  if (item2 === null) {
    return {};
  }
  return JSON.parse(item2);
};

// src/components/SetTimelineInOutProvider.tsx
import { jsx as jsx265 } from "react/jsx-runtime";
var SetTimelineInOutProvider = ({ children }) => {
  const [inAndOutFrames, setInAndOutFrames] = useState84(() => loadMarks());
  const setTimelineInOutContextValue = useMemo134(() => {
    return {
      setInAndOutFrames
    };
  }, []);
  useEffect78(() => {
    persistMarks(inAndOutFrames);
  }, [inAndOutFrames]);
  return /* @__PURE__ */ jsx265(TimelineInOutContext.Provider, {
    value: inAndOutFrames,
    children: /* @__PURE__ */ jsx265(SetTimelineInOutContext.Provider, {
      value: setTimelineInOutContextValue,
      children
    })
  });
};

// src/components/ShowGuidesProvider.tsx
import { useCallback as useCallback133, useMemo as useMemo135, useRef as useRef41, useState as useState85 } from "react";
import { jsx as jsx266 } from "react/jsx-runtime";
var ShowGuidesProvider = ({ children }) => {
  const [guidesList, setGuidesList] = useState85(() => loadGuidesList());
  const [selectedGuideId, setSelectedGuideId] = useState85(null);
  const [hoveredGuideId, setHoveredGuideId] = useState85(null);
  const [editorShowGuides, setEditorShowGuidesState] = useState85(() => loadEditorShowGuidesOption());
  const shouldCreateGuideRef = useRef41(false);
  const shouldDeleteGuideRef = useRef41(false);
  const setEditorShowGuides = useCallback133((newValue) => {
    setEditorShowGuidesState((prevState) => {
      const newVal = newValue(prevState);
      persistEditorShowGuidesOption(newVal);
      return newVal;
    });
  }, []);
  const editorShowGuidesCtx = useMemo135(() => {
    return {
      editorShowGuides,
      setEditorShowGuides,
      guidesList,
      setGuidesList,
      selectedGuideId,
      setSelectedGuideId,
      shouldCreateGuideRef,
      shouldDeleteGuideRef,
      hoveredGuideId,
      setHoveredGuideId
    };
  }, [
    editorShowGuides,
    setEditorShowGuides,
    guidesList,
    selectedGuideId,
    hoveredGuideId
  ]);
  return /* @__PURE__ */ jsx266(EditorShowGuidesContext.Provider, {
    value: editorShowGuidesCtx,
    children
  });
};

// src/components/ShowRulersProvider.tsx
import { useCallback as useCallback134, useMemo as useMemo136, useState as useState86 } from "react";
import { jsx as jsx267 } from "react/jsx-runtime";
var ShowRulersProvider = ({ children }) => {
  const [editorShowRulers, setEditorShowRulersState] = useState86(() => loadEditorShowRulersOption());
  const setEditorShowRulers = useCallback134((newValue) => {
    setEditorShowRulersState((prevState) => {
      const newVal = newValue(prevState);
      persistEditorShowRulersOption(newVal);
      return newVal;
    });
  }, []);
  const editorShowRulersCtx = useMemo136(() => {
    return {
      editorShowRulers,
      setEditorShowRulers
    };
  }, [editorShowRulers, setEditorShowRulers]);
  return /* @__PURE__ */ jsx267(EditorShowRulersContext.Provider, {
    value: editorShowRulersCtx,
    children
  });
};

// src/components/ZoomGesturesProvider.tsx
import { useCallback as useCallback135, useMemo as useMemo137, useState as useState87 } from "react";
import { jsx as jsx268 } from "react/jsx-runtime";
var ZoomGesturesProvider = ({ children }) => {
  const [editorZoomGestures, setEditorZoomGesturesState] = useState87(() => loadEditorZoomGesturesOption());
  const setEditorZoomGestures = useCallback135((newValue) => {
    setEditorZoomGesturesState((prevState) => {
      const newVal = newValue(prevState);
      persistEditorZoomGesturesOption(newVal);
      return newVal;
    });
  }, []);
  const editorZoomGesturesCtx = useMemo137(() => {
    return {
      editorZoomGestures,
      setEditorZoomGestures
    };
  }, [editorZoomGestures, setEditorZoomGestures]);
  return /* @__PURE__ */ jsx268(EditorZoomGesturesContext.Provider, {
    value: editorZoomGesturesCtx,
    children
  });
};

// src/components/EditorContexts.tsx
import { jsx as jsx269 } from "react/jsx-runtime";
var EditorContexts = ({ children, readOnlyStudio }) => {
  return /* @__PURE__ */ jsx269(ZodProvider, {
    children: /* @__PURE__ */ jsx269(VisualControlsProvider, {
      children: /* @__PURE__ */ jsx269(PreviewServerConnection, {
        readOnlyStudio,
        children: /* @__PURE__ */ jsx269(RenderQueueContextProvider, {
          children: /* @__PURE__ */ jsx269(KeybindingContextProvider, {
            children: /* @__PURE__ */ jsx269(CheckerboardProvider, {
              children: /* @__PURE__ */ jsx269(ZoomGesturesProvider, {
                children: /* @__PURE__ */ jsx269(ShowRulersProvider, {
                  children: /* @__PURE__ */ jsx269(ShowGuidesProvider, {
                    children: /* @__PURE__ */ jsx269(PreviewSizeProvider, {
                      children: /* @__PURE__ */ jsx269(ModalsProvider, {
                        children: /* @__PURE__ */ jsx269(MediaVolumeProvider, {
                          children: /* @__PURE__ */ jsx269(PlayerInternals20.PlayerEmitterProvider, {
                            currentPlaybackRate: null,
                            children: /* @__PURE__ */ jsx269(SidebarContextProvider, {
                              children: /* @__PURE__ */ jsx269(FolderContextProvider, {
                                children: /* @__PURE__ */ jsx269(HighestZIndexProvider, {
                                  children: /* @__PURE__ */ jsx269(SetTimelineInOutProvider, {
                                    children
                                  })
                                })
                              })
                            })
                          })
                        })
                      })
                    })
                  })
                })
              })
            })
          })
        })
      })
    })
  });
};

// src/components/Notifications/ServerDisconnected.tsx
import { useContext as useContext83 } from "react";
import { jsx as jsx270, jsxs as jsxs138 } from "react/jsx-runtime";
var container62 = {
  position: "fixed",
  justifyContent: "flex-end",
  alignItems: "flex-start",
  display: "flex",
  width: "100%",
  height: "100%",
  flexDirection: "column",
  padding: 30,
  pointerEvents: "none",
  backgroundColor: "transparent",
  fontFamily: "SF Pro, Arial, Helvetica, sans-serif"
};
var message = {
  backgroundColor: "#e74c3c",
  color: "white",
  paddingLeft: 20,
  paddingRight: 20,
  paddingTop: 12,
  paddingBottom: 12,
  borderRadius: 4,
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.4)",
  lineHeight: 1.5
};
var inlineCode = {
  fontSize: 16,
  fontFamily: "monospace"
};
var pageIsGoingToReload = false;
window.addEventListener("beforeunload", () => {
  pageIsGoingToReload = true;
});
var ServerDisconnected = () => {
  const { previewServerState: ctx } = useContext83(StudioServerConnectionCtx);
  const fav = document.getElementById("__remotion_favicon");
  if (ctx.type !== "disconnected") {
    fav.setAttribute("href", "/favicon.ico");
    return null;
  }
  if (pageIsGoingToReload) {
    return null;
  }
  const base64Favicon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAARiSURBVHgB7d1NThRBFAfw/2tGgru5gXMD8QZ4AmVjAi6kN0TiAm8gnkBcGARNumcx4E48Ae0JaE9gewLHlQSZelaNgyHGL/RVd1X3+y10RQL58+rVx1QBKKWUUkoppZRSSimllFJKKVUjQs32stEiJcktZiwxzKL9Fvqzb6S0/44JVBKbtwa9aj29U6JjagtkJzsYzBEyBi9d5utsQIULCcxvelgo03R5jBarJZCXw/17E+bt82r4Hy4gtuEQekUbK8h7IHvDV5vMZht+VAlRfmYw3EhXKrSA10Ce2X7RIzpGDVzlgM1wPb2bI2JeA9nN99/b/waoV+XCmTAex1g13gLZyUZrdjjJ0CAbTB5bMN4C2ctHxwxaRABiCsZLIG6KmxC/R2BiCCaBBwn4NgJk10B2GOWj3Wz/IQLlpUL28oOjyy4AG1AZppuhVYt4hWRZ1o8gDGc6rL4YHjxCQMQDOcNCEI38bxnmLTc9d30PARAPZAITZP/4A1ctx3bjcw0NEw8koeQ64tRnu25qeggTb+q2/BmRcyv9K7yw3MTOsmiFuLMOtICblJzS5+Mm+opoIBOgFYHMuL5yVHcoooFQuwJxag9FNJCIG/rv1BqKaCDfzshbqbZQxAJxK3SJI9qATUPJstdef0axQGJbof+jwRc6eQ2PxAIx4DZXx3duSrybv3oCTyR7yACdYR762sIXDKQbFfId4ZGPJi8YCA3QLf05YvF+IhYIEV1Dx9hNu8XdbLQFQV6OcDuFaFNyKiwWiJ19DNBN/VN8XoMQrRABDFqCEJ32CiBisT08rRAZAwjRQAKjgcgQO+rVQARMb3gJ0UAkML+DEA1EwAQkdkNMcnOx1Zcxf8V9ol7y88GSm4tdDKRy1xsgSIes/0BM4ndN5HZ7OzZkMePperqSQ5jkkFWhO6r76WrYJ4b2N+YTumF60QeeSG6/d2DI4rHvW1eCPaT9Q9YZw/sVOMlZVoUWM8zpg/Su97dVJGdZFVrKhbFR05MdYoFcwWmF1rF9kbG8UeP7KaI3qBp628QTHrueUccwdZHw/ZDWNHY7tU1u1B2GIxqIYSO2Dd0Ud79wnq/eaOpBgR4EMVDW/oijINu87d7U6hYaJBrInA0k0iu4bvVtZ1KrBRrm4Vr06GNkF3cO7RCVhvK4pmiFOISkjOStk1lVrBQIiPh5SAyN3fWKWeMuEBjxCmEkh3bVvokAzd5idL2iQqDEA1nASXmK+XFIfeTCo5gFAudllvo8G20TUeNVElMQ58QrxLHD1jbB3GumSnhsz7qHE9BhTEGc87aOm16KJHi7rfqj8yfI53E1j/l9eK8L651stJUQeXx/iuzU1QztZLGIsRp+xvtOh3Qo3/qCedumEC6qZetpJztwz7O6UAa4FNsP7ELTfXbWbskUdjgq9M9VCJoFcwvTlfyPDd9t3XNJjA+2IZcGpmxi+7tpjW3OupurJziZhtKWPzWhlFJKKaWUUkoppZRSSiml/uwrgZ/Bfwo/wccAAAAASUVORK5CYII=";
  fav.setAttribute("href", base64Favicon);
  return /* @__PURE__ */ jsx270("div", {
    style: container62,
    className: "css-reset",
    children: /* @__PURE__ */ jsxs138("div", {
      style: message,
      children: [
        "The studio server has disconnected. ",
        /* @__PURE__ */ jsx270("br", {}),
        window.remotion_studioServerCommand ? /* @__PURE__ */ jsxs138("span", {
          children: [
            "Run",
            " ",
            /* @__PURE__ */ jsx270("code", {
              style: inlineCode,
              children: window.remotion_studioServerCommand
            }),
            " ",
            "to run it again."
          ]
        }) : /* @__PURE__ */ jsx270("span", {
          children: "Fast refresh will not work."
        })
      ]
    })
  });
};

// src/helpers/inject-css.ts
import { Internals as Internals65 } from "remotion";
var makeDefaultGlobalCSS = () => {
  const unhoveredDragAreaFactor = 2;
  const fromMiddle = 50 / unhoveredDragAreaFactor;
  const hoveredDragAreaFactor = 6;
  const fromMiddleHovered = 50 / hoveredDragAreaFactor;
  return `
  html {
    --remotion-cli-internals-blue: #0b84f3;
  }
  
  body {
    overscroll-behavior-y: none;
    overscroll-behavior-x: none;
    /* Override Chakra UI position: relative on body */
    position: static !important;
  }
  
  .remotion-splitter {
    user-select: none;
  }
  
  .remotion-splitter-horizontal {
    transform: scaleY(${unhoveredDragAreaFactor});
    background: linear-gradient(
      to bottom,
      transparent ${50 - fromMiddle}%,
      black ${50 - fromMiddle}%,
      black ${50 + fromMiddle}%,
      transparent ${50 + fromMiddle}%
    );
  }
  
  .remotion-splitter-horizontal.remotion-splitter-active, .remotion-splitter-horizontal.remotion-splitter-hover {
    background: linear-gradient(
      to bottom,
      transparent ${50 - fromMiddleHovered}%,
      var(--remotion-cli-internals-blue) ${50 - fromMiddleHovered}%,
      var(--remotion-cli-internals-blue) ${50 + fromMiddleHovered}%,
      transparent ${50 + fromMiddleHovered}%
    );
    cursor: row-resize;
    transform: scaleY(${hoveredDragAreaFactor});
    z-index: 1000;
  }
  
  .remotion-splitter-vertical {
    transform: scaleX(${unhoveredDragAreaFactor});
    background: linear-gradient(
      to right,
      transparent ${50 - fromMiddle}%,
      black ${50 - fromMiddle}%,
      black ${50 + fromMiddle}%,
      transparent ${50 + fromMiddle}%
    );
  }
  
  .remotion-splitter-vertical.remotion-splitter-active, .remotion-splitter-vertical.remotion-splitter-hover {
    background: linear-gradient(
      to right,
      transparent ${50 - fromMiddleHovered}%,
      var(--remotion-cli-internals-blue) ${50 - fromMiddleHovered}%,
      var(--remotion-cli-internals-blue) ${50 + fromMiddleHovered}%,
      transparent ${50 + fromMiddleHovered}%
    );
    transform: scaleX(${hoveredDragAreaFactor});
    cursor: col-resize;
    z-index: 1000;
  }
  
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  
  input:focus,
  textarea:focus,
  button:focus,
  a:focus {
    outline: none;
    box-shadow:
      inset 1px 1px #555,
      inset -1px -1px #555,
      inset 1px -1px #555,
      inset -1px 1px #555;
    border-radius: 0 !important;
  }
  
  input[type='color'].__remotion_color_picker::-webkit-color-swatch-wrapper {
    padding: 0;
  }
  input[type='color'].__remotion_color_picker::-webkit-color-swatch {
    border: none;
  }
  
  .__remotion_thumb,
  .__remotion_thumb::-webkit-slider-thumb {
    -webkit-appearance: none;
    -webkit-tap-highlight-color: transparent;
  }
  
  .__remotion_thumb {
    pointer-events: none;
    position: absolute;
    height: 0;
    outline: none;
    top: 15.5px;
    width: 221px;
    margin-left: -2px;
    z-index: 2;
  }
  
  /* For Firefox browsers */
  .__remotion_thumb::-moz-range-thumb {
    border: 1px solid black;
    border-radius: 2px;
    cursor: pointer;
    height: 37px;
    width: 10px;
    pointer-events: all;
    border-color: black;
    background-color: white;
    position: relative;
  }
  
  /* For Chrome browsers */
  .__remotion_thumb::-webkit-slider-thumb {
    border: 1px solid black;
    border-radius: 2px;
    cursor: pointer;
    height: 39px;
    width: 10px;
    pointer-events: all;
    border-color: black;
    background-color: white;
    position: relative;
  }  

  .${DEFAULT_PROPS_PATH_ACTIVE_CLASSNAME} span {
    color: var(--remotion-cli-internals-blue) !important;
    transition: color 0.2s ease-in-out;
  }
  `.trim();
};
var injected = false;
var injectCSS = () => {
  if (injected) {
    return;
  }
  Internals65.CSSUtils.injectCSS(makeDefaultGlobalCSS());
  injected = true;
};

// src/Studio.tsx
import { jsx as jsx271, jsxs as jsxs139 } from "react/jsx-runtime";
var getServerDisconnectedDomElement = () => {
  return document.getElementById("server-disconnected-overlay");
};
var Studio = ({ rootComponent, readOnly }) => {
  useLayoutEffect2(() => {
    window.remotion_isStudio = true;
    window.remotion_isReadOnlyStudio = readOnly;
    Internals66.enableSequenceStackTraces();
    return () => {
      window.remotion_isStudio = false;
      window.remotion_isReadOnlyStudio = false;
    };
  }, [readOnly]);
  useLayoutEffect2(() => {
    injectCSS();
  }, []);
  return /* @__PURE__ */ jsx271(Internals66.RemotionRoot, {
    logLevel: window.remotion_logLevel,
    numberOfAudioTags: window.remotion_numberOfAudioTags,
    onlyRenderComposition: null,
    currentCompositionMetadata: null,
    audioLatencyHint: window.remotion_audioLatencyHint ?? "interactive",
    children: /* @__PURE__ */ jsxs139(EditorContexts, {
      readOnlyStudio: readOnly,
      children: [
        /* @__PURE__ */ jsx271(Editor, {
          readOnlyStudio: readOnly,
          Root: rootComponent
        }),
        readOnly ? null : createPortal(/* @__PURE__ */ jsx271(ServerDisconnected, {}), getServerDisconnectedDomElement())
      ]
    })
  });
};

// src/internals.ts
var StudioInternals = {
  Studio
};
export {
  StudioInternals
};
